/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(382);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(137);
	
	var _reactRouter = __webpack_require__(96);
	
	var _routes = __webpack_require__(381);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactDom.render)(_react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: _routes2.default }), document.getElementById("app"));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(35);
	var hide = __webpack_require__(23);
	var redefine = __webpack_require__(24);
	var ctx = __webpack_require__(36);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(836);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 5 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(45);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(121)('wks');
	var uid = __webpack_require__(73);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 10 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Leaflet 1.0.3, a JS library for interactive maps. http://leafletjs.com
	 (c) 2010-2016 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	*/
	(function (window, document, undefined) {
	var L = {
		version: "1.0.3"
	};
	
	function expose() {
		var oldL = window.L;
	
		L.noConflict = function () {
			window.L = oldL;
			return this;
		};
	
		window.L = L;
	}
	
	// define Leaflet for Node module pattern loaders, including Browserify
	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = L;
	
	// define Leaflet as an AMD module
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (L), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// define Leaflet as a global L variable, saving the original L to restore later if needed
	if (typeof window !== 'undefined') {
		expose();
	}
	
	
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	L.Util = {
	
		// @function extend(dest: Object, src?: Object): Object
		// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
		extend: function (dest) {
			var i, j, len, src;
	
			for (j = 1, len = arguments.length; j < len; j++) {
				src = arguments[j];
				for (i in src) {
					dest[i] = src[i];
				}
			}
			return dest;
		},
	
		// @function create(proto: Object, properties?: Object): Object
		// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
		create: Object.create || (function () {
			function F() {}
			return function (proto) {
				F.prototype = proto;
				return new F();
			};
		})(),
	
		// @function bind(fn: Function, …): Function
		// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
		// Has a `L.bind()` shortcut.
		bind: function (fn, obj) {
			var slice = Array.prototype.slice;
	
			if (fn.bind) {
				return fn.bind.apply(fn, slice.call(arguments, 1));
			}
	
			var args = slice.call(arguments, 2);
	
			return function () {
				return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
			};
		},
	
		// @function stamp(obj: Object): Number
		// Returns the unique ID of an object, assiging it one if it doesn't have it.
		stamp: function (obj) {
			/*eslint-disable */
			obj._leaflet_id = obj._leaflet_id || ++L.Util.lastId;
			return obj._leaflet_id;
			/*eslint-enable */
		},
	
		// @property lastId: Number
		// Last unique ID used by [`stamp()`](#util-stamp)
		lastId: 0,
	
		// @function throttle(fn: Function, time: Number, context: Object): Function
		// Returns a function which executes function `fn` with the given scope `context`
		// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
		// `fn` will be called no more than one time per given amount of `time`. The arguments
		// received by the bound function will be any arguments passed when binding the
		// function, followed by any arguments passed when invoking the bound function.
		// Has an `L.bind` shortcut.
		throttle: function (fn, time, context) {
			var lock, args, wrapperFn, later;
	
			later = function () {
				// reset lock and call if queued
				lock = false;
				if (args) {
					wrapperFn.apply(context, args);
					args = false;
				}
			};
	
			wrapperFn = function () {
				if (lock) {
					// called too soon, queue to call later
					args = arguments;
	
				} else {
					// call and lock until later
					fn.apply(context, arguments);
					setTimeout(later, time);
					lock = true;
				}
			};
	
			return wrapperFn;
		},
	
		// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
		// Returns the number `num` modulo `range` in such a way so it lies within
		// `range[0]` and `range[1]`. The returned value will be always smaller than
		// `range[1]` unless `includeMax` is set to `true`.
		wrapNum: function (x, range, includeMax) {
			var max = range[1],
			    min = range[0],
			    d = max - min;
			return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
		},
	
		// @function falseFn(): Function
		// Returns a function which always returns `false`.
		falseFn: function () { return false; },
	
		// @function formatNum(num: Number, digits?: Number): Number
		// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
		formatNum: function (num, digits) {
			var pow = Math.pow(10, digits || 5);
			return Math.round(num * pow) / pow;
		},
	
		// @function trim(str: String): String
		// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
		trim: function (str) {
			return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
		},
	
		// @function splitWords(str: String): String[]
		// Trims and splits the string on whitespace and returns the array of parts.
		splitWords: function (str) {
			return L.Util.trim(str).split(/\s+/);
		},
	
		// @function setOptions(obj: Object, options: Object): Object
		// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
		setOptions: function (obj, options) {
			if (!obj.hasOwnProperty('options')) {
				obj.options = obj.options ? L.Util.create(obj.options) : {};
			}
			for (var i in options) {
				obj.options[i] = options[i];
			}
			return obj.options;
		},
	
		// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
		// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
		// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
		// be appended at the end. If `uppercase` is `true`, the parameter names will
		// be uppercased (e.g. `'?A=foo&B=bar'`)
		getParamString: function (obj, existingUrl, uppercase) {
			var params = [];
			for (var i in obj) {
				params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
			}
			return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
		},
	
		// @function template(str: String, data: Object): String
		// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
		// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
		// `('Hello foo, bar')`. You can also specify functions instead of strings for
		// data values — they will be evaluated passing `data` as an argument.
		template: function (str, data) {
			return str.replace(L.Util.templateRe, function (str, key) {
				var value = data[key];
	
				if (value === undefined) {
					throw new Error('No value provided for variable ' + str);
	
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},
	
		templateRe: /\{ *([\w_\-]+) *\}/g,
	
		// @function isArray(obj): Boolean
		// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
		isArray: Array.isArray || function (obj) {
			return (Object.prototype.toString.call(obj) === '[object Array]');
		},
	
		// @function indexOf(array: Array, el: Object): Number
		// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
		indexOf: function (array, el) {
			for (var i = 0; i < array.length; i++) {
				if (array[i] === el) { return i; }
			}
			return -1;
		},
	
		// @property emptyImageUrl: String
		// Data URI string containing a base64-encoded empty GIF image.
		// Used as a hack to free memory from unused images on WebKit-powered
		// mobile devices (by setting image `src` to this string).
		emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	};
	
	(function () {
		// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
		function getPrefixed(name) {
			return window['webkit' + name] || window['moz' + name] || window['ms' + name];
		}
	
		var lastTime = 0;
	
		// fallback for IE 7-8
		function timeoutDefer(fn) {
			var time = +new Date(),
			    timeToCall = Math.max(0, 16 - (time - lastTime));
	
			lastTime = time + timeToCall;
			return window.setTimeout(fn, timeToCall);
		}
	
		var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
		    cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
		               getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	
		// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
		// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
		// `context` if given. When `immediate` is set, `fn` is called immediately if
		// the browser doesn't have native support for
		// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
		// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
		L.Util.requestAnimFrame = function (fn, context, immediate) {
			if (immediate && requestFn === timeoutDefer) {
				fn.call(context);
			} else {
				return requestFn.call(window, L.bind(fn, context));
			}
		};
	
		// @function cancelAnimFrame(id: Number): undefined
		// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
		L.Util.cancelAnimFrame = function (id) {
			if (id) {
				cancelFn.call(window, id);
			}
		};
	})();
	
	// shortcuts for most used utility functions
	L.extend = L.Util.extend;
	L.bind = L.Util.bind;
	L.stamp = L.Util.stamp;
	L.setOptions = L.Util.setOptions;
	
	
	
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	L.Class = function () {};
	
	L.Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = L.Util.create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			L.extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			L.Util.extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = L.Util.extend(L.Util.create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		L.extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	L.Class.include = function (props) {
		L.extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	L.Class.mergeOptions = function (options) {
		L.extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	
	L.Evented = L.Class.extend({
	
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = L.Util.falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = L.Util.falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = L.Util.extend({}, data, {type: type, target: this});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = L.bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[L.stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[L.stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, L.extend({layer: e.target}, e), true);
			}
		}
	});
	
	var proto = L.Evented.prototype;
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	proto.addEventListener = proto.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	proto.removeEventListener = proto.clearAllEventListeners = proto.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	proto.addOneTimeEventListener = proto.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	proto.fireEvent = proto.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	proto.hasEventListeners = proto.listens;
	
	L.Mixin = {Events: proto};
	
	
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	(function () {
	
		var ua = navigator.userAgent.toLowerCase(),
		    doc = document.documentElement,
	
		    ie = 'ActiveXObject' in window,
	
		    webkit    = ua.indexOf('webkit') !== -1,
		    phantomjs = ua.indexOf('phantom') !== -1,
		    android23 = ua.search('android [23]') !== -1,
		    chrome    = ua.indexOf('chrome') !== -1,
		    gecko     = ua.indexOf('gecko') !== -1  && !webkit && !window.opera && !ie,
	
		    win = navigator.platform.indexOf('Win') === 0,
	
		    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
		    msPointer = !window.PointerEvent && window.MSPointerEvent,
		    pointer = window.PointerEvent || msPointer,
	
		    ie3d = ie && ('transition' in doc.style),
		    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
		    gecko3d = 'MozPerspective' in doc.style,
		    opera12 = 'OTransition' in doc.style;
	
	
		var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
				(window.DocumentTouch && document instanceof window.DocumentTouch));
	
		L.Browser = {
	
			// @property ie: Boolean
			// `true` for all Internet Explorer versions (not Edge).
			ie: ie,
	
			// @property ielt9: Boolean
			// `true` for Internet Explorer versions less than 9.
			ielt9: ie && !document.addEventListener,
	
			// @property edge: Boolean
			// `true` for the Edge web browser.
			edge: 'msLaunchUri' in navigator && !('documentMode' in document),
	
			// @property webkit: Boolean
			// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
			webkit: webkit,
	
			// @property gecko: Boolean
			// `true` for gecko-based browsers like Firefox.
			gecko: gecko,
	
			// @property android: Boolean
			// `true` for any browser running on an Android platform.
			android: ua.indexOf('android') !== -1,
	
			// @property android23: Boolean
			// `true` for browsers running on Android 2 or Android 3.
			android23: android23,
	
			// @property chrome: Boolean
			// `true` for the Chrome browser.
			chrome: chrome,
	
			// @property safari: Boolean
			// `true` for the Safari browser.
			safari: !chrome && ua.indexOf('safari') !== -1,
	
	
			// @property win: Boolean
			// `true` when the browser is running in a Windows platform
			win: win,
	
	
			// @property ie3d: Boolean
			// `true` for all Internet Explorer versions supporting CSS transforms.
			ie3d: ie3d,
	
			// @property webkit3d: Boolean
			// `true` for webkit-based browsers supporting CSS transforms.
			webkit3d: webkit3d,
	
			// @property gecko3d: Boolean
			// `true` for gecko-based browsers supporting CSS transforms.
			gecko3d: gecko3d,
	
			// @property opera12: Boolean
			// `true` for the Opera browser supporting CSS transforms (version 12 or later).
			opera12: opera12,
	
			// @property any3d: Boolean
			// `true` for all browsers supporting CSS transforms.
			any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,
	
	
			// @property mobile: Boolean
			// `true` for all browsers running in a mobile device.
			mobile: mobile,
	
			// @property mobileWebkit: Boolean
			// `true` for all webkit-based browsers in a mobile device.
			mobileWebkit: mobile && webkit,
	
			// @property mobileWebkit3d: Boolean
			// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
			mobileWebkit3d: mobile && webkit3d,
	
			// @property mobileOpera: Boolean
			// `true` for the Opera browser in a mobile device.
			mobileOpera: mobile && window.opera,
	
			// @property mobileGecko: Boolean
			// `true` for gecko-based browsers running in a mobile device.
			mobileGecko: mobile && gecko,
	
	
			// @property touch: Boolean
			// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
			// This does not necessarily mean that the browser is running in a computer with
			// a touchscreen, it only means that the browser is capable of understanding
			// touch events.
			touch: !!touch,
	
			// @property msPointer: Boolean
			// `true` for browsers implementing the Microsoft touch events model (notably IE10).
			msPointer: !!msPointer,
	
			// @property pointer: Boolean
			// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
			pointer: !!pointer,
	
	
			// @property retina: Boolean
			// `true` for browsers on a high-resolution "retina" screen.
			retina: (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1
		};
	
	}());
	
	
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 */
	
	L.Point = function (x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	};
	
	L.Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new L.Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(L.point(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(L.point(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new L.Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new L.Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = L.point(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = L.point(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = L.point(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        L.Util.formatNum(this.x) + ', ' +
			        L.Util.formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	L.point = function (x, y, round) {
		if (x instanceof L.Point) {
			return x;
		}
		if (L.Util.isArray(x)) {
			return new L.Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new L.Point(x.x, x.y);
		}
		return new L.Point(x, y, round);
	};
	
	
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 */
	
	L.Bounds = function (a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	};
	
	L.Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = L.point(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new L.Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new L.Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new L.Point(this.max.x, this.min.y);
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof L.Point) {
				obj = L.point(obj);
			} else {
				obj = L.bounds(obj);
			}
	
			if (obj instanceof L.Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(topLeft: Point, bottomRight: Point)
	// Creates a Bounds object from two coordinates (usually top-left and bottom-right corners).
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the points it contains
	L.bounds = function (a, b) {
		if (!a || a instanceof L.Bounds) {
			return a;
		}
		return new L.Bounds(a, b);
	};
	
	
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = new L.Transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	L.Transformation = function (a, b, c, d) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	};
	
	L.Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new L.Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	L.DomUtil = {
	
		// @function get(id: String|HTMLElement): HTMLElement
		// Returns an element given its DOM id, or returns the element itself
		// if it was passed directly.
		get: function (id) {
			return typeof id === 'string' ? document.getElementById(id) : id;
		},
	
		// @function getStyle(el: HTMLElement, styleAttrib: String): String
		// Returns the value for a certain style attribute on an element,
		// including computed values or values set through CSS.
		getStyle: function (el, style) {
	
			var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
			if ((!value || value === 'auto') && document.defaultView) {
				var css = document.defaultView.getComputedStyle(el, null);
				value = css ? css[style] : null;
			}
	
			return value === 'auto' ? null : value;
		},
	
		// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
		// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
		create: function (tagName, className, container) {
	
			var el = document.createElement(tagName);
			el.className = className || '';
	
			if (container) {
				container.appendChild(el);
			}
	
			return el;
		},
	
		// @function remove(el: HTMLElement)
		// Removes `el` from its parent element
		remove: function (el) {
			var parent = el.parentNode;
			if (parent) {
				parent.removeChild(el);
			}
		},
	
		// @function empty(el: HTMLElement)
		// Removes all of `el`'s children elements from `el`
		empty: function (el) {
			while (el.firstChild) {
				el.removeChild(el.firstChild);
			}
		},
	
		// @function toFront(el: HTMLElement)
		// Makes `el` the last children of its parent, so it renders in front of the other children.
		toFront: function (el) {
			el.parentNode.appendChild(el);
		},
	
		// @function toBack(el: HTMLElement)
		// Makes `el` the first children of its parent, so it renders back from the other children.
		toBack: function (el) {
			var parent = el.parentNode;
			parent.insertBefore(el, parent.firstChild);
		},
	
		// @function hasClass(el: HTMLElement, name: String): Boolean
		// Returns `true` if the element's class attribute contains `name`.
		hasClass: function (el, name) {
			if (el.classList !== undefined) {
				return el.classList.contains(name);
			}
			var className = L.DomUtil.getClass(el);
			return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
		},
	
		// @function addClass(el: HTMLElement, name: String)
		// Adds `name` to the element's class attribute.
		addClass: function (el, name) {
			if (el.classList !== undefined) {
				var classes = L.Util.splitWords(name);
				for (var i = 0, len = classes.length; i < len; i++) {
					el.classList.add(classes[i]);
				}
			} else if (!L.DomUtil.hasClass(el, name)) {
				var className = L.DomUtil.getClass(el);
				L.DomUtil.setClass(el, (className ? className + ' ' : '') + name);
			}
		},
	
		// @function removeClass(el: HTMLElement, name: String)
		// Removes `name` from the element's class attribute.
		removeClass: function (el, name) {
			if (el.classList !== undefined) {
				el.classList.remove(name);
			} else {
				L.DomUtil.setClass(el, L.Util.trim((' ' + L.DomUtil.getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
			}
		},
	
		// @function setClass(el: HTMLElement, name: String)
		// Sets the element's class.
		setClass: function (el, name) {
			if (el.className.baseVal === undefined) {
				el.className = name;
			} else {
				// in case of SVG element
				el.className.baseVal = name;
			}
		},
	
		// @function getClass(el: HTMLElement): String
		// Returns the element's class.
		getClass: function (el) {
			return el.className.baseVal === undefined ? el.className : el.className.baseVal;
		},
	
		// @function setOpacity(el: HTMLElement, opacity: Number)
		// Set the opacity of an element (including old IE support).
		// `opacity` must be a number from `0` to `1`.
		setOpacity: function (el, value) {
	
			if ('opacity' in el.style) {
				el.style.opacity = value;
	
			} else if ('filter' in el.style) {
				L.DomUtil._setOpacityIE(el, value);
			}
		},
	
		_setOpacityIE: function (el, value) {
			var filter = false,
			    filterName = 'DXImageTransform.Microsoft.Alpha';
	
			// filters collection throws an error if we try to retrieve a filter that doesn't exist
			try {
				filter = el.filters.item(filterName);
			} catch (e) {
				// don't set opacity to 1 if we haven't already set an opacity,
				// it isn't needed and breaks transparent pngs.
				if (value === 1) { return; }
			}
	
			value = Math.round(value * 100);
	
			if (filter) {
				filter.Enabled = (value !== 100);
				filter.Opacity = value;
			} else {
				el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
			}
		},
	
		// @function testProp(props: String[]): String|false
		// Goes through the array of style names and returns the first name
		// that is a valid style name for an element. If no such name is found,
		// it returns false. Useful for vendor-prefixed styles like `transform`.
		testProp: function (props) {
	
			var style = document.documentElement.style;
	
			for (var i = 0; i < props.length; i++) {
				if (props[i] in style) {
					return props[i];
				}
			}
			return false;
		},
	
		// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
		// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
		// and optionally scaled by `scale`. Does not have an effect if the
		// browser doesn't support 3D CSS transforms.
		setTransform: function (el, offset, scale) {
			var pos = offset || new L.Point(0, 0);
	
			el.style[L.DomUtil.TRANSFORM] =
				(L.Browser.ie3d ?
					'translate(' + pos.x + 'px,' + pos.y + 'px)' :
					'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
				(scale ? ' scale(' + scale + ')' : '');
		},
	
		// @function setPosition(el: HTMLElement, position: Point)
		// Sets the position of `el` to coordinates specified by `position`,
		// using CSS translate or top/left positioning depending on the browser
		// (used by Leaflet internally to position its layers).
		setPosition: function (el, point) { // (HTMLElement, Point[, Boolean])
	
			/*eslint-disable */
			el._leaflet_pos = point;
			/*eslint-enable */
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(el, point);
			} else {
				el.style.left = point.x + 'px';
				el.style.top = point.y + 'px';
			}
		},
	
		// @function getPosition(el: HTMLElement): Point
		// Returns the coordinates of an element previously positioned with setPosition.
		getPosition: function (el) {
			// this method is only used for elements previously positioned using setPosition,
			// so it's safe to cache the position for performance
	
			return el._leaflet_pos || new L.Point(0, 0);
		}
	};
	
	
	(function () {
		// prefix style property names
	
		// @property TRANSFORM: String
		// Vendor-prefixed fransform style name (e.g. `'webkitTransform'` for WebKit).
		L.DomUtil.TRANSFORM = L.DomUtil.testProp(
				['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	
		// webkitTransition comes first because some browser versions that drop vendor prefix don't do
		// the same for the transitionend event, in particular the Android 4.1 stock browser
	
		// @property TRANSITION: String
		// Vendor-prefixed transform style name.
		var transition = L.DomUtil.TRANSITION = L.DomUtil.testProp(
				['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
		L.DomUtil.TRANSITION_END =
				transition === 'webkitTransition' || transition === 'OTransition' ? transition + 'End' : 'transitionend';
	
		// @function disableTextSelection()
		// Prevents the user from generating `selectstart` DOM events, usually generated
		// when the user drags the mouse through a page with text. Used internally
		// by Leaflet to override the behaviour of any click-and-drag interaction on
		// the map. Affects drag interactions on the whole document.
	
		// @function enableTextSelection()
		// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
		if ('onselectstart' in document) {
			L.DomUtil.disableTextSelection = function () {
				L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
			};
			L.DomUtil.enableTextSelection = function () {
				L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
			};
	
		} else {
			var userSelectProperty = L.DomUtil.testProp(
				['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
			L.DomUtil.disableTextSelection = function () {
				if (userSelectProperty) {
					var style = document.documentElement.style;
					this._userSelect = style[userSelectProperty];
					style[userSelectProperty] = 'none';
				}
			};
			L.DomUtil.enableTextSelection = function () {
				if (userSelectProperty) {
					document.documentElement.style[userSelectProperty] = this._userSelect;
					delete this._userSelect;
				}
			};
		}
	
		// @function disableImageDrag()
		// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
		// for `dragstart` DOM events, usually generated when the user drags an image.
		L.DomUtil.disableImageDrag = function () {
			L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function enableImageDrag()
		// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
		L.DomUtil.enableImageDrag = function () {
			L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function preventOutline(el: HTMLElement)
		// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
		// of the element `el` invisible. Used internally by Leaflet to prevent
		// focusable elements from displaying an outline when the user performs a
		// drag interaction on them.
		L.DomUtil.preventOutline = function (element) {
			while (element.tabIndex === -1) {
				element = element.parentNode;
			}
			if (!element || !element.style) { return; }
			L.DomUtil.restoreOutline();
			this._outlineElement = element;
			this._outlineStyle = element.style.outline;
			element.style.outline = 'none';
			L.DomEvent.on(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	
		// @function restoreOutline()
		// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
		L.DomUtil.restoreOutline = function () {
			if (!this._outlineElement) { return; }
			this._outlineElement.style.outline = this._outlineStyle;
			delete this._outlineElement;
			delete this._outlineStyle;
			L.DomEvent.off(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	})();
	
	
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 */
	
	L.LatLng = function (lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	};
	
	L.LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = L.latLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        L.Util.formatNum(this.lat, precision) + ', ' +
			        L.Util.formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
		distanceTo: function (other) {
			return L.CRS.Earth.distance(this, L.latLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return L.CRS.Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return L.latLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new L.LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	L.latLng = function (a, b, c) {
		if (a instanceof L.LatLng) {
			return a;
		}
		if (L.Util.isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new L.LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new L.LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new L.LatLng(a, b, c);
	};
	
	
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 */
	
	L.LatLngBounds = function (corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	};
	
	L.LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof L.LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(L.latLng(obj) || L.latLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new L.LatLng(sw2.lat, sw2.lng);
				this._northEast = new L.LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new L.LatLngBounds(
			        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new L.LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new L.LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new L.LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof L.LatLng || 'lat' in obj) {
				obj = L.latLng(obj);
			} else {
				obj = L.latLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds.
		equals: function (bounds) {
			if (!bounds) { return false; }
	
			bounds = L.latLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest()) &&
			       this._northEast.equals(bounds.getNorthEast());
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	L.latLngBounds = function (a, b) {
		if (a instanceof L.LatLngBounds) {
			return a;
		}
		return new L.LatLngBounds(a, b);
	};
	
	
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:3395` and `Simple` CRS.
	 */
	
	L.Projection = {};
	
	L.Projection.LonLat = {
		project: function (latlng) {
			return new L.Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new L.LatLng(point.y, point.x);
		},
	
		bounds: L.bounds([-180, -90], [180, 90])
	};
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	L.Projection.SphericalMercator = {
	
		R: 6378137,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new L.Point(
					this.R * latlng.lng * d,
					this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new L.LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = 6378137 * Math.PI;
			return L.bounds([-d, -d], [d, d]);
		})()
	};
	
	
	
	/*
	 * @class CRS
	 * @aka L.CRS
	 * Abstract class that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 */
	
	L.CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return L.bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		// Only accepts actual `L.LatLng` instances, not arrays.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? L.Util.wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? L.Util.wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return L.latLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = L.latLng({lat: sw.lat - latShift, lng: sw.lng - lngShift}),
			    newNe = L.latLng({lat: ne.lat - latShift, lng: ne.lng - lngShift});
	
			return new L.LatLngBounds(newSw, newNe);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	L.CRS.Simple = L.extend({}, L.CRS, {
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	L.CRS.Earth = L.extend({}, L.CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    a = Math.sin(lat1) * Math.sin(lat2) +
			        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);
	
			return this.R * Math.acos(Math.min(a, 1));
		}
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	L.CRS.EPSG3857 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3857',
		projection: L.Projection.SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.SphericalMercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
		code: 'EPSG:900913'
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	L.CRS.EPSG4326 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:4326',
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	L.Map = L.Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: L.CRS.EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = undefined
			// Minimum zoom level of the map. Overrides any `minZoom` option set on map layers.
			minZoom: undefined,
	
			// @option maxZoom: Number = undefined
			// Maximum zoom level of the map. Overrides any `maxZoom` option set on map layers.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = L.setOptions(this, options);
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = L.bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(L.latLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = L.DomUtil.TRANSITION && L.Browser.any3d && !L.Browser.mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				L.DomEvent.on(this._proxy, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = L.extend({animate: options.animate}, options.zoom);
					options.pan = L.extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);
	
			var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = L.point(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new L.PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !L.Browser.any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = L.latLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = L.Util.requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			this.options.minZoom = zoom;
	
			if (this._loaded && this.getZoom() < this.options.minZoom) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			this.options.maxZoom = zoom;
	
			if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, L.latLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method invalidateSize(options: Zoom/Pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = L.extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = L.extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = L.bind(this._handleGeolocationResponse, this),
			    onError = L.bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new L.LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO handler.addTo
		// TODO Appropiate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/*eslint-enable */
				this._containerId = undefined;
			}
	
			L.DomUtil.remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			for (var i in this._layers) {
				this._layers[i].remove();
			}
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a children of `container`, or
		// as a children of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = L.DomUtil.create('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new L.LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = L.latLngBounds(bounds);
			padding = L.point(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = L.bounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
	
			var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new L.Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(L.point(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = L.point(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(L.latLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(L.latLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(L.latLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(L.latLng(latlng1), L.latLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return L.point(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return L.point(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(L.point(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return L.DomEvent.getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = L.DomUtil.get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			L.DomEvent.addListener(container, 'scroll', this._onScroll, this);
			this._containerId = L.Util.stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && L.Browser.any3d;
	
			L.DomUtil.addClass(container, 'leaflet-container' +
				(L.Browser.touch ? ' leaflet-touch' : '') +
				(L.Browser.retina ? ' leaflet-retina' : '') +
				(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
				(L.Browser.safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = L.DomUtil.getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for tooltip.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				L.DomUtil.addClass(panes.markerPane, 'leaflet-zoom-hide');
				L.DomUtil.addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			return this.fire('movestart');
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			L.Util.cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove) {
			if (!L.DomEvent) { return; }
	
			this._targets = {};
			this._targets[L.stamp(this._container)] = this;
	
			var onOff = remove ? 'off' : 'on';
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused.
			L.DomEvent[onOff](this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				L.DomEvent[onOff](window, 'resize', this._onResize, this);
			}
	
			if (L.Browser.any3d && this.options.transform3DLimit) {
				this[onOff]('moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			L.Util.cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = L.Util.requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[L.stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !L.DomEvent._isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && L.DomEvent._isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || L.DomEvent._skipped(e)) { return; }
	
			var type = e.type === 'keypress' && e.keyCode === 13 ? 'click' : e.type;
	
			if (type === 'mousedown') {
				// prevents outline when clicking on keyboard-focusable element
				L.DomUtil.preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = L.Util.extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				L.DomEvent.preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress') {
				var isMarker = target instanceof L.Marker;
				data.containerPoint = isMarker ?
						this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return L.DomUtil.getPosition(this._mapPane) || new L.Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return L.bounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = L.bounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new L.Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = L.DomUtil.create('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = L.DomUtil.TRANSFORM,
				    transform = proxy.style[prop];
	
				L.DomUtil.setTransform(proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				L.DomUtil.setTransform(proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			L.Util.requestAnimFrame(function () {
				this
				    ._moveStart(true)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired on every frame of a zoom animation
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			L.Util.requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	L.map = function (id, options) {
		return new L.Map(id, options);
	};
	
	
	
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.Marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	L.Layer = L.Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
			nonBubblingEvents: [],  // Array of events that should not be bubbled to DOM parents (like the map),
	
			// @option attribution: String = null
			// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
			attribution: null
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map): this
		 * Adds the layer to the given map
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[L.stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[L.stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			var id = L.stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = L.stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (L.stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[L.stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = L.stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	
	
	var eventsKey = '_leaflet_events';
	
	L.DomEvent = {
	
		// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Adds a listener function (`fn`) to a particular DOM event type of the
		// element `el`. You can optionally specify the context of the listener
		// (object the `this` keyword will point to). You can also pass several
		// space-separated types (e.g. `'click dblclick'`).
	
		// @alternative
		// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
		// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		on: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._on(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Removes a previously added listener function. If no function is specified,
		// it will remove all the listeners of that particular DOM event from the element.
		// Note that if you passed a custom context to on, you must pass the same
		// context to `off` in order to remove the listener.
	
		// @alternative
		// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
		// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		off: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._off(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		_on: function (obj, type, fn, context) {
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : '');
	
			if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
			var handler = function (e) {
				return fn.call(context || obj, e || window.event);
			};
	
			var originalHandler = handler;
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.addPointerListener(obj, type, handler, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener &&
			           !(L.Browser.pointer && L.Browser.chrome)) {
				// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
				// See #5180
				this.addDoubleTapListener(obj, handler, id);
	
			} else if ('addEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
					handler = function (e) {
						e = e || window.event;
						if (L.DomEvent._isExternalTarget(obj, e)) {
							originalHandler(e);
						}
					};
					obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
				} else {
					if (type === 'click' && L.Browser.android) {
						handler = function (e) {
							return L.DomEvent._filterClick(e, originalHandler);
						};
					}
					obj.addEventListener(type, handler, false);
				}
	
			} else if ('attachEvent' in obj) {
				obj.attachEvent('on' + type, handler);
			}
	
			obj[eventsKey] = obj[eventsKey] || {};
			obj[eventsKey][id] = handler;
	
			return this;
		},
	
		_off: function (obj, type, fn, context) {
	
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : ''),
			    handler = obj[eventsKey] && obj[eventsKey][id];
	
			if (!handler) { return this; }
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.removePointerListener(obj, type, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
				this.removeDoubleTapListener(obj, id);
	
			} else if ('removeEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else {
					obj.removeEventListener(
						type === 'mouseenter' ? 'mouseover' :
						type === 'mouseleave' ? 'mouseout' : type, handler, false);
				}
	
			} else if ('detachEvent' in obj) {
				obj.detachEvent('on' + type, handler);
			}
	
			obj[eventsKey][id] = null;
	
			return this;
		},
	
		// @function stopPropagation(ev: DOMEvent): this
		// Stop the given event from propagation to parent elements. Used inside the listener functions:
		// ```js
		// L.DomEvent.on(div, 'click', function (ev) {
		// 	L.DomEvent.stopPropagation(ev);
		// });
		// ```
		stopPropagation: function (e) {
	
			if (e.stopPropagation) {
				e.stopPropagation();
			} else if (e.originalEvent) {  // In case of Leaflet event.
				e.originalEvent._stopped = true;
			} else {
				e.cancelBubble = true;
			}
			L.DomEvent._skipped(e);
	
			return this;
		},
	
		// @function disableScrollPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
		disableScrollPropagation: function (el) {
			return L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
		},
	
		// @function disableClickPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
		// `'mousedown'` and `'touchstart'` events (plus browser variants).
		disableClickPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			L.DomEvent.on(el, L.Draggable.START.join(' '), stop);
	
			return L.DomEvent.on(el, {
				click: L.DomEvent._fakeStop,
				dblclick: stop
			});
		},
	
		// @function preventDefault(ev: DOMEvent): this
		// Prevents the default action of the DOM Event `ev` from happening (such as
		// following a link in the href of the a element, or doing a POST request
		// with page reload when a `<form>` is submitted).
		// Use it inside listener functions.
		preventDefault: function (e) {
	
			if (e.preventDefault) {
				e.preventDefault();
			} else {
				e.returnValue = false;
			}
			return this;
		},
	
		// @function stop(ev): this
		// Does `stopPropagation` and `preventDefault` at the same time.
		stop: function (e) {
			return L.DomEvent
				.preventDefault(e)
				.stopPropagation(e);
		},
	
		// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
		// Gets normalized mouse position from a DOM event relative to the
		// `container` or to the whole page if not specified.
		getMousePosition: function (e, container) {
			if (!container) {
				return new L.Point(e.clientX, e.clientY);
			}
	
			var rect = container.getBoundingClientRect();
	
			return new L.Point(
				e.clientX - rect.left - container.clientLeft,
				e.clientY - rect.top - container.clientTop);
		},
	
		// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
		// and Firefox scrolls device pixels, not CSS pixels
		_wheelPxFactor: (L.Browser.win && L.Browser.chrome) ? 2 :
		                L.Browser.gecko ? window.devicePixelRatio :
		                1,
	
		// @function getWheelDelta(ev: DOMEvent): Number
		// Gets normalized wheel delta from a mousewheel DOM event, in vertical
		// pixels scrolled (negative if scrolling down).
		// Events from pointing devices without precise scrolling are mapped to
		// a best guess of 60 pixels.
		getWheelDelta: function (e) {
			return (L.Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
			       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / L.DomEvent._wheelPxFactor : // Pixels
			       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
			       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
			       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
			       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
			       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
			       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
			       0;
		},
	
		_skipEvents: {},
	
		_fakeStop: function (e) {
			// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
			L.DomEvent._skipEvents[e.type] = true;
		},
	
		_skipped: function (e) {
			var skipped = this._skipEvents[e.type];
			// reset when checking, as it's only used in map container and propagates outside of the map
			this._skipEvents[e.type] = false;
			return skipped;
		},
	
		// check if element really left/entered the event target (for mouseenter/mouseleave)
		_isExternalTarget: function (el, e) {
	
			var related = e.relatedTarget;
	
			if (!related) { return true; }
	
			try {
				while (related && (related !== el)) {
					related = related.parentNode;
				}
			} catch (err) {
				return false;
			}
			return (related !== el);
		},
	
		// this is a horrible workaround for a bug in Android where a single touch triggers two click events
		_filterClick: function (e, handler) {
			var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
			    elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);
	
			// are they closer together than 500ms yet more than 100ms?
			// Android typically triggers them ~300ms apart while multiple listeners
			// on the same event should be triggered far faster;
			// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
			if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
				L.DomEvent.stop(e);
				return;
			}
			L.DomEvent._lastClick = timeStamp;
	
			handler(e);
		}
	};
	
	// @function addListener(…): this
	// Alias to [`L.DomEvent.on`](#domevent-on)
	L.DomEvent.addListener = L.DomEvent.on;
	
	// @function removeListener(…): this
	// Alias to [`L.DomEvent.off`](#domevent-off)
	L.DomEvent.removeListener = L.DomEvent.off;
	
	
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	L.PosAnimation = L.Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = L.DomUtil.getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = L.Util.requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			L.DomUtil.setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			L.Util.cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
	 */
	
	L.Projection.Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: L.bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new L.Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new L.LatLng(phi * d, point.x * d / r);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	
	L.CRS.EPSG3395 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3395',
		projection: L.Projection.Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.Mercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	L.GridLayer = L.Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = depends
			// If `false`, new tiles are loaded during panning, otherwise only after it (for better performance). `true` by default on mobile browsers, otherwise `false`.
			updateWhenIdle: L.Browser.mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level that tiles will be loaded at. By default the entire map.
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level that tiles will be loaded at.
			maxZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			L.DomUtil.remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = null;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = L.Util.throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overriden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof L.Point ? s : new L.Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (L.Browser.ielt9) { return; }
	
			L.DomUtil.setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				L.DomUtil.setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) { willPrune = true; }
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = L.DomUtil.create('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
				} else {
					L.DomUtil.remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				L.Util.falseFn(level.el.offsetWidth);
			}
	
			this._level = level;
	
			return level;
		},
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				L.DomUtil.remove(this._levels[z].el);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = null;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new L.Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new L.Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = Math.round(zoom);
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(level.el, translate, scale);
			} else {
				L.DomUtil.setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new L.Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = map.getZoom();
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new L.Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return L.latLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
	
			var map = this._map,
			    tileSize = this.getTileSize(),
	
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
	
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z),
			    bounds = new L.LatLngBounds(nw, se);
	
			if (!this.options.noWrap) {
				map.wrapLatLngBounds(bounds);
			}
	
			return bounds;
		},
	
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new L.Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			L.DomUtil.remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			L.DomUtil.addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = L.Util.falseFn;
			tile.onmousemove = L.Util.falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (L.Browser.ielt9 && this.options.opacity < 1) {
				L.DomUtil.setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (L.Browser.android && !L.Browser.android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				L.Util.requestAnimFrame(L.bind(this._tileReady, this, coords, null, tile));
			}
	
			L.DomUtil.setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map) { return; }
	
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				L.DomUtil.setOpacity(tile.el, 0);
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				L.DomUtil.addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (L.Browser.ielt9 || !this._map._fadeAnimated) {
					L.Util.requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(L.bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new L.Point(
				this._wrapX ? L.Util.wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? L.Util.wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new L.Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	L.gridLayer = function (options) {
		return new L.GridLayer(options);
	};
	
	
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add @2x to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	L.TileLayer = L.GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// Minimum zoom number.
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// Maximum zoom number.
			maxZoom: 18,
	
			// @option maxNativeZoom: Number = null
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: null,
	
			// @option minNativeZoom: Number = null
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: null,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean = false
			// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = L.setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!L.Browser.android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile));
			L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin) {
				tile.crossOrigin = '';
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: L.Browser.retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return L.Util.template(this._url, L.extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (L.Browser.ielt9) {
				setTimeout(L.bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.src !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		getTileSize: function () {
			var map = this._map,
			tileSize = L.GridLayer.prototype.getTileSize.call(this),
			zoom = this._tileZoom + this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			// decrease tile size when scaling below minNativeZoom
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(minNativeZoom, zoom)).round();
			}
	
			// increase tile size when scaling above maxNativeZoom
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(maxNativeZoom, zoom)).round();
			}
	
			return tileSize;
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			zoom += zoomOffset;
	
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return minNativeZoom;
			}
	
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return maxNativeZoom;
			}
	
			return zoom;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = L.Util.falseFn;
					tile.onerror = L.Util.falseFn;
	
					if (!tile.complete) {
						tile.src = L.Util.emptyImageUrl;
						L.DomUtil.remove(tile);
					}
				}
			}
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	L.tileLayer = function (url, options) {
		return new L.TileLayer(url, options);
	};
	
	
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	L.TileLayer.WMS = L.TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = L.extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = L.setOptions(this, options);
	
			wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && L.Browser.retina ? 2 : 1);
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			L.TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToBounds(coords),
			    nw = this._crs.project(tileBounds.getNorthWest()),
			    se = this._crs.project(tileBounds.getSouthEast()),
	
			    bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
				    [se.y, nw.x, nw.y, se.x] :
				    [nw.x, se.y, se.x, nw.y]).join(','),
	
			    url = L.TileLayer.prototype.getTileUrl.call(this, coords);
	
			return url +
				L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			L.extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	L.tileLayer.wms = function (url, options) {
		return new L.TileLayer.WMS(url, options);
	};
	
	
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	L.ImageOverlay = L.Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean = false
			// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = L.latLngBounds(bounds);
	
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				L.DomUtil.addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = bounds;
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Get the img element that represents the ImageOverlay on the map
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var img = this._image = L.DomUtil.create('img',
					'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : ''));
	
			img.onselectstart = L.Util.falseFn;
			img.onmousemove = L.Util.falseFn;
	
			img.onload = L.bind(this.fire, this, 'load');
	
			if (this.options.crossOrigin) {
				img.crossOrigin = '';
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			L.DomUtil.setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new L.Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._image, this.options.opacity);
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	L.imageOverlay = function (url, bounds, options) {
		return new L.ImageOverlay(url, bounds, options);
	};
	
	
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 * @inherits Layer
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	L.Icon = L.Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = null
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = L.point(sizeOption),
			    anchor = L.point(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return L.Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	L.icon = function (options) {
		return new L.Icon(options);
	};
	
	
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	L.Icon.Default = L.Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!L.Icon.Default.imagePath) {	// Deprecated, backwards-compatibility only
				L.Icon.Default.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `L.Icon.Default` will try to auto-detect the absolute location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right absolute path.
			return (this.options.imagePath || L.Icon.Default.imagePath) + L.Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = L.DomUtil.create('div',  'leaflet-default-icon-path', document.body);
			var path = L.DomUtil.getStyle(el, 'background-image') ||
			           L.DomUtil.getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			return path.indexOf('url') === 0 ?
				path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '') : '';
		}
	});
	
	
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	L.Marker = L.Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon class to use for rendering the marker. See [Icon documentation](#L.Icon) for details on how to customize the marker icon. If not specified, a new `L.Icon.Default` is used.
			icon: new L.Icon.Default(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// FIXME: shadowPane is no longer a valid option
			nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = L.latLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			L.DomUtil.addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				L.DomUtil.addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane('shadowPane').appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			L.DomUtil.remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				L.DomUtil.remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			L.DomUtil.setPosition(this._icon, pos);
	
			if (this._shadow) {
				L.DomUtil.setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			L.DomUtil.addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (L.Handler.MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new L.Handler.MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			L.DomUtil.setOpacity(this._icon, opacity);
	
			if (this._shadow) {
				L.DomUtil.setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor || [0, 0];
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor || [0, 0];
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	L.marker = function (latlng, options) {
		return new L.Marker(latlng, options);
	};
	
	
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	L.DivIcon = L.Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String = ''
			// Custom HTML code to put inside the div element, empty by default.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			div.innerHTML = options.html !== false ? options.html : '';
	
			if (options.bgPos) {
				var bgPos = L.point(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	L.divIcon = function (options) {
		return new L.DivIcon(options);
	};
	
	
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	L.DivOverlay = L.Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			L.setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
			} else {
				L.DomUtil.remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
			}
			return this;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				L.DomUtil.setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	L.Popup = L.DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when user clicks the map (set globally by
			// the Map's [closePopupOnClick](#map-closepopuponclick) option).
			autoClose: true,
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof L.Path)) {
					this._source.on('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof L.Path)) {
					this._source.off('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = L.DomUtil.create('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
			}
	
			var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
			this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
	
			L.DomEvent
				.disableClickPropagation(wrapper)
				.disableScrollPropagation(this._contentNode)
				.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);
	
			this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
			this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				L.DomUtil.addClass(container, scrolledClass);
			} else {
				L.DomUtil.removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			L.DomUtil.setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }
	
			var map = this._map,
			    marginBottom = parseInt(L.DomUtil.getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(L.DomUtil.getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = L.point(this.options.autoPanPadding),
			    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			L.DomEvent.stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return L.point(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	L.popup = function (options, source) {
		return new L.Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	L.Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof L.Popup)) {
				popup = new L.Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	L.Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof L.Popup) {
				L.setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new L.Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._popup && this._map) {
				// set popup source to this layer
				this._popup._source = layer;
	
				// update the popup (content, layout, ect...)
				this._popup.update();
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			L.DomEvent.stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof L.Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		}
	});
	
	
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offseting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	L.Tooltip = L.DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if (L.Browser.touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = L.DomUtil.create('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(L.point(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(L.point(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(L.point(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(L.point(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(L.point(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			L.DomUtil.removeClass(container, 'leaflet-tooltip-right');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-left');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-top');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-bottom');
			L.DomUtil.addClass(container, 'leaflet-tooltip-' + direction);
			L.DomUtil.setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				L.DomUtil.setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return L.point(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	L.tooltip = function (options, source) {
		return new L.Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof L.Tooltip)) {
				tooltip = new L.Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	L.Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof L.Tooltip) {
				L.setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = L.tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove) {
			if (!remove && this._tooltipHandlersAdded) { return; }
			var onOff = remove ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (L.Browser.touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._tooltip && this._map) {
	
				// set tooltip source to this layer
				this._tooltip._source = layer;
	
				// update the tooltip (content, layout, ect...)
				this._tooltip.update();
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	L.LayerGroup = L.Layer.extend({
	
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			for (var i in this._layers) {
				this.removeLayer(this._layers[i]);
			}
			return this;
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			for (var i in this._layers) {
				map.addLayer(this._layers[i]);
			}
		},
	
		onRemove: function (map) {
			for (var i in this._layers) {
				map.removeLayer(this._layers[i]);
			}
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return L.stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers: Layer[])
	// Create a layer group, optionally given an initial set of layers.
	L.layerGroup = function (layers) {
		return new L.LayerGroup(layers);
	};
	
	
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	L.FeatureGroup = L.LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			L.LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			L.LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the top of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new L.LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	L.featureGroup = function (layers) {
		return new L.FeatureGroup(layers);
	};
	
	
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	L.Renderer = L.Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
			L.stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					L.DomUtil.addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._container);
			this.off('update', this._updatePaths, this);
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = L.DomUtil.getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(this._container, topLeftOffset, scale);
			} else {
				L.DomUtil.setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new L.Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	
	L.Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				// @namespace Map; @option preferCanvas: Boolean = false
				// Whether `Path`s should be rendered on a `Canvas` renderer.
				// By default, all `Path`s are rendered in a `SVG` renderer.
				renderer = this._renderer = (this.options.preferCanvas && L.canvas()) || L.svg();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = (L.SVG && L.svg({pane: name})) || (L.Canvas && L.canvas({pane: name}));
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		}
	});
	
	
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	L.Path = L.Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			L.setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in children classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + (L.Browser.touch ? 10 : 0);
		}
	});
	
	
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	L.LineUtil = {
	
		// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
		// Improves rendering performance dramatically by lessening the number of points to draw.
	
		// @function simplify(points: Point[], tolerance: Number): Point[]
		// Dramatically reduces the number of points in a polyline while retaining
		// its shape and returns a new array of simplified points, using the
		// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
		// Used for a huge performance boost when processing/displaying Leaflet polylines for
		// each zoom level and also reducing visual noise. tolerance affects the amount of
		// simplification (lesser value means higher quality but slower and with more points).
		// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
		simplify: function (points, tolerance) {
			if (!tolerance || !points.length) {
				return points.slice();
			}
	
			var sqTolerance = tolerance * tolerance;
	
			// stage 1: vertex reduction
			points = this._reducePoints(points, sqTolerance);
	
			// stage 2: Douglas-Peucker simplification
			points = this._simplifyDP(points, sqTolerance);
	
			return points;
		},
	
		// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
		// Returns the distance between point `p` and segment `p1` to `p2`.
		pointToSegmentDistance:  function (p, p1, p2) {
			return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
		},
	
		// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
		// Returns the closest point from a point `p` on a segment `p1` to `p2`.
		closestPointOnSegment: function (p, p1, p2) {
			return this._sqClosestPointOnSegment(p, p1, p2);
		},
	
		// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
		_simplifyDP: function (points, sqTolerance) {
	
			var len = points.length,
			    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
			    markers = new ArrayConstructor(len);
	
			markers[0] = markers[len - 1] = 1;
	
			this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
			var i,
			    newPoints = [];
	
			for (i = 0; i < len; i++) {
				if (markers[i]) {
					newPoints.push(points[i]);
				}
			}
	
			return newPoints;
		},
	
		_simplifyDPStep: function (points, markers, sqTolerance, first, last) {
	
			var maxSqDist = 0,
			    index, i, sqDist;
	
			for (i = first + 1; i <= last - 1; i++) {
				sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
				if (sqDist > maxSqDist) {
					index = i;
					maxSqDist = sqDist;
				}
			}
	
			if (maxSqDist > sqTolerance) {
				markers[index] = 1;
	
				this._simplifyDPStep(points, markers, sqTolerance, first, index);
				this._simplifyDPStep(points, markers, sqTolerance, index, last);
			}
		},
	
		// reduce points that are too close to each other to a single point
		_reducePoints: function (points, sqTolerance) {
			var reducedPoints = [points[0]];
	
			for (var i = 1, prev = 0, len = points.length; i < len; i++) {
				if (this._sqDist(points[i], points[prev]) > sqTolerance) {
					reducedPoints.push(points[i]);
					prev = i;
				}
			}
			if (prev < len - 1) {
				reducedPoints.push(points[len - 1]);
			}
			return reducedPoints;
		},
	
	
		// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
		// Clips the segment a to b by rectangular bounds with the
		// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
		// (modifying the segment points directly!). Used by Leaflet to only show polyline
		// points that are on the screen or near, increasing performance.
		clipSegment: function (a, b, bounds, useLastCode, round) {
			var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
			    codeB = this._getBitCode(b, bounds),
	
			    codeOut, p, newCode;
	
			// save 2nd code to avoid calculating it on the next segment
			this._lastCode = codeB;
	
			while (true) {
				// if a,b is inside the clip window (trivial accept)
				if (!(codeA | codeB)) {
					return [a, b];
				}
	
				// if a,b is outside the clip window (trivial reject)
				if (codeA & codeB) {
					return false;
				}
	
				// other cases
				codeOut = codeA || codeB;
				p = this._getEdgeIntersection(a, b, codeOut, bounds, round);
				newCode = this._getBitCode(p, bounds);
	
				if (codeOut === codeA) {
					a = p;
					codeA = newCode;
				} else {
					b = p;
					codeB = newCode;
				}
			}
		},
	
		_getEdgeIntersection: function (a, b, code, bounds, round) {
			var dx = b.x - a.x,
			    dy = b.y - a.y,
			    min = bounds.min,
			    max = bounds.max,
			    x, y;
	
			if (code & 8) { // top
				x = a.x + dx * (max.y - a.y) / dy;
				y = max.y;
	
			} else if (code & 4) { // bottom
				x = a.x + dx * (min.y - a.y) / dy;
				y = min.y;
	
			} else if (code & 2) { // right
				x = max.x;
				y = a.y + dy * (max.x - a.x) / dx;
	
			} else if (code & 1) { // left
				x = min.x;
				y = a.y + dy * (min.x - a.x) / dx;
			}
	
			return new L.Point(x, y, round);
		},
	
		_getBitCode: function (p, bounds) {
			var code = 0;
	
			if (p.x < bounds.min.x) { // left
				code |= 1;
			} else if (p.x > bounds.max.x) { // right
				code |= 2;
			}
	
			if (p.y < bounds.min.y) { // bottom
				code |= 4;
			} else if (p.y > bounds.max.y) { // top
				code |= 8;
			}
	
			return code;
		},
	
		// square distance (to avoid unnecessary Math.sqrt calls)
		_sqDist: function (p1, p2) {
			var dx = p2.x - p1.x,
			    dy = p2.y - p1.y;
			return dx * dx + dy * dy;
		},
	
		// return closest point on segment or distance to that point
		_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
			var x = p1.x,
			    y = p1.y,
			    dx = p2.x - x,
			    dy = p2.y - y,
			    dot = dx * dx + dy * dy,
			    t;
	
			if (dot > 0) {
				t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
				if (t > 1) {
					x = p2.x;
					y = p2.y;
				} else if (t > 0) {
					x += dx * t;
					y += dy * t;
				}
			}
	
			dx = p.x - x;
			dy = p.y - y;
	
			return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
		}
	};
	
	
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	L.Polyline = L.Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			L.setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = L.LineUtil._sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = L.latLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new L.LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = L.Polyline._flat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = L.latLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new L.Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			var w = this._clickTolerance(),
			    p = new L.Point(w, w);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				pxBounds.min._subtract(p);
				pxBounds.max._add(p);
				this._pxBounds = pxBounds;
			}
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof L.LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = L.LineUtil.clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = L.LineUtil.simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	L.polyline = function (latlngs, options) {
		return new L.Polyline(latlngs, options);
	};
	
	L.Polyline._flat = function (latlngs) {
		// true if it's a flat array of latlngs; false if nested
		return !L.Util.isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	};
	
	
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	L.PolyUtil = {};
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a seperate method for it.
	 */
	L.PolyUtil.clipPolygon = function (points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p,
		    lu = L.LineUtil;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = lu._getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = lu._getEdgeIntersection(b, a, edge, bounds, round);
						p._code = lu._getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = lu._getEdgeIntersection(b, a, edge, bounds, round);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	};
	
	
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	L.Polygon = L.Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = L.Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof L.LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			L.Polyline.prototype._setLatLngs.call(this, latlngs);
			if (L.Polyline._flat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new L.Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new L.Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = L.PolyUtil.clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		}
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	L.polygon = function (latlngs, options) {
		return new L.Polygon(latlngs, options);
	};
	
	
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Retangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	L.Rectangle = L.Polygon.extend({
		initialize: function (latLngBounds, options) {
			L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = L.latLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	L.rectangle = function (latLngBounds, options) {
		return new L.Rectangle(latLngBounds, options);
	};
	
	
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	L.CircleMarker = L.Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			L.Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	L.circleMarker = function (latlng, options) {
		return new L.CircleMarker(latlng, options);
	};
	
	
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	L.Circle = L.CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = L.extend({}, legacyOptions, {radius: options});
			}
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new L.LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: L.Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === L.CRS.Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / L.CRS.Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
				this._radiusY = Math.max(Math.round(p.y - top.y), 1);
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	L.circle = function (latlng, options, legacyOptions) {
		return new L.Circle(latlng, options, legacyOptions);
	};
	
	
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.SVG = L.Renderer.extend({
	
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = L.SVG.create('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = L.SVG.create('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			L.DomUtil.setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = L.SVG.create('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				L.DomUtil.addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				L.DomUtil.addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			L.DomUtil.remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[L.stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, L.SVG.pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = layer._radius,
			    r2 = layer._radiusY || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
					'M' + (p.x - r) + ',' + p.y +
					arc + (r * 2) + ',0 ' +
					arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._path);
		}
	});
	
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	L.extend(L.SVG, {
		// @function create(name: String): SVGElement
		// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
		// corresponding to the class name passed. For example, using 'line' will return
		// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
		create: function (name) {
			return document.createElementNS('http://www.w3.org/2000/svg', name);
		},
	
		// @function pointsToPath(rings: Point[], closed: Boolean): String
		// Generates a SVG path string for multiple rings, with each ring turning
		// into "M..L..L.." instructions
		pointsToPath: function (rings, closed) {
			var str = '',
			    i, j, len, len2, points, p;
	
			for (i = 0, len = rings.length; i < len; i++) {
				points = rings[i];
	
				for (j = 0, len2 = points.length; j < len2; j++) {
					p = points[j];
					str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
				}
	
				// closes the ring for polygons; "x" is VML syntax
				str += closed ? (L.Browser.svg ? 'z' : 'x') : '';
			}
	
			// SVG complains about empty path strings
			return str || 'M0 0';
		}
	});
	
	// @namespace Browser; @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	L.Browser.svg = !!(document.createElementNS && L.SVG.create('svg').createSVGRect);
	
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	L.svg = function (options) {
		return L.Browser.svg || L.Browser.vml ? new L.SVG(options) : null;
	};
	
	
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	/*
	 * @class SVG
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// @namespace Browser; @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	L.Browser.vml = !L.Browser.svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	// redefine some SVG methods to handle VML syntax which is similar but with some differences
	L.SVG.include(!L.Browser.vml ? {} : {
	
		_initContainer: function () {
			this._container = L.DomUtil.create('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			L.Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = L.SVG.create('shape');
	
			L.DomUtil.addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = L.SVG.create('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			L.DomUtil.remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[L.stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = L.SVG.create('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = L.Util.isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = L.SVG.create('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
					'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._container);
		}
	});
	
	if (L.Browser.vml) {
		L.SVG.create = (function () {
			try {
				document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
				return function (name) {
					return document.createElement('<lvml:' + name + ' class="lvml">');
				};
			} catch (e) {
				return function (name) {
					return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
				};
			}
		})();
	}
	
	
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.Canvas = L.Renderer.extend({
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			L.Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			L.DomEvent
				.on(container, 'mousemove', L.Util.throttle(this._onMouseMove, 32, this), this)
				.on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
				.on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			this._drawnLayers = {};
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = L.Browser.retina ? 2 : 1;
	
			L.DomUtil.setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (L.Browser.retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			L.Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[L.stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[L.stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (layer.options.dashArray) {
				var parts = layer.options.dashArray.split(','),
				    dashArray = [],
				    i;
				for (i = 0; i < parts.length; i++) {
					dashArray.push(Number(parts[i]));
				}
				layer.options._dashArray = dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || L.Util.requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			var padding = (layer.options.weight || 0) + 1;
			this._redrawBounds = this._redrawBounds || new L.Bounds();
			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			ctx.beginPath();
	
			if (ctx.setLineDash) {
				ctx.setLineDash(layer.options && layer.options._dashArray || []);
			}
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = layer._radius,
			    s = (layer._radiusY || r) / r;
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				L.DomEvent._fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				L.DomUtil.removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// signle entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// signle entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @namespace Browser; @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	L.Browser.canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @namespace Canvas
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	L.canvas = function (options) {
		return L.Browser.canvas ? new L.Canvas(options) : null;
	};
	
	L.Polyline.prototype._containsPoint = function (p, closed) {
		var i, j, k, len, len2, part,
		    w = this._clickTolerance();
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// hit detection for polylines
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) { continue; }
	
				if (L.LineUtil.pointToSegmentDistance(p, part[k], part[j]) <= w) {
					return true;
				}
			}
		}
		return false;
	};
	
	L.Polygon.prototype._containsPoint = function (p) {
		var inside = false,
		    part, p1, p2, i, j, k, len, len2;
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// ray casting algorithm for detecting if point is in polygon
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];
	
				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}
	
		// also check if it's on polygon stroke
		return inside || L.Polyline.prototype._containsPoint.call(this, p, true);
	};
	
	L.CircleMarker.prototype._containsPoint = function (p) {
		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	};
	
	
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	L.GeoJSON = L.FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			L.setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = L.Util.isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = L.GeoJSON.geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = L.GeoJSON.asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = L.Util.extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	L.extend(L.GeoJSON, {
		// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
		// Creates a `Layer` from a given GeoJSON feature. Can use a custom
		// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
		// functions if provided as options.
		geometryToLayer: function (geojson, options) {
	
			var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
			    coords = geometry ? geometry.coordinates : null,
			    layers = [],
			    pointToLayer = options && options.pointToLayer,
			    coordsToLatLng = options && options.coordsToLatLng || this.coordsToLatLng,
			    latlng, latlngs, i, len;
	
			if (!coords && !geometry) {
				return null;
			}
	
			switch (geometry.type) {
			case 'Point':
				latlng = coordsToLatLng(coords);
				return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);
	
			case 'MultiPoint':
				for (i = 0, len = coords.length; i < len; i++) {
					latlng = coordsToLatLng(coords[i]);
					layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
				}
				return new L.FeatureGroup(layers);
	
			case 'LineString':
			case 'MultiLineString':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, coordsToLatLng);
				return new L.Polyline(latlngs, options);
	
			case 'Polygon':
			case 'MultiPolygon':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, coordsToLatLng);
				return new L.Polygon(latlngs, options);
	
			case 'GeometryCollection':
				for (i = 0, len = geometry.geometries.length; i < len; i++) {
					var layer = this.geometryToLayer({
						geometry: geometry.geometries[i],
						type: 'Feature',
						properties: geojson.properties
					}, options);
	
					if (layer) {
						layers.push(layer);
					}
				}
				return new L.FeatureGroup(layers);
	
			default:
				throw new Error('Invalid GeoJSON object.');
			}
		},
	
		// @function coordsToLatLng(coords: Array): LatLng
		// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
		// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
		coordsToLatLng: function (coords) {
			return new L.LatLng(coords[1], coords[0], coords[2]);
		},
	
		// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
		// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
		// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
		// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
		coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) {
			var latlngs = [];
	
			for (var i = 0, len = coords.length, latlng; i < len; i++) {
				latlng = levelsDeep ?
				        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
				        (coordsToLatLng || this.coordsToLatLng)(coords[i]);
	
				latlngs.push(latlng);
			}
	
			return latlngs;
		},
	
		// @function latLngToCoords(latlng: LatLng): Array
		// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
		latLngToCoords: function (latlng) {
			return latlng.alt !== undefined ?
					[latlng.lng, latlng.lat, latlng.alt] :
					[latlng.lng, latlng.lat];
		},
	
		// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
		// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
		// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
		latLngsToCoords: function (latlngs, levelsDeep, closed) {
			var coords = [];
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				coords.push(levelsDeep ?
					L.GeoJSON.latLngsToCoords(latlngs[i], levelsDeep - 1, closed) :
					L.GeoJSON.latLngToCoords(latlngs[i]));
			}
	
			if (!levelsDeep && closed) {
				coords.push(coords[0]);
			}
	
			return coords;
		},
	
		getFeature: function (layer, newGeometry) {
			return layer.feature ?
					L.extend({}, layer.feature, {geometry: newGeometry}) :
					L.GeoJSON.asFeature(newGeometry);
		},
	
		// @function asFeature(geojson: Object): Object
		// Normalize GeoJSON geometries/features into GeoJSON features.
		asFeature: function (geojson) {
			if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
				return geojson;
			}
	
			return {
				type: 'Feature',
				properties: {},
				geometry: geojson
			};
		}
	});
	
	var PointToGeoJSON = {
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'Point',
				coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	L.Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	L.Circle.include(PointToGeoJSON);
	L.CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	L.Polyline.prototype.toGeoJSON = function () {
		var multi = !L.Polyline._flat(this._latlngs);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 1 : 0);
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'LineString',
			coordinates: coords
		});
	};
	
	// @namespace Polygon
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	L.Polygon.prototype.toGeoJSON = function () {
		var holes = !L.Polyline._flat(this._latlngs),
		    multi = holes && !L.Polyline._flat(this._latlngs[0]);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true);
	
		if (!holes) {
			coords = [coords];
		}
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'Polygon',
			coordinates: coords
		});
	};
	
	
	// @namespace LayerGroup
	L.LayerGroup.include({
		toMultiPoint: function () {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON().geometry.coordinates);
			});
	
			return L.GeoJSON.getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(): Object
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `GeometryCollection`).
		toGeoJSON: function () {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint();
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON();
					jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
				}
			});
	
			if (isGeometryCollection) {
				return L.GeoJSON.getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	L.geoJSON = function (geojson, options) {
		return new L.GeoJSON(geojson, options);
	};
	// Backward compatibility.
	L.geoJson = L.geoJSON;
	
	
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	L.Draggable = L.Evented.extend({
	
		options: {
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		statics: {
			START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
			END: {
				mousedown: 'mouseup',
				touchstart: 'touchend',
				pointerdown: 'touchend',
				MSPointerDown: 'touchend'
			},
			MOVE: {
				mousedown: 'mousemove',
				touchstart: 'touchmove',
				pointerdown: 'touchmove',
				MSPointerDown: 'touchmove'
			}
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline: Boolean)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline) {
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			L.DomEvent.on(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (L.Draggable._dragging === this) {
				this.finishDrag();
			}
	
			L.DomEvent.off(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (L.DomUtil.hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (L.Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			L.Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				L.DomUtil.preventOutline(this._element);
			}
	
			L.DomUtil.disableImageDrag();
			L.DomUtil.disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new L.Point(first.clientX, first.clientY);
	
			L.DomEvent
				.on(document, L.Draggable.MOVE[e.type], this._onMove, this)
				.on(document, L.Draggable.END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new L.Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			L.DomEvent.preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);
	
				L.DomUtil.addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			L.DomUtil.setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			L.DomUtil.removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in L.Draggable.MOVE) {
				L.DomEvent
					.off(document, L.Draggable.MOVE[i], this._onMove, this)
					.off(document, L.Draggable.END[i], this._onUp, this);
			}
	
			L.DomUtil.enableImageDrag();
			L.DomUtil.enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				L.Util.cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			L.Draggable._dragging = false;
		}
	
	});
	
	
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	L.Handler = L.Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !L.Browser.android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	L.Map.Drag = L.Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new L.Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					down: this._onDown,
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			L.DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-grab');
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDown: function () {
			this._map._stop();
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = L.latLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = L.bounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 50) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					L.Util.requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);
	
	
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	L.Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	L.Map.DoubleClickZoom = L.Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);
	
	
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	L.Map.ScrollWheelZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = L.DomEvent.getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(L.bind(this._performZoom, this), left);
	
			L.DomEvent.stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);
	
	
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	L.extend(L.DomEvent, {
	
		_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
		_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',
	
		// inspired by Zepto touch code by Thomas Fuchs
		addDoubleTapListener: function (obj, handler, id) {
			var last, touch,
			    doubleTap = false,
			    delay = 250;
	
			function onTouchStart(e) {
				var count;
	
				if (L.Browser.pointer) {
					if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
					count = L.DomEvent._pointersCount;
				} else {
					count = e.touches.length;
				}
	
				if (count > 1) { return; }
	
				var now = Date.now(),
				    delta = now - (last || now);
	
				touch = e.touches ? e.touches[0] : e;
				doubleTap = (delta > 0 && delta <= delay);
				last = now;
			}
	
			function onTouchEnd(e) {
				if (doubleTap && !touch.cancelBubble) {
					if (L.Browser.pointer) {
						if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
	
						// work around .type being readonly with MSPointer* events
						var newTouch = {},
						    prop, i;
	
						for (i in touch) {
							prop = touch[i];
							newTouch[i] = prop && prop.bind ? prop.bind(touch) : prop;
						}
						touch = newTouch;
					}
					touch.type = 'dblclick';
					handler(touch);
					last = null;
				}
			}
	
			var pre = '_leaflet_',
			    touchstart = this._touchstart,
			    touchend = this._touchend;
	
			obj[pre + touchstart + id] = onTouchStart;
			obj[pre + touchend + id] = onTouchEnd;
			obj[pre + 'dblclick' + id] = handler;
	
			obj.addEventListener(touchstart, onTouchStart, false);
			obj.addEventListener(touchend, onTouchEnd, false);
	
			// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
			// the browser doesn't fire touchend/pointerup events but does fire
			// native dblclicks. See #4127.
			// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
			obj.addEventListener('dblclick', handler, false);
	
			return this;
		},
	
		removeDoubleTapListener: function (obj, id) {
			var pre = '_leaflet_',
			    touchstart = obj[pre + this._touchstart + id],
			    touchend = obj[pre + this._touchend + id],
			    dblclick = obj[pre + 'dblclick' + id];
	
			obj.removeEventListener(this._touchstart, touchstart, false);
			obj.removeEventListener(this._touchend, touchend, false);
			if (!L.Browser.edge) {
				obj.removeEventListener('dblclick', dblclick, false);
			}
	
			return this;
		}
	});
	
	
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	L.extend(L.DomEvent, {
	
		POINTER_DOWN:   L.Browser.msPointer ? 'MSPointerDown'   : 'pointerdown',
		POINTER_MOVE:   L.Browser.msPointer ? 'MSPointerMove'   : 'pointermove',
		POINTER_UP:     L.Browser.msPointer ? 'MSPointerUp'     : 'pointerup',
		POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
		TAG_WHITE_LIST: ['INPUT', 'SELECT', 'OPTION'],
	
		_pointers: {},
		_pointersCount: 0,
	
		// Provides a touch events wrapper for (ms)pointer events.
		// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
		addPointerListener: function (obj, type, handler, id) {
	
			if (type === 'touchstart') {
				this._addPointerStart(obj, handler, id);
	
			} else if (type === 'touchmove') {
				this._addPointerMove(obj, handler, id);
	
			} else if (type === 'touchend') {
				this._addPointerEnd(obj, handler, id);
			}
	
			return this;
		},
	
		removePointerListener: function (obj, type, id) {
			var handler = obj['_leaflet_' + type + id];
	
			if (type === 'touchstart') {
				obj.removeEventListener(this.POINTER_DOWN, handler, false);
	
			} else if (type === 'touchmove') {
				obj.removeEventListener(this.POINTER_MOVE, handler, false);
	
			} else if (type === 'touchend') {
				obj.removeEventListener(this.POINTER_UP, handler, false);
				obj.removeEventListener(this.POINTER_CANCEL, handler, false);
			}
	
			return this;
		},
	
		_addPointerStart: function (obj, handler, id) {
			var onDown = L.bind(function (e) {
				if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
					// In IE11, some touch events needs to fire for form controls, or
					// the controls will stop working. We keep a whitelist of tag names that
					// need these events. For other target tags, we prevent default on the event.
					if (this.TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
						L.DomEvent.preventDefault(e);
					} else {
						return;
					}
				}
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchstart' + id] = onDown;
			obj.addEventListener(this.POINTER_DOWN, onDown, false);
	
			// need to keep track of what pointers and how many are active to provide e.touches emulation
			if (!this._pointerDocListener) {
				var pointerUp = L.bind(this._globalPointerUp, this);
	
				// we listen documentElement as any drags that end by moving the touch off the screen get fired there
				document.documentElement.addEventListener(this.POINTER_DOWN, L.bind(this._globalPointerDown, this), true);
				document.documentElement.addEventListener(this.POINTER_MOVE, L.bind(this._globalPointerMove, this), true);
				document.documentElement.addEventListener(this.POINTER_UP, pointerUp, true);
				document.documentElement.addEventListener(this.POINTER_CANCEL, pointerUp, true);
	
				this._pointerDocListener = true;
			}
		},
	
		_globalPointerDown: function (e) {
			this._pointers[e.pointerId] = e;
			this._pointersCount++;
		},
	
		_globalPointerMove: function (e) {
			if (this._pointers[e.pointerId]) {
				this._pointers[e.pointerId] = e;
			}
		},
	
		_globalPointerUp: function (e) {
			delete this._pointers[e.pointerId];
			this._pointersCount--;
		},
	
		_handlePointer: function (e, handler) {
			e.touches = [];
			for (var i in this._pointers) {
				e.touches.push(this._pointers[i]);
			}
			e.changedTouches = [e];
	
			handler(e);
		},
	
		_addPointerMove: function (obj, handler, id) {
			var onMove = L.bind(function (e) {
				// don't fire touch moves when mouse isn't down
				if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchmove' + id] = onMove;
			obj.addEventListener(this.POINTER_MOVE, onMove, false);
		},
	
		_addPointerEnd: function (obj, handler, id) {
			var onUp = L.bind(function (e) {
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchend' + id] = onUp;
			obj.addEventListener(this.POINTER_UP, onUp, false);
			obj.addEventListener(this.POINTER_CANCEL, onUp, false);
		}
	});
	
	
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: L.Browser.touch && !L.Browser.android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	L.Map.TouchZoom = L.Handler.extend({
		addHooks: function () {
			L.DomUtil.addClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			L.DomEvent
			    .on(document, 'touchmove', this._onTouchMove, this)
			    .on(document, 'touchend', this._onTouchEnd, this);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true);
				this._moved = true;
			}
	
			L.Util.cancelAnimFrame(this._animRequest);
	
			var moveFn = L.bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = L.Util.requestAnimFrame(moveFn, this, true);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			L.Util.cancelAnimFrame(this._animRequest);
	
			L.DomEvent
			    .off(document, 'touchmove', this._onTouchMove)
			    .off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);
	
	
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	L.Map.Tap = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			L.DomEvent.preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(L.bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			L.DomEvent.on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			L.DomEvent.off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					L.DomUtil.removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new L.Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (L.Browser.touch && !L.Browser.pointer) {
		L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
	}
	
	
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	L.Map.BoxZoom = L.Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
		},
	
		addHooks: function () {
			L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_resetState: function () {
			this._moved = false;
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			this._resetState();
	
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			L.DomEvent.on(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._container);
				L.DomUtil.addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new L.Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				L.DomUtil.remove(this._box);
				L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
			}
	
			L.DomUtil.enableTextSelection();
			L.DomUtil.enableImageDrag();
	
			L.DomEvent.off(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			setTimeout(L.bind(this._resetState, this), 0);
	
			var bounds = new L.LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);
	
	
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	L.Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	L.Map.Keyboard = L.Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			L.DomEvent.on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			L.DomEvent.off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				offset = this._panKeys[key];
				if (e.shiftKey) {
					offset = L.point(offset).multiplyBy(3);
				}
	
				map.panBy(offset);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27) {
				map.closePopup();
	
			} else {
				return;
			}
	
			L.DomEvent.stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);
	
	
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch).
	 */
	
	L.Handler.MarkerDrag = L.Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new L.Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			L.DomUtil.addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = L.DomUtil.getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				L.DomUtil.setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	L.Control = L.Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			L.DomUtil.addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			L.DomUtil.remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	L.control = function (options) {
		return new L.Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            L.DomUtil.create('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = L.DomUtil.create('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			L.DomUtil.remove(this._controlContainer);
		}
	});
	
	
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	L.Control.Zoom = L.Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '-'
			// The text set on the 'zoom out' button.
			zoomOutText: '-',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = L.DomUtil.create('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = L.DomUtil.create('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			L.DomEvent
			    .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
			    .on(link, 'click', L.DomEvent.stop)
			    .on(link, 'click', fn, this)
			    .on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			L.DomUtil.removeClass(this._zoomInButton, className);
			L.DomUtil.removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				L.DomUtil.addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				L.DomUtil.addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	L.Map.mergeOptions({
		zoomControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new L.Control.Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	L.control.zoom = function (options) {
		return new L.Control.Zoom(options);
	};
	
	
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	L.Control.Attribution = L.Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
			if (L.DomEvent) {
				L.DomEvent.disableClickPropagation(this._container);
			}
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	L.Map.mergeOptions({
		attributionControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new L.Control.Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	L.control.attribution = function (options) {
		return new L.Control.Attribution(options);
	};
	
	
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	L.Control.Scale = L.Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = L.DomUtil.create('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = L.DomUtil.create('div', className, container);
			}
			if (options.imperial) {
				this._iScale = L.DomUtil.create('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
					map.containerPointToLatLng([0, y]),
					map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	L.control.scale = function (options) {
		return new L.Control.Scale(options);
	};
	
	
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control.html)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	
	L.Control.Layers = L.Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			L.setOptions(this, options);
	
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			return this._container;
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(L.stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
			this._form.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._form.clientHeight) {
				L.DomUtil.addClass(this._form, 'leaflet-control-layers-scrollbar');
				this._form.style.height = acceptableHeight + 'px';
			} else {
				L.DomUtil.removeClass(this._form, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			L.DomUtil.removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = L.DomUtil.create('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			L.DomEvent.disableClickPropagation(container);
			if (!L.Browser.touch) {
				L.DomEvent.disableScrollPropagation(container);
			}
	
			var form = this._form = L.DomUtil.create('form', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!L.Browser.android) {
					L.DomEvent.on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (L.Browser.touch) {
				L.DomEvent
				    .on(link, 'click', L.DomEvent.stop)
				    .on(link, 'click', this.expand, this);
			} else {
				L.DomEvent.on(link, 'focus', this.expand, this);
			}
	
			// work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
			L.DomEvent.on(form, 'click', function () {
				setTimeout(L.bind(this._onInputClick, this), 0);
			}, this);
	
			// TODO keyboard accessibility
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
			this._separator = L.DomUtil.create('div', className + '-separator', form);
			this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			layer.on('add remove', this._onLayerChange, this);
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(L.bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			L.DomUtil.empty(this._baseLayersList);
			L.DomUtil.empty(this._overlaysList);
	
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(L.stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			input.layerId = L.stamp(obj.layer);
	
			L.DomEvent.on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input, layer, hasLayer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				hasLayer = this._map.hasLayer(layer);
	
				if (input.checked && !hasLayer) {
					addedLayers.push(layer);
	
				} else if (!input.checked && hasLayer) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				this._map.removeLayer(removedLayers[i]);
			}
			for (i = 0; i < addedLayers.length; i++) {
				this._map.addLayer(addedLayers[i]);
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	L.control.layers = function (baseLayers, overlays, options) {
		return new L.Control.Layers(baseLayers, overlays, options);
	};
	
	
	
	}(window, document));
	//# sourceMappingURL=leaflet-src.map

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(250);
	var toPrimitive = __webpack_require__(44);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(43);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(41);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	exports.default = _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ReactDOMComponentFlags = __webpack_require__(346);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a native or
	 * native text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedNativeOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_nativeNode` on the rendered native/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var nativeInst = getRenderedNativeOrTextFromComponent(inst);
	  nativeInst._nativeNode = node;
	  node[internalInstanceKey] = nativeInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._nativeNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._nativeNode = null;
	  }
	}
	
	/**
	 * Populate `_nativeNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedNativeOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : invariant(false) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._nativeNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._nativeNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  if (inst._nativeNode) {
	    return inst._nativeNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._nativeNode) {
	    parents.push(inst);
	    !inst._nativeParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : invariant(false) : void 0;
	    inst = inst._nativeParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._nativeNode);
	  }
	
	  return inst._nativeNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(777);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnimationPropType = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(336);
	
	var _reactMotion = __webpack_require__(823);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ANIMATION_PROPTYPES = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
	  stiffness: _react.PropTypes.number,
	  damping: _react.PropTypes.number
	}), _react.PropTypes.bool]);
	
	var propTypes = {
	  animatedProps: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  animation: ANIMATION_PROPTYPES,
	  onStart: _react.PropTypes.func,
	  onEnd: _react.PropTypes.func
	};
	
	/**
	 * Format the animation style object
	 * @param {Object|String} animationStyle - The animation style property, either the name of a
	 * presets are one of noWobble, gentle, wobbly, stiff
	 */
	function getAnimationStyle() {
	  var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _reactMotion.presets.noWobble;
	
	  if (typeof animationStyle === 'string') {
	    return _reactMotion.presets[animationStyle] || _reactMotion.presets.noWobble;
	  }
	  var damping = animationStyle.damping,
	      stiffness = animationStyle.stiffness;
	
	  return _extends({
	    damping: damping || _reactMotion.presets.noWobble.damping,
	    stiffness: stiffness || _reactMotion.presets.noWobble.stiffness
	  }, animationStyle);
	}
	
	var Animation = function (_PureRenderComponent) {
	  _inherits(Animation, _PureRenderComponent);
	
	  function Animation(props) {
	    _classCallCheck(this, Animation);
	
	    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));
	
	    _this._updateInterpolator(props);
	    _this._renderChildren = _this._renderChildren.bind(_this);
	    _this._motionEndHandler = _this._motionEndHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(Animation, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(props) {
	      this._updateInterpolator(this.props, props);
	      if (props.onStart) {
	        props.onStart();
	      }
	    }
	
	    /**
	     * Update the interpolator function and assign it to this._interpolator.
	     * @param {Object} oldProps Old props.
	     * @param {Object} newProps New props.
	     * @private
	     */
	
	  }, {
	    key: '_updateInterpolator',
	    value: function _updateInterpolator(oldProps, newProps) {
	      this._interpolator = (0, _d3Interpolate.interpolate)(this._extractAnimatedPropValues(oldProps), newProps ? this._extractAnimatedPropValues(newProps) : null);
	    }
	
	    /**
	     * Extract the animated props from the entire props object.
	     * @param {Object} props Props.
	     * @returns {Object} Object of animated props.
	     * @private
	     */
	
	  }, {
	    key: '_extractAnimatedPropValues',
	    value: function _extractAnimatedPropValues(props) {
	      var animatedProps = props.animatedProps,
	          otherProps = _objectWithoutProperties(props, ['animatedProps']);
	
	      return animatedProps.reduce(function (result, animatedPropName) {
	        if (otherProps.hasOwnProperty(animatedPropName)) {
	          result[animatedPropName] = otherProps[animatedPropName];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * Render the child into the parent.
	     * @param {Number} i Number generated by the spring.
	     * @returns {React.Component} Rendered react element.
	     * @private
	     */
	
	  }, {
	    key: '_renderChildren',
	    value: function _renderChildren(_ref) {
	      var i = _ref.i;
	      var children = this.props.children;
	
	      var interpolator = this._interpolator;
	      var child = _react2.default.Children.only(children);
	      var interpolatedProps = interpolator ? interpolator(i) : interpolator;
	
	      // interpolator doesnt play nice with deeply nested objected
	      // so we expose an additional prop for situations like these, soit _data,
	      // which stores the full tree and can be recombined with the sanitized version
	      // after interpolation
	      var data = interpolatedProps && interpolatedProps.data || null;
	      if (data && child.props._data) {
	        data = data.map(function (row, index) {
	          var correspondingCell = child.props._data[index];
	          return _extends({}, row, { parent: correspondingCell.parent, children: correspondingCell.children });
	        });
	      }
	
	      return _react2.default.cloneElement(child, _extends({}, child.props, interpolatedProps, {
	        data: data || child.props.data || null,
	        // enforce re-rendering
	        _animation: Math.random()
	      }));
	    }
	  }, {
	    key: '_motionEndHandler',
	    value: function _motionEndHandler() {
	      if (this.props.onEnd) {
	        this.props.onEnd();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animationStyle = getAnimationStyle(this.props.animation);
	      var defaultStyle = { i: 0 };
	      var style = { i: (0, _reactMotion.spring)(1, animationStyle) };
	      // In order to make Motion re-run animations each time, the random key is
	      // always passed.
	      // TODO: find a better solution for the spring.
	      var key = Math.random();
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        _extends({ defaultStyle: defaultStyle, style: style, key: key }, { onRest: this._motionEndHandler }),
	        this._renderChildren
	      );
	    }
	  }]);
	
	  return Animation;
	}(_pureRenderComponent2.default);
	
	Animation.propTypes = propTypes;
	Animation.displayName = 'Animation';
	
	exports.default = Animation;
	var AnimationPropType = exports.AnimationPropType = ANIMATION_PROPTYPES;

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Voronoi = __webpack_require__(276);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _animation = __webpack_require__(19);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, (0, _scalesUtils.getScalePropTypesByAttribute)('x'), (0, _scalesUtils.getScalePropTypesByAttribute)('y'), (0, _scalesUtils.getScalePropTypesByAttribute)('size'), (0, _scalesUtils.getScalePropTypesByAttribute)('opacity'), (0, _scalesUtils.getScalePropTypesByAttribute)('color'), {
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  data: _react2.default.PropTypes.array,
	  onValueMouseOver: _react2.default.PropTypes.func,
	  onValueMouseOut: _react2.default.PropTypes.func,
	  onValueClick: _react2.default.PropTypes.func,
	  onSeriesMouseOver: _react2.default.PropTypes.func,
	  onSeriesMouseOut: _react2.default.PropTypes.func,
	  onSeriesClick: _react2.default.PropTypes.func,
	  onNearestX: _react2.default.PropTypes.func,
	  onNearestXY: _react2.default.PropTypes.func,
	  animation: _animation.AnimationPropType
	});
	
	var defaultProps = {
	  className: ''
	};
	
	var AbstractSeries = function (_PureRenderComponent) {
	  _inherits(AbstractSeries, _PureRenderComponent);
	
	  function AbstractSeries(props) {
	    _classCallCheck(this, AbstractSeries);
	
	    var _this = _possibleConstructorReturn(this, (AbstractSeries.__proto__ || Object.getPrototypeOf(AbstractSeries)).call(this, props));
	
	    _this._seriesMouseOverHandler = _this._seriesMouseOverHandler.bind(_this);
	    _this._valueMouseOverHandler = _this._valueMouseOverHandler.bind(_this);
	    _this._seriesMouseOutHandler = _this._seriesMouseOutHandler.bind(_this);
	    _this._valueMouseOutHandler = _this._valueMouseOutHandler.bind(_this);
	    _this._seriesClickHandler = _this._seriesClickHandler.bind(_this);
	    _this._valueClickHandler = _this._valueClickHandler.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Mouse over handler for the specific series' value.
	   * @param {Object} d Value object
	   * @param {Object} event Event.
	   * @protected
	   */
	
	
	  _createClass(AbstractSeries, [{
	    key: '_valueMouseOverHandler',
	    value: function _valueMouseOverHandler(d, event) {
	      var _props = this.props,
	          onValueMouseOver = _props.onValueMouseOver,
	          onSeriesMouseOver = _props.onSeriesMouseOver;
	
	      if (onValueMouseOver) {
	        onValueMouseOver(d, { event: event });
	      }
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse over handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOverHandler',
	    value: function _seriesMouseOverHandler(event) {
	      var onSeriesMouseOver = this.props.onSeriesMouseOver;
	
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueMouseOutHandler',
	    value: function _valueMouseOutHandler(d, event) {
	      var _props2 = this.props,
	          onValueMouseOut = _props2.onValueMouseOut,
	          onSeriesMouseOut = _props2.onSeriesMouseOut;
	
	      if (onValueMouseOut) {
	        onValueMouseOut(d, { event: event });
	      }
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOutHandler',
	    value: function _seriesMouseOutHandler(event) {
	      var onSeriesMouseOut = this.props.onSeriesMouseOut;
	
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueClickHandler',
	    value: function _valueClickHandler(d, event) {
	      var _props3 = this.props,
	          onValueClick = _props3.onValueClick,
	          onSeriesClick = _props3.onSeriesClick;
	
	      if (onValueClick) {
	        onValueClick(d, { event: event });
	      }
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesClickHandler',
	    value: function _seriesClickHandler(event) {
	      var onSeriesClick = this.props.onSeriesClick;
	
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	     * Tells the rest of the world that it requires SVG to work.
	     * @returns {boolean} Result.
	     */
	
	  }, {
	    key: '_getAttributeFunctor',
	
	
	    /**
	     * Get attribute functor.
	     * @param {string} attr Attribute name
	     * @returns {*} Functor.
	     * @protected
	     */
	    value: function _getAttributeFunctor(attr) {
	      return (0, _scalesUtils.getAttributeFunctor)(this.props, attr);
	    }
	
	    /**
	     * Get the attr0 functor.
	     * @param {string} attr Attribute name.
	     * @returns {*} Functor.
	     * @private
	     */
	
	  }, {
	    key: '_getAttr0Functor',
	    value: function _getAttr0Functor(attr) {
	      return (0, _scalesUtils.getAttr0Functor)(this.props, attr);
	    }
	
	    /**
	     * Get the attribute value if it is available.
	     * @param {string} attr Attribute name.
	     * @returns {*} Attribute value if available, fallback value or undefined
	     * otherwise.
	     * @protected
	     */
	
	  }, {
	    key: '_getAttributeValue',
	    value: function _getAttributeValue(attr) {
	      return (0, _scalesUtils.getAttributeValue)(this.props, attr);
	    }
	
	    /**
	     * Get the scale object distance by the attribute from the list of properties.
	     * @param {string} attr Attribute name.
	     * @returns {number} Scale distance.
	     * @protected
	     */
	
	  }, {
	    key: '_getScaleDistance',
	    value: function _getScaleDistance(attr) {
	      var scaleObject = (0, _scalesUtils.getScaleObjectFromProps)(this.props, attr);
	      return scaleObject ? scaleObject.distance : 0;
	    }
	  }, {
	    key: '_getXYCoordinateInContainer',
	    value: function _getXYCoordinateInContainer(event) {
	      var _props4 = this.props,
	          _props4$marginTop = _props4.marginTop,
	          marginTop = _props4$marginTop === undefined ? 0 : _props4$marginTop,
	          _props4$marginLeft = _props4.marginLeft,
	          marginLeft = _props4$marginLeft === undefined ? 0 : _props4$marginLeft;
	      var _event$nativeEvent = event.nativeEvent,
	          clientX = _event$nativeEvent.clientX,
	          clientY = _event$nativeEvent.clientY,
	          currentTarget = event.currentTarget;
	
	      var rect = currentTarget.getBoundingClientRect();
	      return {
	        x: clientX - rect.left - currentTarget.clientLeft - marginLeft,
	        y: clientY - rect.top - currentTarget.clientTop - marginTop
	      };
	    }
	  }, {
	    key: '_handleNearestX',
	    value: function _handleNearestX(event) {
	      var _props5 = this.props,
	          onNearestX = _props5.onNearestX,
	          data = _props5.data;
	
	      var minDistance = Number.POSITIVE_INFINITY;
	      var value = null;
	      var valueIndex = null;
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	
	      data.forEach(function (item, i) {
	        var currentCoordinate = xScaleFn(item);
	        var newDistance = Math.abs(coordinate.x - currentCoordinate);
	        if (newDistance < minDistance) {
	          minDistance = newDistance;
	          value = item;
	          valueIndex = i;
	        }
	      });
	      if (!value) {
	        return;
	      }
	      onNearestX(value, {
	        innerX: xScaleFn(value),
	        index: valueIndex,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: '_handleNearestXY',
	    value: function _handleNearestXY(event) {
	      var _props6 = this.props,
	          onNearestXY = _props6.onNearestXY,
	          data = _props6.data;
	
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	      var yScaleFn = this._getAttributeFunctor('y');
	
	      // Create a voronoi with each node center points
	      var voronoiInstance = (0, _d3Voronoi.voronoi)().x(xScaleFn).y(yScaleFn);
	
	      var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
	      var value = foundPoint.data;
	
	      if (!value) {
	        return;
	      }
	      onNearestXY(value, {
	        innerX: foundPoint.x,
	        innerY: foundPoint.y,
	        index: foundPoint.index,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: 'onParentMouseMove',
	    value: function onParentMouseMove(event) {
	      var _props7 = this.props,
	          onNearestX = _props7.onNearestX,
	          onNearestXY = _props7.onNearestXY,
	          data = _props7.data;
	
	      if (!onNearestX && !onNearestXY || !data) {
	        return;
	      }
	      if (onNearestXY) {
	        this._handleNearestXY(event);
	      } else {
	        this._handleNearestX(event);
	      }
	    }
	  }], [{
	    key: 'getParentConfig',
	
	
	    /**
	     * Get a default config for the parent.
	     * @returns {Object} Empty config.
	     */
	    value: function getParentConfig() {
	      return {};
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return AbstractSeries;
	}(_pureRenderComponent2.default);
	
	AbstractSeries.displayName = 'AbstractSeries';
	AbstractSeries.propTypes = propTypes;
	AbstractSeries.defaultProps = defaultProps;
	
	exports.default = AbstractSeries;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13);
	var createDesc = __webpack_require__(69);
	module.exports = __webpack_require__(12) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(23);
	var has = __webpack_require__(26);
	var SRC = __webpack_require__(73)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(35).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(41);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 26 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(101);
	var createDesc = __webpack_require__(69);
	var toIObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(44);
	var has = __webpack_require__(26);
	var IE8_DOM_DEFINE = __webpack_require__(250);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(26);
	var toObject = __webpack_require__(15);
	var IE_PROTO = __webpack_require__(170)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(100);
	var defined = __webpack_require__(41);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _SCALE_FUNCTIONS;
	
	exports._getSmallestDistanceIndex = _getSmallestDistanceIndex;
	exports._getScaleFnFromScaleObject = _getScaleFnFromScaleObject;
	exports.getDomainByAttr = getDomainByAttr;
	exports._getScaleDistanceAndAdjustedDomain = _getScaleDistanceAndAdjustedDomain;
	exports._adjustCategoricalScale = _adjustCategoricalScale;
	exports.getScaleObjectFromProps = getScaleObjectFromProps;
	exports.getAttributeScale = getAttributeScale;
	exports.getAttributeFunctor = getAttributeFunctor;
	exports.getAttr0Functor = getAttr0Functor;
	exports.getAttributeValue = getAttributeValue;
	exports.getScalePropTypesByAttribute = getScalePropTypesByAttribute;
	exports.extractScalePropsFromProps = extractScalePropsFromProps;
	exports.getMissingScaleProps = getMissingScaleProps;
	exports.literalScale = literalScale;
	exports.getFontColorFromBackground = getFontColorFromBackground;
	
	var _d3Scale = __webpack_require__(337);
	
	var _d3Array = __webpack_require__(334);
	
	var _d3Collection = __webpack_require__(335);
	
	var _d3Color = __webpack_require__(214);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactUtils = __webpack_require__(333);
	
	var _dataUtils = __webpack_require__(815);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Linear scale name.
	 * @type {string}
	 * @const
	 */
	var LINEAR_SCALE_TYPE = 'linear';
	
	/**
	 * Ordinal scale name.
	 * @type {string}
	 * @const
	 */
	var ORDINAL_SCALE_TYPE = 'ordinal';
	
	/**
	 * Category scale.
	 * @type {string}
	 * @const
	 */
	var CATEGORY_SCALE_TYPE = 'category';
	
	/**
	 * Literal scale.
	 * Differs slightly from d3's identity scale in that it does not coerce value
	 * into numbers, it simply returns exactly what you give it
	 * @type {string}
	 * @const
	 */
	var LITERAL_SCALE_TYPE = 'literal';
	
	/**
	 * Log scale name.
	 * @type {string}
	 * @const
	 */
	var LOG_SCALE_TYPE = 'log';
	
	/**
	 * Time scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_SCALE_TYPE = 'time';
	
	/**
	 * Time UTC scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_UTC_SCALE_TYPE = 'time-utc';
	
	/**
	 * Scale functions that are supported in the library.
	 * @type {Object}
	 * @const
	 */
	var SCALE_FUNCTIONS = (_SCALE_FUNCTIONS = {}, _defineProperty(_SCALE_FUNCTIONS, LINEAR_SCALE_TYPE, _d3Scale.scaleLinear), _defineProperty(_SCALE_FUNCTIONS, ORDINAL_SCALE_TYPE, _d3Scale.scalePoint), _defineProperty(_SCALE_FUNCTIONS, CATEGORY_SCALE_TYPE, _d3Scale.scaleOrdinal), _defineProperty(_SCALE_FUNCTIONS, LITERAL_SCALE_TYPE, literalScale), _defineProperty(_SCALE_FUNCTIONS, LOG_SCALE_TYPE, _d3Scale.scaleLog), _defineProperty(_SCALE_FUNCTIONS, TIME_SCALE_TYPE, _d3Scale.scaleTime), _defineProperty(_SCALE_FUNCTIONS, TIME_UTC_SCALE_TYPE, _d3Scale.scaleUtc), _SCALE_FUNCTIONS);
	/**
	 * Find the smallest distance between the values on a given scale and return
	 * the index of the element, where the smallest distance was found.
	 * It returns the first occurrence of i where
	 * `scale(value[i]) - scale(value[i - 1])` is minimal
	 * @param {Array} values Array of values.
	 * @param {Object} scaleObject Scale object.
	 * @returns {number} Index of an element where the smallest distance was found.
	 * @private
	 */
	function _getSmallestDistanceIndex(values, scaleObject) {
	  var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	  var result = 0;
	  if (scaleFn) {
	    var nextValue = void 0;
	    var currentValue = scaleFn(values[0]);
	    var distance = Infinity;
	    var nextDistance = void 0;
	
	    for (var i = 1; i < values.length; i++) {
	      nextValue = scaleFn(values[i]);
	      nextDistance = Math.abs(nextValue - currentValue);
	      if (nextDistance < distance) {
	        distance = nextDistance;
	        result = i;
	      }
	      currentValue = nextValue;
	    }
	  }
	  return result;
	}
	
	/**
	 * Crate a scale function from the scale object.
	 * @param {Object} scaleObject Scale object.
	 - scaleObject.domain {Array}
	 - scaleObject.range {Array}
	 - scaleObject.type {string}
	 - scaleObject.attr {string}
	 * @returns {*} Scale function.
	 * @private
	 */
	function _getScaleFnFromScaleObject(scaleObject) {
	  if (!scaleObject) {
	    return null;
	  }
	  var type = scaleObject.type,
	      domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [-1, 0] : [-domain[0], domain[0]] : domain;
	  var scale = SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
	  if (type === ORDINAL_SCALE_TYPE) {
	    scale.padding(0.5);
	  }
	  return scale;
	}
	
	/**
	 * Get the domain from the array of data.
	 * @param {Array} allData All data.
	 * @param {string} attr Property name.
	 * @param {string} type Scale type.
	 * @returns {Array} Domain.
	 * @private
	 */
	function getDomainByAttr(allData, attr, type) {
	  var domain = void 0;
	  var attr0 = attr + '0';
	
	  // Collect both attr and available attr0 values from the array of data.
	  var values = allData.reduce(function (data, d) {
	    var value = d[attr];
	    var value0 = d[attr0];
	    if (_isDefined(value)) {
	      data.push(value);
	    }
	    if (_isDefined(value0)) {
	      data.push(value0);
	    }
	    return data;
	  }, []);
	
	  if (!values.length) {
	    return [];
	  }
	
	  // Create proper domain depending on the type of the scale.
	  if (type !== ORDINAL_SCALE_TYPE && type !== CATEGORY_SCALE_TYPE) {
	    domain = (0, _d3Array.extent)(values);
	  } else {
	    domain = (0, _d3Collection.set)(values).values();
	  }
	  return domain;
	}
	
	/**
	 * Create custom scale object from the value. When the scale is created from
	 * this object, it should return the same value all time.
	 * @param {string} attr Attribute.
	 * @param {*} value Value.
	 * @param {string} type - the type of scale being used
	 * @returns {Object} Custom scale object.
	 * @private
	 */
	function _createScaleObjectForValue(attr, value, type) {
	  if (type === 'literal') {
	    return {
	      type: 'literal',
	      domain: [],
	      range: [value],
	      distance: 0,
	      attr: attr,
	      baseValue: undefined,
	      isValue: true
	    };
	  }
	  if (typeof value === 'undefined') {
	    return null;
	  }
	  return {
	    type: 'category',
	    range: [value],
	    domain: [],
	    distance: 0,
	    attr: attr,
	    baseValue: undefined,
	    isValue: true
	  };
	}
	
	/**
	 * Create a regular scale object for a further use from the existing parameters.
	 * @param {Array} domain Domain.
	 * @param {Array} range Range.
	 * @param {string} type Type.
	 * @param {number} distance Distance.
	 * @param {string} attr Attribute.
	 * @param {number} baseValue Base value.
	 * @returns {Object} Scale object.
	 * @private
	 */
	function _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue) {
	  return {
	    domain: domain,
	    range: range,
	    type: type,
	    distance: distance,
	    attr: attr,
	    baseValue: baseValue,
	    isValue: false
	  };
	}
	
	/**
	 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
	 * xType} is transformed into {range, domain, distance, type}.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {*} Null or an object with the scale.
	 * @private
	 */
	function _collectScaleObjectFromProps(props, attr) {
	  var value = props[attr],
	      fallbackValue = props['_' + attr + 'Value'],
	      range = props[attr + 'Range'],
	      _props$ = props[attr + 'Distance'],
	      distance = _props$ === undefined ? 0 : _props$,
	      baseValue = props[attr + 'BaseValue'],
	      _props$2 = props[attr + 'Type'],
	      type = _props$2 === undefined ? LINEAR_SCALE_TYPE : _props$2;
	  var domain = props[attr + 'Domain'];
	
	  // Return value-based scale if the value is assigned.
	
	  if (typeof value !== 'undefined') {
	    return _createScaleObjectForValue(attr, value, props[attr + 'Type']);
	  }
	
	  // Pick up the domain from the properties and create a new one if it's not
	  // available.
	  if (typeof baseValue !== 'undefined') {
	    domain = (0, _dataUtils.addValueToArray)(domain, baseValue);
	  }
	
	  // Make sure that the minimum necessary properties exist.
	  if (!range || !domain || !domain.length) {
	    // Try to use the fallback value if it is available.
	    return _createScaleObjectForValue(attr, fallbackValue, props[attr + 'Type']);
	  }
	
	  return _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue);
	}
	
	/**
	 * Compute left domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeLeftDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[1] - values[0]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute right domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeRightDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[values.length - 1] - values[values.length - 2]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute distance for the given values.
	 * @param {Array} values Array of values.
	 * @param {Array} domain Domain.
	 * @param {number} bestDistIndex Index of a best distance found.
	 * @param {function} scaleFn Scale function.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
	  if (values.length > 1) {
	    // Avoid zero indexes.
	    var i = Math.max(bestDistIndex, 1);
	    return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
	  }
	  if (values.length === 1) {
	    return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  }
	  return 0;
	}
	
	/**
	 * Get the distance, the smallest and the largest value of the domain.
	 * @param {Array} data Array of data for the single series.
	 * @param {Object} scaleObject Scale object.
	 * @returns {{domain0: number, domainN: number, distance: number}} Resuylt.
	 * @private
	 */
	function _getScaleDistanceAndAdjustedDomain(data, scaleObject) {
	  var attr = scaleObject.attr,
	      domain = scaleObject.domain;
	
	  var values = (0, _dataUtils.getUniquePropertyValues)(data, attr);
	  var index = _getSmallestDistanceIndex(values, scaleObject);
	
	  var adjustedDomain = [].concat(domain);
	
	  adjustedDomain[0] -= _computeLeftDomainAdjustment(values);
	  adjustedDomain[domain.length - 1] += _computeRightDomainAdjustment(values);
	  // Fix log scale if it's too small.
	  if (scaleObject.type === LOG_SCALE_TYPE && domain[0] <= 0) {
	    adjustedDomain[0] = Math.min(domain[1] / 10, 1);
	  }
	
	  var adjustedScaleFn = _getScaleFnFromScaleObject(_extends({}, scaleObject, {
	    domain: adjustedDomain
	  }));
	
	  var distance = _computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);
	
	  return {
	    domain0: adjustedDomain[0],
	    domainN: adjustedDomain[adjustedDomain.length - 1],
	    distance: distance
	  };
	}
	
	/**
	 * Returns true if scale adjustments are possible for a given scale.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {boolean} True if scale adjustments possible.
	 * @private
	 */
	function _isScaleAdjustmentPossible(props, scaleObject) {
	  var attr = scaleObject.attr;
	  var _props$_adjustBy = props._adjustBy,
	      adjustBy = _props$_adjustBy === undefined ? [] : _props$_adjustBy,
	      _props$_adjustWhat = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat === undefined ? [] : _props$_adjustWhat;
	
	  // The scale cannot be adjusted if there's no attributes to adjust, no
	  // suitable values
	
	  return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
	}
	
	/**
	 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
	 * space from the left and right of them and by computing the best distance.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustContinuousScale(props, scaleObject) {
	  var allSeriesData = props._allData,
	      _props$_adjustWhat2 = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat2 === undefined ? [] : _props$_adjustWhat2;
	
	  // Assign the initial values.
	
	  var domainLength = scaleObject.domain.length;
	  var domain = scaleObject.domain;
	
	  var scaleDomain0 = domain[0];
	  var scaleDomainN = domain[domainLength - 1];
	  var scaleDistance = scaleObject.distance;
	
	  // Find the smallest left position of the domain, the largest right position
	  // of the domain and the best distance for them.
	  allSeriesData.forEach(function (data, index) {
	    if (adjustWhat.indexOf(index) === -1) {
	      return;
	    }
	    if (data && data.length) {
	      var _getScaleDistanceAndA = _getScaleDistanceAndAdjustedDomain(data, scaleObject),
	          domain0 = _getScaleDistanceAndA.domain0,
	          domainN = _getScaleDistanceAndA.domainN,
	          distance = _getScaleDistanceAndA.distance;
	
	      scaleDomain0 = Math.min(scaleDomain0, domain0);
	      scaleDomainN = Math.max(scaleDomainN, domainN);
	      scaleDistance = Math.max(scaleDistance, distance);
	    }
	  });
	
	  scaleObject.domain = [scaleDomain0].concat(_toConsumableArray(domain.slice(1, -1)), [scaleDomainN]);
	
	  scaleObject.distance = scaleDistance;
	
	  return scaleObject;
	}
	
	/**
	 * Get an adjusted scale. Suitable for 'category' and 'ordinal' scales.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustCategoricalScale(scaleObject) {
	  var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	  var domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  if (domain.length > 1) {
	    scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  } else {
	    scaleObject.distance = Math.abs(range[1] - range[0]);
	  }
	
	  return scaleObject;
	}
	
	/**
	 * Retrieve a scale object or a value from the properties passed.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute.
	 * @returns {*} Scale object, value or null.
	 */
	function getScaleObjectFromProps(props, attr) {
	  // Create the initial scale object.
	  var scaleObject = _collectScaleObjectFromProps(props, attr);
	
	  if (!scaleObject) {
	    return null;
	  }
	
	  // Make sure if it's possible to add space to the scale object. If not,
	  // return the object immediately.
	  if (!_isScaleAdjustmentPossible(props, scaleObject)) {
	    return scaleObject;
	  }
	
	  var type = scaleObject.type;
	  // Depending on what type the scale is, apply different adjustments. Distances
	  // for the ordinal and category scales are even, equal domains cannot be
	  // adjusted.
	
	  if (type === ORDINAL_SCALE_TYPE || type === CATEGORY_SCALE_TYPE) {
	    return _adjustCategoricalScale(scaleObject);
	  }
	  return _adjustContinuousScale(props, scaleObject);
	}
	
	/**
	 * Get d3 scale for a given prop.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {function} d3 scale function.
	 */
	function getAttributeScale(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  return _getScaleFnFromScaleObject(scaleObject);
	}
	
	/**
	 * Get the value of `attr` from the object.
	 * @param {Object} d Object.
	 * @param {string} attr Attribute.
	 * @returns {*} Value of the point.
	 * @private
	 */
	function _getAttrValue(d, attr) {
	  return d.data ? d.data[attr] : d[attr];
	}
	
	function _isDefined(value) {
	  return typeof value !== 'undefined';
	}
	
	/**
	 * Get prop functor (either a value or a function) for a given attribute.
	 * @param {Object} props Series props.
	 * @param {string} attr Property name.
	 * @returns {*} Function or value.
	 */
	function getAttributeFunctor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      return scaleFn(_getAttrValue(d, attr));
	    };
	  }
	  return null;
	}
	
	/**
	 * Get the functor which extracts value form [attr]0 property. Use baseValue if
	 * no attr0 property for a given object is defined. Fall back to domain[0] if no
	 * base value is available.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute name.
	 * @returns {*} Function which returns value or null if no values available.
	 */
	function getAttr0Functor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var attr0 = attr + '0';
	    var domain = scaleObject.domain;
	    var _scaleObject$baseValu = scaleObject.baseValue,
	        baseValue = _scaleObject$baseValu === undefined ? domain[0] : _scaleObject$baseValu;
	
	    var scaleFn = _getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      var value = _getAttrValue(d, attr0);
	      return scaleFn(_isDefined(value) ? value : baseValue);
	    };
	  }
	  return null;
	}
	
	/**
	 * Tries to get the string|number value of the attr and falls back to
	 * a fallback property in case if the value is a scale.
	 * @param {Object} props Series props.
	 * @param {string} attr Property name.
	 * @returns {*} Function or value.
	 */
	function getAttributeValue(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    if (!scaleObject.isValue) {
	      (0, _reactUtils.warning)('[React-vis] Cannot use data defined ' + attr + ' for this ' + 'series type. Using fallback value instead.');
	    }
	    return scaleObject.range[0];
	  }
	  return null;
	}
	
	/**
	 * Get prop types by the attribute.
	 * @param {string} attr Attribute.
	 * @returns {Object} Object of xDomain, xRange, xType, xDistance and _xValue,
	 * where x is an attribute passed to the function.
	 */
	function getScalePropTypesByAttribute(attr) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, '_' + attr + 'Value', _react2.default.PropTypes.any), _defineProperty(_ref, attr + 'Domain', _react2.default.PropTypes.array), _defineProperty(_ref, attr + 'Range', _react2.default.PropTypes.array), _defineProperty(_ref, attr + 'Type', _react2.default.PropTypes.oneOf(Object.keys(SCALE_FUNCTIONS))), _defineProperty(_ref, attr + 'Distance', _react2.default.PropTypes.number), _defineProperty(_ref, attr + 'BaseValue', _react2.default.PropTypes.any), _ref;
	}
	
	/**
	 * Extract the list of scale properties from the entire props object.
	 * @param {Object} props Props.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function extractScalePropsFromProps(props, attributes) {
	  var result = {};
	  Object.keys(props).forEach(function (key) {
	    var attr = attributes.find(function (a) {
	      return key.indexOf(a) === 0 || key.indexOf('_' + a) === 0;
	    });
	    if (!attr) {
	      return;
	    }
	    result[key] = props[key];
	  });
	  return result;
	}
	
	/**
	 * Extract the missing scale props from the given data and return them as
	 * an object.
	 * @param {Object} props Props.
	 * @param {Array} data Array of all data.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function getMissingScaleProps(props, data, attributes) {
	  var result = {};
	  // Make sure that the domain is set and pass the domain as well.
	  attributes.forEach(function (attr) {
	    if (!props[attr + 'Domain']) {
	      result[attr + 'Domain'] = getDomainByAttr(data, attr, props[attr + 'Type']);
	    }
	  });
	  return result;
	}
	
	/**
	 * Return a d3 scale that returns the literal value that was given to it
	 * @returns {function} literal scale.
	 */
	function literalScale() {
	  function scale(d) {
	    return d;
	  }
	
	  function response() {
	    return scale;
	  }
	
	  scale.domain = response;
	  scale.range = response;
	  scale.unknown = response;
	  scale.copy = response;
	
	  return scale;
	}
	
	function getFontColorFromBackground(background) {
	  if (background) {
	    return (0, _d3Color.hsl)(background).l > 0.57 ? '#222' : '#fff';
	  }
	  return null;
	}
	
	exports.default = {
	  extractScalePropsFromProps: extractScalePropsFromProps,
	  getAttributeScale: getAttributeScale,
	  getAttributeFunctor: getAttributeFunctor,
	  getAttr0Functor: getAttr0Functor,
	  getAttributeValue: getAttributeValue,
	  getDomainByAttr: getDomainByAttr,
	  getFontColorFromBackground: getFontColorFromBackground,
	  getMissingScaleProps: getMissingScaleProps,
	  getScaleObjectFromProps: getScaleObjectFromProps,
	  getScalePropTypesByAttribute: getScalePropTypesByAttribute,
	  literalScale: literalScale
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 34 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 35 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.6' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(20);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTicksTotalFromSize = getTicksTotalFromSize;
	exports.getTickValues = getTickValues;
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ORIENTATION = exports.ORIENTATION = {
	  TOP: 'top',
	  LEFT: 'left',
	  RIGHT: 'right',
	  BOTTOM: 'bottom'
	};
	
	var DIRECTION = exports.DIRECTION = {
	  VERTICAL: 'vertical',
	  HORIZONTAL: 'horizontal'
	};
	
	/**
	 * Get total amount of ticks from a given size in pixels.
	 * @param {number} size Size of the axis in pixels.
	 * @returns {number} Total amount of ticks.
	 */
	function getTicksTotalFromSize(size) {
	  if (size < 700) {
	    if (size > 300) {
	      return 10;
	    }
	    return 5;
	  }
	  return 20;
	}
	
	/**
	 * Get the tick values from a given d3 scale.
	 * @param {d3.scale} scale Scale function.
	 * @param {number} tickTotal Total number of ticks
	 * @param {Array} tickValues Array of tick values if they exist.
	 * @returns {Array} Array of tick values.
	 */
	function getTickValues(scale, tickTotal, tickValues) {
	  return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
	}
	
	exports.default = {
	  DIRECTION: DIRECTION,
	  ORIENTATION: ORIENTATION,
	  getTicksTotalFromSize: getTicksTotalFromSize,
	  getTickValues: getTickValues
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(63);
	
	var warning = __webpack_require__(6);
	var canDefineProperty = __webpack_require__(227);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      ref = !config.hasOwnProperty('ref') || Object.getOwnPropertyDescriptor(config, 'ref').get ? null : config.ref;
	      key = !config.hasOwnProperty('key') || Object.getOwnPropertyDescriptor(config, 'key').get ? null : '' + config.key;
	    } else {
	      ref = config.ref === undefined ? null : config.ref;
	      key = config.key === undefined ? null : '' + config.key;
	    }
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    // Create dummy `key` and `ref` property to `props` to warn users
	    // against its use
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: function () {
	            if (!specialPropKeyWarningShown) {
	              specialPropKeyWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: function () {
	            if (!specialPropRefWarningShown) {
	              specialPropRefWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(36);
	var IObject = __webpack_require__(100);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(14);
	var asc = __webpack_require__(155);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 41 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(35);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 43 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(8);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(299);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DISCRETE_COLOR_RANGE = exports.DISCRETE_COLOR_RANGE = ['#12939A', '#79C7E3', '#1A3177', '#FF9833', '#EF5D28'];
	
	var EXTENDED_DISCRETE_COLOR_RANGE = exports.EXTENDED_DISCRETE_COLOR_RANGE = ['#19CDD7', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A', '#DA70BF', '#125C77', '#4DC19C', '#776E57', '#12939A', '#17B8BE', '#F6D18A', '#B7885E', '#FFCB99', '#F89570', '#829AE3', '#E79FD5', '#1E96BE', '#89DAC1', '#B3AD9E'];
	
	var CONTINUOUS_COLOR_RANGE = exports.CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833'];
	
	var SIZE_RANGE = exports.SIZE_RANGE = [1, 10];
	
	var OPACITY_RANGE = exports.OPACITY_RANGE = [0.1, 1];
	var OPACITY_TYPE = exports.OPACITY_TYPE = 'literal';
	var DEFAULT_OPACITY = exports.DEFAULT_OPACITY = 1;
	
	var DEFAULT_SIZE = exports.DEFAULT_SIZE = 5;
	
	var DEFAULT_COLOR = exports.DEFAULT_COLOR = DISCRETE_COLOR_RANGE[0];
	
	var DEFAULT_TICK_SIZE = exports.DEFAULT_TICK_SIZE = 7;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(341);
	var PooledClass = __webpack_require__(81);
	var ReactFeatureFlags = __webpack_require__(350);
	var ReactPerf = __webpack_require__(33);
	var ReactReconciler = __webpack_require__(98);
	var Transaction = __webpack_require__(226);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(271);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(121)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(274))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(12)) {
	  var LIBRARY = __webpack_require__(56);
	  var global = __webpack_require__(5);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(123);
	  var $buffer = __webpack_require__(176);
	  var ctx = __webpack_require__(36);
	  var anInstance = __webpack_require__(64);
	  var propertyDesc = __webpack_require__(69);
	  var hide = __webpack_require__(23);
	  var redefineAll = __webpack_require__(70);
	  var toInteger = __webpack_require__(43);
	  var toLength = __webpack_require__(14);
	  var toIndex = __webpack_require__(269);
	  var toAbsoluteIndex = __webpack_require__(72);
	  var toPrimitive = __webpack_require__(44);
	  var has = __webpack_require__(26);
	  var classof = __webpack_require__(99);
	  var isObject = __webpack_require__(8);
	  var toObject = __webpack_require__(15);
	  var isArrayIter = __webpack_require__(162);
	  var create = __webpack_require__(66);
	  var getPrototypeOf = __webpack_require__(28);
	  var gOPN = __webpack_require__(67).f;
	  var getIterFn = __webpack_require__(178);
	  var uid = __webpack_require__(73);
	  var wks = __webpack_require__(9);
	  var createArrayMethod = __webpack_require__(40);
	  var createArrayIncludes = __webpack_require__(110);
	  var speciesConstructor = __webpack_require__(122);
	  var ArrayIterators = __webpack_require__(179);
	  var Iterators = __webpack_require__(82);
	  var $iterDetect = __webpack_require__(116);
	  var setSpecies = __webpack_require__(71);
	  var arrayFill = __webpack_require__(154);
	  var arrayCopyWithin = __webpack_require__(242);
	  var $DP = __webpack_require__(13);
	  var $GOPD = __webpack_require__(27);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ANIMATED_SERIES_PROPS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.isSeriesChild = isSeriesChild;
	exports.getSeriesChildren = getSeriesChildren;
	exports.getStackedData = getStackedData;
	exports.getSeriesPropsFromChildren = getSeriesPropsFromChildren;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check if the component is series or not.
	 * @param {React.Component} child Component.
	 * @returns {boolean} True if the child is series, false otherwise.
	 */
	function isSeriesChild(child) {
	  var prototype = child.type.prototype;
	
	  return prototype instanceof _abstractSeries2.default;
	}
	
	/**
	 * Get all series from the 'children' object of the component.
	 * @param {Object} children Children.
	 * @returns {Array} Array of children.
	 */
	function getSeriesChildren(children) {
	  return _react2.default.Children.toArray(children).filter(function (child) {
	    return child && isSeriesChild(child);
	  });
	}
	
	/**
	 * Collect the map of repetitions of the series type for all children.
	 * @param {Array} children Array of children.
	 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
	 * sameTypeIndex is always 0.
	 */
	function collectSeriesTypesInfo(children) {
	  var result = {};
	  children.filter(isSeriesChild).forEach(function (child) {
	    var displayName = child.type.displayName;
	    var cluster = child.props.cluster;
	
	    if (!result[displayName]) {
	      result[displayName] = {
	        sameTypeTotal: 0,
	        sameTypeIndex: 0,
	        clusters: new Set()
	      };
	    }
	    result[displayName].clusters.add(cluster);
	    result[displayName].sameTypeTotal++;
	  });
	  return result;
	}
	
	/**
	 * Check series to see if it has angular data that needs to be converted
	 * @param {Array} data - an array of objects to check
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function seriesHasAngleRadius() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (!data) {
	    return false;
	  }
	  return data.some(function (row) {
	    return row.radius && row.angle;
	  });
	}
	
	/**
	 * Possibly convert polar coordinates to x/y for computing domain
	 * @param {Array} data - an array of objects to check
	 * @param {String} attr - the property being checked
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function prepareData(data) {
	  if (!seriesHasAngleRadius(data)) {
	    return data;
	  }
	
	  return data.map(function (row) {
	    return _extends({}, row, {
	      x: row.radius * Math.cos(row.angle),
	      y: row.radius * Math.sin(row.angle)
	    });
	  });
	}
	
	/**
	 * Collect the stacked data for all children in use. If the children don't have
	 * the data (e.g. the child is invalid series or something else), then the child
	 * is skipped.
	 * Each next value of attr is equal to the previous value plus the difference
	 * between attr0 and attr.
	 * @param {Array} children Array of children.
	 * @param {string} attr Attribute to stack by.
	 * @returns {Array} New array of children for the series.
	 */
	function getStackedData(children, attr) {
	  return children.reduce(function (accumulator, series, seriesIndex) {
	    // Skip the children that are not series (e.g. don't have any data).
	    if (!series) {
	      accumulator.result.push(null);
	      return accumulator;
	    }
	
	    var _series$props = series.props,
	        data = _series$props.data,
	        _series$props$cluster = _series$props.cluster,
	        cluster = _series$props$cluster === undefined ? 'default' : _series$props$cluster;
	
	    var preppedData = prepareData(data, attr);
	
	    if (!attr || !preppedData || !preppedData.length) {
	      accumulator.result.push(preppedData);
	      return accumulator;
	    }
	
	    var attr0 = attr + '0';
	
	    accumulator.result.push(preppedData.map(function (d, dIndex) {
	      var _extends2;
	
	      // In case if it's the first series don't try to override any values.
	      if (!accumulator.seriesPointers[cluster]) {
	        return _extends({}, d);
	      }
	      // get the previous series in this cluster
	      var prevSeries = accumulator.seriesPointers[cluster].slice().pop();
	      // get the previous data point in that series
	      var prevD = accumulator.result[prevSeries][dIndex];
	      return _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, attr0, prevD[attr]), _defineProperty(_extends2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _extends2));
	    }));
	    accumulator.seriesPointers[cluster] = (accumulator.seriesPointers[cluster] || []).concat([seriesIndex]);
	    return accumulator;
	  }, {
	    result: [],
	    seriesPointers: {}
	  }).result;
	}
	
	/**
	 * Get the list of series props for a child.
	 * @param {Array} children Array of all children.
	 * @returns {Array} Array of series props for each child. If a child is not a
	 * series, than it's undefined.
	 */
	function getSeriesPropsFromChildren(children) {
	  var result = [];
	  var seriesTypesInfo = collectSeriesTypesInfo(children);
	  var seriesIndex = 0;
	  var _opacityValue = _theme.DEFAULT_OPACITY;
	  children.forEach(function (child) {
	    var props = void 0;
	    if (isSeriesChild(child)) {
	      var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
	      var _colorValue = _theme.DISCRETE_COLOR_RANGE[seriesIndex % _theme.DISCRETE_COLOR_RANGE.length];
	      props = _extends({}, seriesTypeInfo, {
	        seriesIndex: seriesIndex,
	        ref: 'series' + seriesIndex,
	        _colorValue: _colorValue,
	        _opacityValue: _opacityValue
	      });
	      seriesTypeInfo.sameTypeIndex++;
	      seriesIndex++;
	      if (child.props.cluster) {
	        props.cluster = child.props.cluster;
	        // Using Array.from() so we can use .indexOf
	        props.clusters = Array.from(seriesTypeInfo.clusters);
	        props.sameTypeTotal = props.clusters.length;
	        props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
	      }
	    }
	    result.push(props);
	  });
	  return result;
	}
	
	var ANIMATED_SERIES_PROPS = exports.ANIMATED_SERIES_PROPS = ['xRange', 'xDomain', 'x', 'yRange', 'yDomain', 'y', 'colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'strokeRange', 'strokeDomain', 'stroke', 'fillRange', 'fillDomain', 'fill', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'data'];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(126);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(81);
	
	var emptyFunction = __webpack_require__(45);
	var warning = __webpack_require__(6);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      var noop = require('fbjs/lib/emptyFunction');
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', noop));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', noop));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(9)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(23)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(73)('meta');
	var isObject = __webpack_require__(8);
	var has = __webpack_require__(26);
	var setDesc = __webpack_require__(13).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pick2 = __webpack_require__(724);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _isEqual2 = __webpack_require__(309);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var OPTIONS = ['stroke', 'color', 'weight', 'opacity', 'fill', 'fillColor', 'fillOpacity', 'fillRule', 'dashArray', 'lineCap', 'lineJoin', 'clickable', 'pointerEvents', 'className'];
	
	var Path = function (_MapLayer) {
	  _inherits(Path, _MapLayer);
	
	  function Path() {
	    _classCallCheck(this, Path);
	
	    return _possibleConstructorReturn(this, (Path.__proto__ || Object.getPrototypeOf(Path)).apply(this, arguments));
	  }
	
	  _createClass(Path, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      _get(Path.prototype.__proto__ || Object.getPrototypeOf(Path.prototype), 'componentDidUpdate', this).call(this, prevProps);
	      this.setStyleIfChanged(prevProps, this.props);
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'getPathOptions',
	    value: function getPathOptions(props) {
	      return (0, _pick3.default)(props, OPTIONS);
	    }
	  }, {
	    key: 'setStyle',
	    value: function setStyle() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.leafletElement.setStyle(options);
	    }
	  }, {
	    key: 'setStyleIfChanged',
	    value: function setStyleIfChanged(fromProps, toProps) {
	      var nextStyle = this.getPathOptions(toProps);
	      if (!(0, _isEqual3.default)(nextStyle, this.getPathOptions(fromProps))) {
	        this.setStyle(nextStyle);
	      }
	    }
	  }]);
	
	  return Path;
	}(_MapLayer3.default);
	
	Path.childContextTypes = {
	  children: _children2.default,
	  popupContainer: _react.PropTypes.object
	};
	exports.default = Path;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	exports.default = _react.PropTypes.instanceOf(_leaflet.Map);

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (Object.prototype.hasOwnProperty.call(propTypes, propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      /* istanbul ignore if: error logging */
	      if (error instanceof Error)  false ? (0, _routerWarning2.default)(false, error.message) : void 0;
	    }
	  }
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName || type.name, type.propTypes, route);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *   
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(36);
	var call = __webpack_require__(253);
	var isArrayIter = __webpack_require__(162);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(14);
	var getIterFn = __webpack_require__(178);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(259);
	var enumBugKeys = __webpack_require__(158);
	var IE_PROTO = __webpack_require__(170)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(157)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(160).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(261);
	var hiddenKeys = __webpack_require__(158).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(261);
	var enumBugKeys = __webpack_require__(158);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(24);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var dP = __webpack_require__(13);
	var DESCRIPTORS = __webpack_require__(12);
	var SPECIES = __webpack_require__(9)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(43);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 73 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(636),
	    getValue = __webpack_require__(673);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	exports.default = _react.PropTypes.oneOfType([
	// [Number, Number]
	_react.PropTypes.arrayOf(_react.PropTypes.number),
	// {lat: Number, lng: Number}
	_react.PropTypes.shape({
	  lat: _react.PropTypes.number,
	  lng: _react.PropTypes.number
	}),
	// {lat: Number, lon: Number}
	_react.PropTypes.shape({
	  lat: _react.PropTypes.number,
	  lon: _react.PropTypes.number
	})]);

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(733);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var PureRenderComponent = function (_React$Component) {
	  _inherits(PureRenderComponent, _React$Component);
	
	  function PureRenderComponent(props) {
	    _classCallCheck(this, PureRenderComponent);
	
	    return _possibleConstructorReturn(this, (PureRenderComponent.__proto__ || Object.getPrototypeOf(PureRenderComponent)).call(this, props));
	  }
	
	  _createClass(PureRenderComponent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }]);
	
	  return PureRenderComponent;
	}(_react2.default.Component);
	
	exports.default = PureRenderComponent;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_SIDE_EFFECTS: 0x2,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : void 0;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\uB7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(13).f;
	var has = __webpack_require__(26);
	var TAG = __webpack_require__(9)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(41);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(174);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87),
	    getRawTag = __webpack_require__(672),
	    objectToString = __webpack_require__(700);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(31),
	    isKey = __webpack_require__(195),
	    stringToPath = __webpack_require__(713),
	    toString = __webpack_require__(314);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(205);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(290),
	    baseKeys = __webpack_require__(640),
	    isArrayLike = __webpack_require__(201);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _layerContainer = __webpack_require__(94);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(104);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var MapLayer = function (_MapComponent) {
	  _inherits(MapLayer, _MapComponent);
	
	  function MapLayer() {
	    _classCallCheck(this, MapLayer);
	
	    return _possibleConstructorReturn(this, (MapLayer.__proto__ || Object.getPrototypeOf(MapLayer)).apply(this, arguments));
	  }
	
	  _createClass(MapLayer, [{
	    key: 'createLeafletElement',
	
	
	    // eslint-disable-next-line no-unused-vars
	    value: function createLeafletElement(props) {
	      throw new Error('createLeafletElement() must be implemented');
	    }
	
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {}
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _get(MapLayer.prototype.__proto__ || Object.getPrototypeOf(MapLayer.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(MapLayer.prototype.__proto__ || Object.getPrototypeOf(MapLayer.prototype), 'componentDidMount', this).call(this);
	      this.layerContainer.addLayer(this.leafletElement);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _get(MapLayer.prototype.__proto__ || Object.getPrototypeOf(MapLayer.prototype), 'componentWillUnmount', this).call(this);
	      this.layerContainer.removeLayer(this.leafletElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return Array.isArray(this.props.children) ? _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        this.props.children
	      ) : this.props.children || null;
	    }
	  }, {
	    key: 'layerContainer',
	    get: function get() {
	      return this.context.layerContainer || this.context.map;
	    }
	  }]);
	
	  return MapLayer;
	}(_MapComponent3.default);
	
	MapLayer.propTypes = {
	  children: _children2.default
	};
	MapLayer.contextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default,
	  pane: _react2.default.PropTypes.string
	};
	exports.default = MapLayer;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	exports.default = _react.PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	exports.default = _react.PropTypes.shape({
	  addLayer: _react.PropTypes.func.isRequired,
	  removeLayer: _react.PropTypes.func.isRequired
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(62);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(210);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(95);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(763);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(315);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(757);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(776);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(758);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(759);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(316);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(761);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(756);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(760);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(762);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(775);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(140);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(764);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(773);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(320);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(766);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(767);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(771);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(318);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(228);
	var setTextContent = __webpack_require__(367);
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    node.innerHTML = tree.html;
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level.
	  if (tree.node.nodeType === 11) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    tree.node.innerHTML = html;
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(867);
	var ReactInstrumentation = __webpack_require__(148);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing native component instance
	   * @param {?object} info about the native container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, nativeParent, nativeContainerInfo, context) {
	    var markup = internalInstance.mountComponent(transaction, nativeParent, nativeContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      ReactInstrumentation.debugTool.onMountComponent(internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getNativeNode: function (internalInstance) {
	    return internalInstance.getNativeNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      ReactInstrumentation.debugTool.onUnmountComponent(internalInstance);
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onUpdateComponent(internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      ReactInstrumentation.debugTool.onUpdateComponent(internalInstance);
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34);
	var TAG = __webpack_require__(9)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(188),
	    baseAssignValue = __webpack_require__(292);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduce2 = __webpack_require__(726);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _keys2 = __webpack_require__(91);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _forEach2 = __webpack_require__(307);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _clone2 = __webpack_require__(714);
	
	var _clone3 = _interopRequireDefault(_clone2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var EVENTS_RE = /^on(.+)$/i;
	
	var MapComponent = function (_Component) {
	  _inherits(MapComponent, _Component);
	
	  function MapComponent(props, context) {
	    _classCallCheck(this, MapComponent);
	
	    var _this = _possibleConstructorReturn(this, (MapComponent.__proto__ || Object.getPrototypeOf(MapComponent)).call(this, props, context));
	
	    _this._leafletEvents = {};
	    return _this;
	  }
	
	  _createClass(MapComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._leafletEvents = this.extractLeafletEvents(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.bindLeafletEvents(this._leafletEvents);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var next = this.extractLeafletEvents(nextProps);
	      this._leafletEvents = this.bindLeafletEvents(next, this._leafletEvents);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var el = this.leafletElement;
	      if (!el) return;
	
	      (0, _forEach3.default)(this._leafletEvents, function (cb, ev) {
	        el.off(ev, cb);
	      });
	    }
	  }, {
	    key: 'extractLeafletEvents',
	    value: function extractLeafletEvents(props) {
	      return (0, _reduce3.default)((0, _keys3.default)(props), function (res, prop) {
	        if (EVENTS_RE.test(prop)) {
	          var _key = prop.replace(EVENTS_RE, function (match, p) {
	            return p.toLowerCase();
	          });
	          res[_key] = props[prop];
	        }
	        return res;
	      }, {});
	    }
	  }, {
	    key: 'bindLeafletEvents',
	    value: function bindLeafletEvents() {
	      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var el = this.leafletElement;
	      if (!el || !el.on) return {};
	
	      var diff = (0, _clone3.default)(prev);
	      (0, _forEach3.default)(prev, function (cb, ev) {
	        if (!next[ev] || cb !== next[ev]) {
	          delete diff[ev];
	          el.off(ev, cb);
	        }
	      });
	
	      (0, _forEach3.default)(next, function (cb, ev) {
	        if (!prev[ev] || cb !== prev[ev]) {
	          diff[ev] = cb;
	          el.on(ev, cb);
	        }
	      });
	
	      return diff;
	    }
	  }, {
	    key: 'fireLeafletEvent',
	    value: function fireLeafletEvent(type, data) {
	      var el = this.leafletElement;
	      if (el) el.fire(type, data);
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var pane = props.pane || this.context.pane;
	      return pane ? _extends({}, props, { pane: pane }) : props;
	    }
	  }]);
	
	  return MapComponent;
	}(_react.Component);
	
	exports.default = MapComponent;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _controlPosition = __webpack_require__(93);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var MapControl = function (_Component) {
	  _inherits(MapControl, _Component);
	
	  function MapControl() {
	    _classCallCheck(this, MapControl);
	
	    return _possibleConstructorReturn(this, (MapControl.__proto__ || Object.getPrototypeOf(MapControl)).apply(this, arguments));
	  }
	
	  _createClass(MapControl, [{
	    key: 'createLeafletElement',
	
	
	    // eslint-disable-next-line no-unused-vars
	    value: function createLeafletElement(props) {
	      throw new Error('createLeafletElement() must be implemented');
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setPosition(toProps.position);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.leafletElement = this.createLeafletElement(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.leafletElement.addTo(this.context.map);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.leafletElement.remove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return MapControl;
	}(_react.Component);
	
	MapControl.propTypes = {
	  position: _controlPosition2.default
	};
	MapControl.contextTypes = {
	  map: _map2.default
	};
	exports.default = MapControl;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(146);
	var EventPluginUtils = __webpack_require__(220);
	var ReactErrorUtils = __webpack_require__(224);
	
	var accumulateInto = __webpack_require__(361);
	var forEachAccumulated = __webpack_require__(362);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : void 0;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[inst._rootNodeID] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[inst._rootNodeID];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][inst._rootNodeID]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventPluginHub = __webpack_require__(106);
	var EventPluginUtils = __webpack_require__(220);
	
	var accumulateInto = __webpack_require__(361);
	var forEachAccumulated = __webpack_require__(362);
	var warning = __webpack_require__(6);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	var getEventTarget = __webpack_require__(231);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(29);
	var toLength = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(72);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(24);
	var redefineAll = __webpack_require__(70);
	var meta = __webpack_require__(57);
	var forOf = __webpack_require__(65);
	var anInstance = __webpack_require__(64);
	var isObject = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(116);
	var setToStringTag = __webpack_require__(83);
	var inheritIfRequired = __webpack_require__(161);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(23);
	var redefine = __webpack_require__(24);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(41);
	var wks = __webpack_require__(9);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(4);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(8);
	var cof = __webpack_require__(34);
	var MATCH = __webpack_require__(9)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(9)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(56) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(5)[K];
	});


/***/ },
/* 118 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(20);
	var ctx = __webpack_require__(36);
	var forOf = __webpack_require__(65);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(35);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(56) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(20);
	var SPECIES = __webpack_require__(9)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(23);
	var uid = __webpack_require__(73);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(584);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(731);
	
	var _runTransitionHook = __webpack_require__(183);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(74);
	
	var _deprecate = __webpack_require__(182);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(686),
	    listCacheDelete = __webpack_require__(687),
	    listCacheGet = __webpack_require__(688),
	    listCacheHas = __webpack_require__(689),
	    listCacheSet = __webpack_require__(690);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(198);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(89),
	    toKey = __webpack_require__(90);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(684);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(615),
	    Map = __webpack_require__(184),
	    Promise = __webpack_require__(617),
	    Set = __webpack_require__(618),
	    WeakMap = __webpack_require__(620),
	    baseGetTag = __webpack_require__(88),
	    toSource = __webpack_require__(306);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 135 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(729)();
	}


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(839);


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _leaflet = __webpack_require__(11);
	
	var _latlngList = __webpack_require__(139);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_leaflet.LatLngBounds), _latlngList2.default]);

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react.PropTypes.arrayOf(_latlng2.default);

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(141);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(770);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/react-select
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(137);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(785);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(109);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDefaultArrowRenderer = __webpack_require__(783);
	
	var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
	var _utilsDefaultFilterOptions = __webpack_require__(321);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(322);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var _utilsDefaultClearRenderer = __webpack_require__(784);
	
	var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);
	
	var _Async = __webpack_require__(778);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(779);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(780);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Option = __webpack_require__(781);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(782);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		var valueType = typeof value;
		if (valueType === 'string') {
			return value;
		} else if (valueType === 'object') {
			return JSON.stringify(value);
		} else if (valueType === 'number' || valueType === 'boolean') {
			return String(value);
		} else {
			return '';
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var instanceId = 1;
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
			'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
			arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
			autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
			instanceId: _react2['default'].PropTypes.string, // set the components instanceId
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				arrowRenderer: _utilsDefaultArrowRenderer2['default'],
				autosize: true,
				backspaceRemoves: true,
				backspaceToRemoveMessage: 'Press backspace to remove {label}',
				clearable: true,
				clearAllText: 'Clear all',
				clearRenderer: _utilsDefaultClearRenderer2['default'],
				clearValueText: 'Clear value',
				deleteRemoves: true,
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: _utilsDefaultFilterOptions2['default'],
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				onCloseResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				pageSize: 5,
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				tabSelectsValue: true,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);
	
			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);
	
			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		},
	
		toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		},
	
		handleTouchOutside: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		},
	
		focus: function focus() {
			if (!this.input) return;
			this.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			if (event.target.tagName === 'INPUT') {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();
	
				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}
	
				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';
	
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: ''
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.state.inputValue
				});
			}
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			var newInputValue = event.target.value;
	
			if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
				var nextState = this.props.onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && typeof nextState !== 'object') {
					newInputValue = '' + nextState;
				}
			}
	
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
	
			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}
	
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		/**
	  * Turns a value into an array from the given options
	  * @param	{String|Number|Array}	value		- the value of the select input
	  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	  * @returns	{Array}	the value of the select represented in an array
	  */
		getValueArray: function getValueArray(value, nextProps) {
			var _this = this;
	
			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = typeof nextProps === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		},
	
		/**
	  * Retrieve a value from the given options and valueKey
	  * @param	{String|Number|Array}	value	- the selected value(s)
	  * @param	{Object}		props	- the Select component's props (or nextProps)
	  */
		expandValue: function expandValue(value, props) {
			var valueType = typeof value;
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options;
			var valueKey = props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this2 = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			var _this3 = this;
	
			//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.setState({
					inputValue: '',
					focusedIndex: null
				}, function () {
					_this3.addValue(value);
				});
			} else {
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		getResetValue: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusPageUpOption: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		},
	
		focusPageDownOption: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		},
	
		focusStartOption: function focusStartOption() {
			this.focusAdjacentOption('start');
		},
	
		focusEndOption: function focusEndOption() {
			this.focusAdjacentOption('end');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}
	
			if (focusedIndex === -1) {
				focusedIndex = 0;
			}
	
			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		},
	
		getFocusedOption: function getFocusedOption() {
			return this._focusedOption;
		},
	
		getInputValue: function getInputValue() {
			return this.state.inputValue;
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this4 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: _this4._instancePrefix + '-value-' + i,
							instancePrefix: _this4._instancePrefix,
							disabled: _this4.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this4.props.valueKey],
							onClick: onClick,
							onRemove: _this4.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2['default'].createElement(
							'span',
							{ className: 'Select-aria-only' },
							' '
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this5 = this;
	
			var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;
	
			var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
			// TODO: Check how this project includes Object.assign()
			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this5.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});
	
			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}
	
			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps;
				var inputClassName = _props$inputProps.inputClassName;
	
				var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
				return _react2['default'].createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function (ref) {
						return _this5.input = ref;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}
	
			if (this.props.autosize) {
				return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2['default'].createElement(
				'div',
				{ className: className },
				_react2['default'].createElement('input', inputProps)
			);
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();
	
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		},
	
		renderArrow: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
			return _react2['default'].createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		},
	
		onOptionRef: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this6 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this6.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: function (ref) {
						return _this6.value = ref;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this6.props.name,
					value: stringifyValue(item[_this6.props.valueKey]),
					disabled: _this6.props.disabled });
			});
		},
	
		getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;
	
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = options.indexOf(focusedOption);
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}
	
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		},
	
		renderOuter: function renderOuter(options, valueArray, focusedOption) {
			var _this7 = this;
	
			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menuContainer = ref;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menu = ref;
						}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		},
	
		render: function render() {
			var _this8 = this;
	
			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
	
			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2['default'].createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.wrapper = ref;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.control = ref;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2['default'].createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(817)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getNativeProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventConstants = __webpack_require__(53);
	var EventPluginRegistry = __webpack_require__(146);
	var ReactEventEmitterMixin = __webpack_require__(859);
	var ViewportMetrics = __webpack_require__(360);
	
	var getVendorPrefixedEventName = __webpack_require__(887);
	var isEventSupported = __webpack_require__(233);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var ReactDebugTool = __webpack_require__(856);
	
	module.exports = { debugTool: ReactDebugTool };

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(126);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(108);
	var ViewportMetrics = __webpack_require__(360);
	
	var getEventModifierState = __webpack_require__(230);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.appController = exports.appComponents = exports.leftSideBarComponent = exports.homeComponent = exports.appConfig = undefined;
	
	var _receipts_data = __webpack_require__(379);
	
	var _expenditure_data = __webpack_require__(377);
	
	var _expenditure_metadata = __webpack_require__(378);
	
	var _receipts_metadata = __webpack_require__(380);
	
	var _expenditure_concordance_data = __webpack_require__(376);
	
	var _DataKindBLR = __webpack_require__(608);
	
	var appConfig = {
		"app.title": "Story Generator",
		"app.version": "ALPHA"
	
	};
	
	var homeComponent = {
		"primary_header": "OpenBudgets India", // Text Only
		"secondary_header": "Story Generator", // Text 
		"description": "The Story Generator is a tool that facilitates comparison of aggregate budget indicators across different states and years. It incorporates data from both the expenditure and the receipts side of State Budgets. The indicators of expenditure data have been classified into twelve social and economic sectors. It enables users to make inter-state comparison of budget data by generating simple and interactive visualisations, which can be downloaded for reuse. Detailed descriptions are included to help users understand the specificities of calculation for the indicators presented. ",
		"contributor_organizations": [{
			"url": "https://raw.githubusercontent.com/cbgaindia/portal-design/master/logo_OBI/logo_types/light_bg_logo/draft_final/logo_with_text/draft_final.png",
			"alt": "OpenBudgetsIndia Logo",
			"image_name": "OpenBudgetsIndia Logo",
			"id": "openbudgetsindia_logo",
			"height": "35",
			"link": "https://openbudgetsindia.org/"
		}, {
			"url": "images/DataKindBLR.png",
			"alt": "DataKind Bangalore Logo",
			"image_name": "DataKind Bangalore Logo",
			"id": "datakind_logo",
			"height": "30",
			"link": "http://www.datakind.org/chapters/datakind-blr"
		}]
	};
	
	var leftSideBarComponent = {
		"top_logo": {
			"format": "text", // text/img
			"text_config": {
				"text": "Story Generator", // Null for img and text value if top-logo-format is  
				"release_version": "ALPHA" // Alpha/PreALPHA/BETA	
			},
			"img_config": {
				"source": "https://raw.githubusercontent.com/cbgaindia/portal-design/master/logo_OBI/logo_types/light_bg_logo/draft_final/logo_with_text/draft_final.png", // null if text else provide link for images.	
				"width": "270",
				"height": ""
			}
		},
		"bottom_logo": { // To represent organization logo.
			"contributor_organizations": [{
				"url": "https://raw.githubusercontent.com/cbgaindia/portal-design/master/logo_OBI/logo_types/light_bg_logo/draft_final/logo_with_text/draft_final.png",
				"alt": "OpenBudgetsIndia Logo",
				"image_name": "OpenBudgetsIndia Logo",
				"id": "openbudgetsindia_logo",
				"height": "20",
				"link": "https://openbudgetsindia.org/"
			}, {
				"url": "images/DataKindBLR.png",
				"alt": "DataKind Bangalore Logo",
				"image_name": "DataKind Bangalore Logo",
				"id": "datakind_logo",
				"height": "13",
				"link": "http://www.datakind.org/chapters/datakind-blr"
			}],
	
			"img_config": {
				"source": "https://raw.githubusercontent.com/cbgaindia/portal-design/master/logo_OBI/logo_types/light_bg_logo/draft_final/logo_with_text/draft_final.png", // null if text else provide link for images.	
				"width": "250", //Image width
				"height": "", // Image height
				"link": "https://openbudgetsindia.org/" // Hyperlink to the organization
			}
		},
		"selection_panel": {
			"panels": [{
				"isActive": "true",
				"title": "Expenditure",
				"title_slug": "expenditure",
				"heirarchy_level": "2",
				"data": _expenditure_data.expenditure_data
			}, {
				"isActive": "false",
				"title": "Receipts",
				"title_slug": "receipts",
				"heirarchy_level": "1",
				"data": _receipts_data.receipts_data
			}]
		}
	};
	
	var appController = {
		dataseries: [{
			"title": "Expenditure",
			"title_slug": "expenditure",
			"heirarchy_level": "2",
			"data": _expenditure_data.expenditure_data,
			"primary_header": "record",
			"secondary_header": "category_name",
			"meta_data": _expenditure_metadata.expenditure_metadata,
			"addtional_meta_data": _expenditure_concordance_data.expenditure_concordance_data
		}, {
			"title": "Receipts",
			"title_slug": "receipts",
			"heirarchy_level": "1",
			"data": _receipts_data.receipts_data,
			"primary_header": "record",
			"secondary_header": "null",
			"meta_data": _receipts_metadata.receipts_metadata,
			"addtional_meta_data": _receipts_metadata.receipts_metadata
		}]
	};
	
	var appComponents = {
		"homeComponent": homeComponent,
		"leftSideBarComponent": leftSideBarComponent,
		"appController": appController
	};
	
	exports.appConfig = appConfig;
	exports.homeComponent = homeComponent;
	exports.leftSideBarComponent = leftSideBarComponent;
	exports.appComponents = appComponents;
	exports.appController = appController;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(14);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(385);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(13);
	var createDesc = __webpack_require__(69);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 158 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(9)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	var setPrototypeOf = __webpack_require__(169).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(82);
	var ITERATOR = __webpack_require__(9)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(66);
	var descriptor = __webpack_require__(69);
	var setToStringTag = __webpack_require__(83);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(23)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(24);
	var hide = __webpack_require__(23);
	var Iterators = __webpack_require__(82);
	var $iterCreate = __webpack_require__(163);
	var setToStringTag = __webpack_require__(83);
	var getPrototypeOf = __webpack_require__(28);
	var ITERATOR = __webpack_require__(9)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 165 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 166 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(175).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(20);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(8);
	var anObject = __webpack_require__(4);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(36)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(121)('keys');
	var uid = __webpack_require__(73);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(43);
	var defined = __webpack_require__(41);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(115);
	var defined = __webpack_require__(41);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(43);
	var defined = __webpack_require__(41);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 174 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(36);
	var invoke = __webpack_require__(251);
	var html = __webpack_require__(160);
	var cel = __webpack_require__(157);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(34)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(12);
	var LIBRARY = __webpack_require__(56);
	var $typed = __webpack_require__(123);
	var hide = __webpack_require__(23);
	var redefineAll = __webpack_require__(70);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(64);
	var toInteger = __webpack_require__(43);
	var toLength = __webpack_require__(14);
	var toIndex = __webpack_require__(269);
	var gOPN = __webpack_require__(67).f;
	var dP = __webpack_require__(13).f;
	var arrayFill = __webpack_require__(154);
	var setToStringTag = __webpack_require__(83);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(35);
	var LIBRARY = __webpack_require__(56);
	var wksExt = __webpack_require__(270);
	var defineProperty = __webpack_require__(13).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(99);
	var ITERATOR = __webpack_require__(9)('iterator');
	var Iterators = __webpack_require__(82);
	module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(55);
	var step = __webpack_require__(254);
	var Iterators = __webpack_require__(82);
	var toIObject = __webpack_require__(29);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(164)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(691),
	    mapCacheDelete = __webpack_require__(692),
	    mapCacheGet = __webpack_require__(693),
	    mapCacheHas = __webpack_require__(694),
	    mapCacheSet = __webpack_require__(695);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(129),
	    stackClear = __webpack_require__(708),
	    stackDelete = __webpack_require__(709),
	    stackGet = __webpack_require__(710),
	    stackHas = __webpack_require__(711),
	    stackSet = __webpack_require__(712);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(292),
	    eq = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(633),
	    isObjectLike = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(288);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(305);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(622),
	    stubArray = __webpack_require__(313);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 194 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(31),
	    isSymbol = __webpack_require__(205);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 196 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(299);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(238)(module)))

/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(632),
	    isObjectLike = __webpack_require__(59);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(203),
	    isLength = __webpack_require__(204);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47),
	    stubFalse = __webpack_require__(727);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(238)(module)))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(88),
	    isObject = __webpack_require__(76);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(88),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(732)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var GridLayer = function (_MapLayer) {
	  _inherits(GridLayer, _MapLayer);
	
	  function GridLayer() {
	    _classCallCheck(this, GridLayer);
	
	    return _possibleConstructorReturn(this, (GridLayer.__proto__ || Object.getPrototypeOf(GridLayer)).apply(this, arguments));
	  }
	
	  _createClass(GridLayer, [{
	    key: 'getOptions',
	    value: function getOptions(props) {
	      var options = _get(GridLayer.prototype.__proto__ || Object.getPrototypeOf(GridLayer.prototype), 'getOptions', this).call(this, props);
	      var map = this.context.map;
	      return map ? _extends({
	        maxZoom: map.options.maxZoom,
	        minZoom: map.options.minZoom
	      }, options) : options;
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return (0, _leaflet.gridLayer)(this.getOptions(props));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      var opacity = toProps.opacity,
	          zIndex = toProps.zIndex;
	
	      if (opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(opacity);
	      }
	      if (zIndex !== fromProps.zIndex) {
	        this.leafletElement.setZIndex(zIndex);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return GridLayer;
	}(_MapLayer3.default);
	
	GridLayer.propTypes = {
	  children: _children2.default,
	  opacity: _react.PropTypes.number,
	  zIndex: _react.PropTypes.number
	};
	exports.default = GridLayer;

/***/ },
/* 209 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(2);
	
	var _deprecateObjectProperties = __webpack_require__(141);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(86);
	
	var _computeChangedRoutes2 = __webpack_require__(768);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(765);
	
	var _isActive2 = __webpack_require__(772);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(769);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(774);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and must return either a) a prompt message to show
	   * the user, to make sure they want to leave the page or b) false, to prevent
	   * the transition.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(32);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL,
	    HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = {
	  direction: _react2.default.PropTypes.oneOf([VERTICAL, HORIZONTAL]),
	  attr: _react2.default.PropTypes.string.isRequired,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  top: _react2.default.PropTypes.number,
	  left: _react2.default.PropTypes.number,
	
	  tickValues: _react2.default.PropTypes.array,
	  tickTotal: _react2.default.PropTypes.number,
	
	  animation: _animation.AnimationPropType,
	
	  // generally supplied by xyplot
	  marginTop: _react2.default.PropTypes.number,
	  marginBottom: _react2.default.PropTypes.number,
	  marginLeft: _react2.default.PropTypes.number,
	  marginRight: _react2.default.PropTypes.number,
	  innerWidth: _react2.default.PropTypes.number,
	  innerHeight: _react2.default.PropTypes.number
	};
	
	var defaultProps = {
	  direction: VERTICAL
	};
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var GridLines = function (_PureRenderComponent) {
	  _inherits(GridLines, _PureRenderComponent);
	
	  function GridLines() {
	    _classCallCheck(this, GridLines);
	
	    return _possibleConstructorReturn(this, (GridLines.__proto__ || Object.getPrototypeOf(GridLines)).apply(this, arguments));
	  }
	
	  _createClass(GridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft,
	          direction = _props.direction;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(direction === VERTICAL ? innerWidth : innerHeight)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(GridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var attr = props.attr,
	          direction = props.direction,
	          width = props.width,
	          height = props.height,
	          tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          top = props.top,
	          left = props.left;
	
	      var isVertical = direction === VERTICAL;
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var length = isVertical ? height : width;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(props, attr);
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + left + ',' + top + ')',
	          className: 'rv-xy-plot__grid-lines' },
	        values.map(function (v, i) {
	          var _pathProps;
	
	          var pos = scale(v);
	          var pathProps = (_pathProps = {}, _defineProperty(_pathProps, tickYAttr + '1', pos), _defineProperty(_pathProps, tickYAttr + '2', pos), _defineProperty(_pathProps, tickXAttr + '1', 0), _defineProperty(_pathProps, tickXAttr + '2', length), _pathProps);
	          return _react2.default.createElement('line', _extends({}, pathProps, {
	            key: i,
	            className: 'rv-xy-plot__grid-lines__line' }));
	        })
	      );
	    }
	  }]);
	
	  return GridLines;
	}(_pureRenderComponent2.default);
	
	GridLines.displayName = 'GridLines';
	GridLines.defaultProps = defaultProps;
	GridLines.propTypes = propTypes;
	GridLines.requiresSVG = true;
	
	exports.default = GridLines;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--rect';
	
	var RectSeries = function (_AbstractSeries) {
	  _inherits(RectSeries, _AbstractSeries);
	
	  function RectSeries() {
	    _classCallCheck(this, RectSeries);
	
	    return _possibleConstructorReturn(this, (RectSeries.__proto__ || Object.getPrototypeOf(RectSeries)).apply(this, arguments));
	  }
	
	  _createClass(RectSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          linePosAttr = _props.linePosAttr,
	          lineSizeAttr = _props.lineSizeAttr,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          valuePosAttr = _props.valuePosAttr,
	          valueSizeAttr = _props.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(RectSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var line0Functor = this._getAttr0Functor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: {
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }
	          }, _defineProperty(_attrs, linePosAttr, line0Functor(d)), _defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _react2.default.PropTypes.string,
	        valuePosAttr: _react2.default.PropTypes.string,
	        lineSizeAttr: _react2.default.PropTypes.string,
	        valueSizeAttr: _react2.default.PropTypes.string
	      });
	    }
	  }]);
	
	  return RectSeries;
	}(_abstractSeries2.default);
	
	RectSeries.displayName = 'RectSeries';
	
	exports.default = RectSeries;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18;
	var Xn = 0.96422;
	var Yn = 1;
	var Zn = 0.82521;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(97);
	var Danger = __webpack_require__(831);
	var ReactMultiChildUpdateTypes = __webpack_require__(353);
	var ReactPerf = __webpack_require__(33);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(228);
	var setInnerHTML = __webpack_require__(234);
	var setTextContent = __webpack_require__(367);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getNativeNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  replaceDelimitedText: 'replaceDelimitedText'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ReactDOMInstrumentation = __webpack_require__(849);
	var ReactPerf = __webpack_require__(33);
	
	var quoteAttributeValueForBrowser = __webpack_require__(889);
	var warning = __webpack_require__(6);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          // No HAS_SIDE_EFFECTS logic here, only `value` has it and is string.
	          node[propName] = false;
	        } else {
	          if (!propertyInfo.hasSideEffects || '' + node[propName] !== '') {
	            node[propName] = '';
	          }
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var ReactErrorUtils = __webpack_require__(224);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {*} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(357);
	var ReactPropTypeLocations = __webpack_require__(150);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(228);
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  node.innerHTML = html;
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactElement = __webpack_require__(39);
	
	var getIteratorFn = __webpack_require__(232);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(221);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyFunction = __webpack_require__(45);
	var warning = __webpack_require__(6);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RightSidebar = __webpack_require__(240);
	
	var _RightSidebar2 = _interopRequireDefault(_RightSidebar);
	
	var _ReportView = __webpack_require__(372);
	
	var _ReportView2 = _interopRequireDefault(_ReportView);
	
	var _ConfigMap = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppController = function (_React$Component) {
	    _inherits(AppController, _React$Component);
	
	    function AppController(props) {
	        _classCallCheck(this, AppController);
	
	        var _this = _possibleConstructorReturn(this, (AppController.__proto__ || Object.getPrototypeOf(AppController)).call(this, props));
	
	        _this.state = {
	            heirarchyLevel: _this.props.params.heirarchy_level,
	            categorySlug: _this.props.params.category,
	            recordSlug: _this.props.params.record,
	            series: _this.props.route.panelName,
	            viewBy: "choropleth",
	            budgetAttr: "BE",
	            categoryName: null,
	            sectorSelected: null,
	            recordData: null,
	            sectorName: null,
	            recordNotes: null,
	            addtional_details: null
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.onChangeBudgetAttr = _this.onChangeBudgetAttr.bind(_this);
	        _this.setCategoryName = _this.setCategoryName.bind(_this);
	        _this.setNotes = _this.setNotes.bind(_this);
	        _this.setCategorySlug = _this.setCategorySlug.bind(_this);
	        _this.setRecordSlug = _this.setRecordSlug.bind(_this);
	        _this.setRecordData = _this.setRecordData.bind(_this);
	        _this.setYearChange = _this.setYearChange.bind(_this);
	        _this.setAdditionalDetails = _this.setAdditionalDetails.bind(_this);
	        return _this;
	    }
	
	    _createClass(AppController, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setCategoryName();
	            this.setRecordData();
	            this.setState({ heirarchyLevel: this.props.params.heirarchy_level,
	                categorySlug: this.props.params.category,
	                recordSlug: this.props.params.record,
	                series: this.props.route.panelName });
	            this.setNotes();
	            this.setAdditionalDetails();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            //
	            if (prevState.categorySlug != this.props.params.category && this.props.params.heirarchy_level == 2) {
	                this.setCategorySlug();
	                this.setCategoryName();
	            }
	
	            if (prevState.recordSlug != this.props.params.record || prevState.categorySlug != this.props.params.category) {
	                this.setRecordSlug();
	                this.setRecordData();
	            }
	
	            if (prevState.categorySlug != this.props.params.category || prevState.recordSlug != this.props.params.record || prevState.heirarchyLevel != this.props.params.heirarchy_level) {
	                this.setNotes();
	            }
	
	            if (prevProps.params.category != this.props.params.category && this.state.heirarchyLevel == 2) {
	                this.setAdditionalDetails();
	            }
	
	            if (prevProps.params.record != this.props.params.record && this.state.heirarchyLevel == 1) {
	                this.setAdditionalDetails();
	            }
	        }
	    }, {
	        key: 'setCategorySlug',
	        value: function setCategorySlug() {
	            this.setState({ categorySlug: this.props.params.category });
	        }
	    }, {
	        key: 'setRecordSlug',
	        value: function setRecordSlug() {
	            this.setState({ recordSlug: this.props.params.record });
	        }
	    }, {
	        key: 'setRecordData',
	        value: function setRecordData() {
	            var currentState = this.state;
	            if (this.props.params.heirarchy_level == 2) {
	                var recordData = _ConfigMap.appController.dataseries.find(function (series) {
	                    return series.title_slug == currentState.series;
	                }).data.find(function (category) {
	                    return category.category_slug == currentState.categorySlug;
	                }).sub_records.find(function (record) {
	                    return record.record_slug == currentState.recordSlug;
	                });
	                this.setState({ recordData: recordData });
	            } else {
	                var _recordData = _ConfigMap.appController.dataseries.find(function (series) {
	                    return series.title_slug == currentState.series;
	                }).data.find(function (record) {
	                    return record.record_slug == currentState.recordSlug;
	                });
	                this.setState({ recordData: _recordData });
	            }
	        }
	    }, {
	        key: 'setCategoryName',
	        value: function setCategoryName() {
	            var currentState = this.state;
	            var categoryName = _ConfigMap.appController.dataseries.find(function (series) {
	                if (series.title_slug == currentState.series) {
	                    return series;
	                }
	            }).data.find(function (category) {
	                if (category.category_slug == currentState.categorySlug) {
	                    return category;
	                }
	            }).category_name;
	            this.setState({ categoryName: categoryName });
	        }
	    }, {
	        key: 'setNotes',
	        value: function setNotes() {
	            var currentState = this.state;
	            var currentProps = this.props;
	            if (this.props.params.heirarchy_level == 2) {
	                var recordNotes = _ConfigMap.appController.dataseries.find(function (series) {
	                    return series.title_slug == currentState.series;
	                }).meta_data.find(function (record) {
	                    return record.category_slug == currentProps.params.category && record.record_slug == currentProps.params.record;
	                });
	                this.setState({ recordNotes: recordNotes });
	            }
	            if (this.props.params.heirarchy_level == 1) {
	                var _recordNotes = _ConfigMap.appController.dataseries.find(function (series) {
	                    {
	                        return series.title_slug == currentState.series;
	                    }
	                }).meta_data.find(function (record) {
	                    {
	                        return record.record_slug == currentProps.params.record;
	                    }
	                });
	                this.setState({ recordNotes: _recordNotes });
	            }
	        }
	    }, {
	        key: 'setAdditionalDetails',
	        value: function setAdditionalDetails() {
	            var currentState = this.state;
	            var currentProps = this.props;
	            if (this.props.params.heirarchy_level == 2) {
	                var additionalDetails = _ConfigMap.appController.dataseries.find(function (series) {
	                    return series.title_slug == currentState.series;
	                }).addtional_meta_data.find(function (category) {
	                    return category.category_slug == currentProps.params.category;
	                });
	                this.setState({ addtional_details: additionalDetails });
	            } else {
	                var _additionalDetails = _ConfigMap.appController.dataseries.find(function (series) {
	                    return series.title_slug == currentState.series;
	                }).addtional_meta_data.find(function (record) {
	                    return record.record_slug == currentProps.params.record;
	                });
	
	                this.setState({ addtional_details: _additionalDetails });
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(value) {
	            this.setState({ viewBy: value });
	        }
	    }, {
	        key: 'onChangeBudgetAttr',
	        value: function onChangeBudgetAttr(value) {
	            this.setState({ budgetAttr: value });
	        }
	    }, {
	        key: 'setYearChange',
	        value: function setYearChange(value) {
	            this.setState({ selectedYear: value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-10' },
	                    _react2.default.createElement(_ReportView2.default, { heirarchyLevel: this.state.heirarchyLevel,
	                        category: this.state.categoryName,
	                        record: this.state.recordData,
	                        recordName: this.state.recordData.record_name,
	                        budgetAttr: this.state.budgetAttr,
	                        viewBy: this.state.viewBy,
	                        recordNotes: this.state.recordNotes,
	                        setYearChange: this.setYearChange,
	                        selectedYear: this.state.selectedYear,
	                        additionalDetails: this.state.addtional_details
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-2 rightsidebar' },
	                    _react2.default.createElement(_RightSidebar2.default, { viewByChange: this.handleChange, budgetAttrChange: this.onChangeBudgetAttr })
	                )
	            );
	        }
	    }]);
	
	    return AppController;
	}(_react2.default.Component);
	
	AppController.propTypes = {
	    params: _react2.default.PropTypes.object,
	    route: _react2.default.PropTypes.object
	};
	
	exports.default = AppController;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(96);
	
	var _domToImage = __webpack_require__(592);
	
	var _domToImage2 = _interopRequireDefault(_domToImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function filter(node) {
		try {
			return node.getAttribute("class") !== 'statetooltip' && node.getAttribute("class") !== "tcontainer" && node.getAttribute("class") !== "select-container" && node.nodeType != 8 && node.getAttribute("class") != "see-details-text";
		} catch (err) {
			return true;
		}
	}
	
	var RightSidebar = function (_React$Component) {
		_inherits(RightSidebar, _React$Component);
	
		function RightSidebar(props) {
			_classCallCheck(this, RightSidebar);
	
			var _this = _possibleConstructorReturn(this, (RightSidebar.__proto__ || Object.getPrototypeOf(RightSidebar)).call(this, props));
	
			_this.state = {
				viewBy: "choropleth",
				budgetAttribute: "BE"
			};
			_this.handleViewByChange = _this.handleViewByChange.bind(_this);
			_this.handleBudgetAttrChange = _this.handleBudgetAttrChange.bind(_this);
			_this.downloadImage = _this.downloadImage.bind(_this);
			return _this;
		}
	
		_createClass(RightSidebar, [{
			key: 'handleViewByChange',
			value: function handleViewByChange(e) {
				this.setState({ viewBy: e.target.value });
				this.props.viewByChange(e.target.value);
			}
		}, {
			key: 'handleBudgetAttrChange',
			value: function handleBudgetAttrChange(e) {
				this.setState({
					budgetAttribute: e.target.value
				});
				this.props.budgetAttrChange(e.target.value);
			}
		}, {
			key: 'downloadImage',
			value: function downloadImage() {
				_domToImage2.default.toBlob(document.getElementById('report-container'), { filter: filter }).then(function (blob) {
					window.saveAs(blob, 'Visualization Report.png');
				}).catch(function (error) {});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'row-fluid  vis-selector-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'row-fluid' },
							_react2.default.createElement(
								'span',
								{ className: 'view-by-span rightsidebar-titles' },
								_react2.default.createElement(
									'b',
									null,
									'View By :'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row-fluid button-grps' },
							_react2.default.createElement(
								'div',
								{ className: 'btn-group viewby-grp', role: 'group', 'aria-label': '...' },
								_react2.default.createElement(
									'button',
									{ type: 'button', value: 'choropleth', className: this.state.viewBy === "choropleth" ? "btn btn-default focus active" : "btn btn-default", onClick: this.handleViewByChange },
									_react2.default.createElement('i', { className: 'fa fa-globe fa-2x', value: 'choropleth', 'aria-hidden': 'true' })
								),
								_react2.default.createElement(
									'button',
									{ type: 'button', value: 'barchart', className: this.state.viewBy === "barchart" ? "btn btn-default focus active" : "btn btn-default", onClick: this.handleViewByChange },
									_react2.default.createElement('i', { className: 'fa fa-bar-chart fa-2x', value: 'barchart', 'aria-hidden': 'true' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row-fluid estimates-fig-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'row-fluid' },
							_react2.default.createElement(
								'span',
								{ className: 'budget-attr-span rightsidebar-titles' },
								_react2.default.createElement(
									'b',
									null,
									'Budget Attributes :'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'btn-group button-grps btn-group-vertical', 'data-toggle': 'buttons' },
							_react2.default.createElement(
								'button',
								{ type: 'button', value: 'BE', className: this.state.budgetAttribute === "BE" ? "btn btn-default focus active" : "btn btn-default", onClick: this.handleBudgetAttrChange },
								' Budget Estimates'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', value: 'RE', className: this.state.budgetAttribute === "RE" ? "btn btn-default focus active" : "btn btn-default", onClick: this.handleBudgetAttrChange },
								'Revised Estimates'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', value: 'A', className: this.state.budgetAttribute === "A" ? "btn btn-default focus active" : "btn btn-default", onClick: this.handleBudgetAttrChange },
								'Actuals'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row misc-buttons-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'row  ' },
							_react2.default.createElement(
								'span',
								{ className: 'share-text rightsidebar-titles' },
								_react2.default.createElement('i', { className: 'fa fa-share-alt fa-lg', 'aria-hidden': 'true' }),
								' Share : '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'button',
								{ type: 'button', value: 'download', className: 'btn btn-default', id: 'download_report', onClick: this.downloadImage },
								' ',
								_react2.default.createElement('i', { className: 'fa fa-download  fa-lg', 'aria-hidden': 'false' }),
								'  Download Report'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'a',
								{ href: 'https://openbudgetsindia.org/organization/sector-specific-state-budget-aggregates', target: '_blank' },
								_react2.default.createElement(
									'button',
									{ type: 'button', value: 'download-dataset', className: 'btn btn-default', id: 'download_dataset' },
									' ',
									_react2.default.createElement('i', { className: 'fa fa-table  fa-lg', 'aria-hidden': 'false' }),
									'  Download Dataset'
								)
							)
						)
					)
				);
			}
		}]);
	
		return RightSidebar;
	}(_react2.default.Component);
	
	RightSidebar.propTypes = {
		viewByChange: _react2.default.PropTypes.func,
		budgetAttrChange: _react2.default.PropTypes.func
	};
	
	exports.default = RightSidebar;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(14);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(65);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(20);
	var toObject = __webpack_require__(15);
	var IObject = __webpack_require__(100);
	var toLength = __webpack_require__(14);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(20);
	var isObject = __webpack_require__(8);
	var invoke = __webpack_require__(251);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(13).f;
	var create = __webpack_require__(66);
	var redefineAll = __webpack_require__(70);
	var ctx = __webpack_require__(36);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var $iterDefine = __webpack_require__(164);
	var step = __webpack_require__(254);
	var setSpecies = __webpack_require__(71);
	var DESCRIPTORS = __webpack_require__(12);
	var fastKey = __webpack_require__(57).fastKey;
	var validate = __webpack_require__(85);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(99);
	var from = __webpack_require__(243);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(70);
	var getWeak = __webpack_require__(57).getWeak;
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var createArrayMethod = __webpack_require__(40);
	var $has = __webpack_require__(26);
	var validate = __webpack_require__(85);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(114);
	var isObject = __webpack_require__(8);
	var toLength = __webpack_require__(14);
	var ctx = __webpack_require__(36);
	var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(12) && !__webpack_require__(7)(function () {
	  return Object.defineProperty(__webpack_require__(157)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 251 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(8);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(166);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 256 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 257 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(118);
	var pIE = __webpack_require__(101);
	var toObject = __webpack_require__(15);
	var IObject = __webpack_require__(100);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(68);
	
	module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(29);
	var gOPN = __webpack_require__(67).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(26);
	var toIObject = __webpack_require__(29);
	var arrayIndexOf = __webpack_require__(110)(false);
	var IE_PROTO = __webpack_require__(170)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(68);
	var toIObject = __webpack_require__(29);
	var isEnum = __webpack_require__(101).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(67);
	var gOPS = __webpack_require__(118);
	var anObject = __webpack_require__(4);
	var Reflect = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat;
	var $trim = __webpack_require__(84).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(174) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt;
	var $trim = __webpack_require__(84).trim;
	var ws = __webpack_require__(174);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(168);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(14);
	var repeat = __webpack_require__(173);
	var defined = __webpack_require__(41);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(43);
	var toLength = __webpack_require__(14);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(9);


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(246);
	var validate = __webpack_require__(85);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(111)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(13).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(113)
	});


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(246);
	var validate = __webpack_require__(85);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(111)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(40)(0);
	var redefine = __webpack_require__(24);
	var meta = __webpack_require__(57);
	var assign = __webpack_require__(258);
	var weak = __webpack_require__(248);
	var isObject = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var validate = __webpack_require__(85);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(111)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ Version 1.1.6. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	var enclose = function(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(b, a, c) {
	  var dx = b.x - a.x, x, a2,
	      dy = b.y - a.y, y, b2,
	      d2 = dx * dx + dy * dy;
	  if (d2) {
	    a2 = a.r + c.r, a2 *= a2;
	    b2 = b.r + c.r, b2 *= b2;
	    if (a2 > b2) {
	      x = (d2 + b2 - a2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	      c.x = b.x - x * dx - y * dy;
	      c.y = b.y - x * dy + y * dx;
	    } else {
	      x = (d2 + a2 - b2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	      c.x = a.x + x * dx - y * dy;
	      c.y = a.y + x * dy + y * dx;
	    }
	  } else {
	    c.x = a.x + c.r;
	    c.y = a.y;
	  }
	}
	
	function intersects(a, b) {
	  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = ((function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}))(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = ((function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}))(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(591);
	var isArguments = __webpack_require__(590);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 278 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(45);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 280 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(127);
	
	var _DOMUtils = __webpack_require__(181);
	
	var _createHistory = __webpack_require__(286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(86);
	
	var _PathUtils = __webpack_require__(74);
	
	var _ExecutionEnvironment = __webpack_require__(127);
	
	var _DOMUtils = __webpack_require__(181);
	
	var _DOMStateStorage = __webpack_require__(283);
	
	var _createDOMHistory = __webpack_require__(284);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(277);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(74);
	
	var _AsyncUtils = __webpack_require__(610);
	
	var _Actions = __webpack_require__(86);
	
	var _createLocation2 = __webpack_require__(612);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(183);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(182);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(127);
	
	var _PathUtils = __webpack_require__(74);
	
	var _runTransitionHook = __webpack_require__(183);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(182);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(652),
	    isArguments = __webpack_require__(200),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(202),
	    isIndex = __webpack_require__(194),
	    isTypedArray = __webpack_require__(310);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 291 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(296);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(186),
	    arrayEach = __webpack_require__(289),
	    assignValue = __webpack_require__(188),
	    baseAssign = __webpack_require__(625),
	    baseAssignIn = __webpack_require__(626),
	    cloneBuffer = __webpack_require__(657),
	    copyArray = __webpack_require__(662),
	    copySymbols = __webpack_require__(663),
	    copySymbolsIn = __webpack_require__(664),
	    getAllKeys = __webpack_require__(300),
	    getAllKeysIn = __webpack_require__(301),
	    getTag = __webpack_require__(133),
	    initCloneArray = __webpack_require__(680),
	    initCloneByTag = __webpack_require__(681),
	    initCloneObject = __webpack_require__(682),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(202),
	    isMap = __webpack_require__(718),
	    isObject = __webpack_require__(76),
	    isSet = __webpack_require__(720),
	    keys = __webpack_require__(91);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(630),
	    createBaseEach = __webpack_require__(666);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(187),
	    isArray = __webpack_require__(31);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(619),
	    arraySome = __webpack_require__(624),
	    cacheHas = __webpack_require__(655);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(716),
	    overRest = __webpack_require__(701),
	    setToString = __webpack_require__(706);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 299 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(295),
	    getSymbols = __webpack_require__(193),
	    keys = __webpack_require__(91);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(295),
	    getSymbolsIn = __webpack_require__(302),
	    keysIn = __webpack_require__(311);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(187),
	    getPrototype = __webpack_require__(192),
	    getSymbols = __webpack_require__(193),
	    stubArray = __webpack_require__(313);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(76);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 304 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 305 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 306 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(289),
	    baseEach = __webpack_require__(294),
	    castFunction = __webpack_require__(656),
	    isArray = __webpack_require__(31);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(631),
	    hasPath = __webpack_require__(674);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(189);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(638),
	    baseUnary = __webpack_require__(190),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(290),
	    baseKeysIn = __webpack_require__(641),
	    isArrayLike = __webpack_require__(201);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(291),
	    baseClone = __webpack_require__(293),
	    baseUnset = __webpack_require__(654),
	    castPath = __webpack_require__(89),
	    copyObject = __webpack_require__(103),
	    customOmitClone = __webpack_require__(668),
	    flatRest = __webpack_require__(298),
	    getAllKeysIn = __webpack_require__(301);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(653);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _PropTypes = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	      var state = _props.state;
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	      this.context.router.push(location);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _PatternUtils = __webpack_require__(95);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(141);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(128);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(287);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(613);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(320);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(128);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(287);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stripDiacritics = __webpack_require__(323);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2['default'])(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	module.exports = filterOptions;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(109);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption;
		var instancePrefix = _ref.instancePrefix;
		var labelKey = _ref.labelKey;
		var onFocus = _ref.onFocus;
		var onSelect = _ref.onSelect;
		var optionClassName = _ref.optionClassName;
		var optionComponent = _ref.optionComponent;
		var optionRenderer = _ref.optionRenderer;
		var options = _ref.options;
		var valueArray = _ref.valueArray;
		var valueKey = _ref.valueKey;
		var onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2['default'])(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2['default'].createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function (ref) {
						onOptionRef(ref, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	module.exports = menuRenderer;

/***/ },
/* 323 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _discreteColorLegendItem = __webpack_require__(789);
	
	var _discreteColorLegendItem2 = _interopRequireDefault(_discreteColorLegendItem);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.shape({
	    title: _react2.default.PropTypes.string.isRequired,
	    color: _react2.default.PropTypes.string,
	    disabled: _react2.default.PropTypes.bool
	  }), _react2.default.PropTypes.string.isRequired])).isRequired,
	  onItemClick: _react2.default.PropTypes.func,
	  height: _react2.default.PropTypes.number,
	  width: _react2.default.PropTypes.number,
	  orientation: _react2.default.PropTypes.oneOf(['vertical', 'horizontal'])
	};
	
	var defaultProps = {
	  className: '',
	  colors: _theme.DISCRETE_COLOR_RANGE,
	  orientation: 'vertical'
	};
	
	function fillItemsWithDefaults(items) {
	  return items.map(function (item, i) {
	    return {
	      title: item.title ? item.title : item,
	      color: item.color ? item.color : _theme.DISCRETE_COLOR_RANGE[i % _theme.DISCRETE_COLOR_RANGE.length],
	      disabled: Boolean(item.disabled)
	    };
	  });
	}
	
	function DiscreteColorLegend(_ref) {
	  var initialItems = _ref.items,
	      width = _ref.width,
	      height = _ref.height,
	      onItemClick = _ref.onItemClick,
	      orientation = _ref.orientation,
	      className = _ref.className;
	
	  var updatedItems = fillItemsWithDefaults(initialItems);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'rv-discrete-color-legend ' + orientation + ' ' + className,
	      style: { width: width, height: height } },
	    updatedItems.map(function (item, i) {
	      return _react2.default.createElement(_discreteColorLegendItem2.default, _extends({}, item, {
	        orientation: orientation,
	        key: i,
	        onClick: onItemClick ? function () {
	          return onItemClick(initialItems[i], i);
	        } : null }));
	    })
	  );
	}
	
	DiscreteColorLegend.displayName = 'DiscreteColorLegendItem';
	DiscreteColorLegend.propTypes = propTypes;
	DiscreteColorLegend.defaultProps = defaultProps;
	
	exports.default = DiscreteColorLegend;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _axisUtils = __webpack_require__(38);
	
	var _axisLine = __webpack_require__(792);
	
	var _axisLine2 = _interopRequireDefault(_axisLine);
	
	var _axisTicks = __webpack_require__(793);
	
	var _axisTicks2 = _interopRequireDefault(_axisTicks);
	
	var _axisTitle = __webpack_require__(794);
	
	var _axisTitle2 = _interopRequireDefault(_axisTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  orientation: _react.PropTypes.oneOf([LEFT, RIGHT, TOP, BOTTOM]),
	  attr: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  top: _react.PropTypes.number,
	  left: _react.PropTypes.number,
	  title: _react.PropTypes.string,
	
	  className: _react.PropTypes.string,
	  hideTicks: _react.PropTypes.bool,
	  hideLine: _react.PropTypes.bool,
	  tickLabelAngle: _react.PropTypes.number,
	  tickSize: _react.PropTypes.number,
	  tickSizeInner: _react.PropTypes.number,
	  tickSizeOuter: _react.PropTypes.number,
	  tickPadding: _react.PropTypes.number,
	  tickValues: _react.PropTypes.array,
	  tickFormat: _react.PropTypes.func,
	  tickTotal: _react.PropTypes.number,
	
	  // Not expected to be used by the users.
	  // TODO: Add underscore to these properties later.
	  marginTop: _react.PropTypes.number,
	  marginBottom: _react.PropTypes.number,
	  marginLeft: _react.PropTypes.number,
	  marginRight: _react.PropTypes.number,
	  innerWidth: _react.PropTypes.number,
	  innerHeight: _react.PropTypes.number
	};
	
	var defaultProps = {
	  className: '',
	  tickSize: 6,
	  tickPadding: 8,
	  orientation: BOTTOM
	};
	
	var predefinedClassName = 'rv-xy-plot__axis';
	var VERTICAL_CLASS_NAME = 'rv-xy-plot__axis--vertical';
	var HORIZONTAL_CLASS_NAME = 'rv-xy-plot__axis--horizontal';
	
	var Axis = function (_PureRenderComponent) {
	  _inherits(Axis, _PureRenderComponent);
	
	  function Axis() {
	    _classCallCheck(this, Axis);
	
	    return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
	  }
	
	  _createClass(Axis, [{
	    key: '_getDefaultAxisProps',
	
	
	    /**
	     * Define the default values depending on the data passed from the outside.
	     * @returns {*} Object of default properties.
	     * @private
	     */
	    value: function _getDefaultAxisProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginBottom = _props.marginBottom,
	          marginLeft = _props.marginLeft,
	          marginRight = _props.marginRight,
	          orientation = _props.orientation;
	
	      if (orientation === BOTTOM) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: innerHeight + marginTop,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginBottom
	        };
	      } else if (orientation === TOP) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: 0,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginTop
	        };
	      } else if (orientation === LEFT) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	          top: marginTop,
	          left: 0,
	          width: marginLeft,
	          height: innerHeight
	        };
	      }
	      return {
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	        top: marginTop,
	        left: marginLeft + innerWidth,
	        width: marginRight,
	        height: innerHeight
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(Axis, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultAxisProps(), this.props);
	
	      var className = props.className,
	          height = props.height,
	          hideLine = props.hideLine,
	          hideTicks = props.hideTicks,
	          left = props.left,
	          orientation = props.orientation,
	          title = props.title,
	          top = props.top,
	          width = props.width;
	
	      var isVertical = [LEFT, RIGHT].indexOf(orientation) > -1;
	      var axisClassName = isVertical ? VERTICAL_CLASS_NAME : HORIZONTAL_CLASS_NAME;
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + left + ',' + top + ')',
	          className: predefinedClassName + ' ' + axisClassName + ' ' + className },
	        !hideLine && _react2.default.createElement(_axisLine2.default, {
	          height: height,
	          width: width,
	          orientation: orientation }),
	        !hideTicks && _react2.default.createElement(_axisTicks2.default, props),
	        title ? _react2.default.createElement(_axisTitle2.default, {
	          title: title,
	          height: height,
	          width: width,
	          orientation: orientation }) : null
	      );
	    }
	  }]);
	
	  return Axis;
	}(_pureRenderComponent2.default);
	
	Axis.displayName = 'Axis';
	Axis.propTypes = propTypes;
	Axis.defaultProps = defaultProps;
	Axis.requiresSVG = true;
	
	exports.default = Axis;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _d3Shape = __webpack_require__(143);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--arc';
	var ATTRIBUTES = ['radius', 'angle'];
	
	var defaultProps = {
	  center: { x: 0, y: 0 },
	  className: ''
	};
	
	var ArcSeries = function (_AbstractSeries) {
	  _inherits(ArcSeries, _AbstractSeries);
	
	  function ArcSeries(props) {
	    _classCallCheck(this, ArcSeries);
	
	    var _this = _possibleConstructorReturn(this, (ArcSeries.__proto__ || Object.getPrototypeOf(ArcSeries)).call(this, props));
	
	    var scaleProps = _this._getAllScaleProps(props);
	    _this.state = { scaleProps: scaleProps };
	    return _this;
	  }
	
	  _createClass(ArcSeries, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ scaleProps: this._getAllScaleProps(nextProps) });
	    }
	
	    /**
	     * Get the map of scales from the props.
	     * @param {Object} props Props.
	     * @param {Array} data Array of all data.
	     * @returns {Object} Map of scales.
	     * @private
	     */
	
	  }, {
	    key: '_getAllScaleProps',
	    value: function _getAllScaleProps(props) {
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), props.data, ATTRIBUTES);
	
	      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps);
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var innerWidth = props.innerWidth,
	          innerHeight = props.innerHeight;
	
	      var radius = Math.min(innerWidth / 2, innerHeight / 2);
	      return {
	        radiusRange: [0, radius],
	        _radiusValue: radius,
	        angleType: 'literal'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          center = _props.center,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          _props$style = _props.style,
	          style = _props$style === undefined ? {} : _props$style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(ArcSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var scaleProps = this.state.scaleProps;
	      var radiusDomain = scaleProps.radiusDomain;
	      // need to generate our own functors as abstract series doesnt have anythign for us
	
	      var radiusFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'radius');
	      var radius0Functor = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'radius');
	      var angleFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'angle');
	      var angle0Functor = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'angle');
	
	      // but it does have good color support!
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      var xTranslate = xFunctor(center);
	      var yTranslate = yFunctor(center);
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          onMouseOver: this._seriesMouseOverHandler,
	          onMouseOut: this._seriesMouseOutHandler,
	          onClick: this._seriesClickHandler,
	          ref: 'container',
	          transform: 'translate(' + (marginLeft + xTranslate) + ',' + (marginTop + yTranslate) + ')' },
	        data.map(function (row, i) {
	          var noRadius = radiusDomain[1] === radiusDomain[0];
	          var arcArg = {
	            innerRadius: noRadius ? 0 : radius0Functor(row),
	            outerRadius: radiusFunctor(row),
	            startAngle: angle0Functor(row) || 0,
	            endAngle: angleFunctor(row)
	          };
	          var arcedData = (0, _d3Shape.arc)();
	          var rowStyle = row.style || {};
	          return _react2.default.createElement('path', {
	            style: _extends({
	              opacity: opacityFunctor && opacityFunctor(row),
	              stroke: strokeFunctor && strokeFunctor(row),
	              fill: fillFunctor && fillFunctor(row)
	            }, style, rowStyle),
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(row, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(row, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(row, e);
	            },
	            key: i,
	            d: arcedData(arcArg)
	          });
	        })
	      );
	    }
	  }]);
	
	  return ArcSeries;
	}(_abstractSeries2.default);
	
	ArcSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, (0, _scalesUtils.getScalePropTypesByAttribute)('radius'), (0, _scalesUtils.getScalePropTypesByAttribute)('angle'), {
	  center: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number
	  })
	});
	ArcSeries.defaultProps = defaultProps;
	ArcSeries.displayName = 'ArcSeries';
	
	exports.default = ArcSeries;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--bar';
	
	var BarSeries = function (_AbstractSeries) {
	  _inherits(BarSeries, _AbstractSeries);
	
	  function BarSeries() {
	    _classCallCheck(this, BarSeries);
	
	    return _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).apply(this, arguments));
	  }
	
	  _createClass(BarSeries, [{
	    key: '_getStackParams',
	    value: function _getStackParams() {
	      var _props = this.props,
	          _stackBy = _props._stackBy,
	          valuePosAttr = _props.valuePosAttr,
	          cluster = _props.cluster;
	      var _props2 = this.props,
	          _props2$sameTypeTotal = _props2.sameTypeTotal,
	          sameTypeTotal = _props2$sameTypeTotal === undefined ? 1 : _props2$sameTypeTotal,
	          _props2$sameTypeIndex = _props2.sameTypeIndex,
	          sameTypeIndex = _props2$sameTypeIndex === undefined ? 0 : _props2$sameTypeIndex;
	
	      // If bars are stacked, but not clustering, override `sameTypeTotal` and
	      // `sameTypeIndex` such that bars are stacked and not staggered.
	
	      if (_stackBy === valuePosAttr && !cluster) {
	        sameTypeTotal = 1;
	        sameTypeIndex = 0;
	      }
	      return { sameTypeTotal: sameTypeTotal, sameTypeIndex: sameTypeIndex };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          animation = _props3.animation,
	          className = _props3.className,
	          data = _props3.data,
	          linePosAttr = _props3.linePosAttr,
	          lineSizeAttr = _props3.lineSizeAttr,
	          marginLeft = _props3.marginLeft,
	          marginTop = _props3.marginTop,
	          valuePosAttr = _props3.valuePosAttr,
	          valueSizeAttr = _props3.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(BarSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _getStackParams2 = this._getStackParams(),
	          sameTypeTotal = _getStackParams2.sameTypeTotal,
	          sameTypeIndex = _getStackParams2.sameTypeIndex;
	
	      var distance = this._getScaleDistance(linePosAttr);
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      var itemSize = distance / 2 * 0.85;
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: {
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }
	          }, _defineProperty(_attrs, linePosAttr, lineFunctor(d) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex), _defineProperty(_attrs, lineSizeAttr, itemSize * 2 / sameTypeTotal), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _react2.default.PropTypes.string,
	        valuePosAttr: _react2.default.PropTypes.string,
	        lineSizeAttr: _react2.default.PropTypes.string,
	        valueSizeAttr: _react2.default.PropTypes.string,
	        cluster: _react2.default.PropTypes.string
	      });
	    }
	  }]);
	
	  return BarSeries;
	}(_abstractSeries2.default);
	
	BarSeries.displayName = 'BarSeries';
	
	exports.default = BarSeries;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(143);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(48);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var STROKE_STYLES = {
	  dashed: '6, 2',
	  solid: null
	};
	
	var defaultProps = {
	  strokeStyle: 'solid',
	  opacity: 1,
	  curve: null
	};
	
	var propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeStyle: _react2.default.PropTypes.oneOf(Object.keys(STROKE_STYLES)),
	  curve: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func])
	});
	
	var LineSeries = function (_AbstractSeries) {
	  _inherits(LineSeries, _AbstractSeries);
	
	  function LineSeries() {
	    _classCallCheck(this, LineSeries);
	
	    return _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineSeries, [{
	    key: '_renderLine',
	    value: function _renderLine(data, x, y, curve) {
	      var line = d3Shape.line();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          line = line.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          line = line.curve(curve);
	        }
	      }
	      line = line.x(x).y(y);
	      return line(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(LineSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _props2 = this.props,
	          strokeDasharray = _props2.strokeDasharray,
	          strokeStyle = _props2.strokeStyle,
	          strokeWidth = _props2.strokeWidth,
	          marginLeft = _props2.marginLeft,
	          marginTop = _props2.marginTop,
	          curve = _props2.curve;
	
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var d = this._renderLine(data, x, y, curve);
	
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        style: {
	          opacity: opacity,
	          strokeDasharray: STROKE_STYLES[strokeStyle] || strokeDasharray,
	          strokeWidth: strokeWidth,
	          stroke: stroke
	        } });
	    }
	  }]);
	
	  return LineSeries;
	}(_abstractSeries2.default);
	
	LineSeries.displayName = 'LineSeries';
	LineSeries.defaultProps = defaultProps;
	LineSeries.propTypes = propTypes;
	
	exports.default = LineSeries;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _theme = __webpack_require__(48);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--mark';
	var DEFAULT_STROKE_WIDTH = 1;
	
	var MarkSeries = function (_AbstractSeries) {
	  _inherits(MarkSeries, _AbstractSeries);
	
	  function MarkSeries() {
	    _classCallCheck(this, MarkSeries);
	
	    return _possibleConstructorReturn(this, (MarkSeries.__proto__ || Object.getPrototypeOf(MarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          strokeWidth = _props.strokeWidth;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(MarkSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var sizeFunctor = this._getAttributeFunctor('size');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var attrs = {
	            r: sizeFunctor ? sizeFunctor(d) : _theme.DEFAULT_SIZE,
	            cx: xFunctor(d),
	            cy: yFunctor(d),
	            style: {
	              opacity: opacityFunctor ? opacityFunctor(d) : _theme.DEFAULT_OPACITY,
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d),
	              strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
	            },
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            }
	          };
	          return _react2.default.createElement('circle', attrs);
	        })
	      );
	    }
	  }]);
	
	  return MarkSeries;
	}(_abstractSeries2.default);
	
	MarkSeries.displayName = 'MarkSeries';
	MarkSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeWidth: _react.PropTypes.number
	});
	exports.default = MarkSeries;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Voronoi = __webpack_require__(276);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	function Voronoi(_ref) {
	  var className = _ref.className,
	      extent = _ref.extent,
	      nodes = _ref.nodes,
	      onBlur = _ref.onBlur,
	      _onClick = _ref.onClick,
	      onHover = _ref.onHover,
	      polygonStyle = _ref.polygonStyle,
	      style = _ref.style,
	      x = _ref.x,
	      y = _ref.y;
	
	  // Create a voronoi with each node center points
	  var voronoiInstance = (0, _d3Voronoi.voronoi)().x(x).y(y).extent(extent);
	
	  return _react2.default.createElement(
	    'g',
	    { className: className + ' rv-voronoi', style: style },
	    voronoiInstance.polygons(nodes).map(function (d, i) {
	      return _react2.default.createElement('path', {
	        className: 'rv-voronoi__cell',
	        d: 'M' + d.join('L') + 'Z',
	        onClick: function onClick() {
	          return _onClick(d.data);
	        },
	        onMouseOver: function onMouseOver() {
	          return onHover(d.data);
	        },
	        onMouseOut: function onMouseOut() {
	          return onBlur(d.data);
	        },
	        fill: 'none',
	        style: _extends({
	          pointerEvents: 'all'
	        }, polygonStyle),
	        key: i });
	    })
	  );
	}
	
	Voronoi.requiresSVG = true;
	
	Voronoi.defaultProps = {
	  className: '',
	  onBlur: NOOP,
	  onClick: NOOP,
	  onHover: NOOP,
	  x: function x(d) {
	    return d.x;
	  },
	  y: function y(d) {
	    return d.y;
	  }
	};
	
	Voronoi.propTypes = {
	  className: _react.PropTypes.string,
	  extent: _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.number)).isRequired,
	  nodes: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onHover: _react.PropTypes.func,
	  x: _react.PropTypes.func,
	  y: _react.PropTypes.func
	};
	
	exports.default = Voronoi;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(277);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _scalesUtils = __webpack_require__(32);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _chartUtils = __webpack_require__(332);
	
	var _animation = __webpack_require__(19);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['x', 'y', 'radius', 'angle', 'color', 'fill', 'stroke', 'opacity', 'size'];
	
	var DEFAULT_MARGINS = {
	  left: 40,
	  right: 10,
	  top: 10,
	  bottom: 40
	};
	
	/**
	 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
	 * that has circular structures, so we make every node single directional by pruning the parents.
	 * @param {Array} data - the data object to have circular deps resolved in
	 * @returns {Array} the sanitized data
	 */
	function cleanseData(data) {
	  return data.map(function (series) {
	    if (!Array.isArray(series)) {
	      return series;
	    }
	    return series.map(function (row) {
	      return _extends({}, row, { parent: null });
	    });
	  });
	}
	
	/**
	 * Wrapper on the deep-equal method for checking equality of next props vs current props
	 * @param {Object} scaleMixins - Scale object.
	 * @param {Object} nextScaleMixins - Scale object.
	 * @returns {Boolean} whether or not the two mixins objects are equal
	 */
	function checkIfMixinsAreEqual(nextScaleMixins, scaleMixins) {
	  var newMixins = _extends({}, nextScaleMixins, {
	    _allData: cleanseData(nextScaleMixins._allData)
	  });
	  var oldMixins = _extends({}, scaleMixins, {
	    _allData: cleanseData(scaleMixins._allData)
	  });
	  // it's hard to say if this function is reasonable?
	  return (0, _deepEqual2.default)(newMixins, oldMixins);
	}
	
	var XYPlot = function (_React$Component) {
	  _inherits(XYPlot, _React$Component);
	
	  _createClass(XYPlot, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _react2.default.PropTypes.string,
	        height: _react2.default.PropTypes.number.isRequired,
	        margin: _chartUtils.MarginPropType,
	        onMouseDown: _react2.default.PropTypes.func,
	        onMouseEnter: _react2.default.PropTypes.func,
	        onMouseLeave: _react2.default.PropTypes.func,
	        onMouseMove: _react2.default.PropTypes.func,
	        stackBy: _react2.default.PropTypes.oneOf(ATTRIBUTES),
	        width: _react2.default.PropTypes.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: ''
	      };
	    }
	  }]);
	
	  function XYPlot(props) {
	    _classCallCheck(this, XYPlot);
	
	    var _this = _possibleConstructorReturn(this, (XYPlot.__proto__ || Object.getPrototypeOf(XYPlot)).call(this, props));
	
	    _this._mouseDownHandler = _this._mouseDownHandler.bind(_this);
	    _this._mouseLeaveHandler = _this._mouseLeaveHandler.bind(_this);
	    _this._mouseEnterHandler = _this._mouseEnterHandler.bind(_this);
	    _this._mouseMoveHandler = _this._mouseMoveHandler.bind(_this);
	    var stackBy = props.stackBy;
	
	    var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	    var data = (0, _seriesUtils.getStackedData)(children, stackBy);
	    _this.state = {
	      scaleMixins: _this._getScaleMixins(data, props),
	      data: data
	    };
	    return _this;
	  }
	
	  _createClass(XYPlot, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var children = (0, _seriesUtils.getSeriesChildren)(nextProps.children);
	      var nextData = (0, _seriesUtils.getStackedData)(children, nextProps.stackBy);
	      var scaleMixins = this.state.scaleMixins;
	
	      var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
	      if (!checkIfMixinsAreEqual(nextScaleMixins, scaleMixins)) {
	        this.setState({
	          scaleMixins: nextScaleMixins,
	          data: nextData
	        });
	      }
	    }
	
	    /**
	     * Trigger mouse-down related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse down event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseDownHandler',
	    value: function _mouseDownHandler(event) {
	      var _this2 = this;
	
	      var _props = this.props,
	          onMouseDown = _props.onMouseDown,
	          children = _props.children;
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this2.refs['series' + index];
	        if (component && component.onParentMouseDown) {
	          component.onParentMouseDown(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger movement-related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse move event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseMoveHandler',
	    value: function _mouseMoveHandler(event) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          children = _props2.children;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this3.refs['series' + index];
	        if (component && component.onParentMouseMove) {
	          component.onParentMouseMove(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger onMouseLeave handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseLeaveHandler',
	    value: function _mouseLeaveHandler(event) {
	      var onMouseLeave = this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave({ event: event });
	      }
	    }
	
	    /**
	     * Trigger onMouseEnter handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseEnterHandler',
	    value: function _mouseEnterHandler(event) {
	      var onMouseEnter = this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter({ event: event });
	      }
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)(props, DEFAULT_MARGINS),
	          innerWidth = _getInnerDimensions.innerWidth,
	          innerHeight = _getInnerDimensions.innerHeight;
	
	      return {
	        xRange: [0, innerWidth],
	        yRange: [innerHeight, 0],
	        colorRange: _theme.CONTINUOUS_COLOR_RANGE,
	        opacityType: _theme.OPACITY_TYPE,
	        sizeRange: _theme.SIZE_RANGE
	      };
	    }
	
	    /**
	     * Get the map of scales from the props, apply defaults to them and then pass
	     * them further.
	     * @param {Object} data Array of all data.
	     * @param {Object} props Props of the component.
	     * @returns {Object} Map of scale-related props.
	     * @private
	     */
	
	  }, {
	    key: '_getScaleMixins',
	    value: function _getScaleMixins(data, props) {
	      var _ref;
	
	      var filteredData = data.filter(function (d) {
	        return d;
	      });
	      var allData = (_ref = []).concat.apply(_ref, _toConsumableArray(filteredData));
	
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), allData, ATTRIBUTES);
	      var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	      var zeroBaseProps = {};
	      var adjustBy = new Set();
	      var adjustWhat = new Set();
	      children.forEach(function (child, index) {
	        if (!child || !data[index]) {
	          return;
	        }
	        ATTRIBUTES.forEach(function (attr) {
	          var _child$type$getParent = child.type.getParentConfig(attr, child.props),
	              isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded,
	              zeroBaseValue = _child$type$getParent.zeroBaseValue;
	
	          if (isDomainAdjustmentNeeded) {
	            adjustBy.add(attr);
	            adjustWhat.add(index);
	          }
	          if (zeroBaseValue) {
	            zeroBaseProps[attr + 'BaseValue'] = 0;
	          }
	        });
	      });
	      return _extends({}, defaultScaleProps, zeroBaseProps, userScaleProps, missingScaleProps, {
	        _allData: data,
	        _adjustBy: Array.from(adjustBy),
	        _adjustWhat: Array.from(adjustWhat),
	        _stackBy: props.stackBy
	      });
	    }
	
	    /**
	     * Checks if the plot is empty or not.
	     * Currently checks the data only.
	     * @returns {boolean} True for empty.
	     * @private
	     */
	
	  }, {
	    key: '_isPlotEmpty',
	    value: function _isPlotEmpty() {
	      var data = this.state.data;
	
	      return !data || !data.length || !data.some(function (series) {
	        return series && series.some(function (d) {
	          return d;
	        });
	      });
	    }
	
	    /**
	     * Prepare the child components (including series) for rendering.
	     * @returns {Array} Array of child components.
	     * @private
	     */
	
	  }, {
	    key: '_getClonedChildComponents',
	    value: function _getClonedChildComponents() {
	      var animation = this.props.animation;
	      var _state = this.state,
	          scaleMixins = _state.scaleMixins,
	          data = _state.data;
	
	      var dimensions = (0, _chartUtils.getInnerDimensions)(this.props, DEFAULT_MARGINS);
	      var children = _react2.default.Children.toArray(this.props.children);
	      var seriesProps = (0, _seriesUtils.getSeriesPropsFromChildren)(children);
	      return children.map(function (child, index) {
	        var dataProps = null;
	        if (seriesProps[index]) {
	          // Get the index of the series in the list of props and retrieve
	          // the data property from it.
	          var seriesIndex = seriesProps[index].seriesIndex;
	
	          dataProps = { data: data[seriesIndex] };
	        }
	        return _react2.default.cloneElement(child, _extends({}, dimensions, {
	          animation: animation
	        }, seriesProps[index], scaleMixins, child.props, dataProps));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      if (this._isPlotEmpty()) {
	        return _react2.default.createElement('div', {
	          className: 'rv-xy-plot ' + className,
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          } });
	      }
	      var components = this._getClonedChildComponents();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          },
	          className: 'rv-xy-plot ' + className },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'rv-xy-plot__inner',
	            width: width,
	            height: height,
	            onMouseDown: this._mouseDownHandler,
	            onMouseMove: this._mouseMoveHandler,
	            onMouseLeave: this._mouseLeaveHandler,
	            onMouseEnter: this._mouseEnterHandler },
	          components.filter(function (c) {
	            return c && c.type.requiresSVG;
	          })
	        ),
	        components.filter(function (c) {
	          return c && !c.type.requiresSVG;
	        })
	      );
	    }
	  }]);
	
	  return XYPlot;
	}(_react2.default.Component);
	
	XYPlot.displayName = 'XYPlot';
	
	exports.default = XYPlot;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MarginPropType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.getInnerDimensions = getInnerDimensions;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the dimensions of the component for the future use.
	 * @param {Object} props Props.
	 * @param {Object} defaultMargins Object with default margins.
	 * @returns {Object} Dimensions of the component.
	 */
	function getInnerDimensions(props, defaultMargins) {
	  var margin = props.margin,
	      width = props.width,
	      height = props.height;
	
	  var marginProps = _extends({}, defaultMargins, typeof margin === 'number' ? {
	    left: margin,
	    right: margin,
	    top: margin,
	    bottom: margin
	  } : margin);
	  var _marginProps$left = marginProps.left,
	      marginLeft = _marginProps$left === undefined ? 0 : _marginProps$left,
	      _marginProps$top = marginProps.top,
	      marginTop = _marginProps$top === undefined ? 0 : _marginProps$top,
	      _marginProps$right = marginProps.right,
	      marginRight = _marginProps$right === undefined ? 0 : _marginProps$right,
	      _marginProps$bottom = marginProps.bottom,
	      marginBottom = _marginProps$bottom === undefined ? 0 : _marginProps$bottom;
	
	  return {
	    marginLeft: marginLeft,
	    marginTop: marginTop,
	    marginRight: marginRight,
	    marginBottom: marginBottom,
	    innerHeight: height - marginBottom - marginTop,
	    innerWidth: width - marginLeft - marginRight
	  };
	}
	
	var MarginPropType = exports.MarginPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.shape({
	  left: _react2.default.PropTypes.number,
	  top: _react2.default.PropTypes.number,
	  right: _react2.default.PropTypes.number,
	  bottom: _react2.default.PropTypes.number
	}), _react2.default.PropTypes.number]);

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDOMNode = exports.isReactDOMSupported = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.warning = warning;
	exports.warnOnce = warnOnce;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$version$split = _react2.default.version.split('.'),
	    _React$version$split2 = _slicedToArray(_React$version$split, 2),
	    major = _React$version$split2[0],
	    minor = _React$version$split2[1];
	
	var versionHigherThanThirteen = Number(minor) > 13 || Number(major) > 13;
	
	var isReactDOMSupported = exports.isReactDOMSupported = function isReactDOMSupported() {
	  return versionHigherThanThirteen;
	};
	
	/**
	 * Support React 0.13 and greater where refs are React components, not DOM
	 * nodes.
	 * @param {*} ref React's ref.
	 * @returns {Element} DOM element.
	 */
	var getDOMNode = exports.getDOMNode = function getDOMNode(ref) {
	  if (!isReactDOMSupported()) {
	    return ref && ref.getDOMNode();
	  }
	  return ref;
	};
	
	var USED_MESSAGES = {};
	var HIDDEN_PROCESSES = {
	  test: true,
	  production: true
	};
	
	/**
	 * Warn the user about something
	 * @param {String} message - the message to be shown
	 * @param {Boolean} onlyShowMessageOnce - whether or not we allow the
	 - message to be show multiple times
	 */
	function warning(message) {
	  var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  /* eslint-disable no-undef, no-process-env */
	  if (process && HIDDEN_PROCESSES[("production")]) {
	    return;
	  }
	  /* eslint-enable no-undef, no-process-env */
	  if (!onlyShowMessageOnce || !USED_MESSAGES[message]) {
	    /* eslint-disable no-console */
	    console.warn(message);
	    /* eslint-enable no-console */
	    USED_MESSAGES[message] = true;
	  }
	}
	
	/**
	 * Convience wrapper for warning
	 * @param {String} message - the message to be shown
	 */
	function warnOnce(message) {
	  warning(message, true);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(214)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(334), __webpack_require__(335), __webpack_require__(336), __webpack_require__(816), __webpack_require__(338), __webpack_require__(818), __webpack_require__(214)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 340 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(81);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(81);
	var ReactElement = __webpack_require__(39);
	
	var emptyFunction = __webpack_require__(45);
	var traverseAllChildren = __webpack_require__(236);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactComponent = __webpack_require__(344);
	var ReactElement = __webpack_require__(39);
	var ReactPropTypeLocations = __webpack_require__(150);
	var ReactPropTypeLocationNames = __webpack_require__(149);
	var ReactNoopUpdateQueue = __webpack_require__(356);
	
	var emptyObject = __webpack_require__(102);
	var invariant = __webpack_require__(3);
	var keyMirror = __webpack_require__(126);
	var keyOf = __webpack_require__(58);
	var warning = __webpack_require__(6);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.') : invariant(false) : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(356);
	var ReactInstrumentation = __webpack_require__(148);
	
	var canDefineProperty = __webpack_require__(227);
	var emptyObject = __webpack_require__(102);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : void 0;
	  if (false) {
	    ReactInstrumentation.debugTool.onSetState();
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(218);
	var ReactDOMIDOperations = __webpack_require__(847);
	var ReactPerf = __webpack_require__(33);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	ReactPerf.measureMethods(ReactComponentBrowserEnvironment, 'ReactComponentBrowserEnvironment', {
	  replaceNodeWithMarkup: 'replaceNodeWithMarkup'
	});
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 346 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DisabledInputUtils = __webpack_require__(145);
	var LinkedValueUtils = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(49);
	
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `select` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getNativeProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getNativeProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(39);
	var ReactPropTypeLocations = __webpack_require__(150);
	var ReactPropTypeLocationNames = __webpack_require__(149);
	var ReactCurrentOwner = __webpack_require__(63);
	
	var canDefineProperty = __webpack_require__(227);
	var getIteratorFn = __webpack_require__(232);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : void 0;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : void 0;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 349 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 350 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(851);
	
	var containsNode = __webpack_require__(598);
	var focusNode = __webpack_require__(280);
	var getActiveElement = __webpack_require__(281);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(97);
	var DOMProperty = __webpack_require__(80);
	var ReactBrowserEventEmitter = __webpack_require__(147);
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMContainerInfo = __webpack_require__(842);
	var ReactDOMFeatureFlags = __webpack_require__(846);
	var ReactElement = __webpack_require__(39);
	var ReactFeatureFlags = __webpack_require__(350);
	var ReactInstrumentation = __webpack_require__(148);
	var ReactMarkupChecksum = __webpack_require__(863);
	var ReactPerf = __webpack_require__(33);
	var ReactReconciler = __webpack_require__(98);
	var ReactUpdateQueue = __webpack_require__(358);
	var ReactUpdates = __webpack_require__(49);
	
	var emptyObject = __webpack_require__(102);
	var instantiateReactComponent = __webpack_require__(365);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(234);
	var shouldUpdateReactComponent = __webpack_require__(235);
	var warning = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  ReactReconciler.unmountComponent(instance, safely);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._nativeParent);
	  }
	}
	
	function getNativeRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevNativeInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevNativeInstance && !prevNativeInstance._nativeParent ? prevNativeInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getNativeRootInstanceInContainer(container);
	  return root ? root._nativeContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	  }
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(126);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(39);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  NATIVE: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.NATIVE;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : invariant(false) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(39);
	var ReactPropTypeLocationNames = __webpack_require__(149);
	
	var emptyFunction = __webpack_require__(45);
	var getIteratorFn = __webpack_require__(232);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactUpdates = __webpack_require__(49);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : invariant(false) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 359 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.0.2';

/***/ },
/* 360 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : void 0;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNativeComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(355);
	
	function getNativeComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.NATIVE) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getNativeComponentFromComposite;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactCompositeComponent = __webpack_require__(838);
	var ReactEmptyComponent = __webpack_require__(349);
	var ReactNativeComponent = __webpack_require__(354);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getNativeNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	var escapeTextContentForBrowser = __webpack_require__(152);
	var setInnerHTML = __webpack_require__(234);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeftSidebar = __webpack_require__(370);
	
	var _LeftSidebar2 = _interopRequireDefault(_LeftSidebar);
	
	var _ConfigMap = __webpack_require__(153);
	
	var _AppController = __webpack_require__(239);
	
	var _AppController2 = _interopRequireDefault(_AppController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
		_inherits(App, _React$Component);
	
		function App() {
			_classCallCheck(this, App);
	
			return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
		}
	
		_createClass(App, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"div",
					{ className: "app-wrapper " },
					_react2.default.createElement(
						"div",
						{ className: "row " },
						_react2.default.createElement(
							"div",
							{ className: "row full-height" },
							_react2.default.createElement(
								"div",
								{ className: "col-sm-3 leftsidebar " },
								_react2.default.createElement(_LeftSidebar2.default, { config: _ConfigMap.appComponents.leftSideBarComponent })
							),
							_react2.default.createElement(
								"div",
								{ className: "col-sm-9 full-height view-container " },
								_react2.default.createElement(
									"div",
									{ className: "container-fluid " },
									this.props.children
								)
							)
						)
					)
				);
			}
		}]);
	
		return App;
	}(_react2.default.Component);
	
	App.propTypes = {
		children: _react.PropTypes.object.isRequired
	};
	
	exports.default = App;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigMap = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexComponent = function IndexComponent() {
		return _react2.default.createElement(
			"div",
			{ className: "col-lg-12" },
			_react2.default.createElement(
				"div",
				{ className: "jumbotron text-center intro-wrapper" },
				_react2.default.createElement(
					"div",
					{ className: "home-header-wrapper" },
					_react2.default.createElement(
						"h1",
						{ className: "home-top-heading" },
						_ConfigMap.homeComponent.primary_header
					),
					_react2.default.createElement(
						"h1",
						{ className: "secondary-top-heading" },
						_ConfigMap.homeComponent.secondary_header
					),
					_react2.default.createElement("hr", { className: "title-hr" })
				),
				_react2.default.createElement(
					"div",
					{ className: "row" },
					_react2.default.createElement(
						"p",
						{ className: "home-description" },
						_ConfigMap.homeComponent.description
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "row" },
					_react2.default.createElement(
						"div",
						{ className: "col-lg-12 contributor_org_wrapper" },
						_ConfigMap.homeComponent.contributor_organizations.map(function (image) {
							return _react2.default.createElement(
								"a",
								{ href: image.link, target: "_blank", key: image.image_name },
								_react2.default.createElement("img", { src: image.url, alt: image.alt, height: image.height })
							);
						})
					)
				)
			)
		);
	};
	
	exports.default = IndexComponent;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(96);
	
	var _TabsPanel = __webpack_require__(371);
	
	var _TabsPanel2 = _interopRequireDefault(_TabsPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeftSidebar = function (_React$Component) {
		_inherits(LeftSidebar, _React$Component);
	
		function LeftSidebar() {
			_classCallCheck(this, LeftSidebar);
	
			return _possibleConstructorReturn(this, (LeftSidebar.__proto__ || Object.getPrototypeOf(LeftSidebar)).apply(this, arguments));
		}
	
		_createClass(LeftSidebar, [{
			key: 'render',
			value: function render() {
				var leftSideBarComponent = this.props.config;
				var logoWrapper = null;
				if (leftSideBarComponent.top_logo.format == "text") {
					logoWrapper = _react2.default.createElement(
						'h2',
						{ className: 'app-title' },
						leftSideBarComponent.top_logo.text_config.text,
						_react2.default.createElement(
							'sub',
							{ className: 'app-version' },
							leftSideBarComponent.top_logo.text_config.release_version
						),
						_react2.default.createElement('hr', { className: 'title-hr' })
					);
				} else if (leftSideBarComponent.top_logo.format == "img") {
					logoWrapper = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('img', { className: 'app-logo', width: leftSideBarComponent.top_logo.img_config.width, src: leftSideBarComponent.top_logo.img_config.source }),
						_react2.default.createElement('hr', { className: 'title-hr' })
					);
				}
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'row-fluid' },
						_react2.default.createElement(
							_reactRouter.IndexLink,
							{ to: '/', className: 'app-logo' },
							logoWrapper
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'select-panel row-fluid' },
						_react2.default.createElement(_TabsPanel2.default, { panelData: leftSideBarComponent.selection_panel.panels })
					),
					_react2.default.createElement(
						'div',
						{ className: 'row-fluid leftsidebar-bottom-logos' },
						leftSideBarComponent.bottom_logo.contributor_organizations.map(function (image) {
							return _react2.default.createElement(
								'a',
								{ href: image.link, target: '_blank', className: 'organization-logo-link', key: image.image_name },
								_react2.default.createElement('img', { src: image.url, alt: image.alt, height: image.height })
							);
						})
					)
				);
			}
		}]);
	
		return LeftSidebar;
	}(_react2.default.Component);
	
	LeftSidebar.propTypes = {
		config: _react2.default.PropTypes.object
	};
	
	exports.default = LeftSidebar;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(96);
	
	__webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = function (_React$Component) {
		_inherits(Tabs, _React$Component);
	
		function Tabs() {
			_classCallCheck(this, Tabs);
	
			return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
		}
	
		_createClass(Tabs, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'ul',
					{ className: 'nav nav-tabs nav-justified' },
					this.props.panelTabs.map(function (tab) {
						return _react2.default.createElement(Tab, { data: tab,
							isActive: this.props.activeTab === tab,
							handleClick: this.props.changeTab.bind(this, tab),
							key: tab.title });
					}.bind(this))
				);
			}
		}]);
	
		return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = {
		activeTab: _react2.default.PropTypes.object,
		panelTabs: _react2.default.PropTypes.array,
		changeTab: _react2.default.PropTypes.func
	};
	
	var Tab = function (_React$Component2) {
		_inherits(Tab, _React$Component2);
	
		function Tab() {
			_classCallCheck(this, Tab);
	
			return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
		}
	
		_createClass(Tab, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'li',
					{ onClick: this.props.handleClick, className: this.props.isActive ? "active" : null },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: "#" },
						' ',
						this.props.data.title
					)
				);
			}
		}]);
	
		return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
		data: _react2.default.PropTypes.object,
		isActive: _react2.default.PropTypes.bool,
		handleClick: _react2.default.PropTypes.func
	};
	
	var Records = function (_React$Component3) {
		_inherits(Records, _React$Component3);
	
		function Records() {
			_classCallCheck(this, Records);
	
			return _possibleConstructorReturn(this, (Records.__proto__ || Object.getPrototypeOf(Records)).apply(this, arguments));
		}
	
		_createClass(Records, [{
			key: 'render',
			value: function render() {
				var props = this.props;
				var heirarchyLevel = this.props.heirarchyLevel;
				var indicatorList = this.props.subRecords.map(function (record) {
					return _react2.default.createElement(
						'g',
						{ key: record.record_slug },
						props.categoryName == "null" ? _react2.default.createElement(
							_reactRouter.Link,
							{ className: 'list-item-single-links', to: "/" + props.panelTitle + "/" + heirarchyLevel + "/" + record.record_slug, key: record.record_slug },
							_react2.default.createElement(
								'li',
								{ className: 'list-group-item', key: record.record_name },
								' ',
								record.record_name
							)
						) : _react2.default.createElement(
							_reactRouter.Link,
							{ className: 'list-item-links', to: "/" + props.panelTitle + "/" + heirarchyLevel + "/" + props.slugCategory + "/" + record.record_slug, key: record.record_slug },
							_react2.default.createElement(
								'li',
								{ className: 'list-group-item', key: record.record_name },
								' ',
								record.record_name
							)
						)
					);
				});
	
				return _react2.default.createElement(
					'ul',
					{ className: 'list-group' },
					indicatorList
				);
			}
		}]);
	
		return Records;
	}(_react2.default.Component);
	
	Records.propTypes = {
		categoryName: _react2.default.PropTypes.string,
		heirarchyLevel: _react2.default.PropTypes.string,
		panelTitle: _react2.default.PropTypes.string,
		slugCategory: _react2.default.PropTypes.string,
		subRecords: _react2.default.PropTypes.array
	};
	
	var PanelList = function (_React$Component4) {
		_inherits(PanelList, _React$Component4);
	
		function PanelList() {
			_classCallCheck(this, PanelList);
	
			return _possibleConstructorReturn(this, (PanelList.__proto__ || Object.getPrototypeOf(PanelList)).apply(this, arguments));
		}
	
		_createClass(PanelList, [{
			key: 'render',
			value: function render() {
				var listItems = null;
				var heirarchy_level = this.props.panelContent.heirarchy_level;
				if (heirarchy_level == 2) {
					var panelTitle = this.props.panelContent.title_slug;
					listItems = this.props.panelContent.data.map(function (category, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'panel panel-default', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'panel-heading' },
								_react2.default.createElement(
									'h4',
									{ className: 'panel-title' },
									_react2.default.createElement(
										'a',
										{ 'data-toggle': 'collapse', className: 'collapsed', 'data-parent': '#accordion', href: "#" + category.category_slug },
										category.category_name
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: category.category_slug, className: 'panel-collapse collapse ' },
								_react2.default.createElement(Records, { categoryName: category.category_name,
									subRecords: category.sub_records,
									slugCategory: category.category_slug,
									panelTitle: panelTitle,
									heirarchyLevel: heirarchy_level })
							)
						);
					});
				} else if (heirarchy_level == 1) {
					listItems = _react2.default.createElement(Records, { categoryName: "null",
						subRecords: this.props.panelContent.data,
						panelTitle: this.props.panelContent.title_slug,
						heirarchyLevel: heirarchy_level });
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'panel-group select-panel', id: 'accordion' },
					listItems
				);
			}
		}]);
	
		return PanelList;
	}(_react2.default.Component);
	
	PanelList.propTypes = {
		panelContent: _react2.default.PropTypes.object
	};
	
	var PanelContent = function (_React$Component5) {
		_inherits(PanelContent, _React$Component5);
	
		function PanelContent() {
			_classCallCheck(this, PanelContent);
	
			return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
		}
	
		_createClass(PanelContent, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'section',
					{ className: 'panel panel-success card-box-shadow' },
					_react2.default.createElement(PanelList, { panelContent: this.props.activeTab })
				);
			}
		}]);
	
		return PanelContent;
	}(_react2.default.Component);
	
	PanelContent.propTypes = {
		activeTab: _react2.default.PropTypes.object
	};
	
	var TabsPanel = function (_React$Component6) {
		_inherits(TabsPanel, _React$Component6);
	
		function TabsPanel() {
			_classCallCheck(this, TabsPanel);
	
			var _this6 = _possibleConstructorReturn(this, (TabsPanel.__proto__ || Object.getPrototypeOf(TabsPanel)).call(this));
	
			_this6.state = {
				panelData: null,
				activeTab: null
			};
			_this6.handleClick = _this6.handleClick.bind(_this6);
			return _this6;
		}
	
		_createClass(TabsPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setState({
					panelData: this.props.panelData,
					activeTab: this.props.panelData[0]
				});
			}
		}, {
			key: 'handleClick',
			value: function handleClick(tab) {
				this.setState({ activeTab: tab });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row-fluid' },
					_react2.default.createElement(Tabs, { activeTab: this.state.activeTab,
						changeTab: this.handleClick,
						panelTabs: this.props.panelData }),
					_react2.default.createElement(PanelContent, { activeTab: this.state.activeTab })
				);
			}
		}]);
	
		return TabsPanel;
	}(_react2.default.Component);
	
	TabsPanel.propTypes = {
		panelData: _react2.default.PropTypes.array
	};
	
	exports.default = TabsPanel;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RightSidebar = __webpack_require__(240);
	
	var _RightSidebar2 = _interopRequireDefault(_RightSidebar);
	
	var _Choropleth = __webpack_require__(373);
	
	var _Choropleth2 = _interopRequireDefault(_Choropleth);
	
	var _GraphComponent = __webpack_require__(374);
	
	var _GraphComponent2 = _interopRequireDefault(_GraphComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Incomplete Component. Currently this is just a placeholder.
	// TODO : Build the component. Seperate the view of the report generated in the MainViewComponent form the component.
	
	var AdditionalDetails = function (_React$Component) {
		_inherits(AdditionalDetails, _React$Component);
	
		function AdditionalDetails() {
			_classCallCheck(this, AdditionalDetails);
	
			return _possibleConstructorReturn(this, (AdditionalDetails.__proto__ || Object.getPrototypeOf(AdditionalDetails)).apply(this, arguments));
		}
	
		_createClass(AdditionalDetails, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'additional-details-container' },
					this.props.heirarchyLevel == 2 ? _react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							' Concordance Table',
							_react2.default.createElement(
								'span',
								{ className: 'close-icon' },
								_react2.default.createElement(
									'a',
									{ className: 'close-link', onClick: this.props.showAdditionalDetails },
									_react2.default.createElement('i', { className: 'fa fa-times', 'aria-hidden': 'true' })
								)
							)
						),
						_react2.default.createElement(
							'table',
							{ className: 'table' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'States'
									),
									_react2.default.createElement(
										'th',
										null,
										'Details of the Budget Document from which data have been recorded'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								this.props.additionalDetails.group.map(function (record) {
									return _react2.default.createElement(
										'tr',
										{ key: record.name },
										_react2.default.createElement(
											'td',
											null,
											record.name
										),
										_react2.default.createElement(
											'td',
											null,
											record.description
										)
									);
								})
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'panel panel-default' },
						_react2.default.createElement(
							'div',
							{ className: 'panel-heading' },
							' Additional Details',
							_react2.default.createElement(
								'span',
								{ className: 'close-icon' },
								_react2.default.createElement(
									'a',
									{ className: 'close-link', onClick: this.props.showAdditionalDetails },
									_react2.default.createElement('i', { className: 'fa fa-times', 'aria-hidden': 'true' })
								)
							)
						),
						_react2.default.createElement(
							'table',
							{ className: 'table' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement(
										'th',
										null,
										'Particular'
									),
									_react2.default.createElement(
										'th',
										null,
										'Description'
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									{ key: this.props.additionalDetails.record },
									_react2.default.createElement(
										'td',
										null,
										this.props.additionalDetails.record
									),
									_react2.default.createElement(
										'td',
										null,
										this.props.additionalDetails.description
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return AdditionalDetails;
	}(_react2.default.Component);
	
	AdditionalDetails.propTypes = {
		showAdditionalDetails: _react2.default.PropTypes.func,
		heirarchyLevel: _react2.default.PropTypes.number,
		additionalDetails: _react2.default.PropTypes.object
	};
	
	var ReportView = function (_React$Component2) {
		_inherits(ReportView, _React$Component2);
	
		function ReportView() {
			_classCallCheck(this, ReportView);
	
			var _this2 = _possibleConstructorReturn(this, (ReportView.__proto__ || Object.getPrototypeOf(ReportView)).call(this));
	
			_this2.state = {
				vizActive: true
			};
			_this2.showAdditionalDetails = _this2.showAdditionalDetails.bind(_this2);
			return _this2;
		}
	
		_createClass(ReportView, [{
			key: 'showAdditionalDetails',
			value: function showAdditionalDetails() {
				this.setState({ vizActive: this.state.vizActive ? false : true });
			}
		}, {
			key: 'render',
			value: function render() {
				var attributeKey = { "BE": " Budget Estimates", "RE": "Revised Estimates", "A": "Actuals" };
				return _react2.default.createElement(
					'div',
					{ id: 'report-container' },
					_react2.default.createElement(
						'div',
						{ id: 'header-container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-10' },
								_react2.default.createElement(
									'h3',
									{ className: 'primary-header' },
									this.props.recordName
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-2 see-details-text' },
								_react2.default.createElement(
									'a',
									{ className: 'see-details-text', onClick: this.showAdditionalDetails },
									' ',
									_react2.default.createElement('i', { className: 'fa fa-info-circle fa-lg', 'aria-hidden': 'true' }),
									' See Details'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-8' },
								_react2.default.createElement(
									'h4',
									{ className: 'secondary-header' },
									this.props.category
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-8' },
								_react2.default.createElement(
									'h5',
									{ className: 'addtional-details' },
									_react2.default.createElement(
										'span',
										{ className: 'add-detail-1' },
										this.props.viewBy != "barchart" ? this.props.selectedYear + " | " : null
									),
									_react2.default.createElement(
										'span',
										{ className: 'add-detail-2' },
										attributeKey[this.props.budgetAttr]
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4' },
								_react2.default.createElement(
									'h5',
									{ className: 'unit-text addtional-details' },
									'Unit : Figures in ',
									this.props.record.unit
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ id: 'vis-container', className: this.state.vizActive ? "visualization-container" : "additional-details", style: this.state.vizActive ? { "overflowY": "hidden" } : { "overflow-y": "scroll" } },
						this.state.vizActive ? [this.props.viewBy == "choropleth" ? _react2.default.createElement(_Choropleth2.default, {
							data: this.props.record,
							budgetAttr: this.props.budgetAttr,
							unit: this.props.record.unit,
							setYearChange: this.props.setYearChange }) : _react2.default.createElement(_GraphComponent2.default, {
							data: this.props.record,
							budgetAttr: this.props.budgetAttr,
							unit: this.props.record.unit })] : _react2.default.createElement(AdditionalDetails, {
							heirarchyLevel: this.props.heirarchyLevel,
							record: this.props.record,
							additionalDetails: this.props.additionalDetails,
							showAdditionalDetails: this.showAdditionalDetails })
					),
					_react2.default.createElement(
						'div',
						{ id: 'addtional-notes' },
						this.props.recordNotes.source ? "Source : " + this.props.recordNotes.source : null
					)
				);
			}
		}]);
	
		return ReportView;
	}(_react2.default.Component);
	
	ReportView.propTypes = {
		heirarchyLevel: _react2.default.PropTypes.string,
		category: _react2.default.PropTypes.string,
		record: _react2.default.PropTypes.object,
		recordName: _react2.default.PropTypes.string,
		budgetAttr: _react2.default.PropTypes.string,
		recordNotes: _react2.default.PropTypes.object,
		setYearChange: _react2.default.PropTypes.func,
		selectedYear: _react2.default.PropTypes.string,
		additionalDetails: _react2.default.PropTypes.object,
		viewBy: _react2.default.PropTypes.string
	};
	
	exports.default = ReportView;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StatesTopojson = __webpack_require__(375);
	
	var _reactLeaflet = __webpack_require__(754);
	
	__webpack_require__(278);
	
	var _topojsonClient = __webpack_require__(892);
	
	var topojson = _interopRequireWildcard(_topojsonClient);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {};
	
	config.params = {
	  center: [23.59, 81.96],
	  zoomControl: true,
	  zoom: 4,
	  maxZoom: 5,
	  minZoom: 4,
	  scrollwheel: false,
	  legends: true,
	  infoControl: true,
	  attributionControl: true,
	  dragging: false
	};
	
	config.tileLayer = {
	  uri: 'https://api.mapbox.com/styles/v1/suchismitanaik/cj1nivbus001x2sqqlhmct7du/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3VjaGlzbWl0YW5haWsiLCJhIjoiY2lqMmZ5N2N5MDAwZnVna25hcjE2b2Q1eCJ9.IYx8Zoc0yNPcp7Snd7yW2A',
	  params: {
	    minZoom: 4,
	    attribution: '  © <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	    id: '',
	    accessToken: ''
	  }
	};
	
	config.geojson = {
	  weight: "1",
	  color: "#183152",
	  fill: true
	};
	
	var YearSelector = function (_Component) {
	  _inherits(YearSelector, _Component);
	
	  function YearSelector() {
	    _classCallCheck(this, YearSelector);
	
	    return _possibleConstructorReturn(this, (YearSelector.__proto__ || Object.getPrototypeOf(YearSelector)).apply(this, arguments));
	  }
	
	  _createClass(YearSelector, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      return _react2.default.createElement(
	        'div',
	        { className: 'btn-group ', role: 'group', 'aria-label': '...' },
	        this.props.fiscalYears.map(function (item, index) {
	          return _react2.default.createElement(
	            'button',
	            { type: 'button', key: item, value: item, className: props.selectedYear === item ? "btn btn-default focus active" : "btn btn-default", onClick: props.handleYearChange },
	            item
	          );
	        })
	      );
	    }
	  }]);
	
	  return YearSelector;
	}(_react.Component);
	
	YearSelector.propTypes = {
	  fiscalYears: _react2.default.PropTypes.array
	};
	
	var StateToolTip = function (_React$Component) {
	  _inherits(StateToolTip, _React$Component);
	
	  function StateToolTip() {
	    _classCallCheck(this, StateToolTip);
	
	    return _possibleConstructorReturn(this, (StateToolTip.__proto__ || Object.getPrototypeOf(StateToolTip)).apply(this, arguments));
	  }
	
	  _createClass(StateToolTip, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.statetooltip == null) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'statetoolPanelHeading' },
	          'Please select a state from the map'
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'statetoolPanelHeading' },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-map-marker' }),
	          '\xA0',
	          this.props.statetooltip
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(AllocationDetails, { allocations: this.props.allocations, unit: this.props.unit })
	        )
	      );
	    }
	  }]);
	
	  return StateToolTip;
	}(_react2.default.Component);
	
	StateToolTip.propTypes = {
	  statetooltip: _react2.default.PropTypes.string,
	  allocations: _react2.default.PropTypes.number,
	  unit: _react2.default.PropTypes.string
	};
	
	var AllocationDetails = function (_React$Component2) {
	  _inherits(AllocationDetails, _React$Component2);
	
	  function AllocationDetails() {
	    _classCallCheck(this, AllocationDetails);
	
	    return _possibleConstructorReturn(this, (AllocationDetails.__proto__ || Object.getPrototypeOf(AllocationDetails)).apply(this, arguments));
	  }
	
	  _createClass(AllocationDetails, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.allocations == null || isNaN(parseFloat(this.props.allocations))) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Data unavailable'
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        ' ',
	        this.props.allocations,
	        ' ',
	        this.props.unit == "Percentage" ? "%" : this.props.unit
	      );
	    }
	  }]);
	
	  return AllocationDetails;
	}(_react2.default.Component);
	
	AllocationDetails.propTypes = {
	  allocations: _react2.default.PropTypes.number,
	  unit: _react2.default.PropTypes.string
	};
	
	var LegendStep = function (_React$Component3) {
	  _inherits(LegendStep, _React$Component3);
	
	  function LegendStep() {
	    _classCallCheck(this, LegendStep);
	
	    return _possibleConstructorReturn(this, (LegendStep.__proto__ || Object.getPrototypeOf(LegendStep)).apply(this, arguments));
	  }
	
	  _createClass(LegendStep, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'legendspanside', style: { "background": this.props.bgColor } },
	          this.props.range[0].toFixed(2),
	          ' - ',
	          this.props.range[1].toFixed(2)
	        )
	      );
	    }
	  }]);
	
	  return LegendStep;
	}(_react2.default.Component);
	
	LegendStep.propTypes = {
	  bgColor: _react2.default.PropTypes.string,
	  range: _react2.default.PropTypes.array
	};
	
	var Choropleth = function (_Component2) {
	  _inherits(Choropleth, _Component2);
	
	  function Choropleth() {
	    _classCallCheck(this, Choropleth);
	
	    var _this5 = _possibleConstructorReturn(this, (Choropleth.__proto__ || Object.getPrototypeOf(Choropleth)).call(this));
	
	    _this5.state = {
	      budgetAttr: "BE",
	      selectedYear: null,
	      selectedFigure: null,
	      hoverstate: null,
	      hoverFigure: null,
	      bandFigures: null
	    };
	
	    _this5.computeBands = _this5.computeBands.bind(_this5);
	    _this5.mungeData = _this5.mungeData.bind(_this5);
	    _this5.getYearList = _this5.getYearList.bind(_this5);
	    _this5.handleYearChange = _this5.handleYearChange.bind(_this5);
	    _this5.getstyle = _this5.getstyle.bind(_this5);
	    _this5.onEachFeature = _this5.onEachFeature.bind(_this5);
	    _this5.highlightFeature = _this5.highlightFeature.bind(_this5);
	    _this5.resetHighlight = _this5.resetHighlight.bind(_this5);
	    _this5.setToolTipContent = _this5.setToolTipContent.bind(_this5);
	    _this5.getBandNum = _this5.getBandNum.bind(_this5);
	    _this5.fillColor = _this5.fillColor.bind(_this5);
	    return _this5;
	  }
	
	  _createClass(Choropleth, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var MappedFigures = this.mungeData();
	      this.setState({ selectedFigure: MappedFigures });
	      var defaultYear = this.getYearList(this.props.data)[this.getYearList(this.props.data).length - 1];
	      this.props.setYearChange(defaultYear);
	      this.setState({ budgetAttr: this.props.budgetAttr, selectedYear: defaultYear });
	      this.computeBands(MappedFigures, defaultYear);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.data != this.props.data || prevProps.budgetAttr != this.props.budgetAttr) {
	        var MappedFigures = this.mungeData();
	        var yearList = this.getYearList(this.props.data);
	        var flag = 0;
	        for (var year in yearList) {
	          if (this.state.selectedYear == yearList[year]) {
	            flag = 1;
	            break;
	          }
	        }
	
	        this.setState({ selectedFigure: MappedFigures });
	        if (flag == 0) {
	          this.computeBands(MappedFigures, yearList[yearList.length - 1]);
	          this.setState({ selectedYear: yearList[yearList.length - 1] });
	          this.props.setYearChange(yearList[yearList.length - 1]);
	        } else {
	          this.computeBands(MappedFigures, this.state.selectedYear);
	        }
	      }
	    }
	  }, {
	    key: 'computeBands',
	    value: function computeBands(tempData, year) {
	      var data = tempData;
	      var currentState = this.state;
	      var max = Math.max.apply(null, data.features.map(function (state, index) {
	        if (state.properties[year] != null && !isNaN(parseFloat(state.properties[year]))) {
	          return parseFloat(state.properties[year]);
	        } else {
	          return -Infinity;
	        }
	      }));
	      max = max + max * 0.1;
	
	      var min = Math.min.apply(null, data.features.map(function (state, index) {
	        if (state.properties[year] != null && !isNaN(parseFloat(state.properties[year]))) {
	          return parseFloat(state.properties[year]);
	        } else {
	          return Infinity;
	        }
	      }));
	      min = min - min * 0.1;
	      var retvalue = {
	        "20%": [min, min + 20 * (max - min) / 100, 1],
	        "40%": [min + 20 * (max - min) / 100, min + 40 * (max - min) / 100, 2],
	        "60%": [min + 40 * (max - min) / 100, min + 60 * (max - min) / 100, 3],
	        "80%": [min + 60 * (max - min) / 100, min + 80 * (max - min) / 100, 4],
	        "100%": [min + 80 * (max - min) / 100, min + 100 * (max - min) / 100, 5]
	      };
	      this.setState({ bandFigures: retvalue });
	    }
	  }, {
	    key: 'mungeData',
	    value: function mungeData() {
	      var GeoJSONData = new topojson.feature(_StatesTopojson.TopojsonData, _StatesTopojson.TopojsonData.objects.india_state_boundaries);
	      var record = this.props.data.record_figures;
	      var budgetAttr = this.props.budgetAttr;
	      var MappedFigures = new Array();
	      MappedFigures = GeoJSONData.features.map(function (state, index) {
	        var temp = record.find(function (x) {
	          if (x.grpby_name == state.properties.NAME_1) {
	            return x;
	          } else {
	            return false;
	          }
	        });
	        for (var variable in state.properties) {
	          if (variable != "HASC_1" && variable != "NAME_1") {
	            delete state.properties[variable];
	          }
	        }
	        if (temp != null) {
	          var tempFigure = temp.figures[budgetAttr];
	
	          for (var fiscalFigure in tempFigure) {
	            var tempYear = Object.keys(tempFigure[fiscalFigure])[0];
	            state.properties[tempYear] = parseFloat(tempFigure[fiscalFigure][tempYear]);
	          }
	        }
	        return state;
	      });
	      return { "type": "FeatureCollection", "features": MappedFigures };
	    }
	  }, {
	    key: 'getBandNum',
	    value: function getBandNum(figure) {
	      if (figure != null) {
	        var bandFigures = this.state.bandFigures;
	        var bandKeys = Object.keys(bandFigures);
	        for (var band in bandKeys) {
	          if (figure >= bandFigures[bandKeys[band]][0] && figure <= bandFigures[bandKeys[band]][1]) {
	            return bandFigures[bandKeys[band]][2];
	          }
	        }
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: 'fillColor',
	    value: function fillColor(band) {
	      if (band === 0 || band == null) {
	        return "#BFBFBF";
	      }
	      if (band === 1) {
	        return "#B3EAFF";
	      }
	      if (band === 2) {
	        return "#73D9FF";
	      }
	      if (band === 3) {
	        return "#40C1F3";
	      }
	      if (band === 4) {
	        return "#4094B3";
	      }
	      if (band === 5) {
	        return "#406573 ";
	      }
	    }
	  }, {
	    key: 'getstyle',
	    value: function getstyle(feature) {
	      var selectedYear = this.state.selectedYear;
	      return {
	        fillColor: this.fillColor(this.getBandNum(feature.properties[selectedYear])),
	        weight: 1.3,
	        opacity: 1,
	        color: 'grey',
	        dashArray: 0,
	        fillOpacity: 0.8
	      };
	    }
	  }, {
	    key: 'handleYearChange',
	    value: function handleYearChange(e) {
	      this.computeBands(this.state.selectedFigure, e.target.value);
	      this.setState({ selectedYear: e.target.value });
	      this.props.setYearChange(e.target.value);
	    }
	  }, {
	    key: 'getYearList',
	    value: function getYearList(data) {
	      var yearList = [];
	      for (var key in data.record_figures[0].figures[this.props.budgetAttr]) {
	        yearList.push(Object.keys(data.record_figures[0].figures[this.props.budgetAttr][key])[0]);
	      }
	      return yearList;
	    }
	  }, {
	    key: 'highlightFeature',
	    value: function highlightFeature(e) {
	      var layer = e.target;
	      this.setToolTipContent(e.target);
	      layer.setStyle({
	        weight: 2,
	        color: '#000',
	        fillOpacity: 0.9
	      });
	    }
	  }, {
	    key: 'resetHighlight',
	    value: function resetHighlight(e) {
	      this.refs.geojson.leafletElement.resetStyle(e.target);
	      this.resetTooltipContent();
	    }
	  }, {
	    key: 'onEachFeature',
	    value: function onEachFeature(component, feature, layer) {
	      layer.on({
	        mouseover: this.highlightFeature,
	        mouseout: this.resetHighlight
	      });
	    }
	  }, {
	    key: 'setToolTipContent',
	    value: function setToolTipContent(values) {
	      this.setState({ hoverstate: values.feature.properties.NAME_1, hoverFigure: values.feature.properties[this.state.selectedYear] });
	    }
	  }, {
	    key: 'resetTooltipContent',
	    value: function resetTooltipContent() {
	      this.setState({ hoverstate: null, hoverFigure: null });
	    }
	  }, {
	    key: 'showConcordanceData',
	    value: function showConcordanceData() {
	      this.setState({ vizActive: this.state.vizActive ? false : true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row vis-wrapper' },
	        _react2.default.createElement(
	          _reactLeaflet.Map,
	          { center: config.params.center, zoom: config.params.zoom, zoomControl: config.params.zoomControl, dragging: config.params.dragging },
	          _react2.default.createElement(_reactLeaflet.TileLayer, {
	            url: config.tileLayer.uri,
	            maxZoom: config.params.maxZoom,
	            minZoom: config.params.minZoom,
	            attribution: config.tileLayer.params.attribution
	          }),
	          '}',
	          _react2.default.createElement(
	            'div',
	            { className: 'tcontainer' },
	            _react2.default.createElement(YearSelector, { handleYearChange: this.handleYearChange, fiscalYears: this.getYearList(this.props.data), selectedYear: this.state.selectedYear })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'statetooltip' },
	            _react2.default.createElement(StateToolTip, { statetooltip: this.state.hoverstate, allocations: this.state.hoverFigure, unit: this.props.unit })
	          ),
	          _react2.default.createElement(
	            _reactLeaflet.FeatureGroup,
	            null,
	            _react2.default.createElement(_reactLeaflet.GeoJSON, {
	              data: this.state.selectedFigure,
	              weight: config.geojson.weight,
	              style: this.getstyle,
	              valueProperty: function valueProperty(feature) {
	                return feature.properties.NAME_1;
	              },
	              onEachFeature: this.onEachFeature.bind(null, this),
	              ref: 'geojson' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'legendcontainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'legend-scale' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'legend-labels' },
	                _react2.default.createElement(LegendStep, { bgColor: '#B3EAFF', band: '20%', range: this.state.bandFigures["20%"] }),
	                _react2.default.createElement(LegendStep, { bgColor: '#73D9FF', band: '40%', range: this.state.bandFigures["40%"] }),
	                _react2.default.createElement(LegendStep, { bgColor: '#40C1F3', band: '60%', range: this.state.bandFigures["60%"] }),
	                _react2.default.createElement(LegendStep, { bgColor: '#4094B3', band: '80%', range: this.state.bandFigures["80%"] }),
	                _react2.default.createElement(LegendStep, { bgColor: '#406573', band: '100%', range: this.state.bandFigures["100%"] }),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'legendspanside', style: { "background": "#BFBFBF" } },
	                    'Data Unavailable'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'license-text' },
	            'License - ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://creativecommons.org/licenses/by/4.0/', target: '_blank' },
	              'CC-BY 4.0'
	            ),
	            ' | ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://openbudgetsindia.org', target: '_blank' },
	              'Open Budgets India'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Choropleth;
	}(_react.Component);
	
	exports.default = Choropleth;
	
	
	Choropleth.propTypes = {
	  data: _react2.default.PropTypes.object,
	  budgetAttr: _react2.default.PropTypes.string,
	  selectedSector: _react2.default.PropTypes.string,
	  selectedIndicator: _react2.default.PropTypes.string,
	  sectorName: _react2.default.PropTypes.string,
	  setYearChange: _react2.default.PropTypes.func,
	  unit: _react2.default.PropTypes.string
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(96);
	
	var _reactSelect = __webpack_require__(142);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(593);
	
	var _reactVis = __webpack_require__(786);
	
	__webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Hint$ALIGN = _reactVis.Hint.ALIGN,
	    LEFT = _Hint$ALIGN.LEFT,
	    RIGHT = _Hint$ALIGN.RIGHT,
	    TOP = _Hint$ALIGN.TOP,
	    BOTTOM_EDGE = _Hint$ALIGN.BOTTOM_EDGE,
	    RIGHT_EDGE = _Hint$ALIGN.RIGHT_EDGE,
	    TOP_EDGE = _Hint$ALIGN.TOP_EDGE;
	
	var GraphComponent = function (_React$Component) {
	  _inherits(GraphComponent, _React$Component);
	
	  function GraphComponent() {
	    _classCallCheck(this, GraphComponent);
	
	    var _this = _possibleConstructorReturn(this, (GraphComponent.__proto__ || Object.getPrototypeOf(GraphComponent)).call(this));
	
	    _this.state = {
	      value: [],
	      budgetAttr: null,
	      selectedFigures: null,
	      stateOptions: null,
	      hoverValue: null,
	      indicatorUnit: null,
	      notesText: null,
	      vizActive: true,
	      concordanceData: null
	    };
	
	    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
	    _this.getrecord_figures = _this.getrecord_figures.bind(_this);
	    _this.onBarHover = _this.onBarHover.bind(_this);
	    _this.outBarHover = _this.outBarHover.bind(_this);
	    _this.setBudgetAttr = _this.setBudgetAttr.bind(_this);
	    return _this;
	  }
	
	  _createClass(GraphComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.getrecord_figures();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (this.state.budgetAttr != this.props.budgetAttr) {
	        this.setState({ budgetAttr: this.props.budgetAttr });
	      }
	
	      if (prevState.value != this.state.value || prevState.budgetAttr != this.props.budgetAttr || prevProps.data != this.props.data) {
	        if (this.state.value.length != 0) {
	          (function () {
	            var stateArray = _this2.state.value.split(",");
	            var selectedFigures = [];
	
	            var _loop = function _loop(selectedState) {
	              selectedFigures.push(_this2.props.data.record_figures.find(function (value, index) {
	                if (value.grpby_name == stateArray[selectedState]) {
	                  return value.grpby_name;
	                }
	              }));
	            };
	
	            for (var selectedState in stateArray) {
	              _loop(selectedState);
	            }
	
	            var currentState = _this2.state;
	            var mungedFigures = [];
	            selectedFigures.map(function (value, index) {
	              var tempState = {};
	              tempState.name = value.grpby_name;
	              tempState.figures = [];
	              value.figures[currentState.budgetAttr].map(function (figure, index) {
	                var tempFigure = {};
	                tempFigure.x = Object.keys(figure)[0];
	                tempFigure.y = parseFloat(figure[Object.keys(figure)[0]]);
	                tempFigure.grpby_name = value.grpby_name;
	                tempState.figures.push(tempFigure);
	              });
	              mungedFigures.push(tempState);
	            });
	
	            if (_this2.state.value[0] == null && prevState.value != null) {
	              _this2.setState({ selectedFigures: null });
	            } else {
	              _this2.setState({ selectedFigures: mungedFigures });
	            }
	          })();
	        }
	      }
	    }
	  }, {
	    key: 'setBudgetAttr',
	    value: function setBudgetAttr() {
	      this.setState({ budgetAttr: this.props.budgetAttr });
	    }
	  }, {
	    key: 'getrecord_figures',
	    value: function getrecord_figures() {
	      var statesData = [];
	      for (var state in this.props.data.record_figures) {
	        var temp = {};
	        temp.value = this.props.data.record_figures[state].grpby_name;
	        temp.label = this.props.data.record_figures[state].grpby_name;
	        statesData.push(temp);
	      }
	      this.setState({ stateOptions: statesData });
	    }
	  }, {
	    key: 'onBarHover',
	    value: function onBarHover(d, info) {
	      this.setState({ hoverValue: d });
	    }
	  }, {
	    key: 'outBarHover',
	    value: function outBarHover(d, info) {
	      this.setState({ hoverValue: null });
	    }
	  }, {
	    key: 'handleSelectChange',
	    value: function handleSelectChange(value) {
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var accessthis = this;
	      var attributeKey = { "BE": " Budget Estimates", "RE": "Revised Estimates", "A": "Actuals" };
	      var color = ['#26393D', '#40627C', '#D0A825', '#D64700', '#002A4A', '#A7A37E', '#B9121B', '#1B1E26'].reverse();
	      return _react2.default.createElement(
	        'div',
	        { className: 'vis-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid graph-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'select-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-12 state-select' },
	                _react2.default.createElement(_reactSelect2.default, { multi: true, simpleValue: true, value: this.state.value, placeholder: 'Select a State', options: this.state.stateOptions, onChange: this.handleSelectChange })
	              )
	            )
	          ),
	          this.state.value[0] != null && this.state.selectedFigures != null ? _react2.default.createElement(
	            'div',
	            { className: 'row legend-row' },
	            _react2.default.createElement(_reactVis.DiscreteColorLegend, {
	              orientation: 'horizontal',
	              items: this.state.selectedFigures.map(function (value, index) {
	                return { title: value.name, color: color[index] };
	              })
	            })
	          ) : _react2.default.createElement('div', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row graph-area' },
	            this.state.value[0] != null && this.state.selectedFigures != null ? _react2.default.createElement(
	              'div',
	              { id: 'chart' },
	              _react2.default.createElement(
	                _reactVis.XYPlot,
	                {
	                  width: 650,
	                  height: 300,
	                  xType: 'ordinal',
	                  margin: { top: 20, left: 70, right: 10, bottom: 40 } },
	                _react2.default.createElement(_reactVis.HorizontalGridLines, null),
	                _react2.default.createElement(_reactVis.VerticalGridLines, null),
	                this.state.selectedFigures.map(function (state, index) {
	
	                  return _react2.default.createElement(_reactVis.VerticalBarSeries, {
	                    color: color[index],
	                    onValueMouseOver: accessthis.onBarHover,
	                    onValueMouseOut: accessthis.outBarHover,
	                    data: state.figures,
	                    key: state.name
	                  });
	                }),
	                _react2.default.createElement(_reactVis.XAxis, { title: 'Fiscal Years' }),
	                _react2.default.createElement(_reactVis.YAxis, { title: 'Indicator' }),
	                this.state.hoverValue ? _react2.default.createElement(
	                  _reactVis.Hint,
	                  { value: this.state.hoverValue },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rv-hint__content' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'rv-hint__title' },
	                        ' ',
	                        this.state.hoverValue.grpby_name
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'rv-hint__title' },
	                        'Fiscal Year : '
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'rv-hint__value' },
	                        this.state.hoverValue.x
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'rv-hint__title' },
	                        'Figure : '
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'rv-hint__value' },
	                        this.state.hoverValue.y
	                      )
	                    )
	                  )
	                ) : null
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12 select-placeholder' },
	              _react2.default.createElement(
	                'div',
	                { className: 'jumbotron' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'text-center' },
	                  'Select states to generate Visualization'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GraphComponent;
	}(_react2.default.Component);
	
	GraphComponent.propTypes = {
	  data: _react2.default.PropTypes.object,
	  budgetAttr: _react2.default.PropTypes.string
	};
	
	exports.default = GraphComponent;

/***/ },
/* 375 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TopojsonData = exports.TopojsonData = { "type": "Topology", "transform": { "scale": [0.0004479274563322561, 0.00042369142822232486], "translate": [68.15515738328011, 6.75426] }, "arcs": [[[57225, 232], [7, -4], [-7, -7], [-6, 0], [-2, 3], [8, 8]], [[57073, 1070], [-2, -3], [-15, 4], [-1, 17], [-12, 26], [6, 12], [10, -15], [0, -7], [18, -21], [-4, -13]], [[57359, 1147], [1, -16], [-13, -12], [8, -24], [14, -11], [12, 3], [3, 6], [21, 0], [14, -16], [5, -16], [13, 0], [-6, -24], [8, -12], [0, -11], [-8, -26], [4, -10], [8, -6], [-4, -8], [9, -27], [-8, -51], [3, -9], [10, -5], [3, -6], [-6, -27], [-7, -11], [6, -28], [-1, -16], [12, -18], [12, 0], [8, -5], [10, -16], [-1, -19], [11, -12], [2, -10], [11, -10], [0, -8], [-10, -11], [5, -8], [-2, -6], [7, -8], [-1, -13], [9, -5], [18, 9], [12, -13], [6, -19], [8, -8], [12, -2], [5, -25], [-8, -14], [-3, 0], [-5, 9], [-15, 10], [-10, 22], [-5, 2], [-15, -6], [-11, -10], [-4, -10], [2, -13], [10, -3], [20, -16], [3, -6], [-2, -23], [10, -9], [5, -16], [20, -9], [3, -9], [-5, -11], [-9, -3], [-25, 12], [-22, -19], [-2, -34], [-14, -2], [-4, -10], [3, -11], [11, -14], [2, -11], [-13, -16], [-4, -2], [-15, 6], [-11, -12], [7, -15], [-8, -10], [8, -13], [4, -27], [-3, -7], [-17, -14], [4, -25], [-3, -19], [6, -13], [25, -5], [7, -11], [-4, -14], [-16, -20], [1, -18], [-14, -20], [-16, -2], [-3, -15], [-10, -6], [0, -4], [-8, 8], [-1, 16], [-23, 29], [-39, 2], [1, -7], [-12, -30], [6, -22], [-5, -12], [2, -15], [-19, -23], [-9, -34], [-8, 1], [-7, -4], [-24, 6], [-28, 18], [-2, 10], [3, 8], [18, 17], [-13, 11], [2, 14], [8, 8], [-9, 10], [3, 15], [-2, 6], [11, 3], [5, 10], [0, 10], [-9, 5], [-11, -13], [-8, 0], [-15, 14], [-3, 12], [-19, 17], [-2, 12], [4, 12], [14, 15], [2, 7], [-8, 5], [-4, 10], [-15, -6], [-7, 7], [-12, 16], [-2, 5], [6, 9], [-9, 16], [12, 9], [5, 0], [2, 7], [-7, 4], [8, 12], [-3, 3], [-5, -2], [-12, 7], [-1, 8], [-7, -5], [-3, 9], [3, 7], [-12, 14], [6, 4], [2, 5], [-4, 12], [-14, -8], [-9, -15], [-4, 1], [-8, 8], [-4, 17], [-11, 17], [2, 10], [17, -1], [4, 19], [-7, 12], [3, 7], [-2, 9], [-7, 5], [4, 11], [-7, 15], [-6, 4], [-10, -10], [-6, 1], [0, 14], [-10, 9], [6, 18], [-24, 35], [-14, 4], [-11, -2], [-9, -7], [-9, 4], [0, 7], [6, 13], [-12, 22], [-16, 14], [-17, 7], [-19, -4], [-7, -29], [-6, -3], [-9, 0], [-11, 9], [3, 10], [14, 5], [-1, 15], [9, 5], [0, 5], [-11, 11], [8, 12], [1, 7], [-14, 9], [-5, 9], [0, 10], [6, 12], [3, 30], [-12, 2], [-2, 6], [1, 7], [15, 17], [1, 8], [-8, 9], [-8, -4], [-5, 2], [-8, 20], [1, 12], [5, 7], [13, 1], [7, 9], [10, 6], [3, 7], [-16, 12], [-10, -14], [-10, 1], [-5, 8], [-1, 24], [5, 9], [16, 5], [5, 19], [5, 0], [7, -5], [7, 6], [6, 37], [-9, 11], [3, 30], [-6, 7], [23, 18], [6, 15], [13, 5], [3, -4], [18, -4], [12, 7], [14, 2], [12, -6], [2, -5], [14, -4], [7, 4], [11, -1], [28, 31], [11, 7], [6, -2], [1, 3], [-6, 7], [8, 11], [12, 7], [13, 0], [-4, -11], [20, -7], [9, 5], [-1, 7], [16, 4], [7, -6], [12, 5], [15, -15], [6, -2], [1, -11], [4, 14], [-4, 9], [5, 3], [5, -5], [11, 8], [-10, 3], [-3, 10], [10, 2], [-4, 20], [-8, -2], [4, 14], [8, -5], [11, 3], [2, 5], [10, 5], [14, 3], [9, -5], [9, 7], [7, 0], [-3, 8], [14, -6], [8, 4], [1, 6], [1, -9]], [[57361, 1264], [-6, -10], [-2, 0], [-2, 7], [10, 3]], [[56948, 1486], [3, 0], [2, -1], [-9, 0], [4, 1]], [[57182, 1529], [9, -9], [-1, -7], [-5, -4], [-8, 1], [-9, 10], [11, 13], [3, -4]], [[57005, 1547], [7, -3], [-3, -8], [9, -13], [-9, -7], [-8, 2], [-7, 7], [-3, 11], [14, 11]], [[57058, 1627], [6, -22], [10, -9], [1, -18], [4, -4], [-2, -45], [13, -17], [31, -24], [16, -7], [8, -12], [4, 1], [6, -6], [2, -16], [-5, -10], [2, -9], [-17, -7], [1, -11], [-14, -11], [-10, -17], [-7, -31], [-4, -8], [-9, -6], [-9, -26], [-15, -12], [-7, 5], [-6, -5], [-12, -2], [-4, -11], [-16, -14], [-25, -7], [-8, -11], [-9, -3], [-6, -10], [2, -7], [-15, -22], [-5, -24], [-13, -8], [-22, -24], [-10, -5], [-23, 25], [1, 9], [-4, 7], [-9, 9], [-6, -1], [-2, 4], [0, 12], [11, 13], [-7, 12], [6, 6], [2, 8], [-12, 39], [-6, 7], [-9, 1], [-3, 5], [2, 7], [17, 6], [14, 18], [2, 24], [-10, 13], [3, 25], [-4, 8], [-2, 25], [3, 20], [8, 8], [8, 0], [22, -12], [31, 29], [6, 0], [13, -17], [6, -1], [13, 8], [3, 18], [6, 8], [21, 5], [11, 10], [4, -4], [15, 4], [15, -3], [1, 7], [-12, 4], [-1, 6], [-11, 3], [5, 9], [0, 16], [7, 14], [1, 14], [-6, 8], [0, 25], [-5, 13], [3, 4], [6, -4], [7, 5], [3, -4]], [[56913, 1705], [10, -7], [-1, -8], [-18, 1], [0, 9], [9, 5]], [[56883, 1708], [-3, -6], [-7, 7], [0, 3], [5, 1], [5, -5]], [[56680, 1819], [15, -19], [-6, -11], [-12, -5], [-5, 8], [3, 10], [-4, 5], [2, 9], [7, 3]], [[56229, 2719], [2, -3], [0, -2], [-5, 1], [3, 4]], [[56225, 2730], [1, -3], [-2, -2], [-1, 4], [2, 1]], [[56315, 2999], [13, -9], [28, -9], [25, -24], [-1, -4], [-8, -4], [-5, -13], [-1, -19], [4, -14], [-6, -18], [7, -12], [11, -9], [4, -14], [10, -6], [10, 0], [20, 20], [6, -6], [7, -21], [10, -4], [44, -40], [11, -18], [3, -15], [-1, -20], [20, -53], [-7, -10], [-2, -13], [-20, -25], [-19, 7], [-3, 20], [-23, 35], [-42, 20], [-19, -2], [-14, -10], [-6, 3], [-17, -3], [-11, -22], [-13, -12], [-11, -5], [-4, -8], [-7, -1], [-10, 5], [-5, 7], [-6, -2], [-25, 7], [-14, 11], [-3, 12], [-10, 7], [-2, 11], [7, 3], [1, 6], [-10, 21], [20, 30], [-12, -10], [-3, 8], [29, 26], [-7, -2], [-12, 9], [-14, -13], [13, 2], [-2, -11], [-11, -9], [-9, 9], [-11, 1], [-8, -17], [6, -8], [-5, -5], [-19, 8], [-12, 16], [5, 16], [-16, 25], [-3, 26], [9, 10], [4, 9], [16, 14], [-3, 37], [9, 26], [22, 23], [14, -4], [10, 14], [10, -19], [18, 3], [15, 11], [11, 19], [20, 6]], [[56688, 3006], [1, -3], [6, 2], [24, -10], [4, 4], [4, -3], [4, -19], [11, -9], [11, -28], [14, -20], [-2, -14], [3, -5], [-8, -11], [8, -17], [-8, -14], [5, -6], [0, -11], [-5, -9], [5, -8], [-3, -20], [2, -10], [-4, -4], [0, -8], [-6, -4], [3, -5], [-2, -3], [-8, 1], [-24, 20], [-25, 28], [-14, 6], [-16, 16], [0, 6], [-6, 6], [-24, 11], [-1, 6], [-6, 0], [-13, 9], [3, 4], [-3, 6], [-19, 14], [2, 9], [-7, 12], [5, 7], [13, 6], [3, -9], [8, -5], [17, 16], [4, 11], [8, 4], [-2, 22], [-5, 7], [5, 13], [5, 2], [6, -2], [5, -16], [11, -5], [2, -21], [17, -24], [2, 9], [-3, 13], [4, 6], [-4, 2], [0, 11], [-4, 2], [-2, 6], [3, 8], [-13, 11], [4, 7], [5, 0]], [[56758, 3236], [4, -1], [19, -37], [4, -25], [-4, -9], [5, -3], [-1, -25], [5, -15], [-5, -16], [3, -12], [12, -14], [5, -18], [4, -3], [-1, -14], [-18, -15], [-17, 27], [-7, 1], [-4, 16], [-11, 6], [-9, 18], [6, 15], [16, 2], [0, 10], [-4, 1], [4, 6], [-20, 24], [-4, -2], [-3, 12], [13, 34], [-10, -8], [-20, 28], [3, 6], [35, 11]], [[56642, 3486], [24, -4], [15, -11], [6, -35], [-3, -29], [-7, -11], [-10, -6], [1, -12], [-8, -13], [-21, -20], [-2, 7], [11, 7], [10, 15], [-11, -6], [-16, -21], [-8, 1], [-16, -11], [-3, -9], [7, -4], [-2, -12], [-8, -4], [-2, -16], [-10, -2], [3, -9], [21, -18], [15, -27], [8, -7], [19, -41], [-1, -14], [20, -18], [11, -2], [5, -5], [11, -52], [-5, -6], [-2, -16], [-3, -2], [1, -14], [-8, -3], [8, -12], [3, -19], [-3, -1], [-17, 5], [-5, 4], [1, 7], [-9, 6], [1, 5], [-12, 5], [-6, -9], [2, -16], [-8, -15], [-7, 2], [-4, 10], [-8, -7], [-19, -1], [-5, -23], [13, -18], [-11, -4], [-1, -5], [7, -6], [-6, -5], [-1, -15], [-3, -7], [-8, 4], [2, -5], [-4, -2], [-9, 7], [-7, -3], [-4, 2], [-14, 39], [-2, 15], [3, 5], [-1, 24], [2, 10], [-2, 12], [11, 5], [6, -8], [15, -9], [9, 20], [4, -17], [7, 25], [-12, 10], [12, 6], [-1, 13], [6, 12], [6, -6], [4, -20], [-3, -18], [9, -7], [17, 16], [-4, 23], [11, 2], [2, 8], [-10, -2], [-4, 16], [14, 12], [-12, -1], [-4, 13], [-6, -6], [-12, 6], [-5, -24], [-13, -3], [-4, -9], [-4, 2], [-8, -11], [-7, 3], [-10, -9], [6, -6], [0, -14], [-4, -6], [-6, -4], [-5, 6], [-4, -3], [-2, 3], [-2, 10], [1, 18], [-3, 8], [3, 7], [-9, 37], [15, 4], [5, 10], [-18, 11], [-7, -15], [-26, 38], [-1, 13], [-5, 8], [10, 7], [-15, 1], [-5, 9], [1, 13], [-4, 7], [1, 8], [14, 13], [-5, 8], [-9, -4], [-7, 10], [-2, 13], [5, 16], [-7, 19], [0, 5], [3, 2], [-2, 11], [12, 13], [22, 5], [15, 7], [12, 19], [20, 16], [0, 11], [5, 11], [-3, 21], [8, 13], [23, 8], [8, 6], [9, -1], [19, 12], [12, -5]], [[55991, 3567], [10, -11], [22, -47], [-1, -9], [6, -9], [-2, -2], [3, -9], [-4, -8], [-12, -6], [-11, 2], [-1, -7], [-12, 9], [-2, 13], [-19, 15], [-11, 21], [4, 28], [30, 20]], [[55748, 3780], [6, -2], [0, -7], [7, -9], [8, 2], [17, -6], [0, -13], [-5, -9], [0, -18], [-15, -27], [-7, -20], [6, -19], [-17, -43], [0, -17], [16, -28], [47, -50], [43, -21], [12, -10], [34, -12], [8, -12], [15, -10], [2, -6], [-4, -27], [-4, -12], [-6, -6], [-18, 0], [-7, -4], [-6, 6], [-14, 2], [-1, 6], [-8, 5], [-4, -3], [-3, 6], [-10, -4], [-14, 2], [-4, 10], [-13, 4], [-2, 6], [-15, 4], [-16, 10], [-6, -2], [-9, 12], [-7, -1], [-18, 8], [-6, 9], [-6, 2], [1, 13], [-9, 0], [-15, 18], [-9, 14], [-2, 18], [-5, 0], [-24, 37], [-8, 30], [3, 11], [-4, 21], [5, 29], [21, 42], [0, 32], [12, 7], [1, 7], [7, 3], [4, 9], [16, -7], [6, 4], [-1, 4], [9, -3], [16, 15]], [[56923, 3871], [10, -8], [-8, -7], [-6, 5], [-7, -1], [-9, 9], [4, 3], [16, -1]], [[56884, 3872], [-3, 0], [-1, 8], [5, -3], [-1, -5]], [[55564, 4057], [29, -31], [-1, -28], [10, -12], [-7, -9], [-14, -2], [-19, 5], [-17, 19], [-2, 10], [3, 17], [9, 22], [9, 9]], [[56832, 4084], [-1, 3], [5, 0], [0, -1], [-4, -2]], [[56841, 4294], [5, -6], [-1, -7], [6, -8], [0, -14], [-5, -16], [5, -8], [-4, -6], [3, -3], [-1, -5], [4, -2], [5, -21], [-3, -3], [9, -10], [11, -4], [3, -4], [5, 1], [3, -5], [-6, -11], [9, -13], [0, -4], [-9, -5], [-3, -7], [11, -20], [6, -31], [-2, -8], [8, -28], [-2, -9], [-6, 1], [-11, 13], [-16, -8], [-2, -27], [-6, -16], [10, -18], [-2, -4], [3, -7], [-3, -18], [-8, -18], [-8, 26], [-7, 5], [9, 7], [-1, 8], [-6, 5], [6, 8], [1, 14], [-11, 9], [9, 0], [1, 6], [7, 5], [-6, 20], [6, 7], [-10, 4], [4, 4], [-4, 11], [3, 4], [10, 0], [9, 15], [-10, 20], [4, 16], [-2, 27], [-5, 10], [-5, 3], [4, 11], [-2, 5], [-6, 0], [-4, 20], [-7, 5], [-8, 15], [4, 6], [-5, 13], [6, 15], [-4, 5], [9, 9], [-7, 16], [5, 4], [-1, 7], [6, -6]], [[56827, 4313], [0, -5], [-3, -3], [-4, 7], [7, 1]], [[55152, 4876], [-11, -2], [-5, 7], [3, 23], [12, 13], [7, -7], [3, -11], [-2, -17], [-7, -6]], [[55005, 5581], [5, -2], [2, 1], [5, 0], [-5, -2], [-10, 0], [3, 3]], [[55029, 5586], [1, -2], [-4, -3], [-7, -1], [10, 6]], [[55051, 5600], [1, -3], [-6, -3], [0, 3], [5, 3]], [[54992, 5877], [65, -65], [9, -18], [8, -31], [67, 31], [6, -17], [-70, -23], [2, -11], [-3, -16], [8, -11], [7, -23], [-2, -20], [-7, -19], [6, -26], [-14, -1], [-17, -7], [-5, -9], [-6, -1], [-1, -18], [-7, 1], [-11, -8], [-22, -3], [-25, 2], [6, -5], [11, -1], [-1, -1], [-13, 1], [-33, 23], [-1, -4], [-5, 1], [-6, -6], [-18, 8], [-6, -5], [-19, 1], [-12, -5], [-16, 3], [-11, 14], [-1, 14], [-14, 23], [-4, 16], [0, 16], [7, 39], [-4, 41], [4, 9], [-3, 24], [2, 15], [7, 11], [9, 3], [14, -5], [4, -5], [10, 3], [8, -2], [6, -9], [13, 7], [31, 0], [11, 14], [-1, 15], [7, 4], [4, 13], [-7, 8], [2, 6], [3, -4], [4, 1], [5, 12], [-11, 28], [9, 1], [8, -18], [13, -11]], [[54385, 9779], [12, -2], [20, -23], [-4, -12], [8, -18], [-8, -13], [5, -8], [14, 1], [-11, 0], [-5, 4], [8, 15], [-5, 11], [2, 6], [-5, 5], [5, 4], [11, -5], [48, -46], [4, -11], [-6, -10], [-2, -24], [15, -38], [-5, -11], [1, -27], [7, -11], [-7, -9], [-4, 5], [2, -10], [3, -2], [-1, 6], [6, 3], [18, -4], [6, -14], [9, -9], [14, -7], [6, -7], [1, -18], [-11, -48], [-1, -39], [11, -21], [5, -37], [18, -35], [-3, -58], [-5, -4], [-13, 6], [-9, 0], [-17, -13], [-3, -8], [6, -25], [1, -4], [6, 2], [3, -5], [-15, -10], [-11, 1], [-11, -6], [-30, -30], [-22, -37], [-7, -27], [2, -24], [8, -17], [43, -15], [12, -13], [1, -6], [-25, -40], [-12, -13], [-9, -4], [-7, -7], [-10, -36], [-7, -4], [-9, -12], [0, -16], [-5, -10], [-42, -17], [-31, -1], [-13, 11], [-26, 6], [-29, 23], [-14, 19], [-21, 12], [-2, 8], [-5, -3], [-34, 12], [-17, 2], [-18, -4], [-24, -30], [-14, -8], [-24, -2], [-13, 4], [-9, 12], [1, 8], [26, 30], [-3, 8], [3, 8], [12, 17], [4, 12], [19, 23], [8, 56], [6, 9], [10, 4], [2, 7], [-10, 41], [-18, 39], [-19, 30], [-10, 13], [-13, -2], [-20, 4], [7, 16], [-5, 9], [2, 9], [-5, 29], [2, 12], [-1, 35], [5, 17], [-11, 44], [1, 37], [7, 16], [-12, 25], [0, 20], [20, 22], [4, -18], [18, -10], [-5, -8], [2, -16], [4, -16], [5, -3], [4, 6], [-5, -4], [-2, 3], [-5, 22], [7, 21], [22, 8], [26, 26], [8, 18], [1, 12], [8, 11], [2, 25], [16, -3], [29, 36], [15, 0], [8, 6], [6, 28], [-8, 17], [1, 6], [25, 13], [4, 11], [21, -1], [29, 42], [16, 4], [7, 0], [5, -4], [3, -17], [12, -10], [-4, -18], [-16, 6], [12, -9], [6, 1], [5, 11], [-1, 9], [-10, 10], [-3, 18], [8, 14], [12, 5]], [[54593, 9876], [21, -11], [6, -10], [-2, -3], [-13, -3], [-11, 8], [-8, 12], [7, 7]], [[53740, 9979], [5, -3], [-2, -12], [-13, -7], [-8, -1], [-9, 12], [15, 12], [12, -1]], [[54715, 9978], [-5, 0], [-6, 11], [2, 11], [5, 4], [13, -3], [5, -7], [-1, -7], [-13, -9]], [[54854, 10361], [0, -6], [-4, -3], [-3, 7], [7, 2]], [[54868, 10374], [6, -10], [-10, -9], [-7, 9], [11, 10]], [[54745, 10454], [9, -6], [-8, -10], [-4, 3], [1, 4], [-7, 14], [4, 9], [5, -3], [0, -11]], [[54810, 10703], [3, -15], [-5, -30], [2, -16], [-25, -26], [1, -10], [-4, -11], [-14, -3], [1, 10], [21, 36], [-9, 22], [2, 9], [-3, 15], [6, 9], [24, 10]], [[54798, 10756], [5, -7], [16, 0], [5, -13], [-7, -4], [-16, 16], [-8, 0], [-1, 5], [6, 3]], [[54848, 10768], [-4, -5], [-8, 4], [-4, -17], [-3, -2], [-4, 2], [5, 19], [-2, 8], [8, 8], [-1, 11], [10, 11], [5, -3], [-3, -16], [3, -14], [-2, -6]], [[54458, 10949], [-6, 6], [11, 3], [0, -6], [-5, -3]], [[54479, 10944], [-5, 0], [2, 10], [7, 5], [7, -1], [0, -8], [-11, -6]], [[54737, 11171], [-5, 0], [-2, 4], [5, 0], [2, -4]], [[54597, 11210], [-4, 2], [3, 7], [13, 9], [-12, -18]], [[54672, 11232], [-1, 3], [4, 2], [1, -3], [-4, -2]], [[54666, 11225], [10, 2], [0, -25], [30, -21], [15, 0], [5, -4], [6, -26], [14, -17], [-3, -22], [9, -15], [-1, -7], [14, -39], [-2, -8], [-8, -4], [5, -12], [-5, -1], [-3, 6], [-18, -6], [6, -12], [-6, -11], [-51, -21], [13, 1], [13, -4], [-1, -7], [8, -3], [-4, -7], [5, -9], [12, 2], [6, 8], [6, 0], [7, -16], [11, -6], [12, 3], [3, -10], [8, 1], [-7, -12], [3, -12], [-2, -16], [-11, -8], [-11, -2], [-6, -8], [-22, -2], [-7, -10], [-2, -13], [-7, 7], [-20, 5], [-25, -16], [-7, -10], [-23, 8], [-11, -6], [-9, 5], [-14, -2], [-8, -6], [-19, 2], [-13, 5], [-13, 13], [-17, 29], [2, 10], [15, 8], [8, 15], [-12, 47], [51, 3], [9, -3], [20, 11], [6, 36], [-6, 25], [-7, -1], [1, 12], [4, 0], [0, -5], [4, 3], [0, 14], [-7, 3], [-21, 39], [6, 37], [16, 55], [14, 15], [11, 25], [9, 6], [12, -16]], [[53840, 11239], [-2, 2], [5, 3], [1, -4], [-4, -1]], [[54583, 11283], [4, -1], [1, -29], [-10, 5], [-3, 14], [4, 19], [4, -8]], [[54485, 11291], [1, -12], [18, -14], [-6, -24], [-11, 0], [-2, 9], [-17, 24], [-1, 18], [6, -2], [8, 8], [4, -7]], [[54636, 11300], [-3, 5], [3, 12], [4, -6], [-4, -11]], [[54596, 11340], [6, 5], [4, -3], [0, -5], [5, -2], [0, 6], [4, 2], [4, -10], [-6, -45], [-16, -12], [-8, 12], [-2, 28], [-10, 11], [3, 5], [5, -4], [3, 3], [7, -3], [-8, 15], [2, 7], [7, -10]], [[54516, 11349], [-3, 7], [9, 12], [0, -4], [-6, -15]], [[54501, 11368], [-1, -5], [-4, -1], [0, 6], [5, 0]], [[54567, 11299], [-4, -21], [-6, 9], [-11, -7], [0, 13], [-3, 5], [-6, -16], [-2, 14], [7, 3], [1, 5], [-4, 19], [6, 8], [5, 15], [-4, 21], [10, 17], [5, -15], [-3, -10], [9, -10], [0, -50]], [[54525, 11394], [-4, 7], [1, 1], [5, -2], [-2, -6]], [[54598, 11409], [13, -13], [5, -13], [-4, -25], [-6, -9], [-19, 19], [-7, -8], [-6, 2], [2, 41], [22, 6]], [[53723, 11419], [26, -12], [11, 10], [13, 1], [47, -5], [18, -14], [0, -18], [-5, -16], [3, -11], [-2, -23], [13, -45], [-11, -32], [-6, -1], [-3, -4], [-12, -7], [-13, 16], [-9, 4], [-33, -2], [-29, 12], [-8, -3], [-1, -6], [-2, 8], [-7, -1], [1, 5], [-6, 9], [-10, 37], [3, 21], [13, 33], [-17, 27], [18, 9], [3, 9], [-3, 4], [5, 0], [3, -5]], [[54439, 11445], [14, -4], [4, -5], [-4, -6], [-1, -12], [10, 3], [9, -5], [28, 3], [6, -9], [-16, -11], [6, -26], [-17, -10], [-8, -16], [-12, -4], [-14, 6], [-8, -2], [-19, -18], [2, 10], [10, 13], [-7, 19], [7, 24], [-8, 30], [9, 25], [5, 0], [4, -5]], [[54795, 11589], [4, -3], [-1, -9], [-18, 3], [5, 7], [10, 2]], [[54936, 11601], [-3, 1], [-3, 16], [14, 10], [1, -6], [-9, -21]], [[54852, 11647], [4, -3], [-3, -3], [-8, 3], [2, 4], [5, -1]], [[54464, 11723], [-4, 7], [5, 3], [-2, -4], [1, -6]], [[55651, 11861], [-9, -1], [-3, 4], [7, 17], [9, 4], [4, -9], [-8, -15]], [[55513, 12011], [33, -17], [11, 5], [11, 10], [40, 6], [5, -6], [9, 0], [5, -16], [-22, -33], [2, -6], [-3, -5], [-17, -10], [-9, -1], [-31, 16], [-12, 10], [-1, 7], [-7, -2], [-21, 12], [-3, -4], [-3, 1], [-2, 15], [-4, 6], [-1, 25], [4, 2], [16, -15]], [[54567, 12158], [-4, 22], [4, 6], [9, 4], [1, -11], [-6, -9], [2, -2], [-2, -8], [-4, -2]], [[54496, 12263], [6, 0], [3, -9], [-2, -6], [-12, 9], [3, 6], [2, 0]], [[54869, 12273], [-7, -12], [6, -10], [-13, -9], [-5, 14], [6, 13], [-7, -4], [0, 5], [22, 15], [-2, -12]], [[54893, 12297], [-3, 4], [6, 3], [1, -3], [-4, -4]], [[54908, 12306], [29, -3], [6, -4], [3, -22], [-3, -8], [-10, -9], [-10, 1], [-10, -7], [-14, -3], [-11, 14], [-9, 0], [-2, 6], [8, 19], [21, 4], [2, 12]], [[54565, 12325], [10, -11], [0, -7], [6, -7], [-1, -11], [9, -23], [-1, -15], [6, -5], [-4, -12], [-10, -3], [-9, -20], [-6, 7], [-1, 16], [4, 2], [0, 7], [-3, 1], [2, 24], [-4, 34], [-15, 14], [0, 7], [11, 4], [6, -2]], [[54535, 12324], [-3, 8], [5, 8], [3, -12], [-5, -4]], [[54966, 12423], [2, -4], [-5, -8], [-7, 3], [-1, 9], [11, 0]], [[55398, 12461], [12, 8], [-1, 12], [18, 3], [12, -14], [24, -9], [11, -11], [13, -24], [2, -14], [-7, -20], [0, -10], [21, -48], [19, -32], [7, -35], [6, -8], [8, 2], [7, -4], [-1, -7], [21, -47], [-3, -6], [6, -4], [-1, -8], [5, -12], [-1, -8], [11, -13], [0, -13], [-6, -15], [-12, -17], [-8, -4], [-17, -1], [-21, 15], [-7, 30], [-7, 15], [-30, 51], [-17, 12], [1, 9], [-9, 6], [5, 10], [11, 7], [-3, 6], [-8, -7], [-15, 9], [-11, -14], [-24, 8], [-13, 19], [-20, 59], [-26, 9], [-31, 0], [-8, 17], [-11, 8], [-1, 5], [7, 4], [6, 14], [26, 4], [18, 14], [7, 18], [18, 23], [3, 34], [4, 11], [2, -2], [-1, -15], [9, -20]], [[55399, 12532], [-1, 2], [4, 1], [0, -2], [-3, -1]], [[55447, 12638], [4, -5], [23, -4], [4, -5], [-10, -39], [-1, -22], [3, -6], [-6, -5], [4, -12], [-6, -5], [8, -7], [-6, -17], [5, -10], [-8, -13], [-11, -4], [-20, 16], [-9, 2], [0, 8], [-9, 14], [-6, -2], [4, 14], [-4, -3], [-9, 9], [-11, 1], [-5, 8], [-3, 25], [21, 8], [2, 4], [-3, 7], [-9, -2], [0, 11], [-10, -3], [2, 18], [-5, 13], [3, 4], [7, -2], [5, 5], [17, -16], [7, 3], [-6, 0], [-1, 4], [17, 2], [9, 7], [13, -1]], [[55453, 12641], [-4, 1], [0, 3], [4, -2], [0, -2]], [[54892, 12653], [-1, -7], [-8, -13], [1, 9], [8, 11]], [[55351, 12654], [18, -24], [3, -15], [-2, -8], [-13, -12], [2, -16], [-5, 11], [1, 53], [-4, 11]], [[54638, 12647], [-1, 6], [4, 3], [0, -7], [-3, -2]], [[54642, 12659], [-1, 4], [3, 2], [-1, -3], [-1, -3]], [[55685, 12705], [2, -3], [-2, -6], [-4, 3], [4, 6]], [[55735, 12731], [0, -6], [-5, -4], [8, 2], [-1, -8], [5, -3], [-18, -24], [-14, 31], [13, 3], [4, 9], [8, 0]], [[55122, 12729], [-4, 4], [6, 4], [1, -1], [-3, -7]], [[55528, 12751], [-2, -21], [4, -10], [-5, -6], [0, -5], [10, -10], [5, -18], [5, -4], [-8, -22], [0, -14], [8, -17], [-2, -6], [18, -28], [16, -13], [9, -16], [-6, -7], [5, -9], [-2, -15], [2, -6], [-8, -22], [-9, -14], [-10, 2], [-15, 34], [-15, 18], [-18, 9], [-19, -2], [-9, 11], [0, 42], [4, 15], [-3, 17], [-15, -1], [-1, 12], [-7, 4], [-37, -4], [-10, 4], [-2, 9], [-20, 4], [-9, 9], [-15, 46], [2, 12], [12, 7], [28, -5], [24, 0], [16, -12], [6, -32], [12, -17], [2, -11], [6, -10], [4, 8], [-7, 18], [-1, 22], [10, 29], [9, 11], [23, 15], [5, 15], [10, 7], [5, -6], [-5, -17]], [[54928, 12809], [11, -5], [-10, -30], [0, 27], [-6, 5], [5, 3]], [[54842, 12807], [-3, -3], [1, 5], [3, 2], [-1, -4]], [[54867, 12824], [-3, -8], [5, -5], [-9, -1], [0, 8], [-6, -1], [-1, 3], [8, 7], [4, 1], [2, -4]], [[55619, 12880], [18, -4], [2, -18], [21, -21], [-3, -15], [6, -9], [-4, -7], [7, 1], [1, -14], [-14, -45], [6, -9], [6, 2], [11, -10], [2, -14], [-16, -29], [5, -7], [-5, -9], [12, -1], [-3, -9], [2, -5], [-6, -4], [8, -8], [0, -3], [-4, 1], [-2, -26], [-12, -16], [2, -5], [-2, -3], [-3, -3], [-10, 2], [-2, -11], [-6, 2], [-3, -5], [-5, 8], [-7, 1], [2, 8], [-4, 0], [-5, 17], [-6, 1], [-3, 11], [-9, 3], [-18, 25], [10, 18], [4, 2], [-7, -1], [-6, -8], [-3, 2], [-6, 18], [-15, -3], [-6, 16], [14, 53], [-15, 2], [2, 7], [15, -1], [26, 73], [23, 47], [5, 3]], [[54759, 12888], [-4, 1], [-3, 9], [6, 13], [1, -23]], [[55511, 12913], [4, -3], [-4, -3], [-2, 0], [2, 6]], [[55330, 12909], [6, -15], [-7, -12], [-7, 2], [-2, -6], [3, -19], [-6, -16], [-1, 17], [-15, 10], [-2, 10], [6, 26], [13, 6], [8, -3], [2, 4], [2, -4]], [[54798, 12937], [11, -11], [4, -30], [5, -5], [1, -19], [-8, -23], [13, -19], [-7, -6], [-8, -18], [-4, -34], [20, 24], [1, -13], [-3, -6], [4, -6], [17, 35], [7, -4], [27, 9], [15, -4], [11, -8], [10, 7], [11, -9], [0, -27], [-5, -29], [-21, -51], [-5, -25], [-12, -18], [-5, -14], [-1, -53], [12, -24], [-4, -8], [-4, 0], [-5, -13], [5, -3], [-2, 4], [4, 4], [-1, 7], [7, 2], [1, 7], [3, 0], [5, -5], [15, -3], [13, -12], [0, -10], [-13, -13], [1, -3], [17, 3], [5, -11], [8, 1], [0, -10], [3, -2], [13, 1], [12, 8], [12, -8], [-8, -14], [-7, -2], [-3, -21], [8, -12], [-1, -5], [-31, 4], [2, -5], [-8, -7], [-9, 4], [-3, 9], [-6, 2], [-2, 17], [-8, -5], [-2, 10], [-10, -4], [-8, 10], [2, 7], [-5, -3], [3, -15], [-5, 2], [-4, -11], [10, 0], [1, -4], [-3, -9], [-12, -3], [-3, -5], [3, -4], [4, 2], [8, -4], [0, -5], [-8, -2], [8, -7], [9, 11], [6, -1], [7, -8], [1, -6], [-4, -5], [4, -4], [-1, -7], [6, -5], [11, 0], [9, 18], [10, 3], [1, -21], [5, -8], [-45, -9], [-5, 3], [-7, -7], [0, -12], [20, 9], [11, -9], [-6, -16], [-13, -10], [-5, 1], [-4, 11], [-18, -13], [-4, 0], [-3, 14], [6, 3], [4, 7], [-2, 9], [4, 15], [-11, 1], [-13, -7], [0, -4], [6, 0], [-9, -21], [1, -4], [-8, -4], [3, -9], [-2, -5], [15, 0], [5, -15], [-17, -4], [-3, -10], [-7, 2], [-4, -5], [0, -10], [-7, -15], [6, -5], [-4, -7], [4, -15], [-4, -7], [-4, 0], [-1, -8], [2, -5], [5, 8], [7, 0], [8, -9], [2, -7], [-3, -22], [3, -22], [-2, -10], [-5, -4], [7, -2], [4, -9], [-8, -17], [6, -2], [-7, -30], [5, -5], [4, -30], [-6, -28], [-22, -59], [-17, -22], [-10, -6], [-13, 3], [-1, -5], [-28, 13], [-8, 0], [18, -10], [9, -1], [1, -12], [14, 9], [5, -2], [20, 6], [18, 24], [4, 17], [13, 25], [5, 19], [8, 16], [-3, 11], [5, 31], [-2, 21], [4, 49], [8, 25], [10, 13], [11, 26], [15, -1], [20, 13], [5, 7], [7, -4], [8, 4], [30, -9], [2, -4], [-7, -9], [12, -12], [1, -13], [-11, -36], [6, -8], [6, 0], [-18, -11], [-3, -11], [8, -11], [12, -8], [-5, -8], [3, -21], [-8, -30], [6, -9], [-3, -9], [-9, -1], [1, -17], [-7, -7], [1, -9], [-5, -8], [3, -16], [-4, -4], [-4, -33], [-11, -29], [4, -31], [-8, -13], [3, -18], [-9, -14], [2, -9], [-4, -7], [4, -4], [1, -15], [-12, -16], [3, -9], [-7, -14], [0, -14], [-6, -9], [1, -14], [-4, -5], [6, -22], [-6, -16], [-17, 21], [-2, 8], [-7, -2], [-2, -13], [6, -36], [-10, -4], [-9, 4], [-11, 15], [-8, -8], [-3, 6], [-9, 0], [-10, 20], [-9, -5], [1, -11], [-6, -9], [-8, 11], [1, 8], [-15, 9], [7, -10], [-21, -6], [20, 1], [5, -4], [1, -6], [-2, 5], [-9, -6], [-1, -10], [4, -21], [-7, -14], [3, -10], [14, -2], [0, -4], [-22, -11], [-12, 6], [-2, -9], [-16, -7], [-2, -7], [6, -7], [-7, -11], [-22, 7], [-17, 0], [-1, -22], [6, -9], [0, -18], [12, -8], [0, -11], [4, 0], [3, 8], [8, 4], [-2, 11], [4, 6], [9, -14], [2, 21], [3, 1], [6, -10], [-2, -16], [11, -16], [1, 13], [-5, 18], [4, 7], [13, 6], [0, 13], [-9, 6], [-3, 8], [16, 4], [9, -13], [4, -14], [9, 1], [-5, 16], [2, 4], [21, 2], [6, 6], [14, 4], [2, 5], [-1, 5], [-30, 8], [5, 13], [-6, 17], [3, 3], [0, 6], [10, 12], [11, -15], [10, -2], [2, -13], [5, -2], [2, 8], [6, 3], [17, -5], [8, 2], [3, -12], [-6, 1], [2, -8], [7, -4], [3, 3], [9, -7], [-5, -16], [9, -4], [-4, -9], [3, -5], [-11, -14], [-11, 0], [-4, -11], [5, 0], [8, -15], [-4, -12], [4, -2], [-1, -18], [7, -4], [-5, -4], [0, -16], [-9, -9], [1, -12], [-9, -4], [-10, -16], [1, -6], [8, -2], [-1, -10], [-5, -14], [-8, 2], [2, -22], [-20, -26], [1, -7], [9, -10], [-5, -6], [2, -5], [-5, -1], [1, -14], [-6, -3], [-12, -25], [10, -31], [-10, -6], [-13, -27], [-2, -20], [-5, -3], [-5, -12], [-2, -24], [-11, 20], [6, 11], [-9, 6], [-13, 32], [-12, -2], [-4, 5], [-9, 1], [-8, 8], [-14, 0], [-14, -18], [-11, 0], [-18, 23], [-12, 4], [-15, 16], [-7, 44], [12, 12], [4, 13], [-17, 14], [-3, 8], [12, 28], [-18, 5], [-14, 11], [-4, -18], [-8, -2], [-16, -22], [-6, 3], [6, 26], [-3, 21], [-18, 24], [-8, 5], [3, 12], [-7, 21], [7, 15], [-1, 11], [3, 4], [12, 0], [21, -10], [7, 20], [4, -4], [1, -17], [14, -3], [18, 20], [0, 29], [-4, 6], [-9, -10], [-9, 0], [2, 14], [6, 12], [-6, 9], [-8, 3], [-2, -7], [4, -22], [-3, -24], [-13, 0], [-10, 10], [-19, 6], [-9, -3], [-3, 17], [-11, 19], [-8, 6], [3, 11], [-13, 24], [-4, 1], [-2, 4], [1, 6], [8, 4], [7, 14], [2, 28], [-14, 28], [3, 19], [-14, 17], [-5, -9], [-11, 6], [-15, -2], [-4, -39], [-16, -17], [-9, 7], [-20, 62], [0, 37], [4, 10], [-3, 51], [14, 16], [0, 9], [-7, -2], [-3, 19], [-5, 8], [3, 22], [-11, 54], [-7, 7], [-11, 0], [3, 14], [10, 11], [-1, 12], [-9, -14], [-2, 17], [-10, 6], [-10, -13], [-4, 0], [-6, -10], [-11, -8], [-11, 20], [2, 9], [-2, 12], [-10, 12], [11, 21], [5, 24], [9, 10], [0, 16], [5, 11], [-3, 8], [2, 22], [20, 10], [6, 11], [-8, 18], [15, 14], [4, 14], [17, 6], [10, -2], [1, 9], [11, 14], [-5, 11], [9, 16], [7, -8], [17, -38], [12, 0], [4, -6], [7, -38], [-2, -8], [7, -23], [-1, -11], [4, -7], [5, -4], [6, 2], [5, 29], [8, -7], [6, 4], [3, -2], [1, -54], [-4, -17], [9, -21], [-1, 21], [16, 10], [-2, 53], [3, 47], [-5, 10], [-7, 0], [0, 13], [6, 13], [6, 29], [-7, 17], [1, 18], [7, 5], [3, 11], [-3, 49], [4, 16], [7, 2], [-8, 15], [-1, 22], [5, 11], [4, 33], [8, 0], [5, 6], [-7, 12], [5, 9], [-5, 10], [6, -1], [12, 6], [-2, 11], [-10, 1], [-4, 11], [8, 4], [3, 14], [-2, 5], [-9, 6], [-2, 13], [8, 51], [1, 25], [8, 17], [9, 6], [4, 13], [6, 5], [-1, 4], [-8, 2], [8, 41], [5, 8], [-1, 6], [11, 29], [8, 49], [9, 11], [28, 75], [4, 4], [3, -1], [-4, -23], [-18, -43], [-3, -14], [2, -3], [7, 3], [-1, 11], [8, 10], [9, 25], [9, 8], [11, 29], [4, 1], [4, -5], [-1, -27], [2, -3], [4, 24], [7, 0], [3, -14], [5, 11], [-4, 20], [9, 32], [9, 10], [9, 2], [5, -2], [3, -8]], [[54865, 12953], [9, -7], [-2, -8], [-5, -5], [1, -10], [-4, -2], [-1, -8], [4, -12], [-2, -15], [5, -9], [5, 25], [5, 1], [4, 6], [11, -8], [-4, -16], [6, -8], [-4, 8], [4, 22], [-15, 12], [3, 18], [8, -6], [4, -15], [4, 9], [7, -4], [8, 4], [5, -4], [5, 3], [10, -2], [0, -47], [13, -19], [-1, -9], [-6, -9], [0, -7], [4, -3], [-2, -10], [-5, -7], [-25, 1], [-3, 3], [-10, -8], [-9, 9], [-21, 2], [-5, 19], [-10, -10], [-7, 0], [-3, 16], [4, 17], [-4, 6], [5, 6], [-5, 20], [6, 12], [-4, 5], [-2, 23], [6, 5], [2, 11], [11, 5]], [[55199, 12971], [4, -3], [-2, -8], [-4, 6], [2, 5]], [[55168, 12937], [-7, 7], [-4, 11], [2, 12], [8, 6], [7, -7], [-6, -29]], [[54794, 12959], [-6, 4], [2, 10], [5, -6], [-1, -8]], [[55247, 12985], [9, -11], [0, -8], [6, -5], [12, -31], [-1, -23], [-4, 0], [0, 12], [-6, 8], [-18, -8], [-21, 14], [-14, -15], [-1, -8], [-5, 0], [4, -6], [-8, -10], [2, -7], [-5, -14], [-10, 28], [-1, 19], [-10, 22], [2, 17], [7, 9], [10, -2], [3, -19], [3, -2], [1, 6], [6, -5], [2, 21], [5, 8], [17, 10], [15, 0]], [[55640, 12999], [13, -8], [6, -29], [-3, -18], [4, -3], [12, 2], [8, 12], [1, 9], [7, 6], [-2, 10], [5, 15], [12, 0], [2, -20], [-3, -28], [-11, -20], [7, -23], [-1, -31], [-6, -11], [-4, 1], [-4, 11], [-7, 2], [-6, 12], [5, 15], [-1, 8], [-15, -1], [-8, -4], [-16, 7], [-22, 4], [-5, 5], [-2, 11], [5, 4], [6, 32], [9, 9], [-2, 11], [16, 10]], [[55246, 13000], [0, -8], [-2, -1], [-2, 6], [1, 4], [3, -1]], [[54880, 13021], [-5, -4], [7, 14], [1, -6], [-3, -4]], [[55533, 13042], [1, -5], [-7, -10], [-11, 2], [5, 8], [12, 5]], [[54908, 13060], [-16, -77], [-13, -6], [-5, -9], [1, 22], [5, 8], [-2, 6], [6, 4], [2, 17], [-1, 22], [2, 1], [1, -9], [2, 1], [10, 19], [8, 1]], [[54879, 13054], [-2, -8], [-2, 16], [7, 9], [-3, -17]], [[54945, 13019], [-4, -10], [-3, 0], [-4, 9], [-6, -1], [-13, 19], [4, 14], [18, 25], [6, -4], [-1, -10], [6, -9], [-3, -33]], [[54918, 13077], [1, -3], [-4, -4], [-1, 5], [4, 2]], [[54955, 13077], [-5, -15], [-5, 1], [4, 9], [6, 5]], [[55194, 13074], [-2, 5], [7, 5], [1, -6], [-6, -4]], [[54822, 13080], [7, -2], [7, 4], [5, -5], [6, 1], [3, -9], [-9, -20], [2, -10], [-9, -31], [5, -7], [-8, -6], [1, -3], [7, 0], [-11, -16], [-8, -51], [-6, 24], [-7, 9], [-1, 23], [-6, 31], [4, 10], [-4, 8], [6, 20], [-4, 13], [5, 21], [4, 2], [11, -6]], [[54944, 13087], [0, -4], [-5, -2], [0, 4], [5, 2]], [[55335, 13044], [2, -15], [-27, -37], [-5, -14], [2, -35], [-8, -15], [-7, -2], [-8, 19], [0, 12], [10, 34], [-3, 15], [-4, 2], [-3, -7], [-4, 2], [1, 10], [-10, -11], [2, 23], [-13, 4], [-7, -9], [-7, 2], [6, 14], [-5, 8], [-1, 17], [9, 9], [18, 2], [13, -10], [2, -15], [7, 5], [8, -9], [8, 11], [-4, 15], [4, 16], [-3, 14], [12, 15], [5, -28], [-8, -13], [0, -10], [3, -7], [15, -12]], [[54967, 13113], [19, 2], [10, -6], [6, -9], [9, -2], [8, 5], [8, 13], [15, 3], [22, -10], [24, -19], [10, 0], [5, 7], [16, 3], [7, 0], [6, -6], [15, 8], [14, -5], [7, 5], [-2, -10], [18, -1], [-5, -6], [2, -7], [-8, -7], [2, -5], [5, 4], [7, -11], [12, 1], [4, 6], [10, -8], [-3, -11], [-6, -2], [-6, -8], [5, -10], [2, -24], [8, 9], [6, -3], [-6, -8], [3, -9], [-22, -18], [-10, -2], [-20, 2], [-13, -13], [9, -23], [21, -23], [4, -48], [10, -10], [6, -2], [-2, -13], [-12, -5], [-12, 8], [-15, 2], [0, 7], [-20, 8], [-16, -15], [3, -8], [-2, -10], [13, 4], [5, -6], [-1, -9], [-6, -3], [2, -5], [-5, -12], [10, -13], [-11, -10], [-3, -11], [4, -12], [-7, -1], [-4, 9], [-13, 1], [-3, 9], [-6, 6], [-11, -2], [-5, -5], [-9, 6], [-5, -3], [-8, -19], [4, -6], [12, -3], [-15, -15], [-9, -23], [-1, -12], [-8, -7], [-13, 9], [-7, -6], [3, -13], [10, -3], [8, -16], [2, -25], [-8, -5], [-23, 9], [-23, -14], [6, -12], [8, -4], [-2, -13], [-5, -7], [2, -15], [-7, 2], [-8, -5], [-9, 0], [-7, -11], [-10, -5], [-4, -9], [-11, -2], [-6, -11], [-18, 25], [-20, 1], [-14, 8], [-4, 12], [-1, 28], [3, 17], [10, 24], [14, 54], [6, 12], [1, 15], [7, 10], [9, 40], [9, 21], [-1, 13], [6, 10], [-2, 17], [6, 17], [-12, 25], [14, 47], [-2, 13], [-3, 3], [-5, -2], [-9, -12], [-6, 3], [3, 7], [-21, -9], [-7, 6], [2, 15], [-3, 6], [-12, 4], [14, 38], [-1, 8], [6, 21], [3, 1], [12, -16], [16, -9], [16, 22], [6, 15], [7, -2], [9, 15], [-6, 14], [-10, 5], [6, 8], [-5, 11], [-5, 0], [-5, -9], [-7, 1], [9, 35], [11, -6]], [[55628, 13134], [3, -5], [-2, -4], [-22, 2], [12, 7], [9, 0]], [[57341, 13138], [40, -65], [10, 7], [11, -1], [18, -18], [0, -11], [6, -3], [0, -7], [-3, -20], [-9, -7], [18, -74], [-28, -7], [-12, 77], [-8, -2], [6, -74], [-24, 1], [-23, 6], [-19, 10], [45, 62], [-5, 5], [-52, -58], [-25, 61], [-2, 34], [9, 36], [12, 17], [54, -52], [6, 4], [-49, 59], [24, 20]], [[55271, 13164], [-3, 4], [1, 4], [4, -5], [-2, -3]], [[55256, 13180], [-3, 3], [2, 3], [3, -3], [-2, -3]], [[55269, 13179], [-7, 7], [4, 7], [-2, 10], [7, 13], [6, 4], [5, -3], [3, -9], [-16, -29]], [[55236, 13306], [-3, 2], [1, 6], [4, -2], [-2, -6]], [[55138, 13346], [28, -12], [18, 4], [6, -11], [11, -6], [7, 4], [5, 17], [5, 1], [2, -16], [9, -1], [1, -5], [-9, -16], [-13, -8], [4, -22], [-5, -11], [-5, 2], [1, 14], [-5, 6], [-6, -2], [-8, 4], [-15, -15], [-13, 8], [-2, 16], [-11, 1], [-13, 12], [-11, 3], [0, 22], [19, 11]], [[55241, 13343], [-4, 3], [2, 6], [2, 0], [0, -9]], [[55219, 13355], [-2, 1], [1, 2], [1, 0], [0, -3]], [[55167, 13375], [7, -4], [0, -13], [-7, -4], [-12, 3], [-4, 8], [16, 10]], [[55250, 13373], [-8, 3], [2, 11], [10, -7], [-4, -7]], [[55091, 13388], [14, -4], [17, -17], [1, -7], [-17, 0], [-11, 7], [-10, 13], [6, 8]], [[55367, 13360], [-6, -15], [-15, -4], [-6, -9], [-1, -43], [-13, -19], [-11, -40], [-3, -2], [-8, 9], [-18, 5], [-3, 9], [2, 16], [20, 28], [-7, 10], [3, 29], [10, 27], [5, 9], [16, 7], [12, -7], [9, -10], [0, 34], [7, 3], [9, 12], [0, -19], [10, -12], [0, -6], [-12, -12]], [[55187, 13432], [2, -1], [-1, -2], [-2, 1], [1, 2]], [[54751, 13658], [7, -1], [4, -4], [-14, -39], [-18, 16], [-4, 12], [9, 17], [16, -1]], [[54802, 13887], [-4, 3], [3, 3], [3, -3], [-2, -3]], [[54867, 14041], [-2, -2], [1, 5], [3, -3], [-2, 0]], [[54851, 14120], [6, -1], [6, -13], [-4, -10], [-4, 3], [-1, 13], [-6, 5], [3, 3]], [[54856, 14154], [-2, 2], [-1, 4], [3, -1], [0, -5]], [[54698, 14196], [-3, 6], [5, 6], [2, -2], [-4, -10]], [[54835, 14210], [-4, 2], [0, 3], [5, -2], [-1, -3]], [[54852, 14179], [-16, 23], [5, 15], [-10, 1], [0, 7], [5, 3], [-1, 12], [5, -3], [6, -18], [6, -40]], [[54833, 14263], [0, -3], [-3, -2], [1, 4], [2, 1]], [[54834, 14271], [0, -5], [-1, -1], [-2, 6], [3, 0]], [[54836, 14276], [-2, -1], [-2, 0], [1, 4], [3, -3]], [[54821, 14338], [7, 1], [2, -6], [-5, -22], [3, -70], [-4, -26], [21, -35], [7, -18], [1, -14], [-4, -15], [-8, 21], [-2, -2], [-2, -39], [4, -25], [-4, -10], [-6, 4], [-17, -2], [8, 19], [-5, -1], [-1, 8], [9, 17], [-4, 52], [-5, 20], [1, 12], [-6, 16], [-16, 15], [-11, 24], [5, 10], [9, -1], [-4, 10], [6, 21], [10, 10], [4, 26], [7, 0]], [[54858, 14355], [0, -6], [-5, -3], [-1, 3], [5, 10], [1, -4]], [[54867, 14402], [0, -2], [-5, -1], [1, 3], [4, 0]], [[54860, 14421], [3, -8], [-10, -15], [1, -8], [-16, -38], [-6, -6], [-7, 4], [-6, -1], [-5, 11], [8, 13], [4, -1], [3, 21], [7, 12], [2, -1], [-2, 4], [8, 3], [-3, 2], [1, 8], [18, 0]], [[54972, 14422], [-5, 1], [-1, 2], [4, 2], [2, -5]], [[54943, 14398], [-5, 3], [-5, 28], [10, 12], [3, -3], [-3, -18], [4, -14], [-4, -8]], [[54930, 14452], [1, 0], [-7, -3], [0, 5], [6, -2]], [[54988, 14489], [13, -5], [-2, -7], [0, -8], [-11, -6], [-9, 7], [0, 15], [9, 4]], [[55229, 14502], [0, -3], [-5, 0], [1, 6], [4, -3]], [[54919, 14536], [6, -12], [-2, -32], [-2, -7], [-6, -5], [0, 5], [-6, -2], [-5, 7], [4, 8], [4, -1], [1, -5], [4, -3], [-2, 6], [5, 6], [0, 6], [-4, -1], [0, 11], [1, 19], [2, 0]], [[55164, 14535], [-4, 3], [1, 1], [4, -1], [-1, -3]], [[55008, 14532], [13, -33], [-4, -6], [-13, -7], [-19, 5], [-4, 5], [13, 11], [1, 9], [-4, 1], [-15, -8], [-9, 4], [-5, 6], [2, 15], [13, -2], [16, 3], [8, 9], [7, -12]], [[55272, 14546], [-2, -8], [-8, -1], [6, 9], [4, 0]], [[54949, 14547], [0, -3], [-4, 2], [0, 1], [4, 0]], [[55322, 14548], [3, -7], [-6, -5], [-6, 13], [9, -1]], [[54946, 14564], [1, -11], [-7, -7], [-4, 11], [10, 7]], [[55240, 14543], [17, -3], [4, -10], [5, -5], [24, 11], [2, -2], [-11, -12], [-15, -7], [0, -16], [-12, -29], [9, -5], [19, 6], [5, 5], [19, -9], [-2, -24], [5, -34], [15, -12], [10, 4], [-4, -18], [2, -18], [4, -10], [7, 3], [7, -2], [-8, -24], [5, -9], [0, -10], [17, -27], [-2, -11], [-9, -8], [0, -15], [-14, -7], [-12, -16], [-7, -3], [-1, -19], [12, -14], [15, 6], [8, -1], [-1, -20], [7, -10], [23, -10], [0, -13], [13, -18], [-9, -24], [3, -15], [4, -8], [21, -4], [8, -20], [-4, -5], [-12, 9], [-6, -1], [-12, -14], [-5, -15], [0, -10], [6, -3], [-6, -19], [5, -12], [-8, -26], [2, -24], [-10, -38], [0, -43], [-3, -4], [4, -10], [-6, -25], [0, -15], [5, -8], [-2, -11], [11, -23], [-1, -17], [19, -41], [12, -41], [-2, -24], [-6, -18], [-5, -16], [-8, -9], [-2, -21], [7, -19], [-10, -8], [-2, -13], [-9, -2], [-22, 28], [-6, 1], [-16, -38], [-16, -5], [-2, -12], [9, -14], [-10, -9], [28, 6], [5, 11], [16, 7], [13, -7], [-2, -13], [-10, -7], [-8, -1], [-8, -9], [-4, 1], [4, -9], [-11, -19], [-9, -5], [-13, 4], [-18, -14], [-18, 2], [-1, -5], [10, -1], [1, -8], [9, -5], [-10, -14], [2, -14], [-11, -27], [-2, -15], [-10, -1], [-7, 5], [6, 22], [-1, 10], [-12, 12], [-15, 8], [-10, 16], [-17, 13], [-15, 6], [10, 9], [7, 13], [-13, -14], [-23, -4], [-20, 19], [-14, 8], [-22, 28], [0, 27], [-15, 11], [2, 16], [-2, -2], [-7, 8], [-12, 4], [19, -14], [-4, -11], [16, -16], [-3, -20], [16, -29], [43, -36], [12, -6], [8, 4], [25, -19], [16, -21], [8, -23], [-7, -1], [-23, 19], [-15, -11], [-9, -11], [-6, 14], [-16, 14], [-10, -1], [-8, -7], [-10, 5], [-14, -3], [-17, 12], [-3, 7], [-6, -2], [-20, 5], [-13, 12], [-4, -3], [6, -2], [-5, -4], [-19, 5], [-12, 10], [-18, -5], [-1, 20], [8, 19], [-4, 15], [5, 8], [-20, 13], [16, -13], [-4, -10], [3, -15], [-8, -17], [0, -20], [7, -4], [17, 5], [14, -12], [24, -4], [18, -9], [-3, -11], [2, -8], [7, -6], [4, -15], [-2, -4], [12, -2], [6, -6], [-8, -18], [1, -8], [17, -13], [13, -27], [17, -15], [1, -4], [-5, -8], [4, -9], [6, -3], [14, 1], [2, -10], [8, -10], [9, 3], [5, 8], [13, -7], [3, -10], [8, -1], [4, -19], [9, -15], [-4, 0], [-4, 8], [-11, 11], [-8, -2], [-4, 3], [-3, -2], [-2, -24], [8, 0], [-5, -3], [1, -3], [5, 3], [11, -2], [-4, -9], [5, -6], [17, 3], [-4, -14], [-13, 2], [-7, 5], [-18, -24], [-13, 11], [-8, -10], [-25, 2], [-10, -4], [-10, -11], [-22, -4], [-14, -9], [-51, 29], [-15, -5], [-17, -15], [-10, 13], [-14, 4], [-11, -1], [-13, 7], [-5, 9], [1, -5], [-7, -9], [-8, -27], [-3, -1], [-1, 8], [1, 16], [-14, -22], [0, -12], [-6, -5], [-15, 10], [-6, -2], [-8, 6], [-13, -2], [0, 19], [-8, -16], [-9, 2], [-18, -6], [-4, 3], [1, 6], [-8, 18], [-4, 1], [-5, -7], [-9, 17], [3, 28], [-8, 5], [-9, -9], [-4, 4], [3, 18], [-1, 42], [3, 9], [-3, 20], [12, 11], [-5, 6], [-1, 13], [-8, 2], [-4, 23], [2, 29], [5, 16], [-6, 30], [11, 35], [-2, 24], [10, 13], [-11, 31], [-5, 6], [10, 42], [11, 19], [-8, 12], [-8, 6], [-1, 24], [-12, 4], [-3, 7], [1, 10], [5, 4], [1, 12], [4, 5], [-1, 25], [3, 10], [3, 5], [7, 0], [4, 5], [-7, -1], [12, 21], [-2, 13], [-7, 8], [9, 24], [-8, 8], [4, 14], [-6, 7], [7, 22], [-5, -1], [-9, 7], [-25, 6], [-7, -2], [-4, 5], [-1, 11], [5, 18], [2, -9], [9, -9], [7, -2], [17, 14], [4, -13], [7, 16], [5, 4], [6, 18], [7, 47], [10, -1], [-1, -13], [8, -24], [4, -2], [5, 18], [16, 8], [4, 6], [-7, 28], [3, 11], [13, 8], [9, 18], [14, -5], [6, 12], [22, -7], [25, 4], [7, -6], [5, -20], [0, -39], [-7, -13], [3, -9], [-1, 12], [6, -1], [-1, -16], [14, -13], [-5, -15], [4, 2], [2, 15], [-13, 12], [4, 15], [-4, 38], [4, 2], [2, -3], [2, 29], [10, 22], [-5, 25], [2, 52], [-18, 14], [16, -18], [-4, -27], [-35, -52], [-19, -2], [-18, 9], [-18, -9], [-5, 3], [-12, -1], [-8, 6], [7, 17], [-1, 7], [-5, 10], [-6, 6], [-5, -1], [-1, 5], [4, 12], [25, 5], [5, -2], [-6, 9], [-2, 25], [3, 16], [11, 4], [-10, 5], [-5, 25], [-3, -5], [2, 12], [-8, 2], [-9, 10], [-3, 11], [3, 14], [-11, 30], [-11, 50], [6, 20], [-7, 2], [-1, 20], [8, 51], [7, 5], [6, 13], [5, 1], [13, -59], [4, 19], [-4, 24], [6, 18], [3, -2], [3, -25], [3, 35], [20, 14], [0, 6], [10, -1], [2, 22], [4, 6], [6, -16], [24, -26], [-2, -21], [3, -9], [12, -9], [5, -41], [9, 8], [-7, -2], [-4, 32], [6, 2], [-21, 14], [-1, 11], [3, 15], [-10, 9], [-5, 13], [4, 16], [-2, 10], [4, 4], [8, -4], [8, 6], [4, -4], [2, -34], [3, 28], [24, 7], [-1, 40], [2, 6], [-5, 7], [1, 10], [26, 17], [16, 1], [30, -5], [6, -18], [8, -7], [8, 2], [12, 14], [6, -1], [2, -13], [-6, -17], [3, -6], [7, -2], [64, 15], [4, 7], [-9, 9], [2, 10], [16, 8], [16, -4], [12, 3], [9, 9], [5, 13], [0, 13], [-7, 16], [7, 13], [-3, 8], [2, 4], [6, -4], [2, -7], [-6, -16]], [[54962, 14579], [3, -2], [1, -10], [-4, -16], [-5, -4], [-5, 12], [3, 7], [-2, 8], [3, 4], [6, 1]], [[55192, 14581], [16, -6], [4, -15], [-12, -6], [-3, 7], [-9, 7], [-4, -5], [-1, -19], [-18, 1], [-14, 23], [3, 15], [14, 1], [7, -3], [9, 6], [8, -6]], [[54943, 14582], [2, -11], [-7, -5], [-5, 7], [0, 9], [6, 6], [4, -6]], [[55227, 14593], [0, -2], [-8, -3], [2, 5], [6, 0]], [[55246, 14602], [2, 0], [2, -6], [-8, 6], [4, 0]], [[54733, 14619], [-3, 0], [0, 3], [5, -1], [-2, -2]], [[54727, 14631], [2, -3], [-3, -1], [-1, 5], [2, -1]], [[54787, 14722], [4, -6], [6, -3], [7, 2], [0, -4], [7, 1], [1, -4], [6, 2], [-2, 4], [5, -1], [0, -8], [8, -1], [-3, -4], [15, -10], [0, -38], [-6, -17], [0, -14], [-6, -10], [3, -7], [5, 3], [4, 9], [4, -5], [-3, -31], [3, -11], [-2, -7], [-11, -2], [9, -7], [0, -23], [6, -12], [-3, -13], [2, -5], [-1, -22], [-3, -13], [-6, -5], [-4, -1], [-6, 7], [-10, 1], [8, -4], [2, -11], [11, 1], [3, -9], [-8, -11], [-8, -22], [-12, -14], [-8, -3], [-2, -12], [3, -4], [-6, -12], [-25, -15], [-14, 2], [-8, 7], [-11, -6], [6, -6], [-4, -23], [20, 14], [5, -7], [-3, -6], [7, -17], [-3, -1], [-1, -9], [-9, -1], [0, -7], [-14, 0], [-4, -3], [-7, -37], [-9, -23], [-1, 20], [-16, 11], [1, 3], [5, -3], [5, 6], [3, 11], [-2, 22], [-11, 15], [-1, 24], [-9, 7], [-6, 14], [-6, 21], [0, 18], [-6, 16], [6, 3], [0, 13], [8, -1], [19, 28], [-74, 4], [0, 4], [77, -4], [5, 14], [-2, 17], [4, 4], [-4, 16], [12, 8], [-1, 15], [-76, 3], [1, 14], [74, -3], [1, 12], [8, 12], [-1, 11], [6, 3], [-2, 6], [5, 5], [-2, 3], [6, 2], [-2, 6], [4, 11], [-6, -2], [-5, 8], [-16, -1], [4, 5], [-1, 24], [9, 6], [1, 10], [19, 29], [3, 12], [10, 2], [1, 8], [15, 2]], [[55481, 14734], [-14, -20], [-17, -6], [-11, -24], [-19, -21], [1, -16], [19, -11], [0, -4], [-17, -9], [-1, -4], [0, -14], [6, -10], [0, -8], [-8, -4], [-12, 6], [-1, 5], [-5, 1], [4, 4], [-3, 3], [1, 5], [-6, 3], [-25, -4], [-5, -6], [-9, 1], [6, 2], [3, 12], [9, 7], [17, -5], [9, -8], [6, 3], [-3, 22], [-25, 0], [-16, 13], [0, 19], [9, -8], [5, 1], [5, 7], [-2, 7], [-5, 0], [1, 8], [-13, 4], [-5, 8], [6, 7], [6, 1], [4, 14], [3, 2], [6, -9], [12, -8], [0, -4], [-10, -4], [0, -3], [11, -9], [-1, -6], [7, -5], [10, 13], [6, 0], [0, 11], [10, 3], [5, 10], [7, -1], [-9, 15], [2, 6], [18, -6], [16, 8], [1, 5], [11, 1]], [[55440, 14737], [-4, 0], [0, 4], [7, 1], [-3, -5]], [[55271, 14747], [-4, 3], [1, 4], [3, -5], [0, -2]], [[55354, 14791], [-3, 0], [-3, 8], [-4, 2], [9, -2], [1, -8]], [[55302, 14798], [7, -2], [16, 7], [7, -2], [-3, -11], [9, -6], [-7, -20], [11, -29], [-6, -5], [-12, 1], [-8, 10], [-12, -2], [-7, 5], [-7, 0], [-12, 32], [16, 17], [-4, 5], [3, 11], [7, -2], [2, -9]], [[55284, 14836], [-9, 5], [4, 12], [6, -9], [-1, -8]], [[55318, 14858], [-2, 1], [-1, 7], [5, -3], [-2, -5]], [[55281, 14878], [-8, 9], [0, 12], [8, -10], [0, -11]], [[54865, 14967], [2, -6], [-7, -7], [-1, 6], [6, 7]], [[54839, 14975], [4, -9], [-22, -13], [-13, -18], [-3, -9], [6, -12], [-1, -7], [-11, 1], [-12, 47], [1, 10], [7, 8], [15, -8], [14, 2], [15, 8]], [[55008, 15145], [6, -4], [-1, -4], [-8, 2], [3, 6]], [[55603, 15264], [-5, 1], [-2, 11], [4, -2], [3, -10]], [[55503, 15412], [-3, -2], [-2, 3], [4, 1], [1, -2]], [[55633, 15457], [9, -4], [0, -4], [-13, -5], [-4, 7], [8, 6]], [[55508, 15519], [14, -3], [0, -5], [-6, 0], [-2, -21], [-4, -2], [9, -18], [0, -8], [-4, -6], [-8, 13], [-20, 6], [2, 14], [12, -2], [4, 29], [-6, 4], [4, 4], [5, -5]], [[55395, 15526], [-5, 7], [9, 7], [-5, -7], [1, -7]], [[55502, 15541], [0, -2], [-5, -1], [1, 7], [4, -4]], [[55550, 15545], [-2, 4], [3, 4], [1, -4], [-2, -4]], [[55639, 15602], [1, -4], [-9, 7], [5, 2], [3, -5]], [[55651, 15607], [-4, 3], [2, 5], [4, -3], [-2, -5]], [[55605, 15646], [-1, 5], [3, 3], [2, -3], [-4, -5]], [[55167, 15717], [3, -2], [0, -2], [-5, 0], [2, 4]], [[55049, 15732], [13, -8], [-9, -31], [-7, 6], [4, 18], [-4, 14], [3, 1]], [[55677, 15727], [2, -5], [-3, 1], [-6, -13], [-6, -1], [-3, 14], [12, 10], [4, -6]], [[55627, 15747], [-3, -8], [3, -22], [-7, 0], [-3, 25], [12, 17], [-2, -12]], [[55687, 15770], [9, -3], [3, -11], [-12, 2], [-6, 12], [5, 5], [1, -5]], [[55116, 15782], [7, -24], [-10, -12], [-22, -17], [-11, 6], [-8, -3], [-3, 2], [-4, 15], [5, 15], [-2, 8], [4, -1], [5, 7], [12, -3], [21, 5], [5, 11], [1, -9]], [[58309, 15838], [2, -6], [8, -1], [-6, -10], [4, -12], [-4, -28], [-7, -10], [-14, -6], [-6, -9], [-16, 1], [-15, 25], [1, 13], [7, 3], [3, 11], [21, 29], [8, -5], [9, 6], [5, -1]], [[55186, 15950], [-3, -6], [3, -12], [-7, -6], [-9, 8], [-1, 9], [7, 9], [10, -2]], [[55285, 15958], [6, -6], [-10, -14], [-7, 1], [3, 15], [8, 4]], [[55265, 16009], [6, -9], [-15, -7], [-3, 8], [5, 8], [7, 0]], [[55187, 16018], [8, -7], [-6, -8], [-4, 5], [2, 10]], [[55484, 16052], [-5, 4], [1, 7], [1, -2], [3, -9]], [[55594, 16078], [0, -9], [-7, -7], [-4, 12], [11, 4]], [[55532, 16094], [22, -57], [5, -35], [6, -9], [2, -12], [-6, -13], [3, -34], [-9, -15], [4, -15], [-4, -14], [-11, -8], [7, -6], [-7, -11], [2, -13], [-4, -10], [-7, -4], [-15, 7], [-12, -7], [1, -3], [24, -7], [8, -8], [5, -11], [-1, -3], [-3, 4], [-1, -3], [5, -17], [-2, -22], [-6, -6], [-12, 3], [-13, -6], [21, -8], [5, -7], [10, 5], [8, -1], [-9, -23], [19, -15], [-2, -11], [2, -4], [16, 7], [12, 14], [8, 19], [3, -3], [-5, -37], [-3, -5], [2, -7], [3, 0], [10, 15], [9, 5], [2, -3], [-5, -11], [2, -10], [-5, -5], [-10, -9], [-14, 4], [-4, -7], [-4, 2], [-9, -39], [-9, 6], [-8, -5], [-17, 1], [-12, -5], [17, 4], [15, -3], [7, 4], [8, -3], [14, 20], [10, -20], [6, -31], [7, -4], [13, -27], [8, -2], [7, 3], [-2, -12], [4, -4], [11, 0], [8, 5], [6, -18], [-7, -7], [-25, -9], [-9, -15], [1, -14], [-4, -23], [-8, -4], [-3, -5], [-7, 9], [2, 6], [-6, 17], [2, 18], [-4, 11], [-13, -2], [-17, -18], [-9, 0], [-6, 6], [4, 36], [9, 18], [-4, 20], [-10, 16], [5, 14], [-8, -4], [-8, -12], [5, 4], [4, -4], [7, -12], [-1, -8], [-15, -7], [-4, -9], [-11, 0], [-9, 9], [-11, 4], [-7, -3], [-9, 8], [-18, 1], [-30, -26], [-3, -8], [1, -19], [-5, -4], [-6, 1], [-10, 12], [-1, 10], [-6, 9], [0, 14], [-3, 3], [-7, -5], [-1, 2], [1, 10], [-6, 7], [3, 9], [-3, 2], [-11, -2], [-21, -36], [-8, 2], [-2, -3], [6, -11], [1, -15], [25, -20], [30, -1], [5, -6], [10, -4], [3, -6], [25, -4], [0, -8], [4, -3], [14, 21], [8, 0], [-6, -25], [7, 2], [8, -7], [2, -20], [9, -5], [7, 3], [1, -6], [-5, -5], [-16, 5], [9, -13], [-6, -13], [-7, -5], [4, -13], [22, 5], [8, 12], [10, -7], [5, -11], [13, 10], [12, -2], [5, 6], [2, -11], [-15, -17], [12, -26], [47, 31], [-4, -19], [-11, -7], [-5, -12], [0, -19], [-5, -9], [3, -15], [-1, -12], [-12, -14], [-18, -10], [7, -30], [-10, -9], [-2, -14], [-8, -12], [-11, -39], [11, -18], [-7, -20], [8, -56], [-15, -26], [4, -11], [-2, -20], [4, -30], [4, -8], [-3, -12], [4, -5], [-2, -25], [-12, -2], [-5, -6], [-2, -13], [10, -7], [-7, -15], [-16, -30], [-11, 2], [-7, -6], [-1, -5], [5, -5], [-11, -1], [3, -9], [-15, -26], [-3, 1], [0, 6], [-8, 0], [-9, 8], [-10, -6], [-1, -15], [-12, -1], [-5, -4], [-4, 8], [-22, 5], [-11, 13], [1, -21], [5, -9], [0, -10], [10, -7], [4, 3], [3, -5], [-3, -3], [-17, 1], [-9, 8], [-7, -4], [-11, 8], [-1, 10], [-8, 15], [-24, 15], [-12, 17], [-3, 12], [4, 8], [11, 2], [6, 6], [-5, 10], [3, 11], [-9, 18], [2, 15], [-5, 17], [-2, -47], [-3, -9], [-14, 3], [-7, -12], [-7, -1], [-16, 32], [-4, -1], [-5, -20], [-27, -5], [-10, -6], [-9, -12], [-5, -14], [5, 3], [1, 8], [17, 18], [15, 0], [25, -9], [-15, -49], [-12, -26], [-5, -1], [8, -11], [6, -41], [8, -4], [5, 8], [5, -3], [0, -17], [5, -6], [-3, -4], [5, -5], [6, -1], [12, 7], [13, 0], [-5, -21], [13, 2], [4, -24], [-6, -9], [-9, -3], [-2, -11], [-6, -8], [-12, 6], [-9, -1], [-14, -32], [-10, 11], [4, 26], [-8, 13], [1, 41], [-18, 3], [2, 17], [-6, 3], [-12, -13], [-8, -16], [-4, 3], [-9, -2], [3, -10], [-9, -14], [5, -8], [-15, -13], [6, -14], [-11, -18], [1, -4], [8, -3], [1, -7], [-17, -23], [-26, 1], [0, -9], [-8, -9], [-1, -26], [5, -9], [8, 0], [-6, -8], [4, -14], [13, -3], [12, 16], [8, 2], [6, -3], [1, -6], [-9, -11], [-7, -24], [7, -18], [-34, -11], [-35, -5], [5, 21], [-3, 15], [-10, 0], [-18, -13], [-5, 4], [-3, 17], [-4, 4], [-37, 7], [-13, -2], [-10, 27], [-8, 9], [3, 26], [-4, 11], [11, 2], [6, 19], [-4, 8], [1, 14], [-16, 8], [-3, 11], [2, 26], [3, 2], [8, -7], [0, 14], [-10, 21], [3, 13], [12, 15], [15, -21], [10, 3], [6, -3], [4, 8], [6, 1], [2, 3], [-3, 6], [-10, 2], [-3, 6], [-7, -1], [0, 10], [16, 2], [7, 4], [2, 10], [8, 4], [4, 15], [-19, -5], [-4, -8], [-9, 5], [-10, -6], [-5, 13], [-10, -6], [-19, 5], [-6, 18], [14, 27], [-5, 8], [7, 15], [-5, 18], [5, 5], [-7, 13], [2, 17], [8, 12], [-3, 20], [4, 12], [-4, 8], [2, 10], [9, 5], [4, -8], [-4, -13], [6, -12], [6, -6], [10, 1], [2, 8], [-9, 3], [4, 8], [-8, 7], [5, 17], [0, 14], [9, 9], [5, 1], [16, -20], [2, 3], [-5, 11], [3, 8], [-2, 8], [4, 10], [7, 5], [-2, 3], [-18, -1], [-14, 28], [19, 2], [3, 10], [7, 4], [3, 0], [5, -8], [7, 4], [6, -17], [5, 5], [2, 8], [10, -7], [5, 0], [2, 9], [-8, 12], [7, 7], [11, 0], [-12, 16], [-20, -3], [-3, 10], [-5, 0], [-18, -10], [-2, 8], [-15, 9], [-10, 2], [7, 12], [1, 19], [7, 10], [-5, 6], [3, 4], [5, -5], [23, 4], [10, -7], [7, 7], [-20, 17], [-6, -6], [-11, 12], [7, 6], [5, 16], [-13, 4], [4, 7], [-4, 9], [6, 2], [11, 14], [7, 1], [5, 11], [-16, 9], [12, 15], [-9, 1], [5, 9], [0, 21], [8, 14], [11, 2], [7, -2], [10, -14], [13, 6], [10, 42], [-15, 13], [-15, -4], [-5, -5], [-7, 20], [-6, 5], [-5, 0], [-8, -8], [1, 6], [-11, 21], [6, 9], [-1, 18], [9, -1], [9, -7], [13, 4], [-7, 16], [15, 19], [-8, 11], [-11, -5], [-27, 12], [4, 4], [13, 2], [5, 8], [-9, 7], [-3, 21], [19, 25], [-2, 7], [4, 15], [-4, 11], [5, 13], [0, 20], [6, 8], [2, 13], [5, 7], [6, -2], [13, -14], [11, 18], [23, 6], [3, 10], [-6, 10], [-11, -10], [-28, 11], [-9, 10], [1, 19], [4, 6], [1, 9], [10, 7], [5, -1], [4, -6], [12, 0], [4, -11], [10, -7], [5, 3], [9, 22], [6, -9], [-3, 16], [-9, 4], [-2, 6], [5, 14], [5, 2], [5, -6], [5, 9], [16, 7], [-8, 33], [-9, -1], [-8, 10], [7, 29], [-12, 13], [3, 5], [-1, 9], [2, 2], [8, -4], [2, 11], [21, 6], [12, -1], [6, -6], [9, 3], [11, 20], [2, 13], [-2, 17], [7, 3], [15, -3], [6, 7], [8, 1], [4, -11], [3, -1], [15, 14], [-15, 27], [9, 7], [2, 10], [-21, 4], [-9, 10], [-1, 12], [8, 12], [6, 3], [9, -2], [7, 6], [10, 0], [13, 0], [4, -5], [6, -2], [11, 2], [10, 14], [10, 3], [10, -6], [9, 6], [10, -6], [2, -8], [5, 0], [10, -25], [16, -3], [11, 3], [8, 20], [-6, 1], [-7, 20], [-10, 7], [-3, 10], [10, 11], [-2, 11], [9, 12], [0, 7], [-3, -1], [2, 9], [5, 2], [8, -8], [-1, -11], [15, -11], [6, -1], [8, -15], [3, -24], [4, 2], [-2, -4], [4, -4], [1, 5], [8, -1], [-1, 9], [4, 7], [-3, 16], [4, 0], [3, 13], [-2, 2], [-3, -12], [2, 29], [7, 7], [9, -2], [8, 15], [6, -14]], [[55236, 16161], [12, -2], [3, -10], [-25, -24], [-8, -22], [-8, -7], [-9, 21], [5, 0], [10, 29], [20, 15]], [[55609, 16285], [8, -8], [-6, -8], [-13, -2], [-8, -9], [-4, -23], [-12, -22], [2, -4], [-5, -2], [-10, 37], [22, 25], [9, 16], [17, 0]], [[55519, 16325], [-2, 1], [0, 7], [3, -5], [-1, -3]], [[55501, 16337], [15, -14], [-1, -7], [8, -15], [-2, -7], [4, -9], [-2, -14], [15, -34], [-1, -11], [-9, -5], [-8, 1], [-14, 13], [-6, 14], [-1, 12], [-25, 7], [-6, 6], [-14, -12], [-6, 2], [-12, -6], [-6, 4], [0, 10], [-16, 15], [1, 5], [8, 5], [-1, 11], [3, 4], [39, 6], [9, 6], [8, -7], [4, 14], [14, 1], [-2, 2], [4, 3]], [[55967, 17139], [6, -9], [-4, -25], [16, -43], [-3, -20], [-18, -8], [-9, 7], [-1, 6], [6, 46], [-3, 43], [7, 5], [3, -2]], [[56285, 17213], [-3, -2], [-4, 4], [1, 21], [7, -10], [-1, -13]], [[56323, 17403], [-4, -1], [-3, 2], [3, 3], [4, -4]], [[56284, 17471], [5, -19], [19, 0], [4, -3], [-8, -5], [-8, 2], [-4, -7], [1, -27], [17, -25], [-7, -24], [3, -12], [-4, -9], [1, -22], [-9, -16], [-4, -20], [2, -13], [-8, -7], [3, -12], [-7, -12], [0, 10], [-7, 9], [-2, 9], [-13, 5], [-5, 10], [6, 6], [-1, 7], [8, 3], [12, 33], [-4, 42], [-5, 11], [2, 4], [-16, 57], [1, 8], [9, 2], [12, 13], [7, 2]], [[56263, 17556], [7, -1], [3, -2], [-9, -6], [-6, 4], [5, 5]], [[56293, 17558], [6, -9], [-9, -21], [-4, -4], [-6, 6], [-8, 1], [-3, 12], [10, 5], [1, 5], [7, 0], [6, 5]], [[56695, 18952], [-3, 3], [3, 7], [1, -1], [-1, -9]], [[56741, 19099], [-5, 5], [2, 2], [5, -3], [-2, -4]], [[56744, 19130], [-4, -1], [-2, 4], [4, 1], [2, -4]], [[56745, 19156], [-1, -5], [-9, 6], [3, 3], [7, -4]], [[56898, 19232], [4, -11], [-13, -16], [-4, -34], [2, -6], [-8, -2], [-23, -19], [-11, -26], [-13, -20], [0, -25], [-5, 11], [-2, 15], [6, 20], [4, 44], [16, 25], [11, 33], [8, 7], [8, -2], [20, 6]], [[56914, 19308], [8, -5], [-3, -7], [-10, 13], [5, -1]], [[20884, 21635], [11, 53], [3, 34], [-2, 13], [-14, 10], [-7, 12], [10, 70], [-19, 8], [-7, 20], [1, 7], [-15, 20], [-3, 12], [11, 41], [-3, 4], [4, 12], [7, -1], [8, 45], [-22, 15], [0, 10], [11, 31], [12, 11], [14, 4], [-32, 26], [-19, 3], [4, 25], [-1, 50], [-10, 26], [10, 47], [15, 21], [-3, 45], [4, 16], [16, 6], [14, -2], [5, 5], [-1, 15], [-19, 3], [-19, -4], [-11, 3], [-2, 60], [25, 19], [5, 24], [41, 7], [11, -2], [3, -7], [18, -10], [13, 47], [8, 10], [49, 26], [20, -21], [15, -7], [21, 2], [4, 8], [-8, 13], [5, 21], [0, 17], [-14, 38], [16, 22], [-44, -3], [-39, 13], [-22, 19], [-21, 8], [-37, 40], [-19, 0], [-35, 14], [-29, 5], [-97, -9], [-23, -22], [-12, -5], [-24, 0], [-52, 21], [-34, 20], [-46, -8], [-21, 7], [-23, 20], [-58, 14], [-49, 21], [-45, 64], [-14, 41], [-52, 49], [8, 11], [13, -2], [16, -10], [75, 9], [15, 5], [9, 18], [2, 24], [27, -5], [34, -20], [43, 3], [0, 6], [10, 2], [8, -5], [33, 2], [6, 42], [22, 20], [49, 13], [25, -6], [7, 10], [1, 62], [-31, 6], [-15, 27], [-11, 4], [3, 13], [14, -5], [10, 7], [34, -5], [8, 3], [35, 38], [44, -1], [17, 8], [0, 7], [-11, 11], [3, 8], [8, 0], [-1, 22], [-22, 6], [0, 16], [4, 14], [13, 11], [10, 27], [12, 18], [-4, 8], [-18, 4], [-39, -30], [-24, 4], [7, 11], [-13, 5], [-5, 13], [-25, 11], [-1, 19], [46, 9], [21, 18], [34, -4], [7, 14], [9, 71], [-5, 8], [-13, 3], [-10, -6], [-24, 8], [-19, -15], [-16, 10], [-10, 0], [-5, 6], [2, 8], [6, 1], [2, 7], [-5, 14], [13, 22], [9, 31], [4, 32], [-4, 34], [5, 13], [16, -7], [50, -8], [9, 6], [1, 40], [-20, 20], [-13, 45], [8, 48], [0, 25], [-6, 58], [-12, 6], [4, 10], [4, 44], [-6, 10], [27, 12], [5, 8], [1, 16], [-7, 2], [-3, 10], [5, 13], [-3, 12], [-1, 31], [12, 2], [22, 34], [2, 17], [-4, 35], [11, 20], [23, 17], [13, 3], [-3, 19], [-13, 15], [2, 27], [-3, 14], [-11, 13], [-20, 39], [-5, 21], [5, 6], [-2, 9], [-19, 11], [-18, 28], [5, 27], [-23, 8], [-9, 9], [-22, 8], [-10, -8], [-23, 6], [-44, 22], [-11, 21], [-51, 14], [-2, 25], [-19, 6], [-15, 24], [11, 9], [-3, 10], [10, 17], [-1, 15], [7, 17], [24, 8], [22, -3], [4, 34], [13, 5], [0, 6], [-32, 4], [-8, 8], [-2, 8], [35, 31], [7, -3], [14, 13], [21, -17], [7, 6], [6, 40], [5, 9], [32, 19], [12, 17], [16, 3], [11, 14], [-4, 26], [-13, 5], [-29, -2], [9, 20], [6, 3], [20, 40], [4, 29], [8, 26], [3, 16], [-15, 12], [0, 31], [4, 17], [62, -2], [-9, -3], [-6, -12], [5, -9], [18, -11], [21, 2], [15, -3], [24, 12], [25, 7], [16, 23], [5, 14], [-8, 2], [-12, 18], [27, 29], [5, 13], [-5, 5], [-15, -1], [-36, 16], [-1, 35], [30, 22], [22, 10], [34, -14], [20, 0], [34, -13], [1, 58], [38, -14], [13, -13], [32, 4], [1, 60], [52, 6], [14, 8], [8, 45], [19, 20], [-8, -28], [-2, -24], [80, -20], [2, 29], [5, 15], [2, 17], [-5, 16], [-6, -3], [-2, 6], [-7, -4], [-29, 12], [-21, 27], [-15, -1], [-10, -5], [-27, 10], [-27, -2], [-10, 17], [-30, 3], [-9, 7], [-17, -3], [2, 39], [-6, 32], [-10, -1], [0, -9], [-55, -11], [-27, -10], [-10, 12], [-17, 39], [-20, 5], [-31, -38], [-9, -19], [-18, -19], [-11, 6], [-15, 54], [-36, -3], [-4, 9], [-7, -2], [-8, 15], [-9, 6], [-48, 11], [5, 33], [-3, 20], [2, 6], [11, 1], [-2, 12], [7, 25], [10, 19], [-5, 4], [-8, 34], [-5, 3], [1, 22], [8, 20], [4, 35], [-1, 25], [9, 6], [7, 12], [31, 12], [6, -7], [10, 4], [5, 9], [8, -7], [11, 7], [11, 22], [24, -3], [10, 12], [29, 10], [11, 7], [26, -4], [11, 19], [17, 2], [6, 16], [17, 14], [9, 41], [-26, -7], [-39, 21], [-6, 11], [-25, 11], [-31, 1], [-10, 6], [14, 45], [16, 14], [18, 10], [0, 35], [39, -1], [2, -21], [11, 2], [11, 29], [11, 20], [9, 7], [-3, 17], [9, 1], [3, 39], [12, 16], [11, -4], [8, 11], [25, -14], [9, 2], [3, 15], [-12, 6], [-21, 45], [4, 23], [33, -11], [11, 4], [27, -6], [5, 25], [1, 39], [-6, 19], [7, 15], [10, -2], [10, 12], [0, 12], [-11, 10], [13, 12], [5, -22], [8, -8], [11, -2], [8, -7], [7, 16], [-10, 10], [3, 12], [18, 4], [3, 12], [-14, 2], [-8, 8], [12, 11], [2, 18], [-5, 3], [-3, 14], [-18, 8], [-21, -9], [-16, 13], [5, 7], [-3, 8], [-15, 4], [-13, 10], [-7, 18], [-17, -6], [-16, -13], [-11, 8], [-5, 27], [-23, 14], [-38, 10], [-10, -1], [-2, 29], [-9, 3], [-5, 13], [3, 24], [21, -4], [8, 21], [16, 12], [22, 2], [28, 8], [17, 9], [7, 36], [-9, 51], [-7, 16], [10, 57], [-19, 3], [-23, 21], [-15, 40], [-5, 24], [-13, 2], [0, 25], [22, -2], [24, 40], [-28, 56], [20, 37], [24, 13], [24, 38], [-11, 8], [-31, 4], [-22, 9], [1, 6], [-9, 3], [-21, -18], [-25, 20], [11, 16], [34, 24], [-7, 23], [-30, 31], [-59, 19], [-17, 24], [4, 36], [20, 26], [25, 23], [18, 6], [13, 71], [-45, 7], [2, 6], [-23, 9], [6, 31], [13, 4], [27, -4], [31, -13], [15, 9], [16, 1], [25, 15], [-5, 4], [1, 15], [-55, 10], [-20, 0], [-9, 13], [1, 6], [26, -2], [5, 6], [23, -2], [13, 40], [32, -6], [5, -18], [18, 2], [6, 26], [-2, 14], [-20, 6], [-17, 21], [2, 17], [21, 12], [11, 16], [-2, 7], [-16, -4], [0, 12], [11, 16], [-2, 30], [30, 0], [5, -13], [6, 2], [1, 13], [29, 5], [11, -13], [14, 21], [19, -3], [1, -7], [6, 0], [-6, -20], [-9, -12], [27, -21], [10, 14], [31, 19], [15, -1], [66, 32], [35, -7], [19, 8], [-2, 20], [26, 61], [2, 38], [-11, 38], [-30, 50], [3, 30], [5, 1], [0, 15], [-11, 5], [10, 28], [26, 19], [12, 13], [0, 19], [18, 22], [15, 2], [9, -15], [2, -26], [38, -15], [0, 24], [35, 51], [1, 31], [17, 27], [29, 66], [10, 42], [22, 50], [156, 52], [48, -18], [30, 1], [6, 23], [-2, 24], [-32, 10], [6, 11], [-18, 7], [2, 12], [-43, 19], [-16, 2], [-1, 37], [-24, 3], [-12, 27], [-2, 29], [-27, 4], [-28, -10], [-36, 12], [1, 24], [7, 21], [10, 3], [11, 49], [-52, -5], [-7, -11], [-32, 9], [5, 23], [-5, 2], [9, 53], [-67, 4], [-12, -18], [-32, 12], [3, 42], [-6, 19], [-1, 19], [-3, 10], [-9, 7], [-6, 14], [8, 53], [-3, 19], [5, 7], [20, -14], [16, -4], [11, 1], [18, -10], [14, 1], [-4, 23], [4, 10], [-8, 14], [8, 9], [9, 23], [-3, 24], [1, 10], [5, 7], [28, 4], [16, -17], [14, -27], [30, 4], [14, 8], [0, 6], [-9, 8], [2, 43], [-15, 11], [-10, 33], [-7, 7], [15, 6], [26, 40], [3, 29], [7, 4], [-1, 18], [12, 9], [-31, 18], [4, 20], [14, 18], [-1, 12], [14, 21], [7, 18], [1, 19], [7, 9], [6, 19], [-1, 22], [38, 12], [16, -8], [19, -2], [12, 26], [-11, 24], [-57, 6], [-30, 10], [-2, 8], [4, 19], [-4, 16], [23, 8], [9, 8], [29, 8], [11, 21], [28, -13], [15, 5], [22, 19], [9, 14], [25, 9], [7, 16], [19, -3], [62, -48], [19, -28], [59, -19], [14, -11], [20, -42], [13, -11], [29, -7], [8, -19], [-4, -17], [1, -19], [7, -14], [14, -5], [40, 16], [15, 20], [29, -12], [9, -10], [62, 2], [27, -16], [24, -23], [45, 15], [30, 13], [7, 18], [-7, 28], [0, 42], [22, 57], [5, 27], [-1, 24], [5, 17], [-23, 16], [-10, 16], [-6, 18], [10, 35], [7, 65], [-12, 38], [36, -10], [16, 16], [22, 30], [20, 17], [21, -3], [27, -9], [14, 2], [48, 57], [19, -2], [21, -10], [13, 0], [26, 18], [7, 22], [0, 32], [-4, 17], [-14, 17], [-10, 24], [-10, 79], [-35, 49], [14, 5], [25, -5], [6, 7], [1, 13], [14, 2], [11, 10], [2, 16], [-4, 19], [2, 42], [-5, 17], [-22, 28], [-14, 49], [-11, 24], [-34, 14], [-6, 7], [36, 62], [42, -3], [25, 5], [15, 31], [50, 24], [-2, 25], [3, 24], [17, 8], [17, 38], [16, 64], [-2, 32], [-15, 26], [-19, 11], [-28, 7], [-7, 13], [12, 33], [-6, 15], [-80, 16], [-20, 9], [8, 56], [23, 83], [5, 10], [41, 8], [15, -14], [-1, -14], [-18, -12], [-8, -10], [5, -11], [24, -17], [24, -4], [42, 3], [20, -8], [21, 0], [0, -37], [4, -26], [8, -15], [18, -23], [26, -16], [44, -16], [80, -16], [26, 0], [39, -54], [22, -2], [13, 20], [6, 31], [16, 14], [16, 4], [131, -24], [22, 14], [19, 0], [24, -10], [11, -11], [36, -11], [29, -6], [85, -27], [21, -1], [13, -9], [17, -31], [16, -14], [19, 6], [15, 9], [15, 15], [55, -9], [23, 9], [26, -2], [27, -24], [14, -20], [10, -5], [21, 6], [47, 4], [17, -9], [25, -64], [1, -27], [13, -54], [0, -41], [-9, -25], [-1, -29], [43, 1], [29, -4], [28, 22], [27, 8], [43, -14], [19, 7], [24, -4], [16, -11], [17, -22], [-14, -75], [7, -31], [28, -33], [5, -13], [-6, -12], [-53, -40], [-10, -13], [11, -13], [42, -5], [11, 3], [32, 26], [16, -6], [27, -37], [14, -9], [46, 12], [28, 0], [19, -15], [8, -18], [23, -6], [51, 5], [14, -6], [-1, -21], [5, -15], [79, -28], [38, -36], [27, -43], [19, -16], [25, -5], [66, 14], [10, 7], [-5, 19], [-27, 22], [-4, 16], [3, 16], [17, 29], [17, 15], [19, 8], [10, 15], [6, 36], [-2, 21], [4, 20], [22, 43], [-3, 22], [-24, 29], [-1, 24], [15, 7], [25, -3], [28, -11], [57, -23], [26, -16], [10, -19], [11, -39], [16, 15], [18, 4], [88, -5], [5, -23], [68, -51], [26, -15], [22, -2], [16, 6], [24, -4], [38, -35], [15, -23], [12, -27], [22, 15], [29, 3], [45, 30], [6, 10], [-2, 47], [25, 9], [37, 6], [11, -53], [11, -14], [29, -22], [38, -18], [19, -3], [15, 5], [7, 9], [14, 75], [19, 45], [12, 15], [41, 24], [29, 4], [57, -1], [15, 7], [63, 9], [61, 47], [58, -7], [25, -6], [18, -10], [2, -9], [15, -22], [27, -8], [25, -18], [15, -59], [11, -17], [63, -47], [16, -8], [15, -21], [18, -10], [53, -10], [20, -10], [28, -34], [37, -31], [11, -14], [2, -42], [30, -35], [24, -39], [7, -20], [-6, -45], [-7, -17], [-7, -57], [-16, -38], [1, -24], [13, -42], [-4, -21], [-28, -21], [-9, -11], [-29, -59], [-27, -77], [-1, -27], [7, -27], [28, -47], [16, -18], [2, -13], [-6, -14], [-32, -9], [-45, -45], [-78, -45], [-18, -16], [-11, -28], [4, -31], [3, -73], [-10, -42], [6, -18], [26, 3], [44, 23], [27, 6], [29, -2], [22, -11], [16, -31], [3, -18], [-7, -111], [22, -88], [0, -142], [-4, -43], [-13, -33], [-18, -18], [-47, -6], [-23, -10], [34, -57], [16, -22], [35, -30], [111, -24], [25, -2], [43, -16], [14, -37], [25, -6], [7, -5], [30, -60], [16, -8], [19, -3], [28, -33], [10, -2], [7, 2], [5, -4], [50, -55], [9, -3], [12, -1], [11, 13], [22, 10], [25, 2], [15, 17], [21, 6], [8, -5], [6, -9], [6, -24], [8, -6], [41, -4], [11, 30], [17, 21], [14, 8], [14, 1], [25, -12], [23, 11], [24, 2], [31, 30], [16, 9], [7, -11], [16, -6], [41, -59], [52, -151], [27, -60], [23, -24], [25, 11], [6, 7], [9, 20], [6, 3], [10, 2], [8, -3], [24, -23], [27, 22], [19, 10], [31, 4], [4, 5], [73, 37], [28, -9], [11, 0], [35, 13], [11, -3], [22, -22], [28, -5], [7, -6], [3, -13], [6, -9], [24, -23], [7, -18], [19, -8], [39, -24], [23, -27], [30, -9], [31, -20], [12, -9], [22, -28], [7, -17], [17, -7], [13, -12], [12, 2], [5, -9], [3, -18], [-6, -10], [2, -11], [31, -46], [6, -16], [42, -26], [10, -12], [14, -6], [6, -21], [19, -10], [7, 0], [9, -11], [-8, -3], [-10, -36], [50, -32], [11, 9], [19, -1], [5, -13], [-11, -20], [-18, -19], [1, -10], [14, -17], [3, -9], [-3, -25], [8, -26], [19, -27], [18, -39], [4, -13], [0, -35], [15, -11], [4, -14], [9, -16], [14, -7], [7, -8], [24, -44], [17, -4], [7, -9], [-2, -18], [-6, -8], [-114, -57], [-2, -58], [5, -53], [23, -17], [39, -4], [54, 3], [25, 5], [29, 28], [-1, 12], [17, 9], [1, 75], [-3, 15], [4, 14], [12, 6], [12, 1], [10, -2], [12, -12], [44, -5], [18, -45], [0, -9], [-14, -11], [-27, 4], [-2, -6], [9, -34], [-1, -35], [9, -40], [0, -20], [13, -16], [1, -9], [43, 0], [44, 5], [25, 9], [44, 26], [11, 13], [17, 5], [12, 17], [10, 6], [43, 3], [3, -38], [-5, -20], [-52, -48], [-4, -15], [5, -44], [-13, -40], [19, -22], [30, -67], [-8, -28], [23, -91], [12, -103], [12, -34], [3, -29], [16, -8], [5, -12], [23, -179], [18, -51], [45, -64], [11, -8], [17, -5], [24, -3], [40, 8], [30, 40], [4, 18], [19, 15], [53, 26], [85, 57], [73, -13], [63, -42], [75, -40], [21, -4], [78, -1], [62, 6], [70, -5], [60, -17], [2, 8], [21, 3], [33, -7], [12, 12], [-1, 15], [12, 10], [14, 2], [18, -14], [8, -1], [49, 23], [16, 0], [8, -4], [10, -31], [9, -13], [5, -4], [11, -1], [23, 10], [34, 0], [95, 23], [33, 27], [13, -1], [56, -28], [26, 0], [10, 15], [18, 6], [28, 28], [14, 7], [8, 18], [-1, 22], [25, 39], [24, 13], [22, -2], [13, 5], [11, 12], [21, -21], [12, -34], [123, 76]], [[30369, 26291], [24, -35], [28, -19], [25, -43], [4, -20], [-15, -11], [-12, -17], [-41, -5], [-25, -28], [-31, 8], [-21, -5], [-45, -34], [-12, -13], [-13, -35], [-15, -21], [-15, -12], [-23, -8], [-73, -4], [-42, -7], [-10, -10], [-13, -27], [-8, -8], [-61, -31], [-12, -10], [-8, -18], [-2, -16], [-2, -56], [-6, -12], [-18, -15], [-15, -24], [-21, -50], [-22, -35], [-34, -27], [-16, -21], [-6, -15], [0, -13], [-14, -20], [40, -33], [7, -7], [-1, -7], [-49, -72], [-5, -18], [-3, -51], [3, -20], [-3, -27], [-10, -31], [0, -26], [5, -13], [-5, -28], [-48, -69], [-46, -50], [-22, -39], [-18, -16], [-30, -7], [-10, -24], [-21, -1], [-47, -15], [-30, 5], [-49, 27], [-14, 17], [-1, 23], [-13, 11], [-15, 4]], [[29414, 25107], [-18, -6], [-24, -34]], [[29372, 25067], [-50, -88], [-17, -19], [-32, -23], [-22, 7], [-87, -2], [-63, 13], [-20, -12], [-21, -40], [-3, -21], [1, -71], [8, -15], [13, -13], [-28, -29], [-11, -23], [-39, -2], [-61, -17], [-75, -26], [-50, -22], [-35, 23], [-6, -22], [-9, -11], [-11, -6], [-19, -25], [-47, -6], [-31, -11], [-14, 0], [-65, 20], [-57, 40], [-37, 1], [-19, -10], [5, -20], [-2, -21], [4, -14], [14, -19], [-6, -39], [3, -17], [-9, -9], [-30, -4], [-16, 1], [-41, 12], [-8, -51], [-8, -15], [-18, -16], [20, -37], [-4, -33], [-13, -31], [5, -42], [-9, -16], [-22, -26], [-28, -17], [-7, 16], [-14, 12], [-44, 12], [-23, 1], [-17, 10], [-86, 18], [-47, 22], [-93, 10], [-6, -10], [-13, -7], [-59, -16], [-22, 1], [-12, 9], [8, 16], [1, 15], [39, 28], [3, 9], [-24, 16], [-46, 17], [10, 20], [-38, 15], [-20, -2], [-20, 9], [-48, 37], [-30, 7], [-25, -34], [-16, -8], [-14, -1], [-14, -15], [-22, -13], [-17, -4], [-35, 4], [1, -16], [-22, -43], [-4, -63], [-6, -14], [-23, -29], [-42, -3], [-15, -47], [-58, 19], [-6, 9], [-7, 31], [-30, 29], [-5, 13], [2, 13], [-10, 29], [-11, -3]], [[27315, 24362], [-36, -31], [-16, -15]], [[27263, 24316], [2, -10], [23, -43], [-1, -26], [13, -8], [11, -14]], [[27311, 24215], [-1, -16], [-3, -10]], [[27307, 24189], [-35, -17], [1, -20], [-4, -10], [-26, -29], [88, -32], [33, -7], [68, -22], [76, -56], [25, -9], [-5, 23], [3, 23], [10, 27], [41, -14], [24, -14], [25, 33], [84, -56], [33, 0], [14, -36], [-3, -10], [-16, -10], [-2, -15], [10, -22], [3, -31], [-23, -2], [-26, -10], [-2, -62], [-4, -15], [-17, -28], [3, -14], [25, -4], [10, -11], [32, -13], [26, -35], [14, -10], [-77, -40], [-15, -19], [-36, 12], [-37, 6], [-27, -4], [-16, 3], [-47, 14], [-11, 13], [-31, 16], [-32, 5], [-3, 38], [-6, 21], [-46, 20], [0, 8], [-20, 5], [-4, 19], [-6, 12], [-42, 18], [-1, -43], [-11, -16], [-33, -13], [-4, -16], [-4, -5], [-7, 1], [-13, 37], [-13, 56], [-6, 11], [-17, -4], [-36, 6], [6, 26], [-23, 10], [-18, -1], [-7, 31], [0, 26], [-6, 40], [5, 1], [-17, 27], [-14, 76], [-28, 49], [-60, 80], [-27, -7], [-20, -11], [-12, -2], [-40, 41], [-10, -1], [-27, -14], [-13, 12], [-3, 57], [-27, 6], [-26, -34], [-7, -16], [-55, -53], [-5, -19], [-15, -18], [-30, 3], [-12, -2], [-4, -9], [-16, -2], [-40, 15], [-9, -24], [1, -34], [-86, 5], [-20, -68], [-41, -41], [-20, -28], [-32, -70], [-8, -34], [50, -24], [43, -1], [2, -32], [5, -15], [12, -15], [62, -30], [-27, -75], [-13, -25], [-8, -62], [-11, -12], [-23, -19], [-36, -47], [-32, -21], [-24, -25], [-42, -78], [-33, -41], [-35, -22], [-42, -5], [-48, 17], [-25, 28], [-23, 63], [-16, 29], [-26, 23], [-38, -4], [-42, -12], [-35, -3], [-60, 82], [-19, 11], [-26, -6], [-28, -17], [-38, -52], [-24, -12], [-89, -6], [-32, -15], [-29, -23], [-17, -29], [-33, -2], [-37, 8], [-38, -3], [-57, -46], [-45, -21], [-39, -8], [-54, 5], [-34, -7], [-104, -51], [-16, -36], [-20, -19], [-17, -7], [-54, -5], [-155, -5], [-30, -6], [-55, -20], [-65, -14], [-12, -35], [-67, -65], [-12, -26], [-3, -38], [16, -24], [9, -26], [2, -29], [-21, -14], [-17, -34], [-14, -105], [1, -46], [-4, -27], [26, -29], [11, -32], [4, -87], [-10, -118], [-15, -25], [-25, -21], [-34, -18], [-34, -14], [-57, 18], [-40, 28], [-23, 3], [-122, 1], [-58, 16], [-26, 2], [-24, -4], [-22, -9], [-40, -28], [-74, -26], [-75, -36], [-39, -26], [-6, -22], [0, -40], [34, -74], [3, -28], [-26, -39], [-21, -18], [-26, 3], [-37, 27], [-7, 27], [-7, 53], [-8, 21], [-14, 13], [-23, 3], [-19, -7], [-13, -12], [-3, -22], [7, -53], [15, -40], [-2, -21], [-7, -16], [-33, -59], [-31, -38], [-73, -53], [-47, -7], [-34, 1], [-56, 13], [-61, 32], [-26, 21], [-14, 15], [-24, 37], [-47, 48], [-44, 17], [-30, -6], [-81, -81], [-18, -13], [-27, 0], [-32, 14], [-83, 25], [-99, 19], [-68, 4], [-34, -4], [-48, -22], [-31, -28], [-38, -12], [-28, -5], [-21, -13], [-34, -42], [-53, -2], [-54, 15], [-25, -8], [-12, -14], [16, -48], [2, -25], [-19, -56], [-6, -6], [-12, -74], [-11, -18], [-23, -14], [-50, -15], [-57, -39], [-1, -13], [5, -17], [-6, -19], [-18, -31], [-5, -32], [-9, -10], [-59, 4], [-27, -4], [2, -33], [-16, -11], [-23, -7], [-19, 2], [-83, 39], [-12, 14], [-21, 48], [-18, 3], [-2, 61], [-8, 10], [-17, 1], [-10, -9], [-16, -9], [-34, -84], [-19, 4], [-46, 31], [-22, 4], [-42, -2], [-36, 3], [-46, 20], [-44, 26], [-25, 0], [-21, -8], [-26, -39], [-12, -5], [-36, 4], [-19, -4], [-17, -10], [-42, -10], [-45, 9], [-42, 18], [-23, -2], [-25, 6], [-31, 15], [-19, 4], [-37, -14], [-16, -12], [-20, -4], [-55, 6], [-24, 6], [-19, 10], [-31, 38], [-43, 30], [-40, -12], [-38, 13]], [[21022, 21615], [-51, 3], [-87, 17]], [[27057, 15826], [7, -11], [15, -6], [4, -9], [-6, 6], [-18, 9], [-4, 8], [2, 3]], [[26951, 15907], [0, -8], [-7, -1], [0, 4], [7, 5]], [[26963, 15909], [5, -6], [-10, -4], [-2, 7], [7, 3]], [[27036, 15968], [4, -5], [-2, -7], [4, -10], [-5, -26], [-2, 9], [4, 17], [-5, 14], [2, 8]], [[26874, 15970], [6, -6], [4, -12], [-20, 5], [-1, 12], [11, 1]], [[26856, 16005], [-2, -7], [-9, 2], [0, 2], [11, 3]], [[26563, 16132], [6, -1], [2, -5], [-11, 4], [3, 2]], [[26776, 16201], [2, -9], [-7, -9], [9, 2], [12, -10], [12, -2], [3, -4], [-3, -21], [6, -9], [7, 0], [1, -5], [-5, -14], [-12, -7], [0, -24], [-13, -36], [-18, -23], [-10, -3], [-10, 21], [0, 17], [5, 1], [2, 10], [-10, 19], [-18, 12], [-3, 15], [2, 4], [14, 3], [10, 8], [19, 0], [22, -5], [4, 4], [-24, 3], [-5, 3], [-2, 7], [-44, 12], [2, -4], [7, -3], [4, -10], [-3, -7], [3, -5], [-9, -2], [-14, 41], [6, 3], [3, -1], [-2, -3], [6, -2], [4, 3], [25, 3], [15, 11], [7, 16]], [[26660, 16255], [-1, -9], [-11, -3], [4, 8], [8, 4]], [[26681, 16282], [4, -14], [-5, -4], [-5, -18], [-5, -2], [-3, 6], [14, 32]], [[26673, 16341], [8, -2], [-4, -21], [-6, 21], [2, 2]], [[26577, 19933], [6, -5], [0, -1], [-7, 5], [1, 1]], [[26914, 20645], [2, -5], [-4, -1], [-2, 4], [4, 2]], [[28739, 21269], [4, -2], [-2, -4], [-12, -13], [-8, 0], [13, 8], [5, 11]], [[28192, 21439], [17, -15], [2, -9], [5, -3], [-5, -5], [-5, 0], [-16, 28], [2, 4]], [[28203, 21452], [5, -4], [-3, -9], [-6, 9], [4, 4]], [[28198, 21483], [5, -4], [-1, -23], [-5, 4], [-4, 13], [1, 7], [4, 3]], [[28170, 21496], [6, -9], [3, -16], [6, -8], [1, -11], [-19, 30], [0, 10], [3, 4]], [[29886, 22661], [12, -11], [-1, -4], [-75, 2], [6, 8], [10, 3], [4, 0], [2, -7], [4, -2], [8, 0], [11, 2], [7, 7], [12, 2]], [[29871, 22662], [-4, -8], [-4, 0], [2, 7], [6, 1]], [[31617, 23183], [0, -6], [-5, -1], [1, 5], [4, 2]], [[31494, 23422], [3, -7], [-2, -13], [-4, 15], [3, 5]], [[31577, 23508], [0, -1], [0, 0], [0, 0], [0, 1]], [[31596, 23513], [3, -5], [-5, -3], [-15, -4], [3, 6], [14, 6]], [[31612, 23535], [-2, -15], [-9, -2], [0, 6], [11, 11]], [[31650, 23533], [-2, 3], [3, 5], [3, -8], [-4, 0]], [[31650, 23533], [4, -12], [8, 0], [-4, -10], [8, -2], [13, -23], [-1, -3], [-7, 1], [-14, -13], [-2, -8], [4, -9], [15, 10], [2, 6], [10, 6], [2, 8], [9, 6], [0, 7], [-12, 0], [0, 6], [-11, -5], [-7, 19], [21, -7], [7, 1], [7, -8], [8, 0], [13, 13], [0, 9], [-4, 10], [-7, -1], [-4, 5], [5, 2], [10, -3], [8, -10], [-3, -10], [-21, -32], [-7, -4], [-23, -33], [-23, -23], [-16, -26], [-10, -30], [-8, -11], [2, -18], [-4, -2], [-1, -27], [3, -6], [-6, 6], [-1, 11], [-7, 6], [-1, 10], [6, 11], [-7, 9], [-4, 0], [4, -18], [-3, -9], [11, -16], [1, -10], [6, -9], [-1, -7], [3, -3], [-9, -30], [-7, -14], [-3, 0], [-18, 12], [-11, 13], [-31, 71], [-36, 1], [-15, 8], [-8, 11], [-3, 15], [22, 33], [-8, 33], [-8, 11], [40, 7], [20, 10], [15, -2], [2, 4], [24, 2], [15, 5], [21, 13], [11, 17], [9, 1], [-6, 7], [1, 10], [5, 9], [7, -1]], [[33525, 25525], [1, -5], [-4, -2], [2, 6], [1, 1]], [[33824, 25798], [-1, -3], [-6, -2], [2, 3], [5, 2]], [[33838, 25798], [-18, -9], [-14, -3], [30, 12], [2, 0]], [[33744, 25855], [-3, -2], [0, 4], [3, 1], [0, -3]], [[31577, 23508], [8, 20], [-4, 25], [-8, 16], [-9, 7], [-10, -5], [-19, -43], [-38, -8], [-82, -5], [-14, 2], [-21, 23], [-2, 8], [21, 32], [5, 13], [-9, 3], [-15, -8], [-9, -11], [-23, -17], [-18, -22], [-19, 2], [-13, -7], [10, -20], [33, -19], [20, -2], [29, 5], [26, -12], [43, -31], [27, -4], [2, -38], [5, -13], [-17, -27], [0, -13], [10, -14], [0, -4], [-5, 2], [0, -4], [8, -4], [13, 3], [28, -14], [14, -24], [12, -37], [5, -4], [-1, -7], [-11, -11], [-47, -8], [-7, -20], [-6, -6], [7, 4], [8, 18], [18, 2], [19, 8], [9, -1], [12, 6], [4, -1], [11, -24], [-4, -20], [-7, -7], [-2, -9], [-10, -14], [-4, -2], [-2, 6], [-17, -2], [-24, -18], [12, -10], [13, 1], [9, 7], [20, 2], [8, 3], [-1, 4], [26, 5], [-2, 13], [9, -6], [0, -10], [-28, -10], [-25, -15], [-66, -18], [-72, -27], [-118, -61], [-2, -4], [-46, -24], [-19, -6], [-3, -5], [-46, -24], [-10, -1], [-6, 8], [-1, -7], [4, -4], [-10, -7], [-82, -42], [-60, -37], [-20, -7], [-9, 2], [-13, -10], [1, -4], [4, 2], [5, -2], [-23, -12], [-1, -7], [-9, 1], [-20, -11], [-3, -7], [-3, 0], [2, 4], [-3, -1], [-60, -33], [-66, -31], [-8, -8], [-45, -3], [-72, -17], [-85, -28], [-72, -33], [-107, -63], [-60, -27], [-19, -4], [0, -4], [-12, -5], [-1, -4], [-18, -5], [-10, -7], [-3, 3], [3, 3], [-3, 4], [4, 10], [-10, 4], [-11, -2], [-61, 32], [-14, -3], [-9, 4], [-64, 2], [-137, 22], [-51, 4], [-4, 3], [2, 12], [-18, 0], [-24, 17], [-14, 0], [-15, -12], [-10, 4], [2, 6], [-13, 1], [-9, -9], [-9, 0], [-4, -5], [-7, 2], [-24, -4], [-9, 3], [-57, 0], [-60, -7], [-74, -15], [-4, 4], [8, 5], [-2, 2], [-6, -2], [-3, 11], [-3, -1], [2, -14], [-5, -4], [-15, 8], [-8, 15], [-11, 4], [-3, 15], [-22, -5], [-3, 6], [-5, 0], [-10, -6], [-9, -12], [1, -8], [-8, -3], [5, -3], [-2, -7], [-13, -19], [-17, -17], [22, 7], [9, 16], [11, 10], [14, 3], [-12, 11], [0, 4], [32, 18], [6, -2], [5, -12], [7, -2], [-2, -7], [12, -12], [1, -7], [-80, -29], [-64, -28], [-92, -57], [-42, -36], [-6, 7], [-7, -24], [-44, -50], [-16, -28], [-10, -7], [0, -8], [-29, -52], [-18, -57], [-11, -23], [-5, -34], [3, -28], [-4, -10], [-5, -2], [-1, 7], [-6, -11], [-32, 1], [27, -5], [16, 4], [-9, -38], [-19, -55], [-78, -153], [-30, -48], [-4, -53], [6, -25], [9, -11], [-1, -16], [-7, -2], [-16, 3], [-8, -3], [-2, -13], [-6, -10], [-89, -79], [-10, -15], [-32, -30], [-45, -62], [-36, -33], [-31, -35], [-22, -43], [-3, 5], [-3, -2], [0, -17], [-2, 21], [-3, 0], [0, -14], [-4, 0], [0, -7], [-7, 1], [-8, -26], [-7, 0], [4, -14], [-2, -11], [3, -18], [12, -21], [3, -15], [11, -18], [3, 5], [-3, 6], [3, 0], [6, -11], [3, -23], [-3, -5], [-11, -2], [1, -22], [-12, -14], [-76, -47], [-23, -10], [-5, 0], [-34, -22], [-8, 2], [-8, 11], [-114, -24], [-63, -8], [-9, 2], [-2, -4], [-22, -1], [-35, 9], [-14, 16], [-7, 20], [-27, 27], [-8, 11], [-9, 31], [-16, 24], [-11, 31], [0, 21], [4, 6], [0, -8], [7, -8], [5, 1], [-2, -14], [4, -17], [11, -4], [-3, -25], [10, -10], [3, -13], [5, -3], [6, -13], [9, -6], [14, -4], [3, 7], [-6, 18], [-3, 32], [-11, 20], [-5, 30], [-13, 28], [-11, 42], [1, 5], [6, 1], [33, -3], [-2, 14], [4, 27], [-14, 22], [-37, 37], [-7, 5], [-9, -3], [-17, 17], [-12, -7], [-35, 17], [-43, 12], [-49, 11], [-49, 3], [-7, 3], [-19, -5], [-77, -7], [-12, -5], [-87, -14], [-73, -21], [-48, -20], [-8, 0], [-10, 6], [-10, -8], [-7, 1], [9, -6], [-3, -4], [-69, -24], [-157, -75], [-11, -10], [-36, -19], [-110, -72], [-27, -25], [-20, -11], [-18, -21], [-44, -42], [-86, -109], [-7, -3], [-16, -36], [-1, -11], [-34, -65], [-22, -59], [-25, -102], [3, -37], [-6, -10], [0, -13], [-21, -37], [0, -7], [-6, -6], [4, -6], [-4, -14], [-9, 7], [-7, -12], [-5, -2], [1, -4], [-8, 0], [0, -7], [25, 2], [-9, -38], [-15, -34], [-50, -67], [-68, -80], [-44, -61], [-38, -67], [-13, -36], [-1, -15], [-6, -6], [-7, 0], [5, -13], [-7, -11], [-6, -3], [-35, 7], [14, -9], [29, -6], [-18, -38], [-17, -63], [-1, -31], [10, -39], [2, -43], [-11, -58], [-12, -13], [-18, 8], [-8, 12], [-26, 22], [-20, 6], [40, -41], [-5, -1], [-1, -3], [36, -20], [9, 10], [-33, -67], [-28, -95], [-12, -54], [-1, -41], [6, -117], [9, -67], [18, -88], [13, -82], [15, -28], [21, -86], [8, -135], [-4, 3], [-5, -3], [7, -2], [3, -22], [-18, -3], [-28, 22], [-12, 4], [-8, -4], [17, -2], [14, -13], [4, 0], [-1, -7], [16, -6], [11, 1], [10, 7], [5, -2], [2, -33], [15, -63], [24, -60], [4, 0], [4, -6], [-2, -25], [6, 6], [1, 8], [-4, 4], [2, 2], [20, -22], [2, -9], [14, -16], [9, -21], [2, -16], [-18, -28], [11, 2], [3, 12], [10, 12], [-3, 17], [-9, 19], [2, 1], [13, -25], [7, -22], [1, -16], [11, -35], [0, -10], [13, -37], [5, -31], [31, -82], [25, -18], [10, -4], [10, 1], [6, -13], [5, -3], [4, -16], [-34, -119], [-17, -8], [-5, 6], [-3, -2], [3, -8], [10, 1], [5, 4], [4, -8], [-6, -42], [-7, -89], [-8, -116], [-1, -93], [-6, -60], [-11, -48], [-8, -13], [-33, -84], [-18, -64], [-2, -44], [-5, -7], [-4, -18], [3, -8], [-6, -12], [-9, -54], [-3, -51], [1, -71], [-3, -4], [4, -14], [4, -68], [-8, -2], [0, 11], [3, -1], [1, 6], [-4, 11], [-1, -32], [-8, -14], [8, 10], [2, -17], [5, 1], [3, 5], [-5, -2], [-2, 17], [7, 2], [18, -116], [8, -10], [-1, -18], [2, -2], [8, -44], [6, -13], [-1, -18], [5, -9], [-1, -12], [8, 7], [-7, 14], [3, 6], [9, -23], [-3, -18], [8, -15], [0, -15], [5, -3], [3, -11], [0, -8], [-3, -1], [3, -6], [6, -1], [-4, -8], [4, -13], [11, -14], [1, -21], [5, 1], [3, -10], [1, 8], [-9, 23], [2, 6], [-6, 5], [2, 2], [-2, 9], [-3, 1], [-1, -6], [-3, 3], [5, 12], [-14, 44], [-7, 11], [-4, 18], [54, -120], [3, -14], [5, -6], [32, -95], [24, -41], [1, -8], [4, -2], [21, -46], [15, -58], [19, -47], [9, -17], [12, -13], [9, -45], [-3, -5], [6, -8], [5, -35], [-7, -42], [-22, -74], [-12, -80], [-3, -65], [3, -6], [-2, -8], [2, -1], [5, -56], [13, -55], [38, -76], [0, -7], [27, -56], [27, -73], [29, -96], [12, -25], [-1, -6], [14, -13], [6, -14], [4, -17], [-1, -7], [4, -2], [4, -13], [0, -26], [-12, -3], [-8, 4], [-10, 15], [-19, 16], [-12, 28], [-5, 19], [4, -5], [2, 22], [-3, 6], [-5, -2], [-1, 19], [-6, 7], [1, 30], [-9, 22], [0, 27], [-5, 11], [1, -19], [-4, -7], [-4, 5], [-2, 17], [-4, 2], [-5, -6], [-7, 4], [13, 12], [-7, 18], [0, 18], [-6, 11], [0, 30], [-21, 21], [-11, 4], [2, 16], [-15, 16], [-7, 27], [-33, 25], [2, 3], [-5, 3], [-15, 32], [-9, 9], [-34, 15], [-20, 21], [-5, 13], [5, 28], [-2, 16], [-13, 18], [-24, 22], [-4, 14], [-3, -1], [-2, -6], [-5, 0], [-27, 39], [-11, -1], [-4, 4], [-2, -7], [-6, 0], [-9, 20], [5, 0], [-1, 6], [-8, 1], [-5, 14], [10, -11], [1, 11], [7, -1], [7, 5], [0, 9], [-14, -4], [-1, 4], [3, 2], [-16, 2], [-10, -6], [2, -25], [11, -3], [1, 5], [9, -31], [6, 3], [-7, -27], [6, -24], [1, -26], [10, -23], [-4, -19], [3, -12], [-7, -4], [-2, -17], [4, -18], [-14, -40], [-13, -7], [-15, 4], [-17, 22], [1, 17], [-16, 18], [-7, 15], [2, 15], [-4, 13], [5, 10], [18, 1], [0, -7], [-2, -2], [0, 3], [-4, 0], [-1, -3], [11, -10], [-2, -6], [-16, -14], [20, 8], [3, 17], [-5, 7], [-1, 17], [6, 3], [9, 15], [-4, 17], [-9, 1], [4, -8], [-2, -10], [-9, 4], [-6, 9], [-7, -11], [-6, 0], [-4, 6], [4, 16], [-5, 8], [5, 1], [0, 12], [7, 7], [-11, 18], [6, 18], [-6, 3], [-5, -4], [-1, -12], [-8, -1], [5, -15], [7, -1], [4, -5], [-7, -13], [-8, -1], [-1, -22], [9, -41], [-2, -15], [-5, -3], [-8, 0], [2, 20], [-3, 1], [-10, -18], [-9, 0], [18, 25], [-3, 10], [-12, -10], [-5, 2], [-9, -16], [-10, -7], [4, -13], [22, 2], [0, -6], [8, -3], [-7, -4], [-22, -2], [-20, -18], [-5, -15], [3, -12], [-1, -26], [8, -2], [3, -7], [-3, -6], [-10, -4], [-1, -10], [-8, 1], [-8, -7], [-4, -11], [-5, -2], [-6, 4], [-4, -3], [3, -10], [-8, 0], [-3, -5], [16, -26], [19, -11], [15, -34], [7, -4], [2, -6], [24, -7], [6, -19], [14, -5], [2, -11], [4, -1], [-2, -11], [3, -5], [8, -4], [12, -19], [7, -2], [-1, -5], [7, 3], [9, -6], [1, -7], [-7, 0], [-1, -7], [-3, 0], [2, -4], [5, -1], [-1, 9], [2, 0], [1, -11], [16, -1], [3, 13], [-5, 10], [9, 4], [24, -14], [8, -10], [12, -24], [29, -17], [15, 0], [14, 10], [12, 2], [11, -7], [60, -12], [57, -6], [-6, 7], [5, 2], [10, -14], [14, -11], [0, -11], [13, -1], [4, 5], [16, -4], [11, -14], [-1, -19], [5, -4], [11, -29], [8, -10], [-3, -2], [11, -3], [-12, -1], [0, -15], [-13, -20], [-3, -14], [20, 44], [12, 0], [5, -8], [11, 6], [10, -10], [1, -8], [12, -1], [3, -6], [-4, -13], [6, -7], [-2, 14], [4, 7], [11, 7], [11, 0], [-4, -23], [11, -99], [-3, -4], [1, -7], [-7, -5], [-43, 33], [-24, 5], [-14, 9], [-5, 20], [13, 4], [1, 6], [-5, 13], [-14, 13], [-8, 3], [-4, 9], [-4, 41], [-10, 28], [-30, 43], [-36, 27], [-42, 13], [-18, -10], [-21, -5], [-41, 7], [-28, -4], [-25, 4], [-54, 47], [-16, 8], [-45, 7], [-11, 11], [-18, 39], [-18, 7], [-7, -8], [-15, 27], [-9, -7], [-32, -10], [-13, -20], [-25, 0], [-37, 8], [-22, 17], [-31, -7], [-9, -6], [1, -40], [36, 12], [4, -16], [12, -10], [12, -6], [15, 6], [16, -5], [9, -6], [-2, -35], [-67, 8], [-4, -23], [-20, -44], [-10, -1], [0, 7], [-7, 0], [-43, -13], [-15, -13], [3, -25], [-4, -30], [5, -24], [-11, -11], [-17, -11], [-15, 6], [-18, -3], [-8, -12], [7, -46], [33, -7], [7, -19], [-12, -16], [-19, 4], [1, -26], [-25, -34], [-8, -18], [-33, 18], [-10, -11], [-5, -13], [-27, -21], [-37, -17], [-10, -13], [-12, -2], [-15, 7], [-17, -24], [-46, -4], [-49, 7], [-18, -1], [-12, -14], [-17, -33], [-17, -6], [-26, 18], [-32, 31], [-7, -9], [-2, -19], [-8, -26], [-10, -8], [-46, -10], [1, -16], [70, -52], [50, -22], [18, -14], [3, -11], [-3, -14], [-22, 0], [-23, -21], [-12, -7], [-13, -3], [-17, -23], [-14, 8], [-1, 17], [-9, 11], [-3, 12], [-13, 5], [-8, 11], [-10, 2], [-6, -20], [-9, -9], [-13, -3], [-14, -15], [-16, 11], [-8, 0], [16, 38], [0, 24], [-9, 11], [-17, -11], [-8, -13], [-17, 3], [-5, 15], [6, 26], [24, 23], [-11, 30], [-24, 30], [-6, -21], [-8, -12], [-11, 1], [-9, 14], [-22, -3], [-11, 7], [-14, -6], [-6, -30], [-12, 3], [-8, -8], [-12, 4], [-23, 16], [-9, 1], [-28, -17], [-7, -31], [-11, -4], [-34, 9], [-23, 23], [-14, 19], [-5, 16], [-11, 12], [-6, 51], [-7, 25], [-29, 11], [-55, -3], [-24, 4], [-18, 12], [-55, 7], [-57, -2], [-26, -4], [-96, -45], [25, -19], [44, -22], [37, 3], [7, -13], [-15, -16], [2, -19], [-15, -21], [-9, -25], [-2, -22], [5, -22], [-3, -21], [5, -17], [14, 0], [3, 15], [19, 10], [21, 17], [14, -2], [7, -17], [0, -12], [-53, -20], [3, -22], [-4, -14], [5, -13], [-7, -7], [-51, 4], [-11, -4], [-19, 0], [-13, -5], [-21, -15], [4, -18], [-8, -7], [-14, -22], [-14, 12], [-15, 4], [-3, -67], [18, -11], [-10, -11], [-13, -4], [-15, -1], [-5, 10], [-11, -15], [-31, -4], [-9, -13], [-6, -16], [0, -17], [-4, -7], [-24, 1], [3, 41], [-24, 8], [-7, 11], [-16, -7], [-8, 2], [-6, 41], [-9, 8], [-14, -2], [-10, -10], [-9, 12], [-3, 11], [-9, 5], [-7, -17], [-2, -18], [-14, -15], [-8, 2], [-15, 16], [-19, 2], [-8, -18], [8, -17], [10, -11], [-10, -13], [0, -15], [-9, -17], [-15, -13], [-31, -4], [-10, -12], [-4, -18], [-14, -23], [-4, -17], [-22, -17], [12, -7], [-5, -15], [9, -12], [1, -20], [-8, -25], [-6, -9], [-40, -20], [-25, 7], [-49, 30], [-34, 3], [-48, -27], [-31, 4], [-33, 33], [-2, 23], [-21, 13], [-23, 5], [-17, 9], [-7, 16], [-50, 4], [-27, 35], [-19, 9], [-34, -9], [-12, -17], [-21, 1], [-9, -6], [-20, 15], [-15, -9], [-35, 4], [-13, -41], [-17, 4], [-17, -40], [11, -8], [14, -1], [29, 3], [25, -26], [-9, -7], [-4, 8], [-16, 3], [-76, -8], [-5, 13], [3, 45], [-1, 60], [7, 29], [-17, 9], [-12, 3], [-13, -6], [-9, -12], [-5, -20], [-32, 1], [-26, -4], [-42, 12], [-12, 7], [-16, -5], [-32, -32], [-8, -14], [-13, -7], [-70, -19], [-14, 0], [-32, 18], [-51, 8], [-19, -122], [-57, 15], [-39, 16], [-4, -3], [-17, -35], [-9, -11], [-38, -34], [-15, -9], [14, -11], [40, -46], [-20, -3], [39, -81], [-20, -7], [-15, 0], [-11, 7], [-14, -40], [-30, -67], [-4, -38], [-29, -45], [5, -13], [4, -41], [5, -11], [-21, -15], [5, -16], [-2, -12], [-16, -17], [-1, -35], [-4, -8], [-32, -20], [2, -16], [-19, -1], [-9, -13], [-7, 2], [-12, -7], [10, -12], [-10, -24], [18, -6], [-19, -44], [15, -25], [0, -6], [-9, 2], [-6, -6], [6, -8], [-1, -9], [-14, -1], [-30, -14], [-8, 1], [-13, 30], [5, 12], [11, -6], [4, 6], [-2, 9], [-23, 5], [0, 7], [-9, 4], [-3, 32], [-8, -20], [-8, 1], [-4, 19], [-10, 6], [-7, 15], [-22, 10], [-10, -11], [10, -16], [16, -14], [5, -15], [34, -14], [3, -8], [-1, -7], [-12, -1], [-2, -12], [-13, 13], [-6, 12], [-4, -1], [-1, -23], [-12, -2], [-3, -5], [8, -9], [9, -2], [-1, -12], [9, -4], [0, -6], [-7, -4], [-2, -13], [-11, -14], [-32, -10], [-37, 7], [4, -55], [8, -8], [-2, -8], [-7, -2], [2, -33], [-11, -12], [-7, 8], [-10, 2], [-50, -4], [-15, 14], [-24, -7], [-17, -11], [-30, 2], [-40, -5], [-17, 8], [-70, 55], [-16, -3], [-30, 30], [-31, 10], [-10, -3], [-8, 13], [-6, 22], [-44, 57], [-71, 5], [-12, -11], [-1, -22], [3, -14], [-63, 4], [-10, 10], [-13, 3], [0, 5], [22, 16], [-10, 12], [2, 3], [9, -1], [7, 7], [15, 0], [9, 8], [15, 2], [19, 40], [-22, 63], [3, 13], [10, 6], [10, 17], [24, 97], [4, 21], [-2, 83], [8, 9], [20, -4], [10, 15], [10, 2], [18, -14], [11, -4], [61, -5], [7, 23], [-4, 21], [39, -7], [2, 12], [11, 15], [-11, 5], [-3, -11], [-23, 6], [-2, 6], [7, 8], [1, 20], [6, 10], [13, -7], [11, -1], [25, 41], [0, 21], [13, 6], [-8, 9], [0, 7], [11, 7], [52, -62], [21, -15], [15, 2], [8, 22], [25, -22], [7, -11], [32, -6], [17, 11], [4, 20], [21, -3], [-1, -28], [6, -6], [1, -16], [17, -11], [14, -22], [-1, -23], [5, -6], [9, 62], [-5, 31], [-16, 9], [-17, 22], [-15, 6], [-30, 36], [-2, 13], [10, 21], [-11, 20], [17, 9], [-10, 18], [-1, 25], [7, 3], [18, -2], [54, -14], [-1, 18], [9, 20], [-14, 26], [-7, 32], [-5, 52], [4, 14], [21, 1], [8, 7], [5, 15], [9, 6], [14, -2], [24, 16], [37, 7], [1, 15], [-14, 25], [7, 28], [11, 6], [16, 1], [2, 15], [29, 15], [-26, 8], [-11, 13], [-6, 17], [1, 15], [9, 1], [19, 21], [31, 4], [3, 14], [-9, 13], [2, 9], [11, 13], [19, 4], [24, -2], [8, 8], [17, 1], [-13, 50], [-8, 6], [-28, -3], [-10, 4], [-4, 16], [28, 5], [11, 7], [4, 14], [13, 6], [6, 8], [-25, 19], [3, 35], [3, 15], [27, 36], [12, 32], [-3, 12], [-20, 11], [-6, 27], [-20, 38], [-3, -3], [-2, -32], [-6, -20], [-8, -8], [-26, 8], [-15, -1], [-18, -47], [-19, 10], [-9, 22], [-9, 7], [-6, 12], [-14, 4], [-26, 21], [-24, 7], [-6, 7], [4, 33], [-12, 5], [-27, -14], [-41, -14], [-13, 23], [-2, 22], [-11, 4], [-20, -4], [-19, -17], [-35, -15], [-27, 31], [-27, 7], [2, 21], [8, 9], [14, -3], [-5, -11], [20, -7], [9, -12], [6, 12], [9, -3], [5, 24], [-28, 13], [-3, 10], [-20, 10], [-14, 4], [-27, -3], [-2, 19], [30, 59], [6, 26], [-5, 43], [-9, 36], [4, 16], [-6, 16], [-4, 33], [2, 17], [9, 18], [0, 67], [15, 24], [-2, 16], [27, 46], [1, 29], [27, 53], [-9, 10], [-7, 18], [-23, 7], [-82, -8], [-47, 12], [-23, 1], [-46, -11], [-59, -1], [-16, -7], [-19, -2], [-29, 24], [-20, 6], [-11, -24], [-32, 12], [-14, -33], [-14, -17], [-15, -11], [-13, 0], [-7, 19], [2, 22], [-4, 13], [32, 37], [4, 16], [-3, 34], [-19, 12], [-45, 0], [-11, 6], [-3, 51], [-8, 8], [-72, 1], [-17, -8], [-19, 4], [-30, -16], [-7, -18], [-22, 6], [-2, 35], [-16, 11], [-15, 23], [-17, 6], [13, 17], [3, 13], [-6, 13], [3, 6], [47, -17], [45, 9], [4, 33], [6, 13], [-1, 15], [-20, 18], [-16, 23], [-19, 13], [10, 23], [13, 17], [25, 15], [10, 12], [17, 36], [-7, 25], [-14, 26], [-3, 12], [21, 43], [-8, 45], [-17, 30], [-19, -2], [-20, 5], [-30, 0], [-9, 40], [-7, 6], [-29, 12], [-14, 12], [-16, 5], [3, -54], [-11, -26], [-50, 4], [-11, 5], [-13, 12], [-43, 0], [-7, -11], [-2, -19], [-35, -68], [-47, 0], [8, 11], [0, 11], [-14, 98], [1, 22], [16, 10], [49, 10], [15, 11], [-8, 28], [-3, 34], [11, 42], [1, 24], [-27, 7], [-12, -2], [-13, -19], [-10, -33], [-4, -2], [-7, 4], [-16, -10], [-20, -37], [-22, -24], [-19, -3], [-25, 12], [-10, 13], [-14, 8], [-5, 15], [-1, 32], [-54, -10], [-37, 3], [-36, -3], [-19, 8], [-7, 11], [-22, -29], [-5, -12], [0, -21], [11, -33], [8, -9], [14, -4], [9, -22], [5, -20], [-18, -13], [19, -13], [-38, -20], [-18, -27], [-36, -1], [-23, -10], [-5, -10], [14, -27], [-4, -17], [-21, -11], [-30, -2], [-61, -14], [-22, -21], [-12, -5], [5, -17], [-6, -20], [4, -33], [-2, -35], [-10, -31], [-4, 3], [-11, -7], [-15, 71], [-60, -21], [-11, 0], [14, 24], [4, 18], [-4, 17], [-13, -4], [-34, 0], [-77, -36], [-9, -12], [5, -20], [47, -13], [7, -14], [-19, -13], [-16, -6], [-12, 2], [-26, 34], [-19, 2], [-31, -31], [-18, -9], [-16, 7], [-23, -31], [-18, 10], [-15, 34], [-5, 21], [-22, 5], [-22, -5], [-10, -16], [17, -14], [9, -14], [2, -15], [0, -28], [-14, -45], [-20, -5], [-10, 7], [-2, 27], [-9, 10], [-35, 5], [-17, -8], [6, -10], [6, -29], [-5, -17], [-14, -4], [-60, -5], [-11, 47], [3, 12], [16, 8], [8, 20], [3, 42], [10, 31], [-1, 13], [-8, 2], [-11, 67], [-7, 17], [5, 14], [10, 14], [-4, 6], [-33, 6], [-12, -7], [-15, -27], [-19, 2], [-7, 5], [6, 12], [-1, 9], [-23, -1], [-2, 7], [13, 12], [-2, 10], [30, 43], [-4, 12], [-46, -8], [-31, 3], [-38, -4], [0, 17], [-12, 11], [-18, 6], [-17, -3], [-55, -46], [-16, 2], [-9, 33], [-21, 41], [-38, -17], [-15, -21], [-17, 5], [-56, -8], [6, 39], [-21, 10], [-6, 13], [-5, 37], [6, 17], [-3, 12], [-14, 3], [-19, 1], [-7, -16], [-11, -46], [-13, -19], [-7, -2], [1, 43], [-8, 6], [-9, -35], [-9, -16], [-10, -8], [-31, 9], [-8, 3], [10, 40], [6, 54], [-1, 23], [-11, 16], [-15, -3], [-24, -19], [-8, -20], [3, -20], [10, -21], [7, -38], [-5, -22], [-32, 7], [-20, -2], [-20, -22], [-14, -1], [3, -15], [45, -19], [5, -14], [23, -8], [9, -12], [0, -12], [-13, -10], [0, -18], [-5, -7], [10, -32], [29, -36], [-4, -25], [-7, -16], [-65, 3], [-8, -7], [-23, -4], [-63, 23], [-21, -6], [-2, -9], [-10, -3], [-3, -17], [3, -20], [-46, 3], [-28, 41], [-27, 31], [-20, 5], [-14, -4], [-19, -87], [-42, 23], [-2, 16], [-24, 86], [8, 7], [2, 10], [-4, 26], [-8, 7], [-26, 7], [0, 10], [7, 11], [27, 21], [5, 27], [18, -1], [27, 27], [4, 30], [10, 3], [-2, 17], [13, 52], [23, 9], [30, 0], [-12, 67], [-38, 22], [-24, 29], [-19, 7], [-23, 15], [5, 45], [7, 14], [-21, 14], [-22, 21], [-25, 14], [-35, 10], [-8, 10], [-9, 23], [-22, 5], [6, 42], [10, 17], [26, 0], [49, 11], [6, 13], [1, 18], [-6, 7], [-1, 17], [-8, 10], [-37, 13], [-12, 0], [5, 14], [0, 13], [-12, 36], [-13, 7], [-23, 29], [-10, 4], [-22, -16], [-65, 21], [8, 12], [10, 54], [12, 6], [45, -9], [13, 13], [32, 6], [5, 4], [5, 25], [-6, 20], [6, 6], [27, -19], [11, -13], [61, -7], [45, 5], [30, -5], [3, -20], [-11, -27], [-5, -60], [12, -5], [2, -7], [-8, -11], [0, -27], [-18, -19], [4, -14], [31, -21], [1, -14], [-10, -38], [8, -19], [44, -4], [57, -10], [1, -18], [16, -4], [32, 1], [13, 5], [54, 4], [9, -18], [7, -37], [13, -22], [-2, -13], [3, -14], [12, -2], [17, -13], [16, -3], [19, 17], [-3, 20], [22, 6], [52, -14], [54, 12], [53, -4], [29, 35], [20, 13], [15, 4], [6, -28], [-3, -20], [13, -2], [31, 18], [12, 20], [13, 8], [22, -4], [7, -8], [1, -14], [7, -15], [22, -34], [1, -10], [7, -6], [45, -13], [-1, -14], [-14, -37], [0, -13], [-7, -10], [40, -13], [2, -8], [-45, -71], [2, -14], [11, -23], [23, -2], [71, 5], [3, -42], [12, 1], [49, 35], [14, 16], [4, 17], [-11, 7], [-27, 6], [-6, 51], [34, 7], [13, 10], [4, 60], [-9, 10], [-13, 9], [-76, -7], [-24, -11], [-7, 15], [1, 14], [15, 28], [8, 33], [-19, 11], [-28, 9], [-27, 1], [-54, 16], [12, 39], [15, 33], [27, 0], [19, 12], [6, 17], [25, 14], [16, 44], [13, 7], [22, 24], [2, 16], [-4, 10], [-11, 9], [-21, -4], [-15, -10], [-32, -9], [-15, -8], [-18, -22], [7, 67], [16, -2], [49, 14], [13, 43], [16, 14], [0, 27], [45, 11], [15, -1], [16, -10], [67, -5], [22, 3], [56, -26], [26, -5], [23, 50], [-2, 11], [-12, 9], [-10, 56], [-15, 22], [0, 15], [-7, 18], [14, 30], [6, 21], [1, 26], [-7, 27], [-9, -1], [-17, 9], [-12, 22], [-55, -29], [-24, 13], [-3, 76], [-33, -12], [-4, 38], [-37, 14], [-32, 5], [-21, -10], [-15, -18], [-11, -28], [2, -24], [23, -53], [-2, -17], [13, -10], [24, -2], [9, -28], [9, -59], [13, -15], [2, -12], [-2, -21], [-52, -29], [-17, 2], [-8, 25], [3, 19], [-11, 15], [-47, 32], [8, 31], [0, 61], [-115, 11], [-27, 6], [-23, -4], [-13, 3], [7, 62], [-3, 68], [-18, 1], [-13, -11], [-21, -3], [-29, -26], [-29, -8], [-20, 9], [-30, -5], [-29, 3], [-55, 38], [-17, 1], [-10, 13], [-17, 4], [-13, -13], [-13, 9], [-11, -5], [-8, -8], [1, -16], [-4, -24], [-11, -29], [-19, -24], [-12, -9], [-3, -30], [-8, -31], [19, -11], [-9, -20], [3, -20], [-5, -19], [-1, -25], [-11, -19], [-22, -9], [-45, -1], [-34, 35], [-23, 37], [-37, 2], [-19, -9], [-27, -4], [-19, -8], [-21, 9], [-4, -6], [-7, 8], [-16, 4], [-29, -6], [-18, 1], [-23, -4], [-17, 5], [-13, 9], [-4, 21], [-22, 37], [-3, 18], [43, 22], [11, 12], [3, 18], [-16, 26], [-15, 7], [-30, 3], [-53, 23], [-31, 48], [-14, 16], [9, 104], [30, 10], [37, 45], [64, -33], [7, 22], [-5, 72], [3, 13], [33, 1], [13, 15], [22, 44], [-2, 18], [-40, 3], [-23, 6], [-87, 5], [-27, -8], [-19, -11], [-12, -13], [-23, -5], [-14, 15], [-7, 29], [-14, 28], [-23, 24], [-27, 14], [-10, 19], [-17, -7], [-45, 18], [-11, 31], [-19, 29], [-18, 62], [-4, 26], [-5, 0], [-3, -8], [-27, 22], [-1, 13], [6, 24], [18, 146], [22, 39], [10, 39], [28, 65], [-22, 41], [-4, 24], [-13, 41], [68, 5], [13, 2], [1, 7], [8, 3], [13, 1], [11, -7], [5, 2], [3, 36], [5, 10], [21, -5], [4, 4], [2, 19], [-2, 5], [-9, 3], [-3, 21], [-7, 14], [21, 20], [10, 54], [-5, 2], [-6, 41], [-13, 4], [1, 12], [6, 9], [31, 2], [8, 48], [4, 61], [-4, 42], [2, 21], [-52, -7], [-12, -5], [-8, -13], [-10, -6], [-10, 6], [-18, 24], [-41, -2], [-74, 16], [-16, 31], [13, 16], [6, -1], [10, 27], [22, 13], [11, 25], [-6, 16], [-2, 25], [-22, 47], [3, 26], [8, 10], [-4, 5], [5, 5], [5, -4], [12, 9], [-4, 8], [5, 4], [7, 0], [21, 24], [54, -38], [36, -5], [13, -15], [39, -22], [8, -16], [12, -14], [16, -37], [27, 8], [16, 0], [21, -6], [18, 4], [41, -11], [24, 1], [18, -6], [36, -26], [34, -7], [3, 24], [27, 8], [12, 13], [49, -4], [33, 0], [21, 4], [4, -13], [-17, -43], [84, -13], [7, 52], [14, 2], [6, 11], [42, 2], [4, 23], [10, 4], [5, 25], [16, 42], [5, 60], [26, 14], [19, 18], [14, 31], [-3, 26], [-39, 11], [-7, 16], [11, 15], [19, 3], [27, -4], [4, 8], [-1, 13], [9, 8], [3, 17], [-14, 60], [-5, 1], [-13, 32], [-6, 2], [-13, 23], [-46, 7], [6, 28], [20, 4], [17, 39], [15, -3], [41, 2], [-2, 19], [-15, 3], [-17, 16], [-11, -2], [0, 7], [7, 4], [-1, 35], [-20, 0], [-52, 10], [-5, 69], [-7, 4], [-1, 15], [-23, -2], [-68, -16], [-16, 5], [3, 15], [0, 23], [-12, 13], [-34, 21], [-10, 15], [13, 59], [-6, 19], [-18, 11], [-10, 12], [-4, 15], [9, 25], [-1, 19], [-7, 21], [-8, 8], [-19, 6], [-20, 17], [-9, 17], [-3, 14], [-11, 14], [-44, 34], [-13, 21], [3, 37], [22, -4], [32, -12], [21, 7], [48, -6], [4, 20], [1, 39], [-12, 121], [2, 19], [10, 33], [-4, 73], [5, 11], [7, -5], [8, 1], [73, 20], [28, 29], [32, -21], [18, -24], [28, -21], [10, 29], [9, 51], [-13, 7], [-41, 40], [-55, 28], [13, 11], [5, 32], [-18, 3], [0, 26], [-65, 9], [1, 19], [-9, 3], [7, 40], [12, -3], [3, 21], [-11, 4], [3, 8], [9, -1], [14, 36], [6, -1], [10, 41], [-12, 5], [5, 60], [-26, 2], [-5, -10], [-19, 4], [-7, 9], [-10, -3], [-13, 3], [-13, 15], [24, 50], [43, 55], [30, 54], [24, 25], [63, 35], [56, 14], [30, 24], [31, 9], [30, 2], [22, 11], [50, 0], [74, 6], [29, 12], [32, -15], [43, -9], [39, 7], [33, -13], [45, -4], [42, 1], [50, -25], [37, 9], [33, -3], [42, 16], [58, -26], [33, -9], [36, 1], [31, -4], [28, -13]], [[20884, 21635], [49, -11], [89, -9]], [[27307, 24189], [4, 26]], [[27263, 24316], [52, 46]], [[29372, 25067], [29, 37], [13, 3]], [[30369, 26291], [54, 38], [8, 9], [18, 38], [15, 15], [73, 36], [30, -1], [61, 22], [24, 14], [32, 6], [32, 27], [24, 2], [26, 8], [35, 19], [12, 11], [15, 7], [49, 34], [7, 14], [29, 8], [6, 25], [-7, 25], [34, 25], [18, 6], [11, -3], [6, -12], [28, -14], [33, -1], [13, 9], [0, 5], [-10, 7], [-5, 10], [12, 0], [13, 5], [5, 12], [17, -12], [21, -7], [7, -11], [35, 3], [6, 8], [5, 1], [14, -16], [17, 0], [5, -6], [7, -31], [22, 19], [11, -7], [30, 7], [7, -5], [30, -48], [-6, -13], [7, -12], [17, -7], [26, 3], [48, -34], [42, -5], [3, -20], [7, -9], [26, 0], [17, 6], [14, 9], [8, 27], [0, 30], [-10, 36], [-18, 22], [14, 9], [6, 22], [36, 18], [4, 9], [29, 6], [-4, -11], [-8, -7], [9, -20], [10, -5], [12, 2], [-5, -12], [3, -4], [9, 1], [8, -9], [8, 3], [-9, 22], [10, 8], [10, 4], [10, -9], [-3, -9], [11, -5], [15, 16], [15, 48], [-3, 9], [4, 8], [-1, 18], [-6, 11], [-13, 7], [-6, 10], [1, 30], [-5, 28], [11, 20], [-4, 35], [54, -40], [9, 9], [8, 25], [-37, 52], [-35, 4], [-18, 7], [-13, 12], [-20, 7], [-4, 16], [2, 19], [-7, 15], [31, 13], [29, 35], [-14, 1], [-12, 14], [3, 14], [17, 7], [2, 5], [1, 32], [12, 46], [15, 13], [52, -2], [11, 7], [30, 36], [4, 27], [13, 14], [-10, 11], [-9, 17], [-9, 2], [-34, -7], [-16, -19], [-8, 2], [-13, -7], [-13, 3], [-19, 23], [5, 7], [20, 4], [11, 17], [14, 11], [8, 23], [36, 23], [7, 10], [-2, 10], [6, 12], [7, 5], [0, 8], [-21, 25], [0, 23], [-6, 13], [-14, 12], [-11, 16], [11, 7], [2, 10], [24, 11], [10, 23], [34, 47], [51, 43], [15, 17], [5, 19], [17, 29], [37, 46], [46, 47], [17, 4], [8, -11], [-17, -5], [-4, -5], [12, -34], [38, -21], [2, -10], [6, -1], [13, 16], [15, -11], [7, 5], [13, -4], [1, -11], [-4, -6], [6, -17], [-10, -6], [-2, -11], [11, 1], [8, -12], [-15, -13], [14, -10], [-22, -21], [-3, -8], [16, -7], [-6, -5], [1, -8], [5, -3], [8, 3], [5, -10], [2, -21], [7, 0], [13, 9], [-1, 12], [13, -4], [7, 1], [6, -7], [8, -3], [-6, -9], [-2, -17], [-9, -6], [-2, -16], [-12, -1], [-9, -20], [2, -10], [9, -2], [-1, -3], [-17, -12], [-1, -8], [6, -9], [17, -2], [15, -13], [5, 9], [10, 3], [20, -10], [13, 0], [15, -16], [7, 3], [19, -4], [10, -15], [12, 2], [3, -6], [1, -7], [-7, -8], [4, -6], [-4, -9], [2, -5], [23, -7], [5, -11], [-7, -11], [-20, 1], [-5, -3], [2, -17], [6, -7], [8, -25], [-4, -7], [-14, -3], [-14, 8], [-14, -19], [-12, -5], [-3, -6], [7, -13], [18, 2], [7, -24], [-1, -9], [-11, -17], [6, -6], [0, -7], [-17, -12], [6, -9], [9, -2], [4, -21], [20, -5], [6, -6], [19, -6], [6, -7], [-2, -6], [5, -11], [16, -7], [14, -18], [11, 0], [12, 15], [18, 13], [5, 10], [-6, 29], [26, 51], [6, 19], [13, 9], [38, 5], [19, 10], [17, -2], [5, 9], [5, 20], [19, 11], [14, 4], [18, -7], [20, 4], [-3, 11], [11, 4], [19, 0], [9, 8], [1, 12], [8, 4], [9, -6], [19, 9], [10, 20], [29, 34], [-15, 40], [22, 17], [0, 28], [13, 11], [-13, 12], [-14, -1], [1, 11], [-13, 27], [1, 10], [24, 17], [27, 29], [43, -2], [1, -12], [38, -22], [2, -23], [18, -11], [8, 13], [32, -17], [16, -4], [21, 20], [12, -4], [13, -34], [1, -15], [-14, -32], [16, -28], [24, -26], [13, 9], [15, -7], [11, 7], [17, 3], [11, -22], [28, -2], [32, 16], [20, 0], [18, -6], [10, 26], [11, 0], [13, 21], [44, 8], [12, 15], [7, -3], [8, -16], [30, -16], [43, 18], [21, 28], [2, 7], [-17, 16], [-7, 13], [-1, 8], [11, 13], [1, 14], [3, 4], [-5, 18], [-26, -9], [-13, -16], [-11, 2], [-9, 10], [10, 9], [2, 12], [-3, 7], [-28, 4], [-16, 9], [-6, 9], [3, 8], [23, 22], [23, 14], [15, 22], [18, 12], [7, 25], [31, 33], [10, 30], [20, 30], [14, 13], [2, 12], [-5, 7], [-35, 4], [-32, -19], [-14, 1], [-24, 23], [-17, 8], [2, 24], [-18, 14], [3, 9], [15, 18], [7, 4], [18, 2], [21, 19], [-5, 16], [-7, 5], [-17, 4], [-7, -19], [-23, -15], [-26, 5], [-18, 9], [27, 40], [3, 12], [-9, 31], [-14, 10], [-4, 9], [1, 12], [4, 5], [25, 13], [30, 8], [33, 15], [1, 22], [10, 9], [33, 52], [-3, 11], [3, 8], [16, 19], [23, 17], [10, 22], [15, 12], [15, 27], [23, 23], [2, 6], [-11, 18], [8, 9], [38, 24], [13, -3], [14, -10], [13, -19], [12, -3], [27, 4], [19, -11], [19, -24], [14, -6], [22, 1], [4, -4], [-2, -19], [9, -9], [-6, -12], [-1, -9], [4, -9], [17, 44], [22, 25], [-1, 16], [-11, 17], [0, 11], [5, 5], [22, -4], [23, -13], [35, 0], [24, -4], [13, 15], [-6, 17], [2, 11], [12, 24], [9, 10], [28, 7], [27, 15], [22, -8], [10, 1], [10, 5], [7, -8], [16, -5], [6, 1], [4, 6], [3, 18], [39, -7], [8, 10], [0, 7], [-22, 34], [7, 13], [12, 11], [8, 0], [24, -26], [52, 23], [5, 7], [-4, 37], [2, 8], [25, 4], [6, 11], [-13, 15], [-26, 6], [-19, 12], [0, 5], [-15, 12], [-11, 13], [-3, 10], [24, 17], [1, 6], [-16, 6], [-21, -5], [-15, 2], [-9, 9], [-14, 26], [-8, 26], [6, 16], [30, -9], [3, -17], [15, -13], [12, 2], [9, 12], [-36, 35], [-7, 24], [0, 12], [-34, 9], [-5, -52], [-9, -7], [4, -32], [-5, -5], [-22, 2], [-20, 20], [-4, 19], [6, 5], [22, 4], [5, 4], [-1, 10], [-15, 16], [2, 17], [-30, 22], [-10, 32], [-10, 16], [2, 6], [5, 3], [48, -6], [5, 4], [-3, 16], [6, 7], [5, 16], [25, 8], [20, -1], [6, -8], [10, -27], [11, -3], [22, 3], [26, 13], [10, -2], [6, -8], [12, 1], [8, -8], [9, 8], [6, -18], [-6, -21], [13, -5], [41, -39], [21, -32], [20, -8], [9, 3], [15, 32], [-2, 21], [-7, 10], [5, 20], [-6, 4], [-17, 0], [-3, 41], [3, 5], [7, 1], [32, -8], [16, 3], [4, 9], [-3, 18], [6, 22], [-1, 11], [-27, 25], [-6, 18], [1, 21], [-14, 8], [6, 32], [10, 4], [14, -3], [7, 18], [8, -6], [8, -21], [29, -31], [21, 27], [5, 0], [2, -24], [10, -15], [-1, -28], [7, -14], [1, -13], [-12, -7], [-10, 10], [-23, 2], [-1, -21], [5, -16], [21, -3], [24, -12], [35, 1], [8, 55], [18, 19], [11, 20], [10, 5], [-16, 35], [3, 28], [11, 9], [8, 1], [13, -28], [-8, -15], [1, -20], [8, -3], [14, 5], [25, -6], [5, 13], [3, 48], [5, 10], [7, 8], [13, 4], [14, 0], [10, 8], [0, 11], [-22, 42], [0, 23], [24, 25], [12, -1], [8, 7], [11, 19], [8, 7], [-5, 9], [7, 12], [11, -9], [4, -12], [-4, -31], [3, -11], [8, -6], [36, -6], [3, -8], [-2, -9], [-11, -3], [7, -26], [21, -34], [-1, -31], [6, -12], [16, -12], [39, -49], [28, -64], [6, -4], [39, -1], [14, -6], [-8, -18], [-33, -12], [2, -33], [7, -4], [5, 3], [13, -6], [21, -16], [2, -22], [20, -65], [11, -20], [2, -17], [8, -12], [23, -3], [15, -24], [11, -10], [8, -2], [14, 7], [6, 8], [-7, 26], [-16, 33], [-10, 8], [-9, 20], [-14, -6], [-11, 5], [-4, 17], [1, 17], [-16, 20], [-5, 27], [4, 12], [22, 23], [13, 1], [26, 12], [16, 24], [10, 2], [18, -5], [1, -22], [5, -15], [26, -24], [27, -68], [3, -11], [-6, -35], [17, -28], [-9, -29], [3, -6], [11, -4], [26, 9], [6, -1], [6, -11], [5, -37], [-13, -37], [1, -19], [15, -31], [9, -9], [25, -11], [12, -9], [5, -37], [8, -12], [8, -2], [21, 5], [8, -34], [9, 4], [10, 18], [15, 5], [13, -1], [29, -11], [12, -12], [16, 1], [7, -18], [7, -7], [21, 1], [14, 15], [19, 2], [41, -9], [21, 10], [35, -1], [12, -8], [7, 2], [8, -9], [17, 11], [8, -5], [0, -11], [8, -13], [31, -15], [-1, -9], [5, -6], [-4, -7], [3, -9], [9, -5], [11, -1], [17, -39], [26, -6], [9, -10], [16, 6], [6, -5], [21, 18], [15, 5], [14, 0], [11, -4], [9, -12], [15, 11], [-4, 20], [8, 8], [37, 17], [8, 9], [17, -2], [2, -6], [-4, -7], [10, -2], [10, 4], [28, -3], [4, 20], [11, 5], [9, -7], [58, 25], [11, -2], [6, -5], [7, 7], [8, -3], [1, -13], [33, -16], [14, -3], [15, 6], [12, 13], [8, 0], [12, 5], [4, 11], [8, 6], [11, 3], [37, -22], [15, 0], [4, -8], [8, 2], [8, 17], [36, 14], [3, 7], [-9, 22], [0, 11], [33, 7], [-7, 14], [7, 11], [0, 24], [-14, 8], [-8, 36], [0, 29], [4, 7], [18, -9], [16, -28], [9, 4], [16, -4], [15, 19], [5, 19], [-12, 11], [-14, 0], [-13, 8], [-5, 6], [-1, 13], [45, -19], [6, 3], [20, -17], [7, 6], [3, 14], [-3, 13], [-27, 13], [-15, 1], [-6, 10], [1, 7], [29, -7], [35, -18], [9, 1], [27, 10], [5, 8], [-14, 29], [8, 5], [19, -18], [5, 10], [20, 21], [-30, 57], [10, 27], [32, 32], [13, 10], [-13, 23], [-18, 17], [-3, 27], [-22, 30], [-1, 13], [11, -3], [22, -27], [7, 2], [10, -10], [15, -7], [18, -15], [24, -12], [20, -5], [9, 25], [5, 38], [9, 5], [16, 26], [19, 9], [27, 30], [38, 3], [10, 13], [8, 2], [42, 5], [13, 29], [14, 13], [6, -10], [5, -1], [13, 10], [3, -6], [-6, -58], [-4, -6], [4, -18], [6, -20], [22, -14], [5, 1], [15, 15], [8, 31], [16, 30], [15, 3], [-6, 16], [2, 3], [24, 2], [6, -13], [9, -2], [15, 19], [25, -3], [15, -9], [10, 27], [9, 2], [3, 4], [-11, 11], [-12, 24], [-12, 7], [-9, 1], [-22, -14], [-8, -14], [-25, 9], [-8, 21], [1, 11], [-6, 5], [-10, -3], [-9, 4], [-6, 9], [-16, 45], [-9, 13], [0, 7], [39, -15], [36, 2], [9, 5], [24, 4], [3, 6], [13, -10], [13, 6], [18, -3], [7, 15], [3, 17], [-1, 22], [-5, 6], [4, 23], [10, -3], [9, 3], [18, -17], [24, 4], [12, -3], [10, 2], [7, -5], [3, -13], [-21, -43], [-7, -9], [0, -4], [8, -10], [0, -16], [51, -32], [5, -13], [3, 3], [13, -3], [70, -43], [-31, -45], [-2, -9], [-7, -4], [-9, -18], [-7, -4], [-37, -54], [-21, -23], [-6, -14], [-44, -63], [-10, -7], [-29, 3], [-13, -12], [-1, -9], [4, 0], [0, -9], [5, -2], [27, 28], [7, -3], [-27, -29], [-4, -9], [-129, -122], [-29, -42], [-20, -22], [-6, 0], [-9, 8], [8, -13], [-5, -14], [-7, -5], [0, -10], [-11, -23], [1, -27], [-27, -22], [-17, -25], [-7, -34], [2, -16], [-4, -3], [1, -7], [-4, 3], [-1, -4], [-6, -1], [2, -3], [-7, -9], [-20, -17], [-13, -15], [-11, -7], [-1, -5], [-10, -4], [-43, -34], [-27, -28], [-12, -22], [-18, -14], [-20, -25], [-5, -1], [-13, -26], [-42, -51], [-1, -38], [-4, 0], [-15, -23], [-10, -6], [-15, -19], [-14, -10], [-82, -79], [-36, -46], [-13, -28], [-2, -25], [-24, -6], [-8, -11], [0, -10], [-3, -5], [6, 3], [-1, 9], [8, 8], [24, 10], [1, -16], [-161, -133], [-183, -175], [-116, -124], [-29, -57], [-11, -6], [-2, 6], [-13, 5], [5, -5], [-2, -6], [5, 1], [-3, -5], [3, -5], [-11, 0], [7, -5], [0, -11], [-4, -18], [-5, 0], [0, -4], [4, -6], [5, 4], [6, -26], [-12, -14], [-10, -2], [-76, -48], [-5, -11], [-14, -7], [-4, -6], [-14, -4], [-118, -60], [-11, -1], [-10, -10], [-7, 0], [-3, -5], [-72, -36], [-45, -28], [-18, -7], [-18, 1], [6, -8], [-42, -10], [-65, -23], [-26, -16], [-6, -6], [-1, -8], [-10, -11], [-16, -9], [-74, -26], [-63, -28], [-17, -4], [-7, -7], [-13, -2], [-28, -18], [-12, -3], [-5, -6], [-9, -2], [-105, -57], [-90, -57], [-17, -17], [-20, -13], [0, -6], [-19, -9], [-10, -14], [-13, -4], [-13, -13], [-47, -28], [-58, -50], [-4, 0], [-18, -12], [-5, 4], [0, -8], [-18, -9], [3, -8], [-15, -20], [-1, -14], [3, -12], [-3, -11], [-27, -29], [-6, -18], [-20, -17], [-13, -16], [-20, -10], [-21, -18], [-52, -28], [-5, -7], [-34, -19], [-22, -24], [-2, 37], [-5, 1], [4, -35], [-12, -7], [-5, -6], [1, -11], [8, -8], [-2, -11], [-18, -16], [-6, -19], [-11, -4], [-44, -32], [-21, -33], [3, -15], [10, -4], [1, -4], [-1, -25], [-12, -30], [-42, -40], [-15, -23], [3, -11], [-3, -5], [-59, -38], [-20, -24], [4, -7], [-11, -8], [-8, -16], [2, -14], [5, -6], [-3, -10], [-60, -34], [-24, -20], [-1, -11], [-9, 1], [4, -6], [9, 6], [-3, -6], [0, -17], [-2, 12], [-8, 0], [-2, 7], [-5, -2], [6, -5], [-1, -2], [-6, 5], [-4, -2], [6, -7], [-6, 3], [-5, -6], [-15, -3], [-12, 3], [-1, 12], [-6, 1], [-2, 13], [-13, 16], [0, 11], [-6, 3], [-6, -7], [-9, 2], [6, -12], [-6, -4], [19, 2], [24, -41], [22, 1], [5, -6], [8, 2], [0, -2], [-8, -2], [-1, -5], [4, -4], [-1, -14], [-27, -24], [-2, -12], [-11, -1], [-35, -20], [-5, -16], [-38, -20], [-16, -15], [-6, -11], [-1, -12], [3, -1], [-2, -8], [5, -7], [7, 3], [0, -5], [-48, -29], [-7, -20], [-13, -1], [-72, -36], [-12, -10], [-3, -12], [-14, -11], [-113, -34], [-38, -17], [-7, -1], [-7, -14], [-37, -10], [-10, -5], [-2, -6], [-4, 3], [-13, -2], [-7, -7], [-50, -19], [-57, -34], [-10, -16], [4, -11], [-26, -20], [4, -10], [-11, -7], [-82, -30], [-8, -5], [0, -6], [-6, -6], [-12, -2], [-35, -19], [-93, -39], [-14, -16], [-8, 0], [-5, 6], [1, 13], [10, 8], [6, 9], [-2, 2], [-4, -7], [-10, -5], [-4, -13], [-7, -9], [-1, -7], [8, -4], [-3, -4], [-71, -23], [-222, -106], [-125, -66], [-76, -47], [-22, -10], [-11, -11], [-48, -28], [-11, 9], [5, -10], [-1, -5], [-19, -8], [-11, 0], [3, -6], [-3, -3], [-144, -93], [-40, -34], [-80, -56], [-84, -74], [-8, -12], [-82, -75], [-22, -26], [-50, -47], [-5, 10], [7, 8], [1, 10], [-1, 2], [-2, -11], [-10, -11], [6, -11], [-22, -24], [-6, 9], [-4, -1], [4, -10], [-5, -8], [-71, -73], [-34, -41], [-14, -21], [-43, -94], [4, -16], [13, -8], [-17, 2], [-5, -5], [0, -12], [17, 1], [1, -7], [-2, -7], [-18, 0], [-11, -23], [-3, -25], [5, -5], [6, -2], [-5, -9], [0, -7], [-8, -5], [-10, 0], [-5, -5], [-16, -1], [-8, -4], [-3, -10], [3, -39], [-3, -16], [13, -9], [2, -8], [4, -17], [-3, -15], [8, 5], [12, -7], [9, -13], [1, -10], [27, 4], [8, -10], [-1, -10], [-6, -9], [10, 15], [-2, 8], [1, 5], [6, -11], [30, -19], [24, -30], [3, -17], [-6, -10], [11, 10], [5, 16], [15, 10], [23, 3], [28, -14], [13, 2], [3, 5], [-2, 28], [15, 42], [0, 33], [4, 27], [-9, 84], [-10, 28], [-13, 12], [-19, 10], [-16, 33], [-14, 9], [-6, 13], [4, 5], [12, 0], [22, -13], [17, -17], [20, -34], [17, -114], [0, -32], [-4, -42], [-2, 3], [-2, -3], [-9, -45], [1, -49], [-8, -18], [-4, -34], [-3, -1], [1, -9], [-9, -23], [11, 22], [3, 2], [3, -15], [-9, -30], [-1, -20], [-5, -9], [1, -6], [-5, -2], [-6, -40], [-4, -4], [2, -5], [-5, -23], [-1, -20], [4, -16], [-3, -5], [-31, -3], [-3, -3], [-5, 5], [-17, -9], [-10, 4], [0, -20], [-16, -20], [-12, -5]], [[10839, 3602], [6, -4], [-1, -4], [-5, 1], [0, 7]], [[10997, 3713], [-27, -46], [-5, -28], [1, -24], [-25, -24], [-15, -21], [-40, -1], [-19, 5], [-9, 7], [-1, 15], [9, -4], [3, -8], [39, 3], [13, 5], [19, 15], [21, 34], [4, 21], [15, 31], [8, 15], [9, 5]], [[9231, 7778], [-7, -21], [-11, -7], [-1, 5], [5, 8], [14, 15]], [[12230, 7827], [1, -4], [-8, -3], [-1, 3], [8, 4]], [[12220, 7838], [-2, -8], [-6, 3], [7, 5], [1, 0]], [[12271, 7907], [1, -20], [-9, -40], [2, -19], [-2, -1], [0, -22], [-3, -8], [-11, -2], [-5, 5], [2, 5], [-11, 26], [12, -2], [10, 15], [12, 43], [2, 20]], [[9316, 7983], [6, -14], [2, -14], [-3, 4], [-10, 1], [1, 20], [4, 3]], [[12292, 8029], [9, -34], [-7, -28], [-2, 3], [5, 27], [-7, 23], [-4, 2], [1, 4], [5, 3]], [[10017, 9023], [9, -2], [7, -10], [0, -25], [-6, -5], [-28, -10], [-19, -15], [-13, -17], [-10, -2], [4, 10], [14, 5], [28, 50], [6, 19], [8, 2]], [[8960, 9584], [1, -6], [-9, -1], [2, 4], [6, 3]], [[8969, 9596], [0, -5], [-4, -1], [0, 2], [4, 4]], [[12331, 9599], [-3, -9], [42, 2], [14, -4], [1, -4], [-38, -18], [-29, -6], [-12, 2], [-12, 7], [-4, 12], [3, 9], [14, 4], [16, -2], [3, 7], [5, 0]], [[8969, 9596], [37, 69], [4, 29], [7, 22], [15, 16], [13, -1], [-6, -20], [-31, -48], [-23, -48], [-16, -19]], [[9234, 9893], [-7, -5], [6, -18], [-6, -3], [-9, 1], [3, 23], [13, 2]], [[9313, 9910], [-20, -22], [-9, -1], [3, 12], [14, 3], [12, 8]], [[9329, 9923], [1, -6], [-6, -2], [1, 8], [4, 0]], [[10217, 10342], [6, -4], [-3, -15], [-9, -20], [-19, -16], [-1, -5], [-11, 14], [2, 20], [16, 17], [19, 9]], [[8820, 10523], [0, -7], [-5, -4], [1, 7], [4, 4]], [[8813, 10529], [5, -4], [-1, -2], [-10, 4], [6, 2]], [[10348, 10634], [0, -13], [-14, -33], [-13, -54], [-20, -32], [-15, -54], [-3, -2], [2, 26], [24, 69], [1, 14], [4, 4], [6, 31], [18, 38], [10, 6]], [[10818, 11173], [3, -6], [-1, -2], [-2, 2], [0, 6]], [[10816, 11196], [9, -4], [11, -21], [6, -37], [-9, -10], [-13, 57], [-6, 1], [-5, 8], [7, 6]], [[8999, 11440], [7, -6], [0, -7], [-10, 4], [-1, 6], [4, 3]], [[10178, 11688], [6, -10], [-1, -24], [-18, -26], [-8, -1], [-1, 8], [7, 5], [5, 16], [-1, 6], [4, -1], [9, 18], [-2, 9]], [[19362, 56474], [-124, -14], [-182, 229], [267, 36]], [[19323, 56725], [39, -251]], [[20191, 52211], [58, -222], [183, -143], [65, -236], [-26, -236]], [[20471, 51374], [-222, -86], [-71, -122], [-209, 100], [-72, 129], [-437, -21], [-91, 121], [261, 294], [-26, 279], [293, 157], [294, -14]], [[22826, 60831], [157, -236], [13, -465], [124, -57], [306, -401], [216, -171], [-170, -458], [137, -243], [196, -144], [-268, -228], [144, -151], [-59, -300], [313, -43]], [[23935, 57934], [261, -322], [0, -79], [-274, -21], [-215, 207], [-378, 43], [-235, -28], [-268, 171], [-182, 15], [-601, -294], [-195, 7], [-326, -307], [-27, -401], [-182, -193], [156, -365], [-71, -86], [163, -186], [-555, -250], [39, -79]], [[21045, 55766], [-150, 100], [-267, 15], [-437, 157], [-163, 172], [52, 257], [-339, 229], [-209, 294], [-196, 78], [-111, -64]], [[19225, 57004], [-280, 222], [-98, 314], [72, 201], [-144, 143], [-280, 50], [-183, 308], [-183, -287], [-176, -7], [-117, 115], [-163, 493], [-340, 573], [111, 78], [-208, 315], [-281, 143], [-378, 100], [182, 265], [-111, 150], [222, 65], [450, 329], [-156, 229]], [[17164, 60803], [169, 236], [-26, 365], [-241, 336], [98, 71], [222, -107], [352, 272], [254, 93], [170, 229], [235, 114], [365, 79], [144, -100], [261, 21], [437, -386], [339, -200], [574, -194], [457, 129], [378, 215], [450, -565], [33, -193], [163, -194], [228, 136], [294, 50], [293, 151], [0, -244], [-156, -121], [-72, -222], [85, -79], [156, 136]], [[20373, 49685], [-535, 0], [59, -150], [-352, -172], [-26, 179], [98, 286], [-53, 394], [27, 293], [-170, 172], [-437, -315], [0, -186], [-274, -79], [-196, 172], [78, 150], [-84, 115], [-333, 57], [111, -279], [-365, 0], [-53, -72], [124, -479], [-476, 0], [-157, 179], [216, 393], [-183, 101], [196, 143], [-13, 179], [-313, 329], [-235, 57], [-392, 458], [-267, 737], [65, 150], [-150, 57], [-170, 351], [27, 207], [-124, 93], [-516, -143], [-287, 107], [-98, 201], [-235, 85], [-489, -150], [-143, 243], [130, 58], [-46, 250], [46, 451], [-241, -65], [-13, 215], [137, 64], [-66, 222]], [[14195, 54743], [307, -78], [124, 128], [254, 36], [242, -100], [150, -165], [241, 108], [0, -229], [196, 28], [98, -200], [-144, -143], [144, -301], [150, 51], [313, 529], [359, -107], [254, 43], [170, 121], [209, -193], [352, 14], [378, 244], [-85, 207], [111, 458], [320, -57], [104, 157], [98, -200], [150, -29], [216, 136], [39, 143], [-209, 115], [365, 200], [92, 222], [195, -15], [92, -157], [52, 114], [-26, 523], [-144, 128]], [[19323, 56725], [46, 129], [-144, 150]], [[21045, 55766], [-26, -243], [-365, -322], [-418, -429], [-84, -372], [-98, -86], [-170, -465], [0, -343], [157, 7], [13, -701], [163, -458], [-26, -143]], [[20471, 51374], [379, -301], [-72, -193], [143, -136], [26, -172], [-150, -164], [-13, -158], [137, -221], [-124, -151], [-424, -193]], [[43134, 35070], [-300, -122], [-319, -21], [-300, -186], [-333, -344], [-183, -372], [26, -207], [268, -651], [-189, -65], [221, -64], [-84, -136], [176, -36], [-555, -393], [-124, -344], [170, 29], [-170, -222], [-495, -236], [-66, -214], [-156, -265], [-268, 200], [-150, 0], [366, -243], [-229, -129], [-424, -157], [-52, 36], [-698, -222], [-646, -236], [-72, 78], [307, 136], [20, 286], [-294, 51], [-483, -387], [-248, -458], [39, -121], [170, 71], [-20, 129], [118, 200], [130, -35], [190, 114], [32, -107], [-156, -165], [-353, -236], [-685, -608], [-208, -243], [-46, 107], [-163, -14], [-98, -136], [-365, -150], [-26, -208], [-327, -329], [-352, -57], [-196, 79], [-378, -29], [-111, 129], [-111, 336], [-137, -165], [-287, 473], [-209, -287], [-124, 151], [-71, -265], [-294, 72], [209, -294], [-307, -243], [-332, -57], [-183, -243], [124, -265], [-118, -172], [20, -143], [-307, -93], [-32, 107], [-235, 50], [-46, -200], [-222, -129], [-39, -114], [-143, 64], [26, 193], [-176, 194], [-20, 193], [-124, 43], [-182, -251], [-33, -357], [-91, -165], [111, -107], [-59, -229], [-183, -129], [-359, 122], [-371, -115], [-770, -486], [-150, 71], [-72, -93], [-196, 43]], [[29552, 26077], [13, 193], [98, -21], [228, 923], [222, 50], [196, 136], [137, 221], [339, 301], [-98, 122], [150, 157], [372, 143], [65, 279], [144, 165], [-13, 214], [-131, 215], [-39, 250], [53, 387], [-320, 314], [26, 558], [-502, 401], [97, 265], [209, 157], [196, -215], [130, 93], [248, -171], [183, -337], [157, 115], [476, -86], [0, -193], [306, 193], [-52, 365], [-169, -36], [-438, 186], [46, 301], [-59, 314], [13, 315], [-169, 222], [59, 272], [-53, 465], [248, -50], [340, 422], [97, 293], [294, -7], [404, 72], [242, -144], [261, 86], [208, 487], [229, -29], [-124, 251], [39, 257], [222, 365], [59, 215], [195, 64], [13, 222], [-111, 214], [196, 408], [294, 165], [241, 207], [235, 50], [98, 108], [-52, 293]], [[35300, 37259], [221, -93], [183, -272], [365, -143], [209, 7], [209, 100], [39, 122], [483, 14], [182, 50], [209, -64], [352, 193], [72, -258], [-6, -250], [-235, -436], [267, 7], [268, -172], [209, 215], [306, 71], [196, -114], [306, -72], [216, 115], [6, -265], [105, -64], [189, 86], [117, 178], [26, 737], [-97, 215], [254, 129], [111, -129], [378, -186], [255, -236], [221, 36], [451, -287]], [[41367, 36493], [332, -221], [340, -129], [13, -222], [143, -157], [137, 164], [196, -86], [72, -257], [378, -107], [156, -408]], [[14952, 14180], [-85, 236], [-221, 1109], [-59, 114], [-26, 759], [-46, -100], [-169, 579], [-196, 293], [-65, 358], [-118, 286], [-52, 372], [85, 29], [-157, 172], [-124, -43], [-111, 450], [-130, -7], [-222, 186], [72, 108], [235, 64], [-72, 57], [-163, -114], [-85, 107]], [[13243, 19195], [346, 172], [111, 558], [-111, 136], [130, 64], [-143, 451], [0, 336], [-163, 93], [-144, -29]], [[13269, 20976], [85, 208], [150, 100], [170, -100], [195, 222], [-39, 93], [157, 264], [-33, 279], [144, 36], [-46, 343], [-294, 86], [-26, 201], [111, 50], [-241, 350], [228, -7], [183, 250], [209, -57], [45, -164], [261, 121], [46, 244], [404, 157], [-26, 207], [235, 208], [215, 0], [222, -200], [196, 78], [0, 129], [404, 72], [85, -58], [209, 129], [196, -36], [13, 194], [-92, 150], [26, 179], [-156, 393], [143, 200], [346, -229], [228, 93], [151, -214], [352, 121], [280, 22], [242, -86], [111, 64], [-144, 265], [13, 308], [157, 43], [267, 314], [196, -14], [169, -136], [183, 301], [-32, 157], [221, -43], [105, 222], [65, 451], [385, 71], [65, 129], [241, 157], [85, 315], [176, -57], [7, -186], [261, -165], [196, 65]], [[20974, 27265], [117, -430], [-91, -128], [104, -122], [26, -222], [-235, -193], [39, -207], [-137, -79], [-130, -215], [196, -128], [267, -58], [144, 36], [-196, -186], [-496, -622], [124, -208], [72, -293], [-65, -179], [-59, -508], [59, -300], [-392, -344], [79, -107], [450, -64], [124, -108], [-111, -128], [-53, -222], [14, -422], [-85, -115], [-476, 50], [-196, -35], [-242, -201], [-26, -272], [137, -221], [-195, -122], [19, -243], [-85, -22], [124, -357], [183, -101], [59, -393], [-203, -322], [-404, 86], [-222, 114], [-98, -236], [222, -121], [-46, -358], [-137, -372], [46, -165], [170, -200], [195, 14], [-130, -207], [124, -193], [-26, -129], [352, -72], [137, 272], [300, -14], [248, -236], [-13, 222], [222, -93], [6, -229], [-202, -57], [-98, -251], [157, -393], [-157, 28], [-71, 222], [-124, 50], [-294, -43], [-267, 143], [-53, 251], [-117, 43], [-98, -122], [131, -136], [13, -164], [156, -251], [-117, -229], [169, -150], [196, 43], [-39, 215], [111, 121], [320, -136], [195, 0], [131, -343], [515, 136], [268, 293], [0, 136], [195, -57], [111, 100], [-13, -308], [241, 129], [111, -64], [40, -379], [202, -229], [417, -29], [-45, -515], [84, -122], [392, -100], [-26, -215], [-320, -593], [85, -165], [-170, 115], [-85, -108], [-208, -35], [-33, -222]], [[22487, 14166], [-391, 214], [-170, -100], [-111, 136], [-280, -14], [-111, -272], [-137, -150], [-183, -7], [-98, -279], [124, -215], [-52, -179], [-300, -300], [59, -136], [391, 0], [157, -72], [65, -193], [-274, -336], [-274, -22], [-248, -357], [-307, 57], [-280, -36], [-144, -100], [-182, 157], [-209, -57], [-183, -408], [-156, 43], [-444, -14], [-46, 164], [-261, -93]], [[18442, 11597], [-84, 194], [-157, 0], [-346, 279], [-130, -22], [-39, 236], [-216, -64], [-306, 36], [-183, 279], [-280, 78], [-222, 165], [-209, 250], [-130, 58], [-98, 228], [45, 194], [-111, -22], [-143, 172], [46, 143], [-340, 57], [-39, 129], [-169, 14], [-170, 201], [-209, -22]], [[12356, 21170], [-235, 422], [-307, 393], [-19, 315], [-65, 64], [-229, 787], [33, 265], [-118, 465], [46, 265], [-170, 672], [72, 29], [-169, 250], [26, 215], [-124, 200], [-59, 544], [-189, 372], [-105, 579], [20, 107], [209, -42], [-33, 128], [-176, 29], [-157, 172], [-26, 329], [163, 86], [-137, 43], [-123, 293], [26, 272], [137, 64], [111, -114], [91, 78], [-268, 201], [209, 243], [-32, 393], [-66, -257], [-130, -72], [-163, -300], [-46, 207], [72, 437], [-98, -22], [-85, 723], [307, 157], [-222, 7], [-144, 165], [-150, 558], [124, 543]], [[10157, 31435], [535, 129], [111, -207], [222, 36], [117, -65], [40, 208], [150, 21], [84, 165], [255, -22], [0, 365], [-52, 72], [221, 393], [-195, 286], [150, 136], [580, -365], [209, 108], [39, 150], [209, 207], [0, 294], [-78, 214], [-353, 329], [-169, 15], [-183, 150], [326, -43], [177, 114], [71, 172], [222, 0], [85, 208], [215, 207], [137, -21], [418, 143], [-13, 143], [-235, -65], [-411, 22], [-392, -115], [-137, 279], [157, 65], [-46, 436], [294, 86], [411, 186]], [[13328, 35871], [222, -64], [365, 229], [209, -179], [13, -301], [72, -250], [417, -243], [411, 7], [346, -136], [202, -301], [391, -107], [490, -29], [626, 29], [144, 43], [489, -100], [111, -401], [-98, -50], [98, -143], [313, -79], [333, 79], [195, 193], [209, 29], [85, 114], [-52, 215], [221, 172], [124, 186], [20, 200], [280, 100], [248, 172], [307, 78], [98, -64], [228, 172], [333, 0], [196, -179], [58, -344], [-319, -14], [124, -358], [306, 22], [170, -57], [209, 114], [169, -64], [352, 93], [366, 272], [489, 128], [39, -236], [124, 50], [463, -128], [503, 93], [6, 143], [685, 207], [26, 115], [548, -115], [157, -279], [456, 122], [203, -158], [515, 101], [235, 164], [274, -143], [209, -236], [39, -208], [182, 8], [281, -165], [111, 64]], [[27954, 34454], [-111, -264], [-352, -193], [-79, -344], [105, -193], [169, -79], [33, -479], [-170, -179], [281, -50], [0, -644], [-222, -150], [-202, -43], [-39, -207], [254, -50], [65, -229], [-52, -251], [-182, 15], [-59, -108], [130, -107], [-169, -157], [169, -36], [53, 121], [208, -250], [131, -29], [72, -214], [319, -150], [124, -136], [-52, -158], [-144, -36], [59, -164], [-241, -179], [-98, 150], [-137, -7], [-85, 172], [-391, -336], [-131, -394], [-163, -322], [163, -229], [-182, -229], [19, -93]], [[27047, 28223], [-411, -35], [-196, 200], [-182, 100], [98, 93], [-59, 444], [-163, -8], [182, 287], [-39, 136], [92, 443], [-379, 422], [-137, 22], [-267, -93], [-39, -108], [-437, 43], [-124, 100], [-229, 43], [-111, 115], [-195, -22], [-281, -150], [-235, 157], [-71, 215], [-548, 208], [-268, -43], [-248, 178], [-111, -28], [176, -308], [-195, -343], [-13, -229], [-183, -93], [-111, -179], [13, -236], [-254, -36], [-176, 150], [-170, 15], [-124, -251], [-46, -243], [-182, -157], [352, -522], [-157, -65], [-137, -243], [-169, -57], [-46, -258], [-176, -28], [-228, -423], [111, -171]], [[13269, 20976], [-306, -57], [-118, 243], [-189, 151], [-72, -101], [-228, -42]], [[53566, 41980], [189, 558], [-39, 229], [78, 58], [281, -143], [221, 64], [20, 150], [-222, 179]], [[54094, 43075], [398, 351], [189, 7], [346, 171], [-46, 301], [-443, 336], [222, 229], [-209, -21], [-463, 422], [-490, -179], [0, 300], [118, 244], [-72, 171], [183, 215], [-842, -93], [-143, 107], [-170, -100], [-98, -222], [-176, -14], [26, 186], [-130, 0], [-235, -308], [0, -86], [-294, -57], [-169, -200], [-157, 21], [0, 251], [-391, -65], [13, 143], [-124, 108], [-418, -43], [-71, 86], [-242, -72], [-59, 86], [-195, -136], [45, 150], [-124, 86], [-254, 14], [-124, -78], [-424, -57], [-359, -372], [-78, -229], [117, -308], [-195, -50], [-39, -186], [-177, -86]], [[48340, 44098], [59, 458], [-124, 429], [124, 279], [-196, 258], [-71, 243], [-137, 100]], [[47995, 45865], [391, 329], [131, 487], [-72, 450]], [[48445, 47131], [515, 43], [196, 208], [463, 150], [463, -265], [281, -35], [646, 35], [123, 58], [562, -65], [169, 193], [196, 15], [72, -136], [430, -15], [209, 115], [183, -115], [32, 186], [320, -71], [98, 164]], [[53403, 47596], [293, -21], [888, 229], [208, 136], [261, -36], [450, -229], [803, 86], [189, -100], [522, 136], [313, 236], [26, 222], [307, 293], [574, 479], [-52, 236], [84, 50], [209, -128], [392, 21], [182, 107], [431, 129], [332, 157], [816, 301], [157, -64], [352, 78], [391, 208], [555, 7], [-150, -301], [-281, -350], [59, -215], [183, -143], [13, -372], [208, 100], [72, -179], [-241, -236], [-235, 29], [-352, -136], [-209, 107], [-111, -43], [-170, -271], [-365, -222], [-183, -36]], [[60324, 47861], [-332, -236], [-255, 43], [-254, -322], [-248, -172], [-450, -150], [-209, -336], [-144, -129], [-130, 172], [-150, -165], [-72, -300], [-365, -408], [-78, -336], [39, -222], [-196, -222], [-254, -50], [45, 236], [-124, 65], [-169, -93], [71, -129], [-411, -415], [-430, -358], [267, -336], [-6, -222]], [[56469, 43776], [-124, -157], [-431, -988], [-169, -14], [-85, -286], [26, -265], [-78, -43], [-105, -386]], [[55503, 41637], [-417, -43], [-196, 222], [-78, -243], [-176, -172], [-13, -136], [-294, -250], [-124, 28], [-46, 229], [-267, -7]], [[53892, 41265], [-170, 64], [92, 208], [-85, 350], [-163, 93]], [[59150, 44120], [-98, -122], [-124, -358], [52, -164], [255, -93], [52, -158], [-124, -429], [-156, -329], [-164, -100], [-84, -251], [-144, -121], [-183, -437], [-78, -71], [-241, -794], [-196, -358], [-222, 165], [-267, 78], [-170, -35], [-137, 150], [-287, 36], [-91, -101], [-268, -21], [-195, 279], [-144, -100]], [[56136, 40786], [-169, 78], [-268, -57], [-280, 143], [84, 687]], [[56469, 43776], [352, -229], [163, 294], [287, 279], [-111, 121], [98, 107], [503, 22], [352, -129], [306, 29], [561, 415], [-84, -379], [254, -186]], [[60481, 46953], [-98, 50], [-196, -158], [-169, -336], [58, -157], [-58, -251], [111, -436], [111, -172], [-307, -250], [33, -394], [-105, -71], [-417, -523], [-294, -135]], [[60324, 47861], [111, -136], [-52, -257], [72, -158], [26, -357]], [[54094, 43075], [-182, 165], [-679, 257], [-600, -36], [-157, -107], [-248, 93], [-267, -64], [-437, 157], [-926, -150], [-150, 71], [-562, 0], [-306, -50], [-522, 151], [-496, 200], [-196, -29], [-26, 365]], [[12930, 55344], [-124, 301], [-111, 57], [365, 365], [111, 50], [59, 229], [183, 86], [391, 565], [150, -7], [255, 150], [306, 286], [-235, 57], [-98, 107], [53, 351], [169, 322], [-124, 408], [-143, 236], [130, 272], [333, 286], [196, -14], [98, 193], [306, 28], [170, 143], [293, -21], [268, 143], [143, 265], [-130, 164]], [[15944, 60366], [326, 15], [124, -86], [254, 221], [150, 15], [366, 272]], [[14195, 54743], [-1343, 72], [-33, 136], [157, 236], [-46, 157]], [[6471, 42338], [-319, 601], [-118, 444], [-208, 229], [-274, 472], [26, 472], [-46, 164], [-613, -64], [-255, 79], [-71, 186], [-294, 336], [-13, 393], [170, 372], [26, 566], [-72, 164], [-176, 57], [-535, -14], [-339, 229], [-359, 136], [-85, 172], [98, 572], [150, 322], [607, 529], [378, 444], [163, 458], [522, 486], [418, 72], [280, -229], [13, -186], [268, -344], [339, 22], [528, 243], [366, 100], [548, 15], [671, 193], [85, 386], [209, 265], [352, 300], [111, 215], [131, 472], [274, 322], [1167, 565], [333, 487], [411, 729], [307, 923], [417, 193], [398, 93], [470, 365]], [[20373, 49685], [111, -372], [33, -250], [248, -372], [326, -136], [124, -293], [-157, -172], [-195, -79], [130, -143], [196, 22], [163, -100], [-574, -229], [-137, -101], [-13, -178], [548, 229], [137, 107], [613, -57], [294, 100], [267, -29], [-124, -172], [59, -93]], [[22422, 47367], [-215, -64], [-53, -265], [-156, 29], [-261, -86], [-144, -200], [-254, -165], [-222, -50], [-411, -257], [-189, -29], [-300, -286], [-196, -7], [-685, -515], [-209, -244], [-156, 15], [-242, -179], [-137, -258], [144, -658], [183, -164], [332, -136], [313, -65], [392, 122], [196, -36], [124, 193], [195, 50], [144, -701], [-105, -78], [-319, 28], [-431, -86], [-326, -128], [52, -272], [-235, -222], [216, -193], [195, -15], [190, -214], [-27, -258], [-261, -100], [-71, 143], [-183, 0], [13, -465], [183, -279], [-72, -164], [-209, -36], [-254, 200], [-13, 165], [-150, -65], [-85, -164], [-189, 121], [-516, 29], [-84, 179], [-137, -72], [-20, -443], [-274, -200], [-20, -201], [-469, -193], [-105, 72], [-65, -287], [-228, 58], [-209, 229], [-39, 178], [98, 129], [169, -107], [274, 7], [170, 279], [-137, 165], [111, 293], [-98, 64], [-13, 301], [235, 7], [45, 300], [-254, 422], [-241, -93], [-444, -85], [-509, 43], [-111, 100], [72, 300], [124, -107], [281, 43], [0, 93], [-196, -43], [-13, 265], [72, 150], [-424, -43], [-79, -329], [-267, -93], [-353, 164], [40, -322], [300, -21], [-20, -222], [-209, -71], [-221, 236], [26, -222], [-137, -394], [280, -157], [-182, -179], [-72, -236], [306, -57], [59, -279], [163, -200], [-137, -322], [-13, -215], [72, -336], [-268, -394], [-378, -157], [-280, -329], [71, -107], [281, -65], [91, -114], [-541, -251], [-196, 29], [-144, -93]], [[13771, 38425], [-208, 286], [-196, 7], [-137, 265], [-281, 207], [-143, -57], [-183, 229], [-222, -36], [-182, 43], [-26, 394], [-118, 78], [-150, -64], [26, 172], [-332, 243], [26, 293], [111, 79], [-157, 386], [-209, -214], [-319, 293], [-85, 157], [137, 315], [169, 43], [-280, 122], [0, 236], [-209, -43], [-156, -301], [-405, 43], [-169, 193], [-346, 115], [-144, -179], [-71, 193], [-359, 158], [137, 136], [-255, -29], [-235, 57], [-84, 115], [-307, -115], [-98, 79], [-156, -122], [-124, 100], [-255, -57], [-209, 86], [-378, -107], [-313, -22], [-405, 136]], [[26610, 52082], [352, -208], [261, -264], [313, -108], [53, 251], [300, -143], [293, -251], [490, -279], [332, -57], [352, -587], [144, 108], [196, -215], [652, -400], [300, -144], [209, 165], [157, -29], [489, -343], [391, -222], [463, 93], [137, -179], [85, -314], [281, -22], [306, -100], [268, 0], [280, -258], [183, 51], [98, 271], [463, -35], [587, -265]], [[35045, 48598], [196, -286], [-13, -143], [209, -279], [97, -286], [170, -115], [209, 0], [0, -265], [143, -43], [170, -243], [-633, 22], [-117, -215], [-196, -100], [-39, -143], [169, 43], [379, -186], [0, -244], [-405, -100], [-45, -100], [182, -257], [183, -79], [294, -329], [208, 36], [183, -179], [170, -15], [169, -143], [-13, -121], [-267, -108], [-242, 151], [-137, -58], [39, -171], [-241, -22], [-19, 165], [-157, 14], [-307, -300], [-522, -387], [-893, -515], [-105, -372], [92, -157], [-33, -279], [405, -422], [-27, -415]], [[34301, 41952], [-280, -86], [130, -329], [-267, -501]], [[33884, 41036], [-281, -465], [-267, -86], [-281, 7], [-365, 208]], [[32690, 40700], [-267, 393], [124, 115], [71, 272], [-71, 207], [0, 315], [169, 36], [-65, 221], [-170, 151], [-241, -86], [-378, 79], [-13, -179], [-255, -29], [46, 115], [-144, 100], [7, 150], [-144, -22], [0, 165], [-150, -93], [-398, 150], [-169, 122], [-111, 257], [-176, -28], [-98, 107], [-300, 43], [-85, 272], [-372, -107], [-280, 35], [-7, -164], [-137, -172], [-13, -172], [-170, -114], [-221, 143], [-535, 43], [143, 243], [85, 272], [-437, -136], [111, -150], [-196, -7], [-111, 157], [-85, -93], [-182, 29], [124, -179], [-124, -64], [-366, -8], [-65, 122], [346, 265], [-52, 171], [-157, 86], [-98, 308], [-209, 0], [-143, -150], [-248, -43], [-398, -229], [59, -193], [-450, -22], [-222, 86], [-131, -143], [-248, 36], [0, -143], [-123, 164], [195, 265], [-365, 43], [39, -258], [-378, 72], [-183, -50], [46, 193], [-111, 64], [-242, -257], [-58, 107], [143, 179], [79, 307], [-124, 36], [-66, 222], [-71, -258], [-98, 0], [-46, 229], [-124, -64], [46, -143], [-59, -208], [-124, 129], [-183, 15], [-143, -337], [228, -372], [39, -336], [209, -358], [-26, -379], [307, -36], [267, -400], [-26, -158], [-307, -407], [-352, 136], [-398, 286], [-189, -236], [-170, 78], [40, 151], [-281, 271], [98, 151], [-13, 257], [-209, 437], [320, 257], [117, 472], [-241, 515], [209, 194], [45, 157], [418, 50], [424, 157], [0, 380], [137, 93], [326, 629], [-78, 129], [58, 236], [255, 200], [-72, 351], [-143, 229], [-79, 264], [-195, 15], [-294, 207], [-326, -93], [-392, 158], [-84, 78], [-333, -86]], [[21045, 55766], [170, 29], [209, -165], [437, -229], [-255, -229], [-195, -357], [0, -236], [182, -515], [307, 150], [320, -165], [202, 222], [-98, 415], [85, 79], [209, -158], [208, -315], [222, -85], [241, -337], [490, -293], [222, -57], [0, -100], [-418, -251], [326, -157], [111, -258], [307, 108], [548, -422], [163, -8], [156, -286], [281, 72], [46, -72], [502, 65], [52, -165], [118, 29], [150, -193], [97, 0], [170, 200]], [[23935, 57934], [92, 129], [130, -79], [85, 243], [111, 22], [280, -229], [59, -251], [170, -250], [176, -72], [45, -136], [183, -50], [255, -178], [332, 85], [255, -50], [476, -400], [235, 0], [143, -151], [-156, -107], [39, -272], [326, -35], [444, -208], [104, 22], [268, -129], [163, -193], [463, -186], [72, -93], [-353, -165], [-293, -315], [-320, -143], [-267, -372], [-183, -86], [39, -300], [-150, -272], [-228, -179], [130, -300], [-98, -401], [-228, -71], [-52, -272], [-131, -108], [-26, -264], [85, -36]], [[43819, 43569], [-13, -294], [164, -136], [71, -336], [-85, -243], [118, -394], [-170, -93], [-124, 51], [79, -222], [-183, -451], [-222, -136], [85, -172], [-144, -28], [-52, -136], [-182, 36], [-72, -265], [-268, -43], [-65, 129], [-183, -65], [137, -207], [-97, -215], [-196, 72], [26, -165], [-248, 36], [-398, 200], [-124, -143], [-13, -236], [-796, -264], [-228, -129], [-52, -179], [-203, -157], [-273, 143], [26, 136], [-242, 114], [-65, -229], [-372, -64], [144, -158], [-137, -365], [124, -236], [293, -21], [352, -351], [85, 36], [529, -36], [124, -50], [-203, -100], [-45, -365], [424, -257], [52, -172], [170, -29], [169, -171], [-111, -50], [176, -193], [131, -287], [-170, -28], [-195, -158]], [[35300, 37259], [195, 229], [307, 143], [111, 229], [248, 214], [-53, 201], [-404, 128], [-72, -64], [-58, 208], [-164, 228], [53, 301], [-53, 172], [-156, -29], [19, 265], [137, 186], [-71, 179], [-137, -158], [-379, 79], [-45, 315], [-85, 193], [-307, 265], [-85, 314], [-150, 129], [-267, 50]], [[34301, 41952], [516, -50], [78, 71], [294, 15], [280, 186], [137, -329], [450, 114], [13, -193], [379, -351], [241, 215], [150, -43], [98, 165], [222, 121], [156, -129], [85, -207], [379, 93], [39, -115], [169, 208], [281, 143], [509, 21], [124, 136], [182, 22], [-39, 179], [222, 300], [196, 0], [182, -172], [235, 108], [196, -172], [111, -272], [300, -14], [-33, -272], [366, -222], [124, 329], [202, 194], [176, -51], [202, 115], [300, -136], [59, 193], [300, -43], [39, 429], [124, 201], [-13, 257], [150, 215], [176, 21], [65, 244], [255, 14], [261, 336], [169, -136], [385, -64], [26, -57]], [[35045, 48598], [-52, 207], [444, 50], [195, 144], [379, -330], [645, -114], [164, -200], [19, -179], [-85, -258], [313, -136], [98, 36], [261, -136], [222, -272], [313, 15], [78, -208], [203, -50], [698, 265], [195, -93], [59, -372], [261, -208], [411, 208], [378, -165], [222, 58], [477, -187], [489, -271], [241, 57], [111, 136], [378, 200], [85, -350], [118, -93], [195, 35], [209, -157], [98, 150], [209, 57], [306, -121], [379, 164], [254, 29], [235, -229], [215, 215], [26, 200]], [[44491, 46695], [242, 29], [0, -122], [195, -165], [40, -221], [-268, -115], [-215, -222], [-248, -128], [-294, -272], [-84, -351], [241, -257], [294, -208], [58, -443], [-254, 107], [-463, -300], [208, -308], [-124, -150]], [[44309, 48369], [72, 172], [-33, 415], [202, 336], [111, 486], [-143, 143], [65, 108], [567, 78], [268, 108], [248, 179], [463, -258], [72, -358], [-98, -450], [-131, -229], [59, -351], [254, -222], [-254, -171], [-98, -222]], [[45933, 48133], [-476, 64], [-333, -221], [-398, 150], [-222, 14], [-195, 229]], [[29552, 26077], [-378, 7], [-144, 72], [-287, -150], [-98, 150], [-19, 300], [-98, 294], [39, 157], [-176, -50], [-46, 150], [-261, -57], [92, 157], [-176, 408], [-301, 351], [-137, 93], [-332, -22], [-118, 272], [-65, 14]], [[27954, 34454], [98, 287], [13, 558], [169, 150], [72, 172], [0, 250], [222, 351], [98, -115], [98, 329], [228, 286], [13, 258], [111, 136], [124, -86], [241, 129], [196, -136], [241, 186], [235, 71], [59, 143], [209, 122], [26, 408], [196, 107], [182, 193], [0, 193], [281, 136], [124, -14], [130, 508], [-189, 143], [-124, -14], [-307, 329], [-365, 93], [-254, -129], [-92, 172], [222, 293], [-150, 351], [137, 121], [209, -200], [352, 93], [320, -93], [1011, -64], [267, 164], [40, 122], [254, 100], [39, 143]], [[13328, 35871], [39, 258], [-183, 357], [26, 308], [268, -29], [111, 150], [-261, 36], [-228, 165], [84, 100], [222, -14], [268, 229], [215, 78], [183, 372], [-216, 165], [-85, 379]], [[26108, 12277], [-85, -300]], [[26023, 11977], [-183, 21], [-130, 315], [215, 14], [13, -150], [170, 100]], [[15957, 12470], [-176, -50]], [[15781, 12420], [0, 201], [222, 100], [124, -36], [-170, -215]], [[26101, 9966], [0, -400]], [[26101, 9566], [-306, 229], [45, 186], [261, -15]], [[26023, 11977], [-131, -544], [72, -408], [98, -207], [59, -422], [-20, -430]], [[26101, 9566], [33, -1009], [-26, -229], [-216, 64], [-319, 0], [332, -64], [0, -57], [-456, 93], [-59, 86], [-293, -29], [-281, -215], [-85, -150], [98, -315], [-170, -150], [-247, -400], [-327, -473], [-65, -350], [281, -322], [463, -72], [163, 86], [228, -393], [-300, 222], [-274, 50], [-182, -43], [-216, 57], [-280, -64], [-542, -265], [-463, -86], [-385, -322], [-137, -250], [-39, -308], [-111, -172], [65, -143], [-26, -250], [-143, -272], [-581, -343], [-117, -136], [-248, -43], [-294, -186], [-450, 136], [-437, 357]], [[19995, 3606], [124, 51], [104, 264], [-19, 150], [156, 129], [-195, 222], [-20, 157], [170, 372], [-124, 93], [-85, 258], [209, 279], [241, 701], [85, 107], [-124, 272], [-228, -43], [-124, 122], [98, 358], [-14, 279], [72, 193], [-72, 229], [111, 357], [-195, 329], [-255, -107], [-267, -193], [-261, 229], [-72, 279], [39, 465], [118, 136], [26, 207], [-131, 215], [-280, 122], [-39, 264], [182, 36], [-254, 379], [-281, -21], [-195, 43], [228, 272], [-294, 243], [-352, 93], [-26, 300], [222, -28], [169, 178]], [[22487, 14166], [157, -193], [267, -101], [163, 136], [7, 115], [195, 86], [137, 508], [170, 150], [476, 93], [320, -136], [228, 50], [137, 193], [144, -21], [261, 214], [58, 265], [196, 0], [98, -129], [196, 36], [117, -165], [150, 0], [-72, 129], [451, 208], [13, 121], [195, 136], [477, -14], [143, -93], [52, -186], [-39, -308], [-111, -357], [-39, -551], [-78, -379], [-163, -473], [-659, -1073], [-26, -150]], [[13243, 19195], [-111, 79], [-19, 179], [-261, 193], [78, 193], [-124, 429], [-248, 158], [346, 7], [-307, 86], [150, 214], [-261, -57], [-130, 494]], [[53403, 47596], [-59, 251], [-137, 186], [209, 472], [-242, 393], [-502, -128], [-346, 307], [-32, 258], [117, 243], [320, 7], [196, -79], [326, 29], [215, 157], [228, -14], [85, 143], [131, -179], [724, 301], [156, 265], [-98, 186], [281, 214], [85, -43], [613, 444], [98, 136], [182, 501], [183, 57], [724, 28], [216, 58], [319, 186], [124, 136], [242, 71], [-27, 258], [274, 50], [229, 314], [293, 165], [281, 43], [293, 250], [157, -93], [170, -272], [169, 8], [307, -108], [-85, 108], [613, -258], [385, -71], [261, 422], [744, 422], [163, 14], [313, 157], [320, -479], [254, 36], [98, -65], [-111, -171], [-235, -65], [-215, -193], [98, -193], [-59, -136], [163, -14], [261, 243], [365, 100], [-71, -193], [313, -529], [-313, -179], [-13, -122], [-294, -236], [46, -143], [-216, -150], [340, -122], [58, 115], [333, 128], [170, 8], [319, -236], [477, -58], [267, 72], [463, -351], [-39, -357], [111, -101], [-59, -307], [-195, 36], [-405, -372], [-130, -36], [-313, -322], [39, -365], [567, -765], [-241, -79], [-411, 243], [39, 122], [-222, 229], [-385, 35], [-91, -114], [-313, -14], [-587, -101], [-294, -157], [-280, -386], [-242, -72], [-176, -236], [-241, -172], [-235, -28], [-215, -279], [-320, -107]], [[56136, 40786], [111, -294], [52, -407], [131, -215], [-72, -458], [20, -250], [-72, -158], [-7, -357], [-124, -222], [-163, -72], [-156, 129], [-85, -129], [85, -243], [-216, -300], [-19, -251], [78, -121], [-13, -244], [150, -300], [7, -329], [-59, -150], [-268, 21], [7, -186], [-131, -121], [27, -158], [-281, 72], [-326, 286], [-78, -29], [-46, -272], [-170, -100], [-91, 358], [91, 86], [-130, 822], [-46, 423], [-124, 164], [-32, 258], [-150, 128], [-72, 673], [45, 315], [-104, 200], [-111, 429], [20, 215]], [[53814, 39999], [26, 322], [111, 43], [13, 586], [-72, 315]], [[53814, 39999], [-150, -129], [-92, 200], [-339, -200], [-150, 179], [-46, -172], [66, -365], [-248, -193], [-196, -336], [111, -451], [-222, -214], [-248, -115], [-176, 243], [-91, 322], [-118, 165], [-124, -57], [40, -387], [-164, 193], [-45, 380], [-111, 386], [-209, 379], [72, 129], [-59, 136], [144, 71], [13, 294], [137, 221], [150, 15], [45, 250], [444, -28], [144, 271], [241, -100], [0, 172], [170, -29], [124, -171], [97, 264], [-13, 179], [157, -50], [-46, 136], [352, 64], [-6, 222], [98, 107]], [[44563, 35649], [65, 29], [33, -401], [-72, -179], [-195, 122], [169, 429]], [[47995, 45865], [-98, 79], [-13, -387], [-170, -236], [-85, 101], [-306, -8], [-496, 329], [-170, 494], [-235, 222], [-137, -172], [333, -279], [-137, -57], [-169, 114], [-170, -107], [-268, 200], [-110, 244], [-327, 171], [-332, 244], [-98, -222], [326, -100], [78, -244], [-150, 22], [-182, -136], [-85, -229], [-346, -179], [-13, -229], [-170, -293], [124, -315], [222, 72], [431, -358], [6, -143], [235, -222], [326, -79], [150, 115], [157, -129], [-26, -136], [111, -179], [280, -57], [-117, -315], [-261, 65], [-33, -72], [-430, 65], [-379, -43], [-13, -294], [-222, -415], [-182, 15], [-131, 157], [-156, -71], [58, -172], [-195, -208], [-72, -264], [267, -351], [574, -300], [170, -122], [352, -50], [190, 50], [71, -243], [-150, -115], [-13, -221], [111, -101], [-13, -200], [-143, -172], [-137, -7], [-98, -221], [-20, -322], [398, -401], [111, 0], [-183, -415], [46, -122], [554, -78], [-234, -315], [-26, -258], [234, -279], [-84, -250], [97, -422], [111, -258], [-26, -157], [196, -565], [-85, -143], [46, -351], [-105, -78], [-234, 157], [241, -279], [150, -558], [-176, -29], [-268, 150], [-267, -264], [-170, 329], [98, 808], [-111, -236], [-124, 43], [66, 150], [-40, 215], [-156, -615], [0, -186], [130, 14], [-71, -386], [-111, -186], [-131, 50], [98, 236], [-52, 193], [59, 136], [-118, 272], [33, -251], [-92, -157], [46, -179], [-143, -150], [-40, 229], [-150, 7], [-130, 186], [85, -486], [-124, -29], [-157, 243], [59, 336], [-111, 201], [6, 243], [144, 200], [-52, 208], [-385, 143], [-91, 93], [-131, 379], [46, -351], [137, -178], [280, -58], [85, -143], [-267, -307], [-150, -308], [-340, -308], [-293, -164], [-503, -100]], [[44491, 46695], [170, 393], [-26, 372], [-170, 308], [-228, 258], [72, 343]], [[45933, 48133], [242, -179], [26, -300], [71, 78], [248, -128], [229, -244], [195, -21], [353, 93], [221, -129], [235, 7], [255, -171], [352, -72], [85, 64]], [[46312, 34991], [-137, -114], [0, 193], [137, -79]], [[45750, 35814], [-13, -329], [-110, 35], [123, 294]], [[19995, 3606], [-267, 201], [-248, 357], [-718, 873], [157, 272], [-209, -150], [-385, 908], [-124, 394], [-59, 823], [170, -58], [72, -322], [-85, -343], [241, -86], [98, 86], [-215, 86], [19, 265], [-130, 550], [-183, 144], [-65, 286], [-143, 14], [-170, 665], [-124, 301], [-254, 493], [-235, 880], [-353, 837], [-137, 58], [-241, 601], [-437, 479], [-13, 250]], [[15781, 12420], [-46, -21], [-170, 472], [-391, 773], [-222, 536]], [[10157, 31435], [98, 480], [294, 558], [32, 508], [98, 64], [-228, 193], [59, 143], [-222, 329], [196, 29], [-98, 193], [-242, -136], [59, 179], [-215, -28], [182, 128], [-208, 136], [-124, 322], [391, 229], [-352, -157], [85, 171], [293, 179], [170, 186], [137, -7], [509, 222], [26, 79], [-450, -201], [-431, 7], [-437, -35], [59, 400], [124, 201], [208, 136], [-195, -36], [-183, -136], [-85, 121], [85, 451], [157, 136], [306, -114], [144, 171], [182, -57], [66, 107], [-235, 43], [-144, -71], [-352, 100], [-294, -129], [-163, 50], [13, 272], [-156, -250], [-196, 64], [144, -150], [0, -344], [-131, -171], [-209, -29], [-280, -136], [280, -28], [13, -172], [-221, 107], [97, -150], [-221, 57], [-7, -164], [365, 14], [111, -200], [131, -50], [52, -172], [-124, -322], [-307, -386], [0, -272], [-391, -165], [-365, -236], [-405, -172], [-32, 51], [-235, -222], [-326, -86], [-392, -208], [-306, -57], [-53, -71], [-313, -22], [-672, 258], [-613, 408], [-463, 400], [-672, 809], [-281, 293], [-463, 386], [-71, 229], [-124, -36], [-522, 508], [-248, 294], [-105, 221], [85, 294], [196, 150], [0, -200], [241, 71], [59, -71], [-72, -215], [85, -79], [333, 129], [241, 22], [183, 271], [13, -178], [137, -51], [182, 115], [72, 179], [124, -136], [392, 265], [411, 28], [391, 544], [124, 293], [267, 165], [59, 236], [-85, 121], [-169, -85], [-13, -322], [-229, -36], [-150, 93], [-215, -107], [-639, -151], [-307, -279], [-280, 36], [-561, 172], [-301, 43], [-358, 221], [-392, 172], [-398, 265], [-182, 179], [32, 143], [-156, -22], [124, 158], [-405, 279], [131, 164], [-170, -14], [-13, 215], [294, 186], [306, 329], [333, 143], [-418, -108], [-97, -135], [-405, -172], [-183, -272], [-378, 36], [183, 164], [-170, 208], [52, 200], [157, 193], [391, 100], [659, -7], [0, 766], [157, 93], [111, -201], [97, 179], [157, -150], [196, 72], [222, -72], [293, 64], [633, -14], [235, -207], [228, -72], [450, 7], [209, 136], [98, 200], [548, 144], [372, 143], [91, -329], [137, -108], [294, -21], [234, 93], [-13, 121], [183, 108], [130, -29], [196, 122], [-241, 171], [-39, 244], [221, 257]], [[15944, 60366], [-235, 158], [-378, 164], [-268, -50], [-143, 72], [-261, -36], [-131, 86], [-72, 214], [118, 565], [-157, -143], [-293, -43], [-339, 58], [-27, 107], [-756, 358], [-170, 143], [-183, -43], [-443, 265], [52, 164], [-111, 122], [-52, 336], [124, 150], [13, 243], [-137, 165], [52, 279], [-39, 393], [-144, 229], [-97, 616], [-150, 207], [97, 479], [346, 65], [215, 393], [418, 136], [293, 165], [183, 307], [0, 308], [-535, 150], [-261, 15], [-130, 236], [85, 243], [143, 86], [-33, 171], [-600, 29], [-450, 150], [-378, 265], [32, 286], [-143, 107], [-476, -7], [-137, -86], [-340, 36], [-319, 122], [163, 257], [-124, 222], [124, 358], [215, 21], [431, 272], [45, 186], [196, 22], [248, 314], [-52, 208], [248, 93], [293, -36], [229, 86], [1050, -100], [0, 143], [-392, 200], [0, 86], [353, -50], [176, -100], [326, 0], [52, 143], [216, 7], [404, 236], [320, -71], [58, 157], [255, 50], [261, -86], [169, -257], [85, 136], [424, 71], [476, -150], [190, -158], [32, -271], [183, -72], [170, 115], [358, -108], [327, -243], [221, -365], [392, -86], [195, -250], [340, -22], [85, -164], [306, -122], [228, 0], [196, -186], [52, -472], [137, -122], [372, -93], [189, -193], [255, -71], [313, 21], [359, -322], [6, -243], [333, -43], [320, 86], [254, 0], [85, 157], [352, -43], [111, 179], [248, 172], [365, 157], [242, 50], [430, 330], [450, -58], [783, 193], [242, -35], [84, -251], [242, 22], [222, -150], [-72, -108], [124, -243], [280, -86], [98, -129], [170, 115], [182, -401], [242, -36], [189, 308], [215, -136], [170, 7], [13, -179], [-241, -264], [19, -279], [-183, -215], [-19, -486], [-170, -258], [-111, -279], [-443, -71], [-85, -179], [-228, -72], [58, -214], [-156, -86], [-346, 14], [85, -386], [-144, -158], [26, -179], [-267, -228], [-542, 35], [-156, -71], [-294, 28], [-98, -143], [222, -465], [59, -272], [-215, 0], [-79, -100], [79, -486], [117, -179], [196, -79], [59, -143], [150, 29], [508, -150], [-104, -401], [385, -665], [-72, -158], [-404, -357], [-170, 28], [-228, -79], [-85, -243], [-372, -36], [-313, 251], [-170, 400], [-235, -143], [-313, -7], [-150, -93]]], "objects": { "india_state_boundaries": { "type": "GeometryCollection", "geometries": [{ "arcs": [[[0]], [[1]], [[2]], [[3]], [[4]], [[5]], [[6]], [[7]], [[8]], [[9]], [[10]], [[11]], [[12]], [[13]], [[14]], [[15]], [[16]], [[17]], [[18]], [[19]], [[20]], [[21]], [[22]], [[23]], [[24]], [[25]], [[26]], [[27]], [[28]], [[29]], [[30]], [[31]], [[32]], [[33]], [[34]], [[35]], [[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]], [[44]], [[45]], [[46]], [[47]], [[48]], [[49]], [[50]], [[51]], [[52]], [[53]], [[54]], [[55]], [[56]], [[57]], [[58]], [[59]], [[60]], [[61]], [[62]], [[63]], [[64]], [[65]], [[66]], [[67]], [[68]], [[69]], [[70]], [[71]], [[72]], [[73]], [[74]], [[75]], [[76]], [[77]], [[78]], [[79]], [[80]], [[81]], [[82]], [[83]], [[84]], [[85]], [[86]], [[87]], [[88]], [[89]], [[90]], [[91]], [[92]], [[93]], [[94]], [[95]], [[96]], [[97]], [[98]], [[99]], [[100]], [[101]], [[102]], [[103]], [[104]], [[105]], [[106]], [[107]], [[108]], [[109]], [[110]], [[111]], [[112]], [[113]], [[114]], [[115]], [[116]], [[117]], [[118]], [[119]], [[120]], [[121]], [[122]], [[123]], [[124]], [[125]], [[126]], [[127]], [[128]], [[129]], [[130]], [[131]], [[132]], [[133]], [[134]], [[135]], [[136]], [[137]], [[138]], [[139]], [[140]], [[141]], [[142]], [[143]], [[144]], [[145]], [[146]], [[147]], [[148]], [[149]], [[150]], [[151]], [[152]], [[153]], [[154]], [[155]], [[156]], [[157]], [[158]], [[159]], [[160]], [[161]], [[162]], [[163]], [[164]], [[165]], [[166]], [[167]], [[168]], [[169]], [[170]], [[171]], [[172]], [[173]], [[174]], [[175]], [[176]], [[177]], [[178]], [[179]], [[180]], [[181]], [[182]], [[183]], [[184]], [[185]], [[186]], [[187]], [[188]], [[189]], [[190]], [[191]], [[192]], [[193]], [[194]], [[195]], [[196]], [[197]], [[198]], [[199]], [[200]], [[201]], [[202]], [[203]], [[204]], [[205]], [[206]], [[207]], [[208]], [[209]], [[210]], [[211]]], "type": "MultiPolygon", "properties": { "NAME_1": "Andaman & Nicobar", "HASC_1": "IN.AN" } }, { "arcs": [[212, 213, 214, 215, 216, 217, 218, 219, 220]], "type": "Polygon", "properties": { "NAME_1": "Telangana", "HASC_1": "IN.TE" } }, { "arcs": [[[221]], [[222]], [[223]], [[224]], [[225]], [[226]], [[227]], [[228]], [[229]], [[230]], [[231]], [[232]], [[233]], [[234]], [[235]], [[236]], [[237]], [[238]], [[239]], [[240]], [[241]], [[242]], [[244]], [[245]], [[246]], [[247]], [[248]], [[249]], [[250]], [[251]], [[252, 253, -220, 254, -218, 255, -216, 256, -214, 257]]], "type": "MultiPolygon", "properties": { "NAME_1": "Andhra Pradesh", "HASC_1": "IN.AP" } }, { "arcs": [[[258]], [[259]], [[260]], [[261]], [[262]], [[263]], [[264]], [[265]], [[266]], [[267]], [[268]], [[269]], [[270]], [[271]], [[272]], [[273]], [[274]], [[275]], [[276]], [[277]], [[278]], [[279]], [[280]], [[281]]], "type": "MultiPolygon", "properties": { "NAME_1": "Lakshadweep", "HASC_1": "IN.LA" } }, { "arcs": [[282, 283]], "type": "Polygon", "properties": { "NAME_1": "Chandigarh", "HASC_1": "IN.CH" } }, { "arcs": [[284, 285]], "type": "Polygon", "properties": { "NAME_1": "Delhi", "HASC_1": "IN.DL" } }, { "arcs": [[286, 287, 288, 289, 290]], "type": "Polygon", "properties": { "NAME_1": "Himachal Pradesh", "HASC_1": "IN.HP" } }, { "arcs": [[291, 292, -284, 293, -289, 294, -286, 295]], "type": "Polygon", "properties": { "NAME_1": "Haryana", "HASC_1": "IN.HR" } }, { "arcs": [[296, 297, 298, 299]], "type": "Polygon", "properties": { "NAME_1": "Odisha", "HASC_1": "IN.OR" } }, { "arcs": [[300, 301, 302, 303, 304, 305]], "type": "Polygon", "properties": { "NAME_1": "Karnataka", "HASC_1": "IN.KA" } }, { "arcs": [[306, 307, 308, 309, 310, -303, 311]], "type": "Polygon", "properties": { "NAME_1": "Maharashtra", "HASC_1": "IN.MH" } }, { "arcs": [[312, 313, 314, 315, 316, 317, 318, 319, 320, 321]], "type": "Polygon", "properties": { "NAME_1": "Assam", "HASC_1": "IN.AS" } }, { "arcs": [[322, 323, -320, 324]], "type": "Polygon", "properties": { "NAME_1": "Manipur", "HASC_1": "IN.MN" } }, { "arcs": [[325, -325, -319, 326]], "type": "Polygon", "properties": { "NAME_1": "Nagaland", "HASC_1": "IN.NL" } }, { "arcs": [[327, -314]], "type": "Polygon", "properties": { "NAME_1": "Meghalaya", "HASC_1": "IN.ML" } }, { "arcs": [[328, 329, -290, -294, -283, -293, 330]], "type": "Polygon", "properties": { "NAME_1": "Punjab", "HASC_1": "IN.PB" } }, { "arcs": [[331, -331, -292, 332, 333, 334]], "type": "Polygon", "properties": { "NAME_1": "Rajasthan", "HASC_1": "IN.RJ" } }, { "arcs": [[335, 336, 337, 338, 339, -333, -296, -285, -295, 340]], "type": "Polygon", "properties": { "NAME_1": "Uttar Pradesh", "HASC_1": "IN.UP" } }, { "arcs": [[341, -341, -288]], "type": "Polygon", "properties": { "NAME_1": "Uttarakhand", "HASC_1": "IN.UT" } }, { "arcs": [[342, -299, 343, -338, 344]], "type": "Polygon", "properties": { "NAME_1": "Jharkhand", "HASC_1": "IN.JH" } }, { "arcs": [[345, 346, -345, -337]], "type": "Polygon", "properties": { "NAME_1": "Bihar", "HASC_1": "IN.BR" } }, { "arcs": [[347, 348]], "type": "Polygon", "properties": { "NAME_1": "Sikkim", "HASC_1": "IN.SK" } }, { "arcs": [[-298, 349, -310, 350, -339, -344]], "type": "Polygon", "properties": { "NAME_1": "Chhattisgarh", "HASC_1": "IN.CT" } }, { "arcs": [[-309, 351, -334, -340, -351]], "type": "Polygon", "properties": { "NAME_1": "Madhya Pradesh", "HASC_1": "IN.MP" } }, { "arcs": [[[352, 353]], [[354, 355]], [[356, 357]]], "type": "MultiPolygon", "properties": { "NAME_1": "Puducherry", "HASC_1": "IN.PY" } }, { "arcs": [[-354, 358, -358, 359, 360, -305, 361]], "type": "Polygon", "properties": { "NAME_1": "Tamil Nadu", "HASC_1": "IN.TN" } }, { "arcs": [[362, -312, -302]], "type": "Polygon", "properties": { "NAME_1": "Goa", "HASC_1": "IN.GA" } }, { "arcs": [[-327, -318, 363]], "type": "Polygon", "properties": { "NAME_1": "Arunachal Pradesh", "HASC_1": "IN.AR" } }, { "arcs": [[364, 365, -321, -324]], "type": "Polygon", "properties": { "NAME_1": "Mizoram", "HASC_1": "IN.MZ" } }, { "arcs": [[366, -322, -366]], "type": "Polygon", "properties": { "NAME_1": "Tripura", "HASC_1": "IN.TR" } }, { "arcs": [[[367]], [[368, -300, -343, -347, 369, -349, 370, -316]], [[371]], [[372]]], "type": "MultiPolygon", "properties": { "NAME_1": "West Bengal", "HASC_1": "IN.WB" } }, { "arcs": [[373, -356, 374, -306, -361]], "type": "Polygon", "properties": { "NAME_1": "Kerala", "HASC_1": "IN.KL" } }, { "arcs": [[375, -335, -352, -308]], "type": "Polygon", "properties": { "NAME_1": "Gujarat", "HASC_1": "IN.GJ" } }, { "arcs": [[-291, -330, 376]], "type": "Polygon", "properties": { "NAME_1": "Jammu and Kashmir", "HASC_1": "IN.JK" } }] } }, "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } } };

/***/ },
/* 376 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var expenditure_concordance_data = exports.expenditure_concordance_data = [{ "category": "Urban Development & Housing", "group": [{ "name": "Andhra Pradesh", "description": "This sector includes expenditure by Municipal Administration & Urban Development Department (Vol-III/9) & Housing Department (Vol-III/12) under the Demands for Grants 1. Municipal Administration and Urban Development (Demand XVII) 2. Housing (Demand XVIII). The relative administrations to these demands are 1. Municipal Administration and Urban Development Secretariat 2. Municipal Administration Department 3. Town and Country Planning Department 4. Public Health Engineering Department 5. Housing Secretariat and 6. Weaker Section Housing." }, { "name": "Assam", "description": "The sector captures the expenditure incurred on Housing and Urban Development, under the following Demand for Grants: 1. Urban Development, Town &Country Planning (Grant No-31.)  2. Housing Schemes (Grant No-32).  3. Residential Buildings (Grant No-33).  4. Urban Development- Municipal Admin. (Grant No-34).   5. Urban Development (GDD) (Grant No-73). The major heads taken into account are (2216,2217) from following Demand for Grants- 6. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council (Grant No-76).  7. All Services Heads Within N.C. HILLS Autonomous District Council (Grant No.77) 8. Bodoland Territorial Council (Grant No.78)." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred on Housing &Urban Development, details of which are given in the Demand for Grants for Urban Development &Housing (Demand No-48 with Major Heads 2015, 2215, 2217, 2251, 3475)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred on Housing &Urban Development compiled from the Demand for Grants of Housing and Environment Department (Book-18) with Demand Numbers being 22, 41, 53, 64, 69, 81, 83 and the Housing and Environment (Book-32) with Demand No.21. Housing has been included in Environment." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred on Housing and Urban Development, the following grants are related to the said related expenditure: 1. Urban Development and Housing Department (Demand No-11) 2. Housing Loan Department (Demand No-11)." }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred on Housing and Urban Development, the following grants are related to the said related expenditure: Urban Development and Urban Housing Department (Book-26)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred on Housing &Urban Development, details of which can be found in the following Major Heads :1. 2216 Housing 2. 2217 Urban Development. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred on Housing and Urban Development sector through the grant of Urban Development, Town and Country Planning and Housing (Demand. No. 28)." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred on Urban Development and Housing sector under Demand -19." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under the following departments: 1. Urban Development (Demand No 48) 2. Housing (Demand No.57) through Major Heads 2215, 2216, 2217, 2251)." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under 1. Housing (2216, 2217 &4216), 2. Urban Development (2215, 2217, 3054, 3604, 4215, 4217, 6215 &6217)." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XXI - Housing and Demand XXII - Urban Development." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred by Local Government General (Demand No 22,71,75, TSP (Demand No. 41, 68), SCP (Demand No. 53). " }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred by Housing Department (Demand Q) and Urban Development Department (Demand F). " }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred by 1. Housing Schemes (Grant No 28) &2. Urban Development (Grant No 29)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under the Urban Development &Poverty Alleviation (Demand No. 46), Local Administration (Demand No. 19)." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred on the following: Urban Development (Demand No.36 &Demand No.37)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred on Housing &Urban Development Department (Demand No -13)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred on Housing &Urban Development Department (Demand No 17)." }, { "name": "Rajasthan", "description": "The sector captures the expenditure made through Housing and Urban Development departments. The relevant expenditure data can be accessed through documents named Urban Development and Housing (Volume 2c)." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred on Urban Development and Housing Sector through major heads of Building &Housing and Urban Development &Housing. The relevant documents for reference can be accessed under demand number 3 and 41." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on the departments of Housing &Development and Municipal Administration &Water Supply. Expenditure figures in respect of these demands can be accessed through demand number 26 and 34." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred through the following departments: 1. Urban Development (Demand No. 35), 2. Tribal welfare (Demand No. 19 through the Major Heads of 2216, 2217, 4216, 4217), 3. Welfare of SCs (Demand No. 20 through the Major Heads of 2217, 4216, 4217)" }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on Urban development and Housing sector through the following departments: 1. Urban Development (Demand No. 37), 2. Housing (Demand No. 2)." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on the departments of Housing and Urban Development and water supply. Expenditure figures in respect of these demands can be accessed through demand number 13." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on the departments of Housing and Urban Development. Expenditure figures in respect of these demands can be accessed through demand number 28 and 54." }], "category_slug": "urban_development_housing" }, { "category": "Public Works", "group": [{ "name": "Andhra Pradesh", "description": "Public Works data pertain to expenditure made primarily through Transport Administration (Demand VIII) and Roads & Buildings Department (Demand No. XI).  The relative administrations to these demands are 1. Transport, Roads and Buildings Secretariat 2. Administration, State Roads & Road Safety Works (RSW), ENC (R&B) 3. Buildings Department 4. Core Network Roads (CRN), Road Development Corporation (RDC) & Public Private Partnership (PPP) Department 5. Rural Roads, ENC (R&B) 6. Electrical Chief Engineer 7. National Highways and Central Road Funds Department and 8. Transport Department. In addition, it also includes the data under revenue expenditure for public works (MJ. 2059) and Capital Expenditure (MJ 4059) and loans for Public Works (6059) heads of the following Departments- 1. State Legislature 2. Administration of Justice 3. General Administration and Elections 4. Transport Administration 5. Fiscal Administration, Planning Surveys and Statistics 6. Roads, Buildings & Ports. It excludes the expenditure on Port related works to maintain comparability across States." }, { "name": "Assam", "description": "The sector captures the expenditure incurred through the following relevant major heads (2059, 4059, 6059, 3054, 5054, 7054) under the following Demand for Grants numbers: 1. State Legislature (Grant No-01)  2. Transport Services (Grant No-09).   3. Administrative and Functional Buildings (Grant No-17)  4. Roads & Bridges (Grant No-64). The major heads are (2059) &(3054) in the following grants:  5. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council (Grant no. 76) 6. All Services Heads Within N.C. HILLS Autonomous Dist. Council (Grant No.77)  7. Bodoland Territorial Council (Grant No. 78)." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred through the Demand For Grant of Building Construction (Demand No-03 with Major Heads 2052, 2059, 2216, 2245, 3053, 4047, 4055, 4059, 4202, 4210, 4215, 4216, 4225, 4235, 4250, 4408, 4515)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure recorded through Public Works Department (Book-19 with Demand Numbers 24, 42, 64, 67, 68 and 76)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred by the Public Works Department (Demand No-11)." }, { "name": "Gujarat", "description": "The sector captures the expenditure made by the State Government on Public Works is shown in the Demand For Grants named Roads And Buildings Department (Book N0-22.1 &22.2 consisting Demand Numbers 83, 84, 85, 86, 87 and 88)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred by the following Major Heads: 1. 2059 Public Works 2. 3054 Roads and Bridges 3. 4059-Capital Outlay on Public Works 4. 5054- Capital Outlay on Roads and Bridges. For Haryana, Statement of Demand for Grants is presented Major Head wise." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred through the Demand for Grants naming Public Works - Roads, Bridges and Buildings Demand No. 10." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure made by the Public Works Development Department under Demand Number 16." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred through the Building Construction Department (Demand No 3 through Major Heads 2052, 2059, 2216, 4059, 4216). In addition, it also includes the data under revenue expenditure for public works (Major Head 2059) and Capital Expenditure (Major Head 4059) and Loans for Public Works (Major Head 6059)of the following Departments: Energy Department (Demand No 10), Commercial Tax (demand No-17), Labour (demand no 26) and Personnel &Administrative (demand no 33)." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under Public Works (2059)." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand No. XV - Public Works 2059, 3054, 4059, 5054 &7075." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred under the books of Public Works (Demand No. 24, 67), TSP (Demand No. 42), SCP (Demand No. 64). All these Books are Contained in department-wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure made by the state on infrastructure development through departments of Public Works Department (Demand No. H) . The sector also includes expenditure through Tribal Development department and Planning Department under relevant Major Heads of 2059 and 4059." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred under the following departments: 1. Public Works (Grant No 19) and 2. Roads and Bridges(Grant No 56)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Public Works (Demand No 45)." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred under the following: 1. Planning and Coordination (Demand No. 27, Major Head 4059), 2. Works and Housing (Demand No. 57, 58), 3. Home (Demand No. 62), 4. Works and Housing (Demand No. 64, 74). " }, { "name": "Odisha", "description": "The sector captures the expenditure incurred under the Works Department (Demand No -07)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred through Public works Department (Demand No 21)." }, { "name": "Rajasthan", "description": "The sector captures the expenditure pertaining to demands of Public Works and Bridges. The relevant budget documents reflecting expenditure on the above departments are Revenue Expenditure-Economic Services Vol 2b and Capital Expenditure Vol 3a respectively." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred by the State on Public Works through major heads of Buildings & Houses, Human Resources Development, Health Care/Human Services &Family Welfare, Labour, Land Revenue &Disaster Management, Police, Energy &Power, Water Security &Public Health Engineering, Roads &Bridges, Social Justice Empowerment &Welfare and Urban Development &Housing Departments. The relevant documents for reference are under demand numbers 03, 07, 13, 22, 30, 31, 33, 34, 35, 38 and 41." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure of the State on Public Works through major heads of Buildings (Public Works Department). Expenditure figures in respect of these demands can be accessed through demand number of 39." }, { "name": "Tripura", "description": "The sector captures the expenditure of the State on Public Works under the following: 1. 2. Tribal Welfare (D No 19) (2070, 3054, 4059, 4216, 4552 &5054, 2701, 2702, 2711, 4701, 4702, 4711, 2215 &4215), 3. Welfare for SC ( D No 20) (2070, 3054, 4059, 4216, 4552 &5054, 2701, 2702, 2711, 4701, 4702, 4711, 2215 &4215 ), 4. (Water Resources) (15), 5. Public Works (Drinking Water and Sanitation) (51)." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure of the State on Public Works through major heads of Building, Special Area Programme, Transport-Bridge, Transport-Roads, Planning and State Asset Secretariat. Expenditure figures in respect of these demands can be accessed through demand numbers 54, 55, 40, 56, 57, 58 and 59." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure of the State on Public Works. Expenditure figures in respect of these demands can be accessed through demand number 22." }, { "name": "West Bengal", "description": "The sector captures the expenditure of the State on Public Works through major heads of Public Works (Roads). Expenditure figures in respect of these demands can be accessed through demand number 25 (Book 18)." }], "category_slug": "public_works" }, { "category": "Cooperation & Food, Civil Supplies", "group": [{ "name": "Andhra Pradesh", "description": "Under this Sector, allocations of the Co-Operation & Food, Civil Supplies & Consumers Affairs Department have been compiled. The relevant Demand for Grants are: Co-operation (Demand No. XXX) & Civil Supplies Administration (Demand No. XXXVIII). The relative administrations to these demands are 1. Registrar of Co-operation Societies 2. Food and Civil Supplies, Secretariat Department 3. Civil Supplies, HOD 4. Legal Metrology 5.A.P. State Consumer Disputes Redressal Commission." }, { "name": "Assam", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation (Grant No-43) 2. Food Storage &Warehousing (GrantNo-37). 3. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council   4. All Services Heads Within N.C. HILLS Autonomous Dist. Council 5. Bodoland Territorial Council. For the completeness and consistency of data across states, allocations under the Major Heads (2425, 2405, 2404, 2408, 3456) of the following Demand for Grants have been incorporated." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred on the following: 1. Co-operative (Demand No- 09 with Major Heads 2401, 2408, 2425, 3451) 2. Food &Consumer Protection Department (Demand N0-18 with Major Heads 2408, 3451, 3456, 5475)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred on the following: 1.Co-operation Department (Book-15 with Demand Number 17, 41, 64) 2. Food &Civil Supplies Department (Book-29 with Demand Number 39, 41, 64, 67)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation Department (Demand No-10, Major Head 2425) and 2. Food &civil Supplies &Consumer Affairs (Demand No-09, Major Heads 3456, 5475)." }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred on the following:  1.Agriculture and Co-operation Department (Book-03 consisting demand number 5) 2. Food, Civil Supplies and Consumer Affairs Department (Book-07 consisting demand numbers 21, 22, 23 and 24)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred on the following Major Heads: 1. 2425 Co-operation 2. 2408 Food Storage and Ware Housing 3. 3456 Civil Supplies. For Haryana, Statement of Demand for Grants-Appropriation is presented as per Major Head. For this sector, net demand figures have been taken to maintain consistency of capital expenditure figures of Haryana and hence some of the figures have come out to be negative as recoveries were larger than expenditure estimates. " }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation Demand 21 2. Food &Civil Supplies Demand 22." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred on the following: 1. Agriculture Department (Demand 12 Major Head 2425 only) 2. Consumer Affairs &Public Distribution Department (Demand 15)." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred on the following departments: 1. Co-operative (Demand No - 9 through Major Heads 2425, 3451) and 2. Food, Public Division (Demand No 18 through Major Heads 3456, 3451, 3475, 4408)." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred on the following:  Co-operation (2425, 4425 &6425) and Food, Storage and Warehousing (2408, 4408 &6408)." }, { "name": "Kerala", "description": "This sector includes expenditure incurred on the following: 1. Co-operation (Demand XXVII, Major Heads 2425 4445 and 6425)  2. Food (Demand XXX, Major Heads 2236 2408 3456 4408 and 6408)." }, { "name": "Madhya Pradesh", "description": "This sector includes expenditure on the following: 1. Co-operation General (Demand No 17) TSP (Demand No 41), SCP (Demand No 64) 2. Food & Civil Supplies General (Demand No 39), TSP (Demand No 41), SCP (Demand No 64). All these Books are Contained in Department wise Budget Books. Book No 15 and 29" }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation, Marketing and Textiles Department (Demand No V) 2. Food, Civil Supplies and Consumer Protection Department (Demand No. M). " }, { "name": "Meghalaya", "description": "The sector includes the expenditure incurred on the following: 1. Civil Supplies (Grant No 32) and 2. Co-operation (Grant No 39)." }, { "name": "Mizoram", "description": "The sector includes expenditure incurred on the following:  1. Co-operation (Demand No 37) 2. Food, Civil Supplies &Consumer Affairs (Demand No 17)." }, { "name": "Nagaland", "description": "The sector includes the expenditure incurred on the following: 1. Co-operation (Demand No. 45) 2. Food &Civil Supplies (Demand No. 22)." }, { "name": "Odisha", "description": "The sector includes expenditure incurred on the following: 1. Co-operation Department (Demand No. 34) 2. Food Supplies (Demand No. 09)." }, { "name": "Punjab", "description": "This sector includes expenditure incurred on the following:  1. Co-operation Department (Demand No -03) and 2. Food &Consumer Protection (Demand No -09)." }, { "name": "Rajasthan", "description": "The sector records the expenditure incurred on the following: 1. Food &Storage 2. Co-operation and 3.Civil Supplies. The relevant Major Heads are 2408, 2425, 3456." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred on the following: 1. Major Heads of Co-Operation and Food, 2.  Civil Supplies &Consumer Affairs. The relevant documents for reference are under demand numbers 4 and 11." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on the following: 1. Cooperation (Demand No. 12) and 2. Food and Consumer Protection (Demand No. 13)." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation (Demand No.12) and 2. Food, Civil Supplies &Consumer Affairs (Demand No. 21), 3. Tribal Welfare (Demand No. 19, Major Heads 2425, 4059, 4425, 5465, 2059, 3456, 3475, 4408 &5475 &6425) 4. Welfare of SCs (Demand No. 20, Major Heads 2425, 4059, 4425, 2059, 3456, 3475, 4408, 5475 &5465)" }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on the following: 1. Food &Civil Supplies (Demand No. 21) 2. Agriculture &Allied Activities (Cooperation) (Demand No. 18)." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on the following: 1. Co-operation (Demand No. 18) and 2. Food (Demand No. 25). " }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on the following:  1. Co-operative Division (Demand No - 8) and 2. Food & Civil Supplies (Demand No 21)." }], "category_slug": "cooperation_food_civil_supplies" }, { "category": "Agriculture & Allied Activities", "group": [{ "name": "Andhra Pradesh", "description": "The sector captures the expenditure incurred through Agriculture Department (Demand No. XXVII (Agriculture); III/11 Volume) , Animal Husbandry, Dairy Development & Fisheries Department. Also included is Demand No.  XXVIII; III/17 Volume under various Departments/ Secretariat/ Authorities/ Directorates as follows: 1. Agriculture and Co-operation Secretariat Department 2. Agriculture HOD 3. Horticulture HOD 4. Sericulture HOD 5. Agriculture Marketing & Cooperation 6. Director of Marketing, HOD 7. RSAD, Secretariat Department 8. Animal Husbandry, Dairy Development and Fisheries, Secretariat Department, Animal Husbandry HOD and 9. Fisheries HOD." }, { "name": "Assam", "description": "The sector captures the expenditure incurred through the Departments of 1. Animal Husbandry (Grant No-52) 2. Fisheries (Grant No-54) 3.  Agriculture (Grant N0-48)   4. Dairy Development (Grant No-53) 5. Soil &Water Conservation (Grant No-51) 6. Horticulture (Grant No-67) and all related major heads (2401,2402,2403,2404,2405,2415,2435) from the following Demand for Grants - 7. All Services Heads within Karbi-Anglog Autonomous District Council (Grant No.76) 8. All Services Heads within N.C. HILLS Autonomous District Council (Grant No.77) 9. Bodoland Territorial Council (Grant No.78)." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred on the following departments: 1. Agriculture (Demand No-01 with Major Heads 2245, 2401, 2402, 2415, 2435, 3451, 3475) 2. Animal &Fisheries Resources (Demand No-02 with major heads 2403, 2404, 2405, 2415, 3451, 3454)." }, { "name": "Chhattisgarh", "description": "The sector includes the expenditure incurred on the followingdepartments: 1. Agriculture (Book-14 with Demand Numbers 13, 41, 45, 54, 64) 2. Animal Husbandry (Book-35 with Demand Numbers 14, 15, 41, 64, 67, 68, 80 and 82) 3. Fisheries (Book-36 with Demand Number 15, 16, 41, 64, 67, 80 and 82)\n" }, { "name": "Delhi", "description": "The sector captures the expenditure incurred on the following departments: 1. Agriculture Marketing (Demand no-10) 2. Agriculture Development (Development Department, Demand No-10) under the related major heads (2435, 2401, 2402, 2403, 2404, 2405,2415)\n" }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred on the following departments: 1.Agriculture and Co-operation(Book-03 and consisting of demand number 1, 2, 3, 4, 6 and 7). The total of this sector also includes Co-operation.\n" }, { "name": "Haryana", "description": "The sector captures the expenditure incurred on the following departments Agriculture and Allied Activities, through the following Major Heads: 1. 2401 Crop Husbandry 2. 2402 Soil and Water Conservation 3. 2403 Animal Husbandry 4. 2404 Dairy Development 5. 2405 Fisheries 6. 2415 Agricultural Research and Education 7. 2435 Other Agricultural Programmes 8. 4403-Capital Outlay On Animal Husbandry 9. 4405-Capital Outlay on Fisheries 10. 6401-Loans for Crop Husbandry. For Haryana, Demand for Grants is presented as per Major Head.\n" }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure made on the following:  1. Agriculture (Demand No.11) 2. Horticulture (Demand No. 12), 3. Animal Husbandry, Dairy Development &Fishery (Demand No. 14).\n" }, { "name": "Jammu &Kashmir", "description": "The sector captures expenditure incurred through the following departments: 1. Agriculture (Demand 12 excluding Major Head 2425) 2. Animal Husbandry (Demand 13) 3. Fisheries (Demand 26).\n" }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred on the following departments 1. Agriculture and Sugarcane Development (Demand No 1; Vol I Plan, Vol I Non-Plan, Central sector schemes, Schemes under Central Assistance to State Plan through Major Heads 2401, 2402, 2415, 2435, 3451, 3475) 2. Animal Husbandry (Demand No 2; Vol I Plan, Vol I Non-Plan, Central sector schemes, Schemes under central Assistance to state plan through Major Heads 2403, 3451, 3454) 3. Fishery (Demand No 53; Vol IV Plan, Vol IV Non-Plan, Schemes under central Assistance to state plan through Major Heads 2405) 4. Dairy (Demand No 54; Vol IV Plan, Vol IV Non-Plan, Schemes under Central Assistance to State Plan through Major Heads 2404).\n" }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred on the following 1. Crop Husbandry (2401 &4401), 2. Soil and Water Conservation (2402), 3. Animal Husbandry (2403 &4403), 4. Diary Development (2404 &4404), 5. Fisheries (2405 &4405), 6. Agricultural Research and Education (2415)." }, { "name": "Kerala", "description": "The sector includes expenditure incurred on the following 1. Agriculture (Demand XXIX) 2. Animal Husbandry (Demand XXXI) 3. Dairy Development (Demand XXXII)  4. Fishery (Demand XXXIII) contained in Summary of Demand for Grants and Detailed Budget Estimates.\n" }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred on the following 1. Agriculture General (Demand No 13, 54), Agriculture TSP (Demand No. 41), Agriculture SCP (Demand No - 64) 2.Animal Husbandry General (Demand No. 14), Animal Husbandry TSP (Demand No 41). Animal Husbandry SCP (Demand No 64) 3.Fisheries General (Demand No 16), Fisheries TSP (Demand No 41), Fisheries SCP (Demand No 64) 4. Horticulture General (D.NO 50), Horticulture TSP (Demand No 41), Horticulture SCP (Demand No 64). " }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred on the following: Agriculture, Animal Husbandry, Dairy Development and Fisheries Departments.  \nNote: As expenditure relating to Tribal Sub-Plan are contained in the Demand for Grants named \"T- Tribal Development Department\", hence the relevant figures under the heads of 2402, 2402, 2403, 2404, 2405, 2415, 4401, 4402, 4403, 4404, 4405, 4415, 6401, 6402, 6403, 6404, 6405, 6415 have been included from the said Department. Further, in Maharashtra, Planning Department spends a substantial sum on the heads of Agriculture. The sector also includes expenditure by this department given under heads relevant for agriculture." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred on the following: 1. Agriculture &Allied Activities (Demand No 43),  2. Fishery (Demand No 49), 3. Dairy (Demand No 48) and 4. Animal Husbandry (Demand  No 47)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred on the following: 1. Agriculture (Demand No 31) 2. Horticulture (Demand No 32)   4. Soil &Water Conservation (Demand No 33) 5. Animal Husbandry &Veterinary (Demand No 34) 6. Fisheries (Demand No 35) 7. Sericulture (Demand No 41) under the relevant Major Heads (2401, 2402, 2403, 2415, 7610)." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred on the following departments: 1. Agriculture (Demand No. 48), 2. Soil and Water Conservation (Demand No. 49), 3. Animal Husbandry and Veterinary (Demand No. 50), 4. Fisheries (Demand No. 51), 5. Horticulture (Demand No. 70)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred on the following departments: 1.Agriculture (Demand No-23) 2. Fisheries &Animal Resources (Demand No -33)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred on the following departments 1. Agriculture &Forest (Demand No 1) 2. Animal Husbandry &Fisheries (Demand No 2)." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred on the following:  1. Agriculture (Major Head 2401) 2. Soil &Water Conservation (Major Head 2402) 3.Animal Husbandry (Major Head 2403) 4.Dairy Development (Major Head 2404) 5.Fishery (Major Head 2405) 6.Agricultural Research &Education (Major Head 2415) 7.Other Agricultural Programmes (Major Head 2435). " }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred on the following departments: Agricultural Development, Animal Husbandry Livestock, Fisheries, Horticulture &Cash Crop Development. The relevant demand numbers are 1, 2 and 15." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on the following departments: 1. Agriculture Development, 2. Animal Husbandry, 3. Fisheries and 4. Dairy Development. Expenditure figures in respect of these departments can be accessed through demand number 5, 6, 7 and 8." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on the following departments: 1. Agriculture, 2. Horticulture, 3. Fisheries, 4. Animal Resources, 5. Tribal Welfare and 6. Welfare of SCs. Expenditure figures in respect of these demands can be accessed through demand numbers 19, 20, 26, 27, 28 and 29." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on the following departments: 1. Industrial and Silk Development (Demand No. 10), 2. Agriculture (Demand No. 11), 3. Animal Husbandry (Demand No. 15), 4. Fisheries (Demand No. 17), 5. Dairy Development (Demand No. 16), 6. Sugarcane and Sugar Industry (Demand No. 23). " }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on the following: 1. Farming &Research (Major Heads 2401, 2415, 4401), 2. Animal Husbandry (Major Heads 2403, 2404, 2405) and 3. Horticulture Development (Major Heads 2401, 4401). Expenditure figures in respect of these demands can be accessed through demand number 17, 28 and 29." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on the following departments: 1. Agricultural Marketing (Major Heads 2401, 2408, 2435, 3451, 6435), 2. Agriculture (Major Heads 2235, 2236, 2401, 2402, 2415, 2551, 2851, 3451), 3. Animal Resources Development (Major Heads 2049, 2235, 2401, 2403, 2404, 2415, 2515, 2551, 3451, 6003), 4.Sericulture (Major Heads 2401, 2851, 3451), 7. Fisheries (Major Heads 2049, 2235, 2401, 4401, 2405, 2415, 2515, , 8. Horticulture. Expenditure figures in respect of these demands can be accessed through demand number 4, 5, 6, 8, 11, 12, 20, 22and 66." }], "category_slug": "agriculture_allied_activities" }, { "category": "Power & Energy", "group": [{ "name": "Andhra Pradesh", "description": "In the sector the expenditure pertains to Energy Department (Vol-III/15) under Demand for Grant  of Energy , Infrastructure and Investments (Demand No: XXXV) The relevant administrations to these demands are 1. Energy and Infrastructure Secretariat 2. Chief Electrical Inspector To Government 3. Chief Engineer, Electrical Generation and 4. State Ports Directorate." }, { "name": "Assam", "description": "The sector captures the expenditure incurred by the Department of Power and Energy under the following Demands for Grants:  1. Power (Electricity, Grant No-62) 2. Scientific Services &Research (Grant no-69)." }, { "name": "Bihar", "description": "The sector captures the expenditure related to Energy Department by the following: (Demand No-10 with Major Heads 2045, 2801, 2810, 3451)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure related to Energy Department by the following demands: (Book-13 with Demand Numbers 12, 41 and 64)." }, { "name": "Delhi", "description": "The sector captures the expenditure related to Energy Department by the state as shown in the demand for Grants of Power Department (Demand No-11, Major Heads 2052, 2801, and 2810)." }, { "name": "Gujarat", "description": "The sector captures the expenditure through the Energy and Petro-chemicals Department (Book No - 5, consisting Demand Numbers 11, 12, 13 and 14)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred through the following Major Heads: 1. 2801 Power 2. 2810 New and Renewable Energy 3. 3425 Other Scientific Research 4. 6801 Loans for Power Projects. Figures for Power &Energy have been adjusted for UDAY allocations for the States which have implemented UDAY Scheme in their States, including that of Haryana. They represent spending excluding allocations for UDAY Scheme. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure related to Energy Department through Power Development Demand. No. 23." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure made by Power Development Department under Demand Number 6." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under the following: Energy Department (Demand NO 10 through Major Heads 2045, 2059, 2801, 2810, 3451)." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under the following:  1. Power (2801, 4801 &6801), 2. New and Renewable Energy (2810) 3. Energy (2045, 2801, 2810, 4801 &6801)." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under the following: Demand XXXIX - Power 2801, 2810, 4801, 4810 &6801." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure under the following books:  1. Energy (Demand No. 13), 2. New &Renewable Energy (Demand No. 43)" }, { "name": "Maharashtra", "description": "The sector captures the expenditure made by the Department of Industries, Energy and Labour (Demand No. K) Contained in Demand for Grants File. It may be noted that the figures under this grant includes expenditure on industries and hence to that extent, the sector presents an inflated picture." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred under the Power and energy sector through the following Grant no.: Administration of Electricity Rules, Power department services (Grant No 11)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Power &Electricity (Demand No 39, Major Heads 2801, 2501, 2810, 7610)." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred by the following: Power (Demand No. 55), 2. Information Technology &Communication (demand No. 81)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred under the Energy Department (Demand No -30) and Science and Technology (Demand No -27)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred through Irrigation and Power Department (Demand No. 15) includes expenditure under Major Heads of 2801, 2810, 4801 and 6801." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred on Power and Energy Sector through demands of Power and New &Renewable Energy." }, { "name": "Sikkim", "description": "The sector captures the expenditure pertaining to Power and Energy through the following demand number 31." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on Power &Energy sector accessed through demand number 14." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on Power &Energy sector (demand No. 14), 2. Tribal Welfare (D No 19) (4552, 4801), 3. Welfare of SCs (D No 20) (4552, 4801). " }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on Power &Energy sector through demand of Energy (Demand No. 9), Planning (Demand No.40, Major Head 4801 only), science and technology (Demand No 70). " }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on Power &Energy sector through demand of Energy. Expenditure figures in respect of these demands can be accessed through demand number 21, Major Heads 2801, 2810, 4801, 6801." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on Power &Energy sector through Demand for Grants of Power &Non-Conventional Energy Sources. Expenditure figures in respect of these demands can be accessed through demand number 43." }], "category_slug": "power_energy" }, { "category": "Rural Development", "group": [{ "name": "Andhra Pradesh", "description": "Rural Development Sector comprises the allocations made through the Demand for Grants 'Panchayat Raj and Rural Development' (Demand No. XXXII), contained in part-III/14 Volume of the Budget Document. The Demand for Grants include the following departments/Secretariat: 1. Panchayat Raj and Rural Development Secretariat 2. Rural Development, HOD and 3. APARD." }, { "name": "Assam", "description": "The sector captures the expenditure incurred on Rural Employment & Panchayati Raj. It records primarily the following:  1. Rural Development (Grant No-57).   In addition, the sector also captures the allocations under major head (2501) of the following Demand for Grants:   2. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council 3. All Services Heads Within N.C. HILLS Autonomous Dist. Council 4. Bodoland Territorial Council. For Panchayati Raj it incorporates: 1.Panchayat (Grant No-56).  2. Compensation &Assignment to Local Bodies and Panchayati Raj Institutions (Grant No-66). The allocations under major heads (2515) are also included for the following demand for grants: 3. All Services Heads Within Karbi-Anglong Autonomous Dist. Council   4. All Services Heads within N.C. HILLS Autonomous Dist. Council 5. Bodoland Territorial Council." }, { "name": "Bihar", "description": "The sector captures the expenditure under following Demand for Grants:  1. Rural Works (Demand No-37 with Major Heads 2515,2245, 3054, 3451) 2. Rural Development (Demand No-42 with Major Heads 2203, 2215, 2216, 2501, 2505, 2515, 3451, 3454, 4515) 3. Panchayati Raj (Demand N0-16 with Major Heads 2015, 2515, 3451)" }, { "name": "Chhattisgarh", "description": "The sector captures the works related to Rural Sector Development as well as Panchayat Raj Development as per the following Demand for Grants: 1. Panchayat and Rural Development Department (Book-22 with Demand Numbers15, 30, 41, 48, 64, 80 and 82)" }, { "name": "Delhi", "description": "The sector captures the expenditure incurred through the Demand for Grants of Development Department (Demand No-10)." }, { "name": "Gujarat", "description": "This sector captures the expenditure on Rural Development as well as Panchayat Raj Development on the following demands:  (Book-19 and Book- 9 consisting Demand Number 69, 70, 71, 72 and 73)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred through following heads:  Major Heads: 1. 2501 Special Programmes for Rural Development 2. 2505 Rural Employment 3. 2515 Other Rural Development Programmes 4. 6515-Loans for Other Rural Development Programme 5. 3604 Compensation and Assignments to Local Bodies and Panchayat Raj Institutions. Haryana presents Demand for Grants Major Head wise. " }, { "name": "Himachal Pradesh", "description": "This sector captures the expenditure related to rural sector development under the following demand: Demand No. 20" }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred by Rural Development Department under Demand No. 28 and Demand No.5." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under Rural Development &Panchayati Raj Sector under the following: 1. Rural Development (Demand No 42 through Major Heads 2053, 2501, 2505, 2515, 3054, 3451), 2.  Central Assistance to State Plan and Rural Works (Demand No 55 through Major Heads 2501, 2505, 2053, 2515, 3451), 3. Panchayati Raj and N.R.E.P.(Demand NO 56 through Major Heads 2015, 2515, 3451, 3604)" }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under the following:1. Rural Development (Demand No. 7) and 2. Planning, Statistics, Science and Technology (Demand No. 26, Major Heads 2515, 4515)." }, { "name": "Kerala", "description": "The sector captures expenditure incurred under the following: 1. Rural Development (DEMAND XXXVI, Major Heads 2501, 2505, 2515 &4515) 2. Panchayat (Demand XXXV, Major Heads 2251, 4515 &6515)." }, { "name": "Madhya Pradesh", "description": "The sector captures expenditure under Rural Development &Panchayati Raj sectors under the following: 1. General (Demand No 30, 59), 2. Rural Development TSP (Demand No 41), 3. Rural Development SCP (Demand No 64), 4. Panchayat General (Demand No 34, 62), 5. TSP (Demand No 41, 52), 6. SCP (Demand No 15, 64)." }, { "name": "Maharashtra", "description": "The sector captures the expenditure made under the Department of Rural Development and Water Conservation (Demand L) contained in Demand for Grants File. Since expenditure pertaining to Tribal Sub-Plan for this sector are not included under this department and they presented in the Demand for Grants named \"T- Tribal Development Department\". Hence the relevant figures under the heads of 2502, 2505, 2515, 4515, and 6515 are included in the sector. Further, in Maharashtra, Planning Department spends a substantial sum on the heads of Agriculture. The sector also includes expenditure by this department given under heads relevant for Rural Development." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred through 1. Rural Development Programmes (Demand no. 39) 2. Community and Rural development (Demand No. 51)." }, { "name": "Mizoram", "description": "The sector includes expenditure incurred under Rural Development Department (Demand No 38)." }, { "name": "Nagaland", "description": "The sector includes the expenditure incurred under the following: 1. Rural Development (Demand No. 42 &73), 2. Planning and Coordination (Demand No. 61), 3. Land Resources (Demand no. 72), 4. Underdeveloped Areas (Demand No. 77), 5. Planning &Coordination (Demand No. 27, Major Head 2552)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred on Rural Development Department:  (Demand No -28), Panchayati Raj Department (Demand No -17). " }, { "name": "Punjab", "description": "The sector captures the expenditure incurred through 1. Rural Development and Panchayati Raj Department (Demand No 23)." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred on Rural Development through the demands of 1.Special Programme for Rural Development   2.Rural Employment 3.Other Rural Development Programme 4.Other Special Area Programme 5. Compensation &Assignments to Local Bodies & Panchayati Raj Institutions. " }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred on the sectors of Panchayati Raj and Rural Development through major head of Rural Development and Panchayati Raj sectors. The relevant documents for reference are under demand number 35 and demand no 43." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on Rural Development &Panchayati Raj under demand number 42." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on Rural Development under the following: 1. Rural Development (Demand Number 31), 2. Tribal Welfare ((Demand No. 19) (2059, 2215, 2501, 3452, 4059, 4215, 4215, 4515 &5054), 3. Welfare of SCs (Demand No. 20) (2059, 2215, 2501, 2515, 3452, 4059, 4215, 4216, 4515 &5054), 4. Panchayati Raj (Demand No, 23), 5. Tribal Welfare (Demand No 19) (2515, 4515), 6. Welfare of SCs (Demand No 20)." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on Rural Development & Panchayati Raj under the following demands: Demand Number 13, 14 and 40 (Major Heads 2575, 4515, 4575)." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on Rural Development. Expenditure figures in respect of these demands can be accessed through Demand Number 19, Major Heads 2501, 2515, 4515." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on Rural Development through the demand of Panchayats &Rural Development. Expenditure figures in respect of these demands can be accessed through Demand Number 40 (Book 22)." }], "category_slug": "rural_development" }, { "category": "Panchayat", "group": [{ "name": "Andhra Pradesh", "description": "Rural Development Sector comprises the allocations made through the Demand for Grants 'Panchayat Raj and Rural Development' (Demand No. XXXII), contained in part-III/14 Volume of the Budget Document. The Demand for Grants include the following departments/Secretariat: 1. Panchayat Raj and Rural Development Secretariat 2. Rural Development, HOD and 3. APARD." }, { "name": "Assam", "description": "The sector captures the expenditure incurred on Rural Employment & Panchayati Raj. It records primarily the following:  1. Rural Development (Grant No-57).   In addition, the sector also captures the allocations under major head (2501) of the following Demand for Grants:   2. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council 3. All Services Heads Within N.C. HILLS Autonomous Dist. Council 4. Bodoland Territorial Council. For Panchayati Raj it incorporates: 1.Panchayat (Grant No-56).  2. Compensation &Assignment to Local Bodies and Panchayati Raj Institutions (Grant No-66). The allocations under major heads (2515) are also included for the following demand for grants: 3. All Services Heads Within Karbi-Anglong Autonomous Dist. Council   4. All Services Heads within N.C. HILLS Autonomous Dist. Council 5. Bodoland Territorial Council." }, { "name": "Bihar", "description": "The sector captures the expenditure under following Demand for Grants:  1. Rural Works (Demand No-37 with Major Heads 2515,2245, 3054, 3451) 2. Rural Development (Demand No-42 with Major Heads 2203, 2215, 2216, 2501, 2505, 2515, 3451, 3454, 4515) 3. Panchayati Raj (Demand N0-16 with Major Heads 2015, 2515, 3451)" }, { "name": "Chhattisgarh", "description": "The sector captures the works related to Rural Sector Development as well as Panchayat Raj Development as per the following Demand for Grants: 1. Panchayat and Rural Development Department (Book-22 with Demand Numbers15, 30, 41, 48, 64, 80 and 82)" }, { "name": "Delhi", "description": "The sector captures the expenditure incurred through the Demand for Grants of Development Department (Demand No-10)." }, { "name": "Gujarat", "description": "This sector captures the expenditure on Rural Development as well as Panchayat Raj Development on the following demands:  (Book-19 and Book- 9 consisting Demand Number 69, 70, 71, 72 and 73)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred through following heads:  Major Heads: 1. 2501 Special Programmes for Rural Development 2. 2505 Rural Employment 3. 2515 Other Rural Development Programmes 4. 6515-Loans for Other Rural Development Programme 5. 3604 Compensation and Assignments to Local Bodies and Panchayat Raj Institutions. Haryana presents Demand for Grants Major Head wise. " }, { "name": "Himachal Pradesh", "description": "This sector captures the expenditure related to rural sector development under the following demand: Demand No. 20" }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred by Rural Development Department under Demand No. 28 and Demand No.5." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under Rural Development &Panchayati Raj Sector under the following: 1. Rural Development (Demand No 42 through Major Heads 2053, 2501, 2505, 2515, 3054, 3451), 2.  Central Assistance to State Plan and Rural Works (Demand No 55 through Major Heads 2501, 2505, 2053, 2515, 3451), 3. Panchayati Raj and N.R.E.P.(Demand NO 56 through Major Heads 2015, 2515, 3451, 3604)" }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under the following:1. Rural Development (Demand No. 7) and 2. Planning, Statistics, Science and Technology (Demand No. 26, Major Heads 2515, 4515)." }, { "name": "Kerala", "description": "The sector captures expenditure incurred under the following: 1. Rural Development (DEMAND XXXVI, Major Heads 2501, 2505, 2515 &4515) 2. Panchayat (Demand XXXV, Major Heads 2251, 4515 &6515)." }, { "name": "Madhya Pradesh", "description": "The sector captures expenditure under Rural Development &Panchayati Raj sectors under the following: 1. General (Demand No 30, 59), 2. Rural Development TSP (Demand No 41), 3. Rural Development SCP (Demand No 64), 4. Panchayat General (Demand No 34, 62), 5. TSP (Demand No 41, 52), 6. SCP (Demand No 15, 64)." }, { "name": "Maharashtra", "description": "The sector captures the expenditure made under the Department of Rural Development and Water Conservation (Demand L) contained in Demand for Grants File. Since expenditure pertaining to Tribal Sub-Plan for this sector are not included under this department and they presented in the Demand for Grants named \"T- Tribal Development Department\". Hence the relevant figures under the heads of 2502, 2505, 2515, 4515, and 6515 are included in the sector. Further, in Maharashtra, Planning Department spends a substantial sum on the heads of Agriculture. The sector also includes expenditure by this department given under heads relevant for Rural Development." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred through 1. Rural Development Programmes (Demand no. 39) 2. Community and Rural development (Demand No. 51)." }, { "name": "Mizoram", "description": "The sector includes expenditure incurred under Rural Development Department (Demand No 38)." }, { "name": "Nagaland", "description": "The sector includes the expenditure incurred under the following: 1. Rural Development (Demand No. 42 &73), 2. Planning and Coordination (Demand No. 61), 3. Land Resources (Demand no. 72), 4. Underdeveloped Areas (Demand No. 77), 5. Planning &Coordination (Demand No. 27, Major Head 2552)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred on Rural Development Department:  (Demand No -28), Panchayati Raj Department (Demand No -17). " }, { "name": "Punjab", "description": "The sector captures the expenditure incurred through 1. Rural Development and Panchayati Raj Department (Demand No 23)." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred on Rural Development through the demands of 1.Special Programme for Rural Development   2.Rural Employment 3.Other Rural Development Programme 4.Other Special Area Programme 5. Compensation &Assignments to Local Bodies & Panchayati Raj Institutions. " }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred on the sectors of Panchayati Raj and Rural Development through major head of Rural Development and Panchayati Raj sectors. The relevant documents for reference are under demand number 35 and demand no 43." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred on Rural Development &Panchayati Raj under demand number 42." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on Rural Development under the following: 1. Rural Development (Demand Number 31), 2. Tribal Welfare ((Demand No. 19) (2059, 2215, 2501, 3452, 4059, 4215, 4215, 4515 &5054), 3. Welfare of SCs (Demand No. 20) (2059, 2215, 2501, 2515, 3452, 4059, 4215, 4216, 4515 &5054), 4. Panchayati Raj (Demand No, 23), 5. Tribal Welfare (Demand No 19) (2515, 4515), 6. Welfare of SCs (Demand No 20)." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on Rural Development & Panchayati Raj under the following demands: Demand Number 13, 14 and 40 (Major Heads 2575, 4515, 4575)." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on Rural Development. Expenditure figures in respect of these demands can be accessed through Demand Number 19, Major Heads 2501, 2515, 4515." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on Rural Development through the demand of Panchayats &Rural Development. Expenditure figures in respect of these demands can be accessed through Demand Number 40 (Book 22)." }], "category_slug": "panchayat" }, { "category": "Education", "group": [{ "name": "Andhra Pradesh", "description": "Education sector includes expenditure by Education Department (III/7 Volume). It is composed of the following Demand for Grants: School Education (XII), Higher Education (XIII), Technical Education (XIV). The sector also captures the expenditure by Youth Advancement, Tourism & Culture Department under two Demands (III/2 volume): Sports and Youth Services (XV) & Tourism, Art and Culture (XXXVII). It may be noted here that Expenditure on Tourism have not been included. The allocations are presented under following Department/ Direcorates 1. Intermediate Education Department 2. Secondary Education Secretariat 3. School Education Department 4. Government Examinations Department 5. Registrar of Publications 6. Adult Education Department 7. Public Libraries Department 8. Jawahar Bal Bhavan 9. Government Textbook Press 10. Higher Education Secretariat 11. Collegiate Education Department 12. State Archieves 13. Oriental Manuscripts Department 14. Skill Development, Entrepreneurship and Innovation Secretariat 15.Technical Education Department 16.Youth Advancement, Tourism and Culture, Secretariat Dept 17. Youth Services, Yuva Sakthi 18. Directorate of NCC 19. SAAP, LB Stadium 18. Youth Advancement, Tourism and Culture, Secretariat Dept. 19. Cultural affairs and 20. Archeology and Museums." }, { "name": "Assam", "description": "The sector captures the expenditure incurred by the School Education Department, Higher &University Education Department, Technical Education Department, Adult Education &Language Development, and the Departments of Youth Welfare and Arts &Culture. It includes allocations/expenditure under the following heads and Demand for Grants NOs:  Higher Education) (Grant No-26)   2. Arts &Culture (Grant No-27) 3. Education (Elementary &Secondary Education) (GrantNo-71) 4. Sports &Youth Services (Grant No-74).  It also incorporates the relevant Major Head (2202, 2203, 2204 and 2205) from the following demand for grants- 5.  All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council (Grant No 76) 6. All Services Heads Within N.C. HILLS Autonomous Dist. Council (Grant No.77) 7. Bodoland Territorial Council (Grant No.78)." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred through the Demands for Grants numbers 1. Education (Demand No-21 with Major Heads 2202, 2204, 2205, 2251, 4202) 2. Science and Technology (Demand No-43 through Major Heads of 2203, 3451, 4202) 3. Art, Culture and Youth (Demand No. 8 through Major Heads 2204, 2205, 2251, 6202)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred under the following Demand for Grants: 1. School education (Book-20 with Demand Numbers 15, 33, 41, 49, 64, 66, 67, 68, 80, 81and 82) 2. Higher Education (Book-38 with Demand Numbers 41, 44, 64, 67 and 68) 3. Capacity Building, Technical Education & Employment Department (Book-42 with Demand Numbers 41, 46, 47, 64, 67 and 68)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred by the Demand Number 6, which contains the expenditure incurred by Delhi Government on Education &related activities." }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred by the following departments: 1. Education Department (Book-4 consisting Demands Numbers 8, 9 and 10) 2. Sports, Youth and Cultural Activities Department (Book-25 consisting Demand numbers 97, 98 and 99)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred under the following Major Heads: 1. 2202 General Education, 2. 2203 Technical Education 3. 2204 Sports and Youth Services 4. 2205 Art and Culture 5. 4202-Capital Outlay on Education, Sports, Art and Culture. For Haryana, Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred under the Demand for Grants of Education (Demand No.8)." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred made by two departments: 1. Education Department (Demand-7) and 2. Higher Education Department (Demand-27)." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under 1.Higher Education (Demand No 21 through Demand No 2202) Vol II of Plan and Non Plan Vol II, Central Assistance to State Plan 2.Primary &Public Education (Demand No 59 through Major Heads 2202, 4202) Vol IV of Plan and Non Plan Vol IV, Central Assistance to State Plan. 3.Secondary Education (Demand No 58 through Major Heads 2202, 4202) Vol IV of Plan and Non Plan Vol IV, Central Assistance to State Plan and Central Sector Scheme 4.Science &Technology (Demand No 43 through Major Heads 2203, 3451, 4202) Vol IV of Plan and Non Plan Vol IV, Central Sector Scheme. 5. Sports, Art, Culture and Youth Affairs Department (Demand No 52 through Major Heads 2204, 2205, 2251, 4202) Vol IV of Plan and Non Plan Vol IV." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under Education (2058, 2202, 2203, 2204, 2205, 2852, 4202), Kannada Culture (2205, 4202) &Information, Tourism &Youth Services (only 2204, 4202)." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XVII - Education Sports Art &Culture 2202, 2203, 2204, 2205, 3425, 3435, 4202, 5425 &6202." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred under following books 1. Sports and Youth Welfare General (Demand No 43),Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-Plan (Demand No. 64) 2 School Education General (Demand No 27, 77, 40, ), Tribal Sub-Plan (Demand No. 41), Scheduled Castes Sub-Plan (Demand No. 64) 3.Culture General (Demand No 26), Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-Plan (Demand No. 64) 4.Higher Education General (Demand No 44), Tribal Sub-Plan (Demand No 41), S Scheduled Castes Sub-Plan (Demand No. 64). All these Books are Contained in department wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred under the Education Sector has been compiled from School Education and Sports Department (Demand E), Higher &Technical Education (Demand W), Tourism &Cultural Affairs (Demand ZD) and Marathi Language (Demand ZF)." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred under the General Education Programmes (Grant No 21)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Director, School Education (Demand No 20), Director, Higher and Technical Education (Demand No 21), Sports and Youth Services (Demand No 22), and Art and Culture (Demand No 23) contained in Demand for Grants File." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred on the following: 1.School Education (Demand No.1), 2. Higher Education (Demand No. 32), 3. Youth Resources and Sports (Demand No. 33), 4. Art, Culture &Gazetteers (Demand No. 34), 5. State council of Educational Research and Training (Demand No. 65)" }, { "name": "Odisha", "description": "The sector captures the expenditure incurred under the following departments 1. Higher Education (Demand No -38) 2. Skill Development &Technical Education (Demand No -39) 3. School &Mass Education (Demand No -10)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred under the following: 1. Education (Demand No 05) 2. Technical Education (Demand No. 27) and 3. Tourism and Cultural Affairs (Demand No. 28) from which only 2205, 4202 are included contained in Plan Vol I and Non Plan Vol II." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred through Education Sector under major heads of General Education, Technical Education, Sports &Youth Services, Arts & Culture. The relevant expenditure data can be accessed through documents named Revenue Expenditure-Economic Services Vol 2c through Major Heads 2202, 2203, 2204, and 2205." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred through Human Resource Development. The relevant expenditure data can be accessed through Demand No. 7." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred through Education Sector. Expenditure figures in respect of these demands can be accessed through Demand No. 20 and 43." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred through the following: 1. Elementary and Secondary Education (40) 2. Tribal Welfare (Demand No. 19) (2059, 2202, 2236, 4202, 2235, 2236, 4059, 2204, 4552, 4235 &4236) 3. Welfare of SCs (Demand No. 20) (2059, 2202, 2235, 2236, 2235, 4059, 4235, 2204, 4202, 4236, 4552) 4. Elementary and Secondary Education (41) 5. Elementary and Secondary Education (42) 6. Elementary Education (Demand No. 62)." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred through the Departments of Elementary Education, Secondary Education, University and Higher, SCERT and Technical Education under demand for Grants Nos 71, 72, 73, 75 and 47." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred through the Elementary Education, Secondary Education, University and Higher Education and Technical Education. Expenditure figures have been compiled from Demand No. 11." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred through the Higher Education, Mass Education Extn. & Library Services, School Education and Technical Education &Training. Expenditure figures in respect of these demands can be accessed through demand number 13, 14, 15, 30, 49 and 51." }], "category_slug": "education" }, { "category": "Forests & Environment", "group": [{ "name": "Andhra Pradesh", "description": "Forest and Environment Sector comprises of spending made on Environment, Forests, Science & Technology Department((Vol-III/15) (Demand No. XXIX). The relative administrations to these demands are 1. Environment, Forest, Science & Technology Secretariat and 2. Principal Chief Conservator of Forests." }, { "name": "Assam", "description": "The sector captures the expenditure incurred by the Department of Forests and Wild Life and the Department of Environment under the following Grants:on forest and environment - 1. Forestry &Wildlife (Grant No-55). The major head taken account is (4406) from the following demand for grants- 2. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council.  3. All Services Heads Within N.C. HILLS Autonomous Dist. Council. 4. Bodoland Territorial Council." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred under the following Demand for Grants of Environment &Forest Department (Demand No-19 with Major Heads 2406, 3451, 4406)" }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred on forest and environment related works, the Demand of Forest Department (Book-10 with Demand Numbers 10, 41, 48 and 64) reflects the expenditure under the sector." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred on forest and environment related works, the following Demand NOs shows the details: 1. Forest Department (Demand No-10) 2. Environment Department (Demand No-10)" }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred on forest and environment related works under the Demand for Grants of Forests and Environment Department (Book-8 consisting of 25, 26, 27 and 28 demand numbers)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred on forest and environment related works, under the following Major Heads: 1. 2406&4406 Forestry and Wild Life 2. 3435 Ecology and Environment. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred on forest and environment related works through the Demand for Grants of Forest and Wild Life Department (Demand. No. 16.)." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure made by Forest Department under Demand Number 21 and minor head 313 from Ladakh Affairs Department (Demand 5)." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred on Forest and Environment Department (Demand Number 19 through Major Heads 2406, 3451, 4406) contained in Plan Vol II, Non Plan Vol II, Central Assistance to State Plan and Central Sector Schemes." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under Ecology and Environment (2406, 3435 &4406) contained in Volume III of Demand for Grants." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XXXIV - Forest 2406, 4406 &6406 contained in Summary of Demand for Grants and Detailed\nBudget Estimates." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure from following books - Forests General (Demand No 10), TSP (D.No 41), SCP (D.NO 64). All these Books are contained in department wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred by the State through Environment Department (Demand U) and Revenue and Forest Department (Demand C) contained in Demand for Grants. It also captures the expenditure made by the Department of Planning and the Department of Tribal Development under heads of 2406, 4406." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred on the demand for grants under Forests &Environment (Grant No 50) head." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Forest &Environment (Demand NO 36) contained in Demand for Grants File." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred through the following: 1. Forest, Ecology, Environment &Wildlife (Demand No.52) , 2. Science and Technology (Demand No. 63)." }, { "name": "Odisha", "description": "The sector captures the expenditure from department of Forest &Environment (Demand No- 22) and 2. Revenue &Disaster Management (Demand NO -3) contained in the folder of Plan demand for Grants and Non Plan Demand for Grants." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred under the head 2406, 4406 and 3425 from the Demand for Grants: 1. Agriculture and Forest (Demand No 01)  and  2. Environment (Demand No 24) contained in Plan Vol I and Non Plan Vol II." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred by the State on Forest and Environment related works under the heads of Forest, Other Scientific Research and Ecology &Environment. The relevant expenditure data have been compiled from the documents of Revenue Expenditure-Economic Services Vol 2d and Capital Expenditure Vol 3a respectively. The relevant major heads are: 2406, 4406, 3425." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred through the major heads of Forest Environment &Wildlife Management. The relevant document for reference can be accessed under demand number 12." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred through the major heads of Environment Forest and Relief on account of Natural calamities. Expenditure figures in respect of these demands can be accessed through demand number 15, 51 and 54." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred through the Forest and Environment sector for Relief &Rehabilitation and Forest. Expenditure figures are compiled from Demand for Grants Numbers 22 and 30." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred by the State on Forest and Environment sector through major heads of Environment and Relief on account of Natural calamities. Expenditure figures in respect of these demands can be accessed through demand number 45 and 51." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred by the State on Forest and Environment sector under Demand for Grants Number. 27." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred through the major heads of Environment, Forest and Disaster Management. Expenditure figures in respect of these demands can be accessed through Demand for Grants Numbers 16, 23 and 47." }], "category_slug": "forests_environment" }, { "category": "Irrigation & Water Resources", "group": [{ "name": "Andhra Pradesh", "description": "The sector registers the public spending on Irrigation related works  under the department of Water Resources Department (  Vol-III/13) under the Demands  for Grants of 1. Major and Medium Irrigation ( XXXIII). 2. Minor Irrigation (XXXIV) with respect to various departments/Authorities as under: 1. Water Resources Secretariat 2. Command Area Development Authority 3. Water Resources (Administration) 4. Major Irrigation, Flood Control and Drainage 5. N.T.R Telugu Ganga Project 6. Tungabhadra Board 7. Central Design Organisation 8. Inter State Water Resources 9. Commissionerate of Tenders 10. Irrigation Projects, Kadapa 11. Hydrology Department 12. Krishna Basin, Commissioner 13. Irrigation Projects, North Coastal Districts 14. Irrigation Projects, Ongole 15. Irrigation Projects, Anantapur16. Polavaram Project 17. Project Preparation and Monitoring Unit (PPMU), Andhra Pradesh Water Sector Improvement Project (APWSIP) 18. Irrigation Projects, Kurnool 19. Resettlement and Rehabilitation Commissionerate 20. Quality Control Wing for Andhra Region 21. Quality Control Wing for Rayalaseema Region 22. Godavari Delta System, Dowlaiswaram 23. Krishna Delta System, Vijayawada 24. Command Area Development Authority 25. Ground Water Department and 26. Minor Irrigation Department." }, { "name": "Assam", "description": "The sector captures the expenditure incurred through the department of Irrigation and Department of water resources under the following Heads / Demand for Grants NOs: 1. Irrigation (Grant No-49) 2. Water Resources (Grant No-63). The major demands include are (2701,2702,2705,2711)  3. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council (Grant No. 76)   4. All Services Heads Within N.C. HILLS Autonomous Dist. Council (Grant No.77)  5. Bodoland Territorial Council. (Grant no. 78)." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred through the following Demand for Grants: 1.Water Resources (Demand No-49 with Major Heads 2700, 2701, 2705, 2711, 3451, 4700, 4701, 4711, 6701).  2. Minor Water Resource (Demand No-50 with Major Heads 2702, 3451, 4702)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred under the departments of Water Resources (Book-31with Demand Numbers 23, 40, 41, 45, 57, 64 and 75)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred on water resources major or minor. The Demand for Grants of Irrigation &Flood Control Department (Demand No-10) show the details of expenditure." }, { "name": "Gujarat", "description": "The sector captures the expenditure related to irrigation, which is contained in Narmada, Water Resources, Water Supply and Kalpsar Department (Book No-18.1 &18.2 consisting Demand Numbers 64, 65, 66, 67 and 68)" }, { "name": "Haryana", "description": "The sector captures the expenditure related to irrigation &water resources under the following Major Heads: 1. 2700 Major Irrigation 2. 2701 Medium Irrigation 3. 2702 Minor Irrigation 4. 2705 Command Area Development 5. 2711 Flood Control and Drainage 6. 4700-Capital Outlay on Major Irrigation 7. 4701-Capital Outlay on Medium Irrigation 8. 4711-Capital Outlay on Flood Control Projects. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure related with irrigation, which is contained in the demand named Irrigation, Water Supply &Sanitation (Demand No. 13)." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred by Irrigation &Flood Control Department under Demand Number 22." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred through Water Resources Department (Demand No-49 through Major Heads 2700, 2701, 2705, 2711, 3451 4700, 4701, 4711and Water Resources - Minor Irrigation (Demand No 50 through Major Heads 2702, 4702)." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under 1. Major Irrigation (2700, 4700 &6700), 2. Medium Irrigation (2701, 4701 &6701), 3. Minor Irrigation (2702, 4702 &6702), 4. Command Area Development (2705, 4705 &6705), 5. Flood Control and Drainage System (2711, 4711 &6711)." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XXXVIII - Irrigation under Major Heads 2700, 2701, 2711, 4700, 4701, 4711, 6700 &6701." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred through the following books- 1.Narmada Valley Project General (Demand No 48) TSP (Demand No 41), SCP (D.NO 64) 2. Water Resources General (Demand No 23,40,45,57), TSP (Demand No 41), SCP (Demand No 64). All these Books are Contained in Department wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred by the State under Department of Water Resources (Demand No. I) contained in Demand for Grants documents (White Book). The sector also includes expenditure through the Department of Planning and the Department of Tribal Development under the following heads: 2701, 2702, 2705, 2711, 4701, 4702, 4705, 4711, 6701, 6702 and 6711." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred under the following Demand for Grants:- 1. Soil and Water Conservation (Grant No 45) and  2. Irrigation Schemes (Grant No 44)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Minor Irrigation Department (Demand NO 47) contained in Demand for Grants File." }, { "name": "Nagaland", "description": "The sector captures the expenditure under the following department.: Irrigation (Demand No. 59)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred under the following Departments 1. Water Resources (Demand No -20) and the major head 4711 from General Administration (Demand No -09)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred through the Power and Irrigation Department (Demand No 15) from which only expenditure of Major heads 2700, 2701, 2702, 4700, 4701, 4702 are included and Minor Irrigation (2702) from Agriculture Department (D.NO 1) are included." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred by the demands of Major Irrigation, Medium Irrigation, Irrigation, Area Development and Capital Outlay on Flood Control Projects. The relevant expenditure data can be accessed through documents named Revenue Expenditure-Economic Services Vol 2d and Capital Expenditure Vol 3a respectively." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred through the major heads of Water Resources &River Development department. The relevant documents for reference are under Demand Number 19." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred through the departments of Irrigation. Expenditure figures in respect of these demands can be accessed through demand number 40." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred on Irrigation &Water Resources through the following: 1. Public Works (WR) (15) (MH 2701, 2702, 2711, 4701, 4702, 4711), 2. Tribal Welfare (D No 19) (2701, 2702, 2711, 4701, 4702 &4711), 3. Welfare for SC (D No 20) (2701, 2702, 2711, 4701, 4702 &4711)." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred on Irrigation and water resources related works under the department of Major Irrigation and Medium Irrigation. Expenditure figures in respect of these demands can be accessed through Demand Number 94 and 95." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred on Irrigation and water resources related works under the department of Irrigation and Flood. Expenditure figures in respect of these demands can be accessed through Demand Number 20, Major Heads 2700, 2701, 2702, 2711." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred on Irrigation and Water Resources related works under the department of Water Resources Investigation. Development expenditure figures in respect of these demands can be accessed through demand numbers 32 and 55." }], "category_slug": "irrigation_water_resources" }, { "category": "Health", "group": [{ "name": "Andhra Pradesh", "description": "The sector records the expenditure by Health, Medical & Family Welfare Department (contained in volume III/8) of the Budget Documents under the Demand for Grants: 1. Medical & Public Health (Demand No. XVI). The relative administrations to these demands are 1. Health, Medical & Family Welfare Secretariat 2. Medical Education Department 3. Public Health and Family Welfare Department 4. Family Welfare Department 5. Institute of Preventive Medicine 6. Ayurveda, Yoga, Unani, Siddha & Homoepathy (AYUSH) Department and 7. Drugs Control Administration." }, { "name": "Assam", "description": "The sector captures the expenditure incurred under the following grants:  1. Medical &Public Health (Grant No-29). The major head taken account is (2210, 2211) from the following demand for grants- 2. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council.  3. All Services Heads Within N.C. HILLS Autonomous District Council.  4. Bodoland Territorial Council." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred on health and related works through the Demand for Grants of Health &family Welfare (Demand No-20 with Major Heads 2210, 2211, 2235, 2251, 4210)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure incurred under the following Demand for Grants: 1. Public Health &Family Welfare (Book-17 with Demand Numbers 19, 41, 48, 64, 67 and 68) 2. Medical Education (Book-51 with Demand Number 41, 64, 67, 68 and 79)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred under the Demand for Grants Number 07." }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred on the Health and Family Welfare Department (Book-11 consisting Demand Numbers 38, 39, 40 and 41)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred under the following Major Heads: 1. 2210 Medical and Public Health 2. 2211 Family Welfare 3. 4210-Capital Outlay on Medical and Public Health. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred on Health and Family Welfare related works through the demand of Health and Family Welfare Demand Number 9." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred by the Health &Medical Education Department under Demand Number 17." }, { "name": "Jharkhand", "description": "The sector captures the expenditure incurred under the Health, Medical Education &Family Welfare Department (Demand Number 20 through Major Heads 2210, 2211, 2251, 4210) obtained from Plan Volume II, Non Plan II, Central Assistance to State Plan and Central Sector Schemes." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under Health (2210, 2211, 3435, 4210 &5425) contained in Vol II of Demand for Grants." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XVIII - Medical and Public Health 2210, 4210 &6210 contained in Summary of Demands for Grants and Detailed Budget Estimates." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure incurred by 1.Public Health and Family Welfare General (Demand No 19), Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-Plan (Demand No 64)    2. Medical Health Education General (Demand No 73), Tribal Sub-Plan (D.No 41), SCP (Demand No 64) 3. Ayush General (Demand No 38), Scheduled Castes Sub-Plan (Demand No 53, 64). All these Books are Contained in department wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred under the Public Health Department (Demand R) and Medical Education and Drugs Department (Demand S). As a substantial amount is also spent through departments of Planning, Tribal Development and Public Works Department for health services and related construction services. The relevant heads under which expenditure from these departments have been included are: 2210. 4210, 6210." }, { "name": "Meghalaya", "description": "The sector captures the expenditure incurred by the Health & Family Welfare (Grant No 26)." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under the Medical &Public Health Services (Demand No 24)." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred through Health and Family Welfare Department (Demand No. 35)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred by the Health &Family Welfare Department (Demand No.12)." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred under the Health &Family Welfare (Demand No. 11) contained in Plan Vol I and Non Plan Vol I." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred under the following Demand for Grants: Medical &Public Health and Welfare. The relevant expenditure data can be accessed through documents naming Revenue Expenditure-Economic Services Vol 2c and Capital Expenditure Vol3a." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred through the major head of Health Care, Human Services &Family Welfare. The relevant expenditure data can be accessed through demand number 13." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred by the Demand for Grants number 19." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred through Health Sector under major heads of Health, Tribal Welfare, Welfare of SCS and Family Welfare &Preventive Medicine. Expenditure figures in respect of these demands can be accessed through demand number 16, 19, 20 and 52." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred through the major head of Health, Education and Training, Allopathy, Ayurveda & Unani, Homeopathy, Family Welfare and Public Health. Expenditure figures in respect of these demands can be accessed through demand number 31, 32, 33, 34, 35 and 36." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred under the Demand for Grants of Health and Family Welfare (demand number 12.)" }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred under the demand for grants of Health &Family Welfare (demand number 24.)" }], "category_slug": "health" }, { "category": "Social Welfare", "group": [{ "name": "Andhra Pradesh", "description": "This sector records the expenditure made by Social Welfare Department, Backward Classes Welfare Department & Minority Department Department for Women, Children, Disabled & Senior Citizens through the Demand for Grants: 1. Social Welfare (XXI) Vol-III/12  2. Tribal Welfare (XXII) Vol-III/12 3. Backward Classes Welfare (XXIII) Vol-III/12 4. Minority Welfare (XXIV) Vol-III/12 5. Women, Child and  Disabled Welfare (XXV)  III/10 Volume 6. Revenue Department (III/4 Volume) Revenue, Registration and Relief (V) , expenditure pertaining to Relief on account of natural calamities (MH 2245). The relative administrations to these demands are 1. Social Welfare Secretariat 2. Social Welfare Department 3. Social Welfare Residential Educational Institutions Society 4. Tribal Welfare Department 5. Tribal Welfare Engineering Department 6. Tribal Welfare Residential 7. Educational Institutions Society 8. Backward Classes Welfare Secretariat 9. Backward Classes Welfare Department 10. Minorities Welfare Secretariat 11. Minorities Commission 12. Minorities Welfare Department 13.Women, Children, Disabled and Senior Citizens Secretariat 14. Women Development & Child Welfare Department 15. Persons with Differently Abled and Senior Citizens Welfare Department and 15. Juvenile Welfare Department." }, { "name": "Assam", "description": "The sector captures the expenditure incurred by the Departments of Social Justice, Department of Social Welfare and Security, department of Welfare of Minorities Backward Classes, Department of Tribal Welfare, Department of Women &Child Welfare, and the Department of Nutrition. The allocations have been compiled for the following heads and Demand for Grants numbers: 1. Welfare of SC/ST &OBC (Grant N0-38)   2. Social Security, Welfare and Nutrition (Grant No-39) 3. Social Security &Welfare (Freedom Fighter) (Grant No-40 4. Social Security &Welfare (Grant No-72)   5. Natural Calamities (Grant No-41).  The major heads taken into account are (2225, 2235, 2236, 2245, 2250) from following Demand for Grants 6. All Services Heads Within KARBI-ANGLONG Autonomous Dist. Council   7. All Services Heads Within N.C. HILLS Autonomous Dist. Council   8. Bodoland Territorial Council." }, { "name": "Bihar", "description": "The sector captures the expenditure incurred by state on social work, the following demand for grants present the details: 1. Backward Class and Most Backward Class Welfare (Demand No-11 with Major Heads 2225, 2251, 4225) 2. Minorities Welfare (Demand No-30 with Major Heads 2053, 2202, 2225, 2250, 2251, 4225, 4250, 5465, 7465 ) 3. SC &ST Welfare (Demand No-44 with Major Heads 2070, 2225, 2251, 4425) 4. Social Welfare (Demand No-51 with Major Heads 2210, 2235, 2251, 4235)." }, { "name": "Chhattisgarh", "description": "The sector captures the expenditure related to the social welfare by the state in the following demand for grants: 1. Tribal, Scheduled Caste &Backward Classes (Book-25 with Demand Numbers 15, 33, 41, 49, 64, 66, 68 and 82) 2. Social welfare (Book-26 with Demand Numbers 15, 34, 41, 53, 64, 67, 80, 81, 82 and 83) 3. Women and Child Welfare (Book-39 with Demand Numbers 15, 41, 48, 55, 64, 80 and 82)." }, { "name": "Delhi", "description": "The sector captures the expenditure incurred by the state in the following demand for grants: 1. Directorate of women &child Dev. (Demand No-8)  2. Department Welfare of SC/ST &Backward Classes and Social Welfare (Demand No-8) 3. Social Welfare (Demand No-8)  4. Office of the Commissioner (Disabilities) (Demand No-8)." }, { "name": "Gujarat", "description": "The sector captures the expenditure incurred through the following Demand for Grants: 1. Social Justice And Empowerment Department (Book-24.1 &24.2 consisting Demand Numbers 91, 92, 94, 95)  2. Tribal Development Department (Book-24.3 &24.4 consisting Demand Numbers 93 and 96) 3. Women and Child Development Department (Book-27 consisting demand numbers 105 and 106) 4.Revenue Department (Book-21), expenditure pertaining to Relief on account of natural calamities (MH 2245)." }, { "name": "Haryana", "description": "The sector captures the expenditure incurred by the Haryana state government by the department of social welfare, details of which can be found in the following Major Heads: 1. 2225 Welfare of Scheduled Castes, Scheduled Tribes and Other Backward Classes 2. 2235 Social Security and Welfare 3. 2236 Social Security and Welfare 4. 2250 Other Social Services 5. 4225-Capital Outlay on Welfare of SCs, STs, Other BCs. and Minorities 6. 4235-Capital Outlay on Social Security and Welfare 7. 4250-Capital Outlay on Other Social Services. For Haryana, Statement of Demand for Grants is presented as per Major Head." }, { "name": "Himachal Pradesh", "description": "The sector captures the expenditure incurred by the state in the following demand for grants: 1. Social Justice and Empowerment Demand No. 19; 2. Tribal Development Demand No. 31;  3. Scheduled Castes Sub-Plan Demand No. 32." }, { "name": "Jammu &Kashmir", "description": "The sector captures the expenditure incurred by Social Welfare Department under Demand -18." }, { "name": "Jharkhand", "description": "The Sector captures the expenditure incurred under Women, Child Development &Social Security Division (Demand No 60 through Major Heads 2235, 2236, 2251, 4235) contained in Vol IV of Plan and Non Plan and Central Assistance to State Plan and Central Sector Scheme. 2. Welfare Department (Demand No 51 through Major Heads 2225, 2251, 2235, 4225) contained in Plan Non Plan Vol IV and Central Assistance to State Plan and Central Sector Scheme. 3. Minorities Welfare (Demand No 30 through Major Heads 2250, 2251, 4225) Contained in Plan Non Plan Vol II and Central Assistance to State Plan and Central Sector Scheme." }, { "name": "Karnataka", "description": "The sector captures the expenditure incurred under Women and Child Development and Welfare of Scheduled Castes, Scheduled Tribes and Other Backward Classes and Other Social Services (2225, 2235, 2250, 4225, 4235, 4250) Contained Vol V of Demand for Grants." }, { "name": "Kerala", "description": "The sector captures the expenditure incurred under Demand XXVI - Relief on Account of Natural Calamities (2245 &6245), Demand XXV - Welfare of Scheduled Castes/ Scheduled Tribes / Other Backward Classes and Minorities (2225 4225 & 6225),  Demand XLVI - Social Security and Welfare (2235 4235 & 6235) contained in SUMMARY OF DEMANDS FOR GRANTS AND DETAILED BUDGET ESTIMATES." }, { "name": "Madhya Pradesh", "description": "The sector captures the expenditure by 1. Tribal Welfare General (Demand No 33), Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-plan (Demand No. 64) 2. Scheduled Caste Welfare General (Demand No 49, 41, 42), Tribal Sub-Plan (Demand No 68)  3. Social Welfare General (Demand No 34),  Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-Plan (Demand No 64) 4. Rehabilitation General (Demand No 35) 5. Minority Development (Demand No 63) 6.Vimukta Evam GumakkaJait General (Demand No 69) 7.Backward Class Welfare (Demand No 66) 8.Bhopal Gas Tragedy Relief Rehabilitation General (Demand No 72)  9. Women and Child Development General (Demand No 55), Tribal Sub-Plan (Demand No 41), Scheduled Castes Sub-Plan (Demand No 64). All these Books are Contained in Department wise Budget Books." }, { "name": "Maharashtra", "description": "The sector captures the expenditure incurred by the State on welfare of the people through Demand for Grants NOs: 1. Women and child Development department (Demand X) 2. Social Justice, Cultural Affairs and Special Assistance (Demand N), 3. Tribal Development (Demand T), 4. Social Justice, Cultural Affairs and Special Assistance (Demand N) 5. Minorities Development (Demand ZE) contained in Demand for Grants File. The sector includes expenditure through the Department of Planning under heads of 2225, 2235, 2236, 4225, 4235, 4236, 6225, 6235 and 6236." }, { "name": "Meghalaya", "description": "The sector captures the expenditure made under various relevant heads mentioned below: 1. Displaced Persons (Grant No 33); 2. Welfare of SC, ST and OBC and Social Welfare (Grant No 34); 3. Soldiers, Sailors and Airmen Board (Grant No 35) and 4.  Other Social Services (Grant No 36) provided in the Detailed Grant for Grants of the Budget Document." }, { "name": "Mizoram", "description": "The sector captures the expenditure incurred under Social Welfare (Demand Number 29), Disaster Management &Rehabilitation (Demand Number 30) contained in Demand for Grants File." }, { "name": "Nagaland", "description": "The sector captures the expenditure incurred through the following: 1. Home Department (Relief and Rehabilitation Demand No.20), 2. Home Department (Relief of Distress caused by Natural Calamities Demand No. 21), 3. Social Security and Welfare (Demand No. 43), 4. Women, Child and Social Welfare Department (Demand No. 76)." }, { "name": "Odisha", "description": "The sector captures the expenditure incurred by 1. Women &Child Development Department (Demand No -36), 2. Scheduled Tribes &Scheduled Caste (Demand No -11) contained in the folder of Plan demand for Grants and Non-Plan Demand for Grants." }, { "name": "Punjab", "description": "The sector captures the expenditure incurred under Social Security &Women Welfare and Welfare of Schedule Caste &Backward Classes Department (Demand Number 25) contained in Plan Vol I and Non Plan Vol II." }, { "name": "Rajasthan", "description": "The sector captures the expenditure incurred on Social welfare activities, this Sector includes department of Social Welfare of SC, ST, OBC & Minorities, Social Security &Welfare, Nutrition and Other Social Services. The relevant expenditure data can be accessed through documents naming Revenue Expenditure-Economic Services Vol 2c and Capital Expenditure Vol 3a respectively." }, { "name": "Sikkim", "description": "The sector captures the expenditure incurred through the major head of Social Justice Empowerment &Welfare.  The relevant document for reference can be accessed under demand number 38." }, { "name": "Tamil Nadu", "description": "The sector captures the expenditure incurred through the major head of Social Welfare &Nutritious Meal Programme, Adi-Dravidar & Tribal Welfare, Backward Classes, Most Backward Classes &Minorities Welfare and Welfare of Differently Abled Persons. Expenditure figures in respect of these demands can be accessed through demand number 4, 9, 45 and 52." }, { "name": "Tripura", "description": "The sector captures the expenditure incurred through the major head of Women, Children &Persons with Disabilities, Tribal Welfare, OBC Welfare, Minority Development and Welfare of SCs. Expenditure figures in respect of these demands can be accessed through demand number 19, 20, 41, 57 and 61." }, { "name": "Uttar Pradesh", "description": "The sector captures the expenditure incurred through the major head of Women and Child Development, Social Welfare Department (Social Welfare and Welfare of Scheduled Castes), Social Welfare Department (Tribal Welfare), Minorities Welfare and Social Welfare (Disabled and Backward Class welfare) and Special Component Plan for Scheduled Caste. Expenditure figures in respect of these demands can be accessed through demand number 48, 49, 79, 80 and 81 and 83." }, { "name": "Uttarakhand", "description": "The sector captures the expenditure incurred through the major head of Women and Child Development, Welfare of SCs, STs and OBCs, Scheduled Castes and Tribal Welfare. Expenditure figures in respect of these demands can be accessed through demand number 15, 30 and 31." }, { "name": "West Bengal", "description": "The sector captures the expenditure incurred through the major head of Women Development &Social Welfare, Child Development, Tribal Development and Minority Affairs &Madrasah Education. Expenditure figures in respect of these demands can be accessed through demand number 7, 38, 56, 64 and 65." }], "category_slug": "social_welfare" }];

/***/ },
/* 377 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var expenditure_data = exports.expenditure_data = [{ "category_slug": "agriculture_allied_activities", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "3576" }, { "2014-15": "" }, { "2015-16": "4721" }], "BE": [{ "2014-15": "8438" }, { "2015-16": "8401" }, { "2016-17": "8047" }, { "2017-18": "8611" }], "RE": [{ "2014-15": "8477" }, { "2015-16": "7298" }, { "2016-17": "8048" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "1213" }, { "2014-15": "1430" }, { "2015-16": "1083" }], "BE": [{ "2014-15": "2198" }, { "2015-16": "3832" }, { "2016-17": "2319" }, { "2017-18": "2585" }], "RE": [{ "2014-15": "2308" }, { "2015-16": "2903" }, { "2016-17": "2423" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "2248" }, { "2014-15": "2346" }, { "2015-16": "2045" }], "BE": [{ "2014-15": "3358" }, { "2015-16": "3363" }, { "2016-17": "3262" }, { "2017-18": "3226" }], "RE": [{ "2014-15": "4176" }, { "2015-16": "3471" }, { "2016-17": "3301" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1340" }, { "2014-15": "4042" }, { "2015-16": "1611" }], "BE": [{ "2014-15": "4604" }, { "2015-16": "2183" }, { "2016-17": "2774" }, { "2017-18": "2899" }], "RE": [{ "2014-15": "4529" }, { "2015-16": "2218" }, { "2016-17": "2776" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "41" }, { "2014-15": "39" }, { "2015-16": "42" }], "BE": [{ "2014-15": "42" }, { "2015-16": "51" }, { "2016-17": "62" }, { "2017-18": "69" }], "RE": [{ "2014-15": "42" }, { "2015-16": "55" }, { "2016-17": "76" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3255" }, { "2014-15": "3215" }, { "2015-16": "3580" }], "BE": [{ "2014-15": "4060" }, { "2015-16": "4252" }, { "2016-17": "5083" }, { "2017-18": "5556" }], "RE": [{ "2014-15": "3955" }, { "2015-16": "3847" }, { "2016-17": "4396" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "1279" }, { "2014-15": "1349" }, { "2015-16": "1639" }], "BE": [{ "2014-15": "1855" }, { "2015-16": "1974" }, { "2016-17": "2778" }, { "2017-18": "2779" }], "RE": [{ "2014-15": "1623" }, { "2015-16": "2129" }, { "2016-17": "2375" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "655" }, { "2014-15": "774" }, { "2015-16": "857" }], "BE": [{ "2014-15": "695" }, { "2015-16": "915" }, { "2016-17": "950" }, { "2017-18": "1083" }], "RE": [{ "2014-15": "777" }, { "2015-16": "883" }, { "2016-17": "937" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1052" }, { "2014-15": "1017" }, { "2015-16": "1356" }], "BE": [{ "2014-15": "1680" }, { "2015-16": "1940" }, { "2016-17": "2538" }, { "2017-18": "2634" }], "RE": [{ "2014-15": "1633" }, { "2015-16": "2027" }, { "2016-17": "2225" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "663" }, { "2014-15": "704" }, { "2015-16": "1045" }], "BE": [{ "2014-15": "1305" }, { "2015-16": "1352" }, { "2016-17": "2579" }, { "2017-18": "2638" }], "RE": [{ "2014-15": "1382" }, { "2015-16": "1426" }, { "2016-17": "2364" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "5006" }, { "2014-15": "6327" }, { "2015-16": "6944" }], "BE": [{ "2014-15": "6901" }, { "2015-16": "7007" }, { "2016-17": "7652" }, { "2017-18": "8954" }], "RE": [{ "2014-15": "6411" }, { "2015-16": "7176" }, { "2016-17": "7859" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "2939" }, { "2014-15": "3192" }, { "2015-16": "3904" }], "BE": [{ "2014-15": "3724" }, { "2015-16": "4064" }, { "2016-17": "4727" }, { "2017-18": "5256" }], "RE": [{ "2014-15": "3263" }, { "2015-16": "3615" }, { "2016-17": "4847" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2089" }, { "2014-15": "3570" }, { "2015-16": "3170" }], "BE": [{ "2014-15": "4649" }, { "2015-16": "4197" }, { "2016-17": "4633" }, { "2017-18": "6310" }], "RE": [{ "2014-15": "4486" }, { "2015-16": "5107" }, { "2016-17": "6195" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "4960" }, { "2014-15": "5528" }, { "2015-16": "6252" }], "BE": [{ "2014-15": "5479" }, { "2015-16": "5245" }, { "2016-17": "7686" }, { "2017-18": "8005" }], "RE": [{ "2014-15": "6318" }, { "2015-16": "7116" }, { "2016-17": "10344" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "387" }, { "2014-15": "407" }, { "2015-16": "405" }], "BE": [{ "2014-15": "792" }, { "2015-16": "668" }, { "2016-17": "689" }, { "2017-18": "793" }], "RE": [{ "2014-15": "792" }, { "2015-16": "668" }, { "2016-17": "689" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "505" }, { "2014-15": "397" }, { "2015-16": "235" }], "BE": [{ "2014-15": "586" }, { "2015-16": "404" }, { "2016-17": "287" }, { "2017-18": "350" }], "RE": [{ "2014-15": "578" }, { "2015-16": "399" }, { "2016-17": "408" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "307" }, { "2014-15": "377" }, { "2015-16": "345" }], "BE": [{ "2014-15": "435" }, { "2015-16": "362" }, { "2016-17": "402" }, { "2017-18": "434" }], "RE": [{ "2014-15": "413" }, { "2015-16": "394" }, { "2016-17": "424" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2310" }, { "2014-15": "3126" }, { "2015-16": "3686" }], "BE": [{ "2014-15": "3248" }, { "2015-16": "3749" }, { "2016-17": "4119" }, { "2017-18": "4694" }], "RE": [{ "2014-15": "3481" }, { "2015-16": "3813" }, { "2016-17": "3797" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1400" }, { "2014-15": "3715" }, { "2015-16": "6158" }], "BE": [{ "2014-15": "6462" }, { "2015-16": "4263" }, { "2016-17": "6917" }, { "2017-18": "11138" }], "RE": [{ "2014-15": "4306" }, { "2015-16": "6966" }, { "2016-17": "8018" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "2625" }, { "2014-15": "2993" }, { "2015-16": "2823" }], "BE": [{ "2014-15": "3876" }, { "2015-16": "3590" }, { "2016-17": "4863" }, { "2017-18": "4614" }], "RE": [{ "2014-15": "3605" }, { "2015-16": "3433" }, { "2016-17": "4337" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "119" }, { "2014-15": "152" }, { "2015-16": "208" }], "BE": [{ "2014-15": "205" }, { "2015-16": "246" }, { "2016-17": "248" }, { "2017-18": "306" }], "RE": [{ "2014-15": "213" }, { "2015-16": "265" }, { "2016-17": "263" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "6709" }, { "2014-15": "7046" }, { "2015-16": "8142" }], "BE": [{ "2014-15": "7012" }, { "2015-16": "8395" }, { "2016-17": "8996" }, { "2017-18": "9675" }], "RE": [{ "2014-15": "7767" }, { "2015-16": "8990" }, { "2016-17": "8879" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "392" }, { "2014-15": "498" }, { "2015-16": "507" }], "BE": [{ "2014-15": "732" }, { "2015-16": "870" }, { "2016-17": "499" }, { "2017-18": "602" }], "RE": [{ "2014-15": "720" }, { "2015-16": "662" }, { "2016-17": "498" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "4548" }, { "2014-15": "6074" }, { "2015-16": "8313" }], "BE": [{ "2014-15": "6248" }, { "2015-16": "8085" }, { "2016-17": "8882" }, { "2017-18": "40554" }], "RE": [{ "2014-15": "7058" }, { "2015-16": "9913" }, { "2016-17": "8642" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "791" }, { "2014-15": "918" }, { "2015-16": "889" }], "BE": [{ "2014-15": "817" }, { "2015-16": "921" }, { "2016-17": "1443" }, { "2017-18": "1248" }], "RE": [{ "2014-15": "983" }, { "2015-16": "1030" }, { "2016-17": "1005" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1802" }, { "2014-15": "2346" }, { "2015-16": "3310" }], "BE": [{ "2014-15": "3402" }, { "2015-16": "3850" }, { "2016-17": "4335" }, { "2017-18": "4609" }], "RE": [{ "2014-15": "2944" }, { "2015-16": "3772" }, { "2016-17": "3834" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "" }, { "2015-16": "3.2" }], "BE": [{ "2014-15": "7.5" }, { "2015-16": "7.4" }, { "2016-17": "5.9" }, { "2017-18": "5.5" }], "RE": [{ "2014-15": "7.6" }, { "2015-16": "6.5" }, { "2016-17": "6.1" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "3.3" }, { "2014-15": "3.1" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "3.4" }, { "2015-16": "5.8" }, { "2016-17": "3" }, { "2017-18": "3" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "3.9" }, { "2016-17": "2.9" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "2.5" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "2.8" }, { "2016-17": "2.3" }, { "2017-18": "2" }], "RE": [{ "2014-15": "3.2" }, { "2015-16": "2.6" }, { "2016-17": "2.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "8.7" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "3.4" }, { "2016-17": "4" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "8.2" }, { "2015-16": "3.4" }, { "2016-17": "3.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0.1" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "0.1" }, { "2015-16": "0.1" }, { "2016-17": "0.1" }, { "2017-18": "0.1" }], "RE": [{ "2014-15": "0.1" }, { "2015-16": "0.1" }, { "2016-17": "0.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3.1" }, { "2014-15": "2.8" }, { "2015-16": "2.4" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "3.1" }, { "2016-17": "4" }, { "2017-18": "3.3" }], "RE": [{ "2014-15": "3.2" }, { "2015-16": "2.9" }, { "2016-17": "3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "2.5" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "2.9" }, { "2016-17": "3.6" }, { "2017-18": "3.2" }], "RE": [{ "2014-15": "2.6" }, { "2015-16": "3.1" }, { "2016-17": "3.2" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "3.1" }, { "2014-15": "2.5" }, { "2015-16": "2.9" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "3.2" }, { "2016-17": "2.9" }, { "2017-18": "3" }], "RE": [{ "2014-15": "2.6" }, { "2015-16": "3.3" }, { "2016-17": "2.7" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "2.9" }, { "2015-16": "2.1" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "4.2" }, { "2016-17": "5.5" }, { "2017-18": "3.3" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "3.9" }, { "2016-17": "3.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "1.8" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "2.4" }, { "2016-17": "4.1" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "2.5" }, { "2016-17": "3.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "4.7" }, { "2014-15": "5.1" }, { "2015-16": "5" }], "BE": [{ "2014-15": "5.3" }, { "2015-16": "5.1" }, { "2016-17": "4.9" }, { "2017-18": "5" }], "RE": [{ "2014-15": "5" }, { "2015-16": "5.2" }, { "2016-17": "5" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "4.4" }, { "2014-15": "4.2" }, { "2015-16": "4.5" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "4.3" }, { "2016-17": "4.4" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4.1" }, { "2015-16": "4.1" }, { "2016-17": "4.6" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2.4" }, { "2014-15": "3.3" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "4" }, { "2015-16": "3.2" }, { "2016-17": "2.9" }, { "2017-18": "3.7" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "3.8" }, { "2016-17": "4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "2.5" }, { "2015-16": "2.8" }], "BE": [{ "2014-15": "2.4" }, { "2015-16": "2.2" }, { "2016-17": "2.8" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "2.9" }, { "2016-17": "3.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "5.3" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "6.6" }, { "2015-16": "6.9" }, { "2016-17": "6.4" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "6.6" }, { "2015-16": "6.9" }, { "2016-17": "6.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "9.2" }, { "2014-15": "5.1" }, { "2015-16": "3.7" }], "BE": [{ "2014-15": "8.7" }, { "2015-16": "5.2" }, { "2016-17": "3.6" }, { "2017-18": "4.1" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "4.8" }, { "2016-17": "4.3" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "3.7" }, { "2014-15": "3.7" }, { "2015-16": "3" }], "BE": [{ "2014-15": "3.5" }, { "2015-16": "2.9" }, { "2016-17": "2.9" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "3.1" }, { "2016-17": "2.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "4.7" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "4.1" }, { "2015-16": "4.4" }, { "2016-17": "4.4" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4.5" }, { "2015-16": "4.5" }, { "2016-17": "4.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "5.1" }, { "2015-16": "7.6" }], "BE": [{ "2014-15": "8.8" }, { "2015-16": "5.4" }, { "2016-17": "8" }, { "2017-18": "9.4" }], "RE": [{ "2014-15": "5.7" }, { "2015-16": "8.9" }, { "2016-17": "5.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "2.6" }, { "2015-16": "2.2" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "2.6" }, { "2016-17": "3.2" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "2.5" }, { "2016-17": "2.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "3.1" }, { "2015-16": "4.6" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "4.5" }, { "2016-17": "4.3" }, { "2017-18": "4.9" }], "RE": [{ "2014-15": "3.2" }, { "2015-16": "4.7" }, { "2016-17": "4.4" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "5.2" }, { "2014-15": "4.5" }, { "2015-16": "4.8" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "4.8" }, { "2016-17": "4.5" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4.8" }, { "2015-16": "5.1" }, { "2016-17": "4.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "5" }, { "2014-15": "4.7" }, { "2015-16": "4.4" }], "BE": [{ "2014-15": "5.9" }, { "2015-16": "5.8" }, { "2016-17": "3.3" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "5.8" }, { "2015-16": "5.1" }, { "2016-17": "3.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "2.6" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.7" }, { "2016-17": "2.6" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "3" }, { "2016-17": "2.5" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "3.4" }, { "2015-16": "3" }], "BE": [{ "2014-15": "2.7" }, { "2015-16": "2.8" }, { "2016-17": "3.6" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "3" }, { "2015-16": "3.1" }, { "2016-17": "3.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "1.9" }, { "2015-16": "2.3" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "2.8" }, { "2016-17": "2.7" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "2.3" }, { "2015-16": "2.6" }, { "2016-17": "2.3" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "717.3" }, { "2014-15": "" }, { "2015-16": "935.8" }], "BE": [{ "2014-15": "1682.4" }, { "2015-16": "1665.3" }, { "2016-17": "1585.8" }, { "2017-18": "1687.2" }], "RE": [{ "2014-15": "1690.2" }, { "2015-16": "1446.7" }, { "2016-17": "1586" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "387.2" }, { "2014-15": "451.2" }, { "2015-16": "337.6" }], "BE": [{ "2014-15": "693.6" }, { "2015-16": "1195" }, { "2016-17": "714.8" }, { "2017-18": "787.4" }], "RE": [{ "2014-15": "728.2" }, { "2015-16": "905.2" }, { "2016-17": "746.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "224.2" }, { "2014-15": "231" }, { "2015-16": "199.1" }], "BE": [{ "2014-15": "330.7" }, { "2015-16": "327.4" }, { "2016-17": "314" }, { "2017-18": "306.8" }], "RE": [{ "2014-15": "411.3" }, { "2015-16": "337.9" }, { "2016-17": "317.7" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "538.1" }, { "2014-15": "1602.1" }, { "2015-16": "630.6" }], "BE": [{ "2014-15": "1824.6" }, { "2015-16": "854.3" }, { "2016-17": "1071.8" }, { "2017-18": "1106.2" }], "RE": [{ "2014-15": "1794.9" }, { "2015-16": "868.1" }, { "2016-17": "1072.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "20.9" }, { "2014-15": "19.6" }, { "2015-16": "20.2" }], "BE": [{ "2014-15": "20.7" }, { "2015-16": "24.5" }, { "2016-17": "29.2" }, { "2017-18": "31.7" }], "RE": [{ "2014-15": "21.1" }, { "2015-16": "26.6" }, { "2016-17": "35.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "1239.4" }, { "2014-15": "1205.3" }, { "2015-16": "1322" }], "BE": [{ "2014-15": "1521.9" }, { "2015-16": "1570.1" }, { "2016-17": "1849.8" }, { "2017-18": "1992.7" }], "RE": [{ "2014-15": "1482.8" }, { "2015-16": "1420.8" }, { "2016-17": "1600" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "211.2" }, { "2014-15": "220" }, { "2015-16": "264" }], "BE": [{ "2014-15": "302.4" }, { "2015-16": "318" }, { "2016-17": "442.2" }, { "2017-18": "437.1" }], "RE": [{ "2014-15": "264.7" }, { "2015-16": "342.9" }, { "2016-17": "378" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "946.9" }, { "2014-15": "1108.8" }, { "2015-16": "1217.2" }], "BE": [{ "2014-15": "996.5" }, { "2015-16": "1300.2" }, { "2016-17": "1338.8" }, { "2017-18": "1513.2" }], "RE": [{ "2014-15": "1113.4" }, { "2015-16": "1254.1" }, { "2016-17": "1321.2" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "876" }, { "2014-15": "837.2" }, { "2015-16": "1103.7" }], "BE": [{ "2014-15": "1382.4" }, { "2015-16": "1578.6" }, { "2016-17": "2043.5" }, { "2017-18": "2097.7" }], "RE": [{ "2014-15": "1343.7" }, { "2015-16": "1649.3" }, { "2016-17": "1791.7" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "204.9" }, { "2014-15": "214.9" }, { "2015-16": "314.8" }], "BE": [{ "2014-15": "398.4" }, { "2015-16": "407.3" }, { "2016-17": "766.4" }, { "2017-18": "773.9" }], "RE": [{ "2014-15": "421.9" }, { "2015-16": "429.3" }, { "2016-17": "702.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "825.8" }, { "2014-15": "1033.6" }, { "2015-16": "1123.7" }], "BE": [{ "2014-15": "1127.4" }, { "2015-16": "1133.8" }, { "2016-17": "1226.7" }, { "2017-18": "1422.2" }], "RE": [{ "2014-15": "1047.3" }, { "2015-16": "1161.2" }, { "2016-17": "1260" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "839" }, { "2014-15": "905.4" }, { "2015-16": "1100.7" }], "BE": [{ "2014-15": "1056.3" }, { "2015-16": "1145.8" }, { "2016-17": "1324.9" }, { "2017-18": "1464.3" }], "RE": [{ "2014-15": "925.4" }, { "2015-16": "1019" }, { "2016-17": "1358.7" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "280.5" }, { "2014-15": "472.1" }, { "2015-16": "413" }], "BE": [{ "2014-15": "614.9" }, { "2015-16": "546.8" }, { "2016-17": "594.9" }, { "2017-18": "798.6" }], "RE": [{ "2014-15": "593.3" }, { "2015-16": "665.4" }, { "2016-17": "795.5" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "428.7" }, { "2014-15": "471.7" }, { "2015-16": "526.9" }], "BE": [{ "2014-15": "467.5" }, { "2015-16": "442" }, { "2016-17": "640.1" }, { "2017-18": "658.5" }], "RE": [{ "2014-15": "539.1" }, { "2015-16": "599.8" }, { "2016-17": "861.5" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1441.4" }, { "2014-15": "1499.5" }, { "2015-16": "1476.2" }], "BE": [{ "2014-15": "2921.7" }, { "2015-16": "2433.5" }, { "2016-17": "2483.7" }, { "2017-18": "2828.4" }], "RE": [{ "2014-15": "2921.7" }, { "2015-16": "2433.5" }, { "2016-17": "2483.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "4914.4" }, { "2014-15": "3818.5" }, { "2015-16": "2238.7" }], "BE": [{ "2014-15": "5641.3" }, { "2015-16": "3842.9" }, { "2016-17": "2701.1" }, { "2017-18": "3257.7" }], "RE": [{ "2014-15": "5561.4" }, { "2015-16": "3800.9" }, { "2016-17": "3835.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1334.2" }, { "2014-15": "1621" }, { "2015-16": "1467.3" }], "BE": [{ "2014-15": "1868.9" }, { "2015-16": "1539.5" }, { "2016-17": "1690.2" }, { "2017-18": "1804.4" }], "RE": [{ "2014-15": "1755" }, { "2015-16": "1673.3" }, { "2016-17": "1781.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "557.3" }, { "2014-15": "748" }, { "2015-16": "874.7" }], "BE": [{ "2014-15": "777.1" }, { "2015-16": "889.7" }, { "2016-17": "969.5" }, { "2017-18": "1096.2" }], "RE": [{ "2014-15": "832.9" }, { "2015-16": "904.9" }, { "2016-17": "893.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "495.2" }, { "2014-15": "1300.5" }, { "2015-16": "2134.6" }], "BE": [{ "2014-15": "2262" }, { "2015-16": "1477.8" }, { "2016-17": "2376" }, { "2017-18": "3788.8" }], "RE": [{ "2014-15": "1507.2" }, { "2015-16": "2415" }, { "2016-17": "2754.1" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "375.3" }, { "2014-15": "421.7" }, { "2015-16": "392.2" }], "BE": [{ "2014-15": "546.2" }, { "2015-16": "498.8" }, { "2016-17": "666.6" }, { "2017-18": "623.9" }], "RE": [{ "2014-15": "507.9" }, { "2015-16": "477" }, { "2016-17": "594.6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1899.4" }, { "2014-15": "2396.8" }, { "2015-16": "3246.4" }], "BE": [{ "2014-15": "3238.6" }, { "2015-16": "3849.5" }, { "2016-17": "3826" }, { "2017-18": "4676.9" }], "RE": [{ "2014-15": "3360.1" }, { "2015-16": "4139.9" }, { "2016-17": "4066.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "982.8" }, { "2014-15": "1026.3" }, { "2015-16": "1179.4" }], "BE": [{ "2014-15": "1021.4" }, { "2015-16": "1216.2" }, { "2016-17": "1296.3" }, { "2017-18": "1386.5" }], "RE": [{ "2014-15": "1131.3" }, { "2015-16": "1302.3" }, { "2016-17": "1279.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1058.7" }, { "2014-15": "1331.5" }, { "2015-16": "1339.3" }], "BE": [{ "2014-15": "1956.9" }, { "2015-16": "2299.6" }, { "2016-17": "1304.6" }, { "2017-18": "1556.6" }], "RE": [{ "2014-15": "1922.8" }, { "2015-16": "1750.7" }, { "2016-17": "1301.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "219" }, { "2014-15": "287.6" }, { "2015-16": "387.3" }], "BE": [{ "2014-15": "295.8" }, { "2015-16": "376.6" }, { "2016-17": "407.3" }, { "2017-18": "1830.4" }], "RE": [{ "2014-15": "334.2" }, { "2015-16": "461.8" }, { "2016-17": "396.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "773.3" }, { "2014-15": "879" }, { "2015-16": "807.7" }], "BE": [{ "2014-15": "788.1" }, { "2015-16": "870.1" }, { "2016-17": "1294.4" }, { "2017-18": "1092.2" }], "RE": [{ "2014-15": "948.9" }, { "2015-16": "960.8" }, { "2016-17": "890.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "197.7" }, { "2014-15": "255.2" }, { "2015-16": "357" }], "BE": [{ "2014-15": "370.1" }, { "2015-16": "415.3" }, { "2016-17": "463.4" }, { "2017-18": "488.5" }], "RE": [{ "2014-15": "320.3" }, { "2015-16": "406.8" }, { "2016-17": "409.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "99.3" }, { "2014-15": "" }, { "2015-16": "97.7" }], "BE": [{ "2014-15": "98.6" }, { "2015-16": "98.1" }, { "2016-17": "98.2" }, { "2017-18": "96" }], "RE": [{ "2014-15": "98.6" }, { "2015-16": "98.7" }, { "2016-17": "98.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "99.9" }, { "2014-15": "99.4" }, { "2015-16": "98.4" }], "BE": [{ "2014-15": "98.3" }, { "2015-16": "65.3" }, { "2016-17": "92.8" }, { "2017-18": "72.4" }], "RE": [{ "2014-15": "98.4" }, { "2015-16": "92.5" }, { "2016-17": "93.1" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "99.7" }, { "2014-15": "99.4" }, { "2015-16": "98.9" }], "BE": [{ "2014-15": "99.2" }, { "2015-16": "87.6" }, { "2016-17": "99.4" }, { "2017-18": "99.1" }], "RE": [{ "2014-15": "99.1" }, { "2015-16": "97.1" }, { "2016-17": "99.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "88.2" }, { "2014-15": "99.5" }, { "2015-16": "98.5" }], "BE": [{ "2014-15": "97.7" }, { "2015-16": "94" }, { "2016-17": "97.6" }, { "2017-18": "96.9" }], "RE": [{ "2014-15": "99.2" }, { "2015-16": "96.8" }, { "2016-17": "97.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "96.8" }, { "2014-15": "94" }, { "2015-16": "94.9" }], "BE": [{ "2014-15": "94" }, { "2015-16": "94.1" }, { "2016-17": "95.1" }, { "2017-18": "95.7" }], "RE": [{ "2014-15": "92.9" }, { "2015-16": "94.5" }, { "2016-17": "96.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "93.7" }, { "2014-15": "96.5" }, { "2015-16": "92.8" }], "BE": [{ "2014-15": "91.6" }, { "2015-16": "92.1" }, { "2016-17": "88.4" }, { "2017-18": "89.5" }], "RE": [{ "2014-15": "96.3" }, { "2015-16": "92.4" }, { "2016-17": "95" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "99.2" }, { "2014-15": "99.7" }, { "2015-16": "97" }], "BE": [{ "2014-15": "98.9" }, { "2015-16": "98.9" }, { "2016-17": "97.6" }, { "2017-18": "99.4" }], "RE": [{ "2014-15": "98.8" }, { "2015-16": "90.4" }, { "2016-17": "96.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "88.5" }, { "2014-15": "90.1" }, { "2015-16": "90.1" }], "BE": [{ "2014-15": "91.3" }, { "2015-16": "91.9" }, { "2016-17": "92.1" }, { "2017-18": "92.3" }], "RE": [{ "2014-15": "90.2" }, { "2015-16": "87.5" }, { "2016-17": "91.5" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "96.8" }, { "2014-15": "98" }, { "2015-16": "97.7" }], "BE": [{ "2014-15": "73.4" }, { "2015-16": "70.5" }, { "2016-17": "59.4" }, { "2017-18": "62.4" }], "RE": [{ "2014-15": "70.7" }, { "2015-16": "70.7" }, { "2016-17": "67.1" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "97.7" }, { "2014-15": "89.4" }, { "2015-16": "91.4" }], "BE": [{ "2014-15": "91.3" }, { "2015-16": "90.8" }, { "2016-17": "72.1" }, { "2017-18": "83.8" }], "RE": [{ "2014-15": "91.4" }, { "2015-16": "91" }, { "2016-17": "75.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "95" }, { "2014-15": "95.8" }, { "2015-16": "97.4" }], "BE": [{ "2014-15": "95.8" }, { "2015-16": "96.9" }, { "2016-17": "96.7" }, { "2017-18": "97.5" }], "RE": [{ "2014-15": "95.8" }, { "2015-16": "97.5" }, { "2016-17": "97" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "89.1" }, { "2014-15": "91" }, { "2015-16": "84.1" }], "BE": [{ "2014-15": "89.6" }, { "2015-16": "87.2" }, { "2016-17": "85.2" }, { "2017-18": "83.1" }], "RE": [{ "2014-15": "88" }, { "2015-16": "84.3" }, { "2016-17": "81.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "98.9" }, { "2014-15": "98.9" }, { "2015-16": "98.9" }], "BE": [{ "2014-15": "99.6" }, { "2015-16": "99.1" }, { "2016-17": "99.5" }, { "2017-18": "99.8" }], "RE": [{ "2014-15": "99.1" }, { "2015-16": "99.4" }, { "2016-17": "99.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "98.2" }, { "2014-15": "98.4" }, { "2015-16": "98.3" }], "BE": [{ "2014-15": "98.2" }, { "2015-16": "97.9" }, { "2016-17": "98.1" }, { "2017-18": "98.1" }], "RE": [{ "2014-15": "98.5" }, { "2015-16": "98.5" }, { "2016-17": "98.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "97.4" }, { "2014-15": "88.7" }, { "2015-16": "98.6" }], "BE": [{ "2014-15": "78.7" }, { "2015-16": "82.3" }, { "2016-17": "86.2" }, { "2017-18": "81.9" }], "RE": [{ "2014-15": "78.7" }, { "2015-16": "82.3" }, { "2016-17": "86.2" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "97.4" }, { "2014-15": "98.7" }, { "2015-16": "96.7" }], "BE": [{ "2014-15": "99.1" }, { "2015-16": "98.2" }, { "2016-17": "100" }, { "2017-18": "66.9" }], "RE": [{ "2014-15": "99.1" }, { "2015-16": "98.1" }, { "2016-17": "99" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "88.1" }, { "2014-15": "95.6" }, { "2015-16": "94.9" }], "BE": [{ "2014-15": "92.8" }, { "2015-16": "97.3" }, { "2016-17": "96.9" }, { "2017-18": "98.1" }], "RE": [{ "2014-15": "92.4" }, { "2015-16": "95.2" }, { "2016-17": "95.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "98.9" }, { "2014-15": "93.1" }, { "2015-16": "93.3" }], "BE": [{ "2014-15": "93.2" }, { "2015-16": "93.3" }, { "2016-17": "95.9" }, { "2017-18": "97.2" }], "RE": [{ "2014-15": "94.2" }, { "2015-16": "93.8" }, { "2016-17": "95.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "95.7" }, { "2014-15": "99.7" }, { "2015-16": "99.6" }], "BE": [{ "2014-15": "99.3" }, { "2015-16": "99" }, { "2016-17": "99.3" }, { "2017-18": "99.7" }], "RE": [{ "2014-15": "99.6" }, { "2015-16": "99.4" }, { "2016-17": "99.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "91.8" }, { "2014-15": "89.1" }, { "2015-16": "93.1" }], "BE": [{ "2014-15": "88.9" }, { "2015-16": "92.6" }, { "2016-17": "88.8" }, { "2017-18": "93.2" }], "RE": [{ "2014-15": "90.1" }, { "2015-16": "92.1" }, { "2016-17": "93.7" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "94.8" }, { "2014-15": "98.2" }, { "2015-16": "99.3" }], "BE": [{ "2014-15": "98.1" }, { "2015-16": "97.5" }, { "2016-17": "91" }, { "2017-18": "96.8" }], "RE": [{ "2014-15": "97.9" }, { "2015-16": "97.7" }, { "2016-17": "90.8" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "92.5" }, { "2014-15": "92.9" }, { "2015-16": "90.7" }], "BE": [{ "2014-15": "92.4" }, { "2015-16": "90" }, { "2016-17": "89.1" }, { "2017-18": "91.6" }], "RE": [{ "2014-15": "91.2" }, { "2015-16": "89.4" }, { "2016-17": "89.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "85.1" }, { "2014-15": "87.5" }, { "2015-16": "85.2" }], "BE": [{ "2014-15": "69.1" }, { "2015-16": "72.1" }, { "2016-17": "76.6" }, { "2017-18": "81.8" }], "RE": [{ "2014-15": "73.8" }, { "2015-16": "77.6" }, { "2016-17": "81.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "75.4" }, { "2014-15": "75.6" }, { "2015-16": "78.9" }], "BE": [{ "2014-15": "78.2" }, { "2015-16": "76.7" }, { "2016-17": "76.5" }, { "2017-18": "95.6" }], "RE": [{ "2014-15": "75.5" }, { "2015-16": "76.4" }, { "2016-17": "71.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "71" }, { "2014-15": "84.8" }, { "2015-16": "97.3" }], "BE": [{ "2014-15": "99.2" }, { "2015-16": "98.3" }, { "2016-17": "92.9" }, { "2017-18": "97.3" }], "RE": [{ "2014-15": "85.6" }, { "2015-16": "96" }, { "2016-17": "99.2" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "80.2" }, { "2014-15": "73.9" }, { "2015-16": "82.9" }], "BE": [{ "2014-15": "67.2" }, { "2015-16": "75.2" }, { "2016-17": "70.1" }, { "2017-18": "77.7" }], "RE": [{ "2014-15": "67.5" }, { "2015-16": "71.8" }, { "2016-17": "78.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "" }, { "2015-16": "2.3" }], "BE": [{ "2014-15": "1.4" }, { "2015-16": "1.9" }, { "2016-17": "1.8" }, { "2017-18": "4" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "1.3" }, { "2016-17": "1.8" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0.6" }, { "2015-16": "1.6" }], "BE": [{ "2014-15": "1.7" }, { "2015-16": "34.7" }, { "2016-17": "7.2" }, { "2017-18": "27.6" }], "RE": [{ "2014-15": "1.6" }, { "2015-16": "7.5" }, { "2016-17": "6.9" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "0.6" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "0.8" }, { "2015-16": "12.4" }, { "2016-17": "0.6" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "2.9" }, { "2016-17": "0.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "11.8" }, { "2014-15": "0.5" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "6" }, { "2016-17": "2.4" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "3.2" }, { "2016-17": "2.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "6" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "6" }, { "2015-16": "5.9" }, { "2016-17": "4.9" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "7.1" }, { "2015-16": "5.5" }, { "2016-17": "3.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "6.3" }, { "2014-15": "3.5" }, { "2015-16": "7.2" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "7.9" }, { "2016-17": "11.6" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "7.6" }, { "2016-17": "5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.3" }, { "2015-16": "3" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "1.1" }, { "2016-17": "2.4" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "9.6" }, { "2016-17": "3.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "11.5" }, { "2014-15": "9.9" }, { "2015-16": "9.9" }], "BE": [{ "2014-15": "8.7" }, { "2015-16": "8.1" }, { "2016-17": "7.9" }, { "2017-18": "7.7" }], "RE": [{ "2014-15": "9.8" }, { "2015-16": "12.5" }, { "2016-17": "8.5" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "2" }, { "2015-16": "2.3" }], "BE": [{ "2014-15": "26.6" }, { "2015-16": "29.5" }, { "2016-17": "40.6" }, { "2017-18": "37.6" }], "RE": [{ "2014-15": "29.3" }, { "2015-16": "29.3" }, { "2016-17": "32.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "10.6" }, { "2015-16": "8.6" }], "BE": [{ "2014-15": "8.7" }, { "2015-16": "9.2" }, { "2016-17": "27.9" }, { "2017-18": "16.2" }], "RE": [{ "2014-15": "8.6" }, { "2015-16": "9" }, { "2016-17": "24.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "5" }, { "2014-15": "4.2" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "3.1" }, { "2016-17": "3.3" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "2.5" }, { "2016-17": "3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "10.9" }, { "2014-15": "9" }, { "2015-16": "15.9" }], "BE": [{ "2014-15": "10.4" }, { "2015-16": "12.8" }, { "2016-17": "14.8" }, { "2017-18": "16.9" }], "RE": [{ "2014-15": "12" }, { "2015-16": "15.7" }, { "2016-17": "18.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "1.1" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.9" }, { "2016-17": "0.5" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "0.6" }, { "2016-17": "0.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "1.8" }, { "2014-15": "1.6" }, { "2015-16": "1.7" }], "BE": [{ "2014-15": "1.8" }, { "2015-16": "2.1" }, { "2016-17": "1.9" }, { "2017-18": "1.9" }], "RE": [{ "2014-15": "1.5" }, { "2015-16": "1.5" }, { "2016-17": "1.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "11.3" }, { "2015-16": "1.4" }], "BE": [{ "2014-15": "21.3" }, { "2015-16": "17.7" }, { "2016-17": "13.8" }, { "2017-18": "18.1" }], "RE": [{ "2014-15": "21.3" }, { "2015-16": "17.7" }, { "2016-17": "13.8" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "1.3" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "1.8" }, { "2016-17": "0" }, { "2017-18": "33.1" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "1.9" }, { "2016-17": "1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "11.9" }, { "2014-15": "4.4" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "7.2" }, { "2015-16": "2.7" }, { "2016-17": "3.1" }, { "2017-18": "1.9" }], "RE": [{ "2014-15": "7.6" }, { "2015-16": "4.8" }, { "2016-17": "4.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "6.9" }, { "2015-16": "6.7" }], "BE": [{ "2014-15": "6.8" }, { "2015-16": "6.7" }, { "2016-17": "4.1" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "5.8" }, { "2015-16": "6.2" }, { "2016-17": "4.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "4.3" }, { "2014-15": "0.3" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "1" }, { "2016-17": "0.7" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.6" }, { "2016-17": "0.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "8.2" }, { "2014-15": "10.9" }, { "2015-16": "6.9" }], "BE": [{ "2014-15": "11.1" }, { "2015-16": "7.4" }, { "2016-17": "11.2" }, { "2017-18": "6.8" }], "RE": [{ "2014-15": "9.9" }, { "2015-16": "7.9" }, { "2016-17": "6.3" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "5.2" }, { "2014-15": "1.8" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "1.9" }, { "2015-16": "2.5" }, { "2016-17": "9" }, { "2017-18": "3.2" }], "RE": [{ "2014-15": "2.1" }, { "2015-16": "2.3" }, { "2016-17": "9.2" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "7.5" }, { "2014-15": "7.1" }, { "2015-16": "9.3" }], "BE": [{ "2014-15": "7.6" }, { "2015-16": "10" }, { "2016-17": "10.9" }, { "2017-18": "8.4" }], "RE": [{ "2014-15": "8.8" }, { "2015-16": "10.6" }, { "2016-17": "10.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "14.9" }, { "2014-15": "12.5" }, { "2015-16": "14.8" }], "BE": [{ "2014-15": "30.9" }, { "2015-16": "27.9" }, { "2016-17": "23.4" }, { "2017-18": "18.2" }], "RE": [{ "2014-15": "26.2" }, { "2015-16": "22.4" }, { "2016-17": "18.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "24.6" }, { "2014-15": "24.4" }, { "2015-16": "21.1" }], "BE": [{ "2014-15": "21.8" }, { "2015-16": "23.3" }, { "2016-17": "23.5" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "24.5" }, { "2015-16": "23.6" }, { "2016-17": "28.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "29" }, { "2014-15": "15.2" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "0.8" }, { "2015-16": "1.7" }, { "2016-17": "7.1" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "14.4" }, { "2015-16": "4" }, { "2016-17": "0.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "19.8" }, { "2014-15": "26.1" }, { "2015-16": "17.1" }], "BE": [{ "2014-15": "32.8" }, { "2015-16": "24.8" }, { "2016-17": "29.9" }, { "2017-18": "22.3" }], "RE": [{ "2014-15": "32.5" }, { "2015-16": "28.2" }, { "2016-17": "21.3" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Agriculture & Allied Activities" }, { "category_slug": "cooperation_food_civil_supplies", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "3426.5" }, { "2014-15": "" }, { "2015-16": "2667.1" }], "BE": [{ "2014-15": "2499.7" }, { "2015-16": "2634.1" }, { "2016-17": "2899.7" }, { "2017-18": "3686" }], "RE": [{ "2014-15": "2455.8" }, { "2015-16": "2632.4" }, { "2016-17": "2884.9" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "76.7" }, { "2014-15": "171.4" }, { "2015-16": "185.8" }], "BE": [{ "2014-15": "498.7" }, { "2015-16": "314.1" }, { "2016-17": "902.9" }, { "2017-18": "909.9" }], "RE": [{ "2014-15": "518.5" }, { "2015-16": "479" }, { "2016-17": "914.1" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "1153.7" }, { "2014-15": "1335.5" }, { "2015-16": "2185.4" }], "BE": [{ "2014-15": "1270.4" }, { "2015-16": "2879.8" }, { "2016-17": "2816" }, { "2017-18": "2395.2" }], "RE": [{ "2014-15": "2012.2" }, { "2015-16": "3309.3" }, { "2016-17": "2838.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "6010.7" }, { "2014-15": "2810.7" }, { "2015-16": "5815.3" }], "BE": [{ "2014-15": "4612.4" }, { "2015-16": "8320.4" }, { "2016-17": "5022.9" }, { "2017-18": "4843.7" }], "RE": [{ "2014-15": "3930.3" }, { "2015-16": "7430.2" }, { "2016-17": "4777.2" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "209.9" }, { "2014-15": "139.5" }, { "2015-16": "154.1" }], "BE": [{ "2014-15": "209.3" }, { "2015-16": "181.2" }, { "2016-17": "249.7" }, { "2017-18": "271.2" }], "RE": [{ "2014-15": "145.2" }, { "2015-16": "161" }, { "2016-17": "171.3" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "350.8" }, { "2014-15": "477.8" }, { "2015-16": "555" }], "BE": [{ "2014-15": "511.3" }, { "2015-16": "626.2" }, { "2016-17": "903.5" }, { "2017-18": "821.6" }], "RE": [{ "2014-15": "493" }, { "2015-16": "585" }, { "2016-17": "701.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "-711.2" }, { "2014-15": "-467.3" }, { "2015-16": "808.1" }], "BE": [{ "2014-15": "570.4" }, { "2015-16": "251.9" }, { "2016-17": "514.6" }, { "2017-18": "482.6" }], "RE": [{ "2014-15": "432" }, { "2015-16": "371.3" }, { "2016-17": "997.2" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "330.8" }, { "2014-15": "287.5" }, { "2015-16": "218.7" }], "BE": [{ "2014-15": "269" }, { "2015-16": "263.9" }, { "2016-17": "272.7" }, { "2017-18": "271.3" }], "RE": [{ "2014-15": "287.5" }, { "2015-16": "218.9" }, { "2016-17": "271.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "883.7" }, { "2014-15": "957.4" }, { "2015-16": "1064" }], "BE": [{ "2014-15": "1004.3" }, { "2015-16": "994" }, { "2016-17": "769.5" }, { "2017-18": "540.5" }], "RE": [{ "2014-15": "1022" }, { "2015-16": "1072" }, { "2016-17": "814.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "656.1" }, { "2014-15": "959" }, { "2015-16": "923.5" }], "BE": [{ "2014-15": "1152.4" }, { "2015-16": "1369.6" }, { "2016-17": "1594.8" }, { "2017-18": "1790.3" }], "RE": [{ "2014-15": "1064.2" }, { "2015-16": "1037.5" }, { "2016-17": "1690.4" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "6339.2" }, { "2014-15": "3735.1" }, { "2015-16": "3616.4" }], "BE": [{ "2014-15": "4953.6" }, { "2015-16": "3441.8" }, { "2016-17": "3563.4" }, { "2017-18": "5296.3" }], "RE": [{ "2014-15": "3437.5" }, { "2015-16": "3509.1" }, { "2016-17": "3894.4" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1336.2" }, { "2014-15": "1608.9" }, { "2015-16": "1612.1" }], "BE": [{ "2014-15": "1278.7" }, { "2015-16": "1185.7" }, { "2016-17": "2118.3" }, { "2017-18": "2035.5" }], "RE": [{ "2014-15": "1423.3" }, { "2015-16": "1526.8" }, { "2016-17": "1992.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2542.6" }, { "2014-15": "2919.2" }, { "2015-16": "2570.5" }], "BE": [{ "2014-15": "2987.6" }, { "2015-16": "2145" }, { "2016-17": "2360.5" }, { "2017-18": "3217.7" }], "RE": [{ "2014-15": "3391.6" }, { "2015-16": "3737.9" }, { "2016-17": "3619.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "4741.6" }, { "2014-15": "8610.2" }, { "2015-16": "7082.5" }], "BE": [{ "2014-15": "4574.4" }, { "2015-16": "7797.3" }, { "2016-17": "7474.7" }, { "2017-18": "7337.1" }], "RE": [{ "2014-15": "7509.4" }, { "2015-16": "7722.5" }, { "2016-17": "8316.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "42.7" }, { "2014-15": "42" }, { "2015-16": "47.9" }], "BE": [{ "2014-15": "57.2" }, { "2015-16": "41.2" }, { "2016-17": "150.4" }, { "2017-18": "153.8" }], "RE": [{ "2014-15": "57.2" }, { "2015-16": "41.2" }, { "2016-17": "150.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "207.9" }, { "2014-15": "232.8" }, { "2015-16": "214.7" }], "BE": [{ "2014-15": "281.8" }, { "2015-16": "305.5" }, { "2016-17": "272.7" }, { "2017-18": "278" }], "RE": [{ "2014-15": "402.4" }, { "2015-16": "381" }, { "2016-17": "296.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "60.3" }, { "2014-15": "33.9" }, { "2015-16": "37.4" }], "BE": [{ "2014-15": "48.7" }, { "2015-16": "39.1" }, { "2016-17": "41.6" }, { "2017-18": "41.4" }], "RE": [{ "2014-15": "37.6" }, { "2015-16": "40.2" }, { "2016-17": "56.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2042.4" }, { "2014-15": "2173.2" }, { "2015-16": "2120.4" }], "BE": [{ "2014-15": "2512.6" }, { "2015-16": "2451.7" }, { "2016-17": "2776.3" }, { "2017-18": "2041.6" }], "RE": [{ "2014-15": "2604.4" }, { "2015-16": "2302.9" }, { "2016-17": "2845.5" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "677.5" }, { "2014-15": "611.5" }, { "2015-16": "918" }], "BE": [{ "2014-15": "900" }, { "2015-16": "1342.6" }, { "2016-17": "1306.1" }, { "2017-18": "3012.4" }], "RE": [{ "2014-15": "686.2" }, { "2015-16": "1101.3" }, { "2016-17": "33660.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "1499.1" }, { "2014-15": "1598.7" }, { "2015-16": "984.3" }], "BE": [{ "2014-15": "1426.1" }, { "2015-16": "1185.1" }, { "2016-17": "1284.3" }, { "2017-18": "1231.6" }], "RE": [{ "2014-15": "1667.2" }, { "2015-16": "1049.3" }, { "2016-17": "1342.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "42.7" }, { "2014-15": "48.4" }, { "2015-16": "38.8" }], "BE": [{ "2014-15": "51.6" }, { "2015-16": "44.4" }, { "2016-17": "43.8" }, { "2017-18": "41.5" }], "RE": [{ "2014-15": "53.8" }, { "2015-16": "44.8" }, { "2016-17": "34.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "5606.2" }, { "2014-15": "5870.1" }, { "2015-16": "6350.5" }], "BE": [{ "2014-15": "6619.2" }, { "2015-16": "6419.8" }, { "2016-17": "8622.6" }, { "2017-18": "8493.1" }], "RE": [{ "2014-15": "6466.8" }, { "2015-16": "6940.1" }, { "2016-17": "8390.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "113.2" }, { "2014-15": "131.7" }, { "2015-16": "122.2" }], "BE": [{ "2014-15": "83.7" }, { "2015-16": "147.6" }, { "2016-17": "126" }, { "2017-18": "172.4" }], "RE": [{ "2014-15": "150.3" }, { "2015-16": "125.1" }, { "2016-17": "140.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "6245.6" }, { "2014-15": "7339.8" }, { "2015-16": "10040.4" }], "BE": [{ "2014-15": "9550.7" }, { "2015-16": "9311.8" }, { "2016-17": "8460.9" }, { "2017-18": "12824.1" }], "RE": [{ "2014-15": "9599.7" }, { "2015-16": "10093" }, { "2016-17": "9971.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "594.9" }, { "2014-15": "374.2" }, { "2015-16": "221.8" }], "BE": [{ "2014-15": "283.2" }, { "2015-16": "386.4" }, { "2016-17": "414.2" }, { "2017-18": "296.3" }], "RE": [{ "2014-15": "356.4" }, { "2015-16": "330.5" }, { "2016-17": "259.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2796" }, { "2014-15": "1504.5" }, { "2015-16": "4357.8" }], "BE": [{ "2014-15": "3439.1" }, { "2015-16": "1825.4" }, { "2016-17": "6106.6" }, { "2017-18": "7932.8" }], "RE": [{ "2014-15": "3362.1" }, { "2015-16": "3744.2" }, { "2016-17": "9422" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "2.5" }, { "2014-15": "" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "2.2" }, { "2015-16": "2.3" }, { "2016-17": "2.1" }, { "2017-18": "2.3" }], "RE": [{ "2014-15": "2.2" }, { "2015-16": "2.3" }, { "2016-17": "2.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0.2" }, { "2014-15": "0.4" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "0.8" }, { "2015-16": "0.5" }, { "2016-17": "1.2" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "0.6" }, { "2016-17": "1.1" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "1.4" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "2.4" }, { "2016-17": "1.9" }, { "2017-18": "1.5" }], "RE": [{ "2014-15": "1.5" }, { "2015-16": "2.5" }, { "2016-17": "1.8" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "15.5" }, { "2014-15": "6.1" }, { "2015-16": "11.2" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "12.8" }, { "2016-17": "7.2" }, { "2017-18": "6.4" }], "RE": [{ "2014-15": "7.1" }, { "2015-16": "11.3" }, { "2016-17": "6.8" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.5" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.4" }, { "2016-17": "0.5" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.4" }, { "2016-17": "0.4" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "0.4" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.5" }, { "2016-17": "0.7" }, { "2017-18": "0.5" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.4" }, { "2016-17": "0.5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "-1.5" }, { "2014-15": "-0.9" }, { "2015-16": "1.3" }], "BE": [{ "2014-15": "1" }, { "2015-16": "0.4" }, { "2016-17": "0.7" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.7" }, { "2015-16": "0.5" }, { "2016-17": "1.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1.5" }, { "2014-15": "0.9" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "0.9" }, { "2016-17": "0.8" }, { "2017-18": "0.8" }], "RE": [{ "2014-15": "1" }, { "2015-16": "0.8" }, { "2016-17": "0.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "2.7" }, { "2015-16": "1.6" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.1" }, { "2016-17": "1.7" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "2.4" }, { "2015-16": "2.1" }, { "2016-17": "1.3" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "2.4" }, { "2015-16": "1.7" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.5" }, { "2016-17": "2.5" }, { "2017-18": "2.4" }], "RE": [{ "2014-15": "2.1" }, { "2015-16": "1.8" }, { "2016-17": "2.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "5.9" }, { "2014-15": "3" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "2.5" }, { "2016-17": "2.3" }, { "2017-18": "3" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "2.5" }, { "2016-17": "2.5" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "2" }, { "2014-15": "2.1" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "1.6" }, { "2015-16": "1.2" }, { "2016-17": "2" }, { "2017-18": "1.7" }], "RE": [{ "2014-15": "1.8" }, { "2015-16": "1.7" }, { "2016-17": "1.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "3" }, { "2014-15": "2.7" }, { "2015-16": "2.1" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "1.6" }, { "2016-17": "1.5" }, { "2017-18": "1.9" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "2.8" }, { "2016-17": "2.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "2.5" }, { "2014-15": "4" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "2" }, { "2015-16": "3.2" }, { "2016-17": "2.8" }, { "2017-18": "2.4" }], "RE": [{ "2014-15": "3.3" }, { "2015-16": "3.1" }, { "2016-17": "2.9" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.6" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.4" }, { "2016-17": "1.4" }, { "2017-18": "1.2" }], "RE": [{ "2014-15": "0.5" }, { "2015-16": "0.4" }, { "2016-17": "1.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3.8" }, { "2014-15": "3" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "3.9" }, { "2016-17": "3.4" }, { "2017-18": "3.3" }], "RE": [{ "2014-15": "5.2" }, { "2015-16": "4.6" }, { "2016-17": "3.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "0.3" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.3" }, { "2016-17": "0.3" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.4" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "3.3" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "2.9" }, { "2016-17": "3" }, { "2017-18": "1.9" }], "RE": [{ "2014-15": "3.4" }, { "2015-16": "2.7" }, { "2016-17": "3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "0.8" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "1.2" }, { "2015-16": "1.7" }, { "2016-17": "1.5" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "1.4" }, { "2016-17": "23.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "1.4" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "0.9" }, { "2016-17": "0.8" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "0.8" }, { "2016-17": "0.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1" }, { "2014-15": "1" }, { "2015-16": "0.9" }], "BE": [{ "2014-15": "0.8" }, { "2015-16": "0.8" }, { "2016-17": "0.8" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "0.8" }, { "2016-17": "0.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "4.4" }, { "2014-15": "3.7" }, { "2015-16": "3.8" }], "BE": [{ "2014-15": "4.3" }, { "2015-16": "3.7" }, { "2016-17": "4.4" }, { "2017-18": "3.9" }], "RE": [{ "2014-15": "4" }, { "2015-16": "3.9" }, { "2016-17": "3.9" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "1.2" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "1" }, { "2016-17": "0.8" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "1" }, { "2016-17": "0.9" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "3.1" }, { "2014-15": "3.1" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "3.5" }, { "2015-16": "3.1" }, { "2016-17": "2.4" }, { "2017-18": "3.3" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "3.1" }, { "2016-17": "2.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "1.4" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "1.2" }, { "2016-17": "1" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "1.1" }, { "2015-16": "1" }, { "2016-17": "0.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "1.2" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "1.3" }, { "2016-17": "3.8" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "2.6" }, { "2015-16": "2.6" }, { "2016-17": "5.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "687.3" }, { "2014-15": "" }, { "2015-16": "528.7" }], "BE": [{ "2014-15": "498.4" }, { "2015-16": "522.2" }, { "2016-17": "571.5" }, { "2017-18": "722.3" }], "RE": [{ "2014-15": "489.7" }, { "2015-16": "521.8" }, { "2016-17": "568.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "24.5" }, { "2014-15": "54.1" }, { "2015-16": "57.9" }], "BE": [{ "2014-15": "157.4" }, { "2015-16": "98" }, { "2016-17": "278.2" }, { "2017-18": "277.2" }], "RE": [{ "2014-15": "163.6" }, { "2015-16": "149.4" }, { "2016-17": "281.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "115" }, { "2014-15": "131.5" }, { "2015-16": "212.7" }], "BE": [{ "2014-15": "125.1" }, { "2015-16": "280.3" }, { "2016-17": "271" }, { "2017-18": "227.8" }], "RE": [{ "2014-15": "198.2" }, { "2015-16": "322.1" }, { "2016-17": "273.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2413" }, { "2014-15": "1113.9" }, { "2015-16": "2275.6" }], "BE": [{ "2014-15": "1828" }, { "2015-16": "3255.9" }, { "2016-17": "1940.9" }, { "2017-18": "1848.6" }], "RE": [{ "2014-15": "1557.7" }, { "2015-16": "2907.6" }, { "2016-17": "1846" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "107.5" }, { "2014-15": "69.4" }, { "2015-16": "74.5" }], "BE": [{ "2014-15": "104.1" }, { "2015-16": "87.6" }, { "2016-17": "117.3" }, { "2017-18": "124" }], "RE": [{ "2014-15": "72.3" }, { "2015-16": "77.9" }, { "2016-17": "80.5" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "133.6" }, { "2014-15": "179.1" }, { "2015-16": "204.9" }], "BE": [{ "2014-15": "191.7" }, { "2015-16": "231.2" }, { "2016-17": "328.8" }, { "2017-18": "294.6" }], "RE": [{ "2014-15": "184.8" }, { "2015-16": "216" }, { "2016-17": "255.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "-117.4" }, { "2014-15": "-76.2" }, { "2015-16": "130.2" }], "BE": [{ "2014-15": "93" }, { "2015-16": "40.6" }, { "2016-17": "81.9" }, { "2017-18": "75.9" }], "RE": [{ "2014-15": "70.4" }, { "2015-16": "59.8" }, { "2016-17": "158.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "478.2" }, { "2014-15": "412" }, { "2015-16": "310.7" }], "BE": [{ "2014-15": "385.5" }, { "2015-16": "375.1" }, { "2016-17": "384.4" }, { "2017-18": "379.2" }], "RE": [{ "2014-15": "411.9" }, { "2015-16": "311.1" }, { "2016-17": "382.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "735.8" }, { "2014-15": "787.9" }, { "2015-16": "865.8" }], "BE": [{ "2014-15": "826.5" }, { "2015-16": "808.9" }, { "2016-17": "619.6" }, { "2017-18": "430.4" }], "RE": [{ "2014-15": "841" }, { "2015-16": "872.3" }, { "2016-17": "655.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "202.9" }, { "2014-15": "292.7" }, { "2015-16": "278.2" }], "BE": [{ "2014-15": "351.7" }, { "2015-16": "412.5" }, { "2016-17": "473.9" }, { "2017-18": "525.2" }], "RE": [{ "2014-15": "324.8" }, { "2015-16": "312.5" }, { "2016-17": "502.3" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1045.7" }, { "2014-15": "610.2" }, { "2015-16": "585.2" }], "BE": [{ "2014-15": "809.2" }, { "2015-16": "557" }, { "2016-17": "571.3" }, { "2017-18": "841.2" }], "RE": [{ "2014-15": "561.5" }, { "2015-16": "567.8" }, { "2016-17": "624.4" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "381.4" }, { "2014-15": "456.3" }, { "2015-16": "454.4" }], "BE": [{ "2014-15": "362.7" }, { "2015-16": "334.3" }, { "2016-17": "593.7" }, { "2017-18": "567" }], "RE": [{ "2014-15": "403.7" }, { "2015-16": "430.4" }, { "2016-17": "558.6" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "341.4" }, { "2014-15": "386.1" }, { "2015-16": "334.9" }], "BE": [{ "2014-15": "395.1" }, { "2015-16": "279.5" }, { "2016-17": "303.1" }, { "2017-18": "407.3" }], "RE": [{ "2014-15": "448.5" }, { "2015-16": "487" }, { "2016-17": "464.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "409.8" }, { "2014-15": "734.7" }, { "2015-16": "596.9" }], "BE": [{ "2014-15": "390.3" }, { "2015-16": "657.2" }, { "2016-17": "622.5" }, { "2017-18": "603.6" }], "RE": [{ "2014-15": "640.8" }, { "2015-16": "650.9" }, { "2016-17": "692.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "159" }, { "2014-15": "154.8" }, { "2015-16": "174.8" }], "BE": [{ "2014-15": "211.1" }, { "2015-16": "150.3" }, { "2016-17": "542.3" }, { "2017-18": "548.6" }], "RE": [{ "2014-15": "210.8" }, { "2015-16": "150.3" }, { "2016-17": "542.3" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "2022" }, { "2014-15": "2240.9" }, { "2015-16": "2043.1" }], "BE": [{ "2014-15": "2712.5" }, { "2015-16": "2906.5" }, { "2016-17": "2565.6" }, { "2017-18": "2587.7" }], "RE": [{ "2014-15": "3873.3" }, { "2015-16": "3624.9" }, { "2016-17": "2785.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "262.2" }, { "2014-15": "145.8" }, { "2015-16": "158.7" }], "BE": [{ "2014-15": "209.2" }, { "2015-16": "166.2" }, { "2016-17": "175" }, { "2017-18": "172.2" }], "RE": [{ "2014-15": "159.6" }, { "2015-16": "171" }, { "2016-17": "235.6" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "492.7" }, { "2014-15": "519.9" }, { "2015-16": "503.2" }], "BE": [{ "2014-15": "601.1" }, { "2015-16": "581.8" }, { "2016-17": "653.6" }, { "2017-18": "476.8" }], "RE": [{ "2014-15": "623.1" }, { "2015-16": "546.5" }, { "2016-17": "669.9" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "239.6" }, { "2014-15": "214" }, { "2015-16": "318.2" }], "BE": [{ "2014-15": "315.1" }, { "2015-16": "465.4" }, { "2016-17": "448.6" }, { "2017-18": "1024.8" }], "RE": [{ "2014-15": "240.2" }, { "2015-16": "381.8" }, { "2016-17": "11562.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "214.3" }, { "2014-15": "225.3" }, { "2015-16": "136.8" }], "BE": [{ "2014-15": "200.9" }, { "2015-16": "164.7" }, { "2016-17": "176.1" }, { "2017-18": "166.5" }], "RE": [{ "2014-15": "234.9" }, { "2015-16": "145.8" }, { "2016-17": "184.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "681.6" }, { "2014-15": "765.3" }, { "2015-16": "606.6" }], "BE": [{ "2014-15": "815.7" }, { "2015-16": "693.3" }, { "2016-17": "677.3" }, { "2017-18": "634.8" }], "RE": [{ "2014-15": "849.3" }, { "2015-16": "699.9" }, { "2016-17": "535.4" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "821.2" }, { "2014-15": "855" }, { "2015-16": "920" }], "BE": [{ "2014-15": "964.1" }, { "2015-16": "930" }, { "2016-17": "1242.5" }, { "2017-18": "1217.2" }], "RE": [{ "2014-15": "941.9" }, { "2015-16": "1005.4" }, { "2016-17": "1209" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "305.9" }, { "2014-15": "351.9" }, { "2015-16": "322.9" }], "BE": [{ "2014-15": "223.8" }, { "2015-16": "390.1" }, { "2016-17": "329.4" }, { "2017-18": "445.7" }], "RE": [{ "2014-15": "401.7" }, { "2015-16": "330.7" }, { "2016-17": "367.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "300.6" }, { "2014-15": "347.5" }, { "2015-16": "467.7" }], "BE": [{ "2014-15": "452.2" }, { "2015-16": "433.8" }, { "2016-17": "388" }, { "2017-18": "578.8" }], "RE": [{ "2014-15": "454.5" }, { "2015-16": "470.2" }, { "2016-17": "457.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "581.8" }, { "2014-15": "358.4" }, { "2015-16": "201.5" }], "BE": [{ "2014-15": "273.3" }, { "2015-16": "365.1" }, { "2016-17": "371.5" }, { "2017-18": "259.2" }], "RE": [{ "2014-15": "344" }, { "2015-16": "308.2" }, { "2016-17": "230" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "306.8" }, { "2014-15": "163.7" }, { "2015-16": "470" }], "BE": [{ "2014-15": "374.1" }, { "2015-16": "196.9" }, { "2016-17": "652.8" }, { "2017-18": "840.8" }], "RE": [{ "2014-15": "365.8" }, { "2015-16": "403.8" }, { "2016-17": "1007.2" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "" }, { "2015-16": "99.8" }], "BE": [{ "2014-15": "100" }, { "2015-16": "99.8" }, { "2016-17": "99.8" }, { "2017-18": "99.9" }], "RE": [{ "2014-15": "100" }, { "2015-16": "99.8" }, { "2016-17": "99.9" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "89.6" }, { "2014-15": "99.1" }, { "2015-16": "100" }], "BE": [{ "2014-15": "99.3" }, { "2015-16": "96.8" }, { "2016-17": "99.7" }, { "2017-18": "74.9" }], "RE": [{ "2014-15": "97.8" }, { "2015-16": "97.9" }, { "2016-17": "98.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "94.4" }, { "2014-15": "90.7" }, { "2015-16": "92" }], "BE": [{ "2014-15": "95.4" }, { "2015-16": "94.3" }, { "2016-17": "95.1" }, { "2017-18": "92.1" }], "RE": [{ "2014-15": "92" }, { "2015-16": "94.1" }, { "2016-17": "94.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "80.1" }, { "2014-15": "98" }, { "2015-16": "97.6" }], "BE": [{ "2014-15": "97.8" }, { "2015-16": "98.1" }, { "2016-17": "97.1" }, { "2017-18": "98" }], "RE": [{ "2014-15": "96.5" }, { "2015-16": "97.6" }, { "2016-17": "96.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "98.8" }, { "2014-15": "96.2" }, { "2015-16": "100" }], "BE": [{ "2014-15": "94.1" }, { "2015-16": "97.2" }, { "2016-17": "98.7" }, { "2017-18": "98.9" }], "RE": [{ "2014-15": "96.3" }, { "2015-16": "100" }, { "2016-17": "99.7" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "97.1" }, { "2014-15": "98.5" }, { "2015-16": "85.4" }], "BE": [{ "2014-15": "75.4" }, { "2015-16": "77.2" }, { "2016-17": "85" }, { "2017-18": "86" }], "RE": [{ "2014-15": "96.2" }, { "2015-16": "81.3" }, { "2016-17": "95" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "-46.9" }, { "2014-15": "-78.6" }, { "2015-16": "50.5" }], "BE": [{ "2014-15": "74.8" }, { "2015-16": "167.5" }, { "2016-17": "83" }, { "2017-18": "122.9" }], "RE": [{ "2014-15": "101" }, { "2015-16": "137.6" }, { "2016-17": "73.9" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "85.9" }, { "2014-15": "84.6" }, { "2015-16": "98.5" }], "BE": [{ "2014-15": "100" }, { "2015-16": "99" }, { "2016-17": "99.3" }, { "2017-18": "99.3" }], "RE": [{ "2014-15": "84.6" }, { "2015-16": "98.5" }, { "2016-17": "84.6" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.8" }, { "2015-16": "13" }], "BE": [{ "2014-15": "2.8" }, { "2015-16": "0.9" }, { "2016-17": "20.4" }, { "2017-18": "31.1" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "0.9" }, { "2016-17": "17.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "98.4" }, { "2014-15": "97.9" }, { "2015-16": "96.4" }], "BE": [{ "2014-15": "96.9" }, { "2015-16": "97.5" }, { "2016-17": "93.7" }, { "2017-18": "85" }], "RE": [{ "2014-15": "97" }, { "2015-16": "96.7" }, { "2016-17": "94.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "99.4" }, { "2014-15": "99.3" }, { "2015-16": "97" }], "BE": [{ "2014-15": "99.4" }, { "2015-16": "96.3" }, { "2016-17": "98.3" }, { "2017-18": "99.1" }], "RE": [{ "2014-15": "99.3" }, { "2015-16": "97" }, { "2016-17": "91.6" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "91" }, { "2014-15": "83.1" }, { "2015-16": "90.8" }], "BE": [{ "2014-15": "90.7" }, { "2015-16": "88.2" }, { "2016-17": "93" }, { "2017-18": "90.2" }], "RE": [{ "2014-15": "86.3" }, { "2015-16": "90.4" }, { "2016-17": "92.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "86.6" }, { "2014-15": "85.4" }, { "2015-16": "89.1" }], "BE": [{ "2014-15": "89.7" }, { "2015-16": "83.7" }, { "2016-17": "83.5" }, { "2017-18": "94.6" }], "RE": [{ "2014-15": "86.6" }, { "2015-16": "74.3" }, { "2016-17": "77.2" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "28.1" }, { "2014-15": "24" }, { "2015-16": "38.4" }], "BE": [{ "2014-15": "43.2" }, { "2015-16": "28.8" }, { "2016-17": "36.8" }, { "2017-18": "38.1" }], "RE": [{ "2014-15": "29.3" }, { "2015-16": "39.7" }, { "2016-17": "41.4" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "80.6" }, { "2014-15": "86.3" }, { "2015-16": "91.2" }], "BE": [{ "2014-15": "73.7" }, { "2015-16": "77.5" }, { "2016-17": "88.8" }, { "2017-18": "95.2" }], "RE": [{ "2014-15": "73.7" }, { "2015-16": "77.5" }, { "2016-17": "88.8" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "44.8" }, { "2014-15": "37.9" }, { "2015-16": "43.6" }], "BE": [{ "2014-15": "30.1" }, { "2015-16": "29.2" }, { "2016-17": "31.5" }, { "2017-18": "29.5" }], "RE": [{ "2014-15": "27" }, { "2015-16": "27.5" }, { "2016-17": "34.2" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "54.8" }, { "2014-15": "90.2" }, { "2015-16": "98.6" }], "BE": [{ "2014-15": "77.7" }, { "2015-16": "92.9" }, { "2016-17": "88.4" }, { "2017-18": "93.9" }], "RE": [{ "2014-15": "81.6" }, { "2015-16": "93.1" }, { "2016-17": "91.2" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "93.3" }, { "2014-15": "97.2" }, { "2015-16": "87.1" }], "BE": [{ "2014-15": "88.8" }, { "2015-16": "90.1" }, { "2016-17": "89.2" }, { "2017-18": "90.1" }], "RE": [{ "2014-15": "88.7" }, { "2015-16": "92" }, { "2016-17": "97" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "81.5" }, { "2014-15": "56.4" }, { "2015-16": "57.9" }], "BE": [{ "2014-15": "76.9" }, { "2015-16": "49.3" }, { "2016-17": "73.2" }, { "2017-18": "27" }], "RE": [{ "2014-15": "53.9" }, { "2015-16": "58.6" }, { "2016-17": "2" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "88" }, { "2014-15": "90.4" }, { "2015-16": "92.9" }], "BE": [{ "2014-15": "85.3" }, { "2015-16": "90.1" }, { "2016-17": "85.1" }, { "2017-18": "89.2" }], "RE": [{ "2014-15": "88.9" }, { "2015-16": "90.9" }, { "2016-17": "87.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "91.1" }, { "2014-15": "83" }, { "2015-16": "84.6" }], "BE": [{ "2014-15": "80.9" }, { "2015-16": "86.2" }, { "2016-17": "92.1" }, { "2017-18": "84.1" }], "RE": [{ "2014-15": "78.8" }, { "2015-16": "85.7" }, { "2016-17": "90" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "97.4" }, { "2014-15": "95.3" }, { "2015-16": "94.5" }], "BE": [{ "2014-15": "89.4" }, { "2015-16": "93.7" }, { "2016-17": "92.7" }, { "2017-18": "96.1" }], "RE": [{ "2014-15": "91.3" }, { "2015-16": "90.8" }, { "2016-17": "95.2" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "88.2" }, { "2014-15": "94.2" }, { "2015-16": "86.3" }], "BE": [{ "2014-15": "94.8" }, { "2015-16": "93.1" }, { "2016-17": "81.1" }, { "2017-18": "93" }], "RE": [{ "2014-15": "93.4" }, { "2015-16": "91.1" }, { "2016-17": "86.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "16.6" }, { "2014-15": "17.4" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "13.3" }, { "2015-16": "7.5" }, { "2016-17": "9.2" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "13.6" }, { "2015-16": "6.6" }, { "2016-17": "7.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "10.5" }, { "2014-15": "64.9" }, { "2015-16": "108.9" }], "BE": [{ "2014-15": "95.8" }, { "2015-16": "94.8" }, { "2016-17": "95.4" }, { "2017-18": "91.7" }], "RE": [{ "2014-15": "96.2" }, { "2015-16": "93" }, { "2016-17": "96.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "95.9" }, { "2014-15": "89.3" }, { "2015-16": "95.2" }], "BE": [{ "2014-15": "95.4" }, { "2015-16": "89.7" }, { "2016-17": "96.3" }, { "2017-18": "96.5" }], "RE": [{ "2014-15": "94.8" }, { "2015-16": "93.4" }, { "2016-17": "96" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "" }, { "2015-16": "0.2" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }, { "2017-18": "0.1" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0.2" }, { "2016-17": "0.1" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "10.4" }, { "2014-15": "0.9" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "3.2" }, { "2016-17": "0.3" }, { "2017-18": "25.1" }], "RE": [{ "2014-15": "2.2" }, { "2015-16": "2.1" }, { "2016-17": "1.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "5.6" }, { "2014-15": "9.3" }, { "2015-16": "8" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "5.7" }, { "2016-17": "4.9" }, { "2017-18": "7.9" }], "RE": [{ "2014-15": "8" }, { "2015-16": "5.9" }, { "2016-17": "5.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "19.9" }, { "2014-15": "2" }, { "2015-16": "2.4" }], "BE": [{ "2014-15": "2.2" }, { "2015-16": "1.9" }, { "2016-17": "2.9" }, { "2017-18": "2" }], "RE": [{ "2014-15": "3.5" }, { "2015-16": "2.4" }, { "2016-17": "3.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1.2" }, { "2014-15": "3.8" }, { "2015-16": "0" }], "BE": [{ "2014-15": "5.9" }, { "2015-16": "2.8" }, { "2016-17": "1.3" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "0" }, { "2016-17": "0.3" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "2.9" }, { "2014-15": "1.5" }, { "2015-16": "14.6" }], "BE": [{ "2014-15": "24.6" }, { "2015-16": "22.8" }, { "2016-17": "15" }, { "2017-18": "14" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "18.7" }, { "2016-17": "5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "146.9" }, { "2014-15": "178.6" }, { "2015-16": "49.5" }], "BE": [{ "2014-15": "25.2" }, { "2015-16": "-67.5" }, { "2016-17": "17" }, { "2017-18": "-22.9" }], "RE": [{ "2014-15": "-1" }, { "2015-16": "-37.6" }, { "2016-17": "26.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "14.1" }, { "2014-15": "15.4" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "0" }, { "2015-16": "1" }, { "2016-17": "0.7" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "15.4" }, { "2015-16": "1.5" }, { "2016-17": "15.4" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "99.2" }, { "2014-15": "99.2" }, { "2015-16": "87" }], "BE": [{ "2014-15": "97.2" }, { "2015-16": "99.1" }, { "2016-17": "79.6" }, { "2017-18": "68.9" }], "RE": [{ "2014-15": "99.2" }, { "2015-16": "99.1" }, { "2016-17": "82.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "2.1" }, { "2015-16": "3.6" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "2.5" }, { "2016-17": "6.3" }, { "2017-18": "15" }], "RE": [{ "2014-15": "3" }, { "2015-16": "3.3" }, { "2016-17": "5.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.7" }, { "2015-16": "3" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "3.7" }, { "2016-17": "1.7" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "0.7" }, { "2015-16": "3" }, { "2016-17": "8.4" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "9" }, { "2014-15": "16.9" }, { "2015-16": "9.2" }], "BE": [{ "2014-15": "9.3" }, { "2015-16": "11.8" }, { "2016-17": "7" }, { "2017-18": "9.8" }], "RE": [{ "2014-15": "13.7" }, { "2015-16": "9.6" }, { "2016-17": "7.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "13.4" }, { "2014-15": "14.6" }, { "2015-16": "10.9" }], "BE": [{ "2014-15": "10.3" }, { "2015-16": "16.3" }, { "2016-17": "16.5" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "13.4" }, { "2015-16": "25.7" }, { "2016-17": "22.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "71.9" }, { "2014-15": "76" }, { "2015-16": "61.6" }], "BE": [{ "2014-15": "56.8" }, { "2015-16": "71.2" }, { "2016-17": "63.2" }, { "2017-18": "61.9" }], "RE": [{ "2014-15": "70.7" }, { "2015-16": "60.3" }, { "2016-17": "58.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "19.4" }, { "2014-15": "13.7" }, { "2015-16": "8.8" }], "BE": [{ "2014-15": "26.3" }, { "2015-16": "22.5" }, { "2016-17": "11.2" }, { "2017-18": "4.8" }], "RE": [{ "2014-15": "26.3" }, { "2015-16": "22.5" }, { "2016-17": "11.2" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "55.2" }, { "2014-15": "62.1" }, { "2015-16": "56.4" }], "BE": [{ "2014-15": "69.9" }, { "2015-16": "70.8" }, { "2016-17": "68.5" }, { "2017-18": "70.5" }], "RE": [{ "2014-15": "73" }, { "2015-16": "72.5" }, { "2016-17": "65.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "45.2" }, { "2014-15": "9.8" }, { "2015-16": "1.4" }], "BE": [{ "2014-15": "22.3" }, { "2015-16": "7.1" }, { "2016-17": "11.6" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "18.4" }, { "2015-16": "6.9" }, { "2016-17": "8.8" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "6.7" }, { "2014-15": "2.8" }, { "2015-16": "12.9" }], "BE": [{ "2014-15": "11.2" }, { "2015-16": "9.9" }, { "2016-17": "10.8" }, { "2017-18": "9.9" }], "RE": [{ "2014-15": "11.3" }, { "2015-16": "8" }, { "2016-17": "3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "18.5" }, { "2014-15": "43.6" }, { "2015-16": "42.1" }], "BE": [{ "2014-15": "23.1" }, { "2015-16": "50.7" }, { "2016-17": "26.8" }, { "2017-18": "73" }], "RE": [{ "2014-15": "46.1" }, { "2015-16": "41.4" }, { "2016-17": "98" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "12" }, { "2014-15": "9.6" }, { "2015-16": "7.1" }], "BE": [{ "2014-15": "14.7" }, { "2015-16": "9.9" }, { "2016-17": "14.9" }, { "2017-18": "10.8" }], "RE": [{ "2014-15": "11.1" }, { "2015-16": "9.1" }, { "2016-17": "12.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "8.9" }, { "2014-15": "17" }, { "2015-16": "15.4" }], "BE": [{ "2014-15": "19.1" }, { "2015-16": "13.8" }, { "2016-17": "7.9" }, { "2017-18": "15.9" }], "RE": [{ "2014-15": "21.2" }, { "2015-16": "14.3" }, { "2016-17": "10" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "4.7" }, { "2015-16": "5.5" }], "BE": [{ "2014-15": "10.6" }, { "2015-16": "6.3" }, { "2016-17": "7.3" }, { "2017-18": "3.9" }], "RE": [{ "2014-15": "8.7" }, { "2015-16": "9.2" }, { "2016-17": "4.8" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "11.8" }, { "2014-15": "5.8" }, { "2015-16": "13.7" }], "BE": [{ "2014-15": "5.2" }, { "2015-16": "6.9" }, { "2016-17": "18.9" }, { "2017-18": "7" }], "RE": [{ "2014-15": "6.6" }, { "2015-16": "8.9" }, { "2016-17": "13.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "83.4" }, { "2014-15": "82.6" }, { "2015-16": "93.8" }], "BE": [{ "2014-15": "86.7" }, { "2015-16": "92.5" }, { "2016-17": "90.8" }, { "2017-18": "93.9" }], "RE": [{ "2014-15": "86.4" }, { "2015-16": "93.4" }, { "2016-17": "92.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "89.5" }, { "2014-15": "35.1" }, { "2015-16": "-8.9" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "5.2" }, { "2016-17": "4.6" }, { "2017-18": "8.3" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "7" }, { "2016-17": "3.2" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "10.7" }, { "2015-16": "4.8" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "10.3" }, { "2016-17": "3.7" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "5.2" }, { "2015-16": "6.6" }, { "2016-17": "4" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Cooperation & Food, Civil Supplies " }, { "category_slug": "rural_development", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "8878.8" }, { "2014-15": "" }, { "2015-16": "18815.3" }], "BE": [{ "2014-15": "11616.8" }, { "2015-16": "12462.2" }, { "2016-17": "16188.7" }, { "2017-18": "21221.4" }], "RE": [{ "2014-15": "11763.4" }, { "2015-16": "18807.9" }, { "2016-17": "17241.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "1333.6" }, { "2014-15": "3491.3" }, { "2015-16": "3262.1" }], "BE": [{ "2014-15": "6109.5" }, { "2015-16": "5176.6" }, { "2016-17": "6871.6" }, { "2017-18": "7572.4" }], "RE": [{ "2014-15": "6165.6" }, { "2015-16": "6055.2" }, { "2016-17": "7022.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "7027.3" }, { "2014-15": "9785.1" }, { "2015-16": "15245" }], "BE": [{ "2014-15": "16374.5" }, { "2015-16": "16401.5" }, { "2016-17": "19844.5" }, { "2017-18": "27930" }], "RE": [{ "2014-15": "16909.4" }, { "2015-16": "18964.8" }, { "2016-17": "24002.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "3264.3" }, { "2014-15": "5704.3" }, { "2015-16": "5552.4" }], "BE": [{ "2014-15": "7583.3" }, { "2015-16": "8126.9" }, { "2016-17": "8320" }, { "2017-18": "9429.4" }], "RE": [{ "2014-15": "8138.9" }, { "2015-16": "8479.5" }, { "2016-17": "9942.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "164" }, { "2014-15": "11.5" }, { "2015-16": "110" }], "BE": [{ "2014-15": "203" }, { "2015-16": "177" }, { "2016-17": "197.7" }, { "2017-18": "623.2" }], "RE": [{ "2014-15": "100.3" }, { "2015-16": "102" }, { "2016-17": "150.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3800.8" }, { "2014-15": "4181" }, { "2015-16": "5905.2" }], "BE": [{ "2014-15": "5358.5" }, { "2015-16": "5579.5" }, { "2016-17": "6186.8" }, { "2017-18": "5928.3" }], "RE": [{ "2014-15": "4942.1" }, { "2015-16": "5979.5" }, { "2016-17": "6403.8" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "1864.5" }, { "2014-15": "1988.7" }, { "2015-16": "2144.4" }], "BE": [{ "2014-15": "2521" }, { "2015-16": "2967" }, { "2016-17": "3103.3" }, { "2017-18": "5396.2" }], "RE": [{ "2014-15": "2521.6" }, { "2015-16": "2830.8" }, { "2016-17": "3703.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "400.9" }, { "2014-15": "839.9" }, { "2015-16": "981.8" }], "BE": [{ "2014-15": "507.2" }, { "2015-16": "1186.4" }, { "2016-17": "1220.2" }, { "2017-18": "1295.7" }], "RE": [{ "2014-15": "839.8" }, { "2015-16": "982.6" }, { "2016-17": "1100.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "8.8" }, { "2014-15": "9.6" }, { "2015-16": "890.5" }], "BE": [{ "2014-15": "10" }, { "2015-16": "9.9" }, { "2016-17": "3142" }, { "2017-18": "3682.9" }], "RE": [{ "2014-15": "10.2" }, { "2015-16": "10.7" }, { "2016-17": "3002.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2648.4" }, { "2014-15": "4907.7" }, { "2015-16": "6018.6" }], "BE": [{ "2014-15": "6471" }, { "2015-16": "6966.3" }, { "2016-17": "8764.4" }, { "2017-18": "10473.7" }], "RE": [{ "2014-15": "7868.8" }, { "2015-16": "7633.1" }, { "2016-17": "10534" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "4456.4" }, { "2014-15": "9166" }, { "2015-16": "10434.7" }], "BE": [{ "2014-15": "8737.3" }, { "2015-16": "9727.3" }, { "2016-17": "12761" }, { "2017-18": "13618.3" }], "RE": [{ "2014-15": "9284.7" }, { "2015-16": "10056.7" }, { "2016-17": "12744.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "5684.1" }, { "2014-15": "8998.1" }, { "2015-16": "7245.9" }], "BE": [{ "2014-15": "7098.7" }, { "2015-16": "9837.7" }, { "2016-17": "11478.1" }, { "2017-18": "13266.2" }], "RE": [{ "2014-15": "7464.4" }, { "2015-16": "8945.6" }, { "2016-17": "10498.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "8799.9" }, { "2014-15": "13041.7" }, { "2015-16": "16657" }], "BE": [{ "2014-15": "18773.3" }, { "2015-16": "17804.9" }, { "2016-17": "24584.6" }, { "2017-18": "29967.9" }], "RE": [{ "2014-15": "18362.6" }, { "2015-16": "18849.4" }, { "2016-17": "26387.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "9835.1" }, { "2014-15": "13299.8" }, { "2015-16": "14006.9" }], "BE": [{ "2014-15": "26407.6" }, { "2015-16": "28756.3" }, { "2016-17": "25674.1" }, { "2017-18": "25360.9" }], "RE": [{ "2014-15": "17607.3" }, { "2015-16": "17562.4" }, { "2016-17": "20241" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "350.6" }, { "2014-15": "568.4" }, { "2015-16": "534.4" }], "BE": [{ "2014-15": "351.1" }, { "2015-16": "612.4" }, { "2016-17": "910" }, { "2017-18": "1649.8" }], "RE": [{ "2014-15": "672.9" }, { "2015-16": "612.4" }, { "2016-17": "910" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "120.8" }, { "2014-15": "301.8" }, { "2015-16": "329.2" }], "BE": [{ "2014-15": "370.7" }, { "2015-16": "383.1" }, { "2016-17": "358" }, { "2017-18": "364.1" }], "RE": [{ "2014-15": "299.9" }, { "2015-16": "369.4" }, { "2016-17": "488.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "208.3" }, { "2014-15": "405.5" }, { "2015-16": "435.6" }], "BE": [{ "2014-15": "1025" }, { "2015-16": "1020.9" }, { "2016-17": "1048.5" }, { "2017-18": "1107.7" }], "RE": [{ "2014-15": "621.7" }, { "2015-16": "903.3" }, { "2016-17": "1000.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "5318.2" }, { "2014-15": "8648.8" }, { "2015-16": "14244.8" }], "BE": [{ "2014-15": "11501.7" }, { "2015-16": "13032.1" }, { "2016-17": "14948.8" }, { "2017-18": "15845.2" }], "RE": [{ "2014-15": "11485.5" }, { "2015-16": "15125.3" }, { "2016-17": "15579.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1239.9" }, { "2014-15": "1493.6" }, { "2015-16": "1277.4" }], "BE": [{ "2014-15": "1938" }, { "2015-16": "1113" }, { "2016-17": "1569.1" }, { "2017-18": "1604.5" }], "RE": [{ "2014-15": "1395" }, { "2015-16": "1324.6" }, { "2016-17": "1711.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "5600.5" }, { "2014-15": "11123.2" }, { "2015-16": "12971.5" }], "BE": [{ "2014-15": "14298.2" }, { "2015-16": "13298.8" }, { "2016-17": "15124.7" }, { "2017-18": "14322.8" }], "RE": [{ "2014-15": "12618.1" }, { "2015-16": "14363.6" }, { "2016-17": "13642.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "535.2" }, { "2014-15": "733" }, { "2015-16": "630.2" }], "BE": [{ "2014-15": "869.5" }, { "2015-16": "729.7" }, { "2016-17": "772.5" }, { "2017-18": "878.1" }], "RE": [{ "2014-15": "876.5" }, { "2015-16": "735" }, { "2016-17": "937.1" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "11155.9" }, { "2014-15": "14799.7" }, { "2015-16": "17059.8" }], "BE": [{ "2014-15": "12949.9" }, { "2015-16": "18476.8" }, { "2016-17": "21186.6" }, { "2017-18": "16665.4" }], "RE": [{ "2014-15": "17576" }, { "2015-16": "17572.9" }, { "2016-17": "18289.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "493.3" }, { "2014-15": "1349.4" }, { "2015-16": "709.3" }], "BE": [{ "2014-15": "1701.4" }, { "2015-16": "2349.4" }, { "2016-17": "770.6" }, { "2017-18": "700.8" }], "RE": [{ "2014-15": "1429.5" }, { "2015-16": "1892" }, { "2016-17": "646.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "9884.6" }, { "2014-15": "15714.9" }, { "2015-16": "15961.5" }], "BE": [{ "2014-15": "18377.6" }, { "2015-16": "20694.5" }, { "2016-17": "22799.5" }, { "2017-18": "28895.3" }], "RE": [{ "2014-15": "19604.8" }, { "2015-16": "20519.2" }, { "2016-17": "20910.5" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "551" }, { "2014-15": "1671.7" }, { "2015-16": "1514.4" }], "BE": [{ "2014-15": "1075.5" }, { "2015-16": "1471.2" }, { "2016-17": "1884.9" }, { "2017-18": "2147.6" }], "RE": [{ "2014-15": "1872.4" }, { "2015-16": "1470.7" }, { "2016-17": "1626.4" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "6607.1" }, { "2014-15": "13902.1" }, { "2015-16": "17024.5" }], "BE": [{ "2014-15": "9970.5" }, { "2015-16": "10938.9" }, { "2016-17": "14294.4" }, { "2017-18": "16966.3" }], "RE": [{ "2014-15": "14180.9" }, { "2015-16": "18089.7" }, { "2016-17": "17869.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "6.5" }, { "2014-15": "" }, { "2015-16": "12.6" }], "BE": [{ "2014-15": "10.4" }, { "2015-16": "11" }, { "2016-17": "11.9" }, { "2017-18": "13.5" }], "RE": [{ "2014-15": "10.5" }, { "2015-16": "16.8" }, { "2016-17": "13" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "7.5" }, { "2015-16": "7.8" }], "BE": [{ "2014-15": "9.4" }, { "2015-16": "7.8" }, { "2016-17": "8.8" }, { "2017-18": "8.8" }], "RE": [{ "2014-15": "9.7" }, { "2015-16": "8.1" }, { "2016-17": "8.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "8.7" }, { "2014-15": "10.3" }, { "2015-16": "13.6" }], "BE": [{ "2014-15": "14" }, { "2015-16": "13.6" }, { "2016-17": "13.7" }, { "2017-18": "17.4" }], "RE": [{ "2014-15": "12.8" }, { "2015-16": "14.3" }, { "2016-17": "15.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "8.4" }, { "2014-15": "12.3" }, { "2015-16": "10.7" }], "BE": [{ "2014-15": "13.9" }, { "2015-16": "12.5" }, { "2016-17": "11.9" }, { "2017-18": "12.4" }], "RE": [{ "2014-15": "14.8" }, { "2015-16": "12.9" }, { "2016-17": "14.1" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0.5" }, { "2014-15": "0" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.4" }, { "2016-17": "0.4" }, { "2017-18": "1.3" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.4" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "3.6" }, { "2015-16": "3.9" }], "BE": [{ "2014-15": "4.1" }, { "2015-16": "4.1" }, { "2016-17": "4.9" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "4.5" }, { "2016-17": "4.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "3.7" }, { "2015-16": "3.5" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "4.3" }, { "2016-17": "4" }, { "2017-18": "6.3" }], "RE": [{ "2014-15": "4.1" }, { "2015-16": "4.2" }, { "2016-17": "5" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "2.7" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "2.1" }, { "2015-16": "4.2" }, { "2016-17": "3.7" }, { "2017-18": "3.6" }], "RE": [{ "2014-15": "2.8" }, { "2015-16": "3.6" }, { "2016-17": "3.2" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "1.4" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "6.9" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "4.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "8.7" }, { "2014-15": "12.3" }, { "2015-16": "11.1" }], "BE": [{ "2014-15": "12.8" }, { "2015-16": "12.6" }, { "2016-17": "13.8" }, { "2017-18": "13.8" }], "RE": [{ "2014-15": "15.5" }, { "2015-16": "13.6" }, { "2016-17": "15.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "4.2" }, { "2014-15": "7.4" }, { "2015-16": "7.5" }], "BE": [{ "2014-15": "6.7" }, { "2015-16": "7.1" }, { "2016-17": "8.1" }, { "2017-18": "7.6" }], "RE": [{ "2014-15": "7.2" }, { "2015-16": "7.2" }, { "2016-17": "8.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "8.6" }, { "2014-15": "11.7" }, { "2015-16": "8.3" }], "BE": [{ "2014-15": "8.9" }, { "2015-16": "10.3" }, { "2016-17": "10.6" }, { "2017-18": "11.1" }], "RE": [{ "2014-15": "9.4" }, { "2015-16": "10.1" }, { "2016-17": "10.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "10.3" }, { "2014-15": "12.2" }, { "2015-16": "13.9" }], "BE": [{ "2014-15": "16" }, { "2015-16": "13.6" }, { "2016-17": "15.5" }, { "2017-18": "17.6" }], "RE": [{ "2014-15": "15.5" }, { "2015-16": "14.2" }, { "2016-17": "16.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "5.2" }, { "2014-15": "6.1" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "11.8" }, { "2015-16": "11.8" }, { "2016-17": "9.5" }, { "2017-18": "8.4" }], "RE": [{ "2014-15": "7.6" }, { "2015-16": "7.1" }, { "2016-17": "7.2" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "5" }, { "2014-15": "7.4" }, { "2015-16": "6.7" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "6.3" }, { "2016-17": "8.5" }, { "2017-18": "12.6" }], "RE": [{ "2014-15": "5.6" }, { "2015-16": "6.3" }, { "2016-17": "8.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "3.9" }, { "2015-16": "5.2" }], "BE": [{ "2014-15": "5.5" }, { "2015-16": "4.9" }, { "2016-17": "4.5" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "4.5" }, { "2016-17": "5.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "2.5" }, { "2014-15": "4" }, { "2015-16": "3.8" }], "BE": [{ "2014-15": "8.2" }, { "2015-16": "8.1" }, { "2016-17": "7.7" }, { "2017-18": "6.8" }], "RE": [{ "2014-15": "5.5" }, { "2015-16": "7.1" }, { "2016-17": "6.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "9.5" }, { "2014-15": "13" }, { "2015-16": "18" }], "BE": [{ "2014-15": "14.4" }, { "2015-16": "15.4" }, { "2016-17": "15.9" }, { "2017-18": "14.8" }], "RE": [{ "2014-15": "14.8" }, { "2015-16": "17.9" }, { "2016-17": "16.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2" }, { "2014-15": "2" }, { "2015-16": "1.6" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "1.4" }, { "2016-17": "1.8" }, { "2017-18": "1.4" }], "RE": [{ "2014-15": "1.9" }, { "2015-16": "1.7" }, { "2016-17": "1.2" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "6" }, { "2014-15": "9.5" }, { "2015-16": "10" }], "BE": [{ "2014-15": "10.9" }, { "2015-16": "9.7" }, { "2016-17": "10" }, { "2017-18": "8.6" }], "RE": [{ "2014-15": "10" }, { "2015-16": "10.4" }, { "2016-17": "9.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "12" }, { "2014-15": "15.2" }, { "2015-16": "14" }], "BE": [{ "2014-15": "13.2" }, { "2015-16": "13.2" }, { "2016-17": "13.5" }, { "2017-18": "14.1" }], "RE": [{ "2014-15": "13.1" }, { "2015-16": "13.1" }, { "2016-17": "15.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "8.7" }, { "2014-15": "9.4" }, { "2015-16": "10.1" }], "BE": [{ "2014-15": "8.5" }, { "2015-16": "10.6" }, { "2016-17": "10.7" }, { "2017-18": "7.6" }], "RE": [{ "2014-15": "10.9" }, { "2015-16": "9.9" }, { "2016-17": "8.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "6.3" }, { "2014-15": "12.7" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "13.7" }, { "2015-16": "15.7" }, { "2016-17": "5.1" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "11.5" }, { "2015-16": "14.6" }, { "2016-17": "4.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "4.9" }, { "2014-15": "6.7" }, { "2015-16": "5.3" }], "BE": [{ "2014-15": "6.7" }, { "2015-16": "6.8" }, { "2016-17": "6.6" }, { "2017-18": "7.5" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "6.2" }, { "2016-17": "6.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "2.5" }, { "2014-15": "6.1" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "3.5" }, { "2015-16": "4.5" }, { "2016-17": "4.7" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "5.8" }, { "2015-16": "4.4" }, { "2016-17": "5.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "6.1" }, { "2014-15": "11.3" }, { "2015-16": "12" }], "BE": [{ "2014-15": "7.7" }, { "2015-16": "7.9" }, { "2016-17": "8.9" }, { "2017-18": "9.3" }], "RE": [{ "2014-15": "10.9" }, { "2015-16": "12.5" }, { "2016-17": "10.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "1780.9" }, { "2014-15": "" }, { "2015-16": "3729.8" }], "BE": [{ "2014-15": "2316.4" }, { "2015-16": "2470.4" }, { "2016-17": "3190.3" }, { "2017-18": "4158.3" }], "RE": [{ "2014-15": "2345.6" }, { "2015-16": "3728.3" }, { "2016-17": "3397.8" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "425.8" }, { "2014-15": "1101.6" }, { "2015-16": "1017.2" }], "BE": [{ "2014-15": "1927.7" }, { "2015-16": "1614.2" }, { "2016-17": "2117.7" }, { "2017-18": "2307" }], "RE": [{ "2014-15": "1945.4" }, { "2015-16": "1888.2" }, { "2016-17": "2164.2" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "700.7" }, { "2014-15": "963.8" }, { "2015-16": "1484" }], "BE": [{ "2014-15": "1612.8" }, { "2015-16": "1596.5" }, { "2016-17": "1909.8" }, { "2017-18": "2656.7" }], "RE": [{ "2014-15": "1665.5" }, { "2015-16": "1846" }, { "2016-17": "2309.9" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1310.5" }, { "2014-15": "2260.8" }, { "2015-16": "2172.7" }], "BE": [{ "2014-15": "3005.4" }, { "2015-16": "3180.2" }, { "2016-17": "3214.9" }, { "2017-18": "3598.7" }], "RE": [{ "2014-15": "3225.6" }, { "2015-16": "3318.1" }, { "2016-17": "3842" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "84" }, { "2014-15": "5.7" }, { "2015-16": "53.2" }], "BE": [{ "2014-15": "101" }, { "2015-16": "85.6" }, { "2016-17": "92.9" }, { "2017-18": "285.1" }], "RE": [{ "2014-15": "49.9" }, { "2015-16": "49.3" }, { "2016-17": "70.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "1447" }, { "2014-15": "1567.4" }, { "2015-16": "2180.7" }], "BE": [{ "2014-15": "2008.8" }, { "2015-16": "2060.4" }, { "2016-17": "2251.6" }, { "2017-18": "2126.1" }], "RE": [{ "2014-15": "1852.7" }, { "2015-16": "2208.2" }, { "2016-17": "2330.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "307.8" }, { "2014-15": "324.3" }, { "2015-16": "345.4" }], "BE": [{ "2014-15": "411.1" }, { "2015-16": "477.9" }, { "2016-17": "494" }, { "2017-18": "848.7" }], "RE": [{ "2014-15": "411.2" }, { "2015-16": "456" }, { "2016-17": "589.4" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "579.5" }, { "2014-15": "1203.7" }, { "2015-16": "1395.2" }], "BE": [{ "2014-15": "726.8" }, { "2015-16": "1686" }, { "2016-17": "1719.9" }, { "2017-18": "1811.1" }], "RE": [{ "2014-15": "1203.6" }, { "2015-16": "1396.3" }, { "2016-17": "1551.6" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "7.4" }, { "2014-15": "7.9" }, { "2015-16": "724.7" }], "BE": [{ "2014-15": "8.3" }, { "2015-16": "8.1" }, { "2016-17": "2530" }, { "2017-18": "2932.6" }], "RE": [{ "2014-15": "8.4" }, { "2015-16": "8.7" }, { "2016-17": "2417.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "819.1" }, { "2014-15": "1497.8" }, { "2015-16": "1812.7" }], "BE": [{ "2014-15": "1974.9" }, { "2015-16": "2098.1" }, { "2016-17": "2604.4" }, { "2017-18": "3072.7" }], "RE": [{ "2014-15": "2401.5" }, { "2015-16": "2298.9" }, { "2016-17": "3130.3" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "735.1" }, { "2014-15": "1497.4" }, { "2015-16": "1688.6" }], "BE": [{ "2014-15": "1427.3" }, { "2015-16": "1574.1" }, { "2016-17": "2045.9" }, { "2017-18": "2163" }], "RE": [{ "2014-15": "1516.8" }, { "2015-16": "1627.4" }, { "2016-17": "2043.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1622.4" }, { "2014-15": "2552.1" }, { "2015-16": "2042.6" }], "BE": [{ "2014-15": "2013.4" }, { "2015-16": "2773.3" }, { "2016-17": "3217.2" }, { "2017-18": "3695.7" }], "RE": [{ "2014-15": "2117.1" }, { "2015-16": "2521.8" }, { "2016-17": "2942.6" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1181.5" }, { "2014-15": "1724.8" }, { "2015-16": "2170.4" }], "BE": [{ "2014-15": "2482.8" }, { "2015-16": "2320" }, { "2016-17": "3156.9" }, { "2017-18": "3793.1" }], "RE": [{ "2014-15": "2428.5" }, { "2015-16": "2456.1" }, { "2016-17": "3388.5" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "850.1" }, { "2014-15": "1134.9" }, { "2015-16": "1180.5" }], "BE": [{ "2014-15": "2253.4" }, { "2015-16": "2423.6" }, { "2016-17": "2138.2" }, { "2017-18": "2086.4" }], "RE": [{ "2014-15": "1502.5" }, { "2015-16": "1480.2" }, { "2016-17": "1685.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1307.3" }, { "2014-15": "2095.7" }, { "2015-16": "1948.3" }], "BE": [{ "2014-15": "1294.7" }, { "2015-16": "2232.7" }, { "2016-17": "3281.7" }, { "2017-18": "5884.7" }], "RE": [{ "2014-15": "2481.1" }, { "2015-16": "2232.7" }, { "2016-17": "3281.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "1175.4" }, { "2014-15": "2904.5" }, { "2015-16": "3132" }], "BE": [{ "2014-15": "3567.9" }, { "2015-16": "3644.9" }, { "2016-17": "3367.9" }, { "2017-18": "3388.7" }], "RE": [{ "2014-15": "2886.2" }, { "2015-16": "3514.8" }, { "2016-17": "4598" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "905.1" }, { "2014-15": "1742.7" }, { "2015-16": "1850.6" }], "BE": [{ "2014-15": "4404.9" }, { "2015-16": "4336.8" }, { "2016-17": "4405.3" }, { "2017-18": "4601.8" }], "RE": [{ "2014-15": "2641.2" }, { "2015-16": "3837.4" }, { "2016-17": "4205.6" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1282.9" }, { "2014-15": "2069.2" }, { "2015-16": "3380.5" }], "BE": [{ "2014-15": "2751.8" }, { "2015-16": "3092.7" }, { "2016-17": "3519.1" }, { "2017-18": "3700.3" }], "RE": [{ "2014-15": "2747.9" }, { "2015-16": "3589.5" }, { "2016-17": "3667.5" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "438.5" }, { "2014-15": "522.8" }, { "2015-16": "442.8" }], "BE": [{ "2014-15": "678.4" }, { "2015-16": "385.8" }, { "2016-17": "539" }, { "2017-18": "545.8" }], "RE": [{ "2014-15": "488.3" }, { "2015-16": "459.2" }, { "2016-17": "587.8" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "800.8" }, { "2014-15": "1567.3" }, { "2015-16": "1802.3" }], "BE": [{ "2014-15": "2014.7" }, { "2015-16": "1847.8" }, { "2016-17": "2073.4" }, { "2017-18": "1936.4" }], "RE": [{ "2014-15": "1778" }, { "2015-16": "1995.7" }, { "2016-17": "1870.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "8549.3" }, { "2014-15": "11580" }, { "2015-16": "9846.2" }], "BE": [{ "2014-15": "13736.8" }, { "2015-16": "11401.6" }, { "2016-17": "11939.4" }, { "2017-18": "13427.3" }], "RE": [{ "2014-15": "13847.4" }, { "2015-16": "11483.6" }, { "2016-17": "14483.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "1634.2" }, { "2014-15": "2155.7" }, { "2015-16": "2471.4" }], "BE": [{ "2014-15": "1886.3" }, { "2015-16": "2676.6" }, { "2016-17": "3053" }, { "2017-18": "2388.3" }], "RE": [{ "2014-15": "2560.1" }, { "2015-16": "2545.7" }, { "2016-17": "2635.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1333.3" }, { "2014-15": "3606" }, { "2015-16": "1874.4" }], "BE": [{ "2014-15": "4546.7" }, { "2015-16": "6208.7" }, { "2016-17": "2014" }, { "2017-18": "1811.9" }], "RE": [{ "2014-15": "3820.1" }, { "2015-16": "4999.9" }, { "2016-17": "1690.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "475.8" }, { "2014-15": "744" }, { "2015-16": "743.5" }], "BE": [{ "2014-15": "870.1" }, { "2015-16": "964" }, { "2016-17": "1045.4" }, { "2017-18": "1304.2" }], "RE": [{ "2014-15": "928.2" }, { "2015-16": "955.8" }, { "2016-17": "958.8" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "538.9" }, { "2014-15": "1601.1" }, { "2015-16": "1375.9" }], "BE": [{ "2014-15": "1038" }, { "2015-16": "1390.3" }, { "2016-17": "1690.8" }, { "2017-18": "1878.7" }], "RE": [{ "2014-15": "1806.9" }, { "2015-16": "1371.4" }, { "2016-17": "1440.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "725.1" }, { "2014-15": "1512.4" }, { "2015-16": "1836" }], "BE": [{ "2014-15": "1084.7" }, { "2015-16": "1179.7" }, { "2016-17": "1528" }, { "2017-18": "1798.2" }], "RE": [{ "2014-15": "1542.7" }, { "2015-16": "1950.9" }, { "2016-17": "1910.2" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "97.5" }, { "2014-15": "" }, { "2015-16": "99.7" }], "BE": [{ "2014-15": "98" }, { "2015-16": "99.6" }, { "2016-17": "97.1" }, { "2017-18": "91.8" }], "RE": [{ "2014-15": "98" }, { "2015-16": "97" }, { "2016-17": "97.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "76.2" }, { "2014-15": "59" }, { "2015-16": "48.3" }], "BE": [{ "2014-15": "73.7" }, { "2015-16": "65.5" }, { "2016-17": "70.5" }, { "2017-18": "70" }], "RE": [{ "2014-15": "72.3" }, { "2015-16": "61.5" }, { "2016-17": "73.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "79.1" }, { "2014-15": "75.5" }, { "2015-16": "64.4" }], "BE": [{ "2014-15": "77.8" }, { "2015-16": "68" }, { "2016-17": "73.4" }, { "2017-18": "80.6" }], "RE": [{ "2014-15": "76.7" }, { "2015-16": "68.4" }, { "2016-17": "78.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1.2" }, { "2014-15": "15" }, { "2015-16": "5.8" }], "BE": [{ "2014-15": "1.2" }, { "2015-16": "1.1" }, { "2016-17": "9.5" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "1.8" }, { "2015-16": "1.9" }, { "2016-17": "5.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "79.4" }, { "2014-15": "77.7" }, { "2015-16": "83.6" }], "BE": [{ "2014-15": "82.5" }, { "2015-16": "83.2" }, { "2016-17": "84.2" }, { "2017-18": "83.5" }], "RE": [{ "2014-15": "81.1" }, { "2015-16": "83.8" }, { "2016-17": "85.1" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "99.9" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "99.9" }, { "2016-17": "100" }, { "2017-18": "77.7" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "99.8" }, { "2015-16": "99.4" }], "BE": [{ "2014-15": "99.7" }, { "2015-16": "99.9" }, { "2016-17": "99.8" }, { "2017-18": "99.8" }], "RE": [{ "2014-15": "99.8" }, { "2015-16": "99.4" }, { "2016-17": "99.7" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.8" }, { "2015-16": "99.9" }], "BE": [{ "2014-15": "2.8" }, { "2015-16": "0.9" }, { "2016-17": "32.8" }, { "2017-18": "29.6" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "0.9" }, { "2016-17": "32" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "56.5" }, { "2014-15": "73" }, { "2015-16": "70.8" }], "BE": [{ "2014-15": "82.3" }, { "2015-16": "81.4" }, { "2016-17": "79.9" }, { "2017-18": "80.2" }], "RE": [{ "2014-15": "82" }, { "2015-16": "76.3" }, { "2016-17": "80" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "63.7" }, { "2014-15": "81.4" }, { "2015-16": "91.8" }], "BE": [{ "2014-15": "73.7" }, { "2015-16": "88" }, { "2016-17": "83.7" }, { "2017-18": "90.2" }], "RE": [{ "2014-15": "73.9" }, { "2015-16": "91.3" }, { "2016-17": "87.8" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "99.5" }, { "2014-15": "97.6" }, { "2015-16": "94" }], "BE": [{ "2014-15": "97.9" }, { "2015-16": "96.6" }, { "2016-17": "95.3" }, { "2017-18": "95.8" }], "RE": [{ "2014-15": "97.3" }, { "2015-16": "96.9" }, { "2016-17": "96.3" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "96" }, { "2014-15": "92.7" }, { "2015-16": "87.4" }], "BE": [{ "2014-15": "87.5" }, { "2015-16": "85.5" }, { "2016-17": "90.3" }, { "2017-18": "87.8" }], "RE": [{ "2014-15": "89.8" }, { "2015-16": "88.6" }, { "2016-17": "87.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "87.4" }, { "2014-15": "87.3" }, { "2015-16": "85.4" }], "BE": [{ "2014-15": "68.9" }, { "2015-16": "68.6" }, { "2016-17": "76.9" }, { "2017-18": "68.4" }], "RE": [{ "2014-15": "80.7" }, { "2015-16": "77.5" }, { "2016-17": "81.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "99.9" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "99.8" }, { "2015-16": "99.9" }, { "2016-17": "99.7" }, { "2017-18": "98.9" }], "RE": [{ "2014-15": "99.9" }, { "2015-16": "99.9" }, { "2016-17": "99.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "63.7" }, { "2014-15": "82.6" }, { "2015-16": "87.8" }], "BE": [{ "2014-15": "89.3" }, { "2015-16": "89.4" }, { "2016-17": "88.7" }, { "2017-18": "84.5" }], "RE": [{ "2014-15": "81" }, { "2015-16": "88.1" }, { "2016-17": "89.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "65.3" }, { "2014-15": "98.3" }, { "2015-16": "73.2" }], "BE": [{ "2014-15": "92.6" }, { "2015-16": "84.8" }, { "2016-17": "85.3" }, { "2017-18": "92.1" }], "RE": [{ "2014-15": "94.5" }, { "2015-16": "79.9" }, { "2016-17": "86.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "85.6" }, { "2014-15": "74.2" }, { "2015-16": "70.5" }], "BE": [{ "2014-15": "73.9" }, { "2015-16": "72.3" }, { "2016-17": "73.6" }, { "2017-18": "71.7" }], "RE": [{ "2014-15": "77.9" }, { "2015-16": "71.7" }, { "2016-17": "73.3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "89.5" }, { "2014-15": "93.8" }, { "2015-16": "93.1" }], "BE": [{ "2014-15": "85.8" }, { "2015-16": "88.8" }, { "2016-17": "91" }, { "2017-18": "78.8" }], "RE": [{ "2014-15": "87.7" }, { "2015-16": "92.4" }, { "2016-17": "88.1" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "85.8" }, { "2014-15": "93.5" }, { "2015-16": "94" }], "BE": [{ "2014-15": "94.6" }, { "2015-16": "93.7" }, { "2016-17": "94.3" }, { "2017-18": "92.9" }], "RE": [{ "2014-15": "94" }, { "2015-16": "94.4" }, { "2016-17": "93.4" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "87.9" }, { "2014-15": "71.2" }, { "2015-16": "83.9" }], "BE": [{ "2014-15": "75.9" }, { "2015-16": "80.2" }, { "2016-17": "82.9" }, { "2017-18": "73.8" }], "RE": [{ "2014-15": "72.5" }, { "2015-16": "78.9" }, { "2016-17": "75.9" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "70.7" }, { "2014-15": "92.3" }, { "2015-16": "91.7" }], "BE": [{ "2014-15": "75.6" }, { "2015-16": "90" }, { "2016-17": "95.7" }, { "2017-18": "91.4" }], "RE": [{ "2014-15": "89.1" }, { "2015-16": "92.2" }, { "2016-17": "94.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "64.6" }, { "2014-15": "39.3" }, { "2015-16": "34.3" }], "BE": [{ "2014-15": "32" }, { "2015-16": "34.6" }, { "2016-17": "34" }, { "2017-18": "50.2" }], "RE": [{ "2014-15": "42.6" }, { "2015-16": "33.9" }, { "2016-17": "44.1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "68.3" }, { "2014-15": "36.9" }, { "2015-16": "41.9" }], "BE": [{ "2014-15": "43.8" }, { "2015-16": "43.4" }, { "2016-17": "47.2" }, { "2017-18": "52.3" }], "RE": [{ "2014-15": "42.6" }, { "2015-16": "43.1" }, { "2016-17": "51.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "56.8" }, { "2014-15": "61.7" }, { "2015-16": "51.5" }], "BE": [{ "2014-15": "75.8" }, { "2015-16": "56.6" }, { "2016-17": "59" }, { "2017-18": "54.7" }], "RE": [{ "2014-15": "57.8" }, { "2015-16": "55.4" }, { "2016-17": "57.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "99" }, { "2014-15": "100" }, { "2015-16": "99.5" }], "BE": [{ "2014-15": "99.5" }, { "2015-16": "99.9" }, { "2016-17": "99.9" }, { "2017-18": "99.7" }], "RE": [{ "2014-15": "99.4" }, { "2015-16": "99.8" }, { "2016-17": "99.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "2.5" }, { "2014-15": "" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "2" }, { "2015-16": "0.4" }, { "2016-17": "2.9" }, { "2017-18": "8.2" }], "RE": [{ "2014-15": "2" }, { "2015-16": "3" }, { "2016-17": "2.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "23.8" }, { "2014-15": "41" }, { "2015-16": "51.7" }], "BE": [{ "2014-15": "26.3" }, { "2015-16": "34.5" }, { "2016-17": "29.5" }, { "2017-18": "30" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "38.5" }, { "2016-17": "26.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "20.9" }, { "2014-15": "24.5" }, { "2015-16": "35.6" }], "BE": [{ "2014-15": "22.2" }, { "2015-16": "32" }, { "2016-17": "26.6" }, { "2017-18": "19.4" }], "RE": [{ "2014-15": "23.3" }, { "2015-16": "31.6" }, { "2016-17": "21.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "98.8" }, { "2014-15": "85" }, { "2015-16": "94.2" }], "BE": [{ "2014-15": "98.8" }, { "2015-16": "98.9" }, { "2016-17": "90.5" }, { "2017-18": "93.9" }], "RE": [{ "2014-15": "98.2" }, { "2015-16": "98.1" }, { "2016-17": "94.8" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "20.6" }, { "2014-15": "22.3" }, { "2015-16": "16.4" }], "BE": [{ "2014-15": "17.5" }, { "2015-16": "16.8" }, { "2016-17": "15.8" }, { "2017-18": "16.5" }], "RE": [{ "2014-15": "18.9" }, { "2015-16": "16.2" }, { "2016-17": "14.9" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0.1" }, { "2016-17": "0" }, { "2017-18": "22.3" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0.2" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.3" }, { "2015-16": "0.1" }, { "2016-17": "0.2" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.2" }, { "2015-16": "0.6" }, { "2016-17": "0.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "99.2" }, { "2014-15": "99.2" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "97.2" }, { "2015-16": "99.1" }, { "2016-17": "67.2" }, { "2017-18": "70.4" }], "RE": [{ "2014-15": "99.2" }, { "2015-16": "99.1" }, { "2016-17": "68" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "43.5" }, { "2014-15": "27" }, { "2015-16": "29.2" }], "BE": [{ "2014-15": "17.7" }, { "2015-16": "18.6" }, { "2016-17": "20.1" }, { "2017-18": "19.8" }], "RE": [{ "2014-15": "18" }, { "2015-16": "23.7" }, { "2016-17": "20" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "36.3" }, { "2014-15": "18.6" }, { "2015-16": "8.2" }], "BE": [{ "2014-15": "26.3" }, { "2015-16": "12" }, { "2016-17": "16.3" }, { "2017-18": "9.8" }], "RE": [{ "2014-15": "26.1" }, { "2015-16": "8.7" }, { "2016-17": "12.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "0.5" }, { "2014-15": "2.4" }, { "2015-16": "6" }], "BE": [{ "2014-15": "2.1" }, { "2015-16": "3.4" }, { "2016-17": "4.7" }, { "2017-18": "4.2" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "3.1" }, { "2016-17": "3.7" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "7.3" }, { "2015-16": "12.6" }], "BE": [{ "2014-15": "12.5" }, { "2015-16": "14.5" }, { "2016-17": "9.7" }, { "2017-18": "12.2" }], "RE": [{ "2014-15": "10.2" }, { "2015-16": "11.4" }, { "2016-17": "12.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "12.6" }, { "2014-15": "12.7" }, { "2015-16": "14.6" }], "BE": [{ "2014-15": "31.1" }, { "2015-16": "31.4" }, { "2016-17": "23.1" }, { "2017-18": "31.6" }], "RE": [{ "2014-15": "19.3" }, { "2015-16": "22.5" }, { "2016-17": "18.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0.2" }, { "2015-16": "0.1" }, { "2016-17": "0.3" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "0.1" }, { "2015-16": "0.1" }, { "2016-17": "0.3" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "36.3" }, { "2014-15": "17.4" }, { "2015-16": "12.2" }], "BE": [{ "2014-15": "10.7" }, { "2015-16": "10.6" }, { "2016-17": "11.3" }, { "2017-18": "15.5" }], "RE": [{ "2014-15": "19" }, { "2015-16": "11.9" }, { "2016-17": "10.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "34.7" }, { "2014-15": "1.7" }, { "2015-16": "26.8" }], "BE": [{ "2014-15": "7.4" }, { "2015-16": "15.2" }, { "2016-17": "14.7" }, { "2017-18": "7.9" }], "RE": [{ "2014-15": "5.5" }, { "2015-16": "20.1" }, { "2016-17": "13.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "14.4" }, { "2014-15": "25.8" }, { "2015-16": "29.5" }], "BE": [{ "2014-15": "26.1" }, { "2015-16": "27.7" }, { "2016-17": "26.4" }, { "2017-18": "28.3" }], "RE": [{ "2014-15": "22.1" }, { "2015-16": "28.3" }, { "2016-17": "26.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "10.5" }, { "2014-15": "6.2" }, { "2015-16": "6.9" }], "BE": [{ "2014-15": "14.2" }, { "2015-16": "11.2" }, { "2016-17": "9" }, { "2017-18": "21.2" }], "RE": [{ "2014-15": "12.3" }, { "2015-16": "7.6" }, { "2016-17": "11.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "14.2" }, { "2014-15": "6.5" }, { "2015-16": "6" }], "BE": [{ "2014-15": "5.4" }, { "2015-16": "6.3" }, { "2016-17": "5.7" }, { "2017-18": "7.1" }], "RE": [{ "2014-15": "6" }, { "2015-16": "5.6" }, { "2016-17": "6.6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "12.1" }, { "2014-15": "28.8" }, { "2015-16": "16.1" }], "BE": [{ "2014-15": "24.1" }, { "2015-16": "19.8" }, { "2016-17": "17.1" }, { "2017-18": "26.2" }], "RE": [{ "2014-15": "27.5" }, { "2015-16": "21.1" }, { "2016-17": "24.1" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "29.3" }, { "2014-15": "7.7" }, { "2015-16": "8.3" }], "BE": [{ "2014-15": "24.4" }, { "2015-16": "10" }, { "2016-17": "4.3" }, { "2017-18": "8.6" }], "RE": [{ "2014-15": "10.9" }, { "2015-16": "7.8" }, { "2016-17": "5.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "35.4" }, { "2014-15": "60.7" }, { "2015-16": "65.7" }], "BE": [{ "2014-15": "68" }, { "2015-16": "65.4" }, { "2016-17": "66" }, { "2017-18": "49.8" }], "RE": [{ "2014-15": "57.4" }, { "2015-16": "66.1" }, { "2016-17": "55.9" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "31.7" }, { "2014-15": "63.1" }, { "2015-16": "58.1" }], "BE": [{ "2014-15": "56.2" }, { "2015-16": "56.6" }, { "2016-17": "52.8" }, { "2017-18": "47.7" }], "RE": [{ "2014-15": "57.4" }, { "2015-16": "56.9" }, { "2016-17": "48.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "43.2" }, { "2014-15": "38.3" }, { "2015-16": "48.5" }], "BE": [{ "2014-15": "24.2" }, { "2015-16": "43.4" }, { "2016-17": "41" }, { "2017-18": "45.3" }], "RE": [{ "2014-15": "42.2" }, { "2015-16": "44.6" }, { "2016-17": "42.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1" }, { "2014-15": "0" }, { "2015-16": "0.5" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.1" }, { "2016-17": "0.1" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.2" }, { "2016-17": "0.3" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Rural Development" }, { "category_slug": "power_energy", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "7557.5" }, { "2014-15": "" }, { "2015-16": "4282.8" }], "BE": [{ "2014-15": "7163.8" }, { "2015-16": "4560.2" }, { "2016-17": "4026.4" }, { "2017-18": "4318.2" }], "RE": [{ "2014-15": "7164.1" }, { "2015-16": "4836.8" }, { "2016-17": "4148.8" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "886.5" }, { "2014-15": "922.6" }, { "2015-16": "320.3" }], "BE": [{ "2014-15": "1031.3" }, { "2015-16": "1263.3" }, { "2016-17": "1170.3" }, { "2017-18": "1322.8" }], "RE": [{ "2014-15": "1288.6" }, { "2015-16": "1269.3" }, { "2016-17": "1320.9" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "5887.5" }, { "2014-15": "8202.7" }, { "2015-16": "9088.8" }], "BE": [{ "2014-15": "6355" }, { "2015-16": "8436.9" }, { "2016-17": "14367.8" }, { "2017-18": "10905" }], "RE": [{ "2014-15": "8355.5" }, { "2015-16": "9935.7" }, { "2016-17": "15657.3" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "798.6" }, { "2014-15": "1375.3" }, { "2015-16": "3493.1" }], "BE": [{ "2014-15": "988.1" }, { "2015-16": "2667.4" }, { "2016-17": "2536.3" }, { "2017-18": "3915.5" }], "RE": [{ "2014-15": "1701.6" }, { "2015-16": "3745.7" }, { "2016-17": "2300.1" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "4719.7" }, { "2014-15": "1239.8" }, { "2015-16": "2125.2" }], "BE": [{ "2014-15": "1357.8" }, { "2015-16": "2105.9" }, { "2016-17": "2189.1" }, { "2017-18": "2196.4" }], "RE": [{ "2014-15": "1358.9" }, { "2015-16": "2175.5" }, { "2016-17": "2324.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "5902.4" }, { "2014-15": "7640.5" }, { "2015-16": "6983.9" }], "BE": [{ "2014-15": "6399.2" }, { "2015-16": "7210.8" }, { "2016-17": "7268.1" }, { "2017-18": "7571.2" }], "RE": [{ "2014-15": "7772.1" }, { "2015-16": "8478.8" }, { "2016-17": "7232" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "5603" }, { "2014-15": "5429.7" }, { "2015-16": "24084.2" }], "BE": [{ "2014-15": "5360.1" }, { "2015-16": "6546.9" }, { "2016-17": "16826.7" }, { "2017-18": "12678.8" }], "RE": [{ "2014-15": "5979" }, { "2015-16": "24480.7" }, { "2016-17": "16278.4" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "481.1" }, { "2014-15": "841.2" }, { "2015-16": "1393.3" }], "BE": [{ "2014-15": "712.4" }, { "2015-16": "829.5" }, { "2016-17": "882.9" }, { "2017-18": "909.2" }], "RE": [{ "2014-15": "753.8" }, { "2015-16": "1255.3" }, { "2016-17": "1084" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "3917" }, { "2014-15": "4832.1" }, { "2015-16": "6686.1" }], "BE": [{ "2014-15": "4761.8" }, { "2015-16": "4985.1" }, { "2016-17": "13242.6" }, { "2017-18": "16521.3" }], "RE": [{ "2014-15": "5295.6" }, { "2015-16": "7775.7" }, { "2016-17": "10122.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "1712.2" }, { "2014-15": "3144.1" }, { "2015-16": "9612.5" }], "BE": [{ "2014-15": "1868.5" }, { "2015-16": "2511.7" }, { "2016-17": "2277" }, { "2017-18": "6000" }], "RE": [{ "2014-15": "3374.5" }, { "2015-16": "3386.3" }, { "2016-17": "3177.4" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "6382.3" }, { "2014-15": "7052.4" }, { "2015-16": "9252" }], "BE": [{ "2014-15": "7641.2" }, { "2015-16": "8165.9" }, { "2016-17": "7932.2" }, { "2017-18": "10272.3" }], "RE": [{ "2014-15": "7131.3" }, { "2015-16": "9421.2" }, { "2016-17": "7941" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "242.7" }, { "2014-15": "105.6" }, { "2015-16": "83.8" }], "BE": [{ "2014-15": "164.8" }, { "2015-16": "180" }, { "2016-17": "200.9" }, { "2017-18": "186.9" }], "RE": [{ "2014-15": "193.9" }, { "2015-16": "158.7" }, { "2016-17": "164.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "8044" }, { "2014-15": "17644" }, { "2015-16": "10629.3" }], "BE": [{ "2014-15": "8015.2" }, { "2015-16": "9718.2" }, { "2016-17": "20114.4" }, { "2017-18": "16909.1" }], "RE": [{ "2014-15": "11042.6" }, { "2015-16": "12101.1" }, { "2016-17": "21166.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "10738.7" }, { "2014-15": "15468.5" }, { "2015-16": "13980.8" }], "BE": [{ "2014-15": "14615.1" }, { "2015-16": "11325.5" }, { "2016-17": "9840.2" }, { "2017-18": "11365.3" }], "RE": [{ "2014-15": "15857.7" }, { "2015-16": "14582.8" }, { "2016-17": "20089.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "183.5" }, { "2014-15": "207.5" }, { "2015-16": "117.7" }], "BE": [{ "2014-15": "177.5" }, { "2015-16": "140.4" }, { "2016-17": "197" }, { "2017-18": "135.5" }], "RE": [{ "2014-15": "177.5" }, { "2015-16": "140.4" }, { "2016-17": "197" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "382.4" }, { "2014-15": "480.1" }, { "2015-16": "429.2" }], "BE": [{ "2014-15": "335.9" }, { "2015-16": "353.7" }, { "2016-17": "321.5" }, { "2017-18": "424.4" }], "RE": [{ "2014-15": "487.7" }, { "2015-16": "441.8" }, { "2016-17": "534.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "379.2" }, { "2014-15": "405.1" }, { "2015-16": "439.9" }], "BE": [{ "2014-15": "420.2" }, { "2015-16": "373.4" }, { "2016-17": "418.5" }, { "2017-18": "455.4" }], "RE": [{ "2014-15": "424.3" }, { "2015-16": "433.1" }, { "2016-17": "473.2" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1187.8" }, { "2014-15": "795.2" }, { "2015-16": "1609.8" }], "BE": [{ "2014-15": "1346.8" }, { "2015-16": "1239.8" }, { "2016-17": "2862.4" }, { "2017-18": "1762.5" }], "RE": [{ "2014-15": "946.9" }, { "2015-16": "1654.9" }, { "2016-17": "3338.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "4815" }, { "2014-15": "2504.9" }, { "2015-16": "6110.3" }], "BE": [{ "2014-15": "800" }, { "2015-16": "2991.2" }, { "2016-17": "664.5" }, { "2017-18": "2647.7" }], "RE": [{ "2014-15": "2504.9" }, { "2015-16": "665.7" }, { "2016-17": "12931" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "11171.9" }, { "2014-15": "13607.9" }, { "2015-16": "16549.1" }], "BE": [{ "2014-15": "14854.1" }, { "2015-16": "16852.9" }, { "2016-17": "12523.1" }, { "2017-18": "11439.6" }], "RE": [{ "2014-15": "14262.5" }, { "2015-16": "20607.1" }, { "2016-17": "12845.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "185.8" }, { "2014-15": "167.8" }, { "2015-16": "253.7" }], "BE": [{ "2014-15": "197.2" }, { "2015-16": "312.8" }, { "2016-17": "323.9" }, { "2017-18": "349.4" }], "RE": [{ "2014-15": "202.8" }, { "2015-16": "315" }, { "2016-17": "332.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "5034.4" }, { "2014-15": "9884.1" }, { "2015-16": "7799.4" }], "BE": [{ "2014-15": "7392.7" }, { "2015-16": "8432.7" }, { "2016-17": "9249.3" }, { "2017-18": "12965.8" }], "RE": [{ "2014-15": "7724" }, { "2015-16": "9242.2" }, { "2016-17": "35082.9" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "113.6" }, { "2014-15": "124.8" }, { "2015-16": "135.1" }], "BE": [{ "2014-15": "117.5" }, { "2015-16": "243.7" }, { "2016-17": "114.1" }, { "2017-18": "113.6" }], "RE": [{ "2014-15": "141.9" }, { "2015-16": "163.7" }, { "2016-17": "150.1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "12840.6" }, { "2014-15": "25949.2" }, { "2015-16": "48218.8" }], "BE": [{ "2014-15": "23039.8" }, { "2015-16": "24699.1" }, { "2016-17": "32835.1" }, { "2017-18": "17728.3" }], "RE": [{ "2014-15": "27563.5" }, { "2015-16": "51692.8" }, { "2016-17": "34601.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "300.5" }, { "2014-15": "152.2" }, { "2015-16": "130.1" }], "BE": [{ "2014-15": "519.5" }, { "2015-16": "203" }, { "2016-17": "496.3" }, { "2017-18": "336.5" }], "RE": [{ "2014-15": "409.5" }, { "2015-16": "179.5" }, { "2016-17": "210" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2054.3" }, { "2014-15": "1660.6" }, { "2015-16": "3290.8" }], "BE": [{ "2014-15": "1863.4" }, { "2015-16": "1984" }, { "2016-17": "2217.4" }, { "2017-18": "2923.2" }], "RE": [{ "2014-15": "2462.5" }, { "2015-16": "2264.3" }, { "2016-17": "4124.3" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "" }, { "2015-16": "2.9" }], "BE": [{ "2014-15": "6.4" }, { "2015-16": "4" }, { "2016-17": "3" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "6.4" }, { "2015-16": "4.3" }, { "2016-17": "3.1" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "2.4" }, { "2014-15": "2" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "1.6" }, { "2015-16": "1.9" }, { "2016-17": "1.5" }, { "2017-18": "1.5" }], "RE": [{ "2014-15": "2" }, { "2015-16": "1.7" }, { "2016-17": "1.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "7.3" }, { "2014-15": "8.7" }, { "2015-16": "8.1" }], "BE": [{ "2014-15": "5.4" }, { "2015-16": "7" }, { "2016-17": "9.9" }, { "2017-18": "6.8" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "7.5" }, { "2016-17": "10.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "3" }, { "2015-16": "6.7" }], "BE": [{ "2014-15": "1.8" }, { "2015-16": "4.1" }, { "2016-17": "3.6" }, { "2017-18": "5.1" }], "RE": [{ "2014-15": "3.1" }, { "2015-16": "5.7" }, { "2016-17": "3.3" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "13.9" }, { "2014-15": "4" }, { "2015-16": "6" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "5.1" }, { "2016-17": "4.7" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "5.7" }, { "2016-17": "5.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "5.6" }, { "2014-15": "6.5" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "5.2" }, { "2016-17": "5.7" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "6.2" }, { "2015-16": "6.4" }, { "2016-17": "4.9" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "12" }, { "2014-15": "10.1" }, { "2015-16": "38.8" }], "BE": [{ "2014-15": "9" }, { "2015-16": "9.5" }, { "2016-17": "21.5" }, { "2017-18": "14.8" }], "RE": [{ "2014-15": "9.7" }, { "2015-16": "36.1" }, { "2016-17": "21.9" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "2.7" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "3" }, { "2015-16": "2.9" }, { "2016-17": "2.7" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "2.5" }, { "2015-16": "4.7" }, { "2016-17": "3.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "11.9" }, { "2014-15": "13.5" }, { "2015-16": "10.3" }], "BE": [{ "2014-15": "10.9" }, { "2015-16": "10.7" }, { "2016-17": "28.9" }, { "2017-18": "20.8" }], "RE": [{ "2014-15": "12.3" }, { "2015-16": "15" }, { "2016-17": "16.5" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "5.6" }, { "2014-15": "7.9" }, { "2015-16": "17.7" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "4.5" }, { "2016-17": "3.6" }, { "2017-18": "7.9" }], "RE": [{ "2014-15": "6.6" }, { "2015-16": "6" }, { "2016-17": "4.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "6" }, { "2014-15": "5.7" }, { "2015-16": "6.7" }], "BE": [{ "2014-15": "5.8" }, { "2015-16": "6" }, { "2016-17": "5.1" }, { "2017-18": "5.8" }], "RE": [{ "2014-15": "5.6" }, { "2015-16": "6.8" }, { "2016-17": "5.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "0.4" }, { "2014-15": "0.1" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "0.2" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.2" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "9.4" }, { "2014-15": "16.5" }, { "2015-16": "8.9" }], "BE": [{ "2014-15": "6.8" }, { "2015-16": "7.4" }, { "2016-17": "12.7" }, { "2017-18": "9.9" }], "RE": [{ "2014-15": "9.3" }, { "2015-16": "9.1" }, { "2016-17": "13.5" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "5.7" }, { "2014-15": "7.1" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "6.5" }, { "2015-16": "4.7" }, { "2016-17": "3.6" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "6.9" }, { "2015-16": "5.9" }, { "2016-17": "7.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "2.7" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "1.4" }, { "2016-17": "1.8" }, { "2017-18": "1" }], "RE": [{ "2014-15": "1.5" }, { "2015-16": "1.4" }, { "2016-17": "1.8" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "6.9" }, { "2014-15": "6.2" }, { "2015-16": "6.8" }], "BE": [{ "2014-15": "5" }, { "2015-16": "4.6" }, { "2016-17": "4.1" }, { "2017-18": "5" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.3" }, { "2016-17": "5.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "4" }, { "2015-16": "3.9" }], "BE": [{ "2014-15": "3.4" }, { "2015-16": "3" }, { "2016-17": "3.1" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "3.4" }, { "2016-17": "3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "1.2" }, { "2015-16": "2" }], "BE": [{ "2014-15": "1.7" }, { "2015-16": "1.5" }, { "2016-17": "3" }, { "2017-18": "1.6" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "2" }, { "2016-17": "3.6" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "7.9" }, { "2014-15": "3.4" }, { "2015-16": "7.5" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "3.8" }, { "2016-17": "0.8" }, { "2017-18": "2.2" }], "RE": [{ "2014-15": "3.3" }, { "2015-16": "0.8" }, { "2016-17": "8.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "11.9" }, { "2014-15": "11.7" }, { "2015-16": "12.8" }], "BE": [{ "2014-15": "11.3" }, { "2015-16": "12.2" }, { "2016-17": "8.3" }, { "2017-18": "6.9" }], "RE": [{ "2014-15": "11.3" }, { "2015-16": "15" }, { "2016-17": "8.6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "4.2" }, { "2014-15": "3.5" }, { "2015-16": "5.6" }], "BE": [{ "2014-15": "3" }, { "2015-16": "5.7" }, { "2016-17": "5.6" }, { "2017-18": "5.6" }], "RE": [{ "2014-15": "3" }, { "2015-16": "5.6" }, { "2016-17": "5.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "3.9" }, { "2014-15": "6.3" }, { "2015-16": "4.6" }], "BE": [{ "2014-15": "4.8" }, { "2015-16": "4.8" }, { "2016-17": "4.7" }, { "2017-18": "6" }], "RE": [{ "2014-15": "4.8" }, { "2015-16": "5.2" }, { "2016-17": "16.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1.5" }, { "2014-15": "1.2" }, { "2015-16": "1.2" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "1.6" }, { "2016-17": "0.7" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "1.1" }, { "2015-16": "1.3" }, { "2016-17": "1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "6.4" }, { "2014-15": "11" }, { "2015-16": "15.9" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "8.2" }, { "2016-17": "9.5" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "10.5" }, { "2015-16": "15.6" }, { "2016-17": "10.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "0.6" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "1.7" }, { "2015-16": "0.6" }, { "2016-17": "1.2" }, { "2017-18": "0.8" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "0.5" }, { "2016-17": "0.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "1.3" }, { "2015-16": "2.3" }], "BE": [{ "2014-15": "1.4" }, { "2015-16": "1.4" }, { "2016-17": "1.4" }, { "2017-18": "1.6" }], "RE": [{ "2014-15": "1.9" }, { "2015-16": "1.6" }, { "2016-17": "2.5" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "1515.8" }, { "2014-15": "" }, { "2015-16": "849" }], "BE": [{ "2014-15": "1428.4" }, { "2015-16": "904" }, { "2016-17": "793.5" }, { "2017-18": "846.1" }], "RE": [{ "2014-15": "1428.5" }, { "2015-16": "958.8" }, { "2016-17": "817.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "283.1" }, { "2014-15": "291.1" }, { "2015-16": "99.9" }], "BE": [{ "2014-15": "325.4" }, { "2015-16": "393.9" }, { "2016-17": "360.7" }, { "2017-18": "403" }], "RE": [{ "2014-15": "406.6" }, { "2015-16": "395.8" }, { "2016-17": "407.1" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "587.1" }, { "2014-15": "807.9" }, { "2015-16": "884.7" }], "BE": [{ "2014-15": "625.9" }, { "2015-16": "821.3" }, { "2016-17": "1382.7" }, { "2017-18": "1037.3" }], "RE": [{ "2014-15": "823" }, { "2015-16": "967.1" }, { "2016-17": "1506.8" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "320.6" }, { "2014-15": "545.1" }, { "2015-16": "1366.9" }], "BE": [{ "2014-15": "391.6" }, { "2015-16": "1043.8" }, { "2016-17": "980.1" }, { "2017-18": "1494.3" }], "RE": [{ "2014-15": "674.4" }, { "2015-16": "1465.7" }, { "2016-17": "888.8" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "2416.8" }, { "2014-15": "617.1" }, { "2015-16": "1027.9" }], "BE": [{ "2014-15": "675.8" }, { "2015-16": "1018.5" }, { "2016-17": "1028.4" }, { "2017-18": "1004.8" }], "RE": [{ "2014-15": "676.3" }, { "2015-16": "1052.2" }, { "2016-17": "1092.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "2247.1" }, { "2014-15": "2864.3" }, { "2015-16": "2579.1" }], "BE": [{ "2014-15": "2399" }, { "2015-16": "2662.9" }, { "2016-17": "2645.2" }, { "2017-18": "2715.3" }], "RE": [{ "2014-15": "2913.6" }, { "2015-16": "3131.1" }, { "2016-17": "2632" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "925.1" }, { "2014-15": "885.3" }, { "2015-16": "3879.5" }], "BE": [{ "2014-15": "874" }, { "2015-16": "1054.6" }, { "2016-17": "2678.3" }, { "2017-18": "1994.1" }], "RE": [{ "2014-15": "974.9" }, { "2015-16": "3943.3" }, { "2016-17": "2591.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "695.4" }, { "2014-15": "1205.5" }, { "2015-16": "1980" }], "BE": [{ "2014-15": "1020.9" }, { "2015-16": "1178.7" }, { "2016-17": "1244.5" }, { "2017-18": "1270.9" }], "RE": [{ "2014-15": "1080.3" }, { "2015-16": "1783.9" }, { "2016-17": "1527.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "3261.4" }, { "2014-15": "3976.4" }, { "2015-16": "5440.8" }], "BE": [{ "2014-15": "3918.6" }, { "2015-16": "4056.6" }, { "2016-17": "10663.2" }, { "2017-18": "13155.5" }], "RE": [{ "2014-15": "4357.8" }, { "2015-16": "6327.4" }, { "2016-17": "8151.1" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "529.5" }, { "2014-15": "959.6" }, { "2015-16": "2895.1" }], "BE": [{ "2014-15": "570.3" }, { "2015-16": "756.5" }, { "2016-17": "676.6" }, { "2017-18": "1760.2" }], "RE": [{ "2014-15": "1029.9" }, { "2015-16": "1019.9" }, { "2016-17": "944.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1052.8" }, { "2014-15": "1152.1" }, { "2015-16": "1497.2" }], "BE": [{ "2014-15": "1248.3" }, { "2015-16": "1321.4" }, { "2016-17": "1271.7" }, { "2017-18": "1631.5" }], "RE": [{ "2014-15": "1165" }, { "2015-16": "1524.5" }, { "2016-17": "1273.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "69.3" }, { "2014-15": "30" }, { "2015-16": "23.6" }], "BE": [{ "2014-15": "46.7" }, { "2015-16": "50.7" }, { "2016-17": "56.3" }, { "2017-18": "52.1" }], "RE": [{ "2014-15": "55" }, { "2015-16": "44.7" }, { "2016-17": "46" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1080" }, { "2014-15": "2333.4" }, { "2015-16": "1385" }], "BE": [{ "2014-15": "1060" }, { "2015-16": "1266.3" }, { "2016-17": "2582.9" }, { "2017-18": "2140.2" }], "RE": [{ "2014-15": "1460.4" }, { "2015-16": "1576.8" }, { "2016-17": "2718" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "928.2" }, { "2014-15": "1320" }, { "2015-16": "1178.3" }], "BE": [{ "2014-15": "1247.1" }, { "2015-16": "954.5" }, { "2016-17": "819.5" }, { "2017-18": "935" }], "RE": [{ "2014-15": "1353.2" }, { "2015-16": "1229" }, { "2016-17": "1673.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "684.3" }, { "2014-15": "765.2" }, { "2015-16": "429.2" }], "BE": [{ "2014-15": "654.4" }, { "2015-16": "511.8" }, { "2016-17": "710.5" }, { "2017-18": "483.2" }], "RE": [{ "2014-15": "654.4" }, { "2015-16": "511.8" }, { "2016-17": "710.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3719.5" }, { "2014-15": "4621.3" }, { "2015-16": "4083.6" }], "BE": [{ "2014-15": "3233.3" }, { "2015-16": "3365.3" }, { "2016-17": "3024.1" }, { "2017-18": "3949.5" }], "RE": [{ "2014-15": "4693.9" }, { "2015-16": "4203.9" }, { "2016-17": "5030.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1647.9" }, { "2014-15": "1740.8" }, { "2015-16": "1868.9" }], "BE": [{ "2014-15": "1805.9" }, { "2015-16": "1586.3" }, { "2016-17": "1758.5" }, { "2017-18": "1891.8" }], "RE": [{ "2014-15": "1802.6" }, { "2015-16": "1839.8" }, { "2016-17": "1988.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "286.5" }, { "2014-15": "190.2" }, { "2015-16": "382" }], "BE": [{ "2014-15": "322.2" }, { "2015-16": "294.2" }, { "2016-17": "673.8" }, { "2017-18": "411.6" }], "RE": [{ "2014-15": "226.5" }, { "2015-16": "392.7" }, { "2016-17": "785.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1702.7" }, { "2014-15": "876.8" }, { "2015-16": "2118.2" }], "BE": [{ "2014-15": "280" }, { "2015-16": "1037" }, { "2016-17": "228.3" }, { "2017-18": "900.7" }], "RE": [{ "2014-15": "876.8" }, { "2015-16": "230.8" }, { "2016-17": "4441.8" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "1597.4" }, { "2014-15": "1917.4" }, { "2015-16": "2299.3" }], "BE": [{ "2014-15": "2093" }, { "2015-16": "2341.6" }, { "2016-17": "1716.7" }, { "2017-18": "1546.6" }], "RE": [{ "2014-15": "2009.7" }, { "2015-16": "2863.2" }, { "2016-17": "1760.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2967.7" }, { "2014-15": "2650.2" }, { "2015-16": "3964" }], "BE": [{ "2014-15": "3114.7" }, { "2015-16": "4887.9" }, { "2016-17": "5006.9" }, { "2017-18": "5342.4" }], "RE": [{ "2014-15": "3203.5" }, { "2015-16": "4922.6" }, { "2016-17": "5140.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "737.5" }, { "2014-15": "1439.7" }, { "2015-16": "1129.9" }], "BE": [{ "2014-15": "1076.8" }, { "2015-16": "1221.6" }, { "2016-17": "1332.8" }, { "2017-18": "1858.1" }], "RE": [{ "2014-15": "1125.1" }, { "2015-16": "1338.9" }, { "2016-17": "5055.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "306.9" }, { "2014-15": "333.5" }, { "2015-16": "357.1" }], "BE": [{ "2014-15": "313.9" }, { "2015-16": "644" }, { "2016-17": "298.1" }, { "2017-18": "293.8" }], "RE": [{ "2014-15": "379.3" }, { "2015-16": "432.7" }, { "2016-17": "392.4" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "618.1" }, { "2014-15": "1228.6" }, { "2015-16": "2246.2" }], "BE": [{ "2014-15": "1090.8" }, { "2015-16": "1150.6" }, { "2016-17": "1505.6" }, { "2017-18": "800.2" }], "RE": [{ "2014-15": "1305" }, { "2015-16": "2408" }, { "2016-17": "1586.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "293.9" }, { "2014-15": "145.7" }, { "2015-16": "118.2" }], "BE": [{ "2014-15": "501.4" }, { "2015-16": "191.8" }, { "2016-17": "445.2" }, { "2017-18": "294.4" }], "RE": [{ "2014-15": "395.2" }, { "2015-16": "167.4" }, { "2016-17": "186" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "225.4" }, { "2014-15": "180.7" }, { "2015-16": "354.9" }], "BE": [{ "2014-15": "202.7" }, { "2015-16": "214" }, { "2016-17": "237" }, { "2017-18": "309.8" }], "RE": [{ "2014-15": "267.9" }, { "2015-16": "244.2" }, { "2016-17": "440.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "97.1" }, { "2014-15": "" }, { "2015-16": "91.3" }], "BE": [{ "2014-15": "98.9" }, { "2015-16": "94.5" }, { "2016-17": "93.6" }, { "2017-18": "87.3" }], "RE": [{ "2014-15": "98.9" }, { "2015-16": "93.5" }, { "2016-17": "92.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "20.8" }, { "2014-15": "80.8" }, { "2015-16": "3" }], "BE": [{ "2014-15": "2.7" }, { "2015-16": "62" }, { "2016-17": "19.7" }, { "2017-18": "45.9" }], "RE": [{ "2014-15": "11.6" }, { "2015-16": "62.1" }, { "2016-17": "28.8" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "55.4" }, { "2014-15": "46.1" }, { "2015-16": "67.7" }], "BE": [{ "2014-15": "48.8" }, { "2015-16": "50.9" }, { "2016-17": "37.2" }, { "2017-18": "46.7" }], "RE": [{ "2014-15": "37.2" }, { "2015-16": "62.3" }, { "2016-17": "49.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "97.2" }, { "2014-15": "80.6" }, { "2015-16": "90.3" }], "BE": [{ "2014-15": "77.4" }, { "2015-16": "89.3" }, { "2016-17": "58.4" }, { "2017-18": "79.8" }], "RE": [{ "2014-15": "72.2" }, { "2015-16": "90.9" }, { "2016-17": "57.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "22.7" }, { "2014-15": "69.3" }, { "2015-16": "77.2" }], "BE": [{ "2014-15": "65.4" }, { "2015-16": "80.9" }, { "2016-17": "86" }, { "2017-18": "75.4" }], "RE": [{ "2014-15": "68.2" }, { "2015-16": "77.2" }, { "2016-17": "77.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "61.3" }, { "2014-15": "70.3" }, { "2015-16": "63.9" }], "BE": [{ "2014-15": "65.3" }, { "2015-16": "66.2" }, { "2016-17": "68.7" }, { "2017-18": "64.1" }], "RE": [{ "2014-15": "69.2" }, { "2015-16": "70.1" }, { "2016-17": "70" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "93" }, { "2014-15": "96.6" }, { "2015-16": "42.4" }], "BE": [{ "2014-15": "84.1" }, { "2015-16": "86.3" }, { "2016-17": "63.7" }, { "2017-18": "80.7" }], "RE": [{ "2014-15": "89.5" }, { "2015-16": "42.3" }, { "2016-17": "64.8" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "46.8" }, { "2015-16": "69.7" }], "BE": [{ "2014-15": "47.3" }, { "2015-16": "53.6" }, { "2016-17": "53.9" }, { "2017-18": "54.9" }], "RE": [{ "2014-15": "52.2" }, { "2015-16": "77.4" }, { "2016-17": "75.7" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "91.9" }, { "2015-16": "92.3" }, { "2016-17": "78.3" }, { "2017-18": "62.2" }], "RE": [{ "2014-15": "92.6" }, { "2015-16": "87.1" }, { "2016-17": "86.3" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "89.8" }, { "2014-15": "75.2" }, { "2015-16": "23.3" }], "BE": [{ "2014-15": "68.2" }, { "2015-16": "56.3" }, { "2016-17": "32.2" }, { "2017-18": "69.3" }], "RE": [{ "2014-15": "70.6" }, { "2015-16": "67" }, { "2016-17": "51.4" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "93.9" }, { "2014-15": "95.6" }, { "2015-16": "99.2" }], "BE": [{ "2014-15": "88.2" }, { "2015-16": "99.1" }, { "2016-17": "98.3" }, { "2017-18": "91.9" }], "RE": [{ "2014-15": "94.6" }, { "2015-16": "90.5" }, { "2016-17": "98.3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "98.6" }, { "2014-15": "99.2" }, { "2015-16": "89.5" }], "BE": [{ "2014-15": "77.1" }, { "2015-16": "73.8" }, { "2016-17": "69.2" }, { "2017-18": "77.5" }], "RE": [{ "2014-15": "86.2" }, { "2015-16": "69.5" }, { "2016-17": "75.3" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "38.6" }, { "2014-15": "28.5" }, { "2015-16": "74" }], "BE": [{ "2014-15": "49.1" }, { "2015-16": "59.2" }, { "2016-17": "42.4" }, { "2017-18": "56.5" }], "RE": [{ "2014-15": "48.3" }, { "2015-16": "70.9" }, { "2016-17": "64" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "77.7" }, { "2014-15": "89.3" }, { "2015-16": "89.6" }], "BE": [{ "2014-15": "87.1" }, { "2015-16": "91.7" }, { "2016-17": "88.8" }, { "2017-18": "88.9" }], "RE": [{ "2014-15": "89.6" }, { "2015-16": "89" }, { "2016-17": "69.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "85.8" }, { "2014-15": "81.2" }, { "2015-16": "61" }], "BE": [{ "2014-15": "73.2" }, { "2015-16": "93.2" }, { "2016-17": "93.9" }, { "2017-18": "76.2" }], "RE": [{ "2014-15": "73.2" }, { "2015-16": "93.2" }, { "2016-17": "93.9" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "82.9" }, { "2014-15": "70.5" }, { "2015-16": "84.3" }], "BE": [{ "2014-15": "85.7" }, { "2015-16": "87.8" }, { "2016-17": "99.8" }, { "2017-18": "89.5" }], "RE": [{ "2014-15": "70.8" }, { "2015-16": "84.8" }, { "2016-17": "90.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "79.1" }, { "2014-15": "86.2" }, { "2015-16": "85.7" }], "BE": [{ "2014-15": "77.5" }, { "2015-16": "98.1" }, { "2016-17": "97.1" }, { "2017-18": "97" }], "RE": [{ "2014-15": "84.2" }, { "2015-16": "91.3" }, { "2016-17": "93.6" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "4.6" }, { "2014-15": "8.6" }, { "2015-16": "5.7" }], "BE": [{ "2014-15": "7.1" }, { "2015-16": "6.7" }, { "2016-17": "3.2" }, { "2017-18": "8.2" }], "RE": [{ "2014-15": "10" }, { "2015-16": "4.5" }, { "2016-17": "4.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "8.4" }], "BE": [{ "2014-15": "100" }, { "2015-16": "99.8" }, { "2016-17": "98.6" }, { "2017-18": "98.1" }], "RE": [{ "2014-15": "100" }, { "2015-16": "98.4" }, { "2016-17": "22.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "64.6" }, { "2014-15": "67" }, { "2015-16": "66.6" }], "BE": [{ "2014-15": "70.3" }, { "2015-16": "60.3" }, { "2016-17": "70.9" }, { "2017-18": "87" }], "RE": [{ "2014-15": "64.7" }, { "2015-16": "54.1" }, { "2016-17": "72.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "64.9" }, { "2014-15": "81.3" }, { "2015-16": "85.2" }], "BE": [{ "2014-15": "68" }, { "2015-16": "71.4" }, { "2016-17": "69.5" }, { "2017-18": "66" }], "RE": [{ "2014-15": "66.1" }, { "2015-16": "69" }, { "2016-17": "66.8" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "37.4" }, { "2014-15": "35.5" }, { "2015-16": "50.3" }], "BE": [{ "2014-15": "58.5" }, { "2015-16": "51.1" }, { "2016-17": "77.9" }, { "2017-18": "71.1" }], "RE": [{ "2014-15": "45.5" }, { "2015-16": "60.5" }, { "2016-17": "18.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "45.5" }, { "2014-15": "72.9" }, { "2015-16": "54.1" }], "BE": [{ "2014-15": "54.5" }, { "2015-16": "44.1" }, { "2016-17": "80.2" }, { "2017-18": "69.2" }], "RE": [{ "2014-15": "65.8" }, { "2015-16": "62.8" }, { "2016-17": "47.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "52.5" }, { "2014-15": "54.5" }, { "2015-16": "49.3" }], "BE": [{ "2014-15": "51.7" }, { "2015-16": "45.6" }, { "2016-17": "56.2" }, { "2017-18": "66.5" }], "RE": [{ "2014-15": "51.3" }, { "2015-16": "47.9" }, { "2016-17": "55.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "3.4" }, { "2015-16": "14.3" }], "BE": [{ "2014-15": "5.2" }, { "2015-16": "3" }, { "2016-17": "3.2" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "6.5" }, { "2015-16": "13.1" }, { "2016-17": "8.3" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "51.9" }, { "2014-15": "23.5" }, { "2015-16": "33.4" }], "BE": [{ "2014-15": "38.7" }, { "2015-16": "38.1" }, { "2016-17": "35.7" }, { "2017-18": "25.6" }], "RE": [{ "2014-15": "33.3" }, { "2015-16": "51.3" }, { "2016-17": "66.6" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "2.9" }, { "2014-15": "" }, { "2015-16": "8.7" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "5.5" }, { "2016-17": "6.4" }, { "2017-18": "12.7" }], "RE": [{ "2014-15": "1.1" }, { "2015-16": "6.5" }, { "2016-17": "7.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "79.2" }, { "2014-15": "19.2" }, { "2015-16": "97" }], "BE": [{ "2014-15": "97.3" }, { "2015-16": "38" }, { "2016-17": "80.3" }, { "2017-18": "54.1" }], "RE": [{ "2014-15": "88.4" }, { "2015-16": "37.9" }, { "2016-17": "71.2" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "44.6" }, { "2014-15": "53.9" }, { "2015-16": "32.3" }], "BE": [{ "2014-15": "51.2" }, { "2015-16": "49.1" }, { "2016-17": "62.8" }, { "2017-18": "53.3" }], "RE": [{ "2014-15": "62.8" }, { "2015-16": "37.7" }, { "2016-17": "50.8" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "19.4" }, { "2015-16": "9.7" }], "BE": [{ "2014-15": "22.6" }, { "2015-16": "10.7" }, { "2016-17": "41.6" }, { "2017-18": "20.2" }], "RE": [{ "2014-15": "27.8" }, { "2015-16": "9.1" }, { "2016-17": "42.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "77.3" }, { "2014-15": "30.7" }, { "2015-16": "22.8" }], "BE": [{ "2014-15": "34.6" }, { "2015-16": "19.1" }, { "2016-17": "14" }, { "2017-18": "24.6" }], "RE": [{ "2014-15": "31.8" }, { "2015-16": "22.8" }, { "2016-17": "22.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "38.7" }, { "2014-15": "29.7" }, { "2015-16": "36.1" }], "BE": [{ "2014-15": "34.7" }, { "2015-16": "33.8" }, { "2016-17": "31.3" }, { "2017-18": "35.9" }], "RE": [{ "2014-15": "30.8" }, { "2015-16": "29.9" }, { "2016-17": "30" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "7" }, { "2014-15": "3.4" }, { "2015-16": "57.6" }], "BE": [{ "2014-15": "15.9" }, { "2015-16": "13.7" }, { "2016-17": "36.3" }, { "2017-18": "19.3" }], "RE": [{ "2014-15": "10.5" }, { "2015-16": "57.7" }, { "2016-17": "35.2" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "98.6" }, { "2014-15": "53.2" }, { "2015-16": "30.3" }], "BE": [{ "2014-15": "52.7" }, { "2015-16": "46.4" }, { "2016-17": "46.1" }, { "2017-18": "45.1" }], "RE": [{ "2014-15": "47.8" }, { "2015-16": "22.6" }, { "2016-17": "24.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "8.1" }, { "2015-16": "7.7" }, { "2016-17": "21.7" }, { "2017-18": "37.8" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "12.9" }, { "2016-17": "13.7" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "10.2" }, { "2014-15": "24.8" }, { "2015-16": "76.7" }], "BE": [{ "2014-15": "31.8" }, { "2015-16": "43.7" }, { "2016-17": "67.8" }, { "2017-18": "30.7" }], "RE": [{ "2014-15": "29.4" }, { "2015-16": "33" }, { "2016-17": "48.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "6.1" }, { "2014-15": "4.4" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "11.8" }, { "2015-16": "0.9" }, { "2016-17": "1.7" }, { "2017-18": "8.1" }], "RE": [{ "2014-15": "5.4" }, { "2015-16": "9.5" }, { "2016-17": "1.7" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "0.8" }, { "2015-16": "10.5" }], "BE": [{ "2014-15": "22.9" }, { "2015-16": "26.2" }, { "2016-17": "30.8" }, { "2017-18": "22.5" }], "RE": [{ "2014-15": "13.8" }, { "2015-16": "30.5" }, { "2016-17": "24.7" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "61.4" }, { "2014-15": "71.5" }, { "2015-16": "26" }], "BE": [{ "2014-15": "50.9" }, { "2015-16": "40.8" }, { "2016-17": "57.6" }, { "2017-18": "43.5" }], "RE": [{ "2014-15": "51.7" }, { "2015-16": "29.1" }, { "2016-17": "36" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "22.3" }, { "2014-15": "10.7" }, { "2015-16": "10.4" }], "BE": [{ "2014-15": "12.9" }, { "2015-16": "8.3" }, { "2016-17": "11.2" }, { "2017-18": "11.1" }], "RE": [{ "2014-15": "10.4" }, { "2015-16": "11" }, { "2016-17": "30.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "14.2" }, { "2014-15": "18.8" }, { "2015-16": "39" }], "BE": [{ "2014-15": "26.8" }, { "2015-16": "6.8" }, { "2016-17": "6.1" }, { "2017-18": "23.8" }], "RE": [{ "2014-15": "26.8" }, { "2015-16": "6.8" }, { "2016-17": "6.1" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "17.1" }, { "2014-15": "29.5" }, { "2015-16": "15.7" }], "BE": [{ "2014-15": "14.3" }, { "2015-16": "12.2" }, { "2016-17": "0.2" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "29.2" }, { "2015-16": "15.2" }, { "2016-17": "9.3" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "20.9" }, { "2014-15": "13.8" }, { "2015-16": "14.3" }], "BE": [{ "2014-15": "22.5" }, { "2015-16": "1.9" }, { "2016-17": "2.9" }, { "2017-18": "3" }], "RE": [{ "2014-15": "15.8" }, { "2015-16": "8.7" }, { "2016-17": "6.4" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "95.4" }, { "2014-15": "91.4" }, { "2015-16": "94.3" }], "BE": [{ "2014-15": "92.9" }, { "2015-16": "93.3" }, { "2016-17": "96.8" }, { "2017-18": "91.8" }], "RE": [{ "2014-15": "90" }, { "2015-16": "95.5" }, { "2016-17": "95.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "91.6" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0.2" }, { "2016-17": "1.4" }, { "2017-18": "1.9" }], "RE": [{ "2014-15": "0" }, { "2015-16": "1.6" }, { "2016-17": "77.6" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "35.4" }, { "2014-15": "33" }, { "2015-16": "33.4" }], "BE": [{ "2014-15": "29.7" }, { "2015-16": "39.7" }, { "2016-17": "29.1" }, { "2017-18": "13" }], "RE": [{ "2014-15": "35.3" }, { "2015-16": "45.9" }, { "2016-17": "27.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "35.1" }, { "2014-15": "18.7" }, { "2015-16": "14.8" }], "BE": [{ "2014-15": "32" }, { "2015-16": "28.6" }, { "2016-17": "30.5" }, { "2017-18": "34" }], "RE": [{ "2014-15": "33.9" }, { "2015-16": "31" }, { "2016-17": "33.2" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "62.6" }, { "2014-15": "64.5" }, { "2015-16": "49.7" }], "BE": [{ "2014-15": "41.5" }, { "2015-16": "48.9" }, { "2016-17": "22.1" }, { "2017-18": "28.9" }], "RE": [{ "2014-15": "54.5" }, { "2015-16": "39.5" }, { "2016-17": "81.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "54.5" }, { "2014-15": "27.1" }, { "2015-16": "45.9" }], "BE": [{ "2014-15": "45.5" }, { "2015-16": "55.9" }, { "2016-17": "19.8" }, { "2017-18": "30.8" }], "RE": [{ "2014-15": "34.2" }, { "2015-16": "37.2" }, { "2016-17": "52.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "47.5" }, { "2014-15": "45.5" }, { "2015-16": "50.7" }], "BE": [{ "2014-15": "48.3" }, { "2015-16": "54.4" }, { "2016-17": "43.8" }, { "2017-18": "33.5" }], "RE": [{ "2014-15": "48.7" }, { "2015-16": "52.1" }, { "2016-17": "44.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "97.9" }, { "2014-15": "96.6" }, { "2015-16": "85.7" }], "BE": [{ "2014-15": "94.8" }, { "2015-16": "97" }, { "2016-17": "96.8" }, { "2017-18": "96.9" }], "RE": [{ "2014-15": "93.5" }, { "2015-16": "86.9" }, { "2016-17": "91.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "48.1" }, { "2014-15": "76.5" }, { "2015-16": "66.6" }], "BE": [{ "2014-15": "61.3" }, { "2015-16": "61.9" }, { "2016-17": "64.3" }, { "2017-18": "74.4" }], "RE": [{ "2014-15": "66.7" }, { "2015-16": "48.7" }, { "2016-17": "33.4" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Power & Energy" }, { "category_slug": "public_works", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "4664.2" }, { "2014-15": "" }, { "2015-16": "3497.5" }], "BE": [{ "2014-15": "2572.5" }, { "2015-16": "2674.3" }, { "2016-17": "3158.1" }, { "2017-18": "3630.7" }], "RE": [{ "2014-15": "2569.3" }, { "2015-16": "2883.7" }, { "2016-17": "3067.7" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "2266.4" }, { "2014-15": "2708.6" }, { "2015-16": "2115.5" }], "BE": [{ "2014-15": "3361.2" }, { "2015-16": "4001.2" }, { "2016-17": "4636.6" }, { "2017-18": "4579.3" }], "RE": [{ "2014-15": "4685" }, { "2015-16": "4540.4" }, { "2016-17": "5352.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "6177.2" }, { "2014-15": "6560.4" }, { "2015-16": "7413.4" }], "BE": [{ "2014-15": "7564" }, { "2015-16": "8844.7" }, { "2016-17": "9779.2" }, { "2017-18": "10643.2" }], "RE": [{ "2014-15": "9817.5" }, { "2015-16": "9092.2" }, { "2016-17": "9964" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2822" }, { "2014-15": "2963.4" }, { "2015-16": "3522.9" }], "BE": [{ "2014-15": "3631.5" }, { "2015-16": "5183.3" }, { "2016-17": "6804.5" }, { "2017-18": "7720" }], "RE": [{ "2014-15": "3532.4" }, { "2015-16": "4495.1" }, { "2016-17": "5384.3" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "3766.9" }, { "2014-15": "4000.7" }, { "2015-16": "3699.3" }], "BE": [{ "2014-15": "4163.4" }, { "2015-16": "5269.9" }, { "2016-17": "5398.6" }, { "2017-18": "4698.9" }], "RE": [{ "2014-15": "4145.8" }, { "2015-16": "4210.5" }, { "2016-17": "4441.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "8544.9" }, { "2014-15": "9122.1" }, { "2015-16": "8761.9" }], "BE": [{ "2014-15": "10481.9" }, { "2015-16": "10506.1" }, { "2016-17": "10672.3" }, { "2017-18": "10916.2" }], "RE": [{ "2014-15": "9853.2" }, { "2015-16": "9329.4" }, { "2016-17": "9535.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2932.6" }, { "2014-15": "2601.2" }, { "2015-16": "3174.4" }], "BE": [{ "2014-15": "2889.6" }, { "2015-16": "3136.9" }, { "2016-17": "4325.9" }, { "2017-18": "3677.8" }], "RE": [{ "2014-15": "3039.3" }, { "2015-16": "3443.9" }, { "2016-17": "3046.8" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2799" }, { "2014-15": "3073.4" }, { "2015-16": "3482.7" }], "BE": [{ "2014-15": "2960.7" }, { "2015-16": "3337" }, { "2016-17": "3670.2" }, { "2017-18": "3901.2" }], "RE": [{ "2014-15": "2820.6" }, { "2015-16": "3212.3" }, { "2016-17": "4110.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "692.3" }, { "2014-15": "612.4" }, { "2015-16": "2181.2" }], "BE": [{ "2014-15": "1816.6" }, { "2015-16": "2298.1" }, { "2016-17": "2539.1" }, { "2017-18": "2763.5" }], "RE": [{ "2014-15": "2191.7" }, { "2015-16": "2660.2" }, { "2016-17": "2547.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2304.3" }, { "2014-15": "2964.8" }, { "2015-16": "4145" }], "BE": [{ "2014-15": "3076.1" }, { "2015-16": "3601.4" }, { "2016-17": "4871" }, { "2017-18": "6104.2" }], "RE": [{ "2014-15": "3116.1" }, { "2015-16": "4009.5" }, { "2016-17": "4865.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "8221.3" }, { "2014-15": "7329.2" }, { "2015-16": "7568.8" }], "BE": [{ "2014-15": "7588" }, { "2015-16": "5962.8" }, { "2016-17": "6424.6" }, { "2017-18": "8042.3" }], "RE": [{ "2014-15": "8128.7" }, { "2015-16": "7692" }, { "2016-17": "7236" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "3645.2" }, { "2014-15": "3786.5" }, { "2015-16": "5588.5" }], "BE": [{ "2014-15": "3653.6" }, { "2015-16": "4805.1" }, { "2016-17": "4795.7" }, { "2017-18": "5204.7" }], "RE": [{ "2014-15": "3932.6" }, { "2015-16": "5410.7" }, { "2016-17": "5111.4" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "4160" }, { "2014-15": "4537.7" }, { "2015-16": "5168.4" }], "BE": [{ "2014-15": "4278.6" }, { "2015-16": "5967.8" }, { "2016-17": "7219.1" }, { "2017-18": "8331.7" }], "RE": [{ "2014-15": "4886.7" }, { "2015-16": "6032.4" }, { "2016-17": "7332.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "9453.4" }, { "2014-15": "9274.8" }, { "2015-16": "10325.3" }], "BE": [{ "2014-15": "8220.2" }, { "2015-16": "8699.3" }, { "2016-17": "10175.9" }, { "2017-18": "14502.6" }], "RE": [{ "2014-15": "10132.7" }, { "2015-16": "11077.6" }, { "2016-17": "11276.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "366" }, { "2014-15": "564.5" }, { "2015-16": "1052.5" }], "BE": [{ "2014-15": "1007.3" }, { "2015-16": "1023.3" }, { "2016-17": "1005.1" }, { "2017-18": "1196.2" }], "RE": [{ "2014-15": "853.3" }, { "2015-16": "1030.9" }, { "2016-17": "1005.1" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "310.9" }, { "2014-15": "469.5" }, { "2015-16": "433.4" }], "BE": [{ "2014-15": "461.2" }, { "2015-16": "467.4" }, { "2016-17": "486" }, { "2017-18": "816" }], "RE": [{ "2014-15": "572.2" }, { "2015-16": "529.4" }, { "2016-17": "728.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "824.5" }, { "2014-15": "789.3" }, { "2015-16": "921.8" }], "BE": [{ "2014-15": "1619.9" }, { "2015-16": "911.7" }, { "2016-17": "977.1" }, { "2017-18": "815" }], "RE": [{ "2014-15": "907" }, { "2015-16": "806.5" }, { "2016-17": "845.6" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2718.6" }, { "2014-15": "3776.9" }, { "2015-16": "5305.3" }], "BE": [{ "2014-15": "3736.4" }, { "2015-16": "4145.1" }, { "2016-17": "4524.4" }, { "2017-18": "4964.3" }], "RE": [{ "2014-15": "3783.7" }, { "2015-16": "5218.9" }, { "2016-17": "4600.5" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1763.6" }, { "2014-15": "2306.5" }, { "2015-16": "2294.7" }], "BE": [{ "2014-15": "3110.1" }, { "2015-16": "2955.5" }, { "2016-17": "2558.3" }, { "2017-18": "2895.6" }], "RE": [{ "2014-15": "2606.3" }, { "2015-16": "2730.5" }, { "2016-17": "3263.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "3898.2" }, { "2014-15": "4759.9" }, { "2015-16": "4802" }], "BE": [{ "2014-15": "5981.5" }, { "2015-16": "5378.2" }, { "2016-17": "6259.3" }, { "2017-18": "7256.4" }], "RE": [{ "2014-15": "5866.7" }, { "2015-16": "4981.7" }, { "2016-17": "4618.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "274.3" }, { "2014-15": "239.7" }, { "2015-16": "264.2" }], "BE": [{ "2014-15": "349.5" }, { "2015-16": "297.1" }, { "2016-17": "233.7" }, { "2017-18": "335.8" }], "RE": [{ "2014-15": "360.1" }, { "2015-16": "368" }, { "2016-17": "381" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "932.1" }, { "2014-15": "1077.5" }, { "2015-16": "1127.2" }], "BE": [{ "2014-15": "1129.4" }, { "2015-16": "939.9" }, { "2016-17": "1020.2" }, { "2017-18": "1246.6" }], "RE": [{ "2014-15": "1029" }, { "2015-16": "978.5" }, { "2016-17": "1023.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1146.8" }, { "2014-15": "1465.8" }, { "2015-16": "1132.1" }], "BE": [{ "2014-15": "1740.6" }, { "2015-16": "1785.5" }, { "2016-17": "1250" }, { "2017-18": "1471.8" }], "RE": [{ "2014-15": "1779.3" }, { "2015-16": "1766.5" }, { "2016-17": "1443.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "16239.9" }, { "2014-15": "20045.2" }, { "2015-16": "18764" }], "BE": [{ "2014-15": "15939.7" }, { "2015-16": "16717" }, { "2016-17": "20019.9" }, { "2017-18": "19578.7" }], "RE": [{ "2014-15": "16703.9" }, { "2015-16": "17068.4" }, { "2016-17": "22514.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1450.1" }, { "2014-15": "1948.3" }, { "2015-16": "1861.7" }], "BE": [{ "2014-15": "1410.1" }, { "2015-16": "1549.5" }, { "2016-17": "2313.6" }, { "2017-18": "1943.6" }], "RE": [{ "2014-15": "2123.1" }, { "2015-16": "1905.2" }, { "2016-17": "2055.3" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "3247.3" }, { "2014-15": "3752.2" }, { "2015-16": "4809.4" }], "BE": [{ "2014-15": "4439.9" }, { "2015-16": "4973.7" }, { "2016-17": "5020.7" }, { "2017-18": "5248" }], "RE": [{ "2014-15": "4608.9" }, { "2015-16": "6489" }, { "2016-17": "5093.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "" }, { "2015-16": "2.3" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.4" }, { "2016-17": "2.3" }, { "2017-18": "2.3" }], "RE": [{ "2014-15": "2.3" }, { "2015-16": "2.6" }, { "2016-17": "2.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "6.1" }, { "2014-15": "5.8" }, { "2015-16": "5" }], "BE": [{ "2014-15": "5.2" }, { "2015-16": "6" }, { "2016-17": "5.9" }, { "2017-18": "5.3" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "6.1" }, { "2016-17": "6.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "7.7" }, { "2014-15": "6.9" }, { "2015-16": "6.6" }], "BE": [{ "2014-15": "6.5" }, { "2015-16": "7.3" }, { "2016-17": "6.8" }, { "2017-18": "6.6" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "6.8" }, { "2016-17": "6.5" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "7.3" }, { "2014-15": "6.4" }, { "2015-16": "6.8" }], "BE": [{ "2014-15": "6.6" }, { "2015-16": "8" }, { "2016-17": "9.7" }, { "2017-18": "10.2" }], "RE": [{ "2014-15": "6.4" }, { "2015-16": "6.8" }, { "2016-17": "7.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "11.1" }, { "2014-15": "12.9" }, { "2015-16": "10.5" }], "BE": [{ "2014-15": "11.3" }, { "2015-16": "12.8" }, { "2016-17": "11.6" }, { "2017-18": "9.8" }], "RE": [{ "2014-15": "11.9" }, { "2015-16": "11.1" }, { "2016-17": "10.8" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "8.2" }, { "2014-15": "7.8" }, { "2015-16": "5.8" }], "BE": [{ "2014-15": "8" }, { "2015-16": "7.6" }, { "2016-17": "8.4" }, { "2017-18": "6.4" }], "RE": [{ "2014-15": "7.9" }, { "2015-16": "7" }, { "2016-17": "6.5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "6.3" }, { "2014-15": "4.8" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "4.5" }, { "2016-17": "5.5" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "5.1" }, { "2016-17": "4.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "13.1" }, { "2014-15": "9.9" }, { "2015-16": "11.8" }], "BE": [{ "2014-15": "12.5" }, { "2015-16": "11.8" }, { "2016-17": "11.3" }, { "2017-18": "10.9" }], "RE": [{ "2014-15": "9.5" }, { "2015-16": "11.9" }, { "2016-17": "11.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "1.7" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "4.9" }, { "2016-17": "5.5" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "5.1" }, { "2015-16": "5.1" }, { "2016-17": "4.1" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "7.6" }, { "2014-15": "7.4" }, { "2015-16": "7.6" }], "BE": [{ "2014-15": "6.1" }, { "2015-16": "6.5" }, { "2016-17": "7.7" }, { "2017-18": "8.1" }], "RE": [{ "2014-15": "6.1" }, { "2015-16": "7.1" }, { "2016-17": "7.3" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "7.7" }, { "2014-15": "5.9" }, { "2015-16": "5.5" }], "BE": [{ "2014-15": "5.8" }, { "2015-16": "4.4" }, { "2016-17": "4.1" }, { "2017-18": "4.5" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.5" }, { "2016-17": "4.6" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "4.9" }, { "2015-16": "6.4" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "5" }, { "2016-17": "4.4" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "6.1" }, { "2016-17": "4.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "4.9" }, { "2014-15": "4.2" }, { "2015-16": "4.3" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "4.5" }, { "2016-17": "4.5" }, { "2017-18": "4.9" }], "RE": [{ "2014-15": "4.1" }, { "2015-16": "4.5" }, { "2016-17": "4.7" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "5" }, { "2014-15": "4.3" }, { "2015-16": "4.6" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "3.6" }, { "2016-17": "3.8" }, { "2017-18": "4.8" }], "RE": [{ "2014-15": "4.4" }, { "2015-16": "4.5" }, { "2016-17": "4" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "5.3" }, { "2014-15": "7.4" }, { "2015-16": "13.2" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "10.5" }, { "2016-17": "9.4" }, { "2017-18": "9.2" }], "RE": [{ "2014-15": "7.2" }, { "2015-16": "10.6" }, { "2016-17": "9.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "5.6" }, { "2014-15": "6" }, { "2015-16": "6.9" }], "BE": [{ "2014-15": "6.8" }, { "2015-16": "6" }, { "2016-17": "6.1" }, { "2017-18": "9.6" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "6.4" }, { "2016-17": "7.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "9.8" }, { "2014-15": "7.8" }, { "2015-16": "8.1" }], "BE": [{ "2014-15": "13" }, { "2015-16": "7.2" }, { "2016-17": "7.2" }, { "2017-18": "5" }], "RE": [{ "2014-15": "8.1" }, { "2015-16": "6.4" }, { "2016-17": "5.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "4.8" }, { "2014-15": "5.7" }, { "2015-16": "6.7" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "4.9" }, { "2016-17": "4.8" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "6.2" }, { "2016-17": "4.9" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2.9" }, { "2014-15": "3.2" }, { "2015-16": "2.8" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "3.7" }, { "2016-17": "3" }, { "2017-18": "2.4" }], "RE": [{ "2014-15": "3.5" }, { "2015-16": "3.5" }, { "2016-17": "2.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "4.1" }, { "2015-16": "3.7" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "3.9" }, { "2016-17": "4.1" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4.7" }, { "2015-16": "3.6" }, { "2016-17": "3.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "6.1" }, { "2014-15": "5" }, { "2015-16": "5.9" }], "BE": [{ "2014-15": "5.3" }, { "2015-16": "5.4" }, { "2016-17": "4.1" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "5.4" }, { "2015-16": "6.5" }, { "2016-17": "6.4" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "0.7" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "0.5" }, { "2016-17": "0.5" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.5" }, { "2016-17": "0.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "14.7" }, { "2014-15": "13.8" }, { "2015-16": "9.8" }], "BE": [{ "2014-15": "14" }, { "2015-16": "11.9" }, { "2016-17": "8.2" }, { "2017-18": "9.2" }], "RE": [{ "2014-15": "14.3" }, { "2015-16": "13.6" }, { "2016-17": "9.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "8.1" }, { "2014-15": "8.5" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "5.8" }, { "2015-16": "5.5" }, { "2016-17": "5.8" }, { "2017-18": "5.1" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.2" }, { "2016-17": "6.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "6.6" }, { "2014-15": "7.2" }, { "2015-16": "6.3" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "4.7" }, { "2016-17": "5.7" }, { "2017-18": "4.9" }], "RE": [{ "2014-15": "6.6" }, { "2015-16": "5.7" }, { "2016-17": "6.4" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "3" }, { "2014-15": "3" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "3.4" }, { "2015-16": "3.6" }, { "2016-17": "3.1" }, { "2017-18": "2.9" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "4.5" }, { "2016-17": "3.1" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "935.5" }, { "2014-15": "" }, { "2015-16": "693.3" }], "BE": [{ "2014-15": "512.9" }, { "2015-16": "530.1" }, { "2016-17": "622.4" }, { "2017-18": "711.4" }], "RE": [{ "2014-15": "512.3" }, { "2015-16": "571.6" }, { "2016-17": "604.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "723.6" }, { "2014-15": "854.6" }, { "2015-16": "659.7" }], "BE": [{ "2014-15": "1060.5" }, { "2015-16": "1247.7" }, { "2016-17": "1428.9" }, { "2017-18": "1395.1" }], "RE": [{ "2014-15": "1478.2" }, { "2015-16": "1415.8" }, { "2016-17": "1649.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "615.9" }, { "2014-15": "646.2" }, { "2015-16": "721.6" }], "BE": [{ "2014-15": "745" }, { "2015-16": "860.9" }, { "2016-17": "941.1" }, { "2017-18": "1012.4" }], "RE": [{ "2014-15": "967" }, { "2015-16": "885" }, { "2016-17": "958.9" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1132.9" }, { "2014-15": "1174.5" }, { "2015-16": "1378.5" }], "BE": [{ "2014-15": "1439.2" }, { "2015-16": "2028.3" }, { "2016-17": "2629.4" }, { "2017-18": "2946.3" }], "RE": [{ "2014-15": "1400" }, { "2015-16": "1759" }, { "2016-17": "2080.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1928.9" }, { "2014-15": "1991.2" }, { "2015-16": "1789.2" }], "BE": [{ "2014-15": "2072.2" }, { "2015-16": "2548.8" }, { "2016-17": "2536.4" }, { "2017-18": "2149.7" }], "RE": [{ "2014-15": "2063.4" }, { "2015-16": "2036.4" }, { "2016-17": "2086.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3253.2" }, { "2014-15": "3419.7" }, { "2015-16": "3235.7" }], "BE": [{ "2014-15": "3929.5" }, { "2015-16": "3879.8" }, { "2016-17": "3884.1" }, { "2017-18": "3914.9" }], "RE": [{ "2014-15": "3693.8" }, { "2015-16": "3445.3" }, { "2016-17": "3470.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "484.2" }, { "2014-15": "424.1" }, { "2015-16": "511.3" }], "BE": [{ "2014-15": "471.2" }, { "2015-16": "505.3" }, { "2016-17": "688.6" }, { "2017-18": "578.4" }], "RE": [{ "2014-15": "495.6" }, { "2015-16": "554.7" }, { "2016-17": "485" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "4046" }, { "2014-15": "4404.4" }, { "2015-16": "4949.1" }], "BE": [{ "2014-15": "4242.9" }, { "2015-16": "4742" }, { "2016-17": "5172.9" }, { "2017-18": "5452.8" }], "RE": [{ "2014-15": "4042.1" }, { "2015-16": "4564.9" }, { "2016-17": "5794.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "576.4" }, { "2014-15": "503.9" }, { "2015-16": "1774.9" }], "BE": [{ "2014-15": "1494.9" }, { "2015-16": "1870.1" }, { "2016-17": "2044.5" }, { "2017-18": "2200.5" }], "RE": [{ "2014-15": "1803.5" }, { "2015-16": "2164.7" }, { "2016-17": "2051.3" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "712.7" }, { "2014-15": "904.8" }, { "2015-16": "1248.4" }], "BE": [{ "2014-15": "938.8" }, { "2015-16": "1084.7" }, { "2016-17": "1447.5" }, { "2017-18": "1790.8" }], "RE": [{ "2014-15": "951" }, { "2015-16": "1207.6" }, { "2016-17": "1445.9" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1356.1" }, { "2014-15": "1197.3" }, { "2015-16": "1224.8" }], "BE": [{ "2014-15": "1239.6" }, { "2015-16": "964.9" }, { "2016-17": "1030" }, { "2017-18": "1277.4" }], "RE": [{ "2014-15": "1327.9" }, { "2015-16": "1244.7" }, { "2016-17": "1160.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1040.5" }, { "2014-15": "1073.9" }, { "2015-16": "1575.4" }], "BE": [{ "2014-15": "1036.2" }, { "2015-16": "1354.6" }, { "2016-17": "1344.2" }, { "2017-18": "1449.9" }], "RE": [{ "2014-15": "1115.4" }, { "2015-16": "1525.3" }, { "2016-17": "1432.7" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "558.5" }, { "2014-15": "600.1" }, { "2015-16": "673.5" }], "BE": [{ "2014-15": "565.8" }, { "2015-16": "777.6" }, { "2016-17": "927" }, { "2017-18": "1054.6" }], "RE": [{ "2014-15": "646.3" }, { "2015-16": "786" }, { "2016-17": "941.5" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "817.1" }, { "2014-15": "791.4" }, { "2015-16": "870.2" }], "BE": [{ "2014-15": "701.4" }, { "2015-16": "733.2" }, { "2016-17": "847.5" }, { "2017-18": "1193.1" }], "RE": [{ "2014-15": "864.6" }, { "2015-16": "933.6" }, { "2016-17": "939.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1364.7" }, { "2014-15": "2081.5" }, { "2015-16": "3837.1" }], "BE": [{ "2014-15": "3714.3" }, { "2015-16": "3730.4" }, { "2016-17": "3624.5" }, { "2017-18": "4266.9" }], "RE": [{ "2014-15": "3146.5" }, { "2015-16": "3758.4" }, { "2016-17": "3624.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3024.6" }, { "2014-15": "4518.9" }, { "2015-16": "4123.5" }], "BE": [{ "2014-15": "4438.8" }, { "2015-16": "4447.5" }, { "2016-17": "4572" }, { "2017-18": "7594.2" }], "RE": [{ "2014-15": "5506.7" }, { "2015-16": "5037.1" }, { "2016-17": "6849.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "3583.4" }, { "2014-15": "3392" }, { "2015-16": "3916" }], "BE": [{ "2014-15": "6961.5" }, { "2015-16": "3873.1" }, { "2016-17": "4105.3" }, { "2017-18": "3385.9" }], "RE": [{ "2014-15": "3852.8" }, { "2015-16": "3426.3" }, { "2016-17": "3552.8" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "655.8" }, { "2014-15": "903.6" }, { "2015-16": "1259" }], "BE": [{ "2014-15": "893.9" }, { "2015-16": "983.7" }, { "2016-17": "1065.1" }, { "2017-18": "1159.3" }], "RE": [{ "2014-15": "905.3" }, { "2015-16": "1238.5" }, { "2016-17": "1083" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "623.7" }, { "2014-15": "807.4" }, { "2015-16": "795.5" }], "BE": [{ "2014-15": "1088.7" }, { "2015-16": "1024.6" }, { "2016-17": "878.8" }, { "2017-18": "985" }], "RE": [{ "2014-15": "912.3" }, { "2015-16": "946.6" }, { "2016-17": "1121" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "557.4" }, { "2014-15": "670.7" }, { "2015-16": "667.2" }], "BE": [{ "2014-15": "842.8" }, { "2015-16": "747.2" }, { "2016-17": "858" }, { "2017-18": "981.1" }], "RE": [{ "2014-15": "826.7" }, { "2015-16": "692.2" }, { "2016-17": "633.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "4381.8" }, { "2014-15": "3787.2" }, { "2015-16": "4128.2" }], "BE": [{ "2014-15": "5521.7" }, { "2015-16": "4641.5" }, { "2016-17": "3611.4" }, { "2017-18": "5134.7" }], "RE": [{ "2014-15": "5688.5" }, { "2015-16": "5750.3" }, { "2016-17": "5889.2" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "136.5" }, { "2014-15": "156.9" }, { "2015-16": "163.3" }], "BE": [{ "2014-15": "164.5" }, { "2015-16": "136.2" }, { "2016-17": "147" }, { "2017-18": "178.6" }], "RE": [{ "2014-15": "149.9" }, { "2015-16": "141.7" }, { "2016-17": "147.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "3099.5" }, { "2014-15": "3917.1" }, { "2015-16": "2991.8" }], "BE": [{ "2014-15": "4651.6" }, { "2015-16": "4718.5" }, { "2016-17": "3267" }, { "2017-18": "3805.1" }], "RE": [{ "2014-15": "4754.9" }, { "2015-16": "4668.3" }, { "2016-17": "3773.1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "781.7" }, { "2014-15": "949" }, { "2015-16": "874.1" }], "BE": [{ "2014-15": "754.7" }, { "2015-16": "778.7" }, { "2016-17": "918" }, { "2017-18": "883.7" }], "RE": [{ "2014-15": "790.8" }, { "2015-16": "795.1" }, { "2016-17": "1032.4" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1418.3" }, { "2014-15": "1866.1" }, { "2015-16": "1691.4" }], "BE": [{ "2014-15": "1360.9" }, { "2015-16": "1464.3" }, { "2016-17": "2075.3" }, { "2017-18": "1700.3" }], "RE": [{ "2014-15": "2049" }, { "2015-16": "1776.6" }, { "2016-17": "1820.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "356.4" }, { "2014-15": "408.2" }, { "2015-16": "518.7" }], "BE": [{ "2014-15": "483" }, { "2015-16": "536.4" }, { "2016-17": "536.7" }, { "2017-18": "556.2" }], "RE": [{ "2014-15": "501.4" }, { "2015-16": "699.8" }, { "2016-17": "544.5" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "33.9" }, { "2014-15": "" }, { "2015-16": "32.4" }], "BE": [{ "2014-15": "39.9" }, { "2015-16": "33" }, { "2016-17": "32" }, { "2017-18": "38.7" }], "RE": [{ "2014-15": "39.8" }, { "2015-16": "30.6" }, { "2016-17": "33" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "57.7" }, { "2014-15": "63.6" }, { "2015-16": "55.7" }], "BE": [{ "2014-15": "50.6" }, { "2015-16": "42.4" }, { "2016-17": "19.2" }, { "2017-18": "20.6" }], "RE": [{ "2014-15": "41.6" }, { "2015-16": "39.7" }, { "2016-17": "21.3" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "19.6" }, { "2014-15": "19.7" }, { "2015-16": "18.5" }], "BE": [{ "2014-15": "18.2" }, { "2015-16": "17" }, { "2016-17": "16" }, { "2017-18": "16.3" }], "RE": [{ "2014-15": "17.8" }, { "2015-16": "17.6" }, { "2016-17": "15.8" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "46.3" }, { "2014-15": "30.2" }, { "2015-16": "32.1" }], "BE": [{ "2014-15": "28.2" }, { "2015-16": "29.9" }, { "2016-17": "23.4" }, { "2017-18": "22.7" }], "RE": [{ "2014-15": "32.7" }, { "2015-16": "32.7" }, { "2016-17": "26.7" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "21.5" }, { "2014-15": "23.8" }, { "2015-16": "26.7" }], "BE": [{ "2014-15": "21.6" }, { "2015-16": "20.4" }, { "2016-17": "23.7" }, { "2017-18": "39.3" }], "RE": [{ "2014-15": "23.5" }, { "2015-16": "25.2" }, { "2016-17": "31" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "58" }, { "2014-15": "63" }, { "2015-16": "66.7" }], "BE": [{ "2014-15": "59.6" }, { "2015-16": "60.6" }, { "2016-17": "61.2" }, { "2017-18": "59.8" }], "RE": [{ "2014-15": "62.9" }, { "2015-16": "67.4" }, { "2016-17": "68.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "35.3" }, { "2014-15": "40.5" }, { "2015-16": "32.9" }], "BE": [{ "2014-15": "38.8" }, { "2015-16": "37.9" }, { "2016-17": "30.4" }, { "2017-18": "37.2" }], "RE": [{ "2014-15": "34.7" }, { "2015-16": "33.2" }, { "2016-17": "40.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "82.7" }, { "2014-15": "79.4" }, { "2015-16": "69.5" }], "BE": [{ "2014-15": "82.6" }, { "2015-16": "73.3" }, { "2016-17": "76.1" }, { "2017-18": "72.8" }], "RE": [{ "2014-15": "77.5" }, { "2015-16": "66.9" }, { "2016-17": "68.2" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "52.9" }, { "2015-16": "41.6" }, { "2016-17": "26.9" }, { "2017-18": "27.4" }], "RE": [{ "2014-15": "40.8" }, { "2015-16": "36.6" }, { "2016-17": "28.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "13.3" }, { "2014-15": "12.7" }, { "2015-16": "8.6" }], "BE": [{ "2014-15": "13.5" }, { "2015-16": "10" }, { "2016-17": "8.5" }, { "2017-18": "10" }], "RE": [{ "2014-15": "14.3" }, { "2015-16": "10.4" }, { "2016-17": "8.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "31.7" }, { "2014-15": "30.4" }, { "2015-16": "27.1" }], "BE": [{ "2014-15": "44.5" }, { "2015-16": "33.3" }, { "2016-17": "30" }, { "2017-18": "25.7" }], "RE": [{ "2014-15": "42" }, { "2015-16": "25.5" }, { "2016-17": "26.7" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "55.5" }, { "2014-15": "56.3" }, { "2015-16": "46.6" }], "BE": [{ "2014-15": "63.6" }, { "2015-16": "48" }, { "2016-17": "51.1" }, { "2017-18": "54.3" }], "RE": [{ "2014-15": "62.1" }, { "2015-16": "55.2" }, { "2016-17": "52.4" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "40.5" }, { "2014-15": "34.8" }, { "2015-16": "39.7" }], "BE": [{ "2014-15": "37.8" }, { "2015-16": "30.8" }, { "2016-17": "44.1" }, { "2017-18": "24.9" }], "RE": [{ "2014-15": "37.4" }, { "2015-16": "34.1" }, { "2016-17": "37.7" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "53.9" }, { "2014-15": "64.2" }, { "2015-16": "54.7" }], "BE": [{ "2014-15": "67.2" }, { "2015-16": "60.9" }, { "2016-17": "58" }, { "2017-18": "47.9" }], "RE": [{ "2014-15": "62.8" }, { "2015-16": "53.7" }, { "2016-17": "54.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "55.5" }, { "2014-15": "78.3" }, { "2015-16": "30.3" }], "BE": [{ "2014-15": "34.2" }, { "2015-16": "34.2" }, { "2016-17": "37" }, { "2017-18": "30.8" }], "RE": [{ "2014-15": "22.3" }, { "2015-16": "33.9" }, { "2016-17": "37" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "50.6" }, { "2014-15": "48.4" }, { "2015-16": "50.4" }], "BE": [{ "2014-15": "47.7" }, { "2015-16": "51.7" }, { "2016-17": "48" }, { "2017-18": "47.5" }], "RE": [{ "2014-15": "43.2" }, { "2015-16": "47.7" }, { "2016-17": "47.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "34.3" }, { "2014-15": "41" }, { "2015-16": "55.5" }], "BE": [{ "2014-15": "19.6" }, { "2015-16": "41.9" }, { "2016-17": "42.6" }, { "2017-18": "54.2" }], "RE": [{ "2014-15": "36.5" }, { "2015-16": "50.1" }, { "2016-17": "57.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "50.2" }, { "2014-15": "42" }, { "2015-16": "31.6" }], "BE": [{ "2014-15": "44.3" }, { "2015-16": "43.5" }, { "2016-17": "47.6" }, { "2017-18": "44.2" }], "RE": [{ "2014-15": "44.1" }, { "2015-16": "33.2" }, { "2016-17": "39.3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "59.5" }, { "2014-15": "40.8" }, { "2015-16": "43" }], "BE": [{ "2014-15": "48.5" }, { "2015-16": "35.5" }, { "2016-17": "36.3" }, { "2017-18": "36.8" }], "RE": [{ "2014-15": "39.3" }, { "2015-16": "35.8" }, { "2016-17": "30.6" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "38.7" }, { "2014-15": "34.1" }, { "2015-16": "29.8" }], "BE": [{ "2014-15": "28" }, { "2015-16": "34" }, { "2016-17": "21.8" }, { "2017-18": "25.6" }], "RE": [{ "2014-15": "26.1" }, { "2015-16": "29.1" }, { "2016-17": "36.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "29.3" }, { "2014-15": "37.3" }, { "2015-16": "31.4" }], "BE": [{ "2014-15": "25.7" }, { "2015-16": "30.3" }, { "2016-17": "44" }, { "2017-18": "32" }], "RE": [{ "2014-15": "25.1" }, { "2015-16": "24.5" }, { "2016-17": "28.1" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "22.2" }, { "2014-15": "19.4" }, { "2015-16": "20" }], "BE": [{ "2014-15": "20.1" }, { "2015-16": "23.9" }, { "2016-17": "23.8" }, { "2017-18": "21" }], "RE": [{ "2014-15": "20.9" }, { "2015-16": "25.8" }, { "2016-17": "24.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "63.2" }, { "2014-15": "52.9" }, { "2015-16": "39.4" }], "BE": [{ "2014-15": "47.8" }, { "2015-16": "49.2" }, { "2016-17": "44.4" }, { "2017-18": "43.5" }], "RE": [{ "2014-15": "50.7" }, { "2015-16": "47.9" }, { "2016-17": "38.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "24" }, { "2014-15": "26.4" }, { "2015-16": "27.7" }], "BE": [{ "2014-15": "33.7" }, { "2015-16": "37" }, { "2016-17": "36" }, { "2017-18": "38.7" }], "RE": [{ "2014-15": "35.8" }, { "2015-16": "35.1" }, { "2016-17": "40.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "34" }, { "2014-15": "29.7" }, { "2015-16": "28.9" }], "BE": [{ "2014-15": "51.7" }, { "2015-16": "41.4" }, { "2016-17": "30.2" }, { "2017-18": "36" }], "RE": [{ "2014-15": "37.2" }, { "2015-16": "32.4" }, { "2016-17": "28.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "43.2" }, { "2014-15": "40" }, { "2015-16": "20.6" }], "BE": [{ "2014-15": "37.9" }, { "2015-16": "30.3" }, { "2016-17": "24.7" }, { "2017-18": "20.9" }], "RE": [{ "2014-15": "31.7" }, { "2015-16": "21.2" }, { "2016-17": "20.6" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "66.1" }, { "2014-15": "" }, { "2015-16": "67.6" }], "BE": [{ "2014-15": "60.1" }, { "2015-16": "67" }, { "2016-17": "68" }, { "2017-18": "61.3" }], "RE": [{ "2014-15": "60.2" }, { "2015-16": "69.4" }, { "2016-17": "67" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "42.3" }, { "2014-15": "36.4" }, { "2015-16": "44.3" }], "BE": [{ "2014-15": "49.4" }, { "2015-16": "57.6" }, { "2016-17": "80.8" }, { "2017-18": "79.4" }], "RE": [{ "2014-15": "58.4" }, { "2015-16": "60.3" }, { "2016-17": "78.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "80.4" }, { "2014-15": "80.3" }, { "2015-16": "81.5" }], "BE": [{ "2014-15": "81.8" }, { "2015-16": "83" }, { "2016-17": "84" }, { "2017-18": "83.7" }], "RE": [{ "2014-15": "82.2" }, { "2015-16": "82.4" }, { "2016-17": "84.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "53.7" }, { "2014-15": "69.8" }, { "2015-16": "67.9" }], "BE": [{ "2014-15": "71.8" }, { "2015-16": "70.1" }, { "2016-17": "76.6" }, { "2017-18": "77.3" }], "RE": [{ "2014-15": "67.3" }, { "2015-16": "67.3" }, { "2016-17": "73.3" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "78.5" }, { "2014-15": "76.2" }, { "2015-16": "73.3" }], "BE": [{ "2014-15": "78.4" }, { "2015-16": "79.6" }, { "2016-17": "76.3" }, { "2017-18": "60.7" }], "RE": [{ "2014-15": "76.5" }, { "2015-16": "74.8" }, { "2016-17": "69" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "42" }, { "2014-15": "37" }, { "2015-16": "33.3" }], "BE": [{ "2014-15": "40.4" }, { "2015-16": "39.4" }, { "2016-17": "38.8" }, { "2017-18": "40.2" }], "RE": [{ "2014-15": "37.1" }, { "2015-16": "32.6" }, { "2016-17": "31.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "64.7" }, { "2014-15": "59.5" }, { "2015-16": "67.1" }], "BE": [{ "2014-15": "61.2" }, { "2015-16": "62.1" }, { "2016-17": "69.6" }, { "2017-18": "62.8" }], "RE": [{ "2014-15": "65.3" }, { "2015-16": "66.8" }, { "2016-17": "59.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "17.3" }, { "2014-15": "20.6" }, { "2015-16": "30.5" }], "BE": [{ "2014-15": "17.4" }, { "2015-16": "26.7" }, { "2016-17": "23.9" }, { "2017-18": "27.2" }], "RE": [{ "2014-15": "22.5" }, { "2015-16": "33.1" }, { "2016-17": "31.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "47.1" }, { "2015-16": "58.4" }, { "2016-17": "73.1" }, { "2017-18": "72.6" }], "RE": [{ "2014-15": "59.2" }, { "2015-16": "63.4" }, { "2016-17": "71.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "86.7" }, { "2014-15": "87.3" }, { "2015-16": "91.4" }], "BE": [{ "2014-15": "86.5" }, { "2015-16": "90" }, { "2016-17": "91.5" }, { "2017-18": "90" }], "RE": [{ "2014-15": "85.7" }, { "2015-16": "89.6" }, { "2016-17": "91.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "68.3" }, { "2014-15": "69.6" }, { "2015-16": "72.9" }], "BE": [{ "2014-15": "55.5" }, { "2015-16": "66.7" }, { "2016-17": "70" }, { "2017-18": "74.3" }], "RE": [{ "2014-15": "58" }, { "2015-16": "74.5" }, { "2016-17": "73.3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "44.5" }, { "2014-15": "43.7" }, { "2015-16": "53.4" }], "BE": [{ "2014-15": "36.4" }, { "2015-16": "52" }, { "2016-17": "48.9" }, { "2017-18": "45.7" }], "RE": [{ "2014-15": "37.9" }, { "2015-16": "44.8" }, { "2016-17": "47.6" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "59.5" }, { "2014-15": "65.2" }, { "2015-16": "60.3" }], "BE": [{ "2014-15": "62.2" }, { "2015-16": "69.2" }, { "2016-17": "55.9" }, { "2017-18": "75.1" }], "RE": [{ "2014-15": "62.6" }, { "2015-16": "65.9" }, { "2016-17": "62.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "46.1" }, { "2014-15": "35.8" }, { "2015-16": "45.3" }], "BE": [{ "2014-15": "32.8" }, { "2015-16": "39.1" }, { "2016-17": "42" }, { "2017-18": "52.1" }], "RE": [{ "2014-15": "37.2" }, { "2015-16": "46.3" }, { "2016-17": "45.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "44.5" }, { "2014-15": "21.7" }, { "2015-16": "69.7" }], "BE": [{ "2014-15": "65.8" }, { "2015-16": "65.8" }, { "2016-17": "63" }, { "2017-18": "69.2" }], "RE": [{ "2014-15": "77.7" }, { "2015-16": "66.1" }, { "2016-17": "63" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "49.4" }, { "2014-15": "51.6" }, { "2015-16": "49.6" }], "BE": [{ "2014-15": "52.3" }, { "2015-16": "48.3" }, { "2016-17": "52" }, { "2017-18": "52.5" }], "RE": [{ "2014-15": "56.8" }, { "2015-16": "52.3" }, { "2016-17": "52.9" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "65.7" }, { "2014-15": "59" }, { "2015-16": "44.5" }], "BE": [{ "2014-15": "80.4" }, { "2015-16": "58.1" }, { "2016-17": "57.4" }, { "2017-18": "45.8" }], "RE": [{ "2014-15": "63.5" }, { "2015-16": "49.9" }, { "2016-17": "42.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "49.8" }, { "2014-15": "58" }, { "2015-16": "68.4" }], "BE": [{ "2014-15": "55.7" }, { "2015-16": "56.5" }, { "2016-17": "52.4" }, { "2017-18": "55.8" }], "RE": [{ "2014-15": "55.9" }, { "2015-16": "66.8" }, { "2016-17": "60.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "40.5" }, { "2014-15": "59.2" }, { "2015-16": "57" }], "BE": [{ "2014-15": "51.5" }, { "2015-16": "64.5" }, { "2016-17": "63.7" }, { "2017-18": "63.2" }], "RE": [{ "2014-15": "60.7" }, { "2015-16": "64.2" }, { "2016-17": "69.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "61.3" }, { "2014-15": "65.9" }, { "2015-16": "70.2" }], "BE": [{ "2014-15": "72" }, { "2015-16": "66" }, { "2016-17": "78.2" }, { "2017-18": "74.4" }], "RE": [{ "2014-15": "73.9" }, { "2015-16": "70.9" }, { "2016-17": "63.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "70.7" }, { "2014-15": "62.7" }, { "2015-16": "68.6" }], "BE": [{ "2014-15": "74.3" }, { "2015-16": "69.7" }, { "2016-17": "56" }, { "2017-18": "68" }], "RE": [{ "2014-15": "74.9" }, { "2015-16": "75.5" }, { "2016-17": "71.9" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "77.8" }, { "2014-15": "80.6" }, { "2015-16": "80" }], "BE": [{ "2014-15": "79.9" }, { "2015-16": "76.1" }, { "2016-17": "76.2" }, { "2017-18": "79" }], "RE": [{ "2014-15": "79.1" }, { "2015-16": "74.2" }, { "2016-17": "75.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "36.8" }, { "2014-15": "47.1" }, { "2015-16": "60.6" }], "BE": [{ "2014-15": "52.2" }, { "2015-16": "50.8" }, { "2016-17": "55.6" }, { "2017-18": "56.5" }], "RE": [{ "2014-15": "49.3" }, { "2015-16": "52.1" }, { "2016-17": "61.4" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "76" }, { "2014-15": "73.6" }, { "2015-16": "72.3" }], "BE": [{ "2014-15": "66.3" }, { "2015-16": "63" }, { "2016-17": "64" }, { "2017-18": "61.3" }], "RE": [{ "2014-15": "64.2" }, { "2015-16": "64.9" }, { "2016-17": "59.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "66" }, { "2014-15": "70.3" }, { "2015-16": "71.1" }], "BE": [{ "2014-15": "48.3" }, { "2015-16": "58.6" }, { "2016-17": "69.8" }, { "2017-18": "64" }], "RE": [{ "2014-15": "62.8" }, { "2015-16": "67.6" }, { "2016-17": "71.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "56.8" }, { "2014-15": "60" }, { "2015-16": "79.4" }], "BE": [{ "2014-15": "62.1" }, { "2015-16": "69.7" }, { "2016-17": "75.3" }, { "2017-18": "79.1" }], "RE": [{ "2014-15": "68.3" }, { "2015-16": "78.8" }, { "2016-17": "79.4" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Public Works" }, { "category_slug": "irrigation_water_resources", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "18777.8" }, { "2014-15": "" }, { "2015-16": "9622.7" }], "BE": [{ "2014-15": "8486.1" }, { "2015-16": "5290.5" }, { "2016-17": "8014.5" }, { "2017-18": "12806.6" }], "RE": [{ "2014-15": "8477.2" }, { "2015-16": "8892" }, { "2016-17": "8155.4" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "1287.6" }, { "2014-15": "1979.1" }, { "2015-16": "1594.6" }], "BE": [{ "2014-15": "2260.8" }, { "2015-16": "3726.3" }, { "2016-17": "4111.7" }, { "2017-18": "4080.4" }], "RE": [{ "2014-15": "3866.3" }, { "2015-16": "4233.2" }, { "2016-17": "4409" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "2853.8" }, { "2014-15": "2464" }, { "2015-16": "2857.4" }], "BE": [{ "2014-15": "3405.7" }, { "2015-16": "3196.8" }, { "2016-17": "2872" }, { "2017-18": "4420.9" }], "RE": [{ "2014-15": "4217.8" }, { "2015-16": "3499.2" }, { "2016-17": "2899.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2045.3" }, { "2014-15": "1943.8" }, { "2015-16": "2177.1" }], "BE": [{ "2014-15": "2443" }, { "2015-16": "2758" }, { "2016-17": "2924.1" }, { "2017-18": "3187.7" }], "RE": [{ "2014-15": "2214.9" }, { "2015-16": "2247.6" }, { "2016-17": "2718.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "193.2" }, { "2014-15": "229.7" }, { "2015-16": "209.3" }], "BE": [{ "2014-15": "230.2" }, { "2015-16": "229" }, { "2016-17": "266.3" }, { "2017-18": "307.8" }], "RE": [{ "2014-15": "236.2" }, { "2015-16": "224.1" }, { "2016-17": "264" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "8419.3" }, { "2014-15": "10267.3" }, { "2015-16": "10390.7" }], "BE": [{ "2014-15": "11316.5" }, { "2015-16": "11593.1" }, { "2016-17": "10706" }, { "2017-18": "11772.4" }], "RE": [{ "2014-15": "11679.1" }, { "2015-16": "10773.3" }, { "2016-17": "10847.1" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2070.1" }, { "2014-15": "2124.5" }, { "2015-16": "2281.6" }], "BE": [{ "2014-15": "2229.7" }, { "2015-16": "2371.7" }, { "2016-17": "2652.6" }, { "2017-18": "2806.9" }], "RE": [{ "2014-15": "2229.3" }, { "2015-16": "2186.5" }, { "2016-17": "2469.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2000.8" }, { "2014-15": "2697" }, { "2015-16": "2390.9" }], "BE": [{ "2014-15": "1961.3" }, { "2015-16": "2452.3" }, { "2016-17": "2800.6" }, { "2017-18": "2750.4" }], "RE": [{ "2014-15": "2173.9" }, { "2015-16": "2069.8" }, { "2016-17": "2994" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "399.8" }, { "2014-15": "412.9" }, { "2015-16": "471.4" }], "BE": [{ "2014-15": "657.3" }, { "2015-16": "912.4" }, { "2016-17": "1335.8" }, { "2017-18": "1949" }], "RE": [{ "2014-15": "800.5" }, { "2015-16": "890.1" }, { "2016-17": "1029.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "964.9" }, { "2014-15": "1040.2" }, { "2015-16": "1483.9" }], "BE": [{ "2014-15": "2344.8" }, { "2015-16": "2459" }, { "2016-17": "2325.2" }, { "2017-18": "2554" }], "RE": [{ "2014-15": "2327.8" }, { "2015-16": "1678.1" }, { "2016-17": "2004.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "7236.1" }, { "2014-15": "8644.4" }, { "2015-16": "8159.7" }], "BE": [{ "2014-15": "9630.8" }, { "2015-16": "10628.1" }, { "2016-17": "11389.3" }, { "2017-18": "14433.3" }], "RE": [{ "2014-15": "8090" }, { "2015-16": "8723.5" }, { "2016-17": "10632.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "521.6" }, { "2014-15": "448.6" }, { "2015-16": "695" }], "BE": [{ "2014-15": "1178.4" }, { "2015-16": "835.5" }, { "2016-17": "734.2" }, { "2017-18": "944.4" }], "RE": [{ "2014-15": "932.7" }, { "2015-16": "663.9" }, { "2016-17": "880.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "5364.9" }, { "2014-15": "4836.9" }, { "2015-16": "7173.7" }], "BE": [{ "2014-15": "5516.3" }, { "2015-16": "7107.9" }, { "2016-17": "8871" }, { "2017-18": "11139.9" }], "RE": [{ "2014-15": "5949.9" }, { "2015-16": "7277" }, { "2016-17": "9634.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "8839.2" }, { "2014-15": "9824.1" }, { "2015-16": "10847.2" }], "BE": [{ "2014-15": "10061.5" }, { "2015-16": "8994.2" }, { "2016-17": "11720.4" }, { "2017-18": "11921.3" }], "RE": [{ "2014-15": "11281.8" }, { "2015-16": "11651.6" }, { "2016-17": "11516.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "124.8" }, { "2014-15": "277" }, { "2015-16": "83.9" }], "BE": [{ "2014-15": "343.8" }, { "2015-16": "344.1" }, { "2016-17": "258.2" }, { "2017-18": "460.9" }], "RE": [{ "2014-15": "343.8" }, { "2015-16": "344.1" }, { "2016-17": "258.2" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "10.2" }, { "2014-15": "11.4" }, { "2015-16": "17.1" }], "BE": [{ "2014-15": "77.1" }, { "2015-16": "97.2" }, { "2016-17": "51.3" }, { "2017-18": "61.8" }], "RE": [{ "2014-15": "77.4" }, { "2015-16": "96.8" }, { "2016-17": "55.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "85.8" }, { "2014-15": "77.6" }, { "2015-16": "127.4" }], "BE": [{ "2014-15": "227.1" }, { "2015-16": "257.3" }, { "2016-17": "261.5" }, { "2017-18": "149.4" }], "RE": [{ "2014-15": "162.1" }, { "2015-16": "139.1" }, { "2016-17": "136.8" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "3657.7" }, { "2014-15": "4278.7" }, { "2015-16": "6043.5" }], "BE": [{ "2014-15": "5087.7" }, { "2015-16": "6212.2" }, { "2016-17": "7241.7" }, { "2017-18": "9199.7" }], "RE": [{ "2014-15": "4401.2" }, { "2015-16": "6019.1" }, { "2016-17": "7582.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1694.7" }, { "2014-15": "1881.3" }, { "2015-16": "2057.7" }], "BE": [{ "2014-15": "2622.6" }, { "2015-16": "2388.8" }, { "2016-17": "2696.1" }, { "2017-18": "2161.9" }], "RE": [{ "2014-15": "2057.2" }, { "2015-16": "2521.4" }, { "2016-17": "2792.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "2699.3" }, { "2014-15": "2989.9" }, { "2015-16": "3120.4" }], "BE": [{ "2014-15": "3379.7" }, { "2015-16": "3466.5" }, { "2016-17": "4131.2" }, { "2017-18": "4625.8" }], "RE": [{ "2014-15": "3184" }, { "2015-16": "3246.6" }, { "2016-17": "4080.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "44.4" }, { "2014-15": "22.4" }, { "2015-16": "35.3" }], "BE": [{ "2014-15": "154.5" }, { "2015-16": "115.6" }, { "2016-17": "164.6" }, { "2017-18": "162.8" }], "RE": [{ "2014-15": "154.5" }, { "2015-16": "116.1" }, { "2016-17": "171.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "2778.6" }, { "2014-15": "3036" }, { "2015-16": "2501.1" }], "BE": [{ "2014-15": "3669.8" }, { "2015-16": "2769.4" }, { "2016-17": "3406.7" }, { "2017-18": "4790.6" }], "RE": [{ "2014-15": "3262.5" }, { "2015-16": "3673.9" }, { "2016-17": "3088.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "127.5" }, { "2014-15": "91.1" }, { "2015-16": "104.1" }], "BE": [{ "2014-15": "222" }, { "2015-16": "271.4" }, { "2016-17": "151.9" }, { "2017-18": "177.5" }], "RE": [{ "2014-15": "192.9" }, { "2015-16": "175.4" }, { "2016-17": "147.2" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "7684.8" }, { "2014-15": "9612.8" }, { "2015-16": "10308.4" }], "BE": [{ "2014-15": "10808.2" }, { "2015-16": "11118.9" }, { "2016-17": "12831.8" }, { "2017-18": "10957.9" }], "RE": [{ "2014-15": "10954" }, { "2015-16": "10820.5" }, { "2016-17": "12117.7" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "755" }, { "2014-15": "1094.3" }, { "2015-16": "1050.5" }], "BE": [{ "2014-15": "1229.2" }, { "2015-16": "1009.7" }, { "2016-17": "1231.5" }, { "2017-18": "725.6" }], "RE": [{ "2014-15": "1322.3" }, { "2015-16": "1202.7" }, { "2016-17": "894.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1817.6" }, { "2014-15": "2482" }, { "2015-16": "2540.5" }], "BE": [{ "2014-15": "3705.8" }, { "2015-16": "3679.4" }, { "2016-17": "4134.9" }, { "2017-18": "4332.9" }], "RE": [{ "2014-15": "3018.9" }, { "2015-16": "3347.8" }, { "2016-17": "3376.7" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "13.7" }, { "2014-15": "" }, { "2015-16": "6.4" }], "BE": [{ "2014-15": "7.6" }, { "2015-16": "4.7" }, { "2016-17": "5.9" }, { "2017-18": "8.2" }], "RE": [{ "2014-15": "7.6" }, { "2015-16": "7.9" }, { "2016-17": "6.1" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "4.2" }, { "2015-16": "3.8" }], "BE": [{ "2014-15": "3.5" }, { "2015-16": "5.6" }, { "2016-17": "5.3" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "6.1" }, { "2015-16": "5.7" }, { "2016-17": "5.3" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "2.6" }, { "2015-16": "2.5" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "2.6" }, { "2016-17": "2" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "3.2" }, { "2015-16": "2.6" }, { "2016-17": "1.9" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "5.3" }, { "2014-15": "4.2" }, { "2015-16": "4.2" }], "BE": [{ "2014-15": "4.5" }, { "2015-16": "4.2" }, { "2016-17": "4.2" }, { "2017-18": "4.2" }], "RE": [{ "2014-15": "4" }, { "2015-16": "3.4" }, { "2016-17": "3.8" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.7" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.7" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "8" }, { "2014-15": "8.8" }, { "2015-16": "6.9" }], "BE": [{ "2014-15": "8.6" }, { "2015-16": "8.4" }, { "2016-17": "8.4" }, { "2017-18": "6.9" }], "RE": [{ "2014-15": "9.3" }, { "2015-16": "8.1" }, { "2016-17": "7.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "4.4" }, { "2014-15": "4" }, { "2015-16": "3.7" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "3.4" }, { "2016-17": "3.4" }, { "2017-18": "3.3" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "3.2" }, { "2016-17": "3.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "9.3" }, { "2014-15": "8.7" }, { "2015-16": "8.1" }], "BE": [{ "2014-15": "8.3" }, { "2015-16": "8.7" }, { "2016-17": "8.6" }, { "2017-18": "7.7" }], "RE": [{ "2014-15": "7.3" }, { "2015-16": "7.7" }, { "2016-17": "8.6" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1.2" }, { "2014-15": "1.2" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "2" }, { "2016-17": "2.9" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "1.9" }, { "2015-16": "1.7" }, { "2016-17": "1.7" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "2.6" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "4.4" }, { "2016-17": "3.7" }, { "2017-18": "3.4" }], "RE": [{ "2014-15": "4.6" }, { "2015-16": "3" }, { "2016-17": "3" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "7" }, { "2015-16": "5.9" }], "BE": [{ "2014-15": "7.3" }, { "2015-16": "7.8" }, { "2016-17": "7.3" }, { "2017-18": "8.1" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "6.3" }, { "2016-17": "6.8" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.6" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "0.9" }, { "2016-17": "0.7" }, { "2017-18": "0.8" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "0.7" }, { "2016-17": "0.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "6.3" }, { "2014-15": "4.5" }, { "2015-16": "6" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "5.4" }, { "2016-17": "5.6" }, { "2017-18": "6.6" }], "RE": [{ "2014-15": "5" }, { "2015-16": "5.5" }, { "2016-17": "6.2" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "4.7" }, { "2014-15": "4.5" }, { "2015-16": "4.8" }], "BE": [{ "2014-15": "4.5" }, { "2015-16": "3.7" }, { "2016-17": "4.3" }, { "2017-18": "4" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "4.7" }, { "2016-17": "4.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1.8" }, { "2014-15": "3.6" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "3.5" }, { "2016-17": "2.4" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "3.5" }, { "2016-17": "2.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "0.2" }, { "2014-15": "0.1" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "1.3" }, { "2016-17": "0.6" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "1" }, { "2015-16": "1.2" }, { "2016-17": "0.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1" }, { "2014-15": "0.8" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "1.8" }, { "2015-16": "2" }, { "2016-17": "1.9" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "1.1" }, { "2016-17": "0.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "6.5" }, { "2014-15": "6.4" }, { "2015-16": "7.6" }], "BE": [{ "2014-15": "6.3" }, { "2015-16": "7.4" }, { "2016-17": "7.7" }, { "2017-18": "8.6" }], "RE": [{ "2014-15": "5.7" }, { "2015-16": "7.1" }, { "2016-17": "8.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "2.6" }, { "2015-16": "2.5" }], "BE": [{ "2014-15": "3.6" }, { "2015-16": "3" }, { "2016-17": "3.1" }, { "2017-18": "1.8" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "3.2" }, { "2016-17": "1.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "2.9" }, { "2014-15": "2.6" }, { "2015-16": "2.4" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "2.5" }, { "2016-17": "2.7" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "2.5" }, { "2015-16": "2.4" }, { "2016-17": "2.7" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1" }, { "2014-15": "0.5" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "2.4" }, { "2015-16": "2.1" }, { "2016-17": "2.9" }, { "2017-18": "2.6" }], "RE": [{ "2014-15": "2.3" }, { "2015-16": "2.1" }, { "2016-17": "2.9" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "1.9" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "2.4" }, { "2015-16": "1.6" }, { "2016-17": "1.7" }, { "2017-18": "2.2" }], "RE": [{ "2014-15": "2" }, { "2015-16": "2.1" }, { "2016-17": "1.4" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "0.9" }, { "2015-16": "0.9" }], "BE": [{ "2014-15": "1.8" }, { "2015-16": "1.8" }, { "2016-17": "1" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.6" }, { "2015-16": "1.3" }, { "2016-17": "1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "3.8" }, { "2014-15": "4.1" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "3.7" }, { "2016-17": "3.7" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "3.3" }, { "2016-17": "3.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "4" }, { "2015-16": "3.6" }], "BE": [{ "2014-15": "4" }, { "2015-16": "3.1" }, { "2016-17": "3" }, { "2017-18": "1.8" }], "RE": [{ "2014-15": "4.1" }, { "2015-16": "3.6" }, { "2016-17": "2.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "2" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "2.7" }, { "2016-17": "2.6" }, { "2017-18": "2.4" }], "RE": [{ "2014-15": "2.3" }, { "2015-16": "2.3" }, { "2016-17": "2" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "3766.3" }, { "2014-15": "" }, { "2015-16": "1907.5" }], "BE": [{ "2014-15": "1692.1" }, { "2015-16": "1048.7" }, { "2016-17": "1579.4" }, { "2017-18": "2509.4" }], "RE": [{ "2014-15": "1690.3" }, { "2015-16": "1762.7" }, { "2016-17": "1607.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "411.1" }, { "2014-15": "624.5" }, { "2015-16": "497.3" }], "BE": [{ "2014-15": "713.4" }, { "2015-16": "1162" }, { "2016-17": "1267.1" }, { "2017-18": "1243.1" }], "RE": [{ "2014-15": "1219.9" }, { "2015-16": "1320" }, { "2016-17": "1358.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "284.6" }, { "2014-15": "242.7" }, { "2015-16": "278.1" }], "BE": [{ "2014-15": "335.5" }, { "2015-16": "311.2" }, { "2016-17": "276.4" }, { "2017-18": "420.5" }], "RE": [{ "2014-15": "415.4" }, { "2015-16": "340.6" }, { "2016-17": "279" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "821.1" }, { "2014-15": "770.4" }, { "2015-16": "851.9" }], "BE": [{ "2014-15": "968.2" }, { "2015-16": "1079.2" }, { "2016-17": "1129.9" }, { "2017-18": "1216.6" }], "RE": [{ "2014-15": "877.8" }, { "2015-16": "879.5" }, { "2016-17": "1050.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "98.9" }, { "2014-15": "114.3" }, { "2015-16": "101.2" }], "BE": [{ "2014-15": "114.6" }, { "2015-16": "110.8" }, { "2016-17": "125.1" }, { "2017-18": "140.8" }], "RE": [{ "2014-15": "117.5" }, { "2015-16": "108.4" }, { "2016-17": "124" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "3205.4" }, { "2014-15": "3849" }, { "2015-16": "3837.2" }], "BE": [{ "2014-15": "4242.4" }, { "2015-16": "4281.2" }, { "2016-17": "3896.4" }, { "2017-18": "4222" }], "RE": [{ "2014-15": "4378.3" }, { "2015-16": "3978.5" }, { "2016-17": "3947.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "341.8" }, { "2014-15": "346.4" }, { "2015-16": "367.5" }], "BE": [{ "2014-15": "363.6" }, { "2015-16": "382" }, { "2016-17": "422.2" }, { "2017-18": "441.5" }], "RE": [{ "2014-15": "363.5" }, { "2015-16": "352.2" }, { "2016-17": "393.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2892.2" }, { "2014-15": "3865" }, { "2015-16": "3397.6" }], "BE": [{ "2014-15": "2810.7" }, { "2015-16": "3484.9" }, { "2016-17": "3947.3" }, { "2017-18": "3844.3" }], "RE": [{ "2014-15": "3115.4" }, { "2015-16": "2941.3" }, { "2016-17": "4219.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "332.9" }, { "2014-15": "339.8" }, { "2015-16": "383.6" }], "BE": [{ "2014-15": "540.9" }, { "2015-16": "742.5" }, { "2016-17": "1075.6" }, { "2017-18": "1552" }], "RE": [{ "2014-15": "658.7" }, { "2015-16": "724.3" }, { "2016-17": "828.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "298.4" }, { "2014-15": "317.5" }, { "2015-16": "446.9" }], "BE": [{ "2014-15": "715.6" }, { "2015-16": "740.6" }, { "2016-17": "691" }, { "2017-18": "749.3" }], "RE": [{ "2014-15": "710.4" }, { "2015-16": "505.4" }, { "2016-17": "595.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1193.6" }, { "2014-15": "1412.2" }, { "2015-16": "1320.4" }], "BE": [{ "2014-15": "1573.3" }, { "2015-16": "1719.8" }, { "2016-17": "1826" }, { "2017-18": "2292.4" }], "RE": [{ "2014-15": "1321.6" }, { "2015-16": "1411.6" }, { "2016-17": "1704.6" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "148.9" }, { "2014-15": "127.2" }, { "2015-16": "195.9" }], "BE": [{ "2014-15": "334.2" }, { "2015-16": "235.5" }, { "2016-17": "205.8" }, { "2017-18": "263.1" }], "RE": [{ "2014-15": "264.5" }, { "2015-16": "187.2" }, { "2016-17": "246.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "720.3" }, { "2014-15": "639.7" }, { "2015-16": "934.7" }], "BE": [{ "2014-15": "729.5" }, { "2015-16": "926.2" }, { "2016-17": "1139.1" }, { "2017-18": "1410" }], "RE": [{ "2014-15": "786.9" }, { "2015-16": "948.2" }, { "2016-17": "1237.2" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "764" }, { "2014-15": "838.3" }, { "2015-16": "914.2" }], "BE": [{ "2014-15": "858.6" }, { "2015-16": "758" }, { "2016-17": "976.1" }, { "2017-18": "980.7" }], "RE": [{ "2014-15": "962.7" }, { "2015-16": "982" }, { "2016-17": "959.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "465.3" }, { "2014-15": "1021.6" }, { "2015-16": "305.8" }], "BE": [{ "2014-15": "1267.5" }, { "2015-16": "1254.4" }, { "2016-17": "931.2" }, { "2017-18": "1643.9" }], "RE": [{ "2014-15": "1267.5" }, { "2015-16": "1254.4" }, { "2016-17": "931.2" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "99.7" }, { "2014-15": "110" }, { "2015-16": "163.1" }], "BE": [{ "2014-15": "742.2" }, { "2015-16": "924.7" }, { "2016-17": "483" }, { "2017-18": "575.1" }], "RE": [{ "2014-15": "745.3" }, { "2015-16": "921.2" }, { "2016-17": "524.2" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "372.7" }, { "2014-15": "333.5" }, { "2015-16": "541.1" }], "BE": [{ "2014-15": "976.1" }, { "2015-16": "1093.1" }, { "2016-17": "1098.8" }, { "2017-18": "620.8" }], "RE": [{ "2014-15": "688.7" }, { "2015-16": "590.9" }, { "2016-17": "574.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "882.4" }, { "2014-15": "1023.7" }, { "2015-16": "1434.2" }], "BE": [{ "2014-15": "1217.2" }, { "2015-16": "1474.2" }, { "2016-17": "1704.8" }, { "2017-18": "2148.4" }], "RE": [{ "2014-15": "1053" }, { "2015-16": "1428.4" }, { "2016-17": "1785.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "599.3" }, { "2014-15": "658.5" }, { "2015-16": "713.3" }], "BE": [{ "2014-15": "918" }, { "2015-16": "828.1" }, { "2016-17": "926.1" }, { "2017-18": "735.4" }], "RE": [{ "2014-15": "720.1" }, { "2015-16": "874.1" }, { "2016-17": "959.2" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "385.9" }, { "2014-15": "421.3" }, { "2015-16": "433.5" }], "BE": [{ "2014-15": "476.2" }, { "2015-16": "481.6" }, { "2016-17": "566.3" }, { "2017-18": "625.4" }], "RE": [{ "2014-15": "448.6" }, { "2015-16": "451.1" }, { "2016-17": "559.4" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "708.7" }, { "2014-15": "353.6" }, { "2015-16": "551" }], "BE": [{ "2014-15": "2440.2" }, { "2015-16": "1806.4" }, { "2016-17": "2543.9" }, { "2017-18": "2489.6" }], "RE": [{ "2014-15": "2440.4" }, { "2015-16": "1814.2" }, { "2016-17": "2654.4" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "407" }, { "2014-15": "442.2" }, { "2015-16": "362.3" }], "BE": [{ "2014-15": "534.5" }, { "2015-16": "401.2" }, { "2016-17": "490.9" }, { "2017-18": "686.5" }], "RE": [{ "2014-15": "475.2" }, { "2015-16": "532.2" }, { "2016-17": "445.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "344.6" }, { "2014-15": "243.5" }, { "2015-16": "275.2" }], "BE": [{ "2014-15": "593.4" }, { "2015-16": "717.3" }, { "2016-17": "397.1" }, { "2017-18": "458.9" }], "RE": [{ "2014-15": "515.5" }, { "2015-16": "463.5" }, { "2016-17": "384.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "369.9" }, { "2014-15": "455.1" }, { "2015-16": "480.2" }], "BE": [{ "2014-15": "511.7" }, { "2015-16": "517.9" }, { "2016-17": "588.4" }, { "2017-18": "494.6" }], "RE": [{ "2014-15": "518.6" }, { "2015-16": "504.1" }, { "2016-17": "555.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "738.5" }, { "2014-15": "1048.1" }, { "2015-16": "954.4" }], "BE": [{ "2014-15": "1186.3" }, { "2015-16": "954.1" }, { "2016-17": "1104.7" }, { "2017-18": "634.8" }], "RE": [{ "2014-15": "1276.1" }, { "2015-16": "1121.5" }, { "2016-17": "792.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "199.5" }, { "2014-15": "270" }, { "2015-16": "274" }], "BE": [{ "2014-15": "403.2" }, { "2015-16": "396.8" }, { "2016-17": "442" }, { "2017-18": "459.2" }], "RE": [{ "2014-15": "328.4" }, { "2015-16": "361" }, { "2016-17": "361" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "47.9" }, { "2014-15": "" }, { "2015-16": "7.1" }], "BE": [{ "2014-15": "63.2" }, { "2015-16": "13.4" }, { "2016-17": "9" }, { "2017-18": "5.8" }], "RE": [{ "2014-15": "62.2" }, { "2015-16": "7.1" }, { "2016-17": "8.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "48.6" }, { "2014-15": "37" }, { "2015-16": "42" }], "BE": [{ "2014-15": "38.7" }, { "2015-16": "26" }, { "2016-17": "22.5" }, { "2017-18": "24.5" }], "RE": [{ "2014-15": "22.5" }, { "2015-16": "23" }, { "2016-17": "21.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "37" }, { "2014-15": "42.2" }, { "2015-16": "41" }], "BE": [{ "2014-15": "43.4" }, { "2015-16": "48.5" }, { "2016-17": "41" }, { "2017-18": "29.9" }], "RE": [{ "2014-15": "35.7" }, { "2015-16": "44.5" }, { "2016-17": "41.5" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "17.6" }, { "2014-15": "41" }, { "2015-16": "28.1" }], "BE": [{ "2014-15": "18.4" }, { "2015-16": "40.2" }, { "2016-17": "29.8" }, { "2017-18": "24.7" }], "RE": [{ "2014-15": "20.2" }, { "2015-16": "43" }, { "2016-17": "28.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "61.6" }, { "2014-15": "62.4" }, { "2015-16": "75.1" }], "BE": [{ "2014-15": "61.5" }, { "2015-16": "69.4" }, { "2016-17": "74.3" }, { "2017-18": "71" }], "RE": [{ "2014-15": "62.3" }, { "2015-16": "74.6" }, { "2016-17": "74.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "14.1" }, { "2014-15": "11.9" }, { "2015-16": "11.5" }], "BE": [{ "2014-15": "11.7" }, { "2015-16": "11.8" }, { "2016-17": "12.6" }, { "2017-18": "13" }], "RE": [{ "2014-15": "10.9" }, { "2015-16": "10.9" }, { "2016-17": "13.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "56.1" }, { "2014-15": "54.6" }, { "2015-16": "61.6" }], "BE": [{ "2014-15": "74.9" }, { "2015-16": "74.7" }, { "2016-17": "72.6" }, { "2017-18": "70.3" }], "RE": [{ "2014-15": "75" }, { "2015-16": "75.4" }, { "2016-17": "75.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "88.8" }, { "2014-15": "80.6" }, { "2015-16": "87.8" }], "BE": [{ "2014-15": "86.7" }, { "2015-16": "77.1" }, { "2016-17": "80.7" }, { "2017-18": "82.2" }], "RE": [{ "2014-15": "75.9" }, { "2015-16": "86.4" }, { "2016-17": "80.5" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "79.2" }, { "2015-16": "58" }, { "2016-17": "41.2" }, { "2017-18": "30.8" }], "RE": [{ "2014-15": "59.5" }, { "2015-16": "55.3" }, { "2016-17": "49.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "32.1" }, { "2014-15": "32.4" }, { "2015-16": "22" }], "BE": [{ "2014-15": "18.8" }, { "2015-16": "18.5" }, { "2016-17": "21.2" }, { "2017-18": "19.2" }], "RE": [{ "2014-15": "18.3" }, { "2015-16": "24.3" }, { "2016-17": "20.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "11.8" }, { "2014-15": "10.7" }, { "2015-16": "15.3" }], "BE": [{ "2014-15": "16.7" }, { "2015-16": "15" }, { "2016-17": "15" }, { "2017-18": "14" }], "RE": [{ "2014-15": "18.1" }, { "2015-16": "15.5" }, { "2016-17": "15.7" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "58.9" }, { "2014-15": "60.1" }, { "2015-16": "50.9" }], "BE": [{ "2014-15": "31.2" }, { "2015-16": "45.9" }, { "2016-17": "54.7" }, { "2017-18": "47.3" }], "RE": [{ "2014-15": "39" }, { "2015-16": "54.3" }, { "2016-17": "46.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "15" }, { "2014-15": "17.5" }, { "2015-16": "23.4" }], "BE": [{ "2014-15": "19" }, { "2015-16": "13.8" }, { "2016-17": "21.9" }, { "2017-18": "11.6" }], "RE": [{ "2014-15": "17.1" }, { "2015-16": "12.5" }, { "2016-17": "20.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "5.2" }, { "2014-15": "21.3" }, { "2015-16": "20.6" }], "BE": [{ "2014-15": "21.3" }, { "2015-16": "25.7" }, { "2016-17": "21" }, { "2017-18": "17.6" }], "RE": [{ "2014-15": "21" }, { "2015-16": "20.5" }, { "2016-17": "19.8" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "97.3" }, { "2014-15": "99.8" }, { "2015-16": "100" }], "BE": [{ "2014-15": "98.7" }, { "2015-16": "98.7" }, { "2016-17": "98.9" }, { "2017-18": "98.9" }], "RE": [{ "2014-15": "98.7" }, { "2015-16": "98.7" }, { "2016-17": "98.9" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "98.7" }, { "2015-16": "63.8" }], "BE": [{ "2014-15": "16.8" }, { "2015-16": "12.2" }, { "2016-17": "43.5" }, { "2017-18": "33" }], "RE": [{ "2014-15": "17.1" }, { "2015-16": "12.8" }, { "2016-17": "40.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "98.6" }, { "2014-15": "79.8" }, { "2015-16": "21.8" }], "BE": [{ "2014-15": "83.8" }, { "2015-16": "9.8" }, { "2016-17": "11.4" }, { "2017-18": "22" }], "RE": [{ "2014-15": "98.4" }, { "2015-16": "20" }, { "2016-17": "22.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "39.5" }, { "2014-15": "33.4" }, { "2015-16": "30.9" }], "BE": [{ "2014-15": "33.1" }, { "2015-16": "30.1" }, { "2016-17": "27.3" }, { "2017-18": "23.4" }], "RE": [{ "2014-15": "32.2" }, { "2015-16": "32.6" }, { "2016-17": "24.8" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "78.7" }, { "2014-15": "65" }, { "2015-16": "63.5" }], "BE": [{ "2014-15": "47.8" }, { "2015-16": "55.2" }, { "2016-17": "52" }, { "2017-18": "59.7" }], "RE": [{ "2014-15": "62.5" }, { "2015-16": "54.1" }, { "2016-17": "43.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "61.8" }, { "2014-15": "57.5" }, { "2015-16": "58.1" }], "BE": [{ "2014-15": "53.6" }, { "2015-16": "53.9" }, { "2016-17": "47.5" }, { "2017-18": "45.2" }], "RE": [{ "2014-15": "55.9" }, { "2015-16": "57.3" }, { "2016-17": "50.3" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "91.4" }, { "2014-15": "81" }, { "2015-16": "96.7" }], "BE": [{ "2014-15": "96.3" }, { "2015-16": "90" }, { "2016-17": "93.9" }, { "2017-18": "97.3" }], "RE": [{ "2014-15": "96.3" }, { "2015-16": "90" }, { "2016-17": "93.9" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "61.2" }, { "2014-15": "57.2" }, { "2015-16": "68.5" }], "BE": [{ "2014-15": "39.8" }, { "2015-16": "60.1" }, { "2016-17": "50.7" }, { "2017-18": "37.9" }], "RE": [{ "2014-15": "51.7" }, { "2015-16": "47.5" }, { "2016-17": "50.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "78.1" }, { "2014-15": "77.6" }, { "2015-16": "69.6" }], "BE": [{ "2014-15": "63.5" }, { "2015-16": "59" }, { "2016-17": "77.8" }, { "2017-18": "58" }], "RE": [{ "2014-15": "70.2" }, { "2015-16": "79.8" }, { "2016-17": "64.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "56" }, { "2014-15": "51" }, { "2015-16": "45.9" }], "BE": [{ "2014-15": "53.1" }, { "2015-16": "55.7" }, { "2016-17": "48.5" }, { "2017-18": "66.1" }], "RE": [{ "2014-15": "55.7" }, { "2015-16": "50.1" }, { "2016-17": "48.3" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "42.3" }, { "2014-15": "32.6" }, { "2015-16": "34.1" }], "BE": [{ "2014-15": "33.9" }, { "2015-16": "38.9" }, { "2016-17": "37.5" }, { "2017-18": "60.7" }], "RE": [{ "2014-15": "30" }, { "2015-16": "32.5" }, { "2016-17": "40.2" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "60.2" }, { "2014-15": "43.5" }, { "2015-16": "41.3" }], "BE": [{ "2014-15": "41" }, { "2015-16": "32" }, { "2016-17": "30.8" }, { "2017-18": "29.5" }], "RE": [{ "2014-15": "39.7" }, { "2015-16": "35" }, { "2016-17": "35.3" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "52.1" }, { "2014-15": "" }, { "2015-16": "92.9" }], "BE": [{ "2014-15": "36.8" }, { "2015-16": "86.6" }, { "2016-17": "91" }, { "2017-18": "94.2" }], "RE": [{ "2014-15": "37.8" }, { "2015-16": "92.9" }, { "2016-17": "91.4" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "51.4" }, { "2014-15": "63" }, { "2015-16": "58" }], "BE": [{ "2014-15": "61.3" }, { "2015-16": "74" }, { "2016-17": "77.5" }, { "2017-18": "75.5" }], "RE": [{ "2014-15": "77.5" }, { "2015-16": "77" }, { "2016-17": "78.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "63" }, { "2014-15": "57.8" }, { "2015-16": "59" }], "BE": [{ "2014-15": "56.6" }, { "2015-16": "51.5" }, { "2016-17": "59" }, { "2017-18": "70.1" }], "RE": [{ "2014-15": "64.3" }, { "2015-16": "55.5" }, { "2016-17": "58.5" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "82.4" }, { "2014-15": "59" }, { "2015-16": "71.9" }], "BE": [{ "2014-15": "81.6" }, { "2015-16": "59.8" }, { "2016-17": "70.2" }, { "2017-18": "75.3" }], "RE": [{ "2014-15": "79.8" }, { "2015-16": "57" }, { "2016-17": "71.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "38.4" }, { "2014-15": "37.6" }, { "2015-16": "24.9" }], "BE": [{ "2014-15": "38.5" }, { "2015-16": "30.6" }, { "2016-17": "25.7" }, { "2017-18": "29" }], "RE": [{ "2014-15": "37.7" }, { "2015-16": "25.4" }, { "2016-17": "25.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "85.9" }, { "2014-15": "88.1" }, { "2015-16": "88.5" }], "BE": [{ "2014-15": "88.3" }, { "2015-16": "88.2" }, { "2016-17": "87.4" }, { "2017-18": "87" }], "RE": [{ "2014-15": "89.1" }, { "2015-16": "89.1" }, { "2016-17": "86.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "43.9" }, { "2014-15": "45.4" }, { "2015-16": "38.4" }], "BE": [{ "2014-15": "25.1" }, { "2015-16": "25.3" }, { "2016-17": "27.4" }, { "2017-18": "29.7" }], "RE": [{ "2014-15": "25" }, { "2015-16": "24.6" }, { "2016-17": "24.9" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "11.2" }, { "2014-15": "19.4" }, { "2015-16": "12.2" }], "BE": [{ "2014-15": "13.3" }, { "2015-16": "22.9" }, { "2016-17": "19.3" }, { "2017-18": "17.8" }], "RE": [{ "2014-15": "24.1" }, { "2015-16": "13.6" }, { "2016-17": "19.5" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "20.8" }, { "2015-16": "42" }, { "2016-17": "58.8" }, { "2017-18": "69.2" }], "RE": [{ "2014-15": "40.5" }, { "2015-16": "44.7" }, { "2016-17": "50.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "67.9" }, { "2014-15": "67.6" }, { "2015-16": "78" }], "BE": [{ "2014-15": "81.2" }, { "2015-16": "81.5" }, { "2016-17": "78.8" }, { "2017-18": "80.8" }], "RE": [{ "2014-15": "81.7" }, { "2015-16": "75.7" }, { "2016-17": "79.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "88.2" }, { "2014-15": "89.3" }, { "2015-16": "84.7" }], "BE": [{ "2014-15": "83.3" }, { "2015-16": "85" }, { "2016-17": "85" }, { "2017-18": "86" }], "RE": [{ "2014-15": "81.9" }, { "2015-16": "84.5" }, { "2016-17": "84.3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "41.1" }, { "2014-15": "39.9" }, { "2015-16": "49.1" }], "BE": [{ "2014-15": "68.8" }, { "2015-16": "54.1" }, { "2016-17": "45.3" }, { "2017-18": "52.7" }], "RE": [{ "2014-15": "61" }, { "2015-16": "45.7" }, { "2016-17": "53.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "85" }, { "2014-15": "82.5" }, { "2015-16": "76.6" }], "BE": [{ "2014-15": "81" }, { "2015-16": "86.2" }, { "2016-17": "78.1" }, { "2017-18": "88.4" }], "RE": [{ "2014-15": "82.9" }, { "2015-16": "87.5" }, { "2016-17": "79.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "94.8" }, { "2014-15": "78.7" }, { "2015-16": "79.4" }], "BE": [{ "2014-15": "78.7" }, { "2015-16": "74.3" }, { "2016-17": "79" }, { "2017-18": "82.4" }], "RE": [{ "2014-15": "79" }, { "2015-16": "79.5" }, { "2016-17": "80.2" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "0.2" }, { "2015-16": "0" }], "BE": [{ "2014-15": "1.3" }, { "2015-16": "1.3" }, { "2016-17": "1.1" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "1.3" }, { "2016-17": "1.1" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "1.3" }, { "2015-16": "36.2" }], "BE": [{ "2014-15": "83.2" }, { "2015-16": "87.8" }, { "2016-17": "56.5" }, { "2017-18": "67" }], "RE": [{ "2014-15": "82.9" }, { "2015-16": "87.2" }, { "2016-17": "59.2" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "20.2" }, { "2015-16": "78.2" }], "BE": [{ "2014-15": "16.2" }, { "2015-16": "90.2" }, { "2016-17": "88.6" }, { "2017-18": "78" }], "RE": [{ "2014-15": "1.6" }, { "2015-16": "80" }, { "2016-17": "77.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "60.5" }, { "2014-15": "66.6" }, { "2015-16": "69.1" }], "BE": [{ "2014-15": "66.9" }, { "2015-16": "69.9" }, { "2016-17": "72.7" }, { "2017-18": "76.6" }], "RE": [{ "2014-15": "67.8" }, { "2015-16": "67.4" }, { "2016-17": "75.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "21.3" }, { "2014-15": "35" }, { "2015-16": "36.5" }], "BE": [{ "2014-15": "52.2" }, { "2015-16": "44.8" }, { "2016-17": "48" }, { "2017-18": "40.3" }], "RE": [{ "2014-15": "37.5" }, { "2015-16": "45.9" }, { "2016-17": "56.6" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "38.2" }, { "2014-15": "42.5" }, { "2015-16": "41.9" }], "BE": [{ "2014-15": "46.4" }, { "2015-16": "46.1" }, { "2016-17": "52.5" }, { "2017-18": "54.8" }], "RE": [{ "2014-15": "44.1" }, { "2015-16": "42.7" }, { "2016-17": "49.7" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "8.6" }, { "2014-15": "19" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "10" }, { "2016-17": "6.1" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "10" }, { "2016-17": "6.1" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "38.8" }, { "2014-15": "42.8" }, { "2015-16": "31.5" }], "BE": [{ "2014-15": "60.2" }, { "2015-16": "39.9" }, { "2016-17": "49.3" }, { "2017-18": "62.1" }], "RE": [{ "2014-15": "48.3" }, { "2015-16": "52.5" }, { "2016-17": "49.7" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "21.9" }, { "2014-15": "22.4" }, { "2015-16": "30.4" }], "BE": [{ "2014-15": "36.5" }, { "2015-16": "41" }, { "2016-17": "22.2" }, { "2017-18": "42" }], "RE": [{ "2014-15": "29.8" }, { "2015-16": "20.2" }, { "2016-17": "35.2" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "44" }, { "2014-15": "49" }, { "2015-16": "54.1" }], "BE": [{ "2014-15": "46.9" }, { "2015-16": "44.3" }, { "2016-17": "51.5" }, { "2017-18": "33.9" }], "RE": [{ "2014-15": "44.3" }, { "2015-16": "49.9" }, { "2016-17": "51.7" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "57.7" }, { "2014-15": "67.4" }, { "2015-16": "65.9" }], "BE": [{ "2014-15": "66.1" }, { "2015-16": "61.1" }, { "2016-17": "62.5" }, { "2017-18": "39.3" }], "RE": [{ "2014-15": "70" }, { "2015-16": "67.5" }, { "2016-17": "59.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "39.8" }, { "2014-15": "56.5" }, { "2015-16": "58.7" }], "BE": [{ "2014-15": "59" }, { "2015-16": "68" }, { "2016-17": "69.2" }, { "2017-18": "70.5" }], "RE": [{ "2014-15": "60.3" }, { "2015-16": "65" }, { "2016-17": "64.7" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Irrigation & Water Resources" }, { "category_slug": "forests_environment", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "399.6" }, { "2014-15": "" }, { "2015-16": "305.3" }], "BE": [{ "2014-15": "418.5" }, { "2015-16": "283.8" }, { "2016-17": "357.3" }, { "2017-18": "383.7" }], "RE": [{ "2014-15": "372.8" }, { "2015-16": "286.2" }, { "2016-17": "368.4" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "440.4" }, { "2014-15": "429.2" }, { "2015-16": "425.1" }], "BE": [{ "2014-15": "564.2" }, { "2015-16": "712.9" }, { "2016-17": "928.1" }, { "2017-18": "989" }], "RE": [{ "2014-15": "601.3" }, { "2015-16": "748.6" }, { "2016-17": "945.7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "254.7" }, { "2014-15": "328.5" }, { "2015-16": "288.5" }], "BE": [{ "2014-15": "214.2" }, { "2015-16": "232" }, { "2016-17": "242.3" }, { "2017-18": "319" }], "RE": [{ "2014-15": "346.9" }, { "2015-16": "333.9" }, { "2016-17": "392.3" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1145.6" }, { "2014-15": "1355.4" }, { "2015-16": "1482.3" }], "BE": [{ "2014-15": "1746.6" }, { "2015-16": "1786.2" }, { "2016-17": "2197.9" }, { "2017-18": "2246.9" }], "RE": [{ "2014-15": "1612.2" }, { "2015-16": "2400.6" }, { "2016-17": "2054.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "70.5" }, { "2014-15": "71.5" }, { "2015-16": "73.8" }], "BE": [{ "2014-15": "93" }, { "2015-16": "89.2" }, { "2016-17": "103.2" }, { "2017-18": "123.7" }], "RE": [{ "2014-15": "80.3" }, { "2015-16": "80.1" }, { "2016-17": "90.7" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "741" }, { "2014-15": "888.3" }, { "2015-16": "737.6" }], "BE": [{ "2014-15": "714.4" }, { "2015-16": "824.3" }, { "2016-17": "938.2" }, { "2017-18": "887.1" }], "RE": [{ "2014-15": "807.2" }, { "2015-16": "769.9" }, { "2016-17": "809" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "295.7" }, { "2014-15": "358.5" }, { "2015-16": "364.9" }], "BE": [{ "2014-15": "365.3" }, { "2015-16": "454.7" }, { "2016-17": "455" }, { "2017-18": "530.3" }], "RE": [{ "2014-15": "395.2" }, { "2015-16": "414" }, { "2016-17": "403.4" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "376.3" }, { "2014-15": "390.1" }, { "2015-16": "382.7" }], "BE": [{ "2014-15": "384.4" }, { "2015-16": "410.9" }, { "2016-17": "462.9" }, { "2017-18": "461.6" }], "RE": [{ "2014-15": "398.4" }, { "2015-16": "382.7" }, { "2016-17": "402.4" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "465.8" }, { "2014-15": "487.5" }, { "2015-16": "587.4" }], "BE": [{ "2014-15": "657.3" }, { "2015-16": "717.6" }, { "2016-17": "787.2" }, { "2017-18": "838.4" }], "RE": [{ "2014-15": "621.5" }, { "2015-16": "657.6" }, { "2016-17": "694.9" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "271.1" }, { "2014-15": "379.6" }, { "2015-16": "420.8" }], "BE": [{ "2014-15": "451.7" }, { "2015-16": "492.5" }, { "2016-17": "598.3" }, { "2017-18": "656.2" }], "RE": [{ "2014-15": "467.3" }, { "2015-16": "492.8" }, { "2016-17": "567.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1582.5" }, { "2014-15": "1418.6" }, { "2015-16": "1371.8" }], "BE": [{ "2014-15": "1299.5" }, { "2015-16": "1314" }, { "2016-17": "998.7" }, { "2017-18": "1111.8" }], "RE": [{ "2014-15": "1516.1" }, { "2015-16": "1324" }, { "2016-17": "1596.9" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "428.7" }, { "2014-15": "489.8" }, { "2015-16": "502.2" }], "BE": [{ "2014-15": "538.9" }, { "2015-16": "570.9" }, { "2016-17": "671.6" }, { "2017-18": "756" }], "RE": [{ "2014-15": "477.2" }, { "2015-16": "508.9" }, { "2016-17": "556.4" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2026.1" }, { "2014-15": "2286" }, { "2015-16": "2060.2" }], "BE": [{ "2014-15": "2704.6" }, { "2015-16": "2675.2" }, { "2016-17": "2521.4" }, { "2017-18": "2719" }], "RE": [{ "2014-15": "2595.6" }, { "2015-16": "2331.8" }, { "2016-17": "2273.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "1116.9" }, { "2014-15": "1265.5" }, { "2015-16": "1893.3" }], "BE": [{ "2014-15": "1357.6" }, { "2015-16": "1705.7" }, { "2016-17": "2057.9" }, { "2017-18": "2526.8" }], "RE": [{ "2014-15": "1347.7" }, { "2015-16": "2016.2" }, { "2016-17": "2469.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "122.1" }, { "2014-15": "146.3" }, { "2015-16": "122.8" }], "BE": [{ "2014-15": "219.9" }, { "2015-16": "160.2" }, { "2016-17": "131.9" }, { "2017-18": "152.1" }], "RE": [{ "2014-15": "219.9" }, { "2015-16": "160.2" }, { "2016-17": "131.9" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "92.9" }, { "2014-15": "121.6" }, { "2015-16": "80.1" }], "BE": [{ "2014-15": "110.8" }, { "2015-16": "82.5" }, { "2016-17": "73.1" }, { "2017-18": "76.9" }], "RE": [{ "2014-15": "132.2" }, { "2015-16": "86.6" }, { "2016-17": "139.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "79.2" }, { "2014-15": "97.4" }, { "2015-16": "70.9" }], "BE": [{ "2014-15": "110.9" }, { "2015-16": "77.7" }, { "2016-17": "84.6" }, { "2017-18": "94.5" }], "RE": [{ "2014-15": "101.1" }, { "2015-16": "80.4" }, { "2016-17": "81.4" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "601.5" }, { "2014-15": "645.9" }, { "2015-16": "579.3" }], "BE": [{ "2014-15": "716" }, { "2015-16": "718.6" }, { "2016-17": "603.2" }, { "2017-18": "745" }], "RE": [{ "2014-15": "738.6" }, { "2015-16": "642.3" }, { "2016-17": "651.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "110.6" }, { "2014-15": "111.3" }, { "2015-16": "118.7" }], "BE": [{ "2014-15": "127.3" }, { "2015-16": "112.4" }, { "2016-17": "162.2" }, { "2017-18": "206.4" }], "RE": [{ "2014-15": "130.5" }, { "2015-16": "146" }, { "2016-17": "164.1" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "854.7" }, { "2014-15": "973" }, { "2015-16": "1024" }], "BE": [{ "2014-15": "1253.2" }, { "2015-16": "1070.6" }, { "2016-17": "1058.9" }, { "2017-18": "970.2" }], "RE": [{ "2014-15": "1108.8" }, { "2015-16": "1094.4" }, { "2016-17": "1087.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "126.2" }, { "2014-15": "198" }, { "2015-16": "120.5" }], "BE": [{ "2014-15": "246.7" }, { "2015-16": "215" }, { "2016-17": "164.5" }, { "2017-18": "217.9" }], "RE": [{ "2014-15": "286.2" }, { "2015-16": "215" }, { "2016-17": "224" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "686.8" }, { "2014-15": "635.7" }, { "2015-16": "504.9" }], "BE": [{ "2014-15": "782.5" }, { "2015-16": "653.5" }, { "2016-17": "652.8" }, { "2017-18": "567.5" }], "RE": [{ "2014-15": "775.7" }, { "2015-16": "677.9" }, { "2016-17": "556.2" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "118.2" }, { "2014-15": "125.2" }, { "2015-16": "138.8" }], "BE": [{ "2014-15": "169.9" }, { "2015-16": "165.5" }, { "2016-17": "102.2" }, { "2017-18": "83.3" }], "RE": [{ "2014-15": "186.6" }, { "2015-16": "148.7" }, { "2016-17": "106.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "678.3" }, { "2014-15": "785.5" }, { "2015-16": "850.1" }], "BE": [{ "2014-15": "803.2" }, { "2015-16": "965.1" }, { "2016-17": "1368.1" }, { "2017-18": "986.6" }], "RE": [{ "2014-15": "791.8" }, { "2015-16": "935.3" }, { "2016-17": "1234.3" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "419.8" }, { "2014-15": "527.5" }, { "2015-16": "535.7" }], "BE": [{ "2014-15": "526.3" }, { "2015-16": "626.6" }, { "2016-17": "801.5" }, { "2017-18": "675.6" }], "RE": [{ "2014-15": "654.7" }, { "2015-16": "579.8" }, { "2016-17": "556.4" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "470" }, { "2014-15": "454.6" }, { "2015-16": "572.7" }], "BE": [{ "2014-15": "633.5" }, { "2015-16": "677.7" }, { "2016-17": "757.9" }, { "2017-18": "815.5" }], "RE": [{ "2014-15": "579.4" }, { "2015-16": "672.6" }, { "2016-17": "759.8" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "" }, { "2015-16": "0.2" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.3" }, { "2016-17": "0.3" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "1.2" }, { "2014-15": "0.9" }, { "2015-16": "1" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "1.1" }, { "2016-17": "1.2" }, { "2017-18": "1.2" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "1" }, { "2016-17": "1.1" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "0.3" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0.2" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.3" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "3" }, { "2014-15": "2.9" }, { "2015-16": "2.9" }], "BE": [{ "2014-15": "3.2" }, { "2015-16": "2.7" }, { "2016-17": "3.1" }, { "2017-18": "3" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "3.6" }, { "2016-17": "2.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0.2" }, { "2014-15": "0.2" }, { "2015-16": "0.2" }], "BE": [{ "2014-15": "0.3" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.2" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "0.8" }, { "2015-16": "0.5" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.6" }, { "2016-17": "0.7" }, { "2017-18": "0.5" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.7" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.7" }, { "2016-17": "0.6" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.6" }, { "2016-17": "0.5" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1.8" }, { "2014-15": "1.3" }, { "2015-16": "1.3" }], "BE": [{ "2014-15": "1.6" }, { "2015-16": "1.5" }, { "2016-17": "1.4" }, { "2017-18": "1.3" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "1.4" }, { "2016-17": "1.2" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "1.4" }, { "2015-16": "0.9" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "1.5" }, { "2016-17": "1.7" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "1.3" }, { "2016-17": "1.1" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "0.9" }, { "2014-15": "0.9" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "0.9" }, { "2016-17": "0.9" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "0.9" }, { "2016-17": "0.9" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1.5" }, { "2014-15": "1.1" }, { "2015-16": "1" }], "BE": [{ "2014-15": "1" }, { "2015-16": "1" }, { "2016-17": "0.6" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "1" }, { "2016-17": "1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.6" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.6" }, { "2016-17": "0.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2.4" }, { "2014-15": "2.1" }, { "2015-16": "1.7" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2" }, { "2016-17": "1.6" }, { "2017-18": "1.6" }], "RE": [{ "2014-15": "2.2" }, { "2015-16": "1.8" }, { "2016-17": "1.5" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "0.6" }, { "2014-15": "0.6" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.7" }, { "2016-17": "0.8" }, { "2017-18": "0.8" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "0.8" }, { "2016-17": "0.9" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1.8" }, { "2014-15": "1.9" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "1.8" }, { "2015-16": "1.6" }, { "2016-17": "1.2" }, { "2017-18": "1.2" }], "RE": [{ "2014-15": "1.8" }, { "2015-16": "1.6" }, { "2016-17": "1.2" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "1.6" }, { "2015-16": "1.3" }], "BE": [{ "2014-15": "1.6" }, { "2015-16": "1.1" }, { "2016-17": "0.9" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "1.7" }, { "2015-16": "1" }, { "2016-17": "1.5" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "0.9" }, { "2014-15": "1" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "0.6" }, { "2016-17": "0.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "1" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "0.9" }, { "2016-17": "0.6" }, { "2017-18": "0.7" }], "RE": [{ "2014-15": "1" }, { "2015-16": "0.8" }, { "2016-17": "0.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "0.2" }, { "2014-15": "0.2" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "0.2" }, { "2015-16": "0.1" }, { "2016-17": "0.2" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.2" }, { "2015-16": "0.2" }, { "2016-17": "0.1" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "0.9" }, { "2014-15": "0.8" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "1" }, { "2015-16": "0.8" }, { "2016-17": "0.7" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "0.8" }, { "2016-17": "0.7" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "4.1" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "3.9" }, { "2016-17": "2.9" }, { "2017-18": "3.5" }], "RE": [{ "2014-15": "4.3" }, { "2015-16": "3.8" }, { "2016-17": "3.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "0.5" }, { "2014-15": "0.4" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.4" }, { "2016-17": "0.3" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.5" }, { "2015-16": "0.4" }, { "2016-17": "0.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1.5" }, { "2014-15": "1.2" }, { "2015-16": "1.2" }], "BE": [{ "2014-15": "1.4" }, { "2015-16": "1.1" }, { "2016-17": "0.7" }, { "2017-18": "0.5" }], "RE": [{ "2014-15": "1.5" }, { "2015-16": "1.1" }, { "2016-17": "0.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "0.3" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.4" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "0.3" }, { "2016-17": "0.4" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "1.9" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "1.7" }, { "2015-16": "1.9" }, { "2016-17": "2" }, { "2017-18": "1.7" }], "RE": [{ "2014-15": "2" }, { "2015-16": "1.7" }, { "2016-17": "1.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "0.4" }, { "2014-15": "0.4" }, { "2015-16": "0.4" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.5" }, { "2016-17": "0.5" }, { "2017-18": "0.4" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.5" }, { "2016-17": "0.5" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "80.1" }, { "2014-15": "" }, { "2015-16": "60.5" }], "BE": [{ "2014-15": "83.4" }, { "2015-16": "56.3" }, { "2016-17": "70.4" }, { "2017-18": "75.2" }], "RE": [{ "2014-15": "74.3" }, { "2015-16": "56.7" }, { "2016-17": "72.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "140.6" }, { "2014-15": "135.4" }, { "2015-16": "132.6" }], "BE": [{ "2014-15": "178" }, { "2015-16": "222.3" }, { "2016-17": "286" }, { "2017-18": "301.3" }], "RE": [{ "2014-15": "189.7" }, { "2015-16": "233.4" }, { "2016-17": "291.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "25.4" }, { "2014-15": "32.4" }, { "2015-16": "28.1" }], "BE": [{ "2014-15": "21.1" }, { "2015-16": "22.6" }, { "2016-17": "23.3" }, { "2017-18": "30.3" }], "RE": [{ "2014-15": "34.2" }, { "2015-16": "32.5" }, { "2016-17": "37.8" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "459.9" }, { "2014-15": "537.2" }, { "2015-16": "580" }], "BE": [{ "2014-15": "692.2" }, { "2015-16": "699" }, { "2016-17": "849.3" }, { "2017-18": "857.5" }], "RE": [{ "2014-15": "639" }, { "2015-16": "939.4" }, { "2016-17": "793.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "36.1" }, { "2014-15": "35.6" }, { "2015-16": "35.7" }], "BE": [{ "2014-15": "46.3" }, { "2015-16": "43.1" }, { "2016-17": "48.5" }, { "2017-18": "56.6" }], "RE": [{ "2014-15": "40" }, { "2015-16": "38.7" }, { "2016-17": "42.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "282.1" }, { "2014-15": "333" }, { "2015-16": "272.4" }], "BE": [{ "2014-15": "267.8" }, { "2015-16": "304.4" }, { "2016-17": "341.5" }, { "2017-18": "318.1" }], "RE": [{ "2014-15": "302.6" }, { "2015-16": "284.3" }, { "2016-17": "294.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "48.8" }, { "2014-15": "58.5" }, { "2015-16": "58.8" }], "BE": [{ "2014-15": "59.6" }, { "2015-16": "73.3" }, { "2016-17": "72.4" }, { "2017-18": "83.4" }], "RE": [{ "2014-15": "64.4" }, { "2015-16": "66.7" }, { "2016-17": "64.2" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "543.9" }, { "2014-15": "559" }, { "2015-16": "543.8" }], "BE": [{ "2014-15": "550.9" }, { "2015-16": "584" }, { "2016-17": "652.4" }, { "2017-18": "645.2" }], "RE": [{ "2014-15": "570.9" }, { "2015-16": "543.8" }, { "2016-17": "567.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "387.9" }, { "2014-15": "401.1" }, { "2015-16": "478" }], "BE": [{ "2014-15": "540.9" }, { "2015-16": "583.9" }, { "2016-17": "633.9" }, { "2017-18": "667.6" }], "RE": [{ "2014-15": "511.5" }, { "2015-16": "535.1" }, { "2016-17": "559.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "83.8" }, { "2014-15": "115.8" }, { "2015-16": "126.7" }], "BE": [{ "2014-15": "137.9" }, { "2015-16": "148.3" }, { "2016-17": "177.8" }, { "2017-18": "192.5" }], "RE": [{ "2014-15": "142.6" }, { "2015-16": "148.4" }, { "2016-17": "168.7" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "261" }, { "2014-15": "231.7" }, { "2015-16": "222" }], "BE": [{ "2014-15": "212.3" }, { "2015-16": "212.6" }, { "2016-17": "160.1" }, { "2017-18": "176.6" }], "RE": [{ "2014-15": "247.7" }, { "2015-16": "214.2" }, { "2016-17": "256" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "122.4" }, { "2014-15": "138.9" }, { "2015-16": "141.6" }], "BE": [{ "2014-15": "152.9" }, { "2015-16": "160.9" }, { "2016-17": "188.3" }, { "2017-18": "210.6" }], "RE": [{ "2014-15": "135.3" }, { "2015-16": "143.5" }, { "2016-17": "156" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "272" }, { "2014-15": "302.3" }, { "2015-16": "268.4" }], "BE": [{ "2014-15": "357.7" }, { "2015-16": "348.6" }, { "2016-17": "323.8" }, { "2017-18": "344.2" }], "RE": [{ "2014-15": "343.3" }, { "2015-16": "303.8" }, { "2016-17": "292" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "96.5" }, { "2014-15": "108" }, { "2015-16": "159.6" }], "BE": [{ "2014-15": "115.8" }, { "2015-16": "143.8" }, { "2016-17": "171.4" }, { "2017-18": "207.9" }], "RE": [{ "2014-15": "115" }, { "2015-16": "169.9" }, { "2016-17": "205.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "455.4" }, { "2014-15": "539.4" }, { "2015-16": "447.7" }], "BE": [{ "2014-15": "810.7" }, { "2015-16": "584.2" }, { "2016-17": "475.7" }, { "2017-18": "542.6" }], "RE": [{ "2014-15": "810.7" }, { "2015-16": "584.2" }, { "2016-17": "475.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "903.3" }, { "2014-15": "1170.8" }, { "2015-16": "762.6" }], "BE": [{ "2014-15": "1066.5" }, { "2015-16": "784.8" }, { "2016-17": "688.1" }, { "2017-18": "715.5" }], "RE": [{ "2014-15": "1272.6" }, { "2015-16": "823.9" }, { "2016-17": "1308.2" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "344.1" }, { "2014-15": "418.5" }, { "2015-16": "301.4" }], "BE": [{ "2014-15": "476.4" }, { "2015-16": "329.9" }, { "2016-17": "355.3" }, { "2017-18": "392.7" }], "RE": [{ "2014-15": "429.4" }, { "2015-16": "341.4" }, { "2016-17": "342.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "145.1" }, { "2014-15": "154.5" }, { "2015-16": "137.5" }], "BE": [{ "2014-15": "171.3" }, { "2015-16": "170.5" }, { "2016-17": "142" }, { "2017-18": "174" }], "RE": [{ "2014-15": "176.7" }, { "2015-16": "152.4" }, { "2016-17": "153.4" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "39.1" }, { "2014-15": "39" }, { "2015-16": "41.1" }], "BE": [{ "2014-15": "44.6" }, { "2015-16": "39" }, { "2016-17": "55.7" }, { "2017-18": "70.2" }], "RE": [{ "2014-15": "45.7" }, { "2015-16": "50.6" }, { "2016-17": "56.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "122.2" }, { "2014-15": "137.1" }, { "2015-16": "142.3" }], "BE": [{ "2014-15": "176.6" }, { "2015-16": "148.8" }, { "2016-17": "145.2" }, { "2017-18": "131.2" }], "RE": [{ "2014-15": "156.2" }, { "2015-16": "152.1" }, { "2016-17": "149.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2016.3" }, { "2014-15": "3128.3" }, { "2015-16": "1882.4" }], "BE": [{ "2014-15": "3897.3" }, { "2015-16": "3360.1" }, { "2016-17": "2542.3" }, { "2017-18": "3331.2" }], "RE": [{ "2014-15": "4521.9" }, { "2015-16": "3360.1" }, { "2016-17": "3462.3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "100.6" }, { "2014-15": "92.6" }, { "2015-16": "73.1" }], "BE": [{ "2014-15": "114" }, { "2015-16": "94.7" }, { "2016-17": "94.1" }, { "2017-18": "81.3" }], "RE": [{ "2014-15": "113" }, { "2015-16": "98.2" }, { "2016-17": "80.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "319.4" }, { "2014-15": "334.5" }, { "2015-16": "366.9" }], "BE": [{ "2014-15": "454.1" }, { "2015-16": "437.2" }, { "2016-17": "267.1" }, { "2017-18": "215.4" }], "RE": [{ "2014-15": "498.6" }, { "2015-16": "392.9" }, { "2016-17": "277.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "32.7" }, { "2014-15": "37.2" }, { "2015-16": "39.6" }], "BE": [{ "2014-15": "38" }, { "2015-16": "45" }, { "2016-17": "62.7" }, { "2017-18": "44.5" }], "RE": [{ "2014-15": "37.5" }, { "2015-16": "43.6" }, { "2016-17": "56.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "410.6" }, { "2014-15": "505.2" }, { "2015-16": "486.7" }], "BE": [{ "2014-15": "507.9" }, { "2015-16": "592.1" }, { "2016-17": "719" }, { "2017-18": "591.1" }], "RE": [{ "2014-15": "631.8" }, { "2015-16": "540.7" }, { "2016-17": "492.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "51.6" }, { "2014-15": "49.5" }, { "2015-16": "61.8" }], "BE": [{ "2014-15": "68.9" }, { "2015-16": "73.1" }, { "2016-17": "81" }, { "2017-18": "86.4" }], "RE": [{ "2014-15": "63" }, { "2015-16": "72.5" }, { "2016-17": "81.2" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "99.7" }, { "2014-15": "" }, { "2015-16": "92.1" }], "BE": [{ "2014-15": "100" }, { "2015-16": "99.8" }, { "2016-17": "99.8" }, { "2017-18": "99.7" }], "RE": [{ "2014-15": "100" }, { "2015-16": "93.3" }, { "2016-17": "99.7" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "99.8" }, { "2014-15": "99.8" }, { "2015-16": "100.1" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "98.5" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "91.3" }, { "2014-15": "93" }, { "2015-16": "94.8" }], "BE": [{ "2014-15": "95.8" }, { "2015-16": "99.1" }, { "2016-17": "99" }, { "2017-18": "99.4" }], "RE": [{ "2014-15": "92.9" }, { "2015-16": "93.4" }, { "2016-17": "90.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "92.3" }, { "2014-15": "78.1" }, { "2015-16": "78.2" }], "BE": [{ "2014-15": "70.5" }, { "2015-16": "78.2" }, { "2016-17": "70.2" }, { "2017-18": "69.4" }], "RE": [{ "2014-15": "77" }, { "2015-16": "60.3" }, { "2016-17": "66.1" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "80.4" }, { "2014-15": "78.5" }, { "2015-16": "76.9" }], "BE": [{ "2014-15": "77.6" }, { "2015-16": "80.8" }, { "2016-17": "80.1" }, { "2017-18": "74.9" }], "RE": [{ "2014-15": "79.5" }, { "2015-16": "77.1" }, { "2016-17": "76.8" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "45.6" }, { "2014-15": "52.1" }, { "2015-16": "50.4" }], "BE": [{ "2014-15": "52.3" }, { "2015-16": "52.9" }, { "2016-17": "55.5" }, { "2017-18": "51.9" }], "RE": [{ "2014-15": "59.6" }, { "2015-16": "49.9" }, { "2016-17": "54.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "99.3" }, { "2014-15": "99.4" }, { "2015-16": "98.1" }], "BE": [{ "2014-15": "99.4" }, { "2015-16": "99.5" }, { "2016-17": "98.2" }, { "2017-18": "98" }], "RE": [{ "2014-15": "99.4" }, { "2015-16": "98.1" }, { "2016-17": "98.7" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "94.4" }, { "2015-16": "95.3" }, { "2016-17": "91.2" }, { "2017-18": "85.5" }], "RE": [{ "2014-15": "93.9" }, { "2015-16": "94.7" }, { "2016-17": "92.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "99.2" }, { "2015-16": "100" }], "BE": [{ "2014-15": "98.9" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "98.9" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "99.2" }, { "2014-15": "99.4" }, { "2015-16": "99.1" }], "BE": [{ "2014-15": "99" }, { "2015-16": "99.1" }, { "2016-17": "97.3" }, { "2017-18": "98.2" }], "RE": [{ "2014-15": "99.2" }, { "2015-16": "99.1" }, { "2016-17": "96.7" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "91.8" }, { "2014-15": "91.3" }, { "2015-16": "88.2" }], "BE": [{ "2014-15": "87.9" }, { "2015-16": "85.6" }, { "2016-17": "83.7" }, { "2017-18": "84.6" }], "RE": [{ "2014-15": "94.2" }, { "2015-16": "87.7" }, { "2016-17": "85.3" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "95.4" }, { "2014-15": "97.6" }, { "2015-16": "97.8" }], "BE": [{ "2014-15": "97" }, { "2015-16": "97.8" }, { "2016-17": "72.9" }, { "2017-18": "85.7" }], "RE": [{ "2014-15": "96.9" }, { "2015-16": "97.6" }, { "2016-17": "73.7" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "98.7" }, { "2014-15": "96" }, { "2015-16": "93.2" }], "BE": [{ "2014-15": "97.8" }, { "2015-16": "95" }, { "2016-17": "92.2" }, { "2017-18": "91.6" }], "RE": [{ "2014-15": "96.2" }, { "2015-16": "93.7" }, { "2016-17": "78.9" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "99.5" }, { "2014-15": "99.8" }, { "2015-16": "100" }], "BE": [{ "2014-15": "98.6" }, { "2015-16": "93.6" }, { "2016-17": "99.5" }, { "2017-18": "99.8" }], "RE": [{ "2014-15": "98.6" }, { "2015-16": "93.6" }, { "2016-17": "99.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "99.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "65.9" }, { "2014-15": "98.2" }, { "2015-16": "97.3" }], "BE": [{ "2014-15": "99.1" }, { "2015-16": "97.4" }, { "2016-17": "97.6" }, { "2017-18": "98.9" }], "RE": [{ "2014-15": "98" }, { "2015-16": "97.5" }, { "2016-17": "97.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "99.6" }, { "2014-15": "99.5" }, { "2015-16": "99.3" }], "BE": [{ "2014-15": "99.5" }, { "2015-16": "99.5" }, { "2016-17": "99.3" }, { "2017-18": "99.6" }], "RE": [{ "2014-15": "99.5" }, { "2015-16": "99.4" }, { "2016-17": "99.4" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "98.4" }, { "2015-16": "100" }, { "2016-17": "96.4" }, { "2017-18": "98" }], "RE": [{ "2014-15": "98.5" }, { "2015-16": "98.3" }, { "2016-17": "99.1" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "71.6" }, { "2014-15": "77.7" }, { "2015-16": "80.5" }], "BE": [{ "2014-15": "72.9" }, { "2015-16": "84.7" }, { "2016-17": "88.8" }, { "2017-18": "85.5" }], "RE": [{ "2014-15": "77.6" }, { "2015-16": "79.7" }, { "2016-17": "81.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "98.1" }, { "2014-15": "99.6" }, { "2015-16": "97.4" }], "BE": [{ "2014-15": "99.3" }, { "2015-16": "97" }, { "2016-17": "96.7" }, { "2017-18": "99.1" }], "RE": [{ "2014-15": "99.4" }, { "2015-16": "97" }, { "2016-17": "97.5" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "48.4" }, { "2014-15": "54.7" }, { "2015-16": "65.6" }], "BE": [{ "2014-15": "51.2" }, { "2015-16": "69.7" }, { "2016-17": "76.2" }, { "2017-18": "68" }], "RE": [{ "2014-15": "57.5" }, { "2015-16": "77.3" }, { "2016-17": "71.9" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "81.3" }, { "2014-15": "82.3" }, { "2015-16": "63.4" }], "BE": [{ "2014-15": "82.1" }, { "2015-16": "75.1" }, { "2016-17": "65" }, { "2017-18": "96.3" }], "RE": [{ "2014-15": "77.6" }, { "2015-16": "82.9" }, { "2016-17": "64.2" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "69.4" }, { "2014-15": "65.2" }, { "2015-16": "61.8" }], "BE": [{ "2014-15": "70.2" }, { "2015-16": "64.9" }, { "2016-17": "50" }, { "2017-18": "76.3" }], "RE": [{ "2014-15": "67.1" }, { "2015-16": "60.9" }, { "2016-17": "50.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "88.3" }, { "2014-15": "90.4" }, { "2015-16": "81.3" }], "BE": [{ "2014-15": "93.8" }, { "2015-16": "79.8" }, { "2016-17": "80.6" }, { "2017-18": "92" }], "RE": [{ "2014-15": "91" }, { "2015-16": "79.7" }, { "2016-17": "79.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "97.9" }, { "2014-15": "97.2" }, { "2015-16": "98.2" }], "BE": [{ "2014-15": "97.5" }, { "2015-16": "96.3" }, { "2016-17": "95.4" }, { "2017-18": "97.7" }], "RE": [{ "2014-15": "97.3" }, { "2015-16": "96.3" }, { "2016-17": "97.3" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "" }, { "2015-16": "7.9" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0.2" }, { "2016-17": "0.2" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0" }, { "2015-16": "6.7" }, { "2016-17": "0.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0.2" }, { "2014-15": "0.2" }, { "2015-16": "-0.1" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "1.5" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "8.7" }, { "2014-15": "7" }, { "2015-16": "5.2" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "0.9" }, { "2016-17": "1" }, { "2017-18": "0.6" }], "RE": [{ "2014-15": "7.1" }, { "2015-16": "6.6" }, { "2016-17": "9.9" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "7.7" }, { "2014-15": "21.9" }, { "2015-16": "21.8" }], "BE": [{ "2014-15": "29.5" }, { "2015-16": "21.8" }, { "2016-17": "29.8" }, { "2017-18": "30.6" }], "RE": [{ "2014-15": "23" }, { "2015-16": "39.7" }, { "2016-17": "33.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "19.6" }, { "2014-15": "21.5" }, { "2015-16": "23.1" }], "BE": [{ "2014-15": "22.4" }, { "2015-16": "19.2" }, { "2016-17": "19.9" }, { "2017-18": "25.1" }], "RE": [{ "2014-15": "20.5" }, { "2015-16": "22.9" }, { "2016-17": "23.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "54.4" }, { "2014-15": "47.9" }, { "2015-16": "49.6" }], "BE": [{ "2014-15": "47.7" }, { "2015-16": "47.1" }, { "2016-17": "44.5" }, { "2017-18": "48.1" }], "RE": [{ "2014-15": "40.4" }, { "2015-16": "50.1" }, { "2016-17": "45.4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "0.6" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.5" }, { "2016-17": "1.8" }, { "2017-18": "2" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "1.9" }, { "2016-17": "1.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "5.6" }, { "2015-16": "4.7" }, { "2016-17": "8.8" }, { "2017-18": "14.5" }], "RE": [{ "2014-15": "6.1" }, { "2015-16": "5.3" }, { "2016-17": "7.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0.8" }, { "2015-16": "0" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "1.1" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.6" }, { "2015-16": "0.9" }], "BE": [{ "2014-15": "1" }, { "2015-16": "0.9" }, { "2016-17": "2.7" }, { "2017-18": "1.8" }], "RE": [{ "2014-15": "0.8" }, { "2015-16": "0.9" }, { "2016-17": "3.3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "8.2" }, { "2014-15": "8.7" }, { "2015-16": "11.8" }], "BE": [{ "2014-15": "12.1" }, { "2015-16": "14.4" }, { "2016-17": "16.3" }, { "2017-18": "15.4" }], "RE": [{ "2014-15": "5.8" }, { "2015-16": "12.3" }, { "2016-17": "14.7" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "4.6" }, { "2014-15": "2.4" }, { "2015-16": "2.2" }], "BE": [{ "2014-15": "3" }, { "2015-16": "2.2" }, { "2016-17": "27.1" }, { "2017-18": "14.3" }], "RE": [{ "2014-15": "3.1" }, { "2015-16": "2.4" }, { "2016-17": "26.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "1.3" }, { "2014-15": "4" }, { "2015-16": "6.8" }], "BE": [{ "2014-15": "2.2" }, { "2015-16": "5" }, { "2016-17": "7.8" }, { "2017-18": "8.4" }], "RE": [{ "2014-15": "3.8" }, { "2015-16": "6.3" }, { "2016-17": "21.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "0.5" }, { "2014-15": "0.2" }, { "2015-16": "0" }], "BE": [{ "2014-15": "1.4" }, { "2015-16": "6.4" }, { "2016-17": "0.5" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "6.4" }, { "2016-17": "0.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0.3" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "34.1" }, { "2014-15": "1.8" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "2.6" }, { "2016-17": "2.4" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "2" }, { "2015-16": "2.5" }, { "2016-17": "2.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "0.4" }, { "2014-15": "0.5" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "0.5" }, { "2015-16": "0.5" }, { "2016-17": "0.7" }, { "2017-18": "0.4" }], "RE": [{ "2014-15": "0.5" }, { "2015-16": "0.6" }, { "2016-17": "0.6" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "1.6" }, { "2015-16": "0" }, { "2016-17": "3.6" }, { "2017-18": "2" }], "RE": [{ "2014-15": "1.5" }, { "2015-16": "1.7" }, { "2016-17": "0.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "28.4" }, { "2014-15": "22.3" }, { "2015-16": "19.5" }], "BE": [{ "2014-15": "27.1" }, { "2015-16": "15.3" }, { "2016-17": "11.2" }, { "2017-18": "14.5" }], "RE": [{ "2014-15": "22.4" }, { "2015-16": "20.3" }, { "2016-17": "18.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "0.4" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "0.7" }, { "2015-16": "3" }, { "2016-17": "3.3" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "0.6" }, { "2015-16": "3" }, { "2016-17": "2.5" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "51.6" }, { "2014-15": "45.3" }, { "2015-16": "34.4" }], "BE": [{ "2014-15": "48.8" }, { "2015-16": "30.3" }, { "2016-17": "23.8" }, { "2017-18": "32" }], "RE": [{ "2014-15": "42.5" }, { "2015-16": "22.7" }, { "2016-17": "28.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "18.7" }, { "2014-15": "17.7" }, { "2015-16": "36.6" }], "BE": [{ "2014-15": "17.9" }, { "2015-16": "24.9" }, { "2016-17": "35" }, { "2017-18": "3.7" }], "RE": [{ "2014-15": "22.4" }, { "2015-16": "17.1" }, { "2016-17": "35.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "30.6" }, { "2014-15": "34.8" }, { "2015-16": "38.2" }], "BE": [{ "2014-15": "29.8" }, { "2015-16": "35.1" }, { "2016-17": "50" }, { "2017-18": "23.7" }], "RE": [{ "2014-15": "32.9" }, { "2015-16": "39.1" }, { "2016-17": "49.9" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "11.7" }, { "2014-15": "9.6" }, { "2015-16": "18.7" }], "BE": [{ "2014-15": "6.2" }, { "2015-16": "20.2" }, { "2016-17": "19.4" }, { "2017-18": "8" }], "RE": [{ "2014-15": "9" }, { "2015-16": "20.3" }, { "2016-17": "20.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "2.8" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "2.5" }, { "2015-16": "3.7" }, { "2016-17": "4.6" }, { "2017-18": "2.3" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "3.7" }, { "2016-17": "2.7" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Forests & Environment" }, { "category_slug": "urban_development_housing", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "5121" }, { "2014-15": "" }, { "2015-16": "5259.9" }], "BE": [{ "2014-15": "2862.7" }, { "2015-16": "4066.3" }, { "2016-17": "5861.8" }, { "2017-18": "6664" }], "RE": [{ "2014-15": "2825.2" }, { "2015-16": "2757.6" }, { "2016-17": "7793.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "424.1" }, { "2014-15": "396.5" }, { "2015-16": "331.4" }], "BE": [{ "2014-15": "1004.3" }, { "2015-16": "893.9" }, { "2016-17": "1590.8" }, { "2017-18": "2893.2" }], "RE": [{ "2014-15": "1158.5" }, { "2015-16": "1150" }, { "2016-17": "2063.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "1718" }, { "2014-15": "1745.9" }, { "2015-16": "1932.7" }], "BE": [{ "2014-15": "2420.9" }, { "2015-16": "2169.9" }, { "2016-17": "3409.4" }, { "2017-18": "4335" }], "RE": [{ "2014-15": "3301.6" }, { "2015-16": "2662.4" }, { "2016-17": "3799.7" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "1808" }, { "2015-16": "1779.2" }], "BE": [{ "2014-15": "0" }, { "2015-16": "2992" }, { "2016-17": "3819.8" }, { "2017-18": "3753.7" }], "RE": [{ "2014-15": "0" }, { "2015-16": "3195" }, { "2016-17": "4431.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "6333.1" }, { "2014-15": "5884.6" }, { "2015-16": "6553.1" }], "BE": [{ "2014-15": "7536.1" }, { "2015-16": "6639.2" }, { "2016-17": "7900.6" }, { "2017-18": "7931.3" }], "RE": [{ "2014-15": "6474.8" }, { "2015-16": "6997" }, { "2016-17": "6880.8" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "7308.8" }, { "2014-15": "7557.9" }, { "2015-16": "8599.5" }], "BE": [{ "2014-15": "8662.2" }, { "2015-16": "9361.1" }, { "2016-17": "10018.4" }, { "2017-18": "10160.1" }], "RE": [{ "2014-15": "8516.2" }, { "2015-16": "9239.2" }, { "2016-17": "9561.1" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2074.2" }, { "2014-15": "2120.2" }, { "2015-16": "2286.9" }], "BE": [{ "2014-15": "3059.7" }, { "2015-16": "3564.3" }, { "2016-17": "3805.1" }, { "2017-18": "5117" }], "RE": [{ "2014-15": "2588.2" }, { "2015-16": "3339.2" }, { "2016-17": "3542.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "286.5" }, { "2014-15": "201" }, { "2015-16": "315.7" }], "BE": [{ "2014-15": "196.3" }, { "2015-16": "230.4" }, { "2016-17": "285.3" }, { "2017-18": "362.3" }], "RE": [{ "2014-15": "205" }, { "2015-16": "315.8" }, { "2016-17": "564.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "366.7" }, { "2014-15": "592.1" }, { "2015-16": "610.7" }], "BE": [{ "2014-15": "1198.4" }, { "2015-16": "1142.5" }, { "2016-17": "1399" }, { "2017-18": "1680" }], "RE": [{ "2014-15": "898.3" }, { "2015-16": "964.2" }, { "2016-17": "1450.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "515.7" }, { "2014-15": "1068.6" }, { "2015-16": "1621" }], "BE": [{ "2014-15": "1869.3" }, { "2015-16": "1726.2" }, { "2016-17": "2414.2" }, { "2017-18": "2584.5" }], "RE": [{ "2014-15": "1237.7" }, { "2015-16": "1605.3" }, { "2016-17": "2926.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "7826.7" }, { "2014-15": "9338.1" }, { "2015-16": "12063.1" }], "BE": [{ "2014-15": "10993" }, { "2015-16": "11968.4" }, { "2016-17": "14918.8" }, { "2017-18": "18439.8" }], "RE": [{ "2014-15": "10740.7" }, { "2015-16": "11664.3" }, { "2016-17": "14526.7" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "656.2" }, { "2014-15": "468.3" }, { "2015-16": "428.8" }], "BE": [{ "2014-15": "1502.6" }, { "2015-16": "1079.7" }, { "2016-17": "1482.5" }, { "2017-18": "1727.7" }], "RE": [{ "2014-15": "949.5" }, { "2015-16": "728.3" }, { "2016-17": "1080.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "5829.4" }, { "2014-15": "5817.5" }, { "2015-16": "9623.9" }], "BE": [{ "2014-15": "7032.5" }, { "2015-16": "7463.3" }, { "2016-17": "11735.8" }, { "2017-18": "12412.9" }], "RE": [{ "2014-15": "7083.3" }, { "2015-16": "10479.5" }, { "2016-17": "10756.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "6477.2" }, { "2014-15": "6691.6" }, { "2015-16": "11311.3" }], "BE": [{ "2014-15": "7476" }, { "2015-16": "7505.7" }, { "2016-17": "18131.4" }, { "2017-18": "21714" }], "RE": [{ "2014-15": "9291.2" }, { "2015-16": "12227.7" }, { "2016-17": "20656.5" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "156.2" }, { "2014-15": "86.9" }, { "2015-16": "116.4" }], "BE": [{ "2014-15": "351.6" }, { "2015-16": "100.7" }, { "2016-17": "157.7" }, { "2017-18": "356.7" }], "RE": [{ "2014-15": "351.6" }, { "2015-16": "100.7" }, { "2016-17": "157.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "185" }, { "2014-15": "267.4" }, { "2015-16": "197.3" }], "BE": [{ "2014-15": "318.8" }, { "2015-16": "239.5" }, { "2016-17": "193.8" }, { "2017-18": "423.6" }], "RE": [{ "2014-15": "376.4" }, { "2015-16": "286.7" }, { "2016-17": "322.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "136.3" }, { "2014-15": "84" }, { "2015-16": "70.9" }], "BE": [{ "2014-15": "278.8" }, { "2015-16": "151.1" }, { "2016-17": "128.2" }, { "2017-18": "174.6" }], "RE": [{ "2014-15": "155.2" }, { "2015-16": "203.1" }, { "2016-17": "237.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2493.2" }, { "2014-15": "2339.8" }, { "2015-16": "2711" }], "BE": [{ "2014-15": "3031.6" }, { "2015-16": "2925.3" }, { "2016-17": "3357.1" }, { "2017-18": "4477.6" }], "RE": [{ "2014-15": "2794.3" }, { "2015-16": "2414.3" }, { "2016-17": "3334.5" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "662.8" }, { "2014-15": "1094.2" }, { "2015-16": "781" }], "BE": [{ "2014-15": "2030.9" }, { "2015-16": "958.3" }, { "2016-17": "2268.2" }, { "2017-18": "4610.6" }], "RE": [{ "2014-15": "1364.5" }, { "2015-16": "1298.8" }, { "2016-17": "2193.6" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "3776" }, { "2014-15": "3401.3" }, { "2015-16": "3954" }], "BE": [{ "2014-15": "4843.5" }, { "2015-16": "4296" }, { "2016-17": "6658.1" }, { "2017-18": "6367.1" }], "RE": [{ "2014-15": "3982.5" }, { "2015-16": "4978.3" }, { "2016-17": "6554.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "114.6" }, { "2014-15": "119" }, { "2015-16": "84.7" }], "BE": [{ "2014-15": "277.3" }, { "2015-16": "128.3" }, { "2016-17": "178" }, { "2017-18": "151.9" }], "RE": [{ "2014-15": "288" }, { "2015-16": "135.7" }, { "2016-17": "211.5" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "10388.9" }, { "2014-15": "10521.8" }, { "2015-16": "10436.4" }], "BE": [{ "2014-15": "11677" }, { "2015-16": "11623.8" }, { "2016-17": "14277.5" }, { "2017-18": "16647.7" }], "RE": [{ "2014-15": "12287.2" }, { "2015-16": "14572" }, { "2016-17": "14262.8" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "221.7" }, { "2014-15": "333.4" }, { "2015-16": "183.6" }], "BE": [{ "2014-15": "384.2" }, { "2015-16": "518.7" }, { "2016-17": "240.8" }, { "2017-18": "443.7" }], "RE": [{ "2014-15": "572.4" }, { "2015-16": "303.3" }, { "2016-17": "437.2" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "3236.4" }, { "2014-15": "5689.6" }, { "2015-16": "7463.8" }], "BE": [{ "2014-15": "7824.6" }, { "2015-16": "8125.3" }, { "2016-17": "11276.6" }, { "2017-18": "14452.9" }], "RE": [{ "2014-15": "8261.6" }, { "2015-16": "9001.3" }, { "2016-17": "10863.5" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "180.3" }, { "2014-15": "189.4" }, { "2015-16": "588.2" }], "BE": [{ "2014-15": "787.5" }, { "2015-16": "496.7" }, { "2016-17": "868.9" }, { "2017-18": "536.1" }], "RE": [{ "2014-15": "382" }, { "2015-16": "742.5" }, { "2016-17": "299.4" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2610.9" }, { "2014-15": "2492.1" }, { "2015-16": "2817.4" }], "BE": [{ "2014-15": "3018" }, { "2015-16": "3457.7" }, { "2016-17": "3651.7" }, { "2017-18": "11221.1" }], "RE": [{ "2014-15": "3114.2" }, { "2015-16": "3182.7" }, { "2016-17": "3067.6" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "3.7" }, { "2014-15": "" }, { "2015-16": "3.5" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "3.6" }, { "2016-17": "4.3" }, { "2017-18": "4.2" }], "RE": [{ "2014-15": "2.5" }, { "2015-16": "2.5" }, { "2016-17": "5.9" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "0.8" }, { "2015-16": "0.8" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "1.4" }, { "2016-17": "2" }, { "2017-18": "3.4" }], "RE": [{ "2014-15": "1.8" }, { "2015-16": "1.5" }, { "2016-17": "2.5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "1.8" }, { "2015-16": "1.7" }], "BE": [{ "2014-15": "2.1" }, { "2015-16": "1.8" }, { "2016-17": "2.4" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "2.5" }, { "2015-16": "2" }, { "2016-17": "2.5" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "3.9" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "0" }, { "2015-16": "4.6" }, { "2016-17": "5.5" }, { "2017-18": "4.9" }], "RE": [{ "2014-15": "0" }, { "2015-16": "4.8" }, { "2016-17": "6.3" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "18.6" }, { "2014-15": "19" }, { "2015-16": "18.6" }], "BE": [{ "2014-15": "20.5" }, { "2015-16": "16.1" }, { "2016-17": "17" }, { "2017-18": "16.5" }], "RE": [{ "2014-15": "18.6" }, { "2015-16": "18.4" }, { "2016-17": "16.7" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "7" }, { "2014-15": "6.5" }, { "2015-16": "5.7" }], "BE": [{ "2014-15": "6.6" }, { "2015-16": "6.8" }, { "2016-17": "7.9" }, { "2017-18": "5.9" }], "RE": [{ "2014-15": "6.8" }, { "2015-16": "6.9" }, { "2016-17": "6.5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "3.9" }, { "2015-16": "3.7" }], "BE": [{ "2014-15": "5.1" }, { "2015-16": "5.2" }, { "2016-17": "4.9" }, { "2017-18": "6" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "4.9" }, { "2016-17": "4.8" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1.3" }, { "2014-15": "0.6" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "0.8" }, { "2015-16": "0.8" }, { "2016-17": "0.9" }, { "2017-18": "1" }], "RE": [{ "2014-15": "0.7" }, { "2015-16": "1.2" }, { "2016-17": "1.6" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "1.7" }, { "2015-16": "0.9" }], "BE": [{ "2014-15": "2.8" }, { "2015-16": "2.5" }, { "2016-17": "3.1" }, { "2017-18": "2.1" }], "RE": [{ "2014-15": "2.1" }, { "2015-16": "1.9" }, { "2016-17": "2.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "2.7" }, { "2015-16": "3" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "3.1" }, { "2016-17": "3.8" }, { "2017-18": "3.4" }], "RE": [{ "2014-15": "2.4" }, { "2015-16": "2.9" }, { "2016-17": "4.4" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "7.3" }, { "2014-15": "7.5" }, { "2015-16": "8.7" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "8.8" }, { "2016-17": "9.5" }, { "2017-18": "10.3" }], "RE": [{ "2014-15": "8.4" }, { "2015-16": "8.4" }, { "2016-17": "9.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1" }, { "2014-15": "0.6" }, { "2015-16": "0.5" }], "BE": [{ "2014-15": "1.9" }, { "2015-16": "1.1" }, { "2016-17": "1.4" }, { "2017-18": "1.4" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "0.8" }, { "2016-17": "1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "5.4" }, { "2015-16": "8" }], "BE": [{ "2014-15": "6" }, { "2015-16": "5.7" }, { "2016-17": "7.4" }, { "2017-18": "7.3" }], "RE": [{ "2014-15": "6" }, { "2015-16": "7.9" }, { "2016-17": "6.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "3.1" }, { "2015-16": "5" }], "BE": [{ "2014-15": "3.3" }, { "2015-16": "3.1" }, { "2016-17": "6.7" }, { "2017-18": "7.2" }], "RE": [{ "2014-15": "4" }, { "2015-16": "4.9" }, { "2016-17": "7.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "2.2" }, { "2014-15": "1.1" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "1" }, { "2016-17": "1.5" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "1" }, { "2016-17": "1.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "3.4" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "3.1" }, { "2016-17": "2.5" }, { "2017-18": "5" }], "RE": [{ "2014-15": "4.8" }, { "2015-16": "3.5" }, { "2016-17": "3.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "0.8" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "2.2" }, { "2015-16": "1.2" }, { "2016-17": "0.9" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "1.6" }, { "2016-17": "1.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "4.4" }, { "2014-15": "3.5" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "3.5" }, { "2016-17": "3.6" }, { "2017-18": "4.2" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "2.9" }, { "2016-17": "3.6" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "1.5" }, { "2015-16": "1" }], "BE": [{ "2014-15": "2.8" }, { "2015-16": "1.2" }, { "2016-17": "2.6" }, { "2017-18": "3.9" }], "RE": [{ "2014-15": "1.8" }, { "2015-16": "1.7" }, { "2016-17": "1.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "2.9" }, { "2015-16": "3" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "3.1" }, { "2016-17": "4.4" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "3.2" }, { "2015-16": "3.6" }, { "2016-17": "4.4" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2.6" }, { "2014-15": "2.5" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "2.3" }, { "2016-17": "3.1" }, { "2017-18": "2.4" }], "RE": [{ "2014-15": "4.3" }, { "2015-16": "2.4" }, { "2016-17": "3.5" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "8.1" }, { "2014-15": "6.7" }, { "2015-16": "6.2" }], "BE": [{ "2014-15": "7.6" }, { "2015-16": "6.7" }, { "2016-17": "7.2" }, { "2017-18": "7.6" }], "RE": [{ "2014-15": "7.7" }, { "2015-16": "8.2" }, { "2016-17": "6.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "3.1" }, { "2015-16": "1.6" }], "BE": [{ "2014-15": "3.1" }, { "2015-16": "3.5" }, { "2016-17": "1.6" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "4.6" }, { "2015-16": "2.3" }, { "2016-17": "2.9" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "2.4" }, { "2015-16": "2.5" }], "BE": [{ "2014-15": "2.8" }, { "2015-16": "2.7" }, { "2016-17": "3.3" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "3.1" }, { "2015-16": "2.7" }, { "2016-17": "3.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "0.8" }, { "2014-15": "0.7" }, { "2015-16": "2" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "1.5" }, { "2016-17": "2.1" }, { "2017-18": "1.3" }], "RE": [{ "2014-15": "1.2" }, { "2015-16": "2.2" }, { "2016-17": "0.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2.4" }, { "2014-15": "2" }, { "2015-16": "2" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.5" }, { "2016-17": "2.3" }, { "2017-18": "6.2" }], "RE": [{ "2014-15": "2.4" }, { "2015-16": "2.2" }, { "2016-17": "1.8" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "1027.1" }, { "2014-15": "" }, { "2015-16": "1042.7" }], "BE": [{ "2014-15": "570.8" }, { "2015-16": "806.1" }, { "2016-17": "1155.2" }, { "2017-18": "1305.8" }], "RE": [{ "2014-15": "563.3" }, { "2015-16": "546.6" }, { "2016-17": "1535.9" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "135.4" }, { "2014-15": "125.1" }, { "2015-16": "103.3" }], "BE": [{ "2014-15": "316.9" }, { "2015-16": "278.7" }, { "2016-17": "490.3" }, { "2017-18": "881.4" }], "RE": [{ "2014-15": "365.5" }, { "2015-16": "358.6" }, { "2016-17": "635.9" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "171.3" }, { "2014-15": "172" }, { "2015-16": "188.1" }], "BE": [{ "2014-15": "238.5" }, { "2015-16": "211.2" }, { "2016-17": "328.1" }, { "2017-18": "412.3" }], "RE": [{ "2014-15": "325.2" }, { "2015-16": "259.2" }, { "2016-17": "365.7" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "716.6" }, { "2015-16": "696.2" }], "BE": [{ "2014-15": "0" }, { "2015-16": "1170.8" }, { "2016-17": "1476" }, { "2017-18": "1432.6" }], "RE": [{ "2014-15": "0" }, { "2015-16": "1250.2" }, { "2016-17": "1712.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "3242.9" }, { "2014-15": "2928.8" }, { "2015-16": "3169.4" }], "BE": [{ "2014-15": "3750.8" }, { "2015-16": "3211" }, { "2016-17": "3711.8" }, { "2017-18": "3628.5" }], "RE": [{ "2014-15": "3222.6" }, { "2015-16": "3384.1" }, { "2016-17": "3232.7" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "2782.6" }, { "2014-15": "2833.3" }, { "2015-16": "3175.7" }], "BE": [{ "2014-15": "3247.3" }, { "2015-16": "3457" }, { "2016-17": "3646.1" }, { "2017-18": "3643.8" }], "RE": [{ "2014-15": "3192.6" }, { "2015-16": "3411.9" }, { "2016-17": "3479.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "342.5" }, { "2014-15": "345.7" }, { "2015-16": "368.4" }], "BE": [{ "2014-15": "498.9" }, { "2015-16": "574.1" }, { "2016-17": "605.7" }, { "2017-18": "804.8" }], "RE": [{ "2014-15": "422" }, { "2015-16": "537.9" }, { "2016-17": "563.8" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "414.1" }, { "2014-15": "288" }, { "2015-16": "448.7" }], "BE": [{ "2014-15": "281.3" }, { "2015-16": "327.5" }, { "2016-17": "402" }, { "2017-18": "506.4" }], "RE": [{ "2014-15": "293.7" }, { "2015-16": "448.7" }, { "2016-17": "796.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "305.3" }, { "2014-15": "487.3" }, { "2015-16": "496.9" }], "BE": [{ "2014-15": "986.2" }, { "2015-16": "929.7" }, { "2016-17": "1126.5" }, { "2017-18": "1337.8" }], "RE": [{ "2014-15": "739.2" }, { "2015-16": "784.6" }, { "2016-17": "1168.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "159.5" }, { "2014-15": "326.1" }, { "2015-16": "488.2" }], "BE": [{ "2014-15": "570.5" }, { "2015-16": "519.9" }, { "2016-17": "717.4" }, { "2017-18": "758.2" }], "RE": [{ "2014-15": "377.7" }, { "2015-16": "483.5" }, { "2016-17": "869.7" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1291" }, { "2014-15": "1525.5" }, { "2015-16": "1952.1" }], "BE": [{ "2014-15": "1795.8" }, { "2015-16": "1936.7" }, { "2016-17": "2391.8" }, { "2017-18": "2928.8" }], "RE": [{ "2014-15": "1754.6" }, { "2015-16": "1887.5" }, { "2016-17": "2329" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "187.3" }, { "2014-15": "132.8" }, { "2015-16": "120.9" }], "BE": [{ "2014-15": "426.2" }, { "2015-16": "304.4" }, { "2016-17": "415.5" }, { "2017-18": "481.3" }], "RE": [{ "2014-15": "269.3" }, { "2015-16": "205.3" }, { "2016-17": "303" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "782.7" }, { "2014-15": "769.4" }, { "2015-16": "1254" }], "BE": [{ "2014-15": "930.1" }, { "2015-16": "972.5" }, { "2016-17": "1507" }, { "2017-18": "1571.1" }], "RE": [{ "2014-15": "936.8" }, { "2015-16": "1365.5" }, { "2016-17": "1381.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "559.8" }, { "2014-15": "571" }, { "2015-16": "953.3" }], "BE": [{ "2014-15": "637.9" }, { "2015-16": "632.6" }, { "2016-17": "1510" }, { "2017-18": "1786.4" }], "RE": [{ "2014-15": "792.8" }, { "2015-16": "1030.5" }, { "2016-17": "1720.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "582.5" }, { "2014-15": "320.4" }, { "2015-16": "424.5" }], "BE": [{ "2014-15": "1296.4" }, { "2015-16": "367.2" }, { "2016-17": "568.6" }, { "2017-18": "1272.4" }], "RE": [{ "2014-15": "1296.4" }, { "2015-16": "367.2" }, { "2016-17": "568.6" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "1799.4" }, { "2014-15": "2573.7" }, { "2015-16": "1877.5" }], "BE": [{ "2014-15": "3068.3" }, { "2015-16": "2279.1" }, { "2016-17": "1823.4" }, { "2017-18": "3942" }], "RE": [{ "2014-15": "3622.4" }, { "2015-16": "2728.3" }, { "2016-17": "3029.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "592.5" }, { "2014-15": "361" }, { "2015-16": "301" }], "BE": [{ "2014-15": "1198" }, { "2015-16": "642" }, { "2016-17": "538.7" }, { "2017-18": "725.6" }], "RE": [{ "2014-15": "659.5" }, { "2015-16": "862.9" }, { "2016-17": "998.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "601.4" }, { "2014-15": "559.8" }, { "2015-16": "643.4" }], "BE": [{ "2014-15": "725.3" }, { "2015-16": "694.2" }, { "2016-17": "790.3" }, { "2017-18": "1045.6" }], "RE": [{ "2014-15": "668.5" }, { "2015-16": "572.9" }, { "2016-17": "785" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "234.4" }, { "2014-15": "383" }, { "2015-16": "270.7" }], "BE": [{ "2014-15": "710.9" }, { "2015-16": "332.2" }, { "2016-17": "779.1" }, { "2017-18": "1568.5" }], "RE": [{ "2014-15": "477.6" }, { "2015-16": "450.2" }, { "2016-17": "753.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "539.9" }, { "2014-15": "479.3" }, { "2015-16": "549.4" }], "BE": [{ "2014-15": "682.5" }, { "2015-16": "596.9" }, { "2016-17": "912.7" }, { "2017-18": "860.8" }], "RE": [{ "2014-15": "561.2" }, { "2015-16": "691.7" }, { "2016-17": "898.6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1830.5" }, { "2014-15": "1879.7" }, { "2015-16": "1323.6" }], "BE": [{ "2014-15": "4380.4" }, { "2015-16": "2004.5" }, { "2016-17": "2750.4" }, { "2017-18": "2323" }], "RE": [{ "2014-15": "4550.3" }, { "2015-16": "2120.3" }, { "2016-17": "3268.2" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "1521.9" }, { "2014-15": "1532.6" }, { "2015-16": "1511.9" }], "BE": [{ "2014-15": "1700.9" }, { "2015-16": "1683.9" }, { "2016-17": "2057.4" }, { "2017-18": "2385.8" }], "RE": [{ "2014-15": "1789.7" }, { "2015-16": "2111" }, { "2016-17": "2055.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "599.2" }, { "2014-15": "890.9" }, { "2015-16": "485.3" }], "BE": [{ "2014-15": "1026.8" }, { "2015-16": "1370.7" }, { "2016-17": "629.4" }, { "2017-18": "1147.1" }], "RE": [{ "2014-15": "1529.6" }, { "2015-16": "801.5" }, { "2016-17": "1142.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "155.8" }, { "2014-15": "269.4" }, { "2015-16": "347.7" }], "BE": [{ "2014-15": "370.5" }, { "2015-16": "378.5" }, { "2016-17": "517.1" }, { "2017-18": "652.3" }], "RE": [{ "2014-15": "391.1" }, { "2015-16": "419.3" }, { "2016-17": "498.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "176.3" }, { "2014-15": "181.4" }, { "2015-16": "534.4" }], "BE": [{ "2014-15": "760" }, { "2015-16": "469.3" }, { "2016-17": "779.4" }, { "2017-18": "469" }], "RE": [{ "2014-15": "368.6" }, { "2015-16": "692.4" }, { "2016-17": "265.2" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "286.5" }, { "2014-15": "271.1" }, { "2015-16": "303.8" }], "BE": [{ "2014-15": "328.3" }, { "2015-16": "372.9" }, { "2016-17": "390.4" }, { "2017-18": "1189.3" }], "RE": [{ "2014-15": "338.8" }, { "2015-16": "343.2" }, { "2016-17": "327.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "49.6" }, { "2014-15": "" }, { "2015-16": "77" }], "BE": [{ "2014-15": "81.2" }, { "2015-16": "76.5" }, { "2016-17": "66.5" }, { "2017-18": "83.2" }], "RE": [{ "2014-15": "80.9" }, { "2015-16": "85.5" }, { "2016-17": "74" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "93.1" }, { "2014-15": "95.3" }, { "2015-16": "62" }], "BE": [{ "2014-15": "96.1" }, { "2015-16": "49.7" }, { "2016-17": "57" }, { "2017-18": "71" }], "RE": [{ "2014-15": "94.4" }, { "2015-16": "56.3" }, { "2016-17": "61.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "99.9" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "100" }, { "2015-16": "98.6" }, { "2016-17": "100" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "Err:512" }, { "2014-15": "78" }, { "2015-16": "72.4" }], "BE": [{ "2014-15": "Err:512" }, { "2015-16": "71.4" }, { "2016-17": "73.6" }, { "2017-18": "70.4" }], "RE": [{ "2014-15": "Err:512" }, { "2015-16": "59.9" }, { "2016-17": "74" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "65.9" }, { "2014-15": "73.6" }, { "2015-16": "74.3" }], "BE": [{ "2014-15": "78.9" }, { "2015-16": "79.8" }, { "2016-17": "83.5" }, { "2017-18": "81.7" }], "RE": [{ "2014-15": "75.1" }, { "2015-16": "75.6" }, { "2016-17": "83.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "86.1" }, { "2014-15": "98" }, { "2015-16": "96.9" }], "BE": [{ "2014-15": "97.1" }, { "2015-16": "91.5" }, { "2016-17": "92.7" }, { "2017-18": "99.1" }], "RE": [{ "2014-15": "97.1" }, { "2015-16": "96.3" }, { "2016-17": "98.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "79.6" }, { "2014-15": "78.4" }, { "2015-16": "87" }], "BE": [{ "2014-15": "72.9" }, { "2015-16": "67.6" }, { "2016-17": "96.5" }, { "2017-18": "77.9" }], "RE": [{ "2014-15": "78.1" }, { "2015-16": "90.5" }, { "2016-17": "97" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "93.4" }, { "2014-15": "93.5" }, { "2015-16": "94.1" }], "BE": [{ "2014-15": "93.1" }, { "2015-16": "91.7" }, { "2016-17": "91.6" }, { "2017-18": "94.2" }], "RE": [{ "2014-15": "93.7" }, { "2015-16": "94.1" }, { "2016-17": "95.6" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "38.7" }, { "2015-16": "53.7" }, { "2016-17": "44.4" }, { "2017-18": "42" }], "RE": [{ "2014-15": "67.6" }, { "2015-16": "63.8" }, { "2016-17": "47.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "96" }, { "2014-15": "98.1" }, { "2015-16": "97.4" }], "BE": [{ "2014-15": "98.5" }, { "2015-16": "97.5" }, { "2016-17": "97.7" }, { "2017-18": "95.7" }], "RE": [{ "2014-15": "97.8" }, { "2015-16": "97.3" }, { "2016-17": "96.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "91.6" }, { "2014-15": "92.7" }, { "2015-16": "88.5" }], "BE": [{ "2014-15": "91.4" }, { "2015-16": "92.1" }, { "2016-17": "83.3" }, { "2017-18": "79.2" }], "RE": [{ "2014-15": "93.7" }, { "2015-16": "92.1" }, { "2016-17": "87.6" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "50.4" }, { "2014-15": "80.7" }, { "2015-16": "85.1" }], "BE": [{ "2014-15": "92.3" }, { "2015-16": "89.1" }, { "2016-17": "96.1" }, { "2017-18": "95.6" }], "RE": [{ "2014-15": "89" }, { "2015-16": "87.2" }, { "2016-17": "95.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "97.7" }, { "2014-15": "98.5" }, { "2015-16": "94.4" }], "BE": [{ "2014-15": "98.7" }, { "2015-16": "93.3" }, { "2016-17": "92.3" }, { "2017-18": "93.2" }], "RE": [{ "2014-15": "98.6" }, { "2015-16": "92.5" }, { "2016-17": "96.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "90.6" }, { "2014-15": "95.9" }, { "2015-16": "95.7" }], "BE": [{ "2014-15": "99.6" }, { "2015-16": "99.8" }, { "2016-17": "98.4" }, { "2017-18": "97.5" }], "RE": [{ "2014-15": "96.9" }, { "2015-16": "95.8" }, { "2016-17": "96.5" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "27.7" }, { "2014-15": "33.3" }, { "2015-16": "81.4" }], "BE": [{ "2014-15": "41.1" }, { "2015-16": "80" }, { "2016-17": "68" }, { "2017-18": "60.6" }], "RE": [{ "2014-15": "41.1" }, { "2015-16": "80" }, { "2016-17": "68" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "54" }, { "2014-15": "46.3" }, { "2015-16": "58.5" }], "BE": [{ "2014-15": "46.6" }, { "2015-16": "37.4" }, { "2016-17": "41.6" }, { "2017-18": "24.5" }], "RE": [{ "2014-15": "47.3" }, { "2015-16": "43.9" }, { "2016-17": "45.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "12.5" }, { "2014-15": "9.9" }, { "2015-16": "21.7" }], "BE": [{ "2014-15": "13.5" }, { "2015-16": "17.8" }, { "2016-17": "29.4" }, { "2017-18": "24.5" }], "RE": [{ "2014-15": "20.2" }, { "2015-16": "13.6" }, { "2016-17": "18.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "75.4" }, { "2014-15": "76" }, { "2015-16": "87" }], "BE": [{ "2014-15": "71.4" }, { "2015-16": "91.4" }, { "2016-17": "86.2" }, { "2017-18": "81.1" }], "RE": [{ "2014-15": "72.9" }, { "2015-16": "87.3" }, { "2016-17": "82.4" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "58.4" }, { "2014-15": "75.4" }, { "2015-16": "72.3" }], "BE": [{ "2014-15": "41.4" }, { "2015-16": "92.7" }, { "2016-17": "76.4" }, { "2017-18": "66" }], "RE": [{ "2014-15": "76.4" }, { "2015-16": "74.2" }, { "2016-17": "65.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "65.6" }, { "2014-15": "76.7" }, { "2015-16": "83.2" }], "BE": [{ "2014-15": "68.4" }, { "2015-16": "74.4" }, { "2016-17": "69.2" }, { "2017-18": "74.9" }], "RE": [{ "2014-15": "75.6" }, { "2015-16": "78.6" }, { "2016-17": "79.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "44.7" }, { "2014-15": "39" }, { "2015-16": "51.9" }], "BE": [{ "2014-15": "20.2" }, { "2015-16": "44.5" }, { "2016-17": "66.7" }, { "2017-18": "37.2" }], "RE": [{ "2014-15": "19.4" }, { "2015-16": "42.1" }, { "2016-17": "59.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "62.8" }, { "2014-15": "63.8" }, { "2015-16": "61.1" }], "BE": [{ "2014-15": "66.6" }, { "2015-16": "60.9" }, { "2016-17": "57.1" }, { "2017-18": "55.8" }], "RE": [{ "2014-15": "65.1" }, { "2015-16": "59.4" }, { "2016-17": "59.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "82.2" }, { "2014-15": "69" }, { "2015-16": "53.8" }], "BE": [{ "2014-15": "87.8" }, { "2015-16": "51.2" }, { "2016-17": "41.3" }, { "2017-18": "30.3" }], "RE": [{ "2014-15": "56.1" }, { "2015-16": "59.7" }, { "2016-17": "27" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "45.7" }, { "2014-15": "57.8" }, { "2015-16": "61.5" }], "BE": [{ "2014-15": "70.2" }, { "2015-16": "65.8" }, { "2016-17": "69.8" }, { "2017-18": "87.1" }], "RE": [{ "2014-15": "73.1" }, { "2015-16": "66.1" }, { "2016-17": "68" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "29" }, { "2014-15": "26.3" }, { "2015-16": "107.2" }], "BE": [{ "2014-15": "20.4" }, { "2015-16": "29.4" }, { "2016-17": "124.7" }, { "2017-18": "121.6" }], "RE": [{ "2014-15": "25" }, { "2015-16": "55.4" }, { "2016-17": "240.3" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "77.4" }, { "2014-15": "24.6" }, { "2015-16": "35.6" }], "BE": [{ "2014-15": "25.2" }, { "2015-16": "31.2" }, { "2016-17": "24.1" }, { "2017-18": "66.5" }], "RE": [{ "2014-15": "31.5" }, { "2015-16": "38.5" }, { "2016-17": "37.8" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "50.4" }, { "2014-15": "" }, { "2015-16": "23" }], "BE": [{ "2014-15": "18.8" }, { "2015-16": "23.5" }, { "2016-17": "33.5" }, { "2017-18": "16.8" }], "RE": [{ "2014-15": "19.1" }, { "2015-16": "14.5" }, { "2016-17": "26" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "6.9" }, { "2014-15": "4.7" }, { "2015-16": "38" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "50.3" }, { "2016-17": "43" }, { "2017-18": "29" }], "RE": [{ "2014-15": "5.6" }, { "2015-16": "43.7" }, { "2016-17": "38.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "0" }, { "2015-16": "1.4" }, { "2016-17": "0" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "Err:512" }, { "2014-15": "22" }, { "2015-16": "27.6" }], "BE": [{ "2014-15": "Err:512" }, { "2015-16": "28.6" }, { "2016-17": "26.4" }, { "2017-18": "29.6" }], "RE": [{ "2014-15": "Err:512" }, { "2015-16": "40.1" }, { "2016-17": "26" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "34.1" }, { "2014-15": "26.4" }, { "2015-16": "25.7" }], "BE": [{ "2014-15": "21.1" }, { "2015-16": "20.2" }, { "2016-17": "16.5" }, { "2017-18": "18.3" }], "RE": [{ "2014-15": "24.9" }, { "2015-16": "24.4" }, { "2016-17": "16.4" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "13.9" }, { "2014-15": "2" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "2.9" }, { "2015-16": "8.5" }, { "2016-17": "7.3" }, { "2017-18": "0.9" }], "RE": [{ "2014-15": "2.9" }, { "2015-16": "3.7" }, { "2016-17": "1.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "20.4" }, { "2014-15": "21.6" }, { "2015-16": "13" }], "BE": [{ "2014-15": "27.1" }, { "2015-16": "32.4" }, { "2016-17": "3.5" }, { "2017-18": "22.1" }], "RE": [{ "2014-15": "21.9" }, { "2015-16": "9.5" }, { "2016-17": "3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "6.6" }, { "2014-15": "6.5" }, { "2015-16": "5.9" }], "BE": [{ "2014-15": "6.9" }, { "2015-16": "8.3" }, { "2016-17": "8.4" }, { "2017-18": "5.8" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.9" }, { "2016-17": "4.4" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "61.3" }, { "2015-16": "46.3" }, { "2016-17": "55.6" }, { "2017-18": "58" }], "RE": [{ "2014-15": "32.4" }, { "2015-16": "36.2" }, { "2016-17": "52.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "1.9" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "2.5" }, { "2016-17": "2.3" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "2.2" }, { "2015-16": "2.7" }, { "2016-17": "3.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "8.4" }, { "2014-15": "7.3" }, { "2015-16": "11.5" }], "BE": [{ "2014-15": "8.6" }, { "2015-16": "7.9" }, { "2016-17": "16.7" }, { "2017-18": "20.8" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "7.9" }, { "2016-17": "12.4" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "49.6" }, { "2014-15": "19.3" }, { "2015-16": "14.9" }], "BE": [{ "2014-15": "7.7" }, { "2015-16": "10.9" }, { "2016-17": "3.9" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "11" }, { "2015-16": "12.8" }, { "2016-17": "4.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "1.5" }, { "2015-16": "5.6" }], "BE": [{ "2014-15": "1.3" }, { "2015-16": "6.7" }, { "2016-17": "7.7" }, { "2017-18": "6.8" }], "RE": [{ "2014-15": "1.4" }, { "2015-16": "7.5" }, { "2016-17": "3.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "9.4" }, { "2014-15": "4.1" }, { "2015-16": "4.3" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.2" }, { "2016-17": "1.6" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "3.1" }, { "2015-16": "4.2" }, { "2016-17": "3.5" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "72.3" }, { "2014-15": "66.7" }, { "2015-16": "18.6" }], "BE": [{ "2014-15": "58.9" }, { "2015-16": "20" }, { "2016-17": "32" }, { "2017-18": "39.4" }], "RE": [{ "2014-15": "58.9" }, { "2015-16": "20" }, { "2016-17": "32" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "46" }, { "2014-15": "53.7" }, { "2015-16": "41.5" }], "BE": [{ "2014-15": "53.4" }, { "2015-16": "62.6" }, { "2016-17": "58.4" }, { "2017-18": "75.5" }], "RE": [{ "2014-15": "52.7" }, { "2015-16": "56.1" }, { "2016-17": "54.3" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "87.5" }, { "2014-15": "90.1" }, { "2015-16": "78.3" }], "BE": [{ "2014-15": "86.5" }, { "2015-16": "82.2" }, { "2016-17": "70.6" }, { "2017-18": "75.5" }], "RE": [{ "2014-15": "79.8" }, { "2015-16": "86.4" }, { "2016-17": "81.3" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "24.6" }, { "2014-15": "24" }, { "2015-16": "13" }], "BE": [{ "2014-15": "28.6" }, { "2015-16": "8.6" }, { "2016-17": "13.8" }, { "2017-18": "18.9" }], "RE": [{ "2014-15": "27.1" }, { "2015-16": "12.7" }, { "2016-17": "17.6" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "41.6" }, { "2014-15": "24.6" }, { "2015-16": "27.7" }], "BE": [{ "2014-15": "58.6" }, { "2015-16": "7.3" }, { "2016-17": "23.6" }, { "2017-18": "34" }], "RE": [{ "2014-15": "23.6" }, { "2015-16": "25.8" }, { "2016-17": "34.6" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "34.4" }, { "2014-15": "23.3" }, { "2015-16": "16.8" }], "BE": [{ "2014-15": "31.6" }, { "2015-16": "25.6" }, { "2016-17": "30.8" }, { "2017-18": "25.1" }], "RE": [{ "2014-15": "24.4" }, { "2015-16": "21.4" }, { "2016-17": "20.1" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "55.3" }, { "2014-15": "61" }, { "2015-16": "48.1" }], "BE": [{ "2014-15": "79.8" }, { "2015-16": "55.5" }, { "2016-17": "33.3" }, { "2017-18": "62.8" }], "RE": [{ "2014-15": "80.6" }, { "2015-16": "57.9" }, { "2016-17": "40.3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "37.2" }, { "2014-15": "36.2" }, { "2015-16": "38.9" }], "BE": [{ "2014-15": "33.4" }, { "2015-16": "39.1" }, { "2016-17": "42.9" }, { "2017-18": "44.2" }], "RE": [{ "2014-15": "34.9" }, { "2015-16": "40.6" }, { "2016-17": "40.5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "17.8" }, { "2014-15": "31" }, { "2015-16": "46.2" }], "BE": [{ "2014-15": "12.2" }, { "2015-16": "48.8" }, { "2016-17": "58.7" }, { "2017-18": "69.7" }], "RE": [{ "2014-15": "43.9" }, { "2015-16": "40.3" }, { "2016-17": "73" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "54.3" }, { "2014-15": "42.2" }, { "2015-16": "38.5" }], "BE": [{ "2014-15": "29.8" }, { "2015-16": "34.2" }, { "2016-17": "30.2" }, { "2017-18": "12.9" }], "RE": [{ "2014-15": "26.9" }, { "2015-16": "33.9" }, { "2016-17": "32" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "71" }, { "2014-15": "73.7" }, { "2015-16": "64.5" }], "BE": [{ "2014-15": "79.6" }, { "2015-16": "70.6" }, { "2016-17": "43.6" }, { "2017-18": "119.9" }], "RE": [{ "2014-15": "75" }, { "2015-16": "44.6" }, { "2016-17": "88.3" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "22.6" }, { "2014-15": "75.4" }, { "2015-16": "64.4" }], "BE": [{ "2014-15": "74.8" }, { "2015-16": "68.8" }, { "2016-17": "75.9" }, { "2017-18": "33.5" }], "RE": [{ "2014-15": "68.5" }, { "2015-16": "61.5" }, { "2016-17": "62.2" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Urban Development & Housing" }, { "category_slug": "social_welfare", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "14596" }, { "2014-15": "" }, { "2015-16": "7590.7" }], "BE": [{ "2014-15": "8440.1" }, { "2015-16": "8555.7" }, { "2016-17": "11271.8" }, { "2017-18": "13134.6" }], "RE": [{ "2014-15": "8384.9" }, { "2015-16": "6612.3" }, { "2016-17": "10963.4" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "2686.1" }, { "2014-15": "3013.2" }, { "2015-16": "2333.9" }], "BE": [{ "2014-15": "3271.6" }, { "2015-16": "4369.6" }, { "2016-17": "5635.1" }, { "2017-18": "4629" }], "RE": [{ "2014-15": "4681.5" }, { "2015-16": "6538.4" }, { "2016-17": "5835.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "6788.7" }, { "2014-15": "8393.5" }, { "2015-16": "10147.8" }], "BE": [{ "2014-15": "8771.8" }, { "2015-16": "8508.8" }, { "2016-17": "11533.9" }, { "2017-18": "11174.7" }], "RE": [{ "2014-15": "11777.6" }, { "2015-16": "10775.3" }, { "2016-17": "12918.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "4718.9" }, { "2014-15": "5049.4" }, { "2015-16": "2817.3" }], "BE": [{ "2014-15": "6002.5" }, { "2015-16": "7101.8" }, { "2016-17": "4700.7" }, { "2017-18": "4605.3" }], "RE": [{ "2014-15": "6827.8" }, { "2015-16": "6011.8" }, { "2016-17": "4687.1" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1724.9" }, { "2014-15": "1699.5" }, { "2015-16": "2091.5" }], "BE": [{ "2014-15": "2053.2" }, { "2015-16": "2066.9" }, { "2016-17": "2267.5" }, { "2017-18": "2982.9" }], "RE": [{ "2014-15": "1929.7" }, { "2015-16": "2045.4" }, { "2016-17": "2416.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "13345" }, { "2014-15": "13922.6" }, { "2015-16": "16500.1" }], "BE": [{ "2014-15": "17396.9" }, { "2015-16": "18647.2" }, { "2016-17": "20586.2" }, { "2017-18": "22428.4" }], "RE": [{ "2014-15": "16531.8" }, { "2015-16": "18535.8" }, { "2016-17": "19031.1" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "3239.5" }, { "2014-15": "4469.7" }, { "2015-16": "5245.7" }], "BE": [{ "2014-15": "4830.6" }, { "2015-16": "5684.4" }, { "2016-17": "6623.3" }, { "2017-18": "7455.3" }], "RE": [{ "2014-15": "4972.8" }, { "2015-16": "6178.2" }, { "2016-17": "6742.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2418.3" }, { "2014-15": "2949.5" }, { "2015-16": "3391.5" }], "BE": [{ "2014-15": "2640.4" }, { "2015-16": "3050" }, { "2016-17": "4183.5" }, { "2017-18": "4599.7" }], "RE": [{ "2014-15": "2934.6" }, { "2015-16": "3193.4" }, { "2016-17": "3792.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "145.4" }, { "2014-15": "220.8" }, { "2015-16": "404.4" }], "BE": [{ "2014-15": "838.6" }, { "2015-16": "689.5" }, { "2016-17": "2686.4" }, { "2017-18": "3380" }], "RE": [{ "2014-15": "706.8" }, { "2015-16": "739.4" }, { "2016-17": "4524.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "2101.8" }, { "2014-15": "2381.4" }, { "2015-16": "4401.3" }], "BE": [{ "2014-15": "3107.3" }, { "2015-16": "3692.2" }, { "2016-17": "5872.3" }, { "2017-18": "6033.1" }], "RE": [{ "2014-15": "3228.8" }, { "2015-16": "4677" }, { "2016-17": "6594.3" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "10662.7" }, { "2014-15": "14567.6" }, { "2015-16": "18519.3" }], "BE": [{ "2014-15": "13515.2" }, { "2015-16": "17024.8" }, { "2016-17": "19664" }, { "2017-18": "23553.2" }], "RE": [{ "2014-15": "14342.7" }, { "2015-16": "17618.5" }, { "2016-17": "20412.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "4501.7" }, { "2014-15": "5317.1" }, { "2015-16": "6909.2" }], "BE": [{ "2014-15": "5572.1" }, { "2015-16": "6795.2" }, { "2016-17": "7881.7" }, { "2017-18": "8150.5" }], "RE": [{ "2014-15": "5888.4" }, { "2015-16": "6675.5" }, { "2016-17": "8438.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "7528.5" }, { "2014-15": "7367.8" }, { "2015-16": "10401.4" }], "BE": [{ "2014-15": "9924.9" }, { "2015-16": "12841.8" }, { "2016-17": "12612.9" }, { "2017-18": "11461.9" }], "RE": [{ "2014-15": "9252.4" }, { "2015-16": "11945" }, { "2016-17": "11379.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "16327.6" }, { "2014-15": "17260.6" }, { "2015-16": "25689.7" }], "BE": [{ "2014-15": "20376.3" }, { "2015-16": "22211.7" }, { "2016-17": "28732.4" }, { "2017-18": "31613.9" }], "RE": [{ "2014-15": "19780.6" }, { "2015-16": "22190.3" }, { "2016-17": "30029.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "227.1" }, { "2014-15": "305.4" }, { "2015-16": "203.4" }], "BE": [{ "2014-15": "858" }, { "2015-16": "176.2" }, { "2016-17": "394.7" }, { "2017-18": "403.3" }], "RE": [{ "2014-15": "858" }, { "2015-16": "176.2" }, { "2016-17": "394.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "407" }, { "2014-15": "428.5" }, { "2015-16": "450.2" }], "BE": [{ "2014-15": "402.3" }, { "2015-16": "404.4" }, { "2016-17": "439.6" }, { "2017-18": "474.9" }], "RE": [{ "2014-15": "474.2" }, { "2015-16": "482.8" }, { "2016-17": "483.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "272.4" }, { "2014-15": "190.9" }, { "2015-16": "201.3" }], "BE": [{ "2014-15": "180.4" }, { "2015-16": "194.3" }, { "2016-17": "224.8" }, { "2017-18": "233.6" }], "RE": [{ "2014-15": "270.4" }, { "2015-16": "261" }, { "2016-17": "307.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "7379.6" }, { "2014-15": "7253.7" }, { "2015-16": "7704.2" }], "BE": [{ "2014-15": "8860.6" }, { "2015-16": "8049.1" }, { "2016-17": "9987.5" }, { "2017-18": "11229.1" }], "RE": [{ "2014-15": "7253.4" }, { "2015-16": "9954.3" }, { "2016-17": "9566.5" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2235" }, { "2014-15": "2568.7" }, { "2015-16": "2450.7" }], "BE": [{ "2014-15": "3330.3" }, { "2015-16": "3564.8" }, { "2016-17": "3867.2" }, { "2017-18": "4376.9" }], "RE": [{ "2014-15": "3193.4" }, { "2015-16": "3294.5" }, { "2016-17": "3388.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "6219" }, { "2014-15": "7493" }, { "2015-16": "9224.7" }], "BE": [{ "2014-15": "8248.4" }, { "2015-16": "9253.4" }, { "2016-17": "9190.5" }, { "2017-18": "9758.5" }], "RE": [{ "2014-15": "7936.4" }, { "2015-16": "10131.6" }, { "2016-17": "10268.2" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "95.5" }, { "2014-15": "94.3" }, { "2015-16": "120.4" }], "BE": [{ "2014-15": "132.2" }, { "2015-16": "210.6" }, { "2016-17": "167.8" }, { "2017-18": "209.7" }], "RE": [{ "2014-15": "140.9" }, { "2015-16": "215.2" }, { "2016-17": "182.2" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "8741.1" }, { "2014-15": "7749.3" }, { "2015-16": "12401.9" }], "BE": [{ "2014-15": "7486.8" }, { "2015-16": "12733.9" }, { "2016-17": "10007.4" }, { "2017-18": "10264.7" }], "RE": [{ "2014-15": "8153.8" }, { "2015-16": "9623.3" }, { "2016-17": "10875.8" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1926.2" }, { "2014-15": "2979.3" }, { "2015-16": "3266.2" }], "BE": [{ "2014-15": "3807.3" }, { "2015-16": "5367" }, { "2016-17": "4466.5" }, { "2017-18": "4250.4" }], "RE": [{ "2014-15": "3910.2" }, { "2015-16": "3843.2" }, { "2016-17": "4493.9" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "23064.1" }, { "2014-15": "24357.3" }, { "2015-16": "35480.1" }], "BE": [{ "2014-15": "31340.6" }, { "2015-16": "35037.8" }, { "2016-17": "44664.6" }, { "2017-18": "40724.8" }], "RE": [{ "2014-15": "31884.9" }, { "2015-16": "43593.3" }, { "2016-17": "43533.7" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1507.7" }, { "2014-15": "2628.7" }, { "2015-16": "3671.1" }], "BE": [{ "2014-15": "2904.2" }, { "2015-16": "4604.7" }, { "2016-17": "5636.1" }, { "2017-18": "4212.6" }], "RE": [{ "2014-15": "3113.5" }, { "2015-16": "4479.8" }, { "2016-17": "3825.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "5532.2" }, { "2014-15": "6424.5" }, { "2015-16": "7529" }], "BE": [{ "2014-15": "7103.6" }, { "2015-16": "8249.8" }, { "2016-17": "9277.2" }, { "2017-18": "5121" }], "RE": [{ "2014-15": "7092.7" }, { "2015-16": "6965" }, { "2016-17": "8265.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "10.7" }, { "2014-15": "" }, { "2015-16": "5.1" }], "BE": [{ "2014-15": "7.5" }, { "2015-16": "7.6" }, { "2016-17": "8.3" }, { "2017-18": "8.4" }], "RE": [{ "2014-15": "7.5" }, { "2015-16": "5.9" }, { "2016-17": "8.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "7.2" }, { "2014-15": "6.4" }, { "2015-16": "5.6" }], "BE": [{ "2014-15": "5" }, { "2015-16": "6.6" }, { "2016-17": "7.2" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "8.7" }, { "2016-17": "7" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "8.4" }, { "2014-15": "8.9" }, { "2015-16": "9" }], "BE": [{ "2014-15": "7.5" }, { "2015-16": "7.1" }, { "2016-17": "8" }, { "2017-18": "7" }], "RE": [{ "2014-15": "8.9" }, { "2015-16": "8.1" }, { "2016-17": "8.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "12.2" }, { "2014-15": "10.9" }, { "2015-16": "5.4" }], "BE": [{ "2014-15": "11" }, { "2015-16": "10.9" }, { "2016-17": "6.7" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "12.4" }, { "2015-16": "9.1" }, { "2016-17": "6.6" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "5.1" }, { "2014-15": "5.5" }, { "2015-16": "5.9" }], "BE": [{ "2014-15": "5.6" }, { "2015-16": "5" }, { "2016-17": "4.9" }, { "2017-18": "6.2" }], "RE": [{ "2014-15": "5.5" }, { "2015-16": "5.4" }, { "2016-17": "5.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "12.7" }, { "2014-15": "11.9" }, { "2015-16": "11" }], "BE": [{ "2014-15": "13.2" }, { "2015-16": "13.6" }, { "2016-17": "16.2" }, { "2017-18": "13.1" }], "RE": [{ "2014-15": "13.2" }, { "2015-16": "13.9" }, { "2016-17": "13" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "7" }, { "2014-15": "8.3" }, { "2015-16": "8.4" }], "BE": [{ "2014-15": "8.1" }, { "2015-16": "8.2" }, { "2016-17": "8.5" }, { "2017-18": "8.7" }], "RE": [{ "2014-15": "8.1" }, { "2015-16": "9.1" }, { "2016-17": "9.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "11.3" }, { "2014-15": "9.5" }, { "2015-16": "11.5" }], "BE": [{ "2014-15": "11.2" }, { "2015-16": "10.8" }, { "2016-17": "12.8" }, { "2017-18": "12.9" }], "RE": [{ "2014-15": "9.9" }, { "2015-16": "11.8" }, { "2016-17": "10.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0.4" }, { "2014-15": "0.6" }, { "2015-16": "0.6" }], "BE": [{ "2014-15": "1.9" }, { "2015-16": "1.5" }, { "2016-17": "5.9" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "1.6" }, { "2015-16": "1.4" }, { "2016-17": "7.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "6.9" }, { "2014-15": "5.9" }, { "2015-16": "8.1" }], "BE": [{ "2014-15": "6.2" }, { "2015-16": "6.7" }, { "2016-17": "9.2" }, { "2017-18": "8" }], "RE": [{ "2014-15": "6.4" }, { "2015-16": "8.3" }, { "2016-17": "9.9" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "10" }, { "2014-15": "11.8" }, { "2015-16": "13.4" }], "BE": [{ "2014-15": "10.3" }, { "2015-16": "12.4" }, { "2016-17": "12.6" }, { "2017-18": "13.2" }], "RE": [{ "2014-15": "11.2" }, { "2015-16": "12.7" }, { "2016-17": "13" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "6.9" }, { "2015-16": "7.9" }], "BE": [{ "2014-15": "7" }, { "2015-16": "7.1" }, { "2016-17": "7.3" }, { "2017-18": "6.8" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "7.5" }, { "2016-17": "8.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "8.8" }, { "2014-15": "6.9" }, { "2015-16": "8.7" }], "BE": [{ "2014-15": "8.5" }, { "2015-16": "9.8" }, { "2016-17": "7.9" }, { "2017-18": "6.7" }], "RE": [{ "2014-15": "7.8" }, { "2015-16": "9" }, { "2016-17": "7.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "8.7" }, { "2014-15": "7.9" }, { "2015-16": "11.4" }], "BE": [{ "2014-15": "9.1" }, { "2015-16": "9.1" }, { "2016-17": "10.6" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "8.6" }, { "2015-16": "9" }, { "2016-17": "10.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "3.3" }, { "2014-15": "4" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "7.2" }, { "2015-16": "1.8" }, { "2016-17": "3.7" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "7.2" }, { "2015-16": "1.8" }, { "2016-17": "3.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "7.4" }, { "2014-15": "5.5" }, { "2015-16": "7.2" }], "BE": [{ "2014-15": "5.9" }, { "2015-16": "5.2" }, { "2016-17": "5.6" }, { "2017-18": "5.6" }], "RE": [{ "2014-15": "6.1" }, { "2015-16": "5.8" }, { "2016-17": "5.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "1.9" }, { "2015-16": "1.8" }], "BE": [{ "2014-15": "1.5" }, { "2015-16": "1.5" }, { "2016-17": "1.6" }, { "2017-18": "1.4" }], "RE": [{ "2014-15": "2.4" }, { "2015-16": "2.1" }, { "2016-17": "1.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "13.1" }, { "2014-15": "10.9" }, { "2015-16": "9.7" }], "BE": [{ "2014-15": "11.1" }, { "2015-16": "9.5" }, { "2016-17": "10.6" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "9.4" }, { "2015-16": "11.8" }, { "2016-17": "10.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "3.7" }, { "2014-15": "3.5" }, { "2015-16": "3" }], "BE": [{ "2014-15": "4.5" }, { "2015-16": "4.5" }, { "2016-17": "4.5" }, { "2017-18": "3.7" }], "RE": [{ "2014-15": "4.3" }, { "2015-16": "4.2" }, { "2016-17": "2.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "6.6" }, { "2014-15": "6.4" }, { "2015-16": "7.1" }], "BE": [{ "2014-15": "6.3" }, { "2015-16": "6.7" }, { "2016-17": "6.1" }, { "2017-18": "5.9" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "7.4" }, { "2016-17": "6.9" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "2" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "2" }, { "2015-16": "3.8" }, { "2016-17": "2.9" }, { "2017-18": "3.4" }], "RE": [{ "2014-15": "2.1" }, { "2015-16": "3.8" }, { "2016-17": "3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "4.9" }, { "2015-16": "7.3" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "7.3" }, { "2016-17": "5.1" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "5.1" }, { "2015-16": "5.4" }, { "2016-17": "5" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "24.6" }, { "2014-15": "28.1" }, { "2015-16": "28.3" }], "BE": [{ "2014-15": "30.7" }, { "2015-16": "35.9" }, { "2016-17": "29.3" }, { "2017-18": "26.6" }], "RE": [{ "2014-15": "31.5" }, { "2015-16": "29.6" }, { "2016-17": "30.1" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "11.5" }, { "2014-15": "10.3" }, { "2015-16": "11.7" }], "BE": [{ "2014-15": "11.4" }, { "2015-16": "11.6" }, { "2016-17": "12.9" }, { "2017-18": "10.6" }], "RE": [{ "2014-15": "12.1" }, { "2015-16": "13.2" }, { "2016-17": "12.8" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "9.7" }, { "2015-16": "12.4" }], "BE": [{ "2014-15": "9.6" }, { "2015-16": "14.1" }, { "2016-17": "13.9" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "9.6" }, { "2015-16": "13.4" }, { "2016-17": "11.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "5.1" }, { "2014-15": "5.2" }, { "2015-16": "5.3" }], "BE": [{ "2014-15": "5.5" }, { "2015-16": "6" }, { "2016-17": "5.8" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "5.5" }, { "2015-16": "4.8" }, { "2016-17": "5" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "2927.6" }, { "2014-15": "" }, { "2015-16": "1504.7" }], "BE": [{ "2014-15": "1682.9" }, { "2015-16": "1696" }, { "2016-17": "2221.4" }, { "2017-18": "2573.7" }], "RE": [{ "2014-15": "1671.9" }, { "2015-16": "1310.8" }, { "2016-17": "2160.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "857.6" }, { "2014-15": "950.7" }, { "2015-16": "727.8" }], "BE": [{ "2014-15": "1032.3" }, { "2015-16": "1362.6" }, { "2016-17": "1736.6" }, { "2017-18": "1410.2" }], "RE": [{ "2014-15": "1477.1" }, { "2015-16": "2038.8" }, { "2016-17": "1798.4" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "676.9" }, { "2014-15": "826.7" }, { "2015-16": "987.8" }], "BE": [{ "2014-15": "864" }, { "2015-16": "828.3" }, { "2016-17": "1110" }, { "2017-18": "1062.9" }], "RE": [{ "2014-15": "1160.1" }, { "2015-16": "1048.9" }, { "2016-17": "1243.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1894.5" }, { "2014-15": "2001.2" }, { "2015-16": "1102.4" }], "BE": [{ "2014-15": "2378.9" }, { "2015-16": "2779" }, { "2016-17": "1816.4" }, { "2017-18": "1757.6" }], "RE": [{ "2014-15": "2706" }, { "2015-16": "2352.5" }, { "2016-17": "1811.2" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "883.3" }, { "2014-15": "845.9" }, { "2015-16": "1011.6" }], "BE": [{ "2014-15": "1021.9" }, { "2015-16": "999.7" }, { "2016-17": "1065.3" }, { "2017-18": "1364.7" }], "RE": [{ "2014-15": "960.4" }, { "2015-16": "989.3" }, { "2016-17": "1135.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "5080.7" }, { "2014-15": "5219.4" }, { "2015-16": "6093.3" }], "BE": [{ "2014-15": "6521.8" }, { "2015-16": "6886.2" }, { "2016-17": "7492.1" }, { "2017-18": "8043.6" }], "RE": [{ "2014-15": "6197.5" }, { "2015-16": "6845.1" }, { "2016-17": "6926.2" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "534.8" }, { "2014-15": "728.8" }, { "2015-16": "845" }], "BE": [{ "2014-15": "787.7" }, { "2015-16": "915.6" }, { "2016-17": "1054.2" }, { "2017-18": "1172.6" }], "RE": [{ "2014-15": "810.8" }, { "2015-16": "995.2" }, { "2016-17": "1073.3" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "3495.7" }, { "2014-15": "4226.9" }, { "2015-16": "4819.6" }], "BE": [{ "2014-15": "3783.9" }, { "2015-16": "4334.2" }, { "2016-17": "5896.4" }, { "2017-18": "6429.2" }], "RE": [{ "2014-15": "4205.5" }, { "2015-16": "4538" }, { "2016-17": "5345.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "121.1" }, { "2014-15": "181.7" }, { "2015-16": "329.1" }], "BE": [{ "2014-15": "690.1" }, { "2015-16": "561.1" }, { "2016-17": "2163.1" }, { "2017-18": "2691.4" }], "RE": [{ "2014-15": "581.7" }, { "2015-16": "601.6" }, { "2016-17": "3643.3" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "650" }, { "2014-15": "726.8" }, { "2015-16": "1325.6" }], "BE": [{ "2014-15": "948.3" }, { "2015-16": "1112" }, { "2016-17": "1745" }, { "2017-18": "1769.9" }], "RE": [{ "2014-15": "985.4" }, { "2015-16": "1408.6" }, { "2016-17": "1959.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "1758.8" }, { "2014-15": "2379.8" }, { "2015-16": "2996.8" }], "BE": [{ "2014-15": "2207.9" }, { "2015-16": "2755" }, { "2016-17": "3152.6" }, { "2017-18": "3740.9" }], "RE": [{ "2014-15": "2343" }, { "2015-16": "2851" }, { "2016-17": "3272.5" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1285" }, { "2014-15": "1508" }, { "2015-16": "1947.7" }], "BE": [{ "2014-15": "1580.4" }, { "2015-16": "1915.6" }, { "2016-17": "2209.2" }, { "2017-18": "2270.5" }], "RE": [{ "2014-15": "1670.1" }, { "2015-16": "1881.8" }, { "2016-17": "2365.3" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1010.8" }, { "2014-15": "974.4" }, { "2015-16": "1355.3" }], "BE": [{ "2014-15": "1312.6" }, { "2015-16": "1673.3" }, { "2016-17": "1619.6" }, { "2017-18": "1450.7" }], "RE": [{ "2014-15": "1223.6" }, { "2015-16": "1556.5" }, { "2016-17": "1461.2" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "1411.2" }, { "2014-15": "1472.9" }, { "2015-16": "2165.1" }], "BE": [{ "2014-15": "1738.8" }, { "2015-16": "1872" }, { "2016-17": "2392.9" }, { "2017-18": "2600.8" }], "RE": [{ "2014-15": "1687.9" }, { "2015-16": "1870.2" }, { "2016-17": "2500.9" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "846.8" }, { "2014-15": "1126.3" }, { "2015-16": "741.6" }], "BE": [{ "2014-15": "3163.6" }, { "2015-16": "642.3" }, { "2016-17": "1423.3" }, { "2017-18": "1438.5" }], "RE": [{ "2014-15": "3163.6" }, { "2015-16": "642.3" }, { "2016-17": "1423.3" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3959.3" }, { "2014-15": "4124.1" }, { "2015-16": "4283.6" }], "BE": [{ "2014-15": "3872.3" }, { "2015-16": "3847.7" }, { "2016-17": "4135.2" }, { "2017-18": "4419.9" }], "RE": [{ "2014-15": "4564" }, { "2015-16": "4593.5" }, { "2016-17": "4549.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1183.9" }, { "2014-15": "820.2" }, { "2015-16": "855.3" }], "BE": [{ "2014-15": "775" }, { "2015-16": "825.6" }, { "2016-17": "944.4" }, { "2017-18": "970.3" }], "RE": [{ "2014-15": "1148.6" }, { "2015-16": "1108.6" }, { "2016-17": "1293.8" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1780.2" }, { "2014-15": "1735.5" }, { "2015-16": "1828.3" }], "BE": [{ "2014-15": "2119.9" }, { "2015-16": "1910.2" }, { "2016-17": "2351.2" }, { "2017-18": "2622.3" }], "RE": [{ "2014-15": "1735.4" }, { "2015-16": "2362.3" }, { "2016-17": "2252" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "790.3" }, { "2014-15": "899.2" }, { "2015-16": "849.6" }], "BE": [{ "2014-15": "1165.7" }, { "2015-16": "1235.8" }, { "2016-17": "1328.4" }, { "2017-18": "1489" }], "RE": [{ "2014-15": "1117.8" }, { "2015-16": "1142.1" }, { "2016-17": "1163.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "889.2" }, { "2014-15": "1055.8" }, { "2015-16": "1281.7" }], "BE": [{ "2014-15": "1162.3" }, { "2015-16": "1285.7" }, { "2016-17": "1259.9" }, { "2017-18": "1319.4" }], "RE": [{ "2014-15": "1118.3" }, { "2015-16": "1407.7" }, { "2016-17": "1407.6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "1526.1" }, { "2014-15": "1489" }, { "2015-16": "1881.9" }], "BE": [{ "2014-15": "2088.9" }, { "2015-16": "3290.8" }, { "2016-17": "2593.6" }, { "2017-18": "3206.1" }], "RE": [{ "2014-15": "2226.2" }, { "2015-16": "3362.2" }, { "2016-17": "2815.6" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "1280.5" }, { "2014-15": "1128.7" }, { "2015-16": "1796.6" }], "BE": [{ "2014-15": "1090.5" }, { "2015-16": "1844.7" }, { "2016-17": "1442.1" }, { "2017-18": "1471" }], "RE": [{ "2014-15": "1187.7" }, { "2015-16": "1394.1" }, { "2016-17": "1567.2" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "5206.1" }, { "2014-15": "7961.8" }, { "2015-16": "8631.7" }], "BE": [{ "2014-15": "10174.6" }, { "2015-16": "14183.5" }, { "2016-17": "11674.2" }, { "2017-18": "10988.6" }], "RE": [{ "2014-15": "10449.6" }, { "2015-16": "10156.4" }, { "2016-17": "11745.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "1110.2" }, { "2014-15": "1153.2" }, { "2015-16": "1652.8" }], "BE": [{ "2014-15": "1483.8" }, { "2015-16": "1632.2" }, { "2016-17": "2048" }, { "2017-18": "1838.1" }], "RE": [{ "2014-15": "1509.6" }, { "2015-16": "2030.7" }, { "2016-17": "1996.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "1474.7" }, { "2014-15": "2517.7" }, { "2015-16": "3335.3" }], "BE": [{ "2014-15": "2802.8" }, { "2015-16": "4351.5" }, { "2016-17": "5055.5" }, { "2017-18": "3685.2" }], "RE": [{ "2014-15": "3004.7" }, { "2015-16": "4177.3" }, { "2016-17": "3388.6" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "607.1" }, { "2014-15": "698.9" }, { "2015-16": "812" }], "BE": [{ "2014-15": "772.8" }, { "2015-16": "889.7" }, { "2016-17": "991.7" }, { "2017-18": "542.8" }], "RE": [{ "2014-15": "771.6" }, { "2015-16": "751.1" }, { "2016-17": "883.6" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "93.2" }, { "2014-15": "" }, { "2015-16": "91.4" }], "BE": [{ "2014-15": "82.5" }, { "2015-16": "90.2" }, { "2016-17": "89.4" }, { "2017-18": "90.3" }], "RE": [{ "2014-15": "82.4" }, { "2015-16": "92.2" }, { "2016-17": "93.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "97.3" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "98.8" }, { "2014-15": "97.5" }, { "2015-16": "97.4" }], "BE": [{ "2014-15": "89.5" }, { "2015-16": "98.4" }, { "2016-17": "96.7" }, { "2017-18": "95.4" }], "RE": [{ "2014-15": "92.6" }, { "2015-16": "97.9" }, { "2016-17": "96.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "94.4" }, { "2014-15": "93.1" }, { "2015-16": "87.6" }], "BE": [{ "2014-15": "92.3" }, { "2015-16": "92.9" }, { "2016-17": "88.3" }, { "2017-18": "85.9" }], "RE": [{ "2014-15": "92.6" }, { "2015-16": "89.4" }, { "2016-17": "85.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "96.6" }, { "2014-15": "96.8" }, { "2015-16": "97.9" }], "BE": [{ "2014-15": "95.1" }, { "2015-16": "96.1" }, { "2016-17": "96.7" }, { "2017-18": "97.1" }], "RE": [{ "2014-15": "95.6" }, { "2015-16": "97.2" }, { "2016-17": "96.7" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "72.6" }, { "2014-15": "69.7" }, { "2015-16": "72.8" }], "BE": [{ "2014-15": "73.2" }, { "2015-16": "71.7" }, { "2016-17": "75.8" }, { "2017-18": "75.8" }], "RE": [{ "2014-15": "72.1" }, { "2015-16": "75" }, { "2016-17": "78.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "96.5" }, { "2014-15": "94.9" }, { "2015-16": "96.8" }], "BE": [{ "2014-15": "93.7" }, { "2015-16": "93.5" }, { "2016-17": "96" }, { "2017-18": "95.5" }], "RE": [{ "2014-15": "91.9" }, { "2015-16": "95.7" }, { "2016-17": "95.9" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "72.5" }, { "2014-15": "71" }, { "2015-16": "71.9" }], "BE": [{ "2014-15": "70.8" }, { "2015-16": "71.3" }, { "2016-17": "68.6" }, { "2017-18": "68.6" }], "RE": [{ "2014-15": "70" }, { "2015-16": "75.3" }, { "2016-17": "65.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "65.2" }, { "2015-16": "83.5" }, { "2016-17": "49.5" }, { "2017-18": "53.6" }], "RE": [{ "2014-15": "90.7" }, { "2015-16": "84.1" }, { "2016-17": "35.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "84.8" }, { "2014-15": "86" }, { "2015-16": "92.7" }], "BE": [{ "2014-15": "87.9" }, { "2015-16": "84.6" }, { "2016-17": "92.3" }, { "2017-18": "93" }], "RE": [{ "2014-15": "87.5" }, { "2015-16": "90.1" }, { "2016-17": "93" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "90.2" }, { "2014-15": "90" }, { "2015-16": "88.1" }], "BE": [{ "2014-15": "87.1" }, { "2015-16": "87.7" }, { "2016-17": "85.8" }, { "2017-18": "85.1" }], "RE": [{ "2014-15": "87.7" }, { "2015-16": "87.4" }, { "2016-17": "87" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "98.4" }, { "2014-15": "98.3" }, { "2015-16": "98.9" }], "BE": [{ "2014-15": "93.8" }, { "2015-16": "94.6" }, { "2016-17": "97.1" }, { "2017-18": "96.9" }], "RE": [{ "2014-15": "96.5" }, { "2015-16": "96.7" }, { "2016-17": "94.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "90.7" }, { "2014-15": "94.2" }, { "2015-16": "95" }], "BE": [{ "2014-15": "88.8" }, { "2015-16": "93.9" }, { "2016-17": "92.7" }, { "2017-18": "87.8" }], "RE": [{ "2014-15": "89.4" }, { "2015-16": "94.9" }, { "2016-17": "92.7" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "89.6" }, { "2014-15": "90.4" }, { "2015-16": "94.4" }], "BE": [{ "2014-15": "84.6" }, { "2015-16": "86.2" }, { "2016-17": "92" }, { "2017-18": "94" }], "RE": [{ "2014-15": "89" }, { "2015-16": "89.5" }, { "2016-17": "93.4" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "98.3" }, { "2014-15": "94.7" }, { "2015-16": "98.5" }], "BE": [{ "2014-15": "96.3" }, { "2015-16": "95.4" }, { "2016-17": "97.4" }, { "2017-18": "88.3" }], "RE": [{ "2014-15": "96.3" }, { "2015-16": "95.4" }, { "2016-17": "97.4" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "98.1" }, { "2014-15": "100" }, { "2015-16": "99.7" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "100" }], "RE": [{ "2014-15": "95.8" }, { "2015-16": "100" }, { "2016-17": "99.9" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "95.4" }, { "2014-15": "89.3" }, { "2015-16": "92.9" }], "BE": [{ "2014-15": "93.6" }, { "2015-16": "99.3" }, { "2016-17": "99.9" }, { "2017-18": "99.8" }], "RE": [{ "2014-15": "93.3" }, { "2015-16": "99.5" }, { "2016-17": "98.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "91.7" }, { "2014-15": "92" }, { "2015-16": "89.9" }], "BE": [{ "2014-15": "91.6" }, { "2015-16": "89.1" }, { "2016-17": "94.8" }, { "2017-18": "95.4" }], "RE": [{ "2014-15": "91.1" }, { "2015-16": "93.5" }, { "2016-17": "94.9" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "99.6" }, { "2014-15": "97.1" }, { "2015-16": "99" }], "BE": [{ "2014-15": "93.2" }, { "2015-16": "94.3" }, { "2016-17": "94.6" }, { "2017-18": "94.5" }], "RE": [{ "2014-15": "96.6" }, { "2015-16": "97.2" }, { "2016-17": "97.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "96" }, { "2014-15": "96.3" }, { "2015-16": "95.6" }], "BE": [{ "2014-15": "90.1" }, { "2015-16": "92.2" }, { "2016-17": "91" }, { "2017-18": "92.4" }], "RE": [{ "2014-15": "95.8" }, { "2015-16": "94.3" }, { "2016-17": "94" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "81.5" }, { "2014-15": "91.8" }, { "2015-16": "88" }], "BE": [{ "2014-15": "82.4" }, { "2015-16": "80.7" }, { "2016-17": "83.4" }, { "2017-18": "74.3" }], "RE": [{ "2014-15": "83.5" }, { "2015-16": "80.9" }, { "2016-17": "80.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "94.2" }, { "2014-15": "96.8" }, { "2015-16": "98.6" }], "BE": [{ "2014-15": "95.1" }, { "2015-16": "98.2" }, { "2016-17": "96.3" }, { "2017-18": "97.5" }], "RE": [{ "2014-15": "95.4" }, { "2015-16": "96.3" }, { "2016-17": "97.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "54.6" }, { "2014-15": "47" }, { "2015-16": "40.6" }], "BE": [{ "2014-15": "49.1" }, { "2015-16": "42.5" }, { "2016-17": "37.7" }, { "2017-18": "51.4" }], "RE": [{ "2014-15": "47.2" }, { "2015-16": "41.4" }, { "2016-17": "42.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "84.6" }, { "2014-15": "72.2" }, { "2015-16": "80.4" }], "BE": [{ "2014-15": "74.4" }, { "2015-16": "74.5" }, { "2016-17": "76.6" }, { "2017-18": "84.2" }], "RE": [{ "2014-15": "73.5" }, { "2015-16": "79.1" }, { "2016-17": "76.4" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "78.6" }, { "2014-15": "84.4" }, { "2015-16": "93.2" }], "BE": [{ "2014-15": "73.5" }, { "2015-16": "90.9" }, { "2016-17": "91.6" }, { "2017-18": "90.1" }], "RE": [{ "2014-15": "78.9" }, { "2015-16": "92.2" }, { "2016-17": "93.3" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "93.3" }, { "2014-15": "87.7" }, { "2015-16": "92.9" }], "BE": [{ "2014-15": "84.2" }, { "2015-16": "79.9" }, { "2016-17": "78.8" }, { "2017-18": "67.8" }], "RE": [{ "2014-15": "85.3" }, { "2015-16": "88.8" }, { "2016-17": "86.1" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "" }, { "2015-16": "8.6" }], "BE": [{ "2014-15": "17.5" }, { "2015-16": "9.8" }, { "2016-17": "10.6" }, { "2017-18": "9.7" }], "RE": [{ "2014-15": "17.6" }, { "2015-16": "7.8" }, { "2016-17": "6.7" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "2.7" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "1.2" }, { "2014-15": "2.5" }, { "2015-16": "2.6" }], "BE": [{ "2014-15": "10.5" }, { "2015-16": "1.6" }, { "2016-17": "3.3" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "7.9" }, { "2015-16": "2.1" }, { "2016-17": "3.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "5.6" }, { "2014-15": "6.9" }, { "2015-16": "12.4" }], "BE": [{ "2014-15": "7.7" }, { "2015-16": "7.1" }, { "2016-17": "11.7" }, { "2017-18": "14.1" }], "RE": [{ "2014-15": "7.4" }, { "2015-16": "10.6" }, { "2016-17": "14.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "3.2" }, { "2015-16": "2.1" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "3.9" }, { "2016-17": "3.3" }, { "2017-18": "2.9" }], "RE": [{ "2014-15": "4.4" }, { "2015-16": "2.8" }, { "2016-17": "3.3" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "27.4" }, { "2014-15": "30.3" }, { "2015-16": "27.2" }], "BE": [{ "2014-15": "26.8" }, { "2015-16": "28.3" }, { "2016-17": "24.2" }, { "2017-18": "24.2" }], "RE": [{ "2014-15": "27.9" }, { "2015-16": "25" }, { "2016-17": "21.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "5.1" }, { "2015-16": "3.2" }], "BE": [{ "2014-15": "6.3" }, { "2015-16": "6.5" }, { "2016-17": "4" }, { "2017-18": "4.5" }], "RE": [{ "2014-15": "8.1" }, { "2015-16": "4.3" }, { "2016-17": "4.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "27.5" }, { "2014-15": "29" }, { "2015-16": "28.1" }], "BE": [{ "2014-15": "29.2" }, { "2015-16": "28.7" }, { "2016-17": "31.4" }, { "2017-18": "31.4" }], "RE": [{ "2014-15": "30" }, { "2015-16": "24.7" }, { "2016-17": "34.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "34.8" }, { "2015-16": "16.5" }, { "2016-17": "50.5" }, { "2017-18": "46.4" }], "RE": [{ "2014-15": "9.3" }, { "2015-16": "15.9" }, { "2016-17": "64.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "15.2" }, { "2014-15": "14" }, { "2015-16": "7.3" }], "BE": [{ "2014-15": "12.1" }, { "2015-16": "15.4" }, { "2016-17": "7.7" }, { "2017-18": "7" }], "RE": [{ "2014-15": "12.5" }, { "2015-16": "9.9" }, { "2016-17": "7" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "9.8" }, { "2014-15": "10" }, { "2015-16": "11.9" }], "BE": [{ "2014-15": "12.9" }, { "2015-16": "12.3" }, { "2016-17": "14.2" }, { "2017-18": "14.9" }], "RE": [{ "2014-15": "12.3" }, { "2015-16": "12.6" }, { "2016-17": "13" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1.6" }, { "2014-15": "1.7" }, { "2015-16": "1.1" }], "BE": [{ "2014-15": "6.2" }, { "2015-16": "5.4" }, { "2016-17": "2.9" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "3.5" }, { "2015-16": "3.3" }, { "2016-17": "5.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "9.3" }, { "2014-15": "5.8" }, { "2015-16": "5" }], "BE": [{ "2014-15": "11.2" }, { "2015-16": "6.1" }, { "2016-17": "7.3" }, { "2017-18": "12.2" }], "RE": [{ "2014-15": "10.6" }, { "2015-16": "5.1" }, { "2016-17": "7.3" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "10.4" }, { "2014-15": "9.6" }, { "2015-16": "5.6" }], "BE": [{ "2014-15": "15.4" }, { "2015-16": "13.8" }, { "2016-17": "8" }, { "2017-18": "6" }], "RE": [{ "2014-15": "11" }, { "2015-16": "10.5" }, { "2016-17": "6.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "5.3" }, { "2015-16": "1.5" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "4.6" }, { "2016-17": "2.6" }, { "2017-18": "11.7" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "4.6" }, { "2016-17": "2.6" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "0" }, { "2015-16": "0.3" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "0" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "0" }, { "2016-17": "0.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "4.6" }, { "2014-15": "10.7" }, { "2015-16": "7.1" }], "BE": [{ "2014-15": "6.4" }, { "2015-16": "0.7" }, { "2016-17": "0.1" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "6.7" }, { "2015-16": "0.5" }, { "2016-17": "1.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "8.3" }, { "2014-15": "8" }, { "2015-16": "10.1" }], "BE": [{ "2014-15": "8.4" }, { "2015-16": "10.9" }, { "2016-17": "5.2" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "8.9" }, { "2015-16": "6.5" }, { "2016-17": "5.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "0.4" }, { "2014-15": "2.9" }, { "2015-16": "1" }], "BE": [{ "2014-15": "6.8" }, { "2015-16": "5.7" }, { "2016-17": "5.4" }, { "2017-18": "5.5" }], "RE": [{ "2014-15": "3.4" }, { "2015-16": "2.8" }, { "2016-17": "2.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "3.7" }, { "2015-16": "4.4" }], "BE": [{ "2014-15": "9.9" }, { "2015-16": "7.8" }, { "2016-17": "9" }, { "2017-18": "7.6" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "5.7" }, { "2016-17": "6" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "18.5" }, { "2014-15": "8.2" }, { "2015-16": "12" }], "BE": [{ "2014-15": "17.6" }, { "2015-16": "19.3" }, { "2016-17": "16.6" }, { "2017-18": "25.7" }], "RE": [{ "2014-15": "16.5" }, { "2015-16": "19.1" }, { "2016-17": "19.3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "5.8" }, { "2014-15": "3.2" }, { "2015-16": "1.4" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "1.8" }, { "2016-17": "3.7" }, { "2017-18": "2.5" }], "RE": [{ "2014-15": "4.6" }, { "2015-16": "3.7" }, { "2016-17": "2.7" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "45.4" }, { "2014-15": "53" }, { "2015-16": "59.4" }], "BE": [{ "2014-15": "50.9" }, { "2015-16": "57.5" }, { "2016-17": "62.3" }, { "2017-18": "48.6" }], "RE": [{ "2014-15": "52.8" }, { "2015-16": "58.6" }, { "2016-17": "57.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "15.4" }, { "2014-15": "27.8" }, { "2015-16": "19.6" }], "BE": [{ "2014-15": "25.6" }, { "2015-16": "25.5" }, { "2016-17": "23.4" }, { "2017-18": "15.8" }], "RE": [{ "2014-15": "26.5" }, { "2015-16": "20.9" }, { "2016-17": "23.6" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "21.4" }, { "2014-15": "15.6" }, { "2015-16": "6.8" }], "BE": [{ "2014-15": "26.5" }, { "2015-16": "9.1" }, { "2016-17": "8.4" }, { "2017-18": "9.9" }], "RE": [{ "2014-15": "21.1" }, { "2015-16": "7.8" }, { "2016-17": "6.7" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "6.7" }, { "2014-15": "12.3" }, { "2015-16": "7.1" }], "BE": [{ "2014-15": "15.8" }, { "2015-16": "20.1" }, { "2016-17": "21.2" }, { "2017-18": "32.2" }], "RE": [{ "2014-15": "14.7" }, { "2015-16": "11.2" }, { "2016-17": "13.9" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Social Welfare" }, { "category_slug": "health", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "5737.2" }, { "2014-15": "" }, { "2015-16": "5069" }], "BE": [{ "2014-15": "4387.9" }, { "2015-16": "5728.2" }, { "2016-17": "6103.8" }, { "2017-18": "7020.6" }], "RE": [{ "2014-15": "4362.9" }, { "2015-16": "4697.6" }, { "2016-17": "5764.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "269.5" }, { "2014-15": "1917.5" }, { "2015-16": "2857.5" }], "BE": [{ "2014-15": "3011.2" }, { "2015-16": "3252.2" }, { "2016-17": "3984.1" }, { "2017-18": "4871.8" }], "RE": [{ "2014-15": "3090.1" }, { "2015-16": "4399" }, { "2016-17": "4152.2" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "2592" }, { "2014-15": "3609.6" }, { "2015-16": "4602.6" }], "BE": [{ "2014-15": "4805.7" }, { "2015-16": "4971.7" }, { "2016-17": "8234.7" }, { "2017-18": "7001.5" }], "RE": [{ "2014-15": "5263.4" }, { "2015-16": "4984.9" }, { "2016-17": "8283.5" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "1544.5" }, { "2014-15": "2322.6" }, { "2015-16": "2684.5" }], "BE": [{ "2014-15": "2900.1" }, { "2015-16": "3208.5" }, { "2016-17": "4016.2" }, { "2017-18": "4376.9" }], "RE": [{ "2014-15": "2870.3" }, { "2015-16": "3398.3" }, { "2016-17": "4116.2" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "2603.9" }, { "2014-15": "3115.8" }, { "2015-16": "3299.6" }], "BE": [{ "2014-15": "3713.9" }, { "2015-16": "3933.9" }, { "2016-17": "4613.2" }, { "2017-18": "5034.4" }], "RE": [{ "2014-15": "3584.3" }, { "2015-16": "3625.5" }, { "2016-17": "4059.5" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "4235.9" }, { "2014-15": "5189.3" }, { "2015-16": "5898.6" }], "BE": [{ "2014-15": "5611.9" }, { "2015-16": "6153.5" }, { "2016-17": "6821.2" }, { "2017-18": "7368.2" }], "RE": [{ "2014-15": "5629" }, { "2015-16": "6066.7" }, { "2016-17": "6777.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "1752.5" }, { "2014-15": "2238.7" }, { "2015-16": "2524.9" }], "BE": [{ "2014-15": "2804.4" }, { "2015-16": "3028.6" }, { "2016-17": "3916.9" }, { "2017-18": "4070.8" }], "RE": [{ "2014-15": "2646.2" }, { "2015-16": "2857.3" }, { "2016-17": "3529.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "968.5" }, { "2014-15": "1140.4" }, { "2015-16": "1235.8" }], "BE": [{ "2014-15": "1165.2" }, { "2015-16": "1558.9" }, { "2016-17": "1671.7" }, { "2017-18": "1668.9" }], "RE": [{ "2014-15": "1141.1" }, { "2015-16": "1248.7" }, { "2016-17": "1580.1" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1341.7" }, { "2014-15": "1434.7" }, { "2015-16": "1922.7" }], "BE": [{ "2014-15": "2199.4" }, { "2015-16": "2649.1" }, { "2016-17": "3036.6" }, { "2017-18": "3508.7" }], "RE": [{ "2014-15": "2311.3" }, { "2015-16": "2887.9" }, { "2016-17": "2943.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "1132.8" }, { "2014-15": "1565.9" }, { "2015-16": "2158.5" }], "BE": [{ "2014-15": "2619.1" }, { "2015-16": "2919.5" }, { "2016-17": "3049.7" }, { "2017-18": "3106" }], "RE": [{ "2014-15": "2442.9" }, { "2015-16": "2947.4" }, { "2016-17": "2966.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "4533.5" }, { "2014-15": "5699.9" }, { "2015-16": "5527.4" }], "BE": [{ "2014-15": "5900.8" }, { "2015-16": "5825.6" }, { "2016-17": "6303.1" }, { "2017-18": "6728.2" }], "RE": [{ "2014-15": "6276.4" }, { "2015-16": "6448" }, { "2016-17": "6486.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "3652" }, { "2014-15": "4239.6" }, { "2015-16": "4777.4" }], "BE": [{ "2014-15": "4530.6" }, { "2015-16": "5600.8" }, { "2016-17": "5696" }, { "2017-18": "6834.9" }], "RE": [{ "2014-15": "5043.7" }, { "2015-16": "5165.2" }, { "2016-17": "5851.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "3287.2" }, { "2014-15": "4566.8" }, { "2015-16": "5243.9" }], "BE": [{ "2014-15": "5887.3" }, { "2015-16": "5727.5" }, { "2016-17": "6836.2" }, { "2017-18": "7725.5" }], "RE": [{ "2014-15": "5227.5" }, { "2015-16": "5217.2" }, { "2016-17": "6065.1" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "6537" }, { "2014-15": "7995.6" }, { "2015-16": "8875.4" }], "BE": [{ "2014-15": "9269.5" }, { "2015-16": "8712.7" }, { "2016-17": "9320" }, { "2017-18": "10847.5" }], "RE": [{ "2014-15": "9687.2" }, { "2015-16": "10370.5" }, { "2016-17": "11330.1" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "449.7" }, { "2014-15": "571.3" }, { "2015-16": "604.9" }], "BE": [{ "2014-15": "600.9" }, { "2015-16": "582.8" }, { "2016-17": "719.5" }, { "2017-18": "719.5" }], "RE": [{ "2014-15": "600.9" }, { "2015-16": "582.8" }, { "2016-17": "719.5" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "262.5" }, { "2014-15": "345.9" }, { "2015-16": "378.4" }], "BE": [{ "2014-15": "338.8" }, { "2015-16": "406.2" }, { "2016-17": "414.3" }, { "2017-18": "462.2" }], "RE": [{ "2014-15": "454.4" }, { "2015-16": "544.9" }, { "2016-17": "573.6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "303.9" }, { "2014-15": "418.1" }, { "2015-16": "489.8" }], "BE": [{ "2014-15": "476.8" }, { "2015-16": "512.3" }, { "2016-17": "589.8" }, { "2017-18": "617" }], "RE": [{ "2014-15": "521.1" }, { "2015-16": "606.5" }, { "2016-17": "646.4" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "1973.1" }, { "2014-15": "3203.5" }, { "2015-16": "3700.5" }], "BE": [{ "2014-15": "3897.7" }, { "2015-16": "3855.9" }, { "2016-17": "4771.9" }, { "2017-18": "5690.3" }], "RE": [{ "2014-15": "3786.5" }, { "2015-16": "3882.3" }, { "2016-17": "4902.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2037.3" }, { "2014-15": "2481.4" }, { "2015-16": "2711.6" }], "BE": [{ "2014-15": "2790.2" }, { "2015-16": "3134.7" }, { "2016-17": "3325.4" }, { "2017-18": "3568" }], "RE": [{ "2014-15": "2779.6" }, { "2015-16": "3286.2" }, { "2016-17": "3270.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "4337.1" }, { "2014-15": "6462.7" }, { "2015-16": "7757.8" }], "BE": [{ "2014-15": "8708.4" }, { "2015-16": "9416.3" }, { "2016-17": "9537.4" }, { "2017-18": "9750.6" }], "RE": [{ "2014-15": "7449.4" }, { "2015-16": "8241.4" }, { "2016-17": "8573.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "256.4" }, { "2014-15": "261.5" }, { "2015-16": "262.1" }], "BE": [{ "2014-15": "354" }, { "2015-16": "343.4" }, { "2016-17": "285" }, { "2017-18": "364" }], "RE": [{ "2014-15": "361.2" }, { "2015-16": "307.8" }, { "2016-17": "314.8" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "6320.8" }, { "2014-15": "7670.3" }, { "2015-16": "8481.9" }], "BE": [{ "2014-15": "7005" }, { "2015-16": "8610.8" }, { "2016-17": "9072.7" }, { "2017-18": "10157.9" }], "RE": [{ "2014-15": "8027.5" }, { "2015-16": "9071.6" }, { "2016-17": "8856.2" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "426.9" }, { "2014-15": "667.2" }, { "2015-16": "458.4" }], "BE": [{ "2014-15": "615.1" }, { "2015-16": "830.5" }, { "2016-17": "474.8" }, { "2017-18": "599.6" }], "RE": [{ "2014-15": "930.2" }, { "2015-16": "908.1" }, { "2016-17": "739.8" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "8974.1" }, { "2014-15": "11117.1" }, { "2015-16": "12104.3" }], "BE": [{ "2014-15": "13090.1" }, { "2015-16": "14657.8" }, { "2016-17": "17828.5" }, { "2017-18": "17180.7" }], "RE": [{ "2014-15": "12809.7" }, { "2015-16": "14393.3" }, { "2016-17": "15834.1" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "996.3" }, { "2014-15": "1454.1" }, { "2015-16": "1401.5" }], "BE": [{ "2014-15": "1422.9" }, { "2015-16": "1669.6" }, { "2016-17": "1872.4" }, { "2017-18": "1923.3" }], "RE": [{ "2014-15": "1757.4" }, { "2015-16": "1752.9" }, { "2016-17": "1431.4" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "4731.1" }, { "2014-15": "6259.4" }, { "2015-16": "7731.2" }], "BE": [{ "2014-15": "5641.3" }, { "2015-16": "6124.9" }, { "2016-17": "7021.5" }, { "2017-18": "7603.8" }], "RE": [{ "2014-15": "5931" }, { "2015-16": "6967.4" }, { "2016-17": "8188.5" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "4.2" }, { "2014-15": "" }, { "2015-16": "3.4" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "5.1" }, { "2016-17": "4.5" }, { "2017-18": "4.5" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "4.2" }, { "2016-17": "4.3" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0.7" }, { "2014-15": "4.1" }, { "2015-16": "6.8" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "4.9" }, { "2016-17": "5.1" }, { "2017-18": "5.7" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "5.9" }, { "2016-17": "5" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "3.2" }, { "2014-15": "3.8" }, { "2015-16": "4.1" }], "BE": [{ "2014-15": "4.1" }, { "2015-16": "4.1" }, { "2016-17": "5.7" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "4" }, { "2015-16": "3.8" }, { "2016-17": "5.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "5" }, { "2015-16": "5.2" }], "BE": [{ "2014-15": "5.3" }, { "2015-16": "4.9" }, { "2016-17": "5.7" }, { "2017-18": "5.8" }], "RE": [{ "2014-15": "5.2" }, { "2015-16": "5.2" }, { "2016-17": "5.8" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "7.6" }, { "2014-15": "10.1" }, { "2015-16": "9.4" }], "BE": [{ "2014-15": "10.1" }, { "2015-16": "9.6" }, { "2016-17": "9.9" }, { "2017-18": "10.5" }], "RE": [{ "2014-15": "10.3" }, { "2015-16": "9.5" }, { "2016-17": "9.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "4" }, { "2014-15": "4.4" }, { "2015-16": "3.9" }], "BE": [{ "2014-15": "4.3" }, { "2015-16": "4.5" }, { "2016-17": "5.4" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "4.5" }, { "2015-16": "4.6" }, { "2016-17": "4.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "3.8" }, { "2014-15": "4.2" }, { "2015-16": "4.1" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "4.4" }, { "2016-17": "5" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "4.3" }, { "2015-16": "4.2" }, { "2016-17": "4.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "3.7" }, { "2015-16": "4.2" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "5.5" }, { "2016-17": "5.1" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "4.6" }, { "2016-17": "4.5" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "4" }, { "2015-16": "3" }], "BE": [{ "2014-15": "5.1" }, { "2015-16": "5.7" }, { "2016-17": "6.6" }, { "2017-18": "4.4" }], "RE": [{ "2014-15": "5.4" }, { "2015-16": "5.6" }, { "2016-17": "4.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "3.7" }, { "2014-15": "3.9" }, { "2015-16": "4" }], "BE": [{ "2014-15": "5.2" }, { "2015-16": "5.3" }, { "2016-17": "4.8" }, { "2017-18": "4.1" }], "RE": [{ "2014-15": "4.8" }, { "2015-16": "5.3" }, { "2016-17": "4.5" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "4.2" }, { "2014-15": "4.6" }, { "2015-16": "4" }], "BE": [{ "2014-15": "4.5" }, { "2015-16": "4.3" }, { "2016-17": "4" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "4.6" }, { "2016-17": "4.1" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "5.5" }, { "2015-16": "5.5" }], "BE": [{ "2014-15": "5.7" }, { "2015-16": "5.9" }, { "2016-17": "5.3" }, { "2017-18": "5.7" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.8" }, { "2016-17": "5.6" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "3.8" }, { "2014-15": "4.3" }, { "2015-16": "4.4" }], "BE": [{ "2014-15": "5" }, { "2015-16": "4.4" }, { "2016-17": "4.3" }, { "2017-18": "4.5" }], "RE": [{ "2014-15": "4.4" }, { "2015-16": "3.9" }, { "2016-17": "3.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "3.7" }, { "2015-16": "3.9" }], "BE": [{ "2014-15": "4.1" }, { "2015-16": "3.6" }, { "2016-17": "3.4" }, { "2017-18": "3.6" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "4.2" }, { "2016-17": "4" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "6.5" }, { "2014-15": "7.5" }, { "2015-16": "7.6" }], "BE": [{ "2014-15": "5" }, { "2015-16": "6" }, { "2016-17": "6.7" }, { "2017-18": "5.5" }], "RE": [{ "2014-15": "5" }, { "2015-16": "6" }, { "2016-17": "6.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "4.8" }, { "2014-15": "4.5" }, { "2015-16": "6" }], "BE": [{ "2014-15": "5" }, { "2015-16": "5.2" }, { "2016-17": "5.2" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "5.8" }, { "2015-16": "6.6" }, { "2016-17": "6" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "4.1" }, { "2015-16": "4.3" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "4.1" }, { "2016-17": "4.3" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "4.6" }, { "2015-16": "4.8" }, { "2016-17": "4.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "3.5" }, { "2014-15": "4.8" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "4.9" }, { "2015-16": "4.6" }, { "2016-17": "5.1" }, { "2017-18": "5.3" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "4.6" }, { "2016-17": "5.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "3.4" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "4" }, { "2016-17": "3.8" }, { "2017-18": "3" }], "RE": [{ "2014-15": "3.7" }, { "2015-16": "4.2" }, { "2016-17": "2.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "4.6" }, { "2014-15": "5.5" }, { "2015-16": "6" }], "BE": [{ "2014-15": "6.6" }, { "2015-16": "6.8" }, { "2016-17": "6.3" }, { "2017-18": "5.8" }], "RE": [{ "2014-15": "5.9" }, { "2015-16": "6" }, { "2016-17": "5.8" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "5.7" }, { "2014-15": "5.4" }, { "2015-16": "5.8" }], "BE": [{ "2014-15": "5.4" }, { "2015-16": "6.2" }, { "2016-17": "5" }, { "2017-18": "5.9" }], "RE": [{ "2014-15": "5.4" }, { "2015-16": "5.5" }, { "2016-17": "5.3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "4.9" }, { "2014-15": "4.9" }, { "2015-16": "5" }], "BE": [{ "2014-15": "4.6" }, { "2015-16": "4.9" }, { "2016-17": "4.6" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "5" }, { "2015-16": "5.1" }, { "2016-17": "4.1" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "6.3" }, { "2015-16": "4" }], "BE": [{ "2014-15": "5" }, { "2015-16": "5.6" }, { "2016-17": "3.1" }, { "2017-18": "3.8" }], "RE": [{ "2014-15": "7.5" }, { "2015-16": "7" }, { "2016-17": "5" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "4.7" }, { "2015-16": "4" }], "BE": [{ "2014-15": "4.8" }, { "2015-16": "4.8" }, { "2016-17": "5.1" }, { "2017-18": "4.5" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "4.4" }, { "2016-17": "4.7" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "5.3" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "4.7" }, { "2015-16": "5.1" }, { "2016-17": "4.6" }, { "2017-18": "4.8" }], "RE": [{ "2014-15": "5.4" }, { "2015-16": "5.2" }, { "2016-17": "4.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "4.4" }, { "2014-15": "5.1" }, { "2015-16": "5.5" }], "BE": [{ "2014-15": "4.3" }, { "2015-16": "4.4" }, { "2016-17": "4.4" }, { "2017-18": "4.2" }], "RE": [{ "2014-15": "4.6" }, { "2015-16": "4.8" }, { "2016-17": "4.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "1150.7" }, { "2014-15": "" }, { "2015-16": "1004.8" }], "BE": [{ "2014-15": "874.9" }, { "2015-16": "1135.5" }, { "2016-17": "1202.9" }, { "2017-18": "1375.7" }], "RE": [{ "2014-15": "870" }, { "2015-16": "931.2" }, { "2016-17": "1136" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "86.1" }, { "2014-15": "605" }, { "2015-16": "891" }], "BE": [{ "2014-15": "950.1" }, { "2015-16": "1014.1" }, { "2016-17": "1227.8" }, { "2017-18": "1484.2" }], "RE": [{ "2014-15": "975" }, { "2015-16": "1371.7" }, { "2016-17": "1279.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "258.5" }, { "2014-15": "355.5" }, { "2015-16": "448" }], "BE": [{ "2014-15": "473.3" }, { "2015-16": "483.9" }, { "2016-17": "792.5" }, { "2017-18": "666" }], "RE": [{ "2014-15": "518.4" }, { "2015-16": "485.2" }, { "2016-17": "797.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "620" }, { "2014-15": "920.5" }, { "2015-16": "1050.5" }], "BE": [{ "2014-15": "1149.4" }, { "2015-16": "1255.5" }, { "2016-17": "1551.9" }, { "2017-18": "1670.5" }], "RE": [{ "2014-15": "1137.6" }, { "2015-16": "1329.8" }, { "2016-17": "1590.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1333.3" }, { "2014-15": "1550.7" }, { "2015-16": "1595.9" }], "BE": [{ "2014-15": "1848.4" }, { "2015-16": "1902.6" }, { "2016-17": "2167.4" }, { "2017-18": "2303.2" }], "RE": [{ "2014-15": "1783.9" }, { "2015-16": "1753.5" }, { "2016-17": "1907.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "1612.7" }, { "2014-15": "1945.4" }, { "2015-16": "2178.3" }], "BE": [{ "2014-15": "2103.8" }, { "2015-16": "2272.4" }, { "2016-17": "2482.5" }, { "2017-18": "2642.5" }], "RE": [{ "2014-15": "2110.2" }, { "2015-16": "2240.4" }, { "2016-17": "2466.6" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "289.3" }, { "2014-15": "365" }, { "2015-16": "406.7" }], "BE": [{ "2014-15": "457.3" }, { "2015-16": "487.8" }, { "2016-17": "623.5" }, { "2017-18": "640.3" }], "RE": [{ "2014-15": "431.5" }, { "2015-16": "460.2" }, { "2016-17": "561.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "1400" }, { "2014-15": "1634.3" }, { "2015-16": "1756.2" }], "BE": [{ "2014-15": "1669.7" }, { "2015-16": "2215.2" }, { "2016-17": "2356.1" }, { "2017-18": "2332.7" }], "RE": [{ "2014-15": "1635.3" }, { "2015-16": "1774.5" }, { "2016-17": "2227" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "1117.2" }, { "2014-15": "1180.6" }, { "2015-16": "1564.6" }], "BE": [{ "2014-15": "1809.9" }, { "2015-16": "2155.7" }, { "2016-17": "2445.1" }, { "2017-18": "2793.9" }], "RE": [{ "2014-15": "1902" }, { "2015-16": "2350" }, { "2016-17": "2370.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "350.3" }, { "2014-15": "477.9" }, { "2015-16": "650.1" }], "BE": [{ "2014-15": "799.3" }, { "2015-16": "879.3" }, { "2016-17": "906.2" }, { "2017-18": "911.2" }], "RE": [{ "2014-15": "745.5" }, { "2015-16": "887.7" }, { "2016-17": "881.4" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "747.8" }, { "2014-15": "931.1" }, { "2015-16": "894.4" }], "BE": [{ "2014-15": "964" }, { "2015-16": "942.7" }, { "2016-17": "1010.5" }, { "2017-18": "1068.6" }], "RE": [{ "2014-15": "1025.3" }, { "2015-16": "1043.4" }, { "2016-17": "1039.9" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1042.4" }, { "2014-15": "1202.4" }, { "2015-16": "1346.8" }], "BE": [{ "2014-15": "1285" }, { "2015-16": "1578.9" }, { "2016-17": "1596.5" }, { "2017-18": "1904.1" }], "RE": [{ "2014-15": "1430.5" }, { "2015-16": "1456.1" }, { "2016-17": "1640.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "441.3" }, { "2014-15": "604" }, { "2015-16": "683.3" }], "BE": [{ "2014-15": "778.6" }, { "2015-16": "746.3" }, { "2016-17": "877.8" }, { "2017-18": "977.8" }], "RE": [{ "2014-15": "691.3" }, { "2015-16": "679.8" }, { "2016-17": "778.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "565" }, { "2014-15": "682.3" }, { "2015-16": "748" }], "BE": [{ "2014-15": "791" }, { "2015-16": "734.3" }, { "2016-17": "776.2" }, { "2017-18": "892.4" }], "RE": [{ "2014-15": "826.6" }, { "2015-16": "874" }, { "2016-17": "943.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1676.7" }, { "2014-15": "2106.4" }, { "2015-16": "2205.1" }], "BE": [{ "2014-15": "2215.8" }, { "2015-16": "2124.8" }, { "2016-17": "2594.7" }, { "2017-18": "2566.5" }], "RE": [{ "2014-15": "2215.8" }, { "2015-16": "2124.8" }, { "2016-17": "2594.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "2554" }, { "2014-15": "3328.8" }, { "2015-16": "3600.6" }], "BE": [{ "2014-15": "3260.8" }, { "2015-16": "3864.9" }, { "2016-17": "3897.3" }, { "2017-18": "4301.7" }], "RE": [{ "2014-15": "4373" }, { "2015-16": "5184.5" }, { "2016-17": "5396.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1320.7" }, { "2014-15": "1796.7" }, { "2015-16": "2080.6" }], "BE": [{ "2014-15": "2048.9" }, { "2015-16": "2176.2" }, { "2016-17": "2478.2" }, { "2017-18": "2563.2" }], "RE": [{ "2014-15": "2213.6" }, { "2015-16": "2576.6" }, { "2016-17": "2715.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "476" }, { "2014-15": "766.5" }, { "2015-16": "878.2" }], "BE": [{ "2014-15": "932.5" }, { "2015-16": "915.1" }, { "2016-17": "1123.3" }, { "2017-18": "1328.8" }], "RE": [{ "2014-15": "905.9" }, { "2015-16": "921.3" }, { "2016-17": "1154.2" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "720.4" }, { "2014-15": "868.6" }, { "2015-16": "940" }], "BE": [{ "2014-15": "976.7" }, { "2015-16": "1086.7" }, { "2016-17": "1142.3" }, { "2017-18": "1213.8" }], "RE": [{ "2014-15": "973" }, { "2015-16": "1139.2" }, { "2016-17": "1123.4" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "620.1" }, { "2014-15": "910.6" }, { "2015-16": "1077.9" }], "BE": [{ "2014-15": "1227.1" }, { "2015-16": "1308.3" }, { "2016-17": "1307.4" }, { "2017-18": "1318.3" }], "RE": [{ "2014-15": "1049.7" }, { "2015-16": "1145.1" }, { "2016-17": "1175.3" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "4096.2" }, { "2014-15": "4131" }, { "2015-16": "4095.8" }], "BE": [{ "2014-15": "5592.4" }, { "2015-16": "5365.8" }, { "2016-17": "4404.5" }, { "2017-18": "5566.2" }], "RE": [{ "2014-15": "5705.6" }, { "2015-16": "4809.9" }, { "2016-17": "4865" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "925.9" }, { "2014-15": "1117.2" }, { "2015-16": "1228.7" }], "BE": [{ "2014-15": "1020.3" }, { "2015-16": "1247.4" }, { "2016-17": "1307.4" }, { "2017-18": "1455.7" }], "RE": [{ "2014-15": "1169.3" }, { "2015-16": "1314.2" }, { "2016-17": "1276.2" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1153.7" }, { "2014-15": "1783.1" }, { "2015-16": "1211.3" }], "BE": [{ "2014-15": "1643.8" }, { "2015-16": "2194.7" }, { "2016-17": "1241" }, { "2017-18": "1550.2" }], "RE": [{ "2014-15": "2485.9" }, { "2015-16": "2399.8" }, { "2016-17": "1933.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "432" }, { "2014-15": "526.3" }, { "2015-16": "563.9" }], "BE": [{ "2014-15": "619.7" }, { "2015-16": "682.8" }, { "2016-17": "817.5" }, { "2017-18": "775.5" }], "RE": [{ "2014-15": "606.5" }, { "2015-16": "670.5" }, { "2016-17": "726" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "974.5" }, { "2014-15": "1392.7" }, { "2015-16": "1273.3" }], "BE": [{ "2014-15": "1373.2" }, { "2015-16": "1577.8" }, { "2016-17": "1679.5" }, { "2017-18": "1682.5" }], "RE": [{ "2014-15": "1696" }, { "2015-16": "1634.6" }, { "2016-17": "1267.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "519.2" }, { "2014-15": "681" }, { "2015-16": "833.8" }], "BE": [{ "2014-15": "613.7" }, { "2015-16": "660.5" }, { "2016-17": "750.6" }, { "2017-18": "805.9" }], "RE": [{ "2014-15": "645.2" }, { "2015-16": "751.4" }, { "2016-17": "875.3" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "95.9" }, { "2014-15": "" }, { "2015-16": "94.5" }], "BE": [{ "2014-15": "93.9" }, { "2015-16": "91.9" }, { "2016-17": "92.1" }, { "2017-18": "93.6" }], "RE": [{ "2014-15": "94" }, { "2015-16": "95.1" }, { "2016-17": "93.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "99.3" }, { "2015-16": "99.8" }], "BE": [{ "2014-15": "100" }, { "2015-16": "95.9" }, { "2016-17": "97.1" }, { "2017-18": "90.8" }], "RE": [{ "2014-15": "99.6" }, { "2015-16": "96.7" }, { "2016-17": "97.2" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "82.2" }, { "2014-15": "91.6" }, { "2015-16": "76.6" }], "BE": [{ "2014-15": "85.3" }, { "2015-16": "70.6" }, { "2016-17": "88.9" }, { "2017-18": "88.3" }], "RE": [{ "2014-15": "79.4" }, { "2015-16": "80.8" }, { "2016-17": "89" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "92" }, { "2014-15": "90.2" }, { "2015-16": "89.2" }], "BE": [{ "2014-15": "90" }, { "2015-16": "90.5" }, { "2016-17": "89.6" }, { "2017-18": "88.6" }], "RE": [{ "2014-15": "91.2" }, { "2015-16": "86.9" }, { "2016-17": "89.2" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "97.9" }], "BE": [{ "2014-15": "100" }, { "2015-16": "95.8" }, { "2016-17": "95" }, { "2017-18": "96.6" }], "RE": [{ "2014-15": "99.7" }, { "2015-16": "96.3" }, { "2016-17": "97.8" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "69.8" }, { "2014-15": "71.4" }, { "2015-16": "76.1" }], "BE": [{ "2014-15": "71.9" }, { "2015-16": "72.7" }, { "2016-17": "77.4" }, { "2017-18": "80.4" }], "RE": [{ "2014-15": "72" }, { "2015-16": "76.6" }, { "2016-17": "81.7" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "97.2" }, { "2014-15": "97.1" }, { "2015-16": "98.6" }], "BE": [{ "2014-15": "96.3" }, { "2015-16": "98.7" }, { "2016-17": "85.2" }, { "2017-18": "83.5" }], "RE": [{ "2014-15": "96.4" }, { "2015-16": "98.7" }, { "2016-17": "88.9" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "94" }, { "2014-15": "96.1" }, { "2015-16": "92.3" }], "BE": [{ "2014-15": "96.1" }, { "2015-16": "96.7" }, { "2016-17": "96.8" }, { "2017-18": "96" }], "RE": [{ "2014-15": "96" }, { "2015-16": "92.4" }, { "2016-17": "83.7" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "84.7" }, { "2015-16": "72.2" }, { "2016-17": "80.1" }, { "2017-18": "77.4" }], "RE": [{ "2014-15": "73.8" }, { "2015-16": "74.9" }, { "2016-17": "74.4" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "85.3" }, { "2014-15": "83.3" }, { "2015-16": "84.3" }], "BE": [{ "2014-15": "85" }, { "2015-16": "85.3" }, { "2016-17": "78.8" }, { "2017-18": "85.4" }], "RE": [{ "2014-15": "86.4" }, { "2015-16": "83.9" }, { "2016-17": "76.9" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "90.3" }, { "2014-15": "86.1" }, { "2015-16": "85.2" }], "BE": [{ "2014-15": "91.2" }, { "2015-16": "90" }, { "2016-17": "90" }, { "2017-18": "89" }], "RE": [{ "2014-15": "90.1" }, { "2015-16": "89.1" }, { "2016-17": "89.8" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "96.4" }, { "2014-15": "95.4" }, { "2015-16": "95.4" }], "BE": [{ "2014-15": "94.7" }, { "2015-16": "95.3" }, { "2016-17": "93.6" }, { "2017-18": "95.3" }], "RE": [{ "2014-15": "93.7" }, { "2015-16": "94.1" }, { "2016-17": "94.1" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "95.2" }, { "2014-15": "95" }, { "2015-16": "95.8" }], "BE": [{ "2014-15": "95.7" }, { "2015-16": "96" }, { "2016-17": "94.3" }, { "2017-18": "84.6" }], "RE": [{ "2014-15": "96" }, { "2015-16": "96.1" }, { "2016-17": "94.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "99.1" }, { "2014-15": "99.6" }, { "2015-16": "98.8" }], "BE": [{ "2014-15": "99.1" }, { "2015-16": "98.8" }, { "2016-17": "98.7" }, { "2017-18": "98.6" }], "RE": [{ "2014-15": "99" }, { "2015-16": "98.7" }, { "2016-17": "98.2" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "78.6" }, { "2014-15": "84.6" }, { "2015-16": "84.8" }], "BE": [{ "2014-15": "83.5" }, { "2015-16": "83.1" }, { "2016-17": "88.3" }, { "2017-18": "94.3" }], "RE": [{ "2014-15": "83.5" }, { "2015-16": "83.1" }, { "2016-17": "88.3" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "94.5" }, { "2014-15": "94.9" }, { "2015-16": "97" }], "BE": [{ "2014-15": "96.4" }, { "2015-16": "97.1" }, { "2016-17": "100" }, { "2017-18": "92" }], "RE": [{ "2014-15": "95.8" }, { "2015-16": "95.7" }, { "2016-17": "92.2" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "95.2" }, { "2014-15": "94.9" }, { "2015-16": "93.6" }], "BE": [{ "2014-15": "97" }, { "2015-16": "99.6" }, { "2016-17": "95.8" }, { "2017-18": "90.4" }], "RE": [{ "2014-15": "90.4" }, { "2015-16": "92.6" }, { "2016-17": "90.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "91" }, { "2014-15": "86.1" }, { "2015-16": "84.1" }], "BE": [{ "2014-15": "86.4" }, { "2015-16": "83.3" }, { "2016-17": "84.5" }, { "2017-18": "79.6" }], "RE": [{ "2014-15": "86" }, { "2015-16": "85.9" }, { "2016-17": "90.1" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "95.9" }, { "2014-15": "100" }, { "2015-16": "99.9" }], "BE": [{ "2014-15": "95.2" }, { "2015-16": "99.9" }, { "2016-17": "99.8" }, { "2017-18": "96.4" }], "RE": [{ "2014-15": "99.9" }, { "2015-16": "99.8" }, { "2016-17": "99.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "92.1" }, { "2014-15": "92.4" }, { "2015-16": "92.6" }], "BE": [{ "2014-15": "87.6" }, { "2015-16": "88.7" }, { "2016-17": "86.8" }, { "2017-18": "86.4" }], "RE": [{ "2014-15": "91.6" }, { "2015-16": "91.1" }, { "2016-17": "92.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "63.5" }, { "2014-15": "76.5" }, { "2015-16": "74.8" }], "BE": [{ "2014-15": "78.2" }, { "2015-16": "64.8" }, { "2016-17": "78.3" }, { "2017-18": "64.6" }], "RE": [{ "2014-15": "76.8" }, { "2015-16": "74" }, { "2016-17": "75" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "94.5" }, { "2014-15": "96.4" }, { "2015-16": "96.9" }], "BE": [{ "2014-15": "96.5" }, { "2015-16": "97.3" }, { "2016-17": "98.7" }, { "2017-18": "99.5" }], "RE": [{ "2014-15": "96.9" }, { "2015-16": "98.7" }, { "2016-17": "98.7" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "85" }, { "2014-15": "89.9" }, { "2015-16": "79" }], "BE": [{ "2014-15": "94" }, { "2015-16": "80.3" }, { "2016-17": "84.7" }, { "2017-18": "87" }], "RE": [{ "2014-15": "79.7" }, { "2015-16": "65.3" }, { "2016-17": "64.7" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "85.6" }, { "2014-15": "84.3" }, { "2015-16": "82.8" }], "BE": [{ "2014-15": "79" }, { "2015-16": "87" }, { "2016-17": "80.9" }, { "2017-18": "88.1" }], "RE": [{ "2014-15": "78.2" }, { "2015-16": "84.4" }, { "2016-17": "78.8" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "85.6" }, { "2014-15": "82.7" }, { "2015-16": "90.2" }], "BE": [{ "2014-15": "83.8" }, { "2015-16": "98.2" }, { "2016-17": "94.2" }, { "2017-18": "93.6" }], "RE": [{ "2014-15": "84.8" }, { "2015-16": "91.1" }, { "2016-17": "92.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "87.9" }, { "2014-15": "83" }, { "2015-16": "76.3" }], "BE": [{ "2014-15": "76.1" }, { "2015-16": "80" }, { "2016-17": "79.7" }, { "2017-18": "87.2" }], "RE": [{ "2014-15": "86.3" }, { "2015-16": "74.1" }, { "2016-17": "82.1" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "" }, { "2015-16": "5.5" }], "BE": [{ "2014-15": "6.1" }, { "2015-16": "8.1" }, { "2016-17": "7.9" }, { "2017-18": "6.4" }], "RE": [{ "2014-15": "6" }, { "2015-16": "4.9" }, { "2016-17": "6.8" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0.7" }, { "2015-16": "0.2" }], "BE": [{ "2014-15": "0" }, { "2015-16": "4.1" }, { "2016-17": "2.9" }, { "2017-18": "9.2" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "3.3" }, { "2016-17": "2.8" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "17.8" }, { "2014-15": "8.4" }, { "2015-16": "23.4" }], "BE": [{ "2014-15": "14.7" }, { "2015-16": "29.4" }, { "2016-17": "11.1" }, { "2017-18": "11.7" }], "RE": [{ "2014-15": "20.6" }, { "2015-16": "19.2" }, { "2016-17": "11" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "8" }, { "2014-15": "9.8" }, { "2015-16": "10.8" }], "BE": [{ "2014-15": "10" }, { "2015-16": "9.5" }, { "2016-17": "10.4" }, { "2017-18": "11.4" }], "RE": [{ "2014-15": "8.8" }, { "2015-16": "13.1" }, { "2016-17": "10.8" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "2.1" }], "BE": [{ "2014-15": "0" }, { "2015-16": "4.2" }, { "2016-17": "5" }, { "2017-18": "3.4" }], "RE": [{ "2014-15": "0.3" }, { "2015-16": "3.7" }, { "2016-17": "2.2" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "30.2" }, { "2014-15": "28.6" }, { "2015-16": "23.9" }], "BE": [{ "2014-15": "28.1" }, { "2015-16": "27.3" }, { "2016-17": "22.6" }, { "2017-18": "19.6" }], "RE": [{ "2014-15": "28" }, { "2015-16": "23.4" }, { "2016-17": "18.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2.8" }, { "2014-15": "2.9" }, { "2015-16": "1.4" }], "BE": [{ "2014-15": "3.7" }, { "2015-16": "1.3" }, { "2016-17": "14.8" }, { "2017-18": "16.5" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "1.3" }, { "2016-17": "11.1" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "6" }, { "2014-15": "3.9" }, { "2015-16": "7.7" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "3.3" }, { "2016-17": "3.2" }, { "2017-18": "4" }], "RE": [{ "2014-15": "4" }, { "2015-16": "7.6" }, { "2016-17": "16.3" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "15.3" }, { "2015-16": "27.8" }, { "2016-17": "19.9" }, { "2017-18": "22.6" }], "RE": [{ "2014-15": "26.2" }, { "2015-16": "25.1" }, { "2016-17": "25.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "14.7" }, { "2014-15": "16.7" }, { "2015-16": "15.7" }], "BE": [{ "2014-15": "15" }, { "2015-16": "14.7" }, { "2016-17": "21.2" }, { "2017-18": "14.6" }], "RE": [{ "2014-15": "13.6" }, { "2015-16": "16.1" }, { "2016-17": "23.1" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "9.7" }, { "2014-15": "13.9" }, { "2015-16": "14.8" }], "BE": [{ "2014-15": "8.8" }, { "2015-16": "10" }, { "2016-17": "10" }, { "2017-18": "11" }], "RE": [{ "2014-15": "9.9" }, { "2015-16": "10.9" }, { "2016-17": "10.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "4.6" }, { "2015-16": "4.6" }], "BE": [{ "2014-15": "5.3" }, { "2015-16": "4.7" }, { "2016-17": "6.4" }, { "2017-18": "4.7" }], "RE": [{ "2014-15": "6.3" }, { "2015-16": "5.9" }, { "2016-17": "5.9" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "4.8" }, { "2014-15": "5" }, { "2015-16": "4.2" }], "BE": [{ "2014-15": "4.3" }, { "2015-16": "4" }, { "2016-17": "5.7" }, { "2017-18": "15.4" }], "RE": [{ "2014-15": "4" }, { "2015-16": "3.9" }, { "2016-17": "5.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "0.9" }, { "2014-15": "0.4" }, { "2015-16": "1.2" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "1.2" }, { "2016-17": "1.3" }, { "2017-18": "1.4" }], "RE": [{ "2014-15": "1" }, { "2015-16": "1.3" }, { "2016-17": "1.8" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "21.4" }, { "2014-15": "15.4" }, { "2015-16": "15.2" }], "BE": [{ "2014-15": "16.5" }, { "2015-16": "16.9" }, { "2016-17": "11.7" }, { "2017-18": "5.7" }], "RE": [{ "2014-15": "16.5" }, { "2015-16": "16.9" }, { "2016-17": "11.7" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "5.1" }, { "2015-16": "3" }], "BE": [{ "2014-15": "3.6" }, { "2015-16": "2.9" }, { "2016-17": "0" }, { "2017-18": "8" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "4.3" }, { "2016-17": "7.8" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "4.8" }, { "2014-15": "5.1" }, { "2015-16": "6.4" }], "BE": [{ "2014-15": "3" }, { "2015-16": "0.4" }, { "2016-17": "4.2" }, { "2017-18": "9.6" }], "RE": [{ "2014-15": "9.6" }, { "2015-16": "7.4" }, { "2016-17": "9.9" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "9" }, { "2014-15": "13.9" }, { "2015-16": "15.9" }], "BE": [{ "2014-15": "13.6" }, { "2015-16": "16.7" }, { "2016-17": "15.5" }, { "2017-18": "20.4" }], "RE": [{ "2014-15": "14" }, { "2015-16": "14.1" }, { "2016-17": "9.9" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "4.1" }, { "2014-15": "0" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "4.8" }, { "2015-16": "0.1" }, { "2016-17": "0.2" }, { "2017-18": "3.6" }], "RE": [{ "2014-15": "0.1" }, { "2015-16": "0.2" }, { "2016-17": "0.7" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "7.9" }, { "2014-15": "7.6" }, { "2015-16": "7.4" }], "BE": [{ "2014-15": "12.4" }, { "2015-16": "11.3" }, { "2016-17": "13.2" }, { "2017-18": "13.6" }], "RE": [{ "2014-15": "8.4" }, { "2015-16": "8.9" }, { "2016-17": "7.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "36.5" }, { "2014-15": "23.5" }, { "2015-16": "25.2" }], "BE": [{ "2014-15": "21.8" }, { "2015-16": "35.2" }, { "2016-17": "21.7" }, { "2017-18": "35.4" }], "RE": [{ "2014-15": "23.2" }, { "2015-16": "26" }, { "2016-17": "25" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "5.5" }, { "2014-15": "3.6" }, { "2015-16": "3.1" }], "BE": [{ "2014-15": "3.5" }, { "2015-16": "2.7" }, { "2016-17": "1.3" }, { "2017-18": "0.5" }], "RE": [{ "2014-15": "3.1" }, { "2015-16": "1.3" }, { "2016-17": "1.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "15" }, { "2014-15": "10.1" }, { "2015-16": "21" }], "BE": [{ "2014-15": "6" }, { "2015-16": "19.7" }, { "2016-17": "15.3" }, { "2017-18": "13" }], "RE": [{ "2014-15": "20.3" }, { "2015-16": "34.7" }, { "2016-17": "35.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "14.4" }, { "2014-15": "15.7" }, { "2015-16": "17.2" }], "BE": [{ "2014-15": "21" }, { "2015-16": "13" }, { "2016-17": "19.1" }, { "2017-18": "11.9" }], "RE": [{ "2014-15": "21.8" }, { "2015-16": "15.6" }, { "2016-17": "21.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "14.4" }, { "2014-15": "17.3" }, { "2015-16": "9.8" }], "BE": [{ "2014-15": "16.2" }, { "2015-16": "1.8" }, { "2016-17": "5.8" }, { "2017-18": "6.4" }], "RE": [{ "2014-15": "15.2" }, { "2015-16": "8.9" }, { "2016-17": "7.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "12.1" }, { "2014-15": "17" }, { "2015-16": "23.7" }], "BE": [{ "2014-15": "23.9" }, { "2015-16": "20" }, { "2016-17": "20.3" }, { "2017-18": "12.8" }], "RE": [{ "2014-15": "13.7" }, { "2015-16": "25.9" }, { "2016-17": "17.9" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Health" }, { "category_slug": "education", "sub_records": [{ "record_slug": "total_sector_expenditure", "record_name": "Total Sector Expenditure", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2013-14": "18731.4" }, { "2014-15": "" }, { "2015-16": "17011.3" }], "BE": [{ "2014-15": "15827.7" }, { "2015-16": "18560.1" }, { "2016-17": "21099.1" }, { "2017-18": "23433.2" }], "RE": [{ "2014-15": "15229.8" }, { "2015-16": "17159.9" }, { "2016-17": "20152.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "8659.9" }, { "2014-15": "11343.9" }, { "2015-16": "10712.2" }], "BE": [{ "2014-15": "12924.2" }, { "2015-16": "14572.4" }, { "2016-17": "15875" }, { "2017-18": "15197.7" }], "RE": [{ "2014-15": "13634.5" }, { "2015-16": "17420.9" }, { "2016-17": "16236.9" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "14955.8" }, { "2014-15": "16459.4" }, { "2015-16": "18922.9" }], "BE": [{ "2014-15": "24922.7" }, { "2015-16": "22279.3" }, { "2016-17": "22250.3" }, { "2017-18": "25602.4" }], "RE": [{ "2014-15": "26083.6" }, { "2015-16": "24880.8" }, { "2016-17": "23432.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "6540" }, { "2014-15": "5706" }, { "2015-16": "9570.1" }], "BE": [{ "2014-15": "9264.8" }, { "2015-16": "8238.3" }, { "2016-17": "12934.1" }, { "2017-18": "13666" }], "RE": [{ "2014-15": "9363.6" }, { "2015-16": "8802.7" }, { "2016-17": "13776.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "4783.6" }, { "2014-15": "5196.9" }, { "2015-16": "6207.6" }], "BE": [{ "2014-15": "5955.2" }, { "2015-16": "7526.1" }, { "2016-17": "8641.8" }, { "2017-18": "9065.6" }], "RE": [{ "2014-15": "5533.4" }, { "2015-16": "6509.1" }, { "2016-17": "7656" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "17947.5" }, { "2014-15": "20388.5" }, { "2015-16": "21574.4" }], "BE": [{ "2014-15": "21461.4" }, { "2015-16": "20883.8" }, { "2016-17": "22069.3" }, { "2017-18": "23284.2" }], "RE": [{ "2014-15": "20695.6" }, { "2015-16": "22333.7" }, { "2016-17": "22441.9" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "7532.5" }, { "2014-15": "9479.2" }, { "2015-16": "10118.7" }], "BE": [{ "2014-15": "10380.9" }, { "2015-16": "12451.8" }, { "2016-17": "13891.5" }, { "2017-18": "15033.5" }], "RE": [{ "2014-15": "10991.8" }, { "2015-16": "11518.3" }, { "2016-17": "12638.6" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "3295.6" }, { "2014-15": "3749.5" }, { "2015-16": "3756.4" }], "BE": [{ "2014-15": "3952.8" }, { "2015-16": "4695.9" }, { "2016-17": "5345.1" }, { "2017-18": "5453.2" }], "RE": [{ "2014-15": "3749.5" }, { "2015-16": "3756.4" }, { "2016-17": "5191.4" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "3115" }, { "2014-15": "2959.3" }, { "2015-16": "6363.6" }], "BE": [{ "2014-15": "5947.4" }, { "2015-16": "5781.2" }, { "2016-17": "8700.5" }, { "2017-18": "9202.2" }], "RE": [{ "2014-15": "5340.5" }, { "2015-16": "7005.2" }, { "2016-17": "8728.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "3951" }, { "2014-15": "5747.8" }, { "2015-16": "6546.8" }], "BE": [{ "2014-15": "8554.8" }, { "2015-16": "8655.3" }, { "2016-17": "9557.4" }, { "2017-18": "10585.7" }], "RE": [{ "2014-15": "7194" }, { "2015-16": "8428.6" }, { "2016-17": "9138.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "16553.7" }, { "2014-15": "19013.7" }, { "2015-16": "20135.8" }], "BE": [{ "2014-15": "20930.1" }, { "2015-16": "21049.4" }, { "2016-17": "21491.2" }, { "2017-18": "21565.2" }], "RE": [{ "2014-15": "21030.1" }, { "2015-16": "21067" }, { "2016-17": "22275.9" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "12046.2" }, { "2014-15": "13230" }, { "2015-16": "14712.4" }], "BE": [{ "2014-15": "14213.9" }, { "2015-16": "16657.4" }, { "2016-17": "17351.4" }, { "2017-18": "20206.2" }], "RE": [{ "2014-15": "13627.6" }, { "2015-16": "14387.6" }, { "2016-17": "16925.8" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "8874.4" }, { "2014-15": "11032.5" }, { "2015-16": "11216.2" }], "BE": [{ "2014-15": "13649.4" }, { "2015-16": "15244.1" }, { "2016-17": "16388.2" }, { "2017-18": "17055.1" }], "RE": [{ "2014-15": "13111.6" }, { "2015-16": "12854.4" }, { "2016-17": "13814.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "39881.9" }, { "2014-15": "41468.2" }, { "2015-16": "44834.3" }], "BE": [{ "2014-15": "43312.5" }, { "2015-16": "47531" }, { "2016-17": "49474.8" }, { "2017-18": "56371.4" }], "RE": [{ "2014-15": "43521.4" }, { "2015-16": "47782.9" }, { "2016-17": "48962.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "1109.7" }, { "2014-15": "1298.4" }, { "2015-16": "1284.1" }], "BE": [{ "2014-15": "3292.3" }, { "2015-16": "1453.6" }, { "2016-17": "1586.9" }, { "2017-18": "2035.2" }], "RE": [{ "2014-15": "3292.3" }, { "2015-16": "1453.6" }, { "2016-17": "1586.9" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "965.2" }, { "2014-15": "1163.7" }, { "2015-16": "1085.5" }], "BE": [{ "2014-15": "1068.1" }, { "2015-16": "1169.2" }, { "2016-17": "1171.1" }, { "2017-18": "1206.2" }], "RE": [{ "2014-15": "1233.2" }, { "2015-16": "1309.9" }, { "2016-17": "1282.5" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "1108.3" }, { "2014-15": "1124.8" }, { "2015-16": "1298" }], "BE": [{ "2014-15": "1527.7" }, { "2015-16": "1676.1" }, { "2016-17": "1724.7" }, { "2017-18": "1763.5" }], "RE": [{ "2014-15": "1439.9" }, { "2015-16": "1665.9" }, { "2016-17": "1691" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "8500.4" }, { "2014-15": "10261" }, { "2015-16": "11667.9" }], "BE": [{ "2014-15": "12039" }, { "2015-16": "12680.1" }, { "2016-17": "14026" }, { "2017-18": "16752.9" }], "RE": [{ "2014-15": "11506.6" }, { "2015-16": "12104.4" }, { "2016-17": "13511.3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "7144.9" }, { "2014-15": "8002.4" }, { "2015-16": "9167.7" }], "BE": [{ "2014-15": "8559.1" }, { "2015-16": "9684.7" }, { "2016-17": "10384.4" }, { "2017-18": "11091.5" }], "RE": [{ "2014-15": "8686.8" }, { "2015-16": "9587.5" }, { "2016-17": "10387.9" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "15138.3" }, { "2014-15": "19419.3" }, { "2015-16": "21252" }], "BE": [{ "2014-15": "22873.4" }, { "2015-16": "23824.6" }, { "2016-17": "25461.8" }, { "2017-18": "27688.9" }], "RE": [{ "2014-15": "20573" }, { "2015-16": "22391.3" }, { "2016-17": "25702.3" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "352" }, { "2014-15": "355.7" }, { "2015-16": "487.7" }], "BE": [{ "2014-15": "486.2" }, { "2015-16": "554" }, { "2016-17": "616.2" }, { "2017-18": "667.8" }], "RE": [{ "2014-15": "502.1" }, { "2015-16": "523" }, { "2016-17": "685.9" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "19754.8" }, { "2014-15": "23425.3" }, { "2015-16": "24651.2" }], "BE": [{ "2014-15": "21359.6" }, { "2015-16": "24633.3" }, { "2016-17": "27808.9" }, { "2017-18": "30612.7" }], "RE": [{ "2014-15": "23332.8" }, { "2015-16": "26039.4" }, { "2016-17": "27714" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "1688.8" }, { "2014-15": "2136.7" }, { "2015-16": "2272.4" }], "BE": [{ "2014-15": "2431.6" }, { "2015-16": "2921.8" }, { "2016-17": "2208.6" }, { "2017-18": "2783.4" }], "RE": [{ "2014-15": "2429.5" }, { "2015-16": "2564.9" }, { "2016-17": "2369.3" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "29681.2" }, { "2014-15": "32485" }, { "2015-16": "41034.2" }], "BE": [{ "2014-15": "38539.5" }, { "2015-16": "44601.4" }, { "2016-17": "50907.1" }, { "2017-18": "63360.7" }], "RE": [{ "2014-15": "34910.1" }, { "2015-16": "41883.2" }, { "2016-17": "47572.5" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "4270.5" }, { "2014-15": "5104.5" }, { "2015-16": "5012.4" }], "BE": [{ "2014-15": "5308.8" }, { "2015-16": "5675.5" }, { "2016-17": "6919.8" }, { "2017-18": "6633.5" }], "RE": [{ "2014-15": "5503.1" }, { "2015-16": "5840.5" }, { "2016-17": "5597.2" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "18457.8" }, { "2014-15": "20318.8" }, { "2015-16": "21198.5" }], "BE": [{ "2014-15": "23269.8" }, { "2015-16": "24930.2" }, { "2016-17": "27733.8" }, { "2017-18": "27629.2" }], "RE": [{ "2014-15": "20006.4" }, { "2015-16": "21424.7" }, { "2016-17": "26380" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_sector_expenditure_as_of_state_budget", "record_name": "Total Sector Expenditure as % of State Budget", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "13.7" }, { "2014-15": "" }, { "2015-16": "11.4" }], "BE": [{ "2014-15": "14.2" }, { "2015-16": "16.4" }, { "2016-17": "15.5" }, { "2017-18": "14.9" }], "RE": [{ "2014-15": "13.6" }, { "2015-16": "15.3" }, { "2016-17": "15.2" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "23.3" }, { "2014-15": "24.2" }, { "2015-16": "25.5" }], "BE": [{ "2014-15": "19.9" }, { "2015-16": "22" }, { "2016-17": "20.3" }, { "2017-18": "17.7" }], "RE": [{ "2014-15": "21.4" }, { "2015-16": "23.3" }, { "2016-17": "19.6" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "18.6" }, { "2014-15": "17.4" }, { "2015-16": "16.8" }], "BE": [{ "2014-15": "21.3" }, { "2015-16": "18.5" }, { "2016-17": "15.4" }, { "2017-18": "16" }], "RE": [{ "2014-15": "19.7" }, { "2015-16": "18.7" }, { "2016-17": "15.2" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "16.9" }, { "2014-15": "12.3" }, { "2015-16": "18.5" }], "BE": [{ "2014-15": "16.9" }, { "2015-16": "12.7" }, { "2016-17": "18.5" }, { "2017-18": "18" }], "RE": [{ "2014-15": "17" }, { "2015-16": "13.4" }, { "2016-17": "19.5" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "14" }, { "2014-15": "16.8" }, { "2015-16": "17.6" }], "BE": [{ "2014-15": "16.2" }, { "2015-16": "18.3" }, { "2016-17": "18.5" }, { "2017-18": "18.9" }], "RE": [{ "2014-15": "15.9" }, { "2015-16": "17.1" }, { "2016-17": "18.6" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "17.1" }, { "2014-15": "17.5" }, { "2015-16": "14.4" }], "BE": [{ "2014-15": "16.3" }, { "2015-16": "15.2" }, { "2016-17": "17.4" }, { "2017-18": "13.6" }], "RE": [{ "2014-15": "16.5" }, { "2015-16": "16.8" }, { "2016-17": "15.3" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "16.2" }, { "2014-15": "17.7" }, { "2015-16": "16.3" }], "BE": [{ "2014-15": "17.5" }, { "2015-16": "18" }, { "2016-17": "17.8" }, { "2017-18": "17.5" }], "RE": [{ "2014-15": "17.9" }, { "2015-16": "17" }, { "2016-17": "17" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "15.4" }, { "2014-15": "12.1" }, { "2015-16": "12.7" }], "BE": [{ "2014-15": "16.7" }, { "2015-16": "16.6" }, { "2016-17": "16.4" }, { "2017-18": "15.2" }], "RE": [{ "2014-15": "12.7" }, { "2015-16": "13.9" }, { "2016-17": "14.9" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "9.5" }, { "2014-15": "8.3" }, { "2015-16": "9.8" }], "BE": [{ "2014-15": "13.7" }, { "2015-16": "12.4" }, { "2016-17": "19" }, { "2017-18": "11.6" }], "RE": [{ "2014-15": "12.4" }, { "2015-16": "13.6" }, { "2016-17": "14.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "13" }, { "2014-15": "14.4" }, { "2015-16": "12" }], "BE": [{ "2014-15": "17" }, { "2015-16": "15.6" }, { "2016-17": "15.1" }, { "2017-18": "14" }], "RE": [{ "2014-15": "14.2" }, { "2015-16": "15" }, { "2016-17": "13.7" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "15.5" }, { "2014-15": "15.4" }, { "2015-16": "14.5" }], "BE": [{ "2014-15": "15.9" }, { "2015-16": "15.4" }, { "2016-17": "13.7" }, { "2017-18": "12.1" }], "RE": [{ "2014-15": "16.4" }, { "2015-16": "15.2" }, { "2016-17": "14.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "18.2" }, { "2014-15": "17.2" }, { "2015-16": "16.9" }], "BE": [{ "2014-15": "17.9" }, { "2015-16": "17.5" }, { "2016-17": "16.1" }, { "2017-18": "16.9" }], "RE": [{ "2014-15": "17.1" }, { "2015-16": "16.2" }, { "2016-17": "16.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "10.3" }, { "2014-15": "10.3" }, { "2015-16": "9.4" }], "BE": [{ "2014-15": "11.7" }, { "2015-16": "11.6" }, { "2016-17": "10.3" }, { "2017-18": "10" }], "RE": [{ "2014-15": "11.1" }, { "2015-16": "9.7" }, { "2016-17": "8.8" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "21.2" }, { "2014-15": "19" }, { "2015-16": "19.9" }], "BE": [{ "2014-15": "19.3" }, { "2015-16": "19.6" }, { "2016-17": "18.3" }, { "2017-18": "18.8" }], "RE": [{ "2014-15": "18.8" }, { "2015-16": "19.3" }, { "2016-17": "17.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "15.9" }, { "2014-15": "17" }, { "2015-16": "16.1" }], "BE": [{ "2014-15": "27.6" }, { "2015-16": "14.9" }, { "2016-17": "14.9" }, { "2017-18": "15.6" }], "RE": [{ "2014-15": "27.6" }, { "2015-16": "14.9" }, { "2016-17": "14.9" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "17.5" }, { "2014-15": "15" }, { "2015-16": "17.3" }], "BE": [{ "2014-15": "15.8" }, { "2015-16": "15.1" }, { "2016-17": "14.8" }, { "2017-18": "14.1" }], "RE": [{ "2014-15": "15.9" }, { "2015-16": "15.8" }, { "2016-17": "13.4" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "13.2" }, { "2014-15": "11.1" }, { "2015-16": "11.4" }], "BE": [{ "2014-15": "12.3" }, { "2015-16": "13.3" }, { "2016-17": "12.6" }, { "2017-18": "10.8" }], "RE": [{ "2014-15": "12.8" }, { "2015-16": "13.1" }, { "2016-17": "10.7" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "15.1" }, { "2014-15": "15.4" }, { "2015-16": "14.7" }], "BE": [{ "2014-15": "15" }, { "2015-16": "15" }, { "2016-17": "14.9" }, { "2017-18": "15.7" }], "RE": [{ "2014-15": "14.8" }, { "2015-16": "14.3" }, { "2016-17": "14.4" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "11.8" }, { "2014-15": "11" }, { "2015-16": "11.3" }], "BE": [{ "2014-15": "11.6" }, { "2015-16": "12.2" }, { "2016-17": "12" }, { "2017-18": "9.4" }], "RE": [{ "2014-15": "11.6" }, { "2015-16": "12.2" }, { "2016-17": "7.2" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "16.1" }, { "2014-15": "16.7" }, { "2015-16": "16.4" }], "BE": [{ "2014-15": "17.4" }, { "2015-16": "17.3" }, { "2016-17": "16.8" }, { "2017-18": "16.6" }], "RE": [{ "2014-15": "16.3" }, { "2015-16": "16.3" }, { "2016-17": "17.3" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "7.9" }, { "2014-15": "7.4" }, { "2015-16": "10.8" }], "BE": [{ "2014-15": "7.4" }, { "2015-16": "10" }, { "2016-17": "10.7" }, { "2017-18": "10.7" }], "RE": [{ "2014-15": "7.5" }, { "2015-16": "9.3" }, { "2016-17": "11.4" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "15.4" }, { "2014-15": "14.9" }, { "2015-16": "14.6" }], "BE": [{ "2014-15": "14" }, { "2015-16": "14.1" }, { "2016-17": "14.1" }, { "2017-18": "14.1" }], "RE": [{ "2014-15": "14.5" }, { "2015-16": "14.6" }, { "2016-17": "12.7" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "21.6" }, { "2014-15": "20.2" }, { "2015-16": "19.7" }], "BE": [{ "2014-15": "19.6" }, { "2015-16": "19.5" }, { "2016-17": "14.5" }, { "2017-18": "17.4" }], "RE": [{ "2014-15": "19.6" }, { "2015-16": "19.7" }, { "2016-17": "15.9" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "14.8" }, { "2014-15": "13.8" }, { "2015-16": "13.5" }], "BE": [{ "2014-15": "14" }, { "2015-16": "14.7" }, { "2016-17": "14.7" }, { "2017-18": "16.5" }], "RE": [{ "2014-15": "13.3" }, { "2015-16": "12.7" }, { "2016-17": "14" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "19.3" }, { "2014-15": "18.8" }, { "2015-16": "16.9" }], "BE": [{ "2014-15": "17.5" }, { "2015-16": "17.4" }, { "2016-17": "17.1" }, { "2017-18": "16.6" }], "RE": [{ "2014-15": "17" }, { "2015-16": "17.4" }, { "2016-17": "17.5" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "17" }, { "2014-15": "16.5" }, { "2015-16": "15" }], "BE": [{ "2014-15": "17.9" }, { "2015-16": "18" }, { "2016-17": "17.3" }, { "2017-18": "15.2" }], "RE": [{ "2014-15": "15.4" }, { "2015-16": "14.8" }, { "2016-17": "15.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "per_capita_expenditure_on_sector", "record_name": "Per Capita Expenditure on Sector ", "unit": "INR Rs.", "record_figures": [{ "figures": { "A": [{ "2013-14": "3757" }, { "2014-15": "" }, { "2015-16": "3372.2" }], "BE": [{ "2014-15": "3156" }, { "2015-16": "3679.2" }, { "2016-17": "4158" }, { "2017-18": "4591.7" }], "RE": [{ "2014-15": "3036.8" }, { "2015-16": "3401.6" }, { "2016-17": "3971.5" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "2765.1" }, { "2014-15": "3579.3" }, { "2015-16": "3340.4" }], "BE": [{ "2014-15": "4077.9" }, { "2015-16": "4544.1" }, { "2016-17": "4892.3" }, { "2017-18": "4630.1" }], "RE": [{ "2014-15": "4302.1" }, { "2015-16": "5432.3" }, { "2016-17": "5003.8" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "1491.3" }, { "2014-15": "1621.2" }, { "2015-16": "1842" }], "BE": [{ "2014-15": "2454.8" }, { "2015-16": "2168.7" }, { "2016-17": "2141.3" }, { "2017-18": "2435.3" }], "RE": [{ "2014-15": "2569.2" }, { "2015-16": "2421.9" }, { "2016-17": "2255.1" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2625.6" }, { "2014-15": "2261.4" }, { "2015-16": "3744.9" }], "BE": [{ "2014-15": "3671.8" }, { "2015-16": "3223.7" }, { "2016-17": "4997.9" }, { "2017-18": "5215.6" }], "RE": [{ "2014-15": "3711" }, { "2015-16": "3444.6" }, { "2016-17": "5323.4" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "2449.5" }, { "2014-15": "2586.6" }, { "2015-16": "3002.3" }], "BE": [{ "2014-15": "2964" }, { "2015-16": "3640" }, { "2016-17": "4060" }, { "2017-18": "4147.4" }], "RE": [{ "2014-15": "2754" }, { "2015-16": "3148.1" }, { "2016-17": "3596.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "6833" }, { "2014-15": "7643.3" }, { "2015-16": "7967.2" }], "BE": [{ "2014-15": "8045.5" }, { "2015-16": "7712.2" }, { "2016-17": "8031.9" }, { "2017-18": "8350.5" }], "RE": [{ "2014-15": "7758.4" }, { "2015-16": "8247.6" }, { "2016-17": "8167.5" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "1243.6" }, { "2014-15": "1545.6" }, { "2015-16": "1629.9" }], "BE": [{ "2014-15": "1692.7" }, { "2015-16": "2005.7" }, { "2016-17": "2211.1" }, { "2017-18": "2364.5" }], "RE": [{ "2014-15": "1792.3" }, { "2015-16": "1855.4" }, { "2016-17": "2011.7" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "4763.8" }, { "2014-15": "5373.3" }, { "2015-16": "5338.1" }], "BE": [{ "2014-15": "5664.6" }, { "2015-16": "6673.2" }, { "2016-17": "7533.6" }, { "2017-18": "7622" }], "RE": [{ "2014-15": "5373.3" }, { "2015-16": "5338.1" }, { "2016-17": "7317" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "2593.7" }, { "2014-15": "2435.2" }, { "2015-16": "5178.3" }], "BE": [{ "2014-15": "4894.1" }, { "2015-16": "4704.4" }, { "2016-17": "7005.8" }, { "2017-18": "7327.5" }], "RE": [{ "2014-15": "4394.8" }, { "2015-16": "5700.3" }, { "2016-17": "7028.6" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "1221.9" }, { "2014-15": "1754.2" }, { "2015-16": "1971.8" }], "BE": [{ "2014-15": "2610.9" }, { "2015-16": "2606.8" }, { "2016-17": "2840.1" }, { "2017-18": "3105.5" }], "RE": [{ "2014-15": "2195.6" }, { "2015-16": "2538.5" }, { "2016-17": "2715.6" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "2730.5" }, { "2014-15": "3106.1" }, { "2015-16": "3258.4" }], "BE": [{ "2014-15": "3419.2" }, { "2015-16": "3406.2" }, { "2016-17": "3445.5" }, { "2017-18": "3425.2" }], "RE": [{ "2014-15": "3435.5" }, { "2015-16": "3409.1" }, { "2016-17": "3571.3" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "3438.4" }, { "2014-15": "3752.3" }, { "2015-16": "4147.5" }], "BE": [{ "2014-15": "4031.4" }, { "2015-16": "4695.8" }, { "2016-17": "4863.5" }, { "2017-18": "5629" }], "RE": [{ "2014-15": "3865.1" }, { "2015-16": "4055.9" }, { "2016-17": "4744.2" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1191.5" }, { "2014-15": "1459.1" }, { "2015-16": "1461.5" }], "BE": [{ "2014-15": "1805.1" }, { "2015-16": "1986.3" }, { "2016-17": "2104.4" }, { "2017-18": "2158.7" }], "RE": [{ "2014-15": "1734" }, { "2015-16": "1674.9" }, { "2016-17": "1773.9" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "3447.1" }, { "2014-15": "3538.6" }, { "2015-16": "3778.6" }], "BE": [{ "2014-15": "3696" }, { "2015-16": "4005.9" }, { "2016-17": "4120.3" }, { "2017-18": "4637.6" }], "RE": [{ "2014-15": "3713.8" }, { "2015-16": "4027.1" }, { "2016-17": "4077.6" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "4137.8" }, { "2014-15": "4787.7" }, { "2015-16": "4681.2" }], "BE": [{ "2014-15": "12139.6" }, { "2015-16": "5299.4" }, { "2016-17": "5722.8" }, { "2017-18": "7259.6" }], "RE": [{ "2014-15": "12139.6" }, { "2015-16": "5299.4" }, { "2016-17": "5722.8" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "9389.4" }, { "2014-15": "11200.3" }, { "2015-16": "10328.3" }], "BE": [{ "2014-15": "10280.1" }, { "2015-16": "11125" }, { "2016-17": "11017.1" }, { "2017-18": "11225.5" }], "RE": [{ "2014-15": "11868.8" }, { "2015-16": "12463.3" }, { "2016-17": "12064.7" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "4816.5" }, { "2014-15": "4833.8" }, { "2015-16": "5513.9" }], "BE": [{ "2014-15": "6565.1" }, { "2015-16": "7120.4" }, { "2016-17": "7246.8" }, { "2017-18": "7326.7" }], "RE": [{ "2014-15": "6116.8" }, { "2015-16": "7077.1" }, { "2016-17": "7105.1" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2050.6" }, { "2014-15": "2455" }, { "2015-16": "2769" }], "BE": [{ "2014-15": "2880.4" }, { "2015-16": "3009.2" }, { "2016-17": "3301.9" }, { "2017-18": "3912.3" }], "RE": [{ "2014-15": "2753" }, { "2015-16": "2872.6" }, { "2016-17": "3180.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "2526.6" }, { "2014-15": "2801.2" }, { "2015-16": "3178.2" }], "BE": [{ "2014-15": "2996" }, { "2015-16": "3357.4" }, { "2016-17": "3567" }, { "2017-18": "3773.2" }], "RE": [{ "2014-15": "3040.7" }, { "2015-16": "3323.7" }, { "2016-17": "3568.3" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "2164.5" }, { "2014-15": "2736.3" }, { "2015-16": "2952.8" }], "BE": [{ "2014-15": "3223" }, { "2015-16": "3310.2" }, { "2016-17": "3490.4" }, { "2017-18": "3743.5" }], "RE": [{ "2014-15": "2898.9" }, { "2015-16": "3111.1" }, { "2016-17": "3523.4" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "5622.3" }, { "2014-15": "5619.9" }, { "2015-16": "7619.6" }], "BE": [{ "2014-15": "7681.3" }, { "2015-16": "8656.6" }, { "2016-17": "9524.6" }, { "2017-18": "10210.8" }], "RE": [{ "2014-15": "7931.9" }, { "2015-16": "8172" }, { "2016-17": "10601" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "2893.8" }, { "2014-15": "3412.1" }, { "2015-16": "3571.1" }], "BE": [{ "2014-15": "3111.2" }, { "2015-16": "3568.5" }, { "2016-17": "4007.3" }, { "2017-18": "4387.1" }], "RE": [{ "2014-15": "3398.6" }, { "2015-16": "3772.2" }, { "2016-17": "3993.6" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "4564.4" }, { "2014-15": "5710" }, { "2015-16": "6005.3" }], "BE": [{ "2014-15": "6498.2" }, { "2015-16": "7721.5" }, { "2016-17": "5772.5" }, { "2017-18": "7196" }], "RE": [{ "2014-15": "6492.5" }, { "2015-16": "6778.2" }, { "2016-17": "6192.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "1428.8" }, { "2014-15": "1538" }, { "2015-16": "1911.5" }], "BE": [{ "2014-15": "1824.6" }, { "2015-16": "2077.7" }, { "2016-17": "2334.2" }, { "2017-18": "2859.8" }], "RE": [{ "2014-15": "1652.8" }, { "2015-16": "1951" }, { "2016-17": "2181.3" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "4176.9" }, { "2014-15": "4888.9" }, { "2015-16": "4553.9" }], "BE": [{ "2014-15": "5123.4" }, { "2015-16": "5363.4" }, { "2016-17": "6207" }, { "2017-18": "5802.9" }], "RE": [{ "2014-15": "5310.9" }, { "2015-16": "5446.2" }, { "2016-17": "4957.8" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "2025.6" }, { "2014-15": "2210.5" }, { "2015-16": "2286.2" }], "BE": [{ "2014-15": "2531.5" }, { "2015-16": "2688.6" }, { "2016-17": "2964.6" }, { "2017-18": "2928.3" }], "RE": [{ "2014-15": "2176.5" }, { "2015-16": "2310.6" }, { "2016-17": "2819.9" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_expenditure_as_of_total_sector_expenditure", "record_name": "Revenue Expenditure as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "98.7" }, { "2014-15": "" }, { "2015-16": "97.8" }], "BE": [{ "2014-15": "98.4" }, { "2015-16": "98.8" }, { "2016-17": "97.2" }, { "2017-18": "96.9" }], "RE": [{ "2014-15": "98.3" }, { "2015-16": "99" }, { "2016-17": "98.4" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }, { "2017-18": "98.3" }], "RE": [{ "2014-15": "100" }, { "2015-16": "100" }, { "2016-17": "100" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "95.5" }, { "2014-15": "98.4" }, { "2015-16": "97.1" }], "BE": [{ "2014-15": "95.6" }, { "2015-16": "94.2" }, { "2016-17": "97.5" }, { "2017-18": "95.9" }], "RE": [{ "2014-15": "95.5" }, { "2015-16": "96" }, { "2016-17": "96.6" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "130.9" }, { "2014-15": "140.4" }, { "2015-16": "95.4" }], "BE": [{ "2014-15": "129.4" }, { "2015-16": "129.5" }, { "2016-17": "95.5" }, { "2017-18": "94.6" }], "RE": [{ "2014-15": "128.5" }, { "2015-16": "136.7" }, { "2016-17": "95.1" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "98.9" }, { "2014-15": "99.3" }, { "2015-16": "91.4" }], "BE": [{ "2014-15": "96.4" }, { "2015-16": "90.4" }, { "2016-17": "91.7" }, { "2017-18": "95.9" }], "RE": [{ "2014-15": "98.7" }, { "2015-16": "91.5" }, { "2016-17": "94.1" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "95.8" }, { "2014-15": "95.5" }, { "2015-16": "96.8" }], "BE": [{ "2014-15": "88.4" }, { "2015-16": "94.2" }, { "2016-17": "95.4" }, { "2017-18": "96.4" }], "RE": [{ "2014-15": "94.5" }, { "2015-16": "95.7" }, { "2016-17": "96" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "97.9" }, { "2014-15": "98" }, { "2015-16": "98" }], "BE": [{ "2014-15": "97.9" }, { "2015-16": "98" }, { "2016-17": "98.2" }, { "2017-18": "95.4" }], "RE": [{ "2014-15": "98" }, { "2015-16": "98.2" }, { "2016-17": "98.4" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "97.1" }, { "2014-15": "98.7" }, { "2015-16": "96.7" }], "BE": [{ "2014-15": "98.9" }, { "2015-16": "98.9" }, { "2016-17": "98.5" }, { "2017-18": "98.9" }], "RE": [{ "2014-15": "98.7" }, { "2015-16": "96.7" }, { "2016-17": "97.8" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "99.8" }, { "2015-16": "100" }], "BE": [{ "2014-15": "89" }, { "2015-16": "91.4" }, { "2016-17": "83.9" }, { "2017-18": "81.7" }], "RE": [{ "2014-15": "90.5" }, { "2015-16": "92.5" }, { "2016-17": "83.2" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "96.4" }, { "2014-15": "99" }, { "2015-16": "98.4" }], "BE": [{ "2014-15": "98" }, { "2015-16": "98.1" }, { "2016-17": "98" }, { "2017-18": "95.7" }], "RE": [{ "2014-15": "97.6" }, { "2015-16": "98" }, { "2016-17": "97.8" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "97.7" }, { "2014-15": "97.3" }, { "2015-16": "95.3" }], "BE": [{ "2014-15": "96.7" }, { "2015-16": "95.3" }, { "2016-17": "94.4" }, { "2017-18": "92.5" }], "RE": [{ "2014-15": "96.5" }, { "2015-16": "95.6" }, { "2016-17": "94.2" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "98.3" }, { "2014-15": "97.7" }, { "2015-16": "97" }], "BE": [{ "2014-15": "97.7" }, { "2015-16": "97.9" }, { "2016-17": "97.9" }, { "2017-18": "98.5" }], "RE": [{ "2014-15": "97.4" }, { "2015-16": "96.8" }, { "2016-17": "97.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "98.5" }, { "2014-15": "97.1" }, { "2015-16": "93" }], "BE": [{ "2014-15": "97.4" }, { "2015-16": "94.9" }, { "2016-17": "92.3" }, { "2017-18": "88.4" }], "RE": [{ "2014-15": "96.7" }, { "2015-16": "91.3" }, { "2016-17": "93.4" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "99.9" }, { "2014-15": "99.9" }, { "2015-16": "99.9" }], "BE": [{ "2014-15": "99.6" }, { "2015-16": "99.6" }, { "2016-17": "99.8" }, { "2017-18": "99.7" }], "RE": [{ "2014-15": "99.6" }, { "2015-16": "99.6" }, { "2016-17": "99.7" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "100" }, { "2014-15": "100" }, { "2015-16": "100" }], "BE": [{ "2014-15": "99.1" }, { "2015-16": "97.9" }, { "2016-17": "100" }, { "2017-18": "99.8" }], "RE": [{ "2014-15": "99.1" }, { "2015-16": "97.9" }, { "2016-17": "100" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "97" }, { "2014-15": "98.1" }, { "2015-16": "97.3" }], "BE": [{ "2014-15": "98.6" }, { "2015-16": "98.8" }, { "2016-17": "100" }, { "2017-18": "97.4" }], "RE": [{ "2014-15": "98" }, { "2015-16": "98.2" }, { "2016-17": "98.1" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "94.3" }, { "2014-15": "95.8" }, { "2015-16": "95.9" }], "BE": [{ "2014-15": "96.2" }, { "2015-16": "99.2" }, { "2016-17": "99.1" }, { "2017-18": "98.8" }], "RE": [{ "2014-15": "95.5" }, { "2015-16": "97.7" }, { "2016-17": "97.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "97.7" }, { "2014-15": "95.8" }, { "2015-16": "95.1" }], "BE": [{ "2014-15": "96" }, { "2015-16": "94.9" }, { "2016-17": "96.4" }, { "2017-18": "93.9" }], "RE": [{ "2014-15": "95.1" }, { "2015-16": "94.5" }, { "2016-17": "96.3" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "94.9" }, { "2014-15": "98.1" }, { "2015-16": "97.2" }], "BE": [{ "2014-15": "93.1" }, { "2015-16": "95.9" }, { "2016-17": "96.3" }, { "2017-18": "95.9" }], "RE": [{ "2014-15": "96.4" }, { "2015-16": "96.5" }, { "2016-17": "96.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "99.7" }, { "2014-15": "99.7" }, { "2015-16": "99.3" }], "BE": [{ "2014-15": "99.4" }, { "2015-16": "99.5" }, { "2016-17": "99.1" }, { "2017-18": "96.8" }], "RE": [{ "2014-15": "99.6" }, { "2015-16": "99.2" }, { "2016-17": "99.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "68.4" }, { "2014-15": "80.6" }, { "2015-16": "97.2" }], "BE": [{ "2014-15": "79.4" }, { "2015-16": "70.8" }, { "2016-17": "95.1" }, { "2017-18": "93.4" }], "RE": [{ "2014-15": "78.7" }, { "2015-16": "76.9" }, { "2016-17": "91.3" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "98.6" }, { "2014-15": "98" }, { "2015-16": "95.5" }], "BE": [{ "2014-15": "97.5" }, { "2015-16": "97.6" }, { "2016-17": "96.4" }, { "2017-18": "98.3" }], "RE": [{ "2014-15": "97.9" }, { "2015-16": "95.7" }, { "2016-17": "96.3" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "93.2" }, { "2014-15": "94.9" }, { "2015-16": "94.7" }], "BE": [{ "2014-15": "95" }, { "2015-16": "95.4" }, { "2016-17": "91.5" }, { "2017-18": "94.5" }], "RE": [{ "2014-15": "93" }, { "2015-16": "95" }, { "2016-17": "92.6" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "98.1" }, { "2014-15": "96.8" }, { "2015-16": "98.1" }], "BE": [{ "2014-15": "96.1" }, { "2015-16": "95" }, { "2016-17": "94.6" }, { "2017-18": "97.9" }], "RE": [{ "2014-15": "96.1" }, { "2015-16": "94.5" }, { "2016-17": "93.8" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "93.2" }, { "2014-15": "91.9" }, { "2015-16": "95.2" }], "BE": [{ "2014-15": "93.2" }, { "2015-16": "92.3" }, { "2016-17": "92.8" }, { "2017-18": "96.3" }], "RE": [{ "2014-15": "89.4" }, { "2015-16": "90.6" }, { "2016-17": "92.9" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "96.6" }, { "2014-15": "97.6" }, { "2015-16": "97.3" }], "BE": [{ "2014-15": "90.1" }, { "2015-16": "97.1" }, { "2016-17": "95.3" }, { "2017-18": "97.2" }], "RE": [{ "2014-15": "97.3" }, { "2015-16": "96.8" }, { "2016-17": "97.1" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure", "record_name": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure", "unit": "Percentage", "record_figures": [{ "figures": { "A": [{ "2013-14": "1.3" }, { "2014-15": "" }, { "2015-16": "2.2" }], "BE": [{ "2014-15": "2" }, { "2015-16": "1.2" }, { "2016-17": "2.8" }, { "2017-18": "3.1" }], "RE": [{ "2014-15": "2" }, { "2015-16": "1" }, { "2016-17": "1.6" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }, { "2017-18": "1.7" }], "RE": [{ "2014-15": "0" }, { "2015-16": "0" }, { "2016-17": "0" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2013-14": "4.5" }, { "2014-15": "1.6" }, { "2015-16": "2.9" }], "BE": [{ "2014-15": "4.2" }, { "2015-16": "5.8" }, { "2016-17": "2.5" }, { "2017-18": "4.1" }], "RE": [{ "2014-15": "4.2" }, { "2015-16": "4" }, { "2016-17": "3.4" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2013-14": "2.7" }, { "2014-15": "4.6" }, { "2015-16": "4.6" }], "BE": [{ "2014-15": "4.5" }, { "2015-16": "7.4" }, { "2016-17": "4.5" }, { "2017-18": "5.4" }], "RE": [{ "2014-15": "4.5" }, { "2015-16": "7.5" }, { "2016-17": "4.9" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2013-14": "1.1" }, { "2014-15": "0.7" }, { "2015-16": "8.6" }], "BE": [{ "2014-15": "3.6" }, { "2015-16": "9.6" }, { "2016-17": "8.3" }, { "2017-18": "4.1" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "8.5" }, { "2016-17": "5.9" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2013-14": "4.2" }, { "2014-15": "4.5" }, { "2015-16": "3.2" }], "BE": [{ "2014-15": "11.6" }, { "2015-16": "5.8" }, { "2016-17": "4.6" }, { "2017-18": "3.6" }], "RE": [{ "2014-15": "5.5" }, { "2015-16": "4.3" }, { "2016-17": "4" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2013-14": "2.1" }, { "2014-15": "2" }, { "2015-16": "2" }], "BE": [{ "2014-15": "2.1" }, { "2015-16": "2" }, { "2016-17": "1.8" }, { "2017-18": "4.6" }], "RE": [{ "2014-15": "2" }, { "2015-16": "1.8" }, { "2016-17": "1.6" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2013-14": "2.9" }, { "2014-15": "1.3" }, { "2015-16": "3.3" }], "BE": [{ "2014-15": "1.1" }, { "2015-16": "1.1" }, { "2016-17": "1.5" }, { "2017-18": "1.1" }], "RE": [{ "2014-15": "1.3" }, { "2015-16": "3.3" }, { "2016-17": "2.2" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0.2" }, { "2015-16": "0" }], "BE": [{ "2014-15": "11" }, { "2015-16": "8.6" }, { "2016-17": "16.1" }, { "2017-18": "18.3" }], "RE": [{ "2014-15": "9.5" }, { "2015-16": "7.5" }, { "2016-17": "16.8" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2013-14": "3.6" }, { "2014-15": "1" }, { "2015-16": "1.6" }], "BE": [{ "2014-15": "2" }, { "2015-16": "1.9" }, { "2016-17": "2" }, { "2017-18": "4.3" }], "RE": [{ "2014-15": "2.4" }, { "2015-16": "2" }, { "2016-17": "2.2" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "2.7" }, { "2015-16": "4.7" }], "BE": [{ "2014-15": "3.3" }, { "2015-16": "4.7" }, { "2016-17": "5.6" }, { "2017-18": "7.5" }], "RE": [{ "2014-15": "3.5" }, { "2015-16": "4.4" }, { "2016-17": "5.8" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2013-14": "1.7" }, { "2014-15": "2.3" }, { "2015-16": "3" }], "BE": [{ "2014-15": "2.3" }, { "2015-16": "2.1" }, { "2016-17": "2.1" }, { "2017-18": "1.5" }], "RE": [{ "2014-15": "2.6" }, { "2015-16": "3.2" }, { "2016-17": "2.5" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2013-14": "1.5" }, { "2014-15": "2.9" }, { "2015-16": "7" }], "BE": [{ "2014-15": "2.6" }, { "2015-16": "5.1" }, { "2016-17": "7.7" }, { "2017-18": "11.6" }], "RE": [{ "2014-15": "3.3" }, { "2015-16": "8.7" }, { "2016-17": "6.6" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2013-14": "0.1" }, { "2014-15": "0.1" }, { "2015-16": "0.1" }], "BE": [{ "2014-15": "0.4" }, { "2015-16": "0.4" }, { "2016-17": "0.2" }, { "2017-18": "0.3" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.4" }, { "2016-17": "0.3" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2013-14": "0" }, { "2014-15": "0" }, { "2015-16": "0" }], "BE": [{ "2014-15": "0.9" }, { "2015-16": "2.1" }, { "2016-17": "0" }, { "2017-18": "0.2" }], "RE": [{ "2014-15": "0.9" }, { "2015-16": "2.1" }, { "2016-17": "0" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2013-14": "3" }, { "2014-15": "1.9" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "1.4" }, { "2015-16": "1.2" }, { "2016-17": "0" }, { "2017-18": "2.6" }], "RE": [{ "2014-15": "2" }, { "2015-16": "1.8" }, { "2016-17": "1.9" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2013-14": "5.7" }, { "2014-15": "4.2" }, { "2015-16": "4.1" }], "BE": [{ "2014-15": "3.8" }, { "2015-16": "0.8" }, { "2016-17": "0.9" }, { "2017-18": "1.2" }], "RE": [{ "2014-15": "4.5" }, { "2015-16": "2.3" }, { "2016-17": "2.5" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2013-14": "2.3" }, { "2014-15": "4.2" }, { "2015-16": "4.9" }], "BE": [{ "2014-15": "4" }, { "2015-16": "5.1" }, { "2016-17": "3.6" }, { "2017-18": "6.1" }], "RE": [{ "2014-15": "4.9" }, { "2015-16": "5.5" }, { "2016-17": "3.7" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2013-14": "5.1" }, { "2014-15": "1.9" }, { "2015-16": "2.8" }], "BE": [{ "2014-15": "6.9" }, { "2015-16": "4.1" }, { "2016-17": "3.7" }, { "2017-18": "4.1" }], "RE": [{ "2014-15": "3.6" }, { "2015-16": "3.5" }, { "2016-17": "3.5" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2013-14": "0.3" }, { "2014-15": "0.3" }, { "2015-16": "0.7" }], "BE": [{ "2014-15": "0.6" }, { "2015-16": "0.5" }, { "2016-17": "0.9" }, { "2017-18": "3.2" }], "RE": [{ "2014-15": "0.4" }, { "2015-16": "0.8" }, { "2016-17": "0.5" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2013-14": "31.6" }, { "2014-15": "19.4" }, { "2015-16": "2.8" }], "BE": [{ "2014-15": "20.6" }, { "2015-16": "29.2" }, { "2016-17": "4.9" }, { "2017-18": "6.6" }], "RE": [{ "2014-15": "21.3" }, { "2015-16": "23.1" }, { "2016-17": "8.7" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2013-14": "1.4" }, { "2014-15": "2" }, { "2015-16": "4.5" }], "BE": [{ "2014-15": "2.5" }, { "2015-16": "2.4" }, { "2016-17": "3.6" }, { "2017-18": "1.7" }], "RE": [{ "2014-15": "2.1" }, { "2015-16": "4.3" }, { "2016-17": "3.7" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "5.1" }, { "2015-16": "5.3" }], "BE": [{ "2014-15": "5" }, { "2015-16": "4.6" }, { "2016-17": "8.5" }, { "2017-18": "5.5" }], "RE": [{ "2014-15": "7" }, { "2015-16": "5" }, { "2016-17": "7.4" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2013-14": "1.9" }, { "2014-15": "3.2" }, { "2015-16": "1.9" }], "BE": [{ "2014-15": "3.9" }, { "2015-16": "5" }, { "2016-17": "5.4" }, { "2017-18": "2.1" }], "RE": [{ "2014-15": "3.9" }, { "2015-16": "5.5" }, { "2016-17": "6.2" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2013-14": "6.8" }, { "2014-15": "8.1" }, { "2015-16": "4.8" }], "BE": [{ "2014-15": "6.8" }, { "2015-16": "7.7" }, { "2016-17": "7.2" }, { "2017-18": "3.7" }], "RE": [{ "2014-15": "10.6" }, { "2015-16": "9.4" }, { "2016-17": "7.1" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2013-14": "3.4" }, { "2014-15": "2.4" }, { "2015-16": "2.7" }], "BE": [{ "2014-15": "9.9" }, { "2015-16": "2.9" }, { "2016-17": "4.7" }, { "2017-18": "2.8" }], "RE": [{ "2014-15": "2.7" }, { "2015-16": "3.2" }, { "2016-17": "2.9" }] }, "grpby_name": "West Bengal" }] }], "category_name": " Education" }];

/***/ },
/* 378 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var expenditure_metadata = exports.expenditure_metadata = [{
	    "category": "Agriculture & Allied Activities",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "agriculture_allied_activities",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of the State Budgets of concerned States. Note:The expenditure data for 2013-14 is strictly not comparable with the later years because the Union Budget outlays for a number of Centrally Sponsored Schemes (CSS) used to get transferred directly to the implementing agencies without being routed through the State Budgets. Hence, the State Budget data till 2013-14 did not reflect the complete allocations, combining both the Central and States’ share, for these CSS. ",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Agriculture & Allied Activities",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "agriculture_allied_activities",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Agriculture & Allied Activities",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "agriculture_allied_activities",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Agriculture & Allied Activities",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "agriculture_allied_activities",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector I expenditure data have been collected from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Agriculture & Allied Activities",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "agriculture_allied_activities",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- I expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Cooperation & Food, Civil Supplies",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "cooperation_food_civil_supplies",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been taken from from Detailed Demand for Grants documents of the respective departments of  Food & Civil Supplies and Department of Cooperation of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Cooperation & Food, Civil Supplies",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "cooperation_food_civil_supplies",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Cooperation & Food, Civil Supplies",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "cooperation_food_civil_supplies",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been collected from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Cooperation & Food, Civil Supplies",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "cooperation_food_civil_supplies",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector II expenditure data have been noted from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Cooperation & Food, Civil Supplies",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "cooperation_food_civil_supplies",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- II expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Rural Development",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "rural_development",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the Ministry/ Department of Panchayati Raj Institutions (PRIs) of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Rural Development",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "rural_development",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years.Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Rural Development",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "rural_development",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Rural Development",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "rural_development",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector III expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Rural Development",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "rural_development",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- III expenditure data have been taken from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Panchayat",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "panchayat",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective Ministry/ Department of Rural Development of the concerned State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Panchayat",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "panchayat",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Panchayat",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "panchayat",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Panchayat",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "panchayat",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector- IV expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Panchayat",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "panchayat",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- IV expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Power & Energy",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "power_energy",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective Ministry/ Department of Power & Energy of the concerned State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Power & Energy",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "power_energy",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Power & Energy",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "power_energy",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Power & Energy",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "power_energy",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector V expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Power & Energy",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "power_energy",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- V expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Public Works",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "public_works",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of  Construction of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Public Works",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "public_works",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Public Works",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "public_works",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Public Works",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "public_works",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector VI expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Public Works",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "public_works",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- VI expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Irrigation & Water Resources",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "irrigation_water_resources",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of  Irrigation & Water Resources of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Irrigation & Water Resources",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "irrigation_water_resources",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Irrigation & Water Resources",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "irrigation_water_resources",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Irrigation & Water Resources",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "irrigation_water_resources",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector VII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Irrigation & Water Resources",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "irrigation_water_resources",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- VII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Forests & Environment",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "forests_environment",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of Forests and Department of Environment of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Forests & Environment",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "forests_environment",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Forests & Environment",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "forests_environment",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Forests & Environment",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "forests_environment",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector VIII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Forests & Environment",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "forests_environment",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- VIII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Urban Development & Housing",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "urban_development_housing",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of Urban Development and Department of Housing of the State.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Urban Development & Housing",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "urban_development_housing",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Urban Development & Housing",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "urban_development_housing",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Urban Development & Housing",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "urban_development_housing",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector. IX expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Urban Development & Housing",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "urban_development_housing",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- IX expenditure data have been compiled from Detailed Demand for Grants of the departments of Urban Development and Department of Housing/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Social Welfare",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "social_welfare",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective departments of concerned Departments of Welfare of SCs, STs, OBCs & Minorities, Women and Child Development, and Social Security of the State. ",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Social Welfare",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "social_welfare",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Social Welfare",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "social_welfare",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Social Welfare",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "social_welfare",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector X expenditure data have been compiled from Detailed Demand for Grants of the relevant concerned Departments of Welfare of SCs, STs, OBCs & Minorities, Women and Child Development, and Social Security/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Social Welfare",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "social_welfare",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- X expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Health",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "health",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from  Detailed Demand for Grants documents of the departments of Health, Department of Family Welfare, Department of Medical Education, and other relevant departments of the State. ",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Health",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "health",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Health",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "health",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Health",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "health",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector XI expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Health",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "health",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- XI expenditure data have been compiled from Detailed Demand for Grants of the  departments of Health, Department of Family Welfare, Department of Medical Education, Department of Ayush and other relevant departments / Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Education",
	    "record_slug": "total_sector_expenditure",
	    "category_slug": "education",
	    "notes": "The data are compiled and aggregated from data of demand for grants documents. Thus, data compiled pertain to expenditure made through Dpartments/ Ministries of the respective States. These data may not, and usually should not match precisely with those of compiled as per Major Head ( major functions of the government).",
	    "record": "Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Expenditure Data for the Sector have been compiled from from Detailed Demand for Grants documents of the respective by the Department of School & Secondary Education, the Department of Higher Education, the Department of Technical Education, the Department of Arts & Culture, The Department of Sports & Youth Services, the Department of Literacy & Adult Education of the State. ",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Education",
	    "record_slug": "total_sector_expenditure_as_of_state_budget",
	    "category_slug": "education",
	    "notes": "",
	    "record": "Total Sector Expenditure as % of State Budget",
	    "source": "Total State Budget data have been compiled from Annual Financial Statement/ Budget-in-Brief/ Budget at a Glance documents for the respective States.",
	    "unit": "Percentage"
	}, {
	    "category": "Education",
	    "record_slug": "per_capita_expenditure_on_sector",
	    "category_slug": "education",
	    "notes": "Population figures are projections, not the actual numbers based on 2011 Census data.",
	    "record": "Per Capita Expenditure on Sector",
	    "source": "Population data have been compiled from Census of India, 2011 from the document - Population Projections for India & States 2011-2016; OFFICE OF THE REGISTRAR GENERAL & CENSUS COMMISSIONER, INDIA.",
	    "unit": "INR (in Crores)"
	}, {
	    "category": "Education",
	    "record_slug": "revenue_expenditure_as_of_total_sector_expenditure",
	    "category_slug": "education",
	    "notes": "",
	    "record": "Revenue Expenditure as % of Total Sector Expenditure",
	    "source": "State Budgets; Detailed Demand for Grants ( Plan and Non Plan Documents) ; Various Years. Revenue Expenditure and Total Sector- XII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}, {
	    "category": "Education",
	    "record_slug": "capital_expenditure_including_loans_advances_as_of_total_sector_expenditure",
	    "category_slug": "education",
	    "notes": "",
	    "record": "Capital Expenditure (including Loans & Advances ) as % of Total Sector Expenditure",
	    "source": "Capital Expenditure (including loans & advances) and Total Sector- XII expenditure data have been compiled from Detailed Demand for Grants of the relevant Departments/ Demand Nos for the concerned States.",
	    "unit": "Percentage"
	}];

/***/ },
/* 379 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var receipts_data = exports.receipts_data = [{ "record_slug": "total_receipts", "record_name": "Total Receipts", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "128474" }, { "2013-14": "137098" }, { "2014-15": "124284" }, { "2015-16": "149601" }], "BE": [{ "2013-14": "161732" }, { "2014-15": "110367" }, { "2015-16": "112852" }, { "2016-17": "135590" }, { "2016-17": "135590" }, { "2017-18": "156988" }], "RE": [{ "2013-14": "161732" }, { "2014-15": "110355" }, { "2015-16": "112108" }, { "2016-17": "132731" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "32087" }, { "2013-14": "33415" }, { "2014-15": "44337" }, { "2015-16": "48466" }], "BE": [{ "2013-14": "42381" }, { "2014-15": "57311" }, { "2015-16": "64840" }, { "2016-2017": "77423" }, { "2016-17": "77423" }, { "2017-18": "84732" }], "RE": [{ "2013-14": "45731" }, { "2014-15": "51885" }, { "2015-16": "52918" }, { "2016-17": "70146" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "69145" }, { "2013-14": "78841" }, { "2014-15": "93828" }, { "2015-16": "114525" }], "BE": [{ "2013-14": "91899" }, { "2014-15": "116683" }, { "2015-16": "120914" }, { "2016-17": "145863" }, { "2016-17": "145863" }, { "2017-18": "161039" }], "RE": [{ "2013-14": "90917" }, { "2014-15": "110488" }, { "2015-16": "118678" }, { "2016-17": "147026" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "31918" }, { "2013-14": "40478" }, { "2014-15": "46120" }, { "2015-16": "51368" }], "BE": [{ "2013-14": "43977" }, { "2014-15": "54661" }, { "2015-16": "64935" }, { "2016-17": "69972" }, { "2016-17": "69972" }, { "2017-18": "75952" }], "RE": [{ "2013-14": "44234" }, { "2014-15": "54977" }, { "2015-16": "65814" }, { "2016-17": "70596" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "27208" }, { "2013-14": "32946" }, { "2014-15": "31577" }, { "2015-16": "37323" }], "BE": [{ "2013-14": "38181" }, { "2014-15": "37104" }, { "2015-16": "39984" }, { "2016-17": "44946" }, { "2016-17": "44946" }, { "2017-18": "45472" }], "RE": [{ "2013-14": "35200" }, { "2014-15": "33959" }, { "2015-16": "38102" }, { "2016-17": "40083" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "94773" }, { "2013-14": "99459" }, { "2014-15": "112294" }, { "2015-16": "121094" }], "BE": [{ "2013-14": "111984" }, { "2014-15": "129191" }, { "2015-16": "134417" }, { "2016-17": "146163" }, { "2016-17": "146163" }, { "2017-18": "165496" }], "RE": [{ "2013-14": "105211" }, { "2014-15": "123370" }, { "2015-16": "129506" }, { "2016-17": "142548" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "43256" }, { "2013-14": "47920" }, { "2014-15": "51722" }, { "2015-16": "61399" }], "BE": [{ "2013-14": "52641" }, { "2014-15": "59173" }, { "2015-16": "68986" }, { "2016-17": "80065" }, { "2016-17": "80065" }, { "2017-18": "86542" }], "RE": [{ "2013-14": "51650" }, { "2014-15": "56108" }, { "2015-16": "67702" }, { "2016-17": "75360" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "20981" }, { "2013-14": "20330" }, { "2014-15": "31095" }, { "2015-16": "29984" }], "BE": [{ "2013-14": "22848" }, { "2014-15": "21507" }, { "2015-16": "28339" }, { "2016-17": "32373" }, { "2016-17": "32373" }, { "2017-18": "35078" }], "RE": [{ "2013-14": "22325" }, { "2014-15": "30358" }, { "2015-16": "29326" }, { "2016-17": "34329" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "31777" }, { "2013-14": "32781" }, { "2014-15": "35681" }, { "2015-16": "45750" }], "BE": [{ "2013-14": "38068" }, { "2014-15": "43543" }, { "2015-16": "42137" }, { "2016-17": "61681" }, { "2016-17": "61681" }, { "2017-18": "76335" }], "RE": [{ "2013-14": "36289" }, { "2014-15": "39442" }, { "2015-16": "47999" }, { "2016-17": "57521" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "30502" }, { "2013-14": "30429" }, { "2014-15": "40042" }, { "2015-16": "54437" }], "BE": [{ "2013-14": "39549" }, { "2014-15": "50388" }, { "2015-16": "55493" }, { "2016-17": "63503" }, { "2016-17": "63503" }, { "2017-18": "75673" }], "RE": [{ "2013-14": "38497" }, { "2014-15": "50840" }, { "2015-16": "56117" }, { "2016-17": "66596" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "78367" }, { "2013-14": "89740" }, { "2014-15": "126111" }, { "2015-16": "140302" }], "BE": [{ "2013-14": "98321" }, { "2014-15": "111206" }, { "2015-16": "139476" }, { "2016-17": "161956" }, { "2016-17": "161956" }, { "2017-18": "182119" }], "RE": [{ "2013-14": "94444" }, { "2014-15": "109043" }, { "2015-16": "139387" }, { "2016-17": "164104" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "59823" }, { "2013-14": "69404" }, { "2014-15": "76669.62" }, { "2015-16": "86998" }], "BE": [{ "2013-14": "70518" }, { "2014-15": "93751" }, { "2015-16": "95342" }, { "2016-17": "107285" }, { "2016-17": "107285" }, { "2017-18": "119124" }], "RE": [{ "2013-14": "67832" }, { "2014-15": "93962" }, { "2015-16": "88860" }, { "2016-17": "103986" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "78963" }, { "2013-14": "86198" }, { "2014-15": "100120" }, { "2015-16": "120576" }], "BE": [{ "2013-14": "92019" }, { "2014-15": "116582" }, { "2015-16": "130815" }, { "2016-17": "151026" }, { "2016-17": "151026" }, { "2017-18": "169503" }], "RE": [{ "2013-14": "92878" }, { "2014-15": "118215" }, { "2015-16": "132413" }, { "2016-17": "155944" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "157746" }, { "2013-14": "188749" }, { "2014-15": "211354" }, { "2015-16": "223268" }], "BE": [{ "2013-14": "181100" }, { "2014-15": "224114" }, { "2015-16": "243133" }, { "2016-17": "270780" }, { "2016-17": "270780" }, { "2017-18": "300502" }], "RE": [{ "2013-14": "185938" }, { "2014-15": "230285" }, { "2015-16": "247134" }, { "2016-17": "281591" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "6083" }, { "2013-14": "6920" }, { "2014-15": "7175" }, { "2015-16": "7899" }], "BE": [{ "2013-14": "9237" }, { "2014-15": "11868" }, { "2015-16": "9432" }, { "2016-17": "10349" }, { "2016-17": "10349" }, { "2017-18": "12685" }], "RE": [{ "2013-14": "9237" }, { "2014-15": "11868" }, { "2015-16": "9470" }, { "2016-17": "10349" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "4987" }, { "2013-14": "5921" }, { "2014-15": "6926" }, { "2015-16": "7265" }], "BE": [{ "2013-14": "5452" }, { "2014-15": "6397" }, { "2015-16": "7605" }, { "2016-17": "8066" }, { "2016-17": "8066" }, { "2017-18": "8803" }], "RE": [{ "2013-14": "6317" }, { "2014-15": "6740" }, { "2015-16": "8219" }, { "2016-17": "8283" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "8935" }, { "2013-14": "" }, { "2014-15": "10067" }, { "2015-16": "11590" }], "BE": [{ "2013-14": "9982" }, { "2014-15": "12128" }, { "2015-16": "12042" }, { "2016-17": "13871" }, { "2016-17": "13871" }, { "2017-18": "16657" }], "RE": [{ "2013-14": "8708" }, { "2014-15": "8680" }, { "2015-16": "12061" }, { "2016-17": "14741" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "45959" }, { "2013-14": "51494" }, { "2014-15": "64735" }, { "2015-16": "78960" }], "BE": [{ "2013-14": "58344" }, { "2014-15": "78083" }, { "2015-16": "83181" }, { "2016-17": "92981" }, { "2016-17": "92981" }, { "2017-18": "106065" }], "RE": [{ "2013-14": "60233" }, { "2014-15": "75500" }, { "2015-16": "83020" }, { "2016-17": "92515" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "45042" }, { "2013-14": "59357" }, { "2014-15": "70384" }, { "2015-16": "80170" }], "BE": [{ "2013-14": "56012" }, { "2014-15": "71752" }, { "2015-16": "78085" }, { "2016-17": "85595" }, { "2016-17": "85595" }, { "2017-18": "105515" }], "RE": [{ "2013-14": "54213" }, { "2014-15": "72596" }, { "2015-16": "77264" }, { "2016-17": "135403" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "81186" }, { "2013-14": "94150" }, { "2014-15": "116630" }, { "2015-16": "130194" }], "BE": [{ "2013-14": "95209" }, { "2014-15": "128276" }, { "2015-16": "137888" }, { "2016-17": "151207" }, { "2016-17": "151207" }, { "2017-18": "166816" }], "RE": [{ "2013-14": "99877" }, { "2014-15": "126214" }, { "2015-16": "137475" }, { "2016-17": "148518" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "3991" }, { "2013-14": "4624" }, { "2014-15": "4875" }, { "2015-16": "4441" }], "BE": [{ "2013-14": "5385" }, { "2014-15": "6571" }, { "2015-16": "5503" }, { "2016-17": "5726" }, { "2016-17": "5726" }, { "2017-18": "6209" }], "RE": [{ "2013-14": "5513" }, { "2014-15": "6636" }, { "2015-16": "5599" }, { "2016-17": "6001" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "133471" }, { "2014-15": "196260" }, { "2015-16": "165758" }], "BE": [{ "2013-14": "" }, { "2014-15": "158595" }, { "2015-16": "179552" }, { "2016-17": "196260" }, { "2016-17": "196260" }, { "2017-18": "215737" }], "RE": [{ "2013-14": "" }, { "2014-15": "165619" }, { "2015-16": "175986" }, { "2016-17": "215737" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "62473" }, { "2015-16": "97817" }], "BE": [{ "2013-14": "" }, { "2014-15": "98099" }, { "2015-16": "115686" }, { "2016-17": "130429" }, { "2016-17": "130429" }, { "2017-18": "149320" }], "RE": [{ "2013-14": "" }, { "2014-15": "98099" }, { "2015-16": "100162" }, { "2016-17": "112653" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "8119" }, { "2013-14": "8757" }, { "2014-15": "10078" }, { "2015-16": "10888" }], "BE": [{ "2013-14": "9017" }, { "2014-15": "12050" }, { "2015-16": "14260" }, { "2016-17": "14458" }, { "2016-17": "14458" }, { "2017-18": "15159" }], "RE": [{ "2013-14": "9592" }, { "2014-15": "11903" }, { "2015-16": "12193" }, { "2016-17": "14341" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "162143" }, { "2013-14": "183704" }, { "2014-15": "229204" }, { "2015-16": "302315" }], "BE": [{ "2013-14": "215920" }, { "2014-15": "270573" }, { "2015-16": "296723" }, { "2016-17": "340121" }, { "2016-17": "340121" }, { "2017-18": "377191" }], "RE": [{ "2013-14": "199709" }, { "2014-15": "258702" }, { "2015-16": "325917" }, { "2016-17": "333746" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "19158" }, { "2013-14": "21595" }, { "2014-15": "25181" }, { "2015-16": "28260" }], "BE": [{ "2013-14": "24940" }, { "2014-15": "29825" }, { "2015-16": "32310" }, { "2016-17": "39912" }, { "2016-17": "39912" }, { "2017-18": "39856" }], "RE": [{ "2013-14": "26589" }, { "2014-15": "31859" }, { "2015-16": "33045" }, { "2016-17": "32566" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "96554" }, { "2013-14": "108085" }, { "2014-15": "122739" }, { "2015-16": "141983" }], "BE": [{ "2013-14": "110800" }, { "2014-15": "130012" }, { "2015-16": "138370" }, { "2016-17": "160042" }, { "2016-17": "160042" }, { "2017-18": "182292" }], "RE": [{ "2013-14": "111849" }, { "2014-15": "129667" }, { "2015-16": "145501" }, { "2016-17": "166155" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "revenue_receipts", "record_name": "Revenue Receipts", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "103830" }, { "2013-14": "110719" }, { "2014-15": "90672" }, { "2015-16": "88648" }], "BE": [{ "2013-14": "127772" }, { "2014-15": "92078" }, { "2015-16": "90125" }, { "2016-17": "109300" }, { "2016-17": "109300" }, { "2017-18": "125496" }], "RE": [{ "2013-14": "127772" }, { "2014-15": "84066" }, { "2015-16": "89381" }, { "2016-17": "107709" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "30691" }, { "2013-14": "32213" }, { "2014-15": "38181" }, { "2015-16": "42458" }], "BE": [{ "2013-14": "37663" }, { "2014-15": "52697" }, { "2015-16": "57064" }, { "2016-2017": "66180" }, { "2016-17": "66180" }, { "2017-18": "70720" }], "RE": [{ "2013-14": "40912" }, { "2014-15": "47340" }, { "2015-16": "44263" }, { "2016-17": "59008" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "59567" }, { "2013-14": "68919" }, { "2014-15": "78418" }, { "2015-16": "96123" }], "BE": [{ "2013-14": "80067" }, { "2014-15": "101939" }, { "2015-16": "103189" }, { "2016-17": "124590" }, { "2016-17": "124590" }, { "2017-18": "137158" }], "RE": [{ "2013-14": "78602" }, { "2014-15": "95745" }, { "2015-16": "100184" }, { "2016-17": "127537" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "29578" }, { "2013-14": "32050" }, { "2014-15": "37933" }, { "2015-16": "46068" }], "BE": [{ "2013-14": "37445" }, { "2014-15": "48654" }, { "2015-16": "57956" }, { "2016-17": "61427" }, { "2016-17": "61427" }, { "2017-18": "66094" }], "RE": [{ "2013-14": "37498" }, { "2014-15": "49041" }, { "2015-16": "58814" }, { "2016-17": "62786" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "25561" }, { "2013-14": "27981" }, { "2014-15": "29585" }, { "2015-16": "34999" }], "BE": [{ "2013-14": "34068" }, { "2014-15": "36404" }, { "2015-16": "38565" }, { "2016-17": "41391" }, { "2016-17": "41391" }, { "2017-18": "42216" }], "RE": [{ "2013-14": "30450" }, { "2014-15": "32140" }, { "2015-16": "35721" }, { "2016-17": "36922" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "75229" }, { "2013-14": "79976" }, { "2014-15": "91978" }, { "2015-16": "97483" }], "BE": [{ "2013-14": "85752" }, { "2014-15": "103053" }, { "2015-16": "109295" }, { "2016-17": "116366" }, { "2016-17": "116366" }, { "2017-18": "131521" }], "RE": [{ "2013-14": "85000" }, { "2014-15": "98985" }, { "2015-16": "104384" }, { "2016-17": "112521" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "33634" }, { "2013-14": "38012" }, { "2014-15": "40799" }, { "2015-16": "47557" }], "BE": [{ "2013-14": "43780" }, { "2014-15": "47690" }, { "2015-16": "52312" }, { "2016-17": "62956" }, { "2016-17": "62956" }, { "2017-18": "68811" }], "RE": [{ "2013-14": "41636" }, { "2014-15": "45419" }, { "2015-16": "54167" }, { "2016-17": "60327" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "15598" }, { "2013-14": "15711" }, { "2014-15": "17843" }, { "2015-16": "23440" }], "BE": [{ "2013-14": "17701" }, { "2014-15": "16522" }, { "2015-16": "23535" }, { "2016-17": "26270" }, { "2016-17": "26270" }, { "2017-18": "27714" }], "RE": [{ "2013-14": "16663" }, { "2014-15": "18907" }, { "2015-16": "24514" }, { "2016-17": "26677" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "26217" }, { "2013-14": "27128" }, { "2014-15": "28938" }, { "2015-16": "35780" }], "BE": [{ "2013-14": "33970" }, { "2014-15": "39221" }, { "2015-16": "37814" }, { "2016-17": "51460" }, { "2016-17": "51460" }, { "2017-18": "58168" }], "RE": [{ "2013-14": "31227" }, { "2014-15": "34541" }, { "2015-16": "40904" }, { "2016-17": "50174" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "24770" }, { "2013-14": "26137" }, { "2014-15": "31565" }, { "2015-16": "40638" }], "BE": [{ "2013-14": "33599" }, { "2014-15": "43444" }, { "2015-16": "48027" }, { "2016-17": "55756" }, { "2016-17": "55756" }, { "2017-18": "65607" }], "RE": [{ "2013-14": "32552" }, { "2014-15": "43904" }, { "2015-16": "48650" }, { "2016-17": "57651" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "78176" }, { "2013-14": "89543" }, { "2014-15": "104142" }, { "2015-16": "118817" }], "BE": [{ "2013-14": "97986" }, { "2014-15": "111039" }, { "2015-16": "116360" }, { "2016-17": "130758" }, { "2016-17": "130758" }, { "2017-18": "144892" }], "RE": [{ "2013-14": "94270" }, { "2014-15": "108908" }, { "2015-16": "117731" }, { "2016-17": "132867" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "44137" }, { "2013-14": "49177" }, { "2014-15": "57950.47" }, { "2015-16": "69033" }], "BE": [{ "2013-14": "58058" }, { "2014-15": "64842" }, { "2015-16": "77427" }, { "2016-17": "84617" }, { "2016-17": "84617" }, { "2017-18": "93585" }], "RE": [{ "2013-14": "54967" }, { "2014-15": "63588" }, { "2015-16": "71020" }, { "2016-17": "80620" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "70427" }, { "2013-14": "75749" }, { "2014-15": "88641" }, { "2015-16": "105511" }], "BE": [{ "2013-14": "79604" }, { "2014-15": "103493" }, { "2015-16": "114423" }, { "2016-17": "126095" }, { "2016-17": "126095" }, { "2017-18": "139116" }], "RE": [{ "2013-14": "80497" }, { "2014-15": "104621" }, { "2015-16": "111131" }, { "2016-17": "126051" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "142947" }, { "2013-14": "149822" }, { "2014-15": "165415" }, { "2015-16": "185036" }], "BE": [{ "2013-14": "155987" }, { "2014-15": "180320" }, { "2015-16": "198231" }, { "2016-17": "220810" }, { "2016-17": "220810" }, { "2017-18": "243738" }], "RE": [{ "2013-14": "158410" }, { "2014-15": "180794" }, { "2015-16": "198321" }, { "2016-17": "220012" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "5536" }, { "2013-14": "6267" }, { "2014-15": "6428" }, { "2015-16": "7043" }], "BE": [{ "2013-14": "8583" }, { "2014-15": "11128" }, { "2015-16": "8403" }, { "2016-17": "8981" }, { "2016-17": "8981" }, { "2017-18": "11280" }], "RE": [{ "2013-14": "8583" }, { "2014-15": "11128" }, { "2015-16": "8403" }, { "2016-17": "8981" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "4537" }, { "2013-14": "4765" }, { "2014-15": "5511" }, { "2015-16": "6676" }], "BE": [{ "2013-14": "5039" }, { "2014-15": "5879" }, { "2015-16": "7175" }, { "2016-17": "7672" }, { "2016-17": "7672" }, { "2017-18": "8173" }], "RE": [{ "2013-14": "5529" }, { "2014-15": "5317" }, { "2015-16": "7535" }, { "2016-17": "7889" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "6204" }, { "2013-14": "6498" }, { "2014-15": "7651" }, { "2015-16": "8044" }], "BE": [{ "2013-14": "7295" }, { "2014-15": "9538" }, { "2015-16": "8892" }, { "2016-17": "10569" }, { "2016-17": "10569" }, { "2017-18": "10857" }], "RE": [{ "2013-14": "6670" }, { "2014-15": "8089" }, { "2015-16": "8994" }, { "2016-17": "9356" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "43937" }, { "2013-14": "48947" }, { "2014-15": "56998" }, { "2015-16": "68941" }], "BE": [{ "2013-14": "51299" }, { "2014-15": "67147" }, { "2015-16": "70941" }, { "2016-17": "78127" }, { "2016-17": "78127" }, { "2017-18": "88932" }], "RE": [{ "2013-14": "53810" }, { "2014-15": "63649" }, { "2015-16": "71569" }, { "2016-17": "79983" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "32051" }, { "2013-14": "35104" }, { "2014-15": "39023" }, { "2015-16": "41523" }], "BE": [{ "2013-14": "42666" }, { "2014-15": "44894" }, { "2015-16": "46229" }, { "2016-17": "50181" }, { "2016-17": "50181" }, { "2017-18": "60080" }], "RE": [{ "2013-14": "39851" }, { "2014-15": "42742" }, { "2015-16": "45603" }, { "2016-17": "51372" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "66913" }, { "2013-14": "74470" }, { "2014-15": "91327" }, { "2015-16": "100285" }], "BE": [{ "2013-14": "77221" }, { "2014-15": "106125" }, { "2015-16": "111362" }, { "2016-17": "123251" }, { "2016-17": "123251" }, { "2017-18": "130162" }], "RE": [{ "2013-14": "77281" }, { "2014-15": "96668" }, { "2015-16": "106790" }, { "2016-17": "116428" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "3793" }, { "2013-14": "4326" }, { "2014-15": "4462" }, { "2015-16": "3784" }], "BE": [{ "2013-14": "4996" }, { "2014-15": "6113" }, { "2015-16": "4802" }, { "2016-17": "4885" }, { "2016-17": "4885" }, { "2017-18": "5326" }], "RE": [{ "2013-14": "5124" }, { "2014-15": "6179" }, { "2015-16": "4854" }, { "2016-17": "5195" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "98828" }, { "2013-14": "108036" }, { "2014-15": "122420" }, { "2015-16": "129008" }], "BE": [{ "2013-14": "" }, { "2014-15": "127390" }, { "2015-16": "142681" }, { "2016-17": "148175" }, { "2016-17": "148175" }, { "2017-18": "159363" }], "RE": [{ "2013-14": "" }, { "2014-15": "133189" }, { "2015-16": "138306" }, { "2016-17": "143800" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "51042" }, { "2015-16": "76134" }], "BE": [{ "2013-14": "" }, { "2014-15": "80090" }, { "2015-16": "94132" }, { "2016-17": "100925" }, { "2016-17": "100925" }, { "2017-18": "113083" }], "RE": [{ "2013-14": "" }, { "2014-15": "80090" }, { "2015-16": "79313" }, { "2016-17": "87070" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "7050" }, { "2013-14": "7650" }, { "2014-15": "9240" }, { "2015-16": "9427" }], "BE": [{ "2013-14": "8135" }, { "2014-15": "10795" }, { "2015-16": "12525" }, { "2016-17": "12886" }, { "2016-17": "12886" }, { "2017-18": "13553" }], "RE": [{ "2013-14": "8487" }, { "2014-15": "10663" }, { "2015-16": "10821" }, { "2016-17": "12768" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "145904" }, { "2013-14": "168214" }, { "2014-15": "193422" }, { "2015-16": "227076" }], "BE": [{ "2013-14": "177748" }, { "2014-15": "226419" }, { "2015-16": "249880" }, { "2016-17": "281555" }, { "2016-17": "281555" }, { "2017-18": "319397" }], "RE": [{ "2013-14": "172234" }, { "2014-15": "223997" }, { "2015-16": "247722" }, { "2016-17": "269407" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "15747" }, { "2013-14": "17321" }, { "2014-15": "20247" }, { "2015-16": "21234" }], "BE": [{ "2013-14": "18956" }, { "2014-15": "24474" }, { "2015-16": "25778" }, { "2016-17": "32276" }, { "2016-17": "32276" }, { "2017-18": "31593" }], "RE": [{ "2013-14": "20549" }, { "2014-15": "26509" }, { "2015-16": "26013" }, { "2016-17": "25256" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "68296" }, { "2013-14": "72882" }, { "2014-15": "86514" }, { "2015-16": "109732" }], "BE": [{ "2013-14": "88403" }, { "2014-15": "105978" }, { "2015-16": "113100" }, { "2016-17": "129530" }, { "2016-17": "129530" }, { "2017-18": "142644" }], "RE": [{ "2013-14": "81135" }, { "2014-15": "96466" }, { "2015-16": "109632" }, { "2016-17": "129340" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "capital_receipts", "record_name": "Capital Receipts", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "24644" }, { "2013-14": "26379" }, { "2014-15": "33612" }, { "2015-16": "60953" }], "BE": [{ "2013-14": "33960" }, { "2014-15": "18289" }, { "2015-16": "22727" }, { "2016-17": "26290" }, { "2016-17": "26290" }, { "2017-18": "31492" }], "RE": [{ "2013-14": "33960" }, { "2014-15": "26289" }, { "2015-16": "22727" }, { "2016-17": "25022" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "1396" }, { "2013-14": "1202" }, { "2014-15": "6156" }, { "2015-16": "6008" }], "BE": [{ "2013-14": "4718" }, { "2014-15": "4615" }, { "2015-16": "7776" }, { "2016-2017": "11243" }, { "2016-17": "11243" }, { "2017-18": "14013" }], "RE": [{ "2013-14": "4819" }, { "2014-15": "4545" }, { "2015-16": "8655" }, { "2016-17": "11138" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "9579" }, { "2013-14": "9922" }, { "2014-15": "15411" }, { "2015-16": "18402" }], "BE": [{ "2013-14": "11833" }, { "2014-15": "14743" }, { "2015-16": "17725" }, { "2016-17": "21272" }, { "2016-17": "18402" }, { "2017-18": "23881" }], "RE": [{ "2013-14": "12315" }, { "2014-15": "14743" }, { "2015-16": "18495" }, { "2016-17": "18402" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "2340" }, { "2013-14": "8428" }, { "2014-15": "8187" }, { "2015-16": "5300" }], "BE": [{ "2013-14": "6532" }, { "2014-15": "6006" }, { "2015-16": "6979" }, { "2016-17": "8545" }, { "2016-17": "8545" }, { "2017-18": "9858" }], "RE": [{ "2013-14": "6737" }, { "2014-15": "5936" }, { "2015-16": "7000" }, { "2016-17": "7810" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "1647" }, { "2013-14": "4966" }, { "2014-15": "1992" }, { "2015-16": "2325" }], "BE": [{ "2013-14": "4114" }, { "2014-15": "700" }, { "2015-16": "1419" }, { "2016-17": "3555" }, { "2016-17": "3555" }, { "2017-18": "3256" }], "RE": [{ "2013-14": "4750" }, { "2014-15": "1819" }, { "2015-16": "2381" }, { "2016-17": "3161" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "19544" }, { "2013-14": "19484" }, { "2014-15": "20316" }, { "2015-16": "23612" }], "BE": [{ "2013-14": "26232" }, { "2014-15": "26137" }, { "2015-16": "25122" }, { "2016-17": "29797" }, { "2016-17": "29797" }, { "2017-18": "33975" }], "RE": [{ "2013-14": "20211" }, { "2014-15": "24385" }, { "2015-16": "25122" }, { "2016-17": "30027" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "9622" }, { "2013-14": "9907" }, { "2014-15": "10923" }, { "2015-16": "13842" }], "BE": [{ "2013-14": "8861" }, { "2014-15": "11483" }, { "2015-16": "16674" }, { "2016-17": "17109" }, { "2016-17": "17109" }, { "2017-18": "17731" }], "RE": [{ "2013-14": "10014" }, { "2014-15": "10689" }, { "2015-16": "13535" }, { "2016-17": "15033" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "5383" }, { "2013-14": "4619" }, { "2014-15": "13252" }, { "2015-16": "6543" }], "BE": [{ "2013-14": "5147" }, { "2014-15": "4985" }, { "2015-16": "4804" }, { "2016-17": "6102" }, { "2016-17": "6102" }, { "2017-18": "7364" }], "RE": [{ "2013-14": "5662" }, { "2014-15": "11451" }, { "2015-16": "4812" }, { "2016-17": "7653" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "5560" }, { "2013-14": "5653" }, { "2014-15": "6743" }, { "2015-16": "9970" }], "BE": [{ "2013-14": "4098" }, { "2014-15": "4322" }, { "2015-16": "4323" }, { "2016-17": "10221" }, { "2016-17": "10221" }, { "2017-18": "18167" }], "RE": [{ "2013-14": "5062" }, { "2014-15": "4901" }, { "2015-16": "7095" }, { "2016-17": "7347" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "5733" }, { "2013-14": "4293" }, { "2014-15": "8477" }, { "2015-16": "13799" }], "BE": [{ "2013-14": "5950" }, { "2014-15": "6944" }, { "2015-16": "7466" }, { "2016-17": "7746" }, { "2016-17": "7746" }, { "2017-18": "10066" }], "RE": [{ "2013-14": "5946" }, { "2014-15": "6936" }, { "2015-16": "7467" }, { "2016-17": "8945" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "191" }, { "2013-14": "197" }, { "2014-15": "21969" }, { "2015-16": "21484" }], "BE": [{ "2013-14": "335" }, { "2014-15": "168" }, { "2015-16": "23116" }, { "2016-17": "31198" }, { "2016-17": "31198" }, { "2017-18": "37227" }], "RE": [{ "2013-14": "173" }, { "2014-15": "135" }, { "2015-16": "21656" }, { "2016-17": "31237" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "15686" }, { "2013-14": "20227" }, { "2014-15": "18719.15" }, { "2015-16": "17965" }], "BE": [{ "2013-14": "12460" }, { "2014-15": "28909" }, { "2015-16": "17915" }, { "2016-17": "22668" }, { "2016-17": "22668" }, { "2017-18": "25540" }], "RE": [{ "2013-14": "12865" }, { "2014-15": "30374" }, { "2015-16": "17840" }, { "2016-17": "23366" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "8535" }, { "2013-14": "10449" }, { "2014-15": "11479" }, { "2015-16": "15066" }], "BE": [{ "2013-14": "12416" }, { "2014-15": "13089" }, { "2015-16": "16392" }, { "2016-17": "24931" }, { "2016-17": "24931" }, { "2017-18": "26376" }], "RE": [{ "2013-14": "12381" }, { "2014-15": "13594" }, { "2015-16": "21283" }, { "2016-17": "22532" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "14798" }, { "2013-14": "38928" }, { "2014-15": "45939" }, { "2015-16": "38233" }], "BE": [{ "2013-14": "25113" }, { "2014-15": "43793" }, { "2015-16": "44903" }, { "2016-17": "49970" }, { "2016-17": "49970" }, { "2017-18": "56764" }], "RE": [{ "2013-14": "27528" }, { "2014-15": "49491" }, { "2015-16": "48813" }, { "2016-17": "61579" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "546" }, { "2013-14": "653" }, { "2014-15": "747" }, { "2015-16": "856" }], "BE": [{ "2013-14": "654" }, { "2014-15": "741" }, { "2015-16": "1029" }, { "2016-17": "1368" }, { "2016-17": "1368" }, { "2017-18": "1406" }], "RE": [{ "2013-14": "654" }, { "2014-15": "741" }, { "2015-16": "1067" }, { "2016-17": "1368" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "450" }, { "2013-14": "1156" }, { "2014-15": "1415" }, { "2015-16": "589" }], "BE": [{ "2013-14": "413" }, { "2014-15": "517" }, { "2015-16": "430" }, { "2016-17": "393" }, { "2016-17": "393" }, { "2017-18": "630" }], "RE": [{ "2013-14": "788" }, { "2014-15": "1423" }, { "2015-16": "684" }, { "2016-17": "393" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "2731" }, { "2013-14": "" }, { "2014-15": "2416" }, { "2015-16": "3546" }], "BE": [{ "2013-14": "2687" }, { "2014-15": "2590" }, { "2015-16": "3150" }, { "2016-17": "3302" }, { "2016-17": "3302" }, { "2017-18": "5800" }], "RE": [{ "2013-14": "2038" }, { "2014-15": "591" }, { "2015-16": "3067" }, { "2016-17": "5386" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "2022" }, { "2013-14": "2547" }, { "2014-15": "7738" }, { "2015-16": "10018" }], "BE": [{ "2013-14": "7045" }, { "2014-15": "10936" }, { "2015-16": "12241" }, { "2016-17": "14855" }, { "2016-17": "14855" }, { "2017-18": "17133" }], "RE": [{ "2013-14": "6422" }, { "2014-15": "11851" }, { "2015-16": "11451" }, { "2016-17": "12532" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "12991" }, { "2013-14": "24253" }, { "2014-15": "31361" }, { "2015-16": "38646" }], "BE": [{ "2013-14": "13346" }, { "2014-15": "26858" }, { "2015-16": "31856" }, { "2016-17": "35414" }, { "2016-17": "35414" }, { "2017-18": "45435" }], "RE": [{ "2013-14": "14362" }, { "2014-15": "29853" }, { "2015-16": "31660" }, { "2016-17": "84031" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "14273" }, { "2013-14": "19680" }, { "2014-15": "25303" }, { "2015-16": "29909" }], "BE": [{ "2013-14": "17988" }, { "2014-15": "22151" }, { "2015-16": "26526" }, { "2016-17": "27956" }, { "2016-17": "27956" }, { "2017-18": "36654" }], "RE": [{ "2013-14": "22596" }, { "2014-15": "29546" }, { "2015-16": "30685" }, { "2016-17": "32090" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "198" }, { "2013-14": "297" }, { "2014-15": "413" }, { "2015-16": "656" }], "BE": [{ "2013-14": "389" }, { "2014-15": "457" }, { "2015-16": "701" }, { "2016-17": "841" }, { "2016-17": "841" }, { "2017-18": "882" }], "RE": [{ "2013-14": "389" }, { "2014-15": "457" }, { "2015-16": "745" }, { "2016-17": "805" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "25435" }, { "2014-15": "73840" }, { "2015-16": "36750" }], "BE": [{ "2013-14": "" }, { "2014-15": "31205" }, { "2015-16": "36871" }, { "2016-17": "48085" }, { "2016-17": "48085" }, { "2017-18": "71938" }], "RE": [{ "2013-14": "" }, { "2014-15": "32430" }, { "2015-16": "37680" }, { "2016-17": "71938" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "11431" }, { "2015-16": "21683" }], "BE": [{ "2013-14": "" }, { "2014-15": "18008" }, { "2015-16": "21555" }, { "2016-17": "29505" }, { "2016-17": "29505" }, { "2017-18": "36237" }], "RE": [{ "2013-14": "" }, { "2014-15": "18008" }, { "2015-16": "20850" }, { "2016-17": "25583" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "1069" }, { "2013-14": "1107" }, { "2014-15": "838" }, { "2015-16": "1461" }], "BE": [{ "2013-14": "882" }, { "2014-15": "1255" }, { "2015-16": "1735" }, { "2016-17": "1572" }, { "2016-17": "1572" }, { "2017-18": "1606" }], "RE": [{ "2013-14": "1105" }, { "2014-15": "1240" }, { "2015-16": "1372" }, { "2016-17": "1573" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "16239" }, { "2013-14": "15490" }, { "2014-15": "35783" }, { "2015-16": "75239" }], "BE": [{ "2013-14": "38172" }, { "2014-15": "44154" }, { "2015-16": "46843" }, { "2016-17": "58565" }, { "2016-17": "58565" }, { "2017-18": "57793" }], "RE": [{ "2013-14": "27474" }, { "2014-15": "34704" }, { "2015-16": "78194" }, { "2016-17": "64340" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "3411" }, { "2013-14": "4274" }, { "2014-15": "4935" }, { "2015-16": "7026" }], "BE": [{ "2013-14": "5985" }, { "2014-15": "5351" }, { "2015-16": "6532" }, { "2016-17": "7636" }, { "2016-17": "7636" }, { "2017-18": "8263" }], "RE": [{ "2013-14": "6040" }, { "2014-15": "5351" }, { "2015-16": "7032" }, { "2016-17": "7311" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "28259" }, { "2013-14": "35204" }, { "2014-15": "36225" }, { "2015-16": "32251" }], "BE": [{ "2013-14": "22396" }, { "2014-15": "24033" }, { "2015-16": "25270" }, { "2016-17": "30511" }, { "2016-17": "30511" }, { "2017-18": "39647" }], "RE": [{ "2013-14": "30714" }, { "2014-15": "33201" }, { "2015-16": "35870" }, { "2016-17": "36815" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "own_tax_revenue_state_tax_revenue", "record_name": "Own Tax Revenue / State Tax Revenue", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "59875" }, { "2013-14": "64124" }, { "2014-15": "42569" }, { "2015-16": "39922" }], "BE": [{ "2013-14": "72443" }, { "2014-15": "37398" }, { "2015-16": "44423" }, { "2016-17": "52318" }, { "2016-17": "52318" }, { "2017-18": "53717" }], "RE": [{ "2013-14": "72443" }, { "2014-15": "38475" }, { "2015-16": "44423" }, { "2016-17": "49282" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "8257" }, { "2013-14": "8995" }, { "2014-15": "12271" }, { "2015-16": "10120" }], "BE": [{ "2013-14": "7579" }, { "2014-15": "11345" }, { "2015-16": "16195" }, { "2016-2017": "19857" }, { "2016-17": "15634" }, { "2017-18": "16496" }], "RE": [{ "2013-14": "8976" }, { "2014-15": "10752" }, { "2015-16": "15203" }, { "2016-17": "12633" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "16253" }, { "2013-14": "19961" }, { "2014-15": "20750" }, { "2015-16": "25449" }], "BE": [{ "2013-14": "20963" }, { "2014-15": "25663" }, { "2015-16": "30875" }, { "2016-17": "58360" }, { "2016-17": "29730" }, { "2017-18": "32001" }], "RE": [{ "2013-14": "21155" }, { "2014-15": "25663" }, { "2015-16": "25656" }, { "2016-17": "27897" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "13034" }, { "2013-14": "14343" }, { "2014-15": "15707" }, { "2015-16": "17075" }], "BE": [{ "2013-14": "15300" }, { "2014-15": "17926" }, { "2015-16": "20086" }, { "2016-17": "21964" }, { "2016-17": "21964" }, { "2017-18": "23421" }], "RE": [{ "2013-14": "15625" }, { "2014-15": "18127" }, { "2015-16": "21559" }, { "2016-17": "22734" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }], "BE": [{ "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }, { "2016-17": "" }, { "2016-17": "" }, { "2017-18": "" }], "RE": [{ "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }, { "2016-17": "" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "53880" }, { "2013-14": "56150" }, { "2014-15": "61109" }, { "2015-16": "62661" }], "BE": [{ "2013-14": "60208" }, { "2014-15": "62808" }, { "2015-16": "68116" }, { "2016-17": "71370" }, { "2016-17": "71370" }, { "2017-18": "76553" }], "RE": [{ "2013-14": "60208" }, { "2014-15": "61847" }, { "2015-16": "63049" }, { "2016-17": "64759" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "23559" }, { "2013-14": "25567" }, { "2014-15": "27635" }, { "2015-16": "30933" }], "BE": [{ "2013-14": "28784" }, { "2014-15": "30375" }, { "2015-16": "33249" }, { "2016-17": "40200" }, { "2016-17": "30933" }, { "2017-18": "30933" }], "RE": [{ "2013-14": "26589" }, { "2014-15": "29603" }, { "2015-16": "34940" }, { "2016-17": "30933" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "4626" }, { "2013-14": "5121" }, { "2014-15": "5940" }, { "2015-16": "6699" }], "BE": [{ "2013-14": "5373" }, { "2014-15": "5338" }, { "2015-16": "6341" }, { "2016-17": "7469" }, { "2016-17": "7469" }, { "2017-18": "7946" }], "RE": [{ "2013-14": "4847" }, { "2014-15": "5698" }, { "2015-16": "6396" }, { "2016-17": "7217" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "5833" }, { "2013-14": "6273" }, { "2014-15": "6334" }, { "2015-16": "7326" }], "BE": [{ "2013-14": "6700" }, { "2014-15": "7496" }, { "2015-16": "8006" }, { "2016-17": "9220" }, { "2016-17": "9220" }, { "2017-18": "9931" }], "RE": [{ "2013-14": "6820" }, { "2014-15": "6438" }, { "2015-16": "7988" }, { "2016-17": "8442" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "8180" }, { "2013-14": "9380" }, { "2014-15": "10350" }, { "2015-16": "11479" }], "BE": [{ "2013-14": "10152" }, { "2014-15": "11813" }, { "2015-16": "14701" }, { "2016-17": "17050" }, { "2016-17": "17050" }, { "2017-18": "19901" }], "RE": [{ "2013-14": "10152" }, { "2014-15": "13314" }, { "2015-16": "14246" }, { "2016-17": "16750" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "53754" }, { "2013-14": "62604" }, { "2014-15": "70180" }, { "2015-16": "75550" }], "BE": [{ "2013-14": "62464" }, { "2014-15": "69870" }, { "2015-16": "76445" }, { "2016-17": "83864" }, { "2016-17": "83864" }, { "2017-18": "89957" }], "RE": [{ "2013-14": "61530" }, { "2014-15": "68554" }, { "2015-16": "75568" }, { "2016-17": "82211" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "30077" }, { "2013-14": "31995" }, { "2014-15": "35232.5" }, { "2015-16": "38995" }], "BE": [{ "2013-14": "38771" }, { "2014-15": "42467" }, { "2015-16": "45428" }, { "2016-17": "47614" }, { "2016-17": "47614" }, { "2017-18": "53411" }], "RE": [{ "2013-14": "35543" }, { "2014-15": "38285" }, { "2015-16": "39882" }, { "2016-17": "44548" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "30582" }, { "2013-14": "33552" }, { "2014-15": "36567" }, { "2015-16": "40240" }], "BE": [{ "2013-14": "33382" }, { "2014-15": "38990" }, { "2015-16": "43448" }, { "2016-17": "46500" }, { "2016-17": "46500" }, { "2017-18": "50295" }], "RE": [{ "2013-14": "33929" }, { "2014-15": "39190" }, { "2015-16": "40910" }, { "2016-17": "44135" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "103448" }, { "2013-14": "108641" }, { "2014-15": "115090" }, { "2015-16": "126628" }], "BE": [{ "2013-14": "107285" }, { "2014-15": "118640" }, { "2015-16": "130635" }, { "2016-17": "144222" }, { "2016-17": "144222" }, { "2017-18": "153437" }], "RE": [{ "2013-14": "110374" }, { "2014-15": "119008" }, { "2015-16": "130535" }, { "2016-17": "137230" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "848" }, { "2013-14": "949" }, { "2014-15": "939" }, { "2015-16": "1058" }], "BE": [{ "2013-14": "855" }, { "2014-15": "1206" }, { "2015-16": "1036" }, { "2016-17": "1269" }, { "2016-17": "1269" }, { "2017-18": "1559" }], "RE": [{ "2013-14": "855" }, { "2014-15": "1206" }, { "2015-16": "1036" }, { "2016-17": "1269" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "223" }, { "2013-14": "230" }, { "2014-15": "267" }, { "2015-16": "358" }], "BE": [{ "2013-14": "222" }, { "2014-15": "270" }, { "2015-16": "327" }, { "2016-17": "331" }, { "2016-17": "331" }, { "2017-18": "398" }], "RE": [{ "2013-14": "235" }, { "2014-15": "267" }, { "2015-16": "311" }, { "2016-17": "366" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "340" }, { "2013-14": "333" }, { "2014-15": "389" }, { "2015-16": "427" }], "BE": [{ "2013-14": "332" }, { "2014-15": "387" }, { "2015-16": "434" }, { "2016-17": "515" }, { "2016-17": "515" }, { "2017-18": "516" }], "RE": [{ "2013-14": "347" }, { "2014-15": "360" }, { "2015-16": "445" }, { "2016-17": "480" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "15034" }, { "2013-14": "16892" }, { "2014-15": "19828" }, { "2015-16": "22527" }], "BE": [{ "2013-14": "17605" }, { "2014-15": "19863" }, { "2015-16": "21280" }, { "2016-17": "23200" }, { "2016-17": "23200" }, { "2017-18": "26800" }], "RE": [{ "2013-14": "17105" }, { "2014-15": "19274" }, { "2015-16": "21700" }, { "2016-17": "23200" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "22588" }, { "2013-14": "24079" }, { "2014-15": "25570" }, { "2015-16": "26689" }], "BE": [{ "2013-14": "28524" }, { "2014-15": "28480" }, { "2015-16": "29352" }, { "2016-17": "30547" }, { "2016-17": "30547" }, { "2017-18": "39526" }], "RE": [{ "2013-14": "26404" }, { "2014-15": "28561" }, { "2015-16": "28515" }, { "2016-17": "30252" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "30503" }, { "2013-14": "33478" }, { "2014-15": "38673" }, { "2015-16": "42713" }], "BE": [{ "2013-14": "34053" }, { "2014-15": "40655" }, { "2015-16": "47096" }, { "2016-17": "53300" }, { "2016-17": "53300" }, { "2017-18": "54569" }], "RE": [{ "2013-14": "34452" }, { "2014-15": "39787" }, { "2015-16": "45670" }, { "2016-17": "46986" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "435" }, { "2013-14": "525" }, { "2014-15": "520" }, { "2015-16": "560" }], "BE": [{ "2013-14": "426" }, { "2014-15": "497" }, { "2015-16": "552" }, { "2016-17": "637" }, { "2016-17": "637" }, { "2017-18": "659" }], "RE": [{ "2013-14": "449" }, { "2014-15": "514" }, { "2015-16": "584" }, { "2016-17": "621" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "71254" }, { "2013-14": "73718" }, { "2014-15": "78657" }, { "2015-16": "80476" }], "BE": [{ "2013-14": "" }, { "2014-15": "91835" }, { "2015-16": "96083" }, { "2016-17": "90692" }, { "2016-17": "90692" }, { "2017-18": "99590" }], "RE": [{ "2013-14": "" }, { "2014-15": "85773" }, { "2015-16": "86538" }, { "2016-17": "87287" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "29288" }, { "2015-16": "39975" }], "BE": [{ "2013-14": "" }, { "2014-15": "35378" }, { "2015-16": "46495" }, { "2016-17": "54870" }, { "2016-17": "54870" }, { "2017-18": "62619" }], "RE": [{ "2013-14": "" }, { "2014-15": "35378" }, { "2015-16": "43535" }, { "2016-17": "50126" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "1005" }, { "2013-14": "1074" }, { "2014-15": "1174" }, { "2015-16": "1332" }], "BE": [{ "2013-14": "1184" }, { "2014-15": "1278" }, { "2015-16": "1320" }, { "2016-17": "1440" }, { "2016-17": "1440" }, { "2017-18": "1450" }], "RE": [{ "2013-14": "1257" }, { "2014-15": "1241" }, { "2015-16": "132240" }, { "2016-17": "1410" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "58098" }, { "2013-14": "66582" }, { "2014-15": "74173" }, { "2015-16": "81106" }], "BE": [{ "2013-14": "72193" }, { "2014-15": "81000" }, { "2015-16": "91915" }, { "2016-17": "101257" }, { "2016-17": "101257" }, { "2017-18": "111502" }], "RE": [{ "2013-14": "691000" }, { "2014-15": "75975" }, { "2015-16": "86400" }, { "2016-17": "90219" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "6414" }, { "2013-14": "7355" }, { "2014-15": "8338" }, { "2015-16": "9382" }], "BE": [{ "2013-14": "7111" }, { "2014-15": "7355" }, { "2015-16": "9463" }, { "2016-17": "12117" }, { "2016-17": "12117" }, { "2017-18": "13780" }], "RE": [{ "2013-14": "7289" }, { "2014-15": "7355" }, { "2015-16": "9653" }, { "2016-17": "10867" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "32809" }, { "2013-14": "35831" }, { "2014-15": "39412" }, { "2015-16": "42492" }], "BE": [{ "2013-14": "39784" }, { "2014-15": "45414" }, { "2015-16": "46497" }, { "2016-17": "50774" }, { "2016-17": "50774" }, { "2017-18": "55787" }], "RE": [{ "2013-14": "39100" }, { "2014-15": "40062" }, { "2015-16": "42920" }, { "2016-17": "48927" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "share_in_central_taxes", "record_name": "Share in Central Taxes", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "20271" }, { "2013-14": "22132" }, { "2014-15": "15349" }, { "2015-16": "21879" }], "BE": [{ "2013-14": "24132" }, { "2014-15": "16839" }, { "2015-16": "22638" }, { "2016-17": "24637" }, { "2016-17": "24637" }, { "2017-18": "29139" }], "RE": [{ "2013-14": "24132" }, { "2014-15": "16839" }, { "2015-16": "21894" }, { "2016-17": "26264" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "10595" }, { "2013-14": "11575" }, { "2014-15": "9463" }, { "2015-16": "16771" }], "BE": [{ "2013-14": "11438" }, { "2014-15": "14105" }, { "2015-16": "13365" }, { "2016-2017": "14715" }, { "2016-17": "18938" }, { "2017-18": "25589" }], "RE": [{ "2013-14": "12611" }, { "2014-15": "13889" }, { "2015-16": "13423" }, { "2016-17": "18938" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "31900" }, { "2013-14": "34829" }, { "2014-15": "36963" }, { "2015-16": "48923" }], "BE": [{ "2013-14": "37981" }, { "2014-15": "41775" }, { "2015-16": "50748" }, { "2016-17": "58360" }, { "2016-17": "58360" }, { "2017-18": "65326" }], "RE": [{ "2013-14": "37977" }, { "2014-15": "38082" }, { "2015-16": "50748" }, { "2016-17": "58881" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "7218" }, { "2013-14": "7880" }, { "2014-15": "8363" }, { "2015-16": "15716" }], "BE": [{ "2013-14": "8593" }, { "2014-15": "9881" }, { "2015-16": "16213" }, { "2016-17": "18650" }, { "2016-17": "18650" }, { "2017-18": "20868" }], "RE": [{ "2013-14": "8593" }, { "2014-15": "9467" }, { "2015-16": "16213" }, { "2016-17": "18809" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }], "BE": [{ "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }, { "2016-17": "" }, { "2016-17": "" }, { "2017-18": "" }], "RE": [{ "2013-14": "" }, { "2014-15": "" }, { "2015-16": "" }, { "2016-17": "" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "8886" }, { "2013-14": "9924" }, { "2014-15": "10527" }, { "2015-16": "15679" }], "BE": [{ "2013-14": "10120" }, { "2014-15": "11897" }, { "2015-16": "13300" }, { "2016-17": "18520" }, { "2016-17": "18520" }, { "2017-18": "20897" }], "RE": [{ "2013-14": "10579" }, { "2014-15": "11220" }, { "2015-16": "16483" }, { "2016-17": "18835" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "3062" }, { "2013-14": "3343" }, { "2014-15": "3548" }, { "2015-16": "5492" }], "BE": [{ "2013-14": "3484" }, { "2014-15": "4010" }, { "2015-16": "5680" }, { "2016-17": "6189" }, { "2016-17": "6189" }, { "2017-18": "8372" }], "RE": [{ "2013-14": "3645" }, { "2014-15": "3800" }, { "2015-16": "5496" }, { "2016-17": "7246" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "2282" }, { "2013-14": "2492" }, { "2014-15": "2644" }, { "2015-16": "3608" }], "BE": [{ "2013-14": "2717" }, { "2014-15": "3364" }, { "2015-16": "3844" }, { "2016-17": "4334" }, { "2016-17": "4334" }, { "2017-18": "4819" }], "RE": [{ "2013-14": "3017" }, { "2014-15": "3364" }, { "2015-16": "3844" }, { "2016-17": "4334" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "870" }, { "2013-14": "4142" }, { "2014-15": "4477" }, { "2015-16": "7813" }], "BE": [{ "2013-14": "4485" }, { "2014-15": "5191" }, { "2015-16": "8088" }, { "2016-17": "9500" }, { "2016-17": "9500" }, { "2017-18": "9711" }], "RE": [{ "2013-14": "4514" }, { "2014-15": "4477" }, { "2015-16": "8088" }, { "2016-17": "9500" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "8232" }, { "2013-14": "8939" }, { "2014-15": "9487" }, { "2015-16": "15969" }], "BE": [{ "2013-14": "9353" }, { "2014-15": "10879" }, { "2015-16": "12000" }, { "2016-17": "18479" }, { "2016-17": "18479" }, { "2017-18": "21034" }], "RE": [{ "2013-14": "9353" }, { "2014-15": "9885" }, { "2015-16": "16499" }, { "2016-17": "18236" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "12647" }, { "2013-14": "13808" }, { "2014-15": "14654" }, { "2015-16": "23983" }], "BE": [{ "2013-14": "15056" }, { "2014-15": "16560" }, { "2015-16": "24790" }, { "2016-17": "26979" }, { "2016-17": "26979" }, { "2017-18": "31908" }], "RE": [{ "2013-14": "13975" }, { "2014-15": "15410" }, { "2015-16": "23983" }, { "2016-17": "28760" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "6841" }, { "2013-14": "7469" }, { "2014-15": "7926.29" }, { "2015-16": "12691" }], "BE": [{ "2013-14": "8144" }, { "2014-15": "9365" }, { "2015-16": "13122" }, { "2016-17": "14282" }, { "2016-17": "14282" }, { "2017-18": "16892" }], "RE": [{ "2013-14": "8144" }, { "2014-15": "7926" }, { "2015-16": "13122" }, { "2016-17": "15225" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "20805" }, { "2013-14": "22715" }, { "2014-15": "24107" }, { "2015-16": "38371" }], "BE": [{ "2013-14": "23694" }, { "2014-15": "27681" }, { "2015-16": "30450" }, { "2016-17": "43676" }, { "2016-17": "43676" }, { "2017-18": "51106" }], "RE": [{ "2013-14": "22715" }, { "2014-15": "27289" }, { "2015-16": "39706" }, { "2016-17": "46064" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "15192" }, { "2013-14": "16588" }, { "2014-15": "17604" }, { "2015-16": "28086" }], "BE": [{ "2013-14": "18086" }, { "2014-15": "20213" }, { "2015-16": "29062" }, { "2016-17": "31627" }, { "2016-17": "31627" }, { "2017-18": "37405" }], "RE": [{ "2013-14": "16587" }, { "2014-15": "17607" }, { "2015-16": "28106" }, { "2016-17": "33715" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "1192" }, { "2013-14": "1302" }, { "2014-15": "1382" }, { "2015-16": "3275" }], "BE": [{ "2013-14": "1420" }, { "2014-15": "1587" }, { "2015-16": "3371" }, { "2016-17": "3669" }, { "2016-17": "3669" }, { "2017-18": "4339" }], "RE": [{ "2013-14": "1420" }, { "2014-15": "1587" }, { "2015-16": "3371" }, { "2016-17": "3669" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "786" }, { "2013-14": "858" }, { "2014-15": "911" }, { "2015-16": "2348" }], "BE": [{ "2013-14": "936" }, { "2014-15": "1031" }, { "2015-16": "2414" }, { "2016-17": "2627" }, { "2016-17": "2627" }, { "2017-18": "3107" }], "RE": [{ "2013-14": "858" }, { "2014-15": "911" }, { "2015-16": "2371" }, { "2016-17": "2801" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "917" }, { "2013-14": "1001" }, { "2014-15": "1063" }, { "2015-16": "2541" }], "BE": [{ "2013-14": "1092" }, { "2014-15": "1203" }, { "2015-16": "2411" }, { "2016-17": "3016" }, { "2016-17": "3016" }, { "2017-18": "3200" }], "RE": [{ "2013-14": "1001" }, { "2014-15": "1063" }, { "2015-16": "2541" }, { "2016-17": "3033" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "13965" }, { "2013-14": "15247" }, { "2014-15": "16181" }, { "2015-16": "23574" }], "BE": [{ "2013-14": "15904" }, { "2014-15": "18289" }, { "2015-16": "19580" }, { "2016-17": "26568" }, { "2016-17": "26568" }, { "2017-18": "31422" }], "RE": [{ "2013-14": "15904" }, { "2014-15": "17480" }, { "2015-16": "23574" }, { "2016-17": "28321" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "4059" }, { "2013-14": "4431" }, { "2014-15": "4703" }, { "2015-16": "8004" }], "BE": [{ "2013-14": "4832" }, { "2014-15": "5400" }, { "2015-16": "7998" }, { "2016-17": "9005" }, { "2016-17": "9005" }, { "2017-18": "10651" }], "RE": [{ "2013-14": "4516" }, { "2014-15": "5400" }, { "2015-16": "8009" }, { "2016-17": "9600" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "17103" }, { "2013-14": "18673" }, { "2014-15": "19817" }, { "2015-16": "27916" }], "BE": [{ "2013-14": "20361" }, { "2014-15": "22756" }, { "2015-16": "28925" }, { "2016-17": "31478" }, { "2016-17": "31478" }, { "2017-18": "37229" }], "RE": [{ "2013-14": "19155" }, { "2014-15": "19817" }, { "2015-16": "27916" }, { "2016-17": "33556" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "698" }, { "2013-14": "763" }, { "2014-15": "817" }, { "2015-16": "1877" }], "BE": [{ "2013-14": "832" }, { "2014-15": "956" }, { "2015-16": "1933" }, { "2016-17": "2104" }, { "2016-17": "2104" }, { "2017-18": "2488" }], "RE": [{ "2013-14": "832" }, { "2014-15": "916" }, { "2015-16": "1879" }, { "2016-17": "2241" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "14520" }, { "2013-14": "15853" }, { "2014-15": "16824" }, { "2015-16": "20354" }], "BE": [{ "2013-14": "" }, { "2014-15": "19014" }, { "2015-16": "21150" }, { "2016-17": "23018" }, { "2016-17": "23018" }, { "2017-18": "27224" }], "RE": [{ "2013-14": "" }, { "2014-15": "16824" }, { "2015-16": "21150" }, { "2016-17": "24538" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "8189" }, { "2015-16": "12351" }], "BE": [{ "2013-14": "" }, { "2014-15": "9749" }, { "2015-16": "12823" }, { "2016-17": "13955" }, { "2016-17": "13955" }, { "2017-18": "17005" }], "RE": [{ "2013-14": "" }, { "2014-15": "9759" }, { "2015-16": "12596" }, { "2016-17": "14877" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "1493" }, { "2013-14": "1630" }, { "2014-15": "1730" }, { "2015-16": "3266" }], "BE": [{ "2013-14": "1777" }, { "2014-15": "1835" }, { "2015-16": "1890" }, { "2016-17": "4299" }, { "2016-17": "4299" }, { "2017-18": "4500" }], "RE": [{ "2013-14": "1775" }, { "2014-15": "1800" }, { "2015-16": "3437" }, { "2016-17": "4100" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "57498" }, { "2013-14": "62777" }, { "2014-15": "66622" }, { "2015-16": "90974" }], "BE": [{ "2013-14": "68458" }, { "2014-15": "76502" }, { "2015-16": "86729" }, { "2016-17": "105637" }, { "2016-17": "105637" }, { "2017-18": "121407" }], "RE": [{ "2013-14": "63458" }, { "2014-15": "75417" }, { "2015-16": "94313" }, { "2016-17": "102650" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "3273" }, { "2013-14": "3573" }, { "2014-15": "3792" }, { "2015-16": "5329" }], "BE": [{ "2013-14": "3896" }, { "2014-15": "4134" }, { "2015-16": "5526" }, { "2016-17": "6014" }, { "2016-17": "6014" }, { "2017-18": "7113" }], "RE": [{ "2013-14": "3896" }, { "2014-15": "4134" }, { "2015-16": "5428" }, { "2016-17": "6412" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "21226" }, { "2013-14": "23175" }, { "2014-15": "24595" }, { "2015-16": "37164" }], "BE": [{ "2013-14": "25270" }, { "2014-15": "27797" }, { "2015-16": "31966" }, { "2016-17": "41861" }, { "2016-17": "41861" }, { "2017-18": "49510" }], "RE": [{ "2013-14": "24195" }, { "2014-15": "28242" }, { "2015-16": "37164" }, { "2016-17": "44625" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "total_tax_revenue", "record_name": "Total Tax Revenue", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "80146" }, { "2013-14": "86255" }, { "2014-15": "57918" }, { "2015-16": "61800" }], "BE": [{ "2013-14": "96575" }, { "2014-15": "54236" }, { "2015-16": "67061" }, { "2016-17": "76955" }, { "2016-17": "76955" }, { "2017-18": "82856" }], "RE": [{ "2013-14": "96575" }, { "2014-15": "55314" }, { "2015-16": "66317" }, { "2016-17": "75546" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "18851" }, { "2013-14": "20569" }, { "2014-15": "21734" }, { "2015-16": "26891" }], "BE": [{ "2013-14": "19018" }, { "2014-15": "25451" }, { "2015-16": "29560" }, { "2016-2017": "34573" }, { "2016-17": "34573" }, { "2017-18": "42086" }], "RE": [{ "2013-14": "21587" }, { "2014-15": "24641" }, { "2015-16": "28627" }, { "2016-17": "31571" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "48154" }, { "2013-14": "54790" }, { "2014-15": "57713" }, { "2015-16": "74372" }], "BE": [{ "2013-14": "58944" }, { "2014-15": "67438" }, { "2015-16": "81623" }, { "2016-17": "116719" }, { "2016-17": "88090" }, { "2017-18": "97327" }], "RE": [{ "2013-14": "59132" }, { "2014-15": "63745" }, { "2015-16": "76403" }, { "2016-17": "86777" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "20252" }, { "2013-14": "22223" }, { "2014-15": "24070" }, { "2015-16": "32791" }], "BE": [{ "2013-14": "23894" }, { "2014-15": "27808" }, { "2015-16": "36299" }, { "2016-17": "40614" }, { "2016-17": "40614" }, { "2017-18": "44289" }], "RE": [{ "2013-14": "24218" }, { "2014-15": "27594" }, { "2015-16": "37772" }, { "2016-17": "41543" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "23432" }, { "2013-14": "25919" }, { "2014-15": "26604" }, { "2015-16": "30225" }], "BE": [{ "2013-14": "30454" }, { "2014-15": "31571" }, { "2015-16": "34661" }, { "2016-17": "36525" }, { "2016-17": "36525" }, { "2017-18": "38700" }], "RE": [{ "2013-14": "27075" }, { "2014-15": "27670" }, { "2015-16": "31370" }, { "2016-17": "32430" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "62766" }, { "2013-14": "66074" }, { "2014-15": "71636" }, { "2015-16": "78340" }], "BE": [{ "2013-14": "70328" }, { "2014-15": "74704" }, { "2015-16": "81416" }, { "2016-17": "89890" }, { "2016-17": "89890" }, { "2017-18": "97451" }], "RE": [{ "2013-14": "70787" }, { "2014-15": "73067" }, { "2015-16": "79533" }, { "2016-17": "83595" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "26621" }, { "2013-14": "28910" }, { "2014-15": "31183" }, { "2015-16": "36425" }], "BE": [{ "2013-14": "32268" }, { "2014-15": "34385" }, { "2015-16": "38929" }, { "2016-17": "46388" }, { "2016-17": "46388" }, { "2017-18": "51712" }], "RE": [{ "2013-14": "30235" }, { "2014-15": "33403" }, { "2015-16": "40436" }, { "2016-17": "45088" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "6908" }, { "2013-14": "7612" }, { "2014-15": "8584" }, { "2015-16": "10307" }], "BE": [{ "2013-14": "8090" }, { "2014-15": "8702" }, { "2015-16": "10185" }, { "2016-17": "11803" }, { "2016-17": "11803" }, { "2017-18": "12765" }], "RE": [{ "2013-14": "7864" }, { "2014-15": "9062" }, { "2015-16": "10239" }, { "2016-17": "11551" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "6703" }, { "2013-14": "10415" }, { "2014-15": "10811" }, { "2015-16": "15139" }], "BE": [{ "2013-14": "11185" }, { "2014-15": "12687" }, { "2015-16": "16094" }, { "2016-17": "18720" }, { "2016-17": "18720" }, { "2017-18": "19642" }], "RE": [{ "2013-14": "11334" }, { "2014-15": "10915" }, { "2015-16": "16076" }, { "2016-17": "17942" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "16412" }, { "2013-14": "18319" }, { "2014-15": "19837" }, { "2015-16": "27448" }], "BE": [{ "2013-14": "19505" }, { "2014-15": "22691" }, { "2015-16": "26701" }, { "2016-17": "35529" }, { "2016-17": "35529" }, { "2017-18": "40935" }], "RE": [{ "2013-14": "19505" }, { "2014-15": "23199" }, { "2015-16": "30745" }, { "2016-17": "34986" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "66401" }, { "2013-14": "76412" }, { "2014-15": "84834" }, { "2015-16": "99534" }], "BE": [{ "2013-14": "77520" }, { "2014-15": "86430" }, { "2015-16": "101235" }, { "2016-17": "110843" }, { "2016-17": "110843" }, { "2017-18": "121865" }], "RE": [{ "2013-14": "75505" }, { "2014-15": "83964" }, { "2015-16": "99552" }, { "2016-17": "110971" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "36917" }, { "2013-14": "39464" }, { "2014-15": "43158.79" }, { "2015-16": "51686" }], "BE": [{ "2013-14": "46915" }, { "2014-15": "51833" }, { "2015-16": "58550" }, { "2016-17": "61896" }, { "2016-17": "61896" }, { "2017-18": "70303" }], "RE": [{ "2013-14": "43687" }, { "2014-15": "46211" }, { "2015-16": "53003" }, { "2016-17": "59773" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "51387" }, { "2013-14": "56267" }, { "2014-15": "60674" }, { "2015-16": "78611" }], "BE": [{ "2013-14": "57075" }, { "2014-15": "66671" }, { "2015-16": "73897" }, { "2016-17": "90176" }, { "2016-17": "90176" }, { "2017-18": "101402" }], "RE": [{ "2013-14": "56644" }, { "2014-15": "66479" }, { "2015-16": "80616" }, { "2016-17": "90199" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "118641" }, { "2013-14": "125228" }, { "2014-15": "132694" }, { "2015-16": "154714" }], "BE": [{ "2013-14": "125371" }, { "2014-15": "138854" }, { "2015-16": "159697" }, { "2016-17": "175849" }, { "2016-17": "175849" }, { "2017-18": "190842" }], "RE": [{ "2013-14": "126961" }, { "2014-15": "136615" }, { "2015-16": "158641" }, { "2016-17": "170945" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "2040" }, { "2013-14": "2251" }, { "2014-15": "2321" }, { "2015-16": "4333" }], "BE": [{ "2013-14": "2275" }, { "2014-15": "2793" }, { "2015-16": "4406" }, { "2016-17": "4937" }, { "2016-17": "4937" }, { "2017-18": "5898" }], "RE": [{ "2013-14": "2275" }, { "2014-15": "2793" }, { "2015-16": "4406" }, { "2016-17": "4937" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "1009" }, { "2013-14": "1088" }, { "2014-15": "1177" }, { "2015-16": "2707" }], "BE": [{ "2013-14": "1158" }, { "2014-15": "1301" }, { "2015-16": "2740" }, { "2016-17": "2958" }, { "2016-17": "2958" }, { "2017-18": "3505" }], "RE": [{ "2013-14": "1093" }, { "2014-15": "1177" }, { "2015-16": "2682" }, { "2016-17": "3166" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "1257" }, { "2013-14": "" }, { "2014-15": "1451" }, { "2015-16": "2968" }], "BE": [{ "2013-14": "1424" }, { "2014-15": "1590" }, { "2015-16": "2846" }, { "2016-17": "3532" }, { "2016-17": "3532" }, { "2017-18": "3716" }], "RE": [{ "2013-14": "1349" }, { "2014-15": "" }, { "2015-16": "2986" }, { "2016-17": "3512" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "28999" }, { "2013-14": "32139" }, { "2014-15": "36010" }, { "2015-16": "46101" }], "BE": [{ "2013-14": "33509" }, { "2014-15": "38152" }, { "2015-16": "40860" }, { "2016-17": "49768" }, { "2016-17": "49768" }, { "2017-18": "58222" }], "RE": [{ "2013-14": "33009" }, { "2014-15": "36754" }, { "2015-16": "45274" }, { "2016-17": "51521" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "26646" }, { "2013-14": "28511" }, { "2014-15": "30273" }, { "2015-16": "34693" }], "BE": [{ "2013-14": "33356" }, { "2014-15": "33880" }, { "2015-16": "37350" }, { "2016-17": "39552" }, { "2016-17": "39552" }, { "2017-18": "50177" }], "RE": [{ "2013-14": "30920" }, { "2014-15": "33961" }, { "2015-16": "36524" }, { "2016-17": "39852" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "47606" }, { "2013-14": "52151" }, { "2014-15": "58490" }, { "2015-16": "70629" }], "BE": [{ "2013-14": "54414" }, { "2014-15": "63410" }, { "2015-16": "76021" }, { "2016-17": "84778" }, { "2016-17": "84778" }, { "2017-18": "91798" }], "RE": [{ "2013-14": "53608" }, { "2014-15": "59604" }, { "2015-16": "73586" }, { "2016-17": "80542" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "1134" }, { "2013-14": "1288" }, { "2014-15": "1337" }, { "2015-16": "2437" }], "BE": [{ "2013-14": "1257" }, { "2014-15": "1454" }, { "2015-16": "2485" }, { "2016-17": "2741" }, { "2016-17": "2741" }, { "2017-18": "3147" }], "RE": [{ "2013-14": "1281" }, { "2014-15": "1430" }, { "2015-16": "2463" }, { "2016-17": "2862" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "85774" }, { "2013-14": "89571" }, { "2014-15": "95481" }, { "2015-16": "100830" }], "BE": [{ "2013-14": "" }, { "2014-15": "110850" }, { "2015-16": "117233" }, { "2016-17": "113710" }, { "2016-17": "113710" }, { "2017-18": "126814" }], "RE": [{ "2013-14": "" }, { "2014-15": "102597" }, { "2015-16": "107688" }, { "2016-17": "111825" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "37477" }, { "2015-16": "52325" }], "BE": [{ "2013-14": "" }, { "2014-15": "45128" }, { "2015-16": "59318" }, { "2016-17": "68825" }, { "2016-17": "68825" }, { "2017-18": "79624" }], "RE": [{ "2013-14": "" }, { "2014-15": "45138" }, { "2015-16": "56130" }, { "2016-17": "65003" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "2498" }, { "2013-14": "2704" }, { "2014-15": "2904" }, { "2015-16": "4598" }], "BE": [{ "2013-14": "2961" }, { "2014-15": "3113" }, { "2015-16": "3210" }, { "2016-17": "5739" }, { "2016-17": "5739" }, { "2017-18": "5950" }], "RE": [{ "2013-14": "3032" }, { "2014-15": "3041" }, { "2015-16": "135677" }, { "2016-17": "5510" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "115596" }, { "2013-14": "129359" }, { "2014-15": "140795" }, { "2015-16": "172080" }], "BE": [{ "2013-14": "140651" }, { "2014-15": "157502" }, { "2015-16": "178644" }, { "2016-17": "206894" }, { "2016-17": "206894" }, { "2017-18": "232908" }], "RE": [{ "2013-14": "754458" }, { "2014-15": "151391" }, { "2015-16": "180714" }, { "2016-17": "192869" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "9687" }, { "2013-14": "10929" }, { "2014-15": "12131" }, { "2015-16": "14711" }], "BE": [{ "2013-14": "11008" }, { "2014-15": "12157" }, { "2015-16": "14990" }, { "2016-17": "18131" }, { "2016-17": "18131" }, { "2017-18": "20894" }], "RE": [{ "2013-14": "11185" }, { "2014-15": "12330" }, { "2015-16": "15081" }, { "2016-17": "17279" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "54035" }, { "2013-14": "59006" }, { "2014-15": "64007" }, { "2015-16": "79656" }], "BE": [{ "2013-14": "65053" }, { "2014-15": "73211" }, { "2015-16": "78463" }, { "2016-17": "92635" }, { "2016-17": "92635" }, { "2017-18": "105297" }], "RE": [{ "2013-14": "63295" }, { "2014-15": "68304" }, { "2015-16": "80084" }, { "2016-17": "93552" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "own_non_tax_revenue_state_nontax_revenue", "record_name": "Own Non Tax Revenue / State Non-Tax Revenue", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "15999" }, { "2013-14": "15473" }, { "2014-15": "10976" }, { "2015-16": "4920" }], "BE": [{ "2013-14": "15394" }, { "2014-15": "9011" }, { "2015-16": "5341" }, { "2016-17": "5495" }, { "2016-17": "5495" }, { "2017-18": "5092" }], "RE": [{ "2013-14": "15394" }, { "2014-15": "8921" }, { "2015-16": "5341" }, { "2016-17": "4500" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "2474" }, { "2013-14": "2705" }, { "2014-15": "2413" }, { "2015-16": "2742" }], "BE": [{ "2013-14": "3487" }, { "2014-15": "4298" }, { "2015-16": "4326" }, { "2016-2017": "5847" }, { "2016-17": "5847" }, { "2017-18": "7464" }], "RE": [{ "2013-14": "3046" }, { "2014-15": "3003" }, { "2015-16": "2797" }, { "2016-17": "4513" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "1135" }, { "2013-14": "1545" }, { "2014-15": "1558" }, { "2015-16": "2186" }], "BE": [{ "2013-14": "3416" }, { "2014-15": "3082" }, { "2015-16": "3396" }, { "2016-17": "2358" }, { "2016-17": "2358" }, { "2017-18": "2875" }], "RE": [{ "2013-14": "1919" }, { "2014-15": "3097" }, { "2015-16": "1996" }, { "2016-17": "2384" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "4616" }, { "2013-14": "5101" }, { "2014-15": "4875" }, { "2015-16": "5215" }], "BE": [{ "2013-14": "6072" }, { "2014-15": "6185" }, { "2015-16": "8663" }, { "2016-17": "7420" }, { "2016-17": "7420" }, { "2017-18": "7704" }], "RE": [{ "2013-14": "5834" }, { "2014-15": "6319" }, { "2015-16": "8625" }, { "2016-17": "7520" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "627" }, { "2013-14": "659" }, { "2014-15": "633" }, { "2015-16": "515" }], "BE": [{ "2013-14": "913" }, { "2014-15": "1161" }, { "2015-16": "1127" }, { "2016-17": "996" }, { "2016-17": "996" }, { "2017-18": "800" }], "RE": [{ "2013-14": "1088" }, { "2014-15": "964" }, { "2015-16": "569" }, { "2016-17": "456" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "6017" }, { "2013-14": "7018" }, { "2014-15": "9543" }, { "2015-16": "10194" }], "BE": [{ "2013-14": "6380" }, { "2014-15": "9514" }, { "2015-16": "11038" }, { "2016-17": "12428" }, { "2016-17": "12428" }, { "2017-18": "18400" }], "RE": [{ "2013-14": "7113" }, { "2014-15": "9514" }, { "2015-16": "11917" }, { "2016-17": "14378" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "4673" }, { "2013-14": "4975" }, { "2014-15": "4613" }, { "2015-16": "4752" }], "BE": [{ "2013-14": "5162" }, { "2014-15": "5867" }, { "2015-16": "6885" }, { "2016-17": "8308" }, { "2016-17": "8308" }, { "2017-18": "10082" }], "RE": [{ "2013-14": "5066" }, { "2014-15": "5677" }, { "2015-16": "5345" }, { "2016-17": "7338" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "1377" }, { "2013-14": "1785" }, { "2014-15": "2081" }, { "2015-16": "1837" }], "BE": [{ "2013-14": "2393" }, { "2014-15": "1389" }, { "2015-16": "1507" }, { "2016-17": "1669" }, { "2016-17": "1669" }, { "2017-18": "1602" }], "RE": [{ "2013-14": "1408" }, { "2014-15": "1399" }, { "2015-16": "2240" }, { "2016-17": "1511" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "2160" }, { "2013-14": "2870" }, { "2014-15": "1978" }, { "2015-16": "3913" }], "BE": [{ "2013-14": "3033" }, { "2014-15": "3561" }, { "2015-16": "3509" }, { "2016-17": "4019" }, { "2016-17": "4019" }, { "2017-18": "5308" }], "RE": [{ "2013-14": "3400" }, { "2014-15": "3154" }, { "2015-16": "3455" }, { "2016-17": "5224" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "3536" }, { "2013-14": "3753" }, { "2014-15": "4335" }, { "2015-16": "5853" }], "BE": [{ "2013-14": "4167" }, { "2014-15": "4967" }, { "2015-16": "6304" }, { "2016-17": "8426" }, { "2016-17": "8426" }, { "2017-18": "11258" }], "RE": [{ "2013-14": "4344" }, { "2014-15": "5693" }, { "2015-16": "6905" }, { "2016-17": "9802" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "3966" }, { "2013-14": "4032" }, { "2014-15": "4688" }, { "2015-16": "5355" }], "BE": [{ "2013-14": "4038" }, { "2014-15": "4473" }, { "2015-16": "5206" }, { "2016-17": "6220" }, { "2016-17": "6220" }, { "2017-18": "6945" }], "RE": [{ "2013-14": "3859" }, { "2014-15": "4465" }, { "2015-16": "5411" }, { "2016-17": "7099" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "4199" }, { "2013-14": "5575" }, { "2014-15": "7283.69" }, { "2015-16": "8425" }], "BE": [{ "2013-14": "4922" }, { "2014-15": "6337" }, { "2015-16": "8931" }, { "2016-17": "11360" }, { "2016-17": "11360" }, { "2017-18": "12038" }], "RE": [{ "2013-14": "5613" }, { "2014-15": "7883" }, { "2015-16": "8911" }, { "2016-17": "10057" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "7000" }, { "2013-14": "7705" }, { "2014-15": "10375" }, { "2015-16": "8569" }], "BE": [{ "2013-14": "7583" }, { "2014-15": "6759" }, { "2015-16": "10124" }, { "2016-17": "11482" }, { "2016-17": "11482" }, { "2017-18": "11680" }], "RE": [{ "2013-14": "8139" }, { "2014-15": "9598" }, { "2015-16": "9707" }, { "2016-17": "10410" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "9984" }, { "2013-14": "11352" }, { "2014-15": "12581" }, { "2015-16": "13423" }], "BE": [{ "2013-14": "11994" }, { "2014-15": "13509" }, { "2015-16": "20665" }, { "2016-17": "19997" }, { "2016-17": "19997" }, { "2017-18": "20156" }], "RE": [{ "2013-14": "12758" }, { "2014-15": "13520" }, { "2015-16": "14699" }, { "2016-17": "16619" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "485" }, { "2013-14": "598" }, { "2014-15": "343" }, { "2015-16": "229" }], "BE": [{ "2013-14": "517" }, { "2014-15": "679" }, { "2015-16": "312" }, { "2016-17": "466" }, { "2016-17": "466" }, { "2017-18": "513" }], "RE": [{ "2013-14": "517" }, { "2014-15": "679" }, { "2015-16": "312" }, { "2016-17": "466" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "213" }, { "2013-14": "194" }, { "2014-15": "242" }, { "2015-16": "298" }], "BE": [{ "2013-14": "266" }, { "2014-15": "278" }, { "2015-16": "253" }, { "2016-17": "279" }, { "2016-17": "279" }, { "2017-18": "297" }], "RE": [{ "2013-14": "252" }, { "2014-15": "241" }, { "2015-16": "270" }, { "2016-17": "282" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "207" }, { "2013-14": "217" }, { "2014-15": "271" }, { "2015-16": "256" }], "BE": [{ "2013-14": "186" }, { "2014-15": "206" }, { "2015-16": "231" }, { "2016-17": "262" }, { "2016-17": "262" }, { "2017-18": "280" }], "RE": [{ "2013-14": "180" }, { "2014-15": "317" }, { "2015-16": "238" }, { "2016-17": "236" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "8078" }, { "2013-14": "8379" }, { "2014-15": "8071" }, { "2015-16": "8711" }], "BE": [{ "2013-14": "6825" }, { "2014-15": "8024" }, { "2015-16": "9014" }, { "2016-17": "9823" }, { "2016-17": "9823" }, { "2017-18": "9500" }], "RE": [{ "2013-14": "7475" }, { "2014-15": "7605" }, { "2015-16": "9000" }, { "2016-17": "8823" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "2629" }, { "2013-14": "3191" }, { "2014-15": "2880" }, { "2015-16": "2650" }], "BE": [{ "2013-14": "2736" }, { "2014-15": "2783" }, { "2015-16": "3804" }, { "2016-17": "3807" }, { "2016-17": "3807" }, { "2017-18": "3225" }], "RE": [{ "2013-14": "3565" }, { "2014-15": "2973" }, { "2015-16": "4062" }, { "2016-17": "6261" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "12134" }, { "2013-14": "13575" }, { "2014-15": "13229" }, { "2015-16": "10928" }], "BE": [{ "2013-14": "12654" }, { "2014-15": "14939" }, { "2015-16": "15496" }, { "2016-17": "14084" }, { "2016-17": "14084" }, { "2017-18": "14493" }], "RE": [{ "2013-14": "13510" }, { "2014-15": "13468" }, { "2015-16": "11872" }, { "2016-17": "12469" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "302" }, { "2013-14": "794" }, { "2014-15": "698" }, { "2015-16": "413" }], "BE": [{ "2013-14": "318" }, { "2014-15": "1099" }, { "2015-16": "350" }, { "2016-17": "362" }, { "2016-17": "362" }, { "2017-18": "426" }], "RE": [{ "2013-14": "329" }, { "2014-15": "1101" }, { "2015-16": "364" }, { "2016-17": "396" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "6554" }, { "2013-14": "9343" }, { "2014-15": "8351" }, { "2015-16": "8918" }], "BE": [{ "2013-14": "" }, { "2014-15": "8084" }, { "2015-16": "9071" }, { "2016-17": "9724" }, { "2016-17": "9724" }, { "2017-18": "12318" }], "RE": [{ "2013-14": "" }, { "2014-15": "8868" }, { "2015-16": "8931" }, { "2016-17": "11266" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "6447" }, { "2015-16": "14414" }], "BE": [{ "2013-14": "" }, { "2014-15": "13242" }, { "2015-16": "22413" }, { "2016-17": "17542" }, { "2016-17": "17542" }, { "2017-18": "6601" }], "RE": [{ "2013-14": "" }, { "2014-15": "12242" }, { "2015-16": "10722" }, { "2016-17": "8510" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "179" }, { "2013-14": "247" }, { "2014-15": "196" }, { "2015-16": "263" }], "BE": [{ "2013-14": "220" }, { "2014-15": "290" }, { "2015-16": "310" }, { "2016-17": "295" }, { "2016-17": "295" }, { "2017-18": "290" }], "RE": [{ "2013-14": "278" }, { "2014-15": "223" }, { "2015-16": "284" }, { "2016-17": "251" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "12970" }, { "2013-14": "16450" }, { "2014-15": "19935" }, { "2015-16": "31861" }], "BE": [{ "2013-14": "13183" }, { "2014-15": "20232" }, { "2015-16": "21636" }, { "2016-17": "24241" }, { "2016-17": "24241" }, { "2017-18": "18437" }], "RE": [{ "2013-14": "15325" }, { "2014-15": "22968" }, { "2015-16": "22789" }, { "2016-17": "27575" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "1603" }, { "2013-14": "1317" }, { "2014-15": "1110" }, { "2015-16": "1220" }], "BE": [{ "2013-14": "1216" }, { "2014-15": "1807" }, { "2015-16": "2068" }, { "2016-17": "2793" }, { "2016-17": "2793" }, { "2017-18": "2469" }], "RE": [{ "2013-14": "1262" }, { "2014-15": "1812" }, { "2015-16": "2175" }, { "2016-17": "1316" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "1918" }, { "2013-14": "2023" }, { "2014-15": "1627" }, { "2015-16": "1862" }], "BE": [{ "2013-14": "1756" }, { "2014-15": "1990" }, { "2015-16": "2380" }, { "2016-17": "2688" }, { "2016-17": "2688" }, { "2017-18": "2221" }], "RE": [{ "2013-14": "1895" }, { "2014-15": "2202" }, { "2015-16": "2142" }, { "2016-17": "2038" }] }, "grpby_name": "West Bengal" }] }, { "record_slug": "grants_in_aid_from_centre", "record_name": "Grants in aid from Centre", "unit": "INR (in Crores)", "record_figures": [{ "figures": { "A": [{ "2012-13": "7685" }, { "2013-14": "8991" }, { "2014-15": "21779" }, { "2015-16": "21927" }], "BE": [{ "2013-14": "15803" }, { "2014-15": "28831" }, { "2015-16": "17722" }, { "2016-17": "26849" }, { "2016-17": "26849" }, { "2017-18": "37548" }], "RE": [{ "2013-14": "15803" }, { "2014-15": "19831" }, { "2015-16": "17722" }, { "2016-17": "27663" }] }, "grpby_name": "Andhra Pradesh" }, { "figures": { "A": [{ "2012-13": "9366" }, { "2013-14": "8938" }, { "2014-15": "14035" }, { "2015-16": "12825" }], "BE": [{ "2013-14": "15157" }, { "2014-15": "22948" }, { "2015-16": "23179" }, { "2016-2017": "25761" }, { "2016-17": "25761" }, { "2017-18": "21170" }], "RE": [{ "2013-14": "16279" }, { "2014-15": "19696" }, { "2015-16": "12840" }, { "2016-17": "22923" }] }, "grpby_name": "Assam" }, { "figures": { "A": [{ "2012-13": "10278" }, { "2013-14": "12584" }, { "2014-15": "19146" }, { "2015-16": "19566" }], "BE": [{ "2013-14": "17707" }, { "2014-15": "31420" }, { "2015-16": "18171" }, { "2016-17": "34142" }, { "2016-17": "34142" }, { "2017-18": "36956" }], "RE": [{ "2013-14": "17550" }, { "2014-15": "28903" }, { "2015-16": "21785" }, { "2016-17": "38376" }] }, "grpby_name": "Bihar" }, { "figures": { "A": [{ "2012-13": "4710" }, { "2013-14": "4726" }, { "2014-15": "8988" }, { "2015-16": "8062" }], "BE": [{ "2013-14": "7479" }, { "2014-15": "14662" }, { "2015-16": "12994" }, { "2016-17": "13392" }, { "2016-17": "13392" }, { "2017-18": "14101" }], "RE": [{ "2013-14": "7446" }, { "2014-15": "15129" }, { "2015-16": "12416" }, { "2016-17": "13722" }] }, "grpby_name": "Chhattisgarh" }, { "figures": { "A": [{ "2012-13": "1503" }, { "2013-14": "1403" }, { "2014-15": "2348" }, { "2015-16": "4258" }], "BE": [{ "2013-14": "2701" }, { "2014-15": "3672" }, { "2015-16": "2777" }, { "2016-17": "3870" }, { "2016-17": "3870" }, { "2017-18": "2716" }], "RE": [{ "2013-14": "2287" }, { "2014-15": "3506" }, { "2015-16": "3782" }, { "2016-17": "4036" }] }, "grpby_name": "Delhi" }, { "figures": { "A": [{ "2012-13": "6446" }, { "2013-14": "6883" }, { "2014-15": "10799" }, { "2015-16": "8949" }], "BE": [{ "2013-14": "9045" }, { "2014-15": "18835" }, { "2015-16": "16841" }, { "2016-17": "14048" }, { "2016-17": "14048" }, { "2017-18": "15671" }], "RE": [{ "2013-14": "7100" }, { "2014-15": "16404" }, { "2015-16": "12935" }, { "2016-17": "14548" }] }, "grpby_name": "Gujarat" }, { "figures": { "A": [{ "2012-13": "2339" }, { "2013-14": "4127" }, { "2014-15": "5003" }, { "2015-16": "6379" }], "BE": [{ "2013-14": "6350" }, { "2014-15": "7439" }, { "2015-16": "6497" }, { "2016-17": "8259" }, { "2016-17": "8259" }, { "2017-18": "7018" }], "RE": [{ "2013-14": "6335" }, { "2014-15": "6339" }, { "2015-16": "8387" }, { "2016-17": "7902" }] }, "grpby_name": "Haryana" }, { "figures": { "A": [{ "2012-13": "7313" }, { "2013-14": "6314" }, { "2014-15": "7178" }, { "2015-16": "11296" }], "BE": [{ "2013-14": "7218" }, { "2014-15": "6431" }, { "2015-16": "11843" }, { "2016-17": "12799" }, { "2016-17": "12799" }, { "2017-18": "13347" }], "RE": [{ "2013-14": "7392" }, { "2014-15": "8445" }, { "2015-16": "12035" }, { "2016-17": "13615" }] }, "grpby_name": "Himachal Pradesh" }, { "figures": { "A": [{ "2012-13": "14354" }, { "2013-14": "13843" }, { "2014-15": "16149" }, { "2015-16": "16728" }], "BE": [{ "2013-14": "19752" }, { "2014-15": "22973" }, { "2015-16": "18211" }, { "2016-17": "28721" }, { "2016-17": "28721" }, { "2017-18": "33218" }], "RE": [{ "2013-14": "16493" }, { "2014-15": "20472" }, { "2015-16": "21373" }, { "2016-17": "27008" }] }, "grpby_name": "Jammu and Kashmir" }, { "figures": { "A": [{ "2012-13": "4822" }, { "2013-14": "4065" }, { "2014-15": "7393" }, { "2015-16": "7338" }], "BE": [{ "2013-14": "9927" }, { "2014-15": "15785" }, { "2015-16": "15022" }, { "2016-17": "11802" }, { "2016-17": "11802" }, { "2017-18": "13415" }], "RE": [{ "2013-14": "8703" }, { "2014-15": "15012" }, { "2015-16": "11000" }, { "2016-17": "12863" }] }, "grpby_name": "Jharkhand" }, { "figures": { "A": [{ "2012-13": "7809" }, { "2013-14": "9099" }, { "2014-15": "14619" }, { "2015-16": "13929" }], "BE": [{ "2013-14": "16428" }, { "2014-15": "20135" }, { "2015-16": "9919" }, { "2016-17": "13694" }, { "2016-17": "13694" }, { "2017-18": "16082" }], "RE": [{ "2013-14": "14906" }, { "2014-15": "20478" }, { "2015-16": "12768" }, { "2016-17": "14798" }] }, "grpby_name": "Karnataka" }, { "figures": { "A": [{ "2012-13": "3022" }, { "2013-14": "4138" }, { "2014-15": "7507.99" }, { "2015-16": "8921" }], "BE": [{ "2013-14": "6221" }, { "2014-15": "6672" }, { "2015-16": "9946" }, { "2016-17": "11362" }, { "2016-17": "11362" }, { "2017-18": "11244" }], "RE": [{ "2013-14": "5667" }, { "2014-15": "9494" }, { "2015-16": "9105" }, { "2016-17": "10790" }] }, "grpby_name": "Kerala" }, { "figures": { "A": [{ "2012-13": "12040" }, { "2013-14": "11777" }, { "2014-15": "17591" }, { "2015-16": "18330" }], "BE": [{ "2013-14": "14945" }, { "2014-15": "30063" }, { "2015-16": "30401" }, { "2016-17": "24437" }, { "2016-17": "24437" }, { "2017-18": "26034" }], "RE": [{ "2013-14": "15714" }, { "2014-15": "28545" }, { "2015-16": "20808" }, { "2016-17": "25441" }] }, "grpby_name": "Madhya Pradesh" }, { "figures": { "A": [{ "2012-13": "14322" }, { "2013-14": "13241" }, { "2014-15": "20141" }, { "2015-16": "16899" }], "BE": [{ "2013-14": "18622" }, { "2014-15": "27958" }, { "2015-16": "17869" }, { "2016-17": "24964" }, { "2016-17": "24964" }, { "2017-18": "32739" }], "RE": [{ "2013-14": "18691" }, { "2014-15": "30659" }, { "2015-16": "24982" }, { "2016-17": "32447" }] }, "grpby_name": "Maharashtra" }, { "figures": { "A": [{ "2012-13": "3011" }, { "2013-14": "3417" }, { "2014-15": "3764" }, { "2015-16": "2481" }], "BE": [{ "2013-14": "5792" }, { "2014-15": "7655" }, { "2015-16": "3684" }, { "2016-17": "3577" }, { "2016-17": "3577" }, { "2017-18": "4869" }], "RE": [{ "2013-14": "5792" }, { "2014-15": "7655" }, { "2015-16": "3684" }, { "2016-17": "3577" }] }, "grpby_name": "Meghalaya" }, { "figures": { "A": [{ "2012-13": "3315" }, { "2013-14": "3483" }, { "2014-15": "4092" }, { "2015-16": "3672" }], "BE": [{ "2013-14": "3616" }, { "2014-15": "4300" }, { "2015-16": "4182" }, { "2016-17": "4435" }, { "2016-17": "4435" }, { "2017-18": "4371" }], "RE": [{ "2013-14": "4184" }, { "2014-15": "3899" }, { "2015-16": "4584" }, { "2016-17": "4441" }] }, "grpby_name": "Mizoram" }, { "figures": { "A": [{ "2012-13": "4740" }, { "2013-14": "4947" }, { "2014-15": "5929" }, { "2015-16": "4819" }], "BE": [{ "2013-14": "5685" }, { "2014-15": "7743" }, { "2015-16": "5816" }, { "2016-17": "6776" }, { "2016-17": "6776" }, { "2017-18": "6861" }], "RE": [{ "2013-14": "5141" }, { "2014-15": "6348" }, { "2015-16": "5770" }, { "2016-17": "5607" }] }, "grpby_name": "Nagaland" }, { "figures": { "A": [{ "2012-13": "6860" }, { "2013-14": "8429" }, { "2014-15": "12918" }, { "2015-16": "14129" }], "BE": [{ "2013-14": "10965" }, { "2014-15": "20971" }, { "2015-16": "21067" }, { "2016-17": "18536" }, { "2016-17": "18536" }, { "2017-18": "21210" }], "RE": [{ "2013-14": "13326" }, { "2014-15": "19290" }, { "2015-16": "17295" }, { "2016-17": "19639" }] }, "grpby_name": "Odisha" }, { "figures": { "A": [{ "2012-13": "2776" }, { "2013-14": "3401" }, { "2014-15": "5870" }, { "2015-16": "4174" }], "BE": [{ "2013-14": "6574" }, { "2014-15": "8230" }, { "2015-16": "5075" }, { "2016-17": "6821" }, { "2016-17": "6821" }, { "2017-18": "6678" }], "RE": [{ "2013-14": "5366" }, { "2014-15": "5808" }, { "2015-16": "5018" }, { "2016-17": "5260" }] }, "grpby_name": "Punjab" }, { "figures": { "A": [{ "2012-13": "7174" }, { "2013-14": "8744" }, { "2014-15": "19607" }, { "2015-16": "18728" }], "BE": [{ "2013-14": "10152" }, { "2014-15": "27776" }, { "2015-16": "19845" }, { "2016-17": "24389" }, { "2016-17": "24389" }, { "2017-18": "23871" }], "RE": [{ "2013-14": "10163" }, { "2014-15": "23596" }, { "2015-16": "21333" }, { "2016-17": "23417" }] }, "grpby_name": "Rajasthan" }, { "figures": { "A": [{ "2012-13": "1852" }, { "2013-14": "2244" }, { "2014-15": "2427" }, { "2015-16": "934" }], "BE": [{ "2013-14": "2684" }, { "2014-15": "3561" }, { "2015-16": "1966" }, { "2016-17": "1782" }, { "2016-17": "1782" }, { "2017-18": "1753" }], "RE": [{ "2013-14": "2778" }, { "2014-15": "3648" }, { "2015-16": "2027" }, { "2016-17": "1937" }] }, "grpby_name": "Sikkim" }, { "figures": { "A": [{ "2012-13": "6499" }, { "2013-14": "9122" }, { "2014-15": "18589" }, { "2015-16": "19260" }], "BE": [{ "2013-14": "" }, { "2014-15": "8456" }, { "2015-16": "16377" }, { "2016-17": "24741" }, { "2016-17": "24741" }, { "2017-18": "20231" }], "RE": [{ "2013-14": "" }, { "2014-15": "21724" }, { "2015-16": "21687" }, { "2016-17": "20709" }] }, "grpby_name": "Tamil Nadu" }, { "figures": { "A": [{ "2012-13": "" }, { "2013-14": "" }, { "2014-15": "7118" }, { "2015-16": "9394" }], "BE": [{ "2013-14": "" }, { "2014-15": "21721" }, { "2015-16": "12400" }, { "2016-17": "14557" }, { "2016-17": "14557" }, { "2017-18": "26858" }], "RE": [{ "2013-14": "" }, { "2014-15": "21721" }, { "2015-16": "12461" }, { "2016-17": "13557" }] }, "grpby_name": "Telangana" }, { "figures": { "A": [{ "2012-13": "4374" }, { "2013-14": "4700" }, { "2014-15": "6140" }, { "2015-16": "4566" }], "BE": [{ "2013-14": "4954" }, { "2014-15": "7391" }, { "2015-16": "9005" }, { "2016-17": "6852" }, { "2016-17": "6852" }, { "2017-18": "7313" }], "RE": [{ "2013-14": "5176" }, { "2014-15": "7400" }, { "2015-16": "5778" }, { "2016-17": "7007" }] }, "grpby_name": "Tripura" }, { "figures": { "A": [{ "2012-13": "17338" }, { "2013-14": "22405" }, { "2014-15": "32691" }, { "2015-16": "31861" }], "BE": [{ "2013-14": "23915" }, { "2014-15": "48685" }, { "2015-16": "49600" }, { "2016-17": "50421" }, { "2016-17": "50421" }, { "2017-18": "68052" }], "RE": [{ "2013-14": "24352" }, { "2014-15": "49639" }, { "2015-16": "44220" }, { "2016-17": "48963" }] }, "grpby_name": "Uttar Pradesh" }, { "figures": { "A": [{ "2012-13": "4457" }, { "2013-14": "5075" }, { "2014-15": "7005" }, { "2015-16": "5304" }], "BE": [{ "2013-14": "6732" }, { "2014-15": "10510" }, { "2015-16": "8720" }, { "2016-17": "11351" }, { "2016-17": "11351" }, { "2017-18": "8231" }], "RE": [{ "2013-14": "8102" }, { "2014-15": "12366" }, { "2015-16": "8756" }, { "2016-17": "6661" }] }, "grpby_name": "Uttarakhand" }, { "figures": { "A": [{ "2012-13": "12343" }, { "2013-14": "11853" }, { "2014-15": "20881" }, { "2015-16": "28214" }], "BE": [{ "2013-14": "21594" }, { "2014-15": "30777" }, { "2015-16": "32257" }, { "2016-17": "34208" }, { "2016-17": "34208" }, { "2017-18": "35126" }], "RE": [{ "2013-14": "15944" }, { "2014-15": "25960" }, { "2015-16": "27406" }, { "2016-17": "33750" }] }, "grpby_name": "West Bengal" }] }];

/***/ },
/* 380 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var receipts_metadata = exports.receipts_metadata = [{ "record_slug": "total_receipts", "description": "It is the total revenue collected by the government in a financial year on revenue and capital accounts taken together. It includes tax revenue, non tax revenue, share in Central taxes, market and other borrowings, proceeds from disinvestment and grants-in-aid received including those from the Union Government.", "source": "Budget at a Glance, Receipts Budget, Medium Term Fiscal Policy Strategy  and Annual Financial Statements, Fiscal Responsibility and Budget Management Act Document of State Budgets", "notes": "", "record": "Total Receipts", "unit": "INR Rs. Crores" }, { "record_slug": "revenue_receipts", "description": "These are current receipts of the Government that neither create liabilities nor reduce assets. These include proceeds from taxes (State's Own Tax Revenue as well as share in Central Government Tax Collections in divisible pool), Cess on State Taxes, interest & dividend on public investment, grants-in aid and others fees for rendering government services.", "source": "Budget at a Glance, Receipts Budget, Medium Term Fiscal Policy Strategy  and Annual Financial Statements, Fiscal Responsibility and Budget Management Act Document of State Budgets", "notes": "", "record": "Revenue Receipts", "unit": "INR Rs. Crores" }, { "record_slug": "capital_receipts", "description": "Capital Receipts are government loans raised from the public, government borrowings from the Reserve Bank and treasury bills, loans received from foreign bodies and governments, divestment of equity holding in public sector enterprises, securities against small savings, state provident funds, special deposits and the loans taken from the Central Government by the State Governments.", "source": "Budget at a Glance, Receipts Budget, Medium Term Fiscal Policy Strategy  and Annual Financial Statements, Fiscal Responsibility and Budget Management Act Document of State Budgets", "notes": "", "record": "Capital Receipts", "unit": "INR Rs. Crores" }, { "record_slug": "own_tax_revenue_state_tax_revenue", "description": "It is the revenue collected through taxes imposed by the States including Sales tax, VAT, Recreation tax, Toll tax, Stamps and Registration etc.", "source": "Annual Fiancial Statements, Receipt Budgets, Budget at Glance, Medium Term Fiscal Policy Strategy  and Annual Financial Statements, Fiscal Responsibility and Budget Management Act Document of State Governments", "notes": "", "record": "Own Tax Revenue / State Tax Revenue", "unit": "INR Rs. Crores" }, { "record_slug": "share_in_central_taxes", "description": "It is transfer of tax revenue collected by Central Government to the States following recommendations of the Finance Commission. This is based on population, area, fiscal capacity and own tax efforts of the states. The sharable pool of Central Taxes include, 0020-Corporation Tax, 0021-Taxes on Income Other than Corporation Tax, 0028-Other Taxes on Income and Expenditure, 0032-Taxes on Wealth, 0037-Customs, 0038-Union Excise Duties and 0044-Service Tax.", "source": "Receipts Budget, Budget at A Glance and Annual Fiancial Statements", "notes": "Collections through imposition of Cess are not part the pool of resoured shared with States.", "record": "Share in Central Taxes", "unit": "INR Rs. Crores" }, { "record_slug": "total_tax_revenue", "description": "It is sum of State's own tax collections and their share in divisible pool of Central Taxes including  0020-Corporation Tax; 0021-Taxes on Income Other than Corporation Tax; 0037-Customs; 0038-Union Excise Duties and 0044-Service Tax.", "source": "Budget at a Glance, Receipts Budget, Medium Term Fiscal Policy Strategy  and Annual Financial Statements, Fiscal Responsibility and Budget Management Act Document of State Budgets", "notes": "", "record": "Total Tax Revenue", "unit": "INR Rs. Crores" }, { "record_slug": "own_non_tax_revenue_state_nontax_revenue", "description": "This is part of Revenue Receipts for the States. State\u2019s Own Non-Tax Revenue is the recurring income earned by the State Government from sources other than taxes and excluding grants-in aid from the Central Government.\xA0The major components under this head are interest receipts (received on loans given by the State Government), dividends and profits received from public sector companies under the ownership of State Governments, and revenue earned through rendering\xA0various economic, administrative and social services of the State Government in the form of fees and penalties.", "source": "Annual Financial Statements, Budget at a Glance, Receipts Budget", "notes": "", "record": "Own Non-Tax Revenue / State Non-Tax Revenue", "unit": "INR Rs. Crores" }, { "record_slug": "grants_in_aid_from_centre", "description": "Grants-in-aid from Centre is composed of Plan and Non Plan Grants to assist in financing of expenditure by the State Governments. They include Grants under the Constitution (Distribution of Revenue Order) , Grants to meet non-plan revenue deficit, Grants from National Calamity Contingency Fund, Block Grants, Grants as Advance Plan Assistance for relief on account of Natural Calamities, Grants from Central Road Fund, Grants towards contribution to State Disaster Response Fund, Grants as Advance Plan Assistance for drought relief, Grants on the heads of Plan Schemes (e.g., National Rural Employment Guarantee Programme etc.)   ", "source": "Annual Financial Statements, Budget at a Glance, Receipts Budget", "notes": "", "record": "Grants-in-aid from Centre", "unit": "INR Rs. Crores" }];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(96);
	
	var _App = __webpack_require__(368);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AppController = __webpack_require__(239);
	
	var _AppController2 = _interopRequireDefault(_AppController);
	
	var _Home = __webpack_require__(369);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
		_reactRouter.Route,
		{ path: "/", components: _App2.default },
		_react2.default.createElement(_reactRouter.IndexRoute, { components: _Home2.default }),
		_react2.default.createElement(_reactRouter.Route, { path: "/expenditure/:heirarchy_level/:category/:record", component: _AppController2.default, panelName: "expenditure" }),
		_react2.default.createElement(_reactRouter.Route, { path: "/receipts/:heirarchy_level/:record", component: _AppController2.default, panelName: "receipts" })
	);
	//import {expenditure_data} from "./data/expenditure_data";

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*istanbul ignore next*/"use strict";
	
	/*istanbul ignore next*/__webpack_require__(583);
	
	/*istanbul ignore next*/__webpack_require__(383);
	
	/*istanbul ignore next*/__webpack_require__(384);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(135)))

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(391);
	module.exports = __webpack_require__(35).RegExp.escape;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(8);
	var isArray = __webpack_require__(114);
	var SPECIES = __webpack_require__(9)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(44);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(118);
	var pIE = __webpack_require__(101);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 389 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 390 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(389)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(242) });
	
	__webpack_require__(55)('copyWithin');


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(40)(4);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(154) });
	
	__webpack_require__(55)('fill');


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(40)(2);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(40)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(40)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(40)(0);
	var STRICT = __webpack_require__(37)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(36);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var call = __webpack_require__(253);
	var isArrayIter = __webpack_require__(162);
	var toLength = __webpack_require__(14);
	var createProperty = __webpack_require__(156);
	var getIterFn = __webpack_require__(178);
	
	$export($export.S + $export.F * !__webpack_require__(116)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(110)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(37)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(114) });


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(29);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(100) != Object || !__webpack_require__(37)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(29);
	var toInteger = __webpack_require__(43);
	var toLength = __webpack_require__(14);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(37)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(40)(1);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(156);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(244);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(244);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(160);
	var cof = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(14);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(40)(3);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(20);
	var toObject = __webpack_require__(15);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(37)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(71)('Array');


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(386);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(44);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(23)(proto, TO_PRIMITIVE, __webpack_require__(387));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(24)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(245) });


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(28);
	var HAS_INSTANCE = __webpack_require__(9)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(13).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(256);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(166);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(165);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(255) });


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(256) });


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(166) });


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(165);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(165);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var has = __webpack_require__(26);
	var cof = __webpack_require__(34);
	var inheritIfRequired = __webpack_require__(161);
	var toPrimitive = __webpack_require__(44);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(67).f;
	var gOPD = __webpack_require__(27).f;
	var dP = __webpack_require__(13).f;
	var $trim = __webpack_require__(84).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(66)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(24)(global, NUMBER, $Number);
	}


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(252) });


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(252);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(264);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(265);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(43);
	var aNumberValue = __webpack_require__(241);
	var repeat = __webpack_require__(173);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(241);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(258) });


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(66) });


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(259) });


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(13).f });


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(8);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(42)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(29);
	var $getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	__webpack_require__(42)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(42)('getOwnPropertyNames', function () {
	  return __webpack_require__(260).f;
	});


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(15);
	var $getPrototypeOf = __webpack_require__(28);
	
	__webpack_require__(42)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(8);
	
	__webpack_require__(42)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(8);
	
	__webpack_require__(42)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(8);
	
	__webpack_require__(42)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(390) });


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(15);
	var $keys = __webpack_require__(68);
	
	__webpack_require__(42)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(8);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(42)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(8);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(42)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(169).set });


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(99);
	var test = {};
	test[__webpack_require__(9)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(24)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(264);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(265);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(36);
	var classof = __webpack_require__(99);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(8);
	var aFunction = __webpack_require__(20);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var speciesConstructor = __webpack_require__(122);
	var task = __webpack_require__(175).set;
	var microtask = __webpack_require__(167)();
	var newPromiseCapabilityModule = __webpack_require__(168);
	var perform = __webpack_require__(266);
	var userAgent = __webpack_require__(124);
	var promiseResolve = __webpack_require__(267);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(70)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(83)($Promise, PROMISE);
	__webpack_require__(71)(PROMISE);
	Wrapper = __webpack_require__(35)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(116)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(20);
	var anObject = __webpack_require__(4);
	var rApply = (__webpack_require__(5).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(66);
	var aFunction = __webpack_require__(20);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(245);
	var rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(13);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(44);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(27).f;
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(4);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(163)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(27);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(28);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(28);
	var has = __webpack_require__(26);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(8);
	var anObject = __webpack_require__(4);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(4);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(263) });


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(4);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(169);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(13);
	var gOPD = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(28);
	var has = __webpack_require__(26);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(69);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var inheritIfRequired = __webpack_require__(161);
	var dP = __webpack_require__(13).f;
	var gOPN = __webpack_require__(67).f;
	var isRegExp = __webpack_require__(115);
	var $flags = __webpack_require__(113);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(9)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(24)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(71)('RegExp');


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(112)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(112)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(112)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(112)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(115);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(272);
	var anObject = __webpack_require__(4);
	var $flags = __webpack_require__(113);
	var DESCRIPTORS = __webpack_require__(12);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(24)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(25)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(25)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(25)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(25)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(171)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(14);
	var context = __webpack_require__(172);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(159)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(25)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(25)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(25)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(72);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(172);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(159)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(25)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(171)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(164)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(25)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(29);
	var toLength = __webpack_require__(14);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(173)
	});


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(25)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(14);
	var context = __webpack_require__(172);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(159)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(25)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(25)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(25)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(84)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(5);
	var has = __webpack_require__(26);
	var DESCRIPTORS = __webpack_require__(12);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(24);
	var META = __webpack_require__(57).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(121);
	var setToStringTag = __webpack_require__(83);
	var uid = __webpack_require__(73);
	var wks = __webpack_require__(9);
	var wksExt = __webpack_require__(270);
	var wksDefine = __webpack_require__(177);
	var enumKeys = __webpack_require__(388);
	var isArray = __webpack_require__(114);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(8);
	var toIObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(44);
	var createDesc = __webpack_require__(69);
	var _create = __webpack_require__(66);
	var gOPNExt = __webpack_require__(260);
	var $GOPD = __webpack_require__(27);
	var $DP = __webpack_require__(13);
	var $keys = __webpack_require__(68);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(101).f = $propertyIsEnumerable;
	  __webpack_require__(118).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(56)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(123);
	var buffer = __webpack_require__(176);
	var anObject = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(14);
	var isObject = __webpack_require__(8);
	var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
	var speciesConstructor = __webpack_require__(122);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(71)(ARRAY_BUFFER);


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(123).ABV, {
	  DataView: __webpack_require__(176).DataView
	});


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(248);
	var validate = __webpack_require__(85);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(111)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(249);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(14);
	var aFunction = __webpack_require__(20);
	var arraySpeciesCreate = __webpack_require__(155);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatMap');


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(249);
	var toObject = __webpack_require__(15);
	var toLength = __webpack_require__(14);
	var toInteger = __webpack_require__(43);
	var arraySpeciesCreate = __webpack_require__(155);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatten');


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(110)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(55)('includes');


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(167)();
	var process = __webpack_require__(5).process;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(5) });


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(119)('Map');


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(120)('Map');


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(247)('Map') });


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(257);
	var fround = __webpack_require__(255);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(257) });


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var aFunction = __webpack_require__(20);
	var $defineProperty = __webpack_require__(13);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(117), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var aFunction = __webpack_require__(20);
	var $defineProperty = __webpack_require__(13);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(117), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(262)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(263);
	var toIObject = __webpack_require__(29);
	var gOPD = __webpack_require__(27);
	var createProperty = __webpack_require__(156);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(28);
	var getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(117), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(28);
	var getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(117), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(262)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(5);
	var core = __webpack_require__(35);
	var microtask = __webpack_require__(167)();
	var OBSERVABLE = __webpack_require__(9)('observable');
	var aFunction = __webpack_require__(20);
	var anObject = __webpack_require__(4);
	var anInstance = __webpack_require__(64);
	var redefineAll = __webpack_require__(70);
	var hide = __webpack_require__(23);
	var forOf = __webpack_require__(65);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(71)('Observable');


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(35);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(122);
	var promiseResolve = __webpack_require__(267);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(168);
	var perform = __webpack_require__(266);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(273);
	var from = __webpack_require__(243);
	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(28);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(28);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(28);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(50);
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(20);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(119)('Set');


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(120)('Set');


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(247)('Set') });


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(171)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(41);
	var toLength = __webpack_require__(14);
	var isRegExp = __webpack_require__(115);
	var getFlags = __webpack_require__(113);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(163)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(268);
	var userAgent = __webpack_require__(124);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(268);
	var userAgent = __webpack_require__(124);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(177)('asyncIterator');


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(177)('observable');


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(119)('WeakMap');


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(120)('WeakMap');


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(119)('WeakSet');


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(120)('WeakSet');


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(179);
	var getKeys = __webpack_require__(68);
	var redefine = __webpack_require__(24);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(23);
	var Iterators = __webpack_require__(82);
	var wks = __webpack_require__(9);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(175);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(5);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(124);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(511);
	__webpack_require__(450);
	__webpack_require__(452);
	__webpack_require__(451);
	__webpack_require__(454);
	__webpack_require__(456);
	__webpack_require__(461);
	__webpack_require__(455);
	__webpack_require__(453);
	__webpack_require__(463);
	__webpack_require__(462);
	__webpack_require__(458);
	__webpack_require__(459);
	__webpack_require__(457);
	__webpack_require__(449);
	__webpack_require__(460);
	__webpack_require__(464);
	__webpack_require__(465);
	__webpack_require__(417);
	__webpack_require__(419);
	__webpack_require__(418);
	__webpack_require__(467);
	__webpack_require__(466);
	__webpack_require__(437);
	__webpack_require__(447);
	__webpack_require__(448);
	__webpack_require__(438);
	__webpack_require__(439);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(442);
	__webpack_require__(443);
	__webpack_require__(444);
	__webpack_require__(445);
	__webpack_require__(446);
	__webpack_require__(420);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(424);
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(433);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(436);
	__webpack_require__(498);
	__webpack_require__(503);
	__webpack_require__(510);
	__webpack_require__(501);
	__webpack_require__(493);
	__webpack_require__(494);
	__webpack_require__(499);
	__webpack_require__(504);
	__webpack_require__(506);
	__webpack_require__(489);
	__webpack_require__(490);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(495);
	__webpack_require__(496);
	__webpack_require__(497);
	__webpack_require__(500);
	__webpack_require__(502);
	__webpack_require__(505);
	__webpack_require__(507);
	__webpack_require__(508);
	__webpack_require__(509);
	__webpack_require__(412);
	__webpack_require__(414);
	__webpack_require__(413);
	__webpack_require__(416);
	__webpack_require__(415);
	__webpack_require__(401);
	__webpack_require__(399);
	__webpack_require__(405);
	__webpack_require__(402);
	__webpack_require__(408);
	__webpack_require__(410);
	__webpack_require__(398);
	__webpack_require__(404);
	__webpack_require__(395);
	__webpack_require__(409);
	__webpack_require__(393);
	__webpack_require__(407);
	__webpack_require__(406);
	__webpack_require__(400);
	__webpack_require__(403);
	__webpack_require__(392);
	__webpack_require__(394);
	__webpack_require__(397);
	__webpack_require__(396);
	__webpack_require__(411);
	__webpack_require__(179);
	__webpack_require__(483);
	__webpack_require__(488);
	__webpack_require__(272);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(486);
	__webpack_require__(487);
	__webpack_require__(468);
	__webpack_require__(271);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(523);
	__webpack_require__(512);
	__webpack_require__(513);
	__webpack_require__(518);
	__webpack_require__(521);
	__webpack_require__(522);
	__webpack_require__(516);
	__webpack_require__(519);
	__webpack_require__(517);
	__webpack_require__(520);
	__webpack_require__(514);
	__webpack_require__(515);
	__webpack_require__(469);
	__webpack_require__(470);
	__webpack_require__(471);
	__webpack_require__(472);
	__webpack_require__(473);
	__webpack_require__(476);
	__webpack_require__(474);
	__webpack_require__(475);
	__webpack_require__(477);
	__webpack_require__(478);
	__webpack_require__(479);
	__webpack_require__(480);
	__webpack_require__(482);
	__webpack_require__(481);
	__webpack_require__(526);
	__webpack_require__(524);
	__webpack_require__(525);
	__webpack_require__(567);
	__webpack_require__(570);
	__webpack_require__(569);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(568);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(548);
	__webpack_require__(551);
	__webpack_require__(547);
	__webpack_require__(545);
	__webpack_require__(546);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(532);
	__webpack_require__(566);
	__webpack_require__(531);
	__webpack_require__(565);
	__webpack_require__(577);
	__webpack_require__(579);
	__webpack_require__(530);
	__webpack_require__(564);
	__webpack_require__(576);
	__webpack_require__(578);
	__webpack_require__(529);
	__webpack_require__(575);
	__webpack_require__(528);
	__webpack_require__(533);
	__webpack_require__(534);
	__webpack_require__(535);
	__webpack_require__(536);
	__webpack_require__(537);
	__webpack_require__(539);
	__webpack_require__(538);
	__webpack_require__(540);
	__webpack_require__(541);
	__webpack_require__(542);
	__webpack_require__(544);
	__webpack_require__(543);
	__webpack_require__(553);
	__webpack_require__(554);
	__webpack_require__(555);
	__webpack_require__(556);
	__webpack_require__(558);
	__webpack_require__(557);
	__webpack_require__(560);
	__webpack_require__(559);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(527);
	__webpack_require__(552);
	__webpack_require__(582);
	__webpack_require__(581);
	__webpack_require__(580);
	module.exports = __webpack_require__(35);


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyObject = __webpack_require__(102);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_array = {})));
	}(this, function (exports) { 'use strict';
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function bisector(compare) {
	    if (compare.length === 1) compare = ascendingComparator(compare);
	    return {
	      left: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1;
	          else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid;
	          else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	
	  function ascendingComparator(f) {
	    return function(d, x) {
	      return ascending(f(d), x);
	    };
	  }
	
	  var ascendingBisect = bisector(ascending);
	  var bisectRight = ascendingBisect.right;
	  var bisectLeft = ascendingBisect.left;
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function number$1(x) {
	    return x === null ? NaN : +x;
	  }
	
	  function variance(array, f) {
	    var n = array.length,
	        m = 0,
	        a,
	        d,
	        s = 0,
	        i = -1,
	        j = 0;
	
	    if (f == null) {
	      while (++i < n) {
	        if (!isNaN(a = number$1(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    else {
	      while (++i < n) {
	        if (!isNaN(a = number$1(f(array[i], i, array)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    if (j > 1) return s / (j - 1);
	  }
	
	  function deviation(array, f) {
	    var v = variance(array, f);
	    return v ? Math.sqrt(v) : v;
	  }
	
	  function extent(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b,
	        c;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    return [a, c];
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function identity(x) {
	    return x;
	  }
	
	  function range(start, stop, step) {
	    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	    var i = -1,
	        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	        range = new Array(n);
	
	    while (++i < n) {
	      range[i] = start + i * step;
	    }
	
	    return range;
	  }
	
	  var e10 = Math.sqrt(50);
	  var e5 = Math.sqrt(10);
	  var e2 = Math.sqrt(2);
	  function ticks(start, stop, count) {
	    var step = tickStep(start, stop, count);
	    return range(
	      Math.ceil(start / step) * step,
	      Math.floor(stop / step) * step + step / 2, // inclusive
	      step
	    );
	  }
	
	  function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;
	    else if (error >= e5) step1 *= 5;
	    else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	  }
	
	  function sturges(values) {
	    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	  }
	
	  function number(x) {
	    return +x;
	  }
	
	  function histogram() {
	    var value = identity,
	        domain = extent,
	        threshold = sturges;
	
	    function histogram(data) {
	      var i,
	          n = data.length,
	          x,
	          values = new Array(n);
	
	      // Coerce values to numbers.
	      for (i = 0; i < n; ++i) {
	        values[i] = +value(data[i], i, data);
	      }
	
	      var xz = domain(values),
	          x0 = +xz[0],
	          x1 = +xz[1],
	          tz = threshold(values, x0, x1);
	
	      // Convert number of thresholds into uniform thresholds.
	      if (!Array.isArray(tz)) tz = ticks(x0, x1, +tz);
	
	      // Coerce thresholds to numbers, ignoring any outside the domain.
	      var m = tz.length;
	      for (i = 0; i < m; ++i) tz[i] = +tz[i];
	      while (tz[0] <= x0) tz.shift(), --m;
	      while (tz[m - 1] >= x1) tz.pop(), --m;
	
	      var bins = new Array(m + 1),
	          bin;
	
	      // Initialize bins.
	      for (i = 0; i <= m; ++i) {
	        bin = bins[i] = [];
	        bin.x0 = i > 0 ? tz[i - 1] : x0;
	        bin.x1 = i < m ? tz[i] : x1;
	      }
	
	      // Assign data to bins by value, ignoring any outside the domain.
	      for (i = 0; i < n; ++i) {
	        x = values[i];
	        if (x0 <= x && x <= x1) {
	          bins[bisectRight(tz, x, 0, m)].push(data[i]);
	        }
	      }
	
	      return bins;
	    }
	
	    histogram.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), histogram) : value;
	    };
	
	    histogram.domain = function(_) {
	      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), histogram) : domain;
	    };
	
	    histogram.thresholds = function(_) {
	      if (!arguments.length) return threshold;
	      threshold = typeof _ === "function" ? _
	          : Array.isArray(_) ? constant(Array.prototype.map.call(_, number))
	          : constant(+_);
	      return histogram;
	    };
	
	    return histogram;
	  }
	
	  function quantile(array, p, f) {
	    if (f == null) f = number$1;
	    if (!(n = array.length)) return;
	    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	    if (p >= 1) return +f(array[n - 1], n - 1, array);
	    var n,
	        h = (n - 1) * p,
	        i = Math.floor(h),
	        a = +f(array[i], i, array),
	        b = +f(array[i + 1], i + 1, array);
	    return a + (b - a) * (h - i);
	  }
	
	  function freedmanDiaconis(values, min, max) {
	    values.sort(ascending);
	    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function scott(values, min, max) {
	    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function max(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	    }
	
	    return a;
	  }
	
	  function mean(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1,
	        j = n;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number$1(array[i]))) s += a; else --j;
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) s += a; else --j;
	    }
	
	    if (j) return s / j;
	  }
	
	  function median(array, f) {
	    var numbers = [],
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number$1(array[i]))) numbers.push(a);
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) numbers.push(a);
	    }
	
	    return quantile(numbers.sort(ascending), 0.5);
	  }
	
	  function merge(arrays) {
	    var n = arrays.length,
	        m,
	        i = -1,
	        j = 0,
	        merged,
	        array;
	
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	
	    return merged;
	  }
	
	  function min(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	    }
	
	    return a;
	  }
	
	  function pairs(array) {
	    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [p, p = array[++i]];
	    return pairs;
	  }
	
	  function permute(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  }
	
	  function scan(array, compare) {
	    if (!(n = array.length)) return;
	    var i = 0,
	        n,
	        j = 0,
	        xi,
	        xj = array[j];
	
	    if (!compare) compare = ascending;
	
	    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	    if (compare(xj, xj) === 0) return j;
	  }
	
	  function shuffle(array, i0, i1) {
	    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	        t,
	        i;
	
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0];
	      array[m + i0] = array[i + i0];
	      array[i + i0] = t;
	    }
	
	    return array;
	  }
	
	  function sum(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	    }
	
	    else {
	      while (++i < n) if (a = +f(array[i], i, array)) s += a;
	    }
	
	    return s;
	  }
	
	  function transpose(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  }
	
	  function length(d) {
	    return d.length;
	  }
	
	  function zip() {
	    return transpose(arguments);
	  }
	
	  var version = "0.7.1";
	
	  exports.version = version;
	  exports.bisect = bisectRight;
	  exports.bisectRight = bisectRight;
	  exports.bisectLeft = bisectLeft;
	  exports.ascending = ascending;
	  exports.bisector = bisector;
	  exports.descending = descending;
	  exports.deviation = deviation;
	  exports.extent = extent;
	  exports.histogram = histogram;
	  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	  exports.thresholdScott = scott;
	  exports.thresholdSturges = sturges;
	  exports.max = max;
	  exports.mean = mean;
	  exports.median = median;
	  exports.merge = merge;
	  exports.min = min;
	  exports.pairs = pairs;
	  exports.permute = permute;
	  exports.quantile = quantile;
	  exports.range = range;
	  exports.scan = scan;
	  exports.shuffle = shuffle;
	  exports.sum = sum;
	  exports.ticks = ticks;
	  exports.tickStep = tickStep;
	  exports.transpose = transpose;
	  exports.variance = variance;
	  exports.zip = zip;
	
	}));

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_collection = global.d3_collection || {})));
	}(this, function (exports) { 'use strict';
	
	  var prefix = "$";
	
	  function Map() {}
	
	  Map.prototype = map.prototype = {
	    constructor: Map,
	    has: function(key) {
	      return (prefix + key) in this;
	    },
	    get: function(key) {
	      return this[prefix + key];
	    },
	    set: function(key, value) {
	      this[prefix + key] = value;
	      return this;
	    },
	    remove: function(key) {
	      var property = prefix + key;
	      return property in this && delete this[property];
	    },
	    clear: function() {
	      for (var property in this) if (property[0] === prefix) delete this[property];
	    },
	    keys: function() {
	      var keys = [];
	      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	      return keys;
	    },
	    values: function() {
	      var values = [];
	      for (var property in this) if (property[0] === prefix) values.push(this[property]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	      return entries;
	    },
	    size: function() {
	      var size = 0;
	      for (var property in this) if (property[0] === prefix) ++size;
	      return size;
	    },
	    empty: function() {
	      for (var property in this) if (property[0] === prefix) return false;
	      return true;
	    },
	    each: function(f) {
	      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	    }
	  };
	
	  function map(object, f) {
	    var map = new Map;
	
	    // Copy constructor.
	    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	    // Index array by numeric index or specified key function.
	    else if (Array.isArray(object)) {
	      var i = -1,
	          n = object.length,
	          o;
	
	      if (f == null) while (++i < n) map.set(i, object[i]);
	      else while (++i < n) map.set(f(o = object[i], i, object), o);
	    }
	
	    // Convert object to map.
	    else if (object) for (var key in object) map.set(key, object[key]);
	
	    return map;
	  }
	
	  function nest() {
	    var keys = [],
	        sortKeys = [],
	        sortValues,
	        rollup,
	        nest;
	
	    function apply(array, depth, createResult, setResult) {
	      if (depth >= keys.length) return rollup
	          ? rollup(array) : (sortValues
	          ? array.sort(sortValues)
	          : array);
	
	      var i = -1,
	          n = array.length,
	          key = keys[depth++],
	          keyValue,
	          value,
	          valuesByKey = map(),
	          values,
	          result = createResult();
	
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	          values.push(value);
	        } else {
	          valuesByKey.set(keyValue, [value]);
	        }
	      }
	
	      valuesByKey.each(function(values, key) {
	        setResult(result, key, apply(values, depth, createResult, setResult));
	      });
	
	      return result;
	    }
	
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	
	      var array = [],
	          sortKey = sortKeys[depth++];
	
	      map.each(function(value, key) {
	        array.push({key: key, values: entries(value, depth)});
	      });
	
	      return sortKey
	          ? array.sort(function(a, b) { return sortKey(a.key, b.key); })
	          : array;
	    }
	
	    return nest = {
	      object: function(array) { return apply(array, 0, createObject, setObject); },
	      map: function(array) { return apply(array, 0, createMap, setMap); },
	      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	      key: function(d) { keys.push(d); return nest; },
	      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	      sortValues: function(order) { sortValues = order; return nest; },
	      rollup: function(f) { rollup = f; return nest; }
	    };
	  }
	
	  function createObject() {
	    return {};
	  }
	
	  function setObject(object, key, value) {
	    object[key] = value;
	  }
	
	  function createMap() {
	    return map();
	  }
	
	  function setMap(map, key, value) {
	    map.set(key, value);
	  }
	
	  function Set() {}
	
	  var proto = map.prototype;
	
	  Set.prototype = set.prototype = {
	    constructor: Set,
	    has: proto.has,
	    add: function(value) {
	      value += "";
	      this[prefix + value] = value;
	      return this;
	    },
	    remove: proto.remove,
	    clear: proto.clear,
	    values: proto.keys,
	    size: proto.size,
	    empty: proto.empty,
	    each: proto.each
	  };
	
	  function set(object, f) {
	    var set = new Set;
	
	    // Copy constructor.
	    if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	    // Otherwise, assume it’s an array.
	    else if (object) {
	      var i = -1, n = object.length;
	      if (f == null) while (++i < n) set.add(object[i]);
	      else while (++i < n) set.add(f(object[i], i, object));
	    }
	
	    return set;
	  }
	
	  function keys(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  }
	
	  function values(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  }
	
	  function entries(map) {
	    var entries = [];
	    for (var key in map) entries.push({key: key, value: map[key]});
	    return entries;
	  }
	
	  var version = "0.1.2";
	
	  exports.version = version;
	  exports.nest = nest;
	  exports.set = set;
	  exports.map = map;
	  exports.keys = keys;
	  exports.values = values;
	  exports.entries = entries;
	
	}));

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(585), __webpack_require__(586), __webpack_require__(589)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate'], factory) :
	  (factory((global.d3_sankey = global.d3_sankey || {}),global.d3_array,global.d3_collection,global.d3_interpolate));
	}(this, function (exports,d3Array,d3Collection,d3Interpolate) { 'use strict';
	
	  var version = "0.1.0";
	
	  function sankey() {
	    var sankey = {},
	        nodeWidth = 24,
	        nodePadding = 8,
	        size = [1, 1],
	        align = 'justify', // left, right, center or justify
	        nodes = [],
	        links = [];
	
	    sankey.nodeWidth = function(_) {
	      if (!arguments.length) return nodeWidth;
	      nodeWidth = +_;
	      return sankey;
	    };
	
	    sankey.nodePadding = function(_) {
	      if (!arguments.length) return nodePadding;
	      nodePadding = +_;
	      return sankey;
	    };
	
	    sankey.nodes = function(_) {
	      if (!arguments.length) return nodes;
	      nodes = _;
	      return sankey;
	    };
	
	    sankey.links = function(_) {
	      if (!arguments.length) return links;
	      links = _;
	      return sankey;
	    };
	
	    sankey.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return sankey;
	    };
	
	    sankey.align = function(_) {
	      if (!arguments.length) return align;
	      align = _.toLowerCase();
	      return sankey;
	    };
	
	    sankey.layout = function(iterations) {
	      computeNodeLinks();
	      computeNodeValues();
	      computeNodeBreadths();
	      computeNodeDepths(iterations);
	      computeLinkDepths();
	      return sankey;
	    };
	
	    sankey.relayout = function() {
	      computeLinkDepths();
	      return sankey;
	    };
	
	    sankey.link = function() {
	      var curvature = .5;
	
	      function link(d) {
	        var x0 = d.source.x + d.source.dx,
	            x1 = d.target.x,
	            xi = d3Interpolate.number(x0, x1),
	            x2 = xi(curvature),
	            x3 = xi(1 - curvature),
	            y0 = d.source.y + d.sy + d.dy / 2,
	            y1 = d.target.y + d.ty + d.dy / 2;
	        return "M" + x0 + "," + y0
	             + "C" + x2 + "," + y0
	             + " " + x3 + "," + y1
	             + " " + x1 + "," + y1;
	      }
	
	      link.curvature = function(_) {
	        if (!arguments.length) return curvature;
	        curvature = +_;
	        return link;
	      };
	
	      return link;
	    };
	
	    // Populate the sourceLinks and targetLinks for each node.
	    // Also, if the source and target are not objects, assume they are indices.
	    function computeNodeLinks() {
	      nodes.forEach(function(node) {
	        node.sourceLinks = [];
	        node.targetLinks = [];
	      });
	      links.forEach(function(link) {
	        var source = link.source,
	            target = link.target;
	        if (typeof source === "number") source = link.source = nodes[link.source];
	        if (typeof target === "number") target = link.target = nodes[link.target];
	        source.sourceLinks.push(link);
	        target.targetLinks.push(link);
	      });
	    }
	
	    // Compute the value (size) of each node by summing the associated links.
	    function computeNodeValues() {
	      nodes.forEach(function(node) {
	        node.value = Math.max(
	          d3Array.sum(node.sourceLinks, value),
	          d3Array.sum(node.targetLinks, value)
	        );
	      });
	    }
	
	    // Iteratively assign the breadth (x-position) for each node.
	    // Nodes are assigned the maximum breadth of incoming neighbors plus one;
	    // nodes with no incoming links are assigned breadth zero, while
	    // nodes with no outgoing links are assigned the maximum breadth.
	    function computeNodeBreadths() {
	      var remainingNodes = nodes,
	          nextNodes,
	          x = 0,
	          reverse = (align === 'right'); // Reverse traversal direction
	
	      while (remainingNodes.length) {
	        nextNodes = [];
	        remainingNodes.forEach(function(node) {
	          node.x = x;
	          node.dx = nodeWidth;
	
	          node[reverse ? 'targetLinks' : 'sourceLinks'].forEach(function(link) {
	            var nextNode = link[reverse ? 'source' : 'target'];
	            if (nextNodes.indexOf(nextNode) < 0) {
	              nextNodes.push(nextNode);
	            }
	          });
	        });
	        remainingNodes = nextNodes;
	        ++x;
	      }
	
	      if (reverse) {
	        // Flip nodes horizontally
	        nodes.forEach(function(node) {
	          node.x *= -1;
	          node.x += x - 1;
	        });
	      }
	
	      if (align === 'center') {
	        moveSourcesRight();
	      }
	      if (align === 'justify') {
	        moveSinksRight(x);
	      }
	
	      scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
	    }
	
	    function moveSourcesRight() {
	      nodes.slice()
	        // Pack nodes from right to left
	        .sort(function(a, b) { return b.x - a.x; })
	        .forEach(function(node) {
	          if (!node.targetLinks.length) {
	            node.x = d3Array.min(node.sourceLinks, function(d) { return d.target.x; }) - 1;
	          }
	        });
	    }
	
	    function moveSinksRight(x) {
	      nodes.forEach(function(node) {
	        if (!node.sourceLinks.length) {
	          node.x = x - 1;
	        }
	      });
	    }
	
	    function scaleNodeBreadths(kx) {
	      nodes.forEach(function(node) {
	        node.x *= kx;
	      });
	    }
	
	    function computeNodeDepths(iterations) {
	      var nodesByBreadth = d3Collection.nest()
	          .key(function(d) { return d.x; })
	          .sortKeys(d3Array.ascending)
	          .entries(nodes)
	          .map(function(d) { return d.values; });
	
	      //
	      initializeNodeDepth();
	      resolveCollisions();
	      for (var alpha = 1; iterations > 0; --iterations) {
	        relaxRightToLeft(alpha *= .99);
	        resolveCollisions();
	        relaxLeftToRight(alpha);
	        resolveCollisions();
	      }
	
	      function initializeNodeDepth() {
	        var ky = d3Array.min(nodesByBreadth, function(nodes) {
	          return (size[1] - (nodes.length - 1) * nodePadding) / d3Array.sum(nodes, value);
	        });
	
	        nodesByBreadth.forEach(function(nodes) {
	          nodes.forEach(function(node, i) {
	            node.y = i;
	            node.dy = node.value * ky;
	          });
	        });
	
	        links.forEach(function(link) {
	          link.dy = link.value * ky;
	        });
	      }
	
	      function relaxLeftToRight(alpha) {
	        nodesByBreadth.forEach(function(nodes) {
	          nodes.forEach(function(node) {
	            if (node.targetLinks.length) {
	              var y = d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value);
	              node.y += (y - center(node)) * alpha;
	            }
	          });
	        });
	
	        function weightedSource(link) {
	          return center(link.source) * link.value;
	        }
	      }
	
	      function relaxRightToLeft(alpha) {
	        nodesByBreadth.slice().reverse().forEach(function(nodes) {
	          nodes.forEach(function(node) {
	            if (node.sourceLinks.length) {
	              var y = d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value);
	              node.y += (y - center(node)) * alpha;
	            }
	          });
	        });
	
	        function weightedTarget(link) {
	          return center(link.target) * link.value;
	        }
	      }
	
	      function resolveCollisions() {
	        nodesByBreadth.forEach(function(nodes) {
	          var node,
	              dy,
	              y0 = 0,
	              n = nodes.length,
	              i;
	
	          // Push any overlapping nodes down.
	          nodes.sort(ascendingDepth);
	          for (i = 0; i < n; ++i) {
	            node = nodes[i];
	            dy = y0 - node.y;
	            if (dy > 0) node.y += dy;
	            y0 = node.y + node.dy + nodePadding;
	          }
	
	          // If the bottommost node goes outside the bounds, push it back up.
	          dy = y0 - nodePadding - size[1];
	          if (dy > 0) {
	            y0 = node.y -= dy;
	
	            // Push any overlapping nodes back up.
	            for (i = n - 2; i >= 0; --i) {
	              node = nodes[i];
	              dy = node.y + node.dy + nodePadding - y0;
	              if (dy > 0) node.y -= dy;
	              y0 = node.y;
	            }
	          }
	        });
	      }
	
	      function ascendingDepth(a, b) {
	        return a.y - b.y;
	      }
	    }
	
	    function computeLinkDepths() {
	      nodes.forEach(function(node) {
	        node.sourceLinks.sort(ascendingTargetDepth);
	        node.targetLinks.sort(ascendingSourceDepth);
	      });
	      nodes.forEach(function(node) {
	        var sy = 0, ty = 0;
	        node.sourceLinks.forEach(function(link) {
	          link.sy = sy;
	          sy += link.dy;
	        });
	        node.targetLinks.forEach(function(link) {
	          link.ty = ty;
	          ty += link.dy;
	        });
	      });
	
	      function ascendingSourceDepth(a, b) {
	        return a.source.y - b.source.y;
	      }
	
	      function ascendingTargetDepth(a, b) {
	        return a.target.y - b.target.y;
	      }
	    }
	
	    function center(node) {
	      return node.y + node.dy / 2;
	    }
	
	    function value(link) {
	      return link.value;
	    }
	
	    return sankey;
	  }
	
	  exports.version = version;
	  exports.sankey = sankey;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_color = {})));
	}(this, function (exports) { 'use strict';
	
	  function Color() {}
	
	  var darker = 0.7;
	  var brighter = 1 / darker;
	
	  var reHex3 = /^#([0-9a-f]{3})$/;
	  var reHex6 = /^#([0-9a-f]{6})$/;
	  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var named = {
	    aliceblue: 0xf0f8ff,
	    antiquewhite: 0xfaebd7,
	    aqua: 0x00ffff,
	    aquamarine: 0x7fffd4,
	    azure: 0xf0ffff,
	    beige: 0xf5f5dc,
	    bisque: 0xffe4c4,
	    black: 0x000000,
	    blanchedalmond: 0xffebcd,
	    blue: 0x0000ff,
	    blueviolet: 0x8a2be2,
	    brown: 0xa52a2a,
	    burlywood: 0xdeb887,
	    cadetblue: 0x5f9ea0,
	    chartreuse: 0x7fff00,
	    chocolate: 0xd2691e,
	    coral: 0xff7f50,
	    cornflowerblue: 0x6495ed,
	    cornsilk: 0xfff8dc,
	    crimson: 0xdc143c,
	    cyan: 0x00ffff,
	    darkblue: 0x00008b,
	    darkcyan: 0x008b8b,
	    darkgoldenrod: 0xb8860b,
	    darkgray: 0xa9a9a9,
	    darkgreen: 0x006400,
	    darkgrey: 0xa9a9a9,
	    darkkhaki: 0xbdb76b,
	    darkmagenta: 0x8b008b,
	    darkolivegreen: 0x556b2f,
	    darkorange: 0xff8c00,
	    darkorchid: 0x9932cc,
	    darkred: 0x8b0000,
	    darksalmon: 0xe9967a,
	    darkseagreen: 0x8fbc8f,
	    darkslateblue: 0x483d8b,
	    darkslategray: 0x2f4f4f,
	    darkslategrey: 0x2f4f4f,
	    darkturquoise: 0x00ced1,
	    darkviolet: 0x9400d3,
	    deeppink: 0xff1493,
	    deepskyblue: 0x00bfff,
	    dimgray: 0x696969,
	    dimgrey: 0x696969,
	    dodgerblue: 0x1e90ff,
	    firebrick: 0xb22222,
	    floralwhite: 0xfffaf0,
	    forestgreen: 0x228b22,
	    fuchsia: 0xff00ff,
	    gainsboro: 0xdcdcdc,
	    ghostwhite: 0xf8f8ff,
	    gold: 0xffd700,
	    goldenrod: 0xdaa520,
	    gray: 0x808080,
	    green: 0x008000,
	    greenyellow: 0xadff2f,
	    grey: 0x808080,
	    honeydew: 0xf0fff0,
	    hotpink: 0xff69b4,
	    indianred: 0xcd5c5c,
	    indigo: 0x4b0082,
	    ivory: 0xfffff0,
	    khaki: 0xf0e68c,
	    lavender: 0xe6e6fa,
	    lavenderblush: 0xfff0f5,
	    lawngreen: 0x7cfc00,
	    lemonchiffon: 0xfffacd,
	    lightblue: 0xadd8e6,
	    lightcoral: 0xf08080,
	    lightcyan: 0xe0ffff,
	    lightgoldenrodyellow: 0xfafad2,
	    lightgray: 0xd3d3d3,
	    lightgreen: 0x90ee90,
	    lightgrey: 0xd3d3d3,
	    lightpink: 0xffb6c1,
	    lightsalmon: 0xffa07a,
	    lightseagreen: 0x20b2aa,
	    lightskyblue: 0x87cefa,
	    lightslategray: 0x778899,
	    lightslategrey: 0x778899,
	    lightsteelblue: 0xb0c4de,
	    lightyellow: 0xffffe0,
	    lime: 0x00ff00,
	    limegreen: 0x32cd32,
	    linen: 0xfaf0e6,
	    magenta: 0xff00ff,
	    maroon: 0x800000,
	    mediumaquamarine: 0x66cdaa,
	    mediumblue: 0x0000cd,
	    mediumorchid: 0xba55d3,
	    mediumpurple: 0x9370db,
	    mediumseagreen: 0x3cb371,
	    mediumslateblue: 0x7b68ee,
	    mediumspringgreen: 0x00fa9a,
	    mediumturquoise: 0x48d1cc,
	    mediumvioletred: 0xc71585,
	    midnightblue: 0x191970,
	    mintcream: 0xf5fffa,
	    mistyrose: 0xffe4e1,
	    moccasin: 0xffe4b5,
	    navajowhite: 0xffdead,
	    navy: 0x000080,
	    oldlace: 0xfdf5e6,
	    olive: 0x808000,
	    olivedrab: 0x6b8e23,
	    orange: 0xffa500,
	    orangered: 0xff4500,
	    orchid: 0xda70d6,
	    palegoldenrod: 0xeee8aa,
	    palegreen: 0x98fb98,
	    paleturquoise: 0xafeeee,
	    palevioletred: 0xdb7093,
	    papayawhip: 0xffefd5,
	    peachpuff: 0xffdab9,
	    peru: 0xcd853f,
	    pink: 0xffc0cb,
	    plum: 0xdda0dd,
	    powderblue: 0xb0e0e6,
	    purple: 0x800080,
	    rebeccapurple: 0x663399,
	    red: 0xff0000,
	    rosybrown: 0xbc8f8f,
	    royalblue: 0x4169e1,
	    saddlebrown: 0x8b4513,
	    salmon: 0xfa8072,
	    sandybrown: 0xf4a460,
	    seagreen: 0x2e8b57,
	    seashell: 0xfff5ee,
	    sienna: 0xa0522d,
	    silver: 0xc0c0c0,
	    skyblue: 0x87ceeb,
	    slateblue: 0x6a5acd,
	    slategray: 0x708090,
	    slategrey: 0x708090,
	    snow: 0xfffafa,
	    springgreen: 0x00ff7f,
	    steelblue: 0x4682b4,
	    tan: 0xd2b48c,
	    teal: 0x008080,
	    thistle: 0xd8bfd8,
	    tomato: 0xff6347,
	    turquoise: 0x40e0d0,
	    violet: 0xee82ee,
	    wheat: 0xf5deb3,
	    white: 0xffffff,
	    whitesmoke: 0xf5f5f5,
	    yellow: 0xffff00,
	    yellowgreen: 0x9acd32
	  };
	
	  color.prototype = Color.prototype = {
	    displayable: function() {
	      return this.rgb().displayable();
	    },
	    toString: function() {
	      return this.rgb() + "";
	    }
	  };
	
	  function color(format) {
	    var m;
	    format = (format + "").trim().toLowerCase();
	    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf))) // #f00
	        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3]) // rgb(255,0,0)
	        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100) // rgb(100%,0%,0%)
	        : (m = reHslPercent.exec(format)) ? new Hsl(m[1], m[2] / 100, m[3] / 100) // hsl(120,50%,50%)
	        : named.hasOwnProperty(format) ? rgbn(named[format])
	        : null;
	  }
	
	  function rgbn(n) {
	    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff);
	  }
	
	  function rgb(r, g, b) {
	    if (arguments.length === 1) {
	      if (!(r instanceof Color)) r = color(r);
	      if (r) {
	        r = r.rgb();
	        b = r.b;
	        g = r.g;
	        r = r.r;
	      } else {
	        r = g = b = NaN;
	      }
	    }
	    return new Rgb(r, g, b);
	  }
	
	  function Rgb(r, g, b) {
	    this.r = +r;
	    this.g = +g;
	    this.b = +b;
	  }
	
	  var _rgb = rgb.prototype = Rgb.prototype = new Color;
	
	  _rgb.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k);
	  };
	
	  _rgb.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k);
	  };
	
	  _rgb.rgb = function() {
	    return this;
	  };
	
	  _rgb.displayable = function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255);
	  };
	
	  _rgb.toString = function() {
	    var r = Math.round(this.r),
	        g = Math.round(this.g),
	        b = Math.round(this.b);
	    return "#"
	        + (isNaN(r) || r <= 0 ? "00" : r < 16 ? "0" + r.toString(16) : r >= 255 ? "ff" : r.toString(16))
	        + (isNaN(g) || g <= 0 ? "00" : g < 16 ? "0" + g.toString(16) : g >= 255 ? "ff" : g.toString(16))
	        + (isNaN(b) || b <= 0 ? "00" : b < 16 ? "0" + b.toString(16) : b >= 255 ? "ff" : b.toString(16));
	  };
	
	  function hsl(h, s, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Hsl) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	      } else {
	        if (!(h instanceof Color)) h = color(h);
	        if (h) {
	          if (h instanceof Hsl) return h;
	          h = h.rgb();
	          var r = h.r / 255,
	              g = h.g / 255,
	              b = h.b / 255,
	              min = Math.min(r, g, b),
	              max = Math.max(r, g, b),
	              range = max - min;
	          l = (max + min) / 2;
	          if (range) {
	            s = l < 0.5 ? range / (max + min) : range / (2 - max - min);
	            if (r === max) h = (g - b) / range + (g < b) * 6;
	            else if (g === max) h = (b - r) / range + 2;
	            else h = (r - g) / range + 4;
	            h *= 60;
	          } else {
	            h = NaN;
	            s = l > 0 && l < 1 ? 0 : h;
	          }
	        } else {
	          h = s = l = NaN;
	        }
	      }
	    }
	    return new Hsl(h, s, l);
	  }
	
	  function Hsl(h, s, l) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	  }
	
	  var _hsl = hsl.prototype = Hsl.prototype = new Color;
	
	  _hsl.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k);
	  };
	
	  _hsl.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k);
	  };
	
	  _hsl.rgb = function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2)
	    );
	  };
	
	  _hsl.displayable = function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1);
	  };
	
	  /* From FvD 13.37, CSS Color Module Level 3 */
	  function hsl2rgb(h, m1, m2) {
	    return (h < 60 ? m1 + (m2 - m1) * h / 60
	        : h < 180 ? m2
	        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	        : m1) * 255;
	  }
	
	  var deg2rad = Math.PI / 180;
	  var rad2deg = 180 / Math.PI;
	
	  var Kn = 18;
	  var Xn = 0.950470;
	  var Yn = 1;
	  var Zn = 1.088830;
	  var t0 = 4 / 29;
	  var t1 = 6 / 29;
	  var t2 = 3 * t1 * t1;
	  var t3 = t1 * t1 * t1;
	  function lab(l, a, b) {
	    if (arguments.length === 1) {
	      if (l instanceof Lab) {
	        b = l.b;
	        a = l.a;
	        l = l.l;
	      } else if (l instanceof Hcl) {
	        var h = l.h * deg2rad;
	        b = Math.sin(h) * l.c;
	        a = Math.cos(h) * l.c;
	        l = l.l;
	      } else {
	        if (!(l instanceof Rgb)) l = rgb(l);
	        b = rgb2xyz(l.r);
	        a = rgb2xyz(l.g);
	        l = rgb2xyz(l.b);
	        var x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	            y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	            z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	        b = 200 * (y - z);
	        a = 500 * (x - y);
	        l = 116 * y - 16;
	      }
	    }
	    return new Lab(l, a, b);
	  }
	
	  function Lab(l, a, b) {
	    this.l = +l;
	    this.a = +a;
	    this.b = +b;
	  }
	
	  var _lab = lab.prototype = Lab.prototype = new Color;
	
	  _lab.brighter = function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b);
	  };
	
	  _lab.darker = function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b);
	  };
	
	  _lab.rgb = function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z)
	    );
	  };
	
	  function xyz2lab(t) {
	    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	  }
	
	  function lab2xyz(t) {
	    return t > t1 ? t * t * t : t2 * (t - t0);
	  }
	
	  function xyz2rgb(x) {
	    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	  }
	
	  function rgb2xyz(x) {
	    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	  }
	
	  function hcl(h, c, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Hcl) {
	        l = h.l;
	        c = h.c;
	        h = h.h;
	      } else {
	        if (!(h instanceof Lab)) h = lab(h);
	        l = h.l;
	        c = Math.sqrt(h.a * h.a + h.b * h.b);
	        h = Math.atan2(h.b, h.a) * rad2deg;
	        if (h < 0) h += 360;
	      }
	    }
	    return new Hcl(h, c, l);
	  }
	
	  function Hcl(h, c, l) {
	    this.h = +h;
	    this.c = +c;
	    this.l = +l;
	  }
	
	  var _hcl = hcl.prototype = Hcl.prototype = new Color;
	
	  _hcl.brighter = function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k));
	  };
	
	  _hcl.darker = function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k));
	  };
	
	  _hcl.rgb = function() {
	    return lab(this).rgb();
	  };
	
	  var A = -0.14861;
	  var B = +1.78277;
	  var C = -0.29227;
	  var D = -0.90649;
	  var E = +1.97294;
	  var ED = E * D;
	  var EB = E * B;
	  var BC_DA = B * C - D * A;
	  function cubehelix(h, s, l) {
	    if (arguments.length === 1) {
	      if (h instanceof Cubehelix) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	      } else {
	        if (!(h instanceof Rgb)) h = rgb(h);
	        var r = h.r / 255, g = h.g / 255, b = h.b / 255;
	        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB);
	        var bl = b - l, k = (E * (g - l) - C * bl) / D;
	        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)); // NaN if l=0 or l=1
	        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	        if (h < 0) h += 360;
	      }
	    }
	    return new Cubehelix(h, s, l);
	  }
	
	  function Cubehelix(h, s, l) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	  }
	
	  var _cubehelix = cubehelix.prototype = Cubehelix.prototype = new Color;
	
	  _cubehelix.brighter = function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k);
	  };
	
	  _cubehelix.darker = function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k);
	  };
	
	  _cubehelix.rgb = function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh))
	    );
	  };
	
	  var version = "0.3.4";
	
	  exports.version = version;
	  exports.color = color;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.cubehelix = cubehelix;
	
	}));

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(588)) :
	  typeof define === 'function' && define.amd ? define('d3-interpolate', ['exports', 'd3-color'], factory) :
	  factory((global.d3_interpolate = {}),global.d3_color);
	}(this, function (exports,d3Color) { 'use strict';
	
	  function deltaHue(h1, h0) {
	    var delta = h1 - h0;
	    return delta > 180 || delta < -180
	        ? delta - 360 * Math.round(delta / 360)
	        : delta;
	  };
	
	  function cubehelixGamma(gamma) {
	    return function(a, b) {
	      a = d3Color.cubehelix(a);
	      b = d3Color.cubehelix(b);
	      var ah = isNaN(a.h) ? b.h : a.h,
	          as = isNaN(a.s) ? b.s : a.s,
	          al = a.l,
	          bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	          bs = isNaN(b.s) ? 0 : b.s - as,
	          bl = b.l - al;
	      return function(t) {
	        a.h = ah + bh * t;
	        a.s = as + bs * t;
	        a.l = al + bl * Math.pow(t, gamma);
	        return a + "";
	      };
	    };
	  };
	
	  function cubehelixGammaLong(gamma) {
	    return function(a, b) {
	      a = d3Color.cubehelix(a);
	      b = d3Color.cubehelix(b);
	      var ah = isNaN(a.h) ? b.h : a.h,
	          as = isNaN(a.s) ? b.s : a.s,
	          al = a.l,
	          bh = isNaN(b.h) ? 0 : b.h - ah,
	          bs = isNaN(b.s) ? 0 : b.s - as,
	          bl = b.l - al;
	      return function(t) {
	        a.h = ah + bh * t;
	        a.s = as + bs * t;
	        a.l = al + bl * Math.pow(t, gamma);
	        return a + "";
	      };
	    };
	  };
	
	  function rgb(a, b) {
	    a = d3Color.rgb(a);
	    b = d3Color.rgb(b);
	    var ar = a.r,
	        ag = a.g,
	        ab = a.b,
	        br = b.r - ar,
	        bg = b.g - ag,
	        bb = b.b - ab;
	    return function(t) {
	      a.r = ar + br * t;
	      a.g = ag + bg * t;
	      a.b = ab + bb * t;
	      return a + "";
	    };
	  };
	
	  function number(a, b) {
	    return a = +a, b -= a, function(t) {
	      return a + b * t;
	    };
	  };
	
	  function object(a, b) {
	    var i = {},
	        c = {},
	        k;
	
	    for (k in a) {
	      if (k in b) {
	        i[k] = value(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  };
	
	  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	  var reB = new RegExp(reA.source, "g");
	  function zero(b) {
	    return function() {
	      return b;
	    };
	  }
	
	  function one(b) {
	    return function(t) {
	      return b(t) + "";
	    };
	  }
	
	  function string(a, b) {
	    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	        am, // current match in a
	        bm, // current match in b
	        bs, // string preceding current number in b, if any
	        i = -1, // index in s
	        s = [], // string constants and placeholders
	        q = []; // number interpolators
	
	    // Coerce inputs to strings.
	    a = a + "", b = b + "";
	
	    // Interpolate pairs of numbers in a & b.
	    while ((am = reA.exec(a))
	        && (bm = reB.exec(b))) {
	      if ((bs = bm.index) > bi) { // a string precedes the next number in b
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; // coalesce with previous string
	        else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	        if (s[i]) s[i] += bm; // coalesce with previous string
	        else s[++i] = bm;
	      } else { // interpolate non-matching numbers
	        s[++i] = null;
	        q.push({i: i, x: number(am, bm)});
	      }
	      bi = reB.lastIndex;
	    }
	
	    // Add remains of b.
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	
	    // Special optimization for only a single match.
	    // Otherwise, interpolate each of the numbers and rejoin the string.
	    return s.length < 2 ? (q[0]
	        ? one(q[0].x)
	        : zero(b))
	        : (b = q.length, function(t) {
	            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	            return s.join("");
	          });
	  };
	
	  var values = [
	    function(a, b) {
	      var t = typeof b, c;
	      return (t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	          : b instanceof d3Color.color ? rgb
	          : Array.isArray(b) ? array
	          : t === "object" && isNaN(b) ? object
	          : number)(a, b);
	    }
	  ];
	
	  function value(a, b) {
	    var i = values.length, f;
	    while (--i >= 0 && !(f = values[i](a, b)));
	    return f;
	  };
	
	  // TODO sparse arrays?
	  function array(a, b) {
	    var x = [],
	        c = [],
	        na = a.length,
	        nb = b.length,
	        n0 = Math.min(a.length, b.length),
	        i;
	
	    for (i = 0; i < n0; ++i) x.push(value(a[i], b[i]));
	    for (; i < na; ++i) c[i] = a[i];
	    for (; i < nb; ++i) c[i] = b[i];
	
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  };
	
	  function round(a, b) {
	    return a = +a, b -= a, function(t) {
	      return Math.round(a + b * t);
	    };
	  };
	
	  var rad2deg = 180 / Math.PI;
	  var identity = {a: 1, b: 0, c: 0, d: 1, e: 0, f: 0};
	  var g;
	  // Compute x-scale and normalize the first row.
	  // Compute shear and make second row orthogonal to first.
	  // Compute y-scale and normalize the second row.
	  // Finally, compute the rotation.
	  function Transform(string) {
	    if (!g) g = document.createElementNS("http://www.w3.org/2000/svg", "g");
	    if (string) g.setAttribute("transform", string), t = g.transform.baseVal.consolidate();
	
	    var t,
	        m = t ? t.matrix : identity,
	        r0 = [m.a, m.b],
	        r1 = [m.c, m.d],
	        kx = normalize(r0),
	        kz = dot(r0, r1),
	        ky = normalize(combine(r1, r0, -kz)) || 0;
	
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * rad2deg;
	    this.translate = [m.e, m.f];
	    this.scale = [kx, ky];
	    this.skew = ky ? Math.atan2(kz, ky) * rad2deg : 0;
	  }
	
	  function dot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	
	  function normalize(a) {
	    var k = Math.sqrt(dot(a, a));
	    if (k) a[0] /= k, a[1] /= k;
	    return k;
	  }
	
	  function combine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	
	  function pop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	
	  function translate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(ta[0], tb[0])}, {i: i - 2, x: number(ta[1], tb[1])});
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	
	  function rotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, ")") - 2, x: number(ra, rb)});
	    } else if (rb) {
	      s.push(pop(s) + "rotate(" + rb + ")");
	    }
	  }
	
	  function skew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({i: s.push(pop(s) + "skewX(", null, ")") - 2, x: number(wa, wb)});
	    } else if (wb) {
	      s.push(pop(s) + "skewX(" + wb + ")");
	    }
	  }
	
	  function scale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(ka[0], kb[0])}, {i: i - 2, x: number(ka[1], kb[1])});
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(pop(s) + "scale(" + kb + ")");
	    }
	  }
	
	  function transform(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = new Transform(a), b = new Transform(b);
	    translate(a.translate, b.translate, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skew(a.skew, b.skew, s, q);
	    scale(a.scale, b.scale, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	
	  var rho = Math.SQRT2;
	  var rho2 = 2;
	  var rho4 = 4;
	  var epsilon2 = 1e-12;
	  function cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	
	  function sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	
	  function tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	
	  // p0 = [ux0, uy0, w0]
	  // p1 = [ux1, uy1, w1]
	  function zoom(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	        dx = ux1 - ux0,
	        dy = uy1 - uy0,
	        d2 = dx * dx + dy * dy,
	        i,
	        S;
	
	    // Special case for u0 ≅ u1.
	    if (d2 < epsilon2) {
	      S = Math.log(w1 / w0) / rho;
	      i = function(t) {
	        return [
	          ux0 + t * dx,
	          uy0 + t * dy,
	          w0 * Math.exp(rho * t * S)
	        ];
	      }
	    }
	
	    // General case.
	    else {
	      var d1 = Math.sqrt(d2),
	          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / rho;
	      i = function(t) {
	        var s = t * S,
	            coshr0 = cosh(r0),
	            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	        return [
	          ux0 + u * dx,
	          uy0 + u * dy,
	          w0 * coshr0 / cosh(rho * s + r0)
	        ];
	      }
	    }
	
	    i.duration = S * 1000;
	
	    return i;
	  };
	
	  function hsl(a, b) {
	    a = d3Color.hsl(a);
	    b = d3Color.hsl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        as = isNaN(a.s) ? b.s : a.s,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	        bs = isNaN(b.s) ? 0 : b.s - as,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.s = as + bs * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function hslLong(a, b) {
	    a = d3Color.hsl(a);
	    b = d3Color.hsl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        as = isNaN(a.s) ? b.s : a.s,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : b.h - ah,
	        bs = isNaN(b.s) ? 0 : b.s - as,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.s = as + bs * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function lab(a, b) {
	    a = d3Color.lab(a);
	    b = d3Color.lab(b);
	    var al = a.l,
	        aa = a.a,
	        ab = a.b,
	        bl = b.l - al,
	        ba = b.a - aa,
	        bb = b.b - ab;
	    return function(t) {
	      a.l = al + bl * t;
	      a.a = aa + ba * t;
	      a.b = ab + bb * t;
	      return a + "";
	    };
	  };
	
	  function hcl(a, b) {
	    a = d3Color.hcl(a);
	    b = d3Color.hcl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        ac = isNaN(a.c) ? b.c : a.c,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
	        bc = isNaN(b.c) ? 0 : b.c - ac,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.c = ac + bc * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  function hclLong(a, b) {
	    a = d3Color.hcl(a);
	    b = d3Color.hcl(b);
	    var ah = isNaN(a.h) ? b.h : a.h,
	        ac = isNaN(a.c) ? b.c : a.c,
	        al = a.l,
	        bh = isNaN(b.h) ? 0 : b.h - ah,
	        bc = isNaN(b.c) ? 0 : b.c - ac,
	        bl = b.l - al;
	    return function(t) {
	      a.h = ah + bh * t;
	      a.c = ac + bc * t;
	      a.l = al + bl * t;
	      return a + "";
	    };
	  };
	
	  var cubehelix = cubehelixGamma(1);
	  var cubehelixLong = cubehelixGammaLong(1);
	
	  var version = "0.2.1";
	
	  exports.version = version;
	  exports.cubehelix = cubehelix;
	  exports.cubehelixLong = cubehelixLong;
	  exports.cubehelixGamma = cubehelixGamma;
	  exports.cubehelixGammaLong = cubehelixGammaLong;
	  exports.array = array;
	  exports.number = number;
	  exports.object = object;
	  exports.round = round;
	  exports.string = string;
	  exports.transform = transform;
	  exports.values = values;
	  exports.value = value;
	  exports.zoom = zoom;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.hslLong = hslLong;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.hclLong = hclLong;
	
	}));

/***/ },
/* 590 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 591 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	(function (global) {
	    'use strict';
	
	    var util = newUtil();
	    var inliner = newInliner();
	    var fontFaces = newFontFaces();
	    var images = newImages();
	
	    var domtoimage = {
	        toSvg: toSvg,
	        toPng: toPng,
	        toJpeg: toJpeg,
	        toBlob: toBlob,
	        toPixelData: toPixelData,
	        impl: {
	            fontFaces: fontFaces,
	            images: images,
	            util: util,
	            inliner: inliner
	        }
	    };
	
	    if (true)
	        module.exports = domtoimage;
	    else
	        global.domtoimage = domtoimage;
	
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options
	     * @param {Function} options.filter - Should return true if passed node should be included in the output
	     *          (excluding node means excluding it's children as well). Not called on the root node.
	     * @param {String} options.bgcolor - color for the background, any valid CSS color value.
	     * @param {Number} options.width - width to be applied to node before rendering.
	     * @param {Number} options.height - height to be applied to node before rendering.
	     * @param {Object} options.style - an object whose properties to be copied to node's style before rendering.
	     * @param {Number} options.quality - a Number between 0 and 1 indicating image quality (applicable to JPEG only),
	                defaults to 1.0.
	     * @return {Promise} - A promise that is fulfilled with a SVG image data URL
	     * */
	    function toSvg(node, options) {
	        options = options || {};
	        return Promise.resolve(node)
	            .then(function (node) {
	                return cloneNode(node, options.filter, true);
	            })
	            .then(embedFonts)
	            .then(inlineImages)
	            .then(applyOptions)
	            .then(function (clone) {
	                return makeSvgDataUri(clone,
	                    options.width || util.width(node),
	                    options.height || util.height(node)
	                );
	            });
	
	        function applyOptions(clone) {
	            if (options.bgcolor) clone.style.backgroundColor = options.bgcolor;
	
	            if (options.width) clone.style.width = options.width + 'px';
	            if (options.height) clone.style.height = options.height + 'px';
	
	            if (options.style)
	                Object.keys(options.style).forEach(function (property) {
	                    clone.style[property] = options.style[property];
	                });
	
	            return clone;
	        }
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a Uint8Array containing RGBA pixel data.
	     * */
	    function toPixelData(node, options) {
	        return draw(node, options || {})
	            .then(function (canvas) {
	                return canvas.getContext('2d').getImageData(
	                    0,
	                    0,
	                    util.width(node),
	                    util.height(node)
	                ).data;
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image data URL
	     * */
	    function toPng(node, options) {
	        return draw(node, options || {})
	            .then(function (canvas) {
	                return canvas.toDataURL();
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a JPEG image data URL
	     * */
	    function toJpeg(node, options) {
	        options = options || {};
	        return draw(node, options)
	            .then(function (canvas) {
	                return canvas.toDataURL('image/jpeg', options.quality || 1.0);
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image blob
	     * */
	    function toBlob(node, options) {
	        return draw(node, options || {})
	            .then(util.canvasToBlob);
	    }
	
	    function draw(domNode, options) {
	        return toSvg(domNode, options)
	            .then(util.makeImage)
	            .then(util.delay(100))
	            .then(function (image) {
	                var canvas = newCanvas(domNode);
	                canvas.getContext('2d').drawImage(image, 0, 0);
	                return canvas;
	            });
	
	        function newCanvas(domNode) {
	            var canvas = document.createElement('canvas');
	            canvas.width = options.width || util.width(domNode);
	            canvas.height = options.height || util.height(domNode);
	
	            if (options.bgcolor) {
	                var ctx = canvas.getContext('2d');
	                ctx.fillStyle = options.bgcolor;
	                ctx.fillRect(0, 0, canvas.width, canvas.height);
	            }
	
	            return canvas;
	        }
	    }
	
	    function cloneNode(node, filter, root) {
	        if (!root && filter && !filter(node)) return Promise.resolve();
	
	        return Promise.resolve(node)
	            .then(makeNodeCopy)
	            .then(function (clone) {
	                return cloneChildren(node, clone, filter);
	            })
	            .then(function (clone) {
	                return processClone(node, clone);
	            });
	
	        function makeNodeCopy(node) {
	            if (node instanceof HTMLCanvasElement) return util.makeImage(node.toDataURL());
	            return node.cloneNode(false);
	        }
	
	        function cloneChildren(original, clone, filter) {
	            var children = original.childNodes;
	            if (children.length === 0) return Promise.resolve(clone);
	
	            return cloneChildrenInOrder(clone, util.asArray(children), filter)
	                .then(function () {
	                    return clone;
	                });
	
	            function cloneChildrenInOrder(parent, children, filter) {
	                var done = Promise.resolve();
	                children.forEach(function (child) {
	                    done = done
	                        .then(function () {
	                            return cloneNode(child, filter);
	                        })
	                        .then(function (childClone) {
	                            if (childClone) parent.appendChild(childClone);
	                        });
	                });
	                return done;
	            }
	        }
	
	        function processClone(original, clone) {
	            if (!(clone instanceof Element)) return clone;
	
	            return Promise.resolve()
	                .then(cloneStyle)
	                .then(clonePseudoElements)
	                .then(copyUserInput)
	                .then(fixSvg)
	                .then(function () {
	                    return clone;
	                });
	
	            function cloneStyle() {
	                copyStyle(window.getComputedStyle(original), clone.style);
	
	                function copyStyle(source, target) {
	                    if (source.cssText) target.cssText = source.cssText;
	                    else copyProperties(source, target);
	
	                    function copyProperties(source, target) {
	                        util.asArray(source).forEach(function (name) {
	                            target.setProperty(
	                                name,
	                                source.getPropertyValue(name),
	                                source.getPropertyPriority(name)
	                            );
	                        });
	                    }
	                }
	            }
	
	            function clonePseudoElements() {
	                [':before', ':after'].forEach(function (element) {
	                    clonePseudoElement(element);
	                });
	
	                function clonePseudoElement(element) {
	                    var style = window.getComputedStyle(original, element);
	                    var content = style.getPropertyValue('content');
	
	                    if (content === '' || content === 'none') return;
	
	                    var className = util.uid();
	                    clone.className = clone.className + ' ' + className;
	                    var styleElement = document.createElement('style');
	                    styleElement.appendChild(formatPseudoElementStyle(className, element, style));
	                    clone.appendChild(styleElement);
	
	                    function formatPseudoElementStyle(className, element, style) {
	                        var selector = '.' + className + ':' + element;
	                        var cssText = style.cssText ? formatCssText(style) : formatCssProperties(style);
	                        return document.createTextNode(selector + '{' + cssText + '}');
	
	                        function formatCssText(style) {
	                            var content = style.getPropertyValue('content');
	                            return style.cssText + ' content: ' + content + ';';
	                        }
	
	                        function formatCssProperties(style) {
	
	                            return util.asArray(style)
	                                .map(formatProperty)
	                                .join('; ') + ';';
	
	                            function formatProperty(name) {
	                                return name + ': ' +
	                                    style.getPropertyValue(name) +
	                                    (style.getPropertyPriority(name) ? ' !important' : '');
	                            }
	                        }
	                    }
	                }
	            }
	
	            function copyUserInput() {
	                if (original instanceof HTMLTextAreaElement) clone.innerHTML = original.value;
	                if (original instanceof HTMLInputElement) clone.setAttribute("value", original.value);
	            }
	
	            function fixSvg() {
	                if (!(clone instanceof SVGElement)) return;
	                clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	
	                if (!(clone instanceof SVGRectElement)) return;
	                ['width', 'height'].forEach(function (attribute) {
	                    var value = clone.getAttribute(attribute);
	                    if (!value) return;
	
	                    clone.style.setProperty(attribute, value);
	                });
	            }
	        }
	    }
	
	    function embedFonts(node) {
	        return fontFaces.resolveAll()
	            .then(function (cssText) {
	                var styleNode = document.createElement('style');
	                node.appendChild(styleNode);
	                styleNode.appendChild(document.createTextNode(cssText));
	                return node;
	            });
	    }
	
	    function inlineImages(node) {
	        return images.inlineAll(node)
	            .then(function () {
	                return node;
	            });
	    }
	
	    function makeSvgDataUri(node, width, height) {
	        return Promise.resolve(node)
	            .then(function (node) {
	                node.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
	                return new XMLSerializer().serializeToString(node);
	            })
	            .then(util.escapeXhtml)
	            .then(function (xhtml) {
	                return '<foreignObject x="0" y="0" width="100%" height="100%">' + xhtml + '</foreignObject>';
	            })
	            .then(function (foreignObject) {
	                return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' +
	                    foreignObject + '</svg>';
	            })
	            .then(function (svg) {
	                return 'data:image/svg+xml;charset=utf-8,' + svg;
	            });
	    }
	
	    function newUtil() {
	        return {
	            escape: escape,
	            parseExtension: parseExtension,
	            mimeType: mimeType,
	            dataAsUrl: dataAsUrl,
	            isDataUrl: isDataUrl,
	            canvasToBlob: canvasToBlob,
	            resolveUrl: resolveUrl,
	            getAndEncode: getAndEncode,
	            uid: uid(),
	            delay: delay,
	            asArray: asArray,
	            escapeXhtml: escapeXhtml,
	            makeImage: makeImage,
	            width: width,
	            height: height
	        };
	
	        function mimes() {
	            /*
	             * Only WOFF and EOT mime types for fonts are 'real'
	             * see http://www.iana.org/assignments/media-types/media-types.xhtml
	             */
	            var WOFF = 'application/font-woff';
	            var JPEG = 'image/jpeg';
	
	            return {
	                'woff': WOFF,
	                'woff2': WOFF,
	                'ttf': 'application/font-truetype',
	                'eot': 'application/vnd.ms-fontobject',
	                'png': 'image/png',
	                'jpg': JPEG,
	                'jpeg': JPEG,
	                'gif': 'image/gif',
	                'tiff': 'image/tiff',
	                'svg': 'image/svg+xml'
	            };
	        }
	
	        function parseExtension(url) {
	            var match = /\.([^\.\/]*?)$/g.exec(url);
	            if (match) return match[1];
	            else return '';
	        }
	
	        function mimeType(url) {
	            var extension = parseExtension(url).toLowerCase();
	            return mimes()[extension] || '';
	        }
	
	        function isDataUrl(url) {
	            return url.search(/^(data:)/) !== -1;
	        }
	
	        function toBlob(canvas) {
	            return new Promise(function (resolve) {
	                var binaryString = window.atob(canvas.toDataURL().split(',')[1]);
	                var length = binaryString.length;
	                var binaryArray = new Uint8Array(length);
	
	                for (var i = 0; i < length; i++)
	                    binaryArray[i] = binaryString.charCodeAt(i);
	
	                resolve(new Blob([binaryArray], {
	                    type: 'image/png'
	                }));
	            });
	        }
	
	        function canvasToBlob(canvas) {
	            if (canvas.toBlob)
	                return new Promise(function (resolve) {
	                    canvas.toBlob(resolve);
	                });
	
	            return toBlob(canvas);
	        }
	
	        function resolveUrl(url, baseUrl) {
	            var doc = document.implementation.createHTMLDocument();
	            var base = doc.createElement('base');
	            doc.head.appendChild(base);
	            var a = doc.createElement('a');
	            doc.body.appendChild(a);
	            base.href = baseUrl;
	            a.href = url;
	            return a.href;
	        }
	
	        function uid() {
	            var index = 0;
	
	            return function () {
	                return 'u' + fourRandomChars() + index++;
	
	                function fourRandomChars() {
	                    /* see http://stackoverflow.com/a/6248722/2519373 */
	                    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	                }
	            };
	        }
	
	        function makeImage(uri) {
	            return new Promise(function (resolve, reject) {
	                var image = new Image();
	                image.onload = function () {
	                    resolve(image);
	                };
	                image.onerror = reject;
	                image.src = uri;
	            });
	        }
	
	        function getAndEncode(url) {
	            var TIMEOUT = 30000;
	
	            return new Promise(function (resolve) {
	                var request = new XMLHttpRequest();
	
	                request.onreadystatechange = done;
	                request.ontimeout = timeout;
	                request.responseType = 'blob';
	                request.timeout = TIMEOUT;
	                request.open('GET', url, true);
	                request.send();
	
	                function done() {
	                    if (request.readyState !== 4) return;
	
	                    if (request.status !== 200) {
	                        fail('cannot fetch resource: ' + url + ', status: ' + request.status);
	                        return;
	                    }
	
	                    var encoder = new FileReader();
	                    encoder.onloadend = function () {
	                        var content = encoder.result.split(/,/)[1];
	                        resolve(content);
	                    };
	                    encoder.readAsDataURL(request.response);
	                }
	
	                function timeout() {
	                    fail('timeout of ' + TIMEOUT + 'ms occured while fetching resource: ' + url);
	                }
	
	                function fail(message) {
	                    console.error(message);
	                    resolve('');
	                }
	            });
	        }
	
	        function dataAsUrl(content, type) {
	            return 'data:' + type + ';base64,' + content;
	        }
	
	        function escape(string) {
	            return string.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
	        }
	
	        function delay(ms) {
	            return function (arg) {
	                return new Promise(function (resolve) {
	                    setTimeout(function () {
	                        resolve(arg);
	                    }, ms);
	                });
	            };
	        }
	
	        function asArray(arrayLike) {
	            var array = [];
	            var length = arrayLike.length;
	            for (var i = 0; i < length; i++) array.push(arrayLike[i]);
	            return array;
	        }
	
	        function escapeXhtml(string) {
	            return string.replace(/#/g, '%23').replace(/\n/g, '%0A');
	        }
	
	        function width(node) {
	            var leftBorder = px(node, 'border-left-width');
	            var rightBorder = px(node, 'border-right-width');
	            return node.scrollWidth + leftBorder + rightBorder;
	        }
	
	        function height(node) {
	            var topBorder = px(node, 'border-top-width');
	            var bottomBorder = px(node, 'border-bottom-width');
	            return node.scrollHeight + topBorder + bottomBorder;
	        }
	
	        function px(node, styleProperty) {
	            var value = window.getComputedStyle(node).getPropertyValue(styleProperty);
	            return parseFloat(value.replace('px', ''));
	        }
	    }
	
	    function newInliner() {
	        var URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
	
	        return {
	            inlineAll: inlineAll,
	            shouldProcess: shouldProcess,
	            impl: {
	                readUrls: readUrls,
	                inline: inline
	            }
	        };
	
	        function shouldProcess(string) {
	            return string.search(URL_REGEX) !== -1;
	        }
	
	        function readUrls(string) {
	            var result = [];
	            var match;
	            while ((match = URL_REGEX.exec(string)) !== null) {
	                result.push(match[1]);
	            }
	            return result.filter(function (url) {
	                return !util.isDataUrl(url);
	            });
	        }
	
	        function inline(string, url, baseUrl, get) {
	            return Promise.resolve(url)
	                .then(function (url) {
	                    return baseUrl ? util.resolveUrl(url, baseUrl) : url;
	                })
	                .then(get || util.getAndEncode)
	                .then(function (data) {
	                    return util.dataAsUrl(data, util.mimeType(url));
	                })
	                .then(function (dataUrl) {
	                    return string.replace(urlAsRegex(url), '$1' + dataUrl + '$3');
	                });
	
	            function urlAsRegex(url) {
	                return new RegExp('(url\\([\'"]?)(' + util.escape(url) + ')([\'"]?\\))', 'g');
	            }
	        }
	
	        function inlineAll(string, baseUrl, get) {
	            if (nothingToInline()) return Promise.resolve(string);
	
	            return Promise.resolve(string)
	                .then(readUrls)
	                .then(function (urls) {
	                    var done = Promise.resolve(string);
	                    urls.forEach(function (url) {
	                        done = done.then(function (string) {
	                            return inline(string, url, baseUrl, get);
	                        });
	                    });
	                    return done;
	                });
	
	            function nothingToInline() {
	                return !shouldProcess(string);
	            }
	        }
	    }
	
	    function newFontFaces() {
	        return {
	            resolveAll: resolveAll,
	            impl: {
	                readAll: readAll
	            }
	        };
	
	        function resolveAll() {
	            return readAll(document)
	                .then(function (webFonts) {
	                    return Promise.all(
	                        webFonts.map(function (webFont) {
	                            return webFont.resolve();
	                        })
	                    );
	                })
	                .then(function (cssStrings) {
	                    return cssStrings.join('\n');
	                });
	        }
	
	        function readAll() {
	            return Promise.resolve(util.asArray(document.styleSheets))
	                .then(getCssRules)
	                .then(selectWebFontRules)
	                .then(function (rules) {
	                    return rules.map(newWebFont);
	                });
	
	            function selectWebFontRules(cssRules) {
	                return cssRules
	                    .filter(function (rule) {
	                        return rule.type === CSSRule.FONT_FACE_RULE;
	                    })
	                    .filter(function (rule) {
	                        return inliner.shouldProcess(rule.style.getPropertyValue('src'));
	                    });
	            }
	
	            function getCssRules(styleSheets) {
	                var cssRules = [];
	                styleSheets.forEach(function (sheet) {
	                    try {
	                        util.asArray(sheet.cssRules || []).forEach(cssRules.push.bind(cssRules));
	                    } catch (e) {
	                        console.log('Error while reading CSS rules from ' + sheet.href, e.toString());
	                    }
	                });
	                return cssRules;
	            }
	
	            function newWebFont(webFontRule) {
	                return {
	                    resolve: function resolve() {
	                        var baseUrl = (webFontRule.parentStyleSheet || {}).href;
	                        return inliner.inlineAll(webFontRule.cssText, baseUrl);
	                    },
	                    src: function () {
	                        return webFontRule.style.getPropertyValue('src');
	                    }
	                };
	            }
	        }
	    }
	
	    function newImages() {
	        return {
	            inlineAll: inlineAll,
	            impl: {
	                newImage: newImage
	            }
	        };
	
	        function newImage(element) {
	            return {
	                inline: inline
	            };
	
	            function inline(get) {
	                if (util.isDataUrl(element.src)) return Promise.resolve();
	
	                return Promise.resolve(element.src)
	                    .then(get || util.getAndEncode)
	                    .then(function (data) {
	                        return util.dataAsUrl(data, util.mimeType(element.src));
	                    })
	                    .then(function (dataUrl) {
	                        return new Promise(function (resolve, reject) {
	                            element.onload = resolve;
	                            element.onerror = reject;
	                            element.src = dataUrl;
	                        });
	                    });
	            }
	        }
	
	        function inlineAll(node) {
	            if (!(node instanceof Element)) return Promise.resolve(node);
	
	            return inlineBackground(node)
	                .then(function () {
	                    if (node instanceof HTMLImageElement)
	                        return newImage(node).inline();
	                    else
	                        return Promise.all(
	                            util.asArray(node.childNodes).map(function (child) {
	                                return inlineAll(child);
	                            })
	                        );
	                });
	
	            function inlineBackground(node) {
	                var background = node.style.getPropertyValue('background');
	
	                if (!background) return Promise.resolve(node);
	
	                return inliner.inlineAll(background)
	                    .then(function (inlined) {
	                        node.style.setProperty(
	                            'background',
	                            inlined,
	                            node.style.getPropertyPriority('background')
	                        );
	                    })
	                    .then(function () {
	                        return node;
	                    });
	            }
	        }
	    }
	})(this);


/***/ },
/* 593 */
278,
/* 594 */
278,
/* 595 */
278,
/* 596 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(596);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(605);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var createArrayFromMixed = __webpack_require__(599);
	var getMarkupWrap = __webpack_require__(282);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 601 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 602 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(602);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 604 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(604);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 606 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 607 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/DataKindBLR.png";

/***/ },
/* 609 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 610 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(86);
	
	var _PathUtils = __webpack_require__(74);
	
	var _ExecutionEnvironment = __webpack_require__(127);
	
	var _DOMUtils = __webpack_require__(181);
	
	var _DOMStateStorage = __webpack_require__(283);
	
	var _createDOMHistory = __webpack_require__(284);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(86);
	
	var _PathUtils = __webpack_require__(74);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(74);
	
	var _Actions = __webpack_require__(86);
	
	var _createHistory = __webpack_require__(286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 614 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(675),
	    hashDelete = __webpack_require__(676),
	    hashGet = __webpack_require__(677),
	    hashHas = __webpack_require__(678),
	    hashSet = __webpack_require__(679);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(185),
	    setCacheAdd = __webpack_require__(703),
	    setCacheHas = __webpack_require__(704);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(75),
	    root = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 621 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 622 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 623 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 624 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(103),
	    keys = __webpack_require__(91);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(103),
	    keysIn = __webpack_require__(311);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(76);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(187),
	    isFlattenable = __webpack_require__(683);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(667);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(629),
	    keys = __webpack_require__(91);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 631 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(88),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(186),
	    equalArrays = __webpack_require__(297),
	    equalByTag = __webpack_require__(669),
	    equalObjects = __webpack_require__(670),
	    getTag = __webpack_require__(133),
	    isArray = __webpack_require__(31),
	    isBuffer = __webpack_require__(202),
	    isTypedArray = __webpack_require__(310);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(133),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(186),
	    baseIsEqual = __webpack_require__(189);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(203),
	    isMasked = __webpack_require__(685),
	    isObject = __webpack_require__(76),
	    toSource = __webpack_require__(306);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(133),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(88),
	    isLength = __webpack_require__(204),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(642),
	    baseMatchesProperty = __webpack_require__(643),
	    identity = __webpack_require__(199),
	    isArray = __webpack_require__(31),
	    property = __webpack_require__(725);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(196),
	    nativeKeys = __webpack_require__(698);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(76),
	    isPrototype = __webpack_require__(196),
	    nativeKeysIn = __webpack_require__(699);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(635),
	    getMatchData = __webpack_require__(671),
	    matchesStrictComparable = __webpack_require__(304);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(189),
	    get = __webpack_require__(717),
	    hasIn = __webpack_require__(308),
	    isKey = __webpack_require__(195),
	    isStrictComparable = __webpack_require__(303),
	    matchesStrictComparable = __webpack_require__(304),
	    toKey = __webpack_require__(90);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(645),
	    hasIn = __webpack_require__(308);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(131),
	    baseSet = __webpack_require__(649),
	    castPath = __webpack_require__(89);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 646 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(131);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 648 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(188),
	    castPath = __webpack_require__(89),
	    isIndex = __webpack_require__(194),
	    isObject = __webpack_require__(76),
	    toKey = __webpack_require__(90);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(715),
	    defineProperty = __webpack_require__(296),
	    identity = __webpack_require__(199);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 651 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 652 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87),
	    arrayMap = __webpack_require__(291),
	    isArray = __webpack_require__(31),
	    isSymbol = __webpack_require__(205);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(89),
	    last = __webpack_require__(722),
	    parent = __webpack_require__(702),
	    toKey = __webpack_require__(90);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 655 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(199);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(238)(module)))

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(191);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 659 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(191);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 662 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(103),
	    getSymbols = __webpack_require__(193);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(103),
	    getSymbolsIn = __webpack_require__(302);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(47);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(201);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 667 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(719);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87),
	    Uint8Array = __webpack_require__(288),
	    eq = __webpack_require__(198),
	    equalArrays = __webpack_require__(297),
	    mapToArray = __webpack_require__(696),
	    setToArray = __webpack_require__(705);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(300);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(303),
	    keys = __webpack_require__(91);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 673 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(89),
	    isArguments = __webpack_require__(200),
	    isArray = __webpack_require__(31),
	    isIndex = __webpack_require__(194),
	    isLength = __webpack_require__(204),
	    toKey = __webpack_require__(90);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(134);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(134);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(134);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(134);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 680 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(191),
	    cloneDataView = __webpack_require__(658),
	    cloneRegExp = __webpack_require__(659),
	    cloneSymbol = __webpack_require__(660),
	    cloneTypedArray = __webpack_require__(661);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(627),
	    getPrototype = __webpack_require__(192),
	    isPrototype = __webpack_require__(196);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(87),
	    isArguments = __webpack_require__(200),
	    isArray = __webpack_require__(31);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 684 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(665);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 686 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(130);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(616),
	    ListCache = __webpack_require__(129),
	    Map = __webpack_require__(184);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(132);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(132);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(132);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(132);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 696 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(723);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(305);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 699 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 700 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(621);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(131),
	    baseSlice = __webpack_require__(651);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 703 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 704 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 705 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(650),
	    shortOut = __webpack_require__(707);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 707 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(129);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 709 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 710 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 711 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(129),
	    Map = __webpack_require__(184),
	    MapCache = __webpack_require__(185);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(697);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(293);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(628);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(131);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(634),
	    baseUnary = __webpack_require__(190),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(88),
	    getPrototype = __webpack_require__(192),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(637),
	    baseUnary = __webpack_require__(190),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 721 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 722 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(185);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(644),
	    flatRest = __webpack_require__(298);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(646),
	    basePropertyDeep = __webpack_require__(647),
	    isKey = __webpack_require__(195),
	    toKey = __webpack_require__(90);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(623),
	    baseEach = __webpack_require__(294),
	    baseIteratee = __webpack_require__(639),
	    baseReduce = __webpack_require__(648),
	    isArray = __webpack_require__(31);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(314);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(45);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(730);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 730 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(891);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(180);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _controlPosition = __webpack_require__(93);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _MapControl2 = __webpack_require__(105);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var AttributionControl = function (_MapControl) {
	  _inherits(AttributionControl, _MapControl);
	
	  function AttributionControl() {
	    _classCallCheck(this, AttributionControl);
	
	    return _possibleConstructorReturn(this, (AttributionControl.__proto__ || Object.getPrototypeOf(AttributionControl)).apply(this, arguments));
	  }
	
	  _createClass(AttributionControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.attribution(props);
	    }
	  }]);
	
	  return AttributionControl;
	}(_MapControl3.default);
	
	AttributionControl.propTypes = {
	  position: _controlPosition2.default,
	  prefix: _react.PropTypes.string
	};
	exports.default = AttributionControl;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Circle = function (_Path) {
	  _inherits(Circle, _Path);
	
	  function Circle() {
	    _classCallCheck(this, Circle);
	
	    return _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).apply(this, arguments));
	  }
	
	  _createClass(Circle, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var center = props.center,
	          radius = props.radius,
	          options = _objectWithoutProperties(props, ['center', 'radius']);
	
	      return (0, _leaflet.circle)(center, radius, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.center !== fromProps.center) {
	        this.leafletElement.setLatLng(toProps.center);
	      }
	      if (toProps.radius !== fromProps.radius) {
	        this.leafletElement.setRadius(toProps.radius);
	      }
	    }
	  }]);
	
	  return Circle;
	}(_Path3.default);
	
	Circle.propTypes = {
	  center: _latlng2.default.isRequired,
	  children: _children2.default,
	  radius: _react.PropTypes.number.isRequired
	};
	exports.default = Circle;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var CircleMarker = function (_Path) {
	  _inherits(CircleMarker, _Path);
	
	  function CircleMarker() {
	    _classCallCheck(this, CircleMarker);
	
	    return _possibleConstructorReturn(this, (CircleMarker.__proto__ || Object.getPrototypeOf(CircleMarker)).apply(this, arguments));
	  }
	
	  _createClass(CircleMarker, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var center = props.center,
	          options = _objectWithoutProperties(props, ['center']);
	
	      return (0, _leaflet.circleMarker)(center, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.center !== fromProps.center) {
	        this.leafletElement.setLatLng(toProps.center);
	      }
	      if (toProps.radius !== fromProps.radius) {
	        this.leafletElement.setRadius(toProps.radius);
	      }
	    }
	  }]);
	
	  return CircleMarker;
	}(_Path3.default);
	
	CircleMarker.propTypes = {
	  center: _latlng2.default.isRequired,
	  children: _children2.default,
	  radius: _react.PropTypes.number
	};
	exports.default = CircleMarker;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _layerContainer = __webpack_require__(94);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var FeatureGroup = function (_Path) {
	  _inherits(FeatureGroup, _Path);
	
	  function FeatureGroup() {
	    _classCallCheck(this, FeatureGroup);
	
	    return _possibleConstructorReturn(this, (FeatureGroup.__proto__ || Object.getPrototypeOf(FeatureGroup)).apply(this, arguments));
	  }
	
	  _createClass(FeatureGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement,
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return (0, _leaflet.featureGroup)(this.getOptions(props));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(FeatureGroup.prototype.__proto__ || Object.getPrototypeOf(FeatureGroup.prototype), 'componentDidMount', this).call(this);
	      this.setStyle(this.props);
	    }
	  }]);
	
	  return FeatureGroup;
	}(_Path3.default);
	
	FeatureGroup.childContextTypes = {
	  children: _children2.default,
	  layerContainer: _layerContainer2.default,
	  popupContainer: _react.PropTypes.object
	};
	exports.default = FeatureGroup;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(203);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var GeoJSON = function (_Path) {
	  _inherits(GeoJSON, _Path);
	
	  function GeoJSON() {
	    _classCallCheck(this, GeoJSON);
	
	    return _possibleConstructorReturn(this, (GeoJSON.__proto__ || Object.getPrototypeOf(GeoJSON)).apply(this, arguments));
	  }
	
	  _createClass(GeoJSON, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var data = props.data,
	          options = _objectWithoutProperties(props, ['data']);
	
	      return (0, _leaflet.geoJSON)(data, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if ((0, _isFunction3.default)(toProps.style)) {
	        this.setStyle(toProps.style);
	      } else {
	        this.setStyleIfChanged(fromProps, toProps);
	      }
	    }
	  }]);
	
	  return GeoJSON;
	}(_Path3.default);
	
	GeoJSON.propTypes = {
	  children: _children2.default,
	  data: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]).isRequired
	};
	exports.default = GeoJSON;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _bounds = __webpack_require__(138);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ImageOverlay = function (_MapLayer) {
	  _inherits(ImageOverlay, _MapLayer);
	
	  function ImageOverlay() {
	    _classCallCheck(this, ImageOverlay);
	
	    return _possibleConstructorReturn(this, (ImageOverlay.__proto__ || Object.getPrototypeOf(ImageOverlay)).apply(this, arguments));
	  }
	
	  _createClass(ImageOverlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var bounds = props.bounds,
	          url = props.url,
	          options = _objectWithoutProperties(props, ['bounds', 'url']);
	
	      return (0, _leaflet.imageOverlay)(url, bounds, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.url !== fromProps.url) {
	        this.leafletElement.setUrl(toProps.url);
	      }
	      if (toProps.opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(toProps.opacity);
	      }
	    }
	  }]);
	
	  return ImageOverlay;
	}(_MapLayer3.default);
	
	ImageOverlay.propTypes = {
	  attribution: _react.PropTypes.string,
	  bounds: _bounds2.default.isRequired,
	  children: _children2.default,
	  opacity: _react.PropTypes.number,
	  url: _react.PropTypes.string.isRequired
	};
	ImageOverlay.childContextTypes = {
	  popupContainer: _react.PropTypes.object
	};
	exports.default = ImageOverlay;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _layerContainer = __webpack_require__(94);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var LayerGroup = function (_MapLayer) {
	  _inherits(LayerGroup, _MapLayer);
	
	  function LayerGroup() {
	    _classCallCheck(this, LayerGroup);
	
	    return _possibleConstructorReturn(this, (LayerGroup.__proto__ || Object.getPrototypeOf(LayerGroup)).apply(this, arguments));
	  }
	
	  _createClass(LayerGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement() {
	      return (0, _leaflet.layerGroup)(this.getOptions());
	    }
	  }]);
	
	  return LayerGroup;
	}(_MapLayer3.default);
	
	LayerGroup.childContextTypes = {
	  layerContainer: _layerContainer2.default
	};
	exports.default = LayerGroup;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _children2 = __webpack_require__(16);
	
	var _children3 = _interopRequireDefault(_children2);
	
	var _controlPosition = __webpack_require__(93);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _layerContainer = __webpack_require__(94);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapControl2 = __webpack_require__(105);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var baseControlledLayerPropTypes = {
	  checked: _react.PropTypes.bool,
	  children: _react.PropTypes.node.isRequired,
	  removeLayer: _react.PropTypes.func,
	  removeLayerControl: _react.PropTypes.func
	};
	
	var controlledLayerPropTypes = _extends({}, baseControlledLayerPropTypes, {
	  addBaseLayer: _react.PropTypes.func,
	  addOverlay: _react.PropTypes.func,
	  name: _react.PropTypes.string.isRequired
	});
	
	// Abtract class for layer container, extended by BaseLayer and Overlay
	
	var ControlledLayer = function (_Component) {
	  _inherits(ControlledLayer, _Component);
	
	  function ControlledLayer() {
	    _classCallCheck(this, ControlledLayer);
	
	    return _possibleConstructorReturn(this, (ControlledLayer.__proto__ || Object.getPrototypeOf(ControlledLayer)).apply(this, arguments));
	  }
	
	  _createClass(ControlledLayer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: {
	          addLayer: this.addLayer.bind(this),
	          removeLayer: this.removeLayer.bind(this)
	        }
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var checked = _ref.checked;
	
	      // Handle dynamically (un)checking the layer => adding/removing from the map
	      if (checked && !this.props.checked) {
	        this.context.map.addLayer(this.layer);
	      } else if (this.props.checked && !checked) {
	        this.context.map.removeLayer(this.layer);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.removeLayerControl(this.layer);
	    }
	  }, {
	    key: 'addLayer',
	    value: function addLayer() {
	      throw new Error('Must be implemented in extending class');
	    }
	  }, {
	    key: 'removeLayer',
	    value: function removeLayer(layer) {
	      this.props.removeLayer(layer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return ControlledLayer;
	}(_react.Component);
	
	ControlledLayer.propTypes = baseControlledLayerPropTypes;
	ControlledLayer.contextTypes = {
	  map: _map2.default
	};
	ControlledLayer.childContextTypes = {
	  layerContainer: _layerContainer2.default
	};
	
	var BaseLayer = function (_ControlledLayer) {
	  _inherits(BaseLayer, _ControlledLayer);
	
	  function BaseLayer() {
	    _classCallCheck(this, BaseLayer);
	
	    return _possibleConstructorReturn(this, (BaseLayer.__proto__ || Object.getPrototypeOf(BaseLayer)).apply(this, arguments));
	  }
	
	  _createClass(BaseLayer, [{
	    key: 'addLayer',
	    value: function addLayer(layer) {
	      this.layer = layer; // Keep layer reference to handle dynamic changes of props
	      var _props = this.props,
	          addBaseLayer = _props.addBaseLayer,
	          checked = _props.checked,
	          name = _props.name;
	
	      addBaseLayer(layer, name, checked);
	    }
	  }]);
	
	  return BaseLayer;
	}(ControlledLayer);
	
	BaseLayer.propTypes = controlledLayerPropTypes;
	
	var Overlay = function (_ControlledLayer2) {
	  _inherits(Overlay, _ControlledLayer2);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'addLayer',
	    value: function addLayer(layer) {
	      this.layer = layer; // Keep layer reference to handle dynamic changes of props
	      var _props2 = this.props,
	          addOverlay = _props2.addOverlay,
	          checked = _props2.checked,
	          name = _props2.name;
	
	      addOverlay(layer, name, checked);
	    }
	  }]);
	
	  return Overlay;
	}(ControlledLayer);
	
	Overlay.propTypes = controlledLayerPropTypes;
	
	var LayersControl = function (_MapControl) {
	  _inherits(LayersControl, _MapControl);
	
	  function LayersControl() {
	    _classCallCheck(this, LayersControl);
	
	    return _possibleConstructorReturn(this, (LayersControl.__proto__ || Object.getPrototypeOf(LayersControl)).apply(this, arguments));
	  }
	
	  _createClass(LayersControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = _objectWithoutProperties(props, ['children']);
	
	      return _leaflet.control.layers(undefined, undefined, options);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _get(LayersControl.prototype.__proto__ || Object.getPrototypeOf(LayersControl.prototype), 'componentWillMount', this).call(this);
	      this.controlProps = {
	        addBaseLayer: this.addBaseLayer.bind(this),
	        addOverlay: this.addOverlay.bind(this),
	        removeLayer: this.removeLayer.bind(this),
	        removeLayerControl: this.removeLayerControl.bind(this)
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        _get(LayersControl.prototype.__proto__ || Object.getPrototypeOf(LayersControl.prototype), 'componentWillUnmount', _this5).call(_this5);
	      }, 0);
	    }
	  }, {
	    key: 'addBaseLayer',
	    value: function addBaseLayer(layer, name) {
	      var checked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (checked) {
	        this.context.map.addLayer(layer);
	      }
	      this.leafletElement.addBaseLayer(layer, name);
	    }
	  }, {
	    key: 'addOverlay',
	    value: function addOverlay(layer, name) {
	      var checked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (checked) {
	        this.context.map.addLayer(layer);
	      }
	      this.leafletElement.addOverlay(layer, name);
	    }
	  }, {
	    key: 'removeLayer',
	    value: function removeLayer(layer) {
	      this.context.map.removeLayer(layer);
	    }
	  }, {
	    key: 'removeLayerControl',
	    value: function removeLayerControl(layer) {
	      this.leafletElement.removeLayer(layer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var children = _react.Children.map(this.props.children, function (child) {
	        return child ? (0, _react.cloneElement)(child, _this6.controlProps) : null;
	      });
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        children
	      );
	    }
	  }]);
	
	  return LayersControl;
	}(_MapControl3.default);
	
	LayersControl.propTypes = {
	  baseLayers: _react.PropTypes.object,
	  children: _children3.default,
	  overlays: _react.PropTypes.object,
	  position: _controlPosition2.default
	};
	LayersControl.contextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default
	};
	exports.default = LayersControl;
	
	
	LayersControl.BaseLayer = BaseLayer;
	LayersControl.Overlay = Overlay;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(312);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _isUndefined2 = __webpack_require__(721);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bounds = __webpack_require__(138);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _layerContainer = __webpack_require__(94);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(104);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var OTHER_PROPS = ['children', 'className', 'id', 'style', 'useFlyTo'];
	
	var normalizeCenter = function normalizeCenter(pos) {
	  return Array.isArray(pos) ? pos : [pos.lat, pos.lon ? pos.lon : pos.lng];
	};
	
	var Map = function (_MapComponent) {
	  _inherits(Map, _MapComponent);
	
	  function Map(props, context) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props, context));
	
	    _this.bindContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.className = props.className;
	    return _this;
	  }
	
	  _createClass(Map, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement,
	        map: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet2.default.map(this.container, props);
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      var animate = toProps.animate,
	          bounds = toProps.bounds,
	          boundsOptions = toProps.boundsOptions,
	          center = toProps.center,
	          className = toProps.className,
	          maxBounds = toProps.maxBounds,
	          useFlyTo = toProps.useFlyTo,
	          zoom = toProps.zoom;
	
	
	      if (className !== fromProps.className) {
	        if (fromProps.className) {
	          _leaflet2.default.DomUtil.removeClass(this.container, fromProps.className);
	        }
	        if (className) {
	          _leaflet2.default.DomUtil.addClass(this.container, className);
	        }
	      }
	
	      if (center && this.shouldUpdateCenter(center, fromProps.center)) {
	        if (useFlyTo) {
	          this.leafletElement.flyTo(center, zoom, { animate: animate });
	        } else {
	          this.leafletElement.setView(center, zoom, { animate: animate });
	        }
	      } else if (zoom && zoom !== fromProps.zoom) {
	        this.leafletElement.setZoom(zoom);
	      }
	
	      if (maxBounds && this.shouldUpdateBounds(maxBounds, fromProps.maxBounds)) {
	        this.leafletElement.setMaxBounds(maxBounds);
	      }
	
	      if (bounds && (this.shouldUpdateBounds(bounds, fromProps.bounds) || boundsOptions !== fromProps.boundsOptions)) {
	        if (useFlyTo) {
	          this.leafletElement.flyToBounds(bounds, boundsOptions);
	        } else {
	          this.leafletElement.fitBounds(bounds, boundsOptions);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = (0, _omit3.default)(this.props, OTHER_PROPS);
	      this.leafletElement = this.createLeafletElement(props);
	      if (!(0, _isUndefined3.default)(props.bounds)) {
	        this.leafletElement.fitBounds(props.bounds, props.boundsOptions);
	      }
	      _get(Map.prototype.__proto__ || Object.getPrototypeOf(Map.prototype), 'componentDidMount', this).call(this);
	      this.forceUpdate(); // Re-render now that leafletElement is created
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _get(Map.prototype.__proto__ || Object.getPrototypeOf(Map.prototype), 'componentWillUnmount', this).call(this);
	      this.leafletElement.remove();
	    }
	  }, {
	    key: 'shouldUpdateCenter',
	    value: function shouldUpdateCenter(next, prev) {
	      if (!prev) return true;
	      next = normalizeCenter(next);
	      prev = normalizeCenter(prev);
	      return next[0] !== prev[0] || next[1] !== prev[1];
	    }
	  }, {
	    key: 'shouldUpdateBounds',
	    value: function shouldUpdateBounds(next, prev) {
	      if (!prev) return true;
	      next = _leaflet2.default.latLngBounds(next);
	      prev = _leaflet2.default.latLngBounds(prev);
	      return !next.equals(prev);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var map = this.leafletElement;
	      var children = map ? this.props.children : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.className,
	          id: this.props.id,
	          ref: this.bindContainer,
	          style: this.props.style },
	        children
	      );
	    }
	  }]);
	
	  return Map;
	}(_MapComponent3.default);
	
	Map.propTypes = {
	  animate: _react.PropTypes.bool,
	  bounds: _bounds2.default,
	  boundsOptions: _react.PropTypes.object,
	  center: _latlng2.default,
	  children: _children2.default,
	  className: _react.PropTypes.string,
	  id: _react.PropTypes.string,
	  maxBounds: _bounds2.default,
	  maxZoom: _react.PropTypes.number,
	  minZoom: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  useFlyTo: _react.PropTypes.bool,
	  zoom: _react.PropTypes.number
	};
	Map.defaultProps = {
	  animate: false,
	  useFlyTo: false
	};
	Map.childContextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default
	};
	exports.default = Map;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Marker = function (_MapLayer) {
	  _inherits(Marker, _MapLayer);
	
	  function Marker() {
	    _classCallCheck(this, Marker);
	
	    return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
	  }
	
	  _createClass(Marker, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var position = props.position,
	          options = _objectWithoutProperties(props, ['position']);
	
	      return (0, _leaflet.marker)(position, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setLatLng(toProps.position);
	      }
	      if (toProps.icon !== fromProps.icon) {
	        this.leafletElement.setIcon(toProps.icon);
	      }
	      if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
	        this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
	      }
	      if (toProps.opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(toProps.opacity);
	      }
	      if (toProps.draggable !== fromProps.draggable) {
	        if (toProps.draggable) {
	          this.leafletElement.dragging.enable();
	        } else {
	          this.leafletElement.dragging.disable();
	        }
	      }
	    }
	  }]);
	
	  return Marker;
	}(_MapLayer3.default);
	
	Marker.propTypes = {
	  children: _children2.default,
	  icon: _react.PropTypes.instanceOf(_leaflet.Icon),
	  opacity: _react.PropTypes.number,
	  position: _latlng2.default.isRequired,
	  zIndexOffset: _react.PropTypes.number
	};
	Marker.childContextTypes = {
	  popupContainer: _react.PropTypes.object
	};
	exports.default = Marker;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uniqueId2 = __webpack_require__(728);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _omit2 = __webpack_require__(312);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _forEach2 = __webpack_require__(307);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(893);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var LEAFLET_PANES = ['tile', 'shadow', 'overlay', 'map', 'marker', 'tooltip', 'popup'];
	
	var isLeafletPane = function isLeafletPane(name) {
	  return LEAFLET_PANES.indexOf(name.replace(/-*pane/gi, '')) !== -1;
	};
	
	var paneStyles = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var Pane = function (_Component) {
	  _inherits(Pane, _Component);
	
	  function Pane() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pane);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pane.__proto__ || Object.getPrototypeOf(Pane)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: undefined
	    }, _this.setStyle = function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
	          style = _ref2.style,
	          className = _ref2.className;
	
	      var pane = _this.getPane(_this.state.name);
	      if (pane) {
	        if (className) {
	          pane.classList.add(className);
	        }
	        if (style) {
	          (0, _forEach3.default)(style, function (value, key) {
	            pane.style[key] = value;
	          });
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pane, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        pane: this.state.name
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPane(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.state.name) {
	        // Do nothing if this.state.name is undefined due to errors or
	        // an invalid props.name value
	        return;
	      }
	
	      // If the 'name' prop has changed the current pane is unmounted and a new
	      // pane is created.
	      if (nextProps.name !== this.props.name) {
	        this.removePane();
	        this.createPane(nextProps);
	      } else {
	        // Remove the previous css class name from the pane if it has changed.
	        // setStyle will take care of adding in the updated className
	        if (this.props.className && nextProps.className !== this.props.className) {
	          var _pane = this.getPane();
	          if (_pane) _pane.classList.remove(this.props.className);
	        }
	
	        // Update the pane's DOM node style and class
	        this.setStyle(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removePane();
	    }
	  }, {
	    key: 'createPane',
	    value: function createPane(props) {
	      var map = this.context.map;
	      var name = props.name || 'pane-' + (0, _uniqueId3.default)();
	
	      if (map && map.createPane) {
	        var isDefault = isLeafletPane(name);
	        var existing = isDefault || this.getPane(name);
	
	        if (!existing) {
	          map.createPane(name, this.getParentPane());
	        } else {
	          var message = isDefault ? 'You must use a unique name for a pane that is not a default leaflet pane (' + name + ')' : 'A pane with this name already exists. (' + name + ')';
	           false ? (0, _warning2.default)(false, message) : void 0;
	        }
	
	        this.setState({ name: name }, this.setStyle);
	      }
	    }
	  }, {
	    key: 'removePane',
	    value: function removePane() {
	      // Remove the created pane
	      var name = this.state.name;
	
	      if (name) {
	        var _pane2 = this.getPane(name);
	        if (_pane2 && _pane2.remove) _pane2.remove();
	
	        var map = this.context.map;
	        if (map && map._panes) {
	          map._panes = (0, _omit3.default)(map._panes, name);
	          map._paneRenderers = (0, _omit3.default)(map._paneRenderers, name);
	        }
	
	        this.setState({ name: undefined });
	      }
	    }
	  }, {
	    key: 'getParentPane',
	    value: function getParentPane() {
	      return this.getPane(this.props.pane || this.context.pane);
	    }
	  }, {
	    key: 'getPane',
	    value: function getPane(name) {
	      return name ? this.context.map.getPane(name) : undefined;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.name ? _react2.default.createElement(
	        'div',
	        { style: paneStyles },
	        this.props.children
	      ) : null;
	    }
	  }]);
	
	  return Pane;
	}(_react.Component);
	
	Pane.propTypes = {
	  name: _react.PropTypes.string,
	  children: _children2.default,
	  map: _map2.default,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  pane: _react.PropTypes.string
	};
	Pane.contextTypes = {
	  map: _map2.default,
	  pane: _react.PropTypes.string
	};
	Pane.childContextTypes = {
	  pane: _react.PropTypes.string
	};
	exports.default = Pane;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlngList = __webpack_require__(139);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var multiLatLngListType = _react.PropTypes.arrayOf(_latlngList2.default);
	
	var Polygon = function (_Path) {
	  _inherits(Polygon, _Path);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var positions = props.positions,
	          options = _objectWithoutProperties(props, ['positions']);
	
	      return (0, _leaflet.polygon)(positions, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.positions !== fromProps.positions) {
	        this.leafletElement.setLatLngs(toProps.positions);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	
	  return Polygon;
	}(_Path3.default);
	
	Polygon.propTypes = {
	  children: _children2.default,
	  popupContainer: _react.PropTypes.object,
	  positions: _react.PropTypes.oneOfType([_latlngList2.default, multiLatLngListType, _react.PropTypes.arrayOf(multiLatLngListType)]).isRequired
	};
	exports.default = Polygon;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlngList = __webpack_require__(139);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Polyline = function (_Path) {
	  _inherits(Polyline, _Path);
	
	  function Polyline() {
	    _classCallCheck(this, Polyline);
	
	    return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
	  }
	
	  _createClass(Polyline, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var positions = props.positions,
	          options = _objectWithoutProperties(props, ['positions']);
	
	      return (0, _leaflet.polyline)(positions, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.positions !== fromProps.positions) {
	        this.leafletElement.setLatLngs(toProps.positions);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	
	  return Polyline;
	}(_Path3.default);
	
	Polyline.propTypes = {
	  children: _children2.default,
	  positions: _react.PropTypes.oneOfType([_latlngList2.default, _react.PropTypes.arrayOf(_latlngList2.default)]).isRequired
	};
	exports.default = Polyline;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _reactDom = __webpack_require__(137);
	
	var _latlng = __webpack_require__(77);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(104);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Popup = function (_MapComponent) {
	  _inherits(Popup, _MapComponent);
	
	  function Popup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Popup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popup.__proto__ || Object.getPrototypeOf(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.onPopupOpen = function (_ref2) {
	      var popup = _ref2.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.renderPopupContent();
	      }
	    }, _this.onPopupClose = function (_ref3) {
	      var popup = _ref3.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.removePopupContent();
	      }
	    }, _this.renderPopupContent = function () {
	      if (_this.props.children) {
	        (0, _reactDom.render)(_react.Children.only(_this.props.children), _this.leafletElement._contentNode);
	        _this.leafletElement.update();
	      } else {
	        _this.removePopupContent();
	      }
	    }, _this.removePopupContent = function () {
	      if (_this.leafletElement._contentNode) {
	        (0, _reactDom.unmountComponentAtNode)(_this.leafletElement._contentNode);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Popup, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = _objectWithoutProperties(props, ['children']);
	
	      return (0, _leaflet.popup)(this.getOptions(options), this.context.popupContainer);
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setLatLng(toProps.position);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _get(Popup.prototype.__proto__ || Object.getPrototypeOf(Popup.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	
	      this.context.map.on({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var position = this.props.position;
	      var _context = this.context,
	          map = _context.map,
	          popupContainer = _context.popupContainer;
	
	      var el = this.leafletElement;
	
	      if (popupContainer) {
	        // Attach to container component
	        popupContainer.bindPopup(el);
	      } else {
	        // Attach to a Map
	        if (position) {
	          el.setLatLng(position);
	        }
	        el.openOn(map);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	
	      if (this.leafletElement.isOpen()) {
	        this.renderPopupContent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.map.off({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	      this.context.map.removeLayer(this.leafletElement);
	      _get(Popup.prototype.__proto__ || Object.getPrototypeOf(Popup.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Popup;
	}(_MapComponent3.default);
	
	Popup.propTypes = {
	  children: _react.PropTypes.node,
	  position: _latlng2.default
	};
	Popup.contextTypes = {
	  map: _map2.default,
	  popupContainer: _react.PropTypes.object,
	  pane: _react.PropTypes.string
	};
	exports.default = Popup;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _bounds = __webpack_require__(138);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Rectangle = function (_Path) {
	  _inherits(Rectangle, _Path);
	
	  function Rectangle() {
	    _classCallCheck(this, Rectangle);
	
	    return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
	  }
	
	  _createClass(Rectangle, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var bounds = props.bounds,
	          options = _objectWithoutProperties(props, ['bounds']);
	
	      return (0, _leaflet.rectangle)(bounds, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.bounds !== fromProps.bounds) {
	        this.leafletElement.setBounds(toProps.bounds);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	
	  return Rectangle;
	}(_Path3.default);
	
	Rectangle.propTypes = {
	  children: _children2.default,
	  bounds: _bounds2.default.isRequired,
	  popupContainer: _react.PropTypes.object
	};
	exports.default = Rectangle;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _controlPosition = __webpack_require__(93);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _MapControl2 = __webpack_require__(105);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ScaleControl = function (_MapControl) {
	  _inherits(ScaleControl, _MapControl);
	
	  function ScaleControl() {
	    _classCallCheck(this, ScaleControl);
	
	    return _possibleConstructorReturn(this, (ScaleControl.__proto__ || Object.getPrototypeOf(ScaleControl)).apply(this, arguments));
	  }
	
	  _createClass(ScaleControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.scale(props);
	    }
	  }]);
	
	  return ScaleControl;
	}(_MapControl3.default);
	
	ScaleControl.propTypes = {
	  imperial: _react.PropTypes.bool,
	  maxWidth: _react.PropTypes.number,
	  metric: _react.PropTypes.bool,
	  position: _controlPosition2.default,
	  updateWhenIdle: _react.PropTypes.bool
	};
	exports.default = ScaleControl;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _GridLayer2 = __webpack_require__(208);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var TileLayer = function (_GridLayer) {
	  _inherits(TileLayer, _GridLayer);
	
	  function TileLayer() {
	    _classCallCheck(this, TileLayer);
	
	    return _possibleConstructorReturn(this, (TileLayer.__proto__ || Object.getPrototypeOf(TileLayer)).apply(this, arguments));
	  }
	
	  _createClass(TileLayer, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var url = props.url,
	          options = _objectWithoutProperties(props, ['url']);
	
	      return (0, _leaflet.tileLayer)(url, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      _get(TileLayer.prototype.__proto__ || Object.getPrototypeOf(TileLayer.prototype), 'updateLeafletElement', this).call(this, fromProps, toProps);
	      if (toProps.url !== fromProps.url) {
	        this.leafletElement.setUrl(toProps.url);
	      }
	    }
	  }]);
	
	  return TileLayer;
	}(_GridLayer3.default);
	
	TileLayer.propTypes = {
	  children: _children2.default,
	  opacity: _react.PropTypes.number,
	  url: _react.PropTypes.string.isRequired,
	  zIndex: _react.PropTypes.number
	};
	exports.default = TileLayer;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _reactDom = __webpack_require__(137);
	
	var _map = __webpack_require__(61);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(104);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Tooltip = function (_MapComponent) {
	  _inherits(Tooltip, _MapComponent);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.onTooltipOpen = function (_ref2) {
	      var tooltip = _ref2.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.renderTooltipContent();
	      }
	    }, _this.onTooltipClose = function (_ref3) {
	      var tooltip = _ref3.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.removeTooltipContent();
	      }
	    }, _this.renderTooltipContent = function () {
	      if (_this.props.children) {
	        (0, _reactDom.render)(_react.Children.only(_this.props.children), _this.leafletElement._contentNode);
	        _this.leafletElement.update();
	      } else {
	        _this.removeTooltipContent();
	      }
	    }, _this.removeTooltipContent = function () {
	      if (_this.leafletElement._contentNode) {
	        (0, _reactDom.unmountComponentAtNode)(_this.leafletElement._contentNode);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = _objectWithoutProperties(props, ['children']);
	
	      return (0, _leaflet.tooltip)(this.getOptions(options), this.context.popupContainer);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	
	      this.context.popupContainer.on({
	        tooltipopen: this.onTooltipOpen,
	        tooltipclose: this.onTooltipClose
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.context.popupContainer.bindTooltip(this.leafletElement);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.leafletElement.isOpen()) {
	        this.renderTooltipContent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.popupContainer.off({
	        tooltipopen: this.onTooltipOpen,
	        tooltipclose: this.onTooltipClose
	      });
	      this.context.map.removeLayer(this.leafletElement);
	      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(_MapComponent3.default);
	
	Tooltip.propTypes = {
	  children: _react.PropTypes.node
	};
	Tooltip.contextTypes = {
	  map: _map2.default,
	  popupContainer: _react.PropTypes.object,
	  pane: _react.PropTypes.string
	};
	exports.default = Tooltip;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(309);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _children = __webpack_require__(16);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _GridLayer2 = __webpack_require__(208);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var WMSTileLayer = function (_GridLayer) {
	  _inherits(WMSTileLayer, _GridLayer);
	
	  function WMSTileLayer() {
	    _classCallCheck(this, WMSTileLayer);
	
	    return _possibleConstructorReturn(this, (WMSTileLayer.__proto__ || Object.getPrototypeOf(WMSTileLayer)).apply(this, arguments));
	  }
	
	  _createClass(WMSTileLayer, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var url = props.url,
	          options = _objectWithoutProperties(props, ['url']);
	
	      return _leaflet.tileLayer.wms(url, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      _get(WMSTileLayer.prototype.__proto__ || Object.getPrototypeOf(WMSTileLayer.prototype), 'updateLeafletElement', this).call(this, fromProps, toProps);
	
	      var prevUrl = fromProps.url,
	          _po = fromProps.opacity,
	          _pz = fromProps.zIndex,
	          prevParams = _objectWithoutProperties(fromProps, ['url', 'opacity', 'zIndex']);
	
	      var url = toProps.url,
	          _o = toProps.opacity,
	          _z = toProps.zIndex,
	          params = _objectWithoutProperties(toProps, ['url', 'opacity', 'zIndex']);
	
	      if (url !== prevUrl) {
	        this.leafletElement.setUrl(url);
	      }
	      if (!(0, _isEqual3.default)(params, prevParams)) {
	        this.leafletElement.setParams(params);
	      }
	    }
	  }]);
	
	  return WMSTileLayer;
	}(_GridLayer3.default);
	
	WMSTileLayer.propTypes = {
	  children: _children2.default,
	  opacity: _react.PropTypes.number,
	  url: _react.PropTypes.string.isRequired,
	  zIndex: _react.PropTypes.number
	};
	exports.default = WMSTileLayer;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(11);
	
	var _react = __webpack_require__(2);
	
	var _MapControl2 = __webpack_require__(105);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	var _controlPosition = __webpack_require__(93);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ZoomControl = function (_MapControl) {
	  _inherits(ZoomControl, _MapControl);
	
	  function ZoomControl() {
	    _classCallCheck(this, ZoomControl);
	
	    return _possibleConstructorReturn(this, (ZoomControl.__proto__ || Object.getPrototypeOf(ZoomControl)).apply(this, arguments));
	  }
	
	  _createClass(ZoomControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.zoom(props);
	    }
	  }]);
	
	  return ZoomControl;
	}(_MapControl3.default);
	
	ZoomControl.propTypes = {
	  position: _controlPosition2.default,
	  zoomInText: _react.PropTypes.string,
	  zoomInTitle: _react.PropTypes.string,
	  zoomOutText: _react.PropTypes.string,
	  zoomOutTitle: _react.PropTypes.string
	};
	exports.default = ZoomControl;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZoomControl = exports.WMSTileLayer = exports.Tooltip = exports.TileLayer = exports.ScaleControl = exports.Rectangle = exports.Popup = exports.Polyline = exports.Polygon = exports.Path = exports.Pane = exports.Marker = exports.MapLayer = exports.MapControl = exports.MapComponent = exports.Map = exports.LayersControl = exports.LayerGroup = exports.ImageOverlay = exports.GridLayer = exports.GeoJSON = exports.FeatureGroup = exports.CircleMarker = exports.Circle = exports.AttributionControl = exports.PropTypes = undefined;
	
	var _types = __webpack_require__(755);
	
	var _PropTypes = _interopRequireWildcard(_types);
	
	var _AttributionControl2 = __webpack_require__(734);
	
	var _AttributionControl3 = _interopRequireDefault(_AttributionControl2);
	
	var _Circle2 = __webpack_require__(735);
	
	var _Circle3 = _interopRequireDefault(_Circle2);
	
	var _CircleMarker2 = __webpack_require__(736);
	
	var _CircleMarker3 = _interopRequireDefault(_CircleMarker2);
	
	var _FeatureGroup2 = __webpack_require__(737);
	
	var _FeatureGroup3 = _interopRequireDefault(_FeatureGroup2);
	
	var _GeoJSON2 = __webpack_require__(738);
	
	var _GeoJSON3 = _interopRequireDefault(_GeoJSON2);
	
	var _GridLayer2 = __webpack_require__(208);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	var _ImageOverlay2 = __webpack_require__(739);
	
	var _ImageOverlay3 = _interopRequireDefault(_ImageOverlay2);
	
	var _LayerGroup2 = __webpack_require__(740);
	
	var _LayerGroup3 = _interopRequireDefault(_LayerGroup2);
	
	var _LayersControl2 = __webpack_require__(741);
	
	var _LayersControl3 = _interopRequireDefault(_LayersControl2);
	
	var _Map2 = __webpack_require__(742);
	
	var _Map3 = _interopRequireDefault(_Map2);
	
	var _MapComponent2 = __webpack_require__(104);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var _MapControl2 = __webpack_require__(105);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	var _MapLayer2 = __webpack_require__(92);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	var _Marker2 = __webpack_require__(743);
	
	var _Marker3 = _interopRequireDefault(_Marker2);
	
	var _Pane2 = __webpack_require__(744);
	
	var _Pane3 = _interopRequireDefault(_Pane2);
	
	var _Path2 = __webpack_require__(60);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	var _Polygon2 = __webpack_require__(745);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Polyline2 = __webpack_require__(746);
	
	var _Polyline3 = _interopRequireDefault(_Polyline2);
	
	var _Popup2 = __webpack_require__(747);
	
	var _Popup3 = _interopRequireDefault(_Popup2);
	
	var _Rectangle2 = __webpack_require__(748);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _ScaleControl2 = __webpack_require__(749);
	
	var _ScaleControl3 = _interopRequireDefault(_ScaleControl2);
	
	var _TileLayer2 = __webpack_require__(750);
	
	var _TileLayer3 = _interopRequireDefault(_TileLayer2);
	
	var _Tooltip2 = __webpack_require__(751);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _WMSTileLayer2 = __webpack_require__(752);
	
	var _WMSTileLayer3 = _interopRequireDefault(_WMSTileLayer2);
	
	var _ZoomControl2 = __webpack_require__(753);
	
	var _ZoomControl3 = _interopRequireDefault(_ZoomControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.PropTypes = _PropTypes;
	exports.AttributionControl = _AttributionControl3.default;
	exports.Circle = _Circle3.default;
	exports.CircleMarker = _CircleMarker3.default;
	exports.FeatureGroup = _FeatureGroup3.default;
	exports.GeoJSON = _GeoJSON3.default;
	exports.GridLayer = _GridLayer3.default;
	exports.ImageOverlay = _ImageOverlay3.default;
	exports.LayerGroup = _LayerGroup3.default;
	exports.LayersControl = _LayersControl3.default;
	exports.Map = _Map3.default;
	exports.MapComponent = _MapComponent3.default;
	exports.MapControl = _MapControl3.default;
	exports.MapLayer = _MapLayer3.default;
	exports.Marker = _Marker3.default;
	exports.Pane = _Pane3.default;
	exports.Path = _Path3.default;
	exports.Polygon = _Polygon3.default;
	exports.Polyline = _Polyline3.default;
	exports.Popup = _Popup3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.ScaleControl = _ScaleControl3.default;
	exports.TileLayer = _TileLayer3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.WMSTileLayer = _WMSTileLayer3.default;
	exports.ZoomControl = _ZoomControl3.default;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.map = exports.layerContainer = exports.latlngList = exports.latlng = exports.controlPosition = exports.children = exports.bounds = undefined;
	
	var _bounds2 = __webpack_require__(138);
	
	var _bounds3 = _interopRequireDefault(_bounds2);
	
	var _children2 = __webpack_require__(16);
	
	var _children3 = _interopRequireDefault(_children2);
	
	var _controlPosition2 = __webpack_require__(93);
	
	var _controlPosition3 = _interopRequireDefault(_controlPosition2);
	
	var _latlng2 = __webpack_require__(77);
	
	var _latlng3 = _interopRequireDefault(_latlng2);
	
	var _latlngList2 = __webpack_require__(139);
	
	var _latlngList3 = _interopRequireDefault(_latlngList2);
	
	var _layerContainer2 = __webpack_require__(94);
	
	var _layerContainer3 = _interopRequireDefault(_layerContainer2);
	
	var _map2 = __webpack_require__(61);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.bounds = _bounds3.default;
	exports.children = _children3.default;
	exports.controlPosition = _controlPosition3.default;
	exports.latlng = _latlng3.default;
	exports.latlngList = _latlngList3.default;
	exports.layerContainer = _layerContainer3.default;
	exports.map = _map3.default;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(315);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(316);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(285);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(128);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(211);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(78);
	
	var _RouterContext = __webpack_require__(140);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _RouterUtils = __webpack_require__(317);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(140);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(209);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(140);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  var withContext = middlewares.map(function (m) {
	    return m.renderRouterContext;
	  }).filter(function (f) {
	    return f;
	  });
	  var withComponent = middlewares.map(function (m) {
	    return m.renderRouteComponent;
	  }).filter(function (f) {
	    return f;
	  });
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(611);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(319);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(95);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _AsyncUtils = __webpack_require__(209);
	
	var _deprecateObjectProperties = __webpack_require__(141);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = void 0;
	
	  if (false) {
	    nextStateWithLocation = _extends({}, nextState);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(nextStateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties from the first argument to `getComponent` and `getComponents` is deprecated. That argument is now the router state (`nextState`) rather than the location. To access the location, use `nextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	  } else {
	    nextStateWithLocation = _extends({}, nextState, location);
	  }
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(95);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  for (var p in params) {
	    if (Object.prototype.hasOwnProperty.call(params, p) && paramNames.indexOf(p) !== -1) {
	      routeParams[p] = params[p];
	    }
	  }
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(285);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(319);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(95);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(318);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(211);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _RouterUtils = __webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _AsyncUtils = __webpack_require__(209);
	
	var _PatternUtils = __webpack_require__(95);
	
	var _RouteUtils = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  route.getChildRoutes(location, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    route.getIndexRoute(location, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	    if (matched) {
	      remainingPathname = matched.remainingPathname;
	      paramNames = [].concat(paramNames, matched.paramNames);
	      paramValues = [].concat(paramValues, matched.paramValues);
	    } else {
	      remainingPathname = null;
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(128);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(211);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(18);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(614);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent) {
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    render: function render() {
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { router: this.context.router }));
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 777 */
46,
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(142);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(323);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var propTypes = {
		autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
		children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
		loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		options: _react.PropTypes.array.isRequired, // array of options
		placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
		searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
		value: _react2['default'].PropTypes.any };
	
	// initial field value
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = (function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
			this._cache = props.cache === defaultCache ? {} : props.cache;
	
			this.state = {
				isLoading: false,
				options: props.options
			};
	
			this._onInputChange = this._onInputChange.bind(this);
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				var _this = this;
	
				var propertiesToSync = ['options'];
				propertiesToSync.forEach(function (prop) {
					if (_this.props[prop] !== nextProps[prop]) {
						_this.setState(_defineProperty({}, prop, nextProps[prop]));
					}
				});
			}
		}, {
			key: 'clearOptions',
			value: function clearOptions() {
				this.setState({ options: [] });
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && cache.hasOwnProperty(inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
	
				return inputValue;
			}
		}, {
			key: '_onInputChange',
			value: function _onInputChange(inputValue) {
				var _props = this.props;
				var ignoreAccents = _props.ignoreAccents;
				var ignoreCase = _props.ignoreCase;
				var onInputChange = _props.onInputChange;
	
				if (ignoreAccents) {
					inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
				}
	
				if (ignoreCase) {
					inputValue = inputValue.toLowerCase();
				}
	
				if (onInputChange) {
					onInputChange(inputValue);
				}
	
				return this.loadOptions(inputValue);
			}
		}, {
			key: 'inputValue',
			value: function inputValue() {
				if (this.select) {
					return this.select.state.inputValue;
				}
				return '';
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props;
				var loadingPlaceholder = _props2.loadingPlaceholder;
				var noResultsText = _props2.noResultsText;
				var searchPromptText = _props2.searchPromptText;
				var isLoading = this.state.isLoading;
	
				var inputValue = this.inputValue();
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props;
				var children = _props3.children;
				var loadingPlaceholder = _props3.loadingPlaceholder;
				var placeholder = _props3.placeholder;
				var _state = this.state;
				var isLoading = _state.isLoading;
				var options = _state.options;
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					},
					onChange: function onChange(newValues) {
						if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
							_this3.clearOptions();
						}
						_this3.props.onChange(newValues);
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this._onInputChange
				}));
			}
		}]);
	
		return Async;
	})(_react.Component);
	
	exports['default'] = Async;
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	module.exports = exports['default'];

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(142);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function reduce(obj) {
		var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		return Object.keys(obj).reduce(function (props, key) {
			var value = obj[key];
			if (value !== undefined) props[key] = value;
			return props;
		}, props);
	}
	
	var AsyncCreatable = _react2['default'].createClass({
		displayName: 'AsyncCreatableSelect',
	
		render: function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_Select2['default'].Async,
				this.props,
				function (asyncProps) {
					return _react2['default'].createElement(
						_Select2['default'].Creatable,
						_this.props,
						function (creatableProps) {
							return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function (input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function (ref) {
									creatableProps.ref(ref);
									asyncProps.ref(ref);
								}
							}));
						}
					);
				}
			);
		}
	});
	
	module.exports = AsyncCreatable;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(142);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsDefaultFilterOptions = __webpack_require__(321);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(322);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var Creatable = _react2['default'].createClass({
		displayName: 'CreatableSelect',
	
		propTypes: {
			// Child function responsible for creating the inner Select component
			// This component can be used to compose HOCs (eg Creatable and Async)
			// (props: Object): PropTypes.element
			children: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.filterOptions
			filterOptions: _react2['default'].PropTypes.any,
	
			// Searches for any matching option within the set of options.
			// This function prevents duplicate options from being created.
			// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
			isOptionUnique: _react2['default'].PropTypes.func,
	
			// Determines if the current input text represents a valid option.
			// ({ label: string }): boolean
			isValidNewOption: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.menuRenderer
			menuRenderer: _react2['default'].PropTypes.any,
	
			// Factory to create new option.
			// ({ label: string, labelKey: string, valueKey: string }): Object
			newOptionCreator: _react2['default'].PropTypes.func,
	
			// input change handler: function (inputValue) {}
			onInputChange: _react2['default'].PropTypes.func,
	
			// input keyDown handler: function (event) {}
			onInputKeyDown: _react2['default'].PropTypes.func,
	
			// new option click handler: function (option) {}
			onNewOptionClick: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.options
			options: _react2['default'].PropTypes.array,
	
			// Creates prompt/placeholder option text.
			// (filterText: string): string
			promptTextCreator: _react2['default'].PropTypes.func,
	
			// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
			shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
		},
	
		// Default prop methods
		statics: {
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				filterOptions: _utilsDefaultFilterOptions2['default'],
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			};
		},
	
		createNewOption: function createNewOption() {
			var _props = this.props;
			var isValidNewOption = _props.isValidNewOption;
			var newOptionCreator = _props.newOptionCreator;
			var onNewOptionClick = _props.onNewOptionClick;
			var _props$options = _props.options;
			var options = _props$options === undefined ? [] : _props$options;
			var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });
	
				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);
	
						this.select.selectValue(option);
					}
				}
			}
		},
	
		filterOptions: function filterOptions() {
			var _props2 = this.props;
			var filterOptions = _props2.filterOptions;
			var isValidNewOption = _props2.isValidNewOption;
			var options = _props2.options;
			var promptTextCreator = _props2.promptTextCreator;
	
			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
			var excludeOptions = arguments[2] || [];
	
			var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;
	
				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});
	
				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});
	
				if (_isOptionUnique2) {
					var _prompt = promptTextCreator(this.inputValue);
	
					this._createPlaceholderOption = _newOptionCreator({
						label: _prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}
	
			return filteredOptions;
		},
	
		isOptionUnique: function isOptionUnique(_ref2) {
			var option = _ref2.option;
			var options = _ref2.options;
			var isOptionUnique = this.props.isOptionUnique;
	
			options = options || this.select.filterOptions();
	
			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		},
	
		menuRenderer: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;
	
			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		},
	
		onInputChange: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;
	
			if (onInputChange) {
				onInputChange(input);
			}
	
			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		},
	
		onInputKeyDown: function onInputKeyDown(event) {
			var _props3 = this.props;
			var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
			var onInputKeyDown = _props3.onInputKeyDown;
	
			var focusedOption = this.select.getFocusedOption();
	
			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();
	
				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		},
	
		onOptionSelect: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		},
	
		render: function render() {
			var _this = this;
	
			var _props4 = this.props;
			var newOptionCreator = _props4.newOptionCreator;
			var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;
	
			var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
			var children = this.props.children;
	
			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.
			if (!children) {
				children = defaultChildren;
			}
	
			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref) {
					_this.select = _ref;
	
					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref) {
						_this.labelKey = _ref.props.labelKey;
						_this.valueKey = _ref.props.valueKey;
					}
				}
			});
	
			return children(props);
		}
	});
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option;
		var options = _ref3.options;
		var labelKey = _ref3.labelKey;
		var valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label;
		var labelKey = _ref5.labelKey;
		var valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	module.exports = Creatable;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(109);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
			optionIndex: _react2['default'].PropTypes.number },
		// index of the option, used to generate unique ids for aria
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var _props = this.props;
			var option = _props.option;
			var instancePrefix = _props.instancePrefix;
			var optionIndex = _props.optionIndex;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(109);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports["default"] = arrowRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2["default"].createElement("span", {
			className: "Select-arrow",
			onMouseDown: onMouseDown
		});
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = clearRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function clearRenderer() {
		return _react2['default'].createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	}
	
	;
	module.exports = exports['default'];

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	var PropTypes = __webpack_require__(136);
	var createClass = __webpack_require__(125);
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var AutosizeInput = createClass({
		propTypes: {
			className: PropTypes.string, // className for the outer element
			defaultValue: PropTypes.any, // default field value
			inputClassName: PropTypes.string, // className for the input element
			inputRef: PropTypes.func, // ref callback for the input element
			inputStyle: PropTypes.object, // css styles for the input element
			minWidth: PropTypes.oneOfType([// minimum width for input element
			PropTypes.number, PropTypes.string]),
			onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
			onChange: PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: PropTypes.string, // placeholder text
			placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
			style: PropTypes.object, // css styles for the outer element
			value: PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth,
				inputId: '_' + Math.random().toString(36).substr(2, 12)
			};
		},
		componentDidMount: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		},
		componentWillUnmount: function componentWillUnmount() {
			this.mounted = false;
		},
		inputRef: function inputRef(el) {
			this.input = el;
			if (typeof this.props.inputRef === 'function') {
				this.props.inputRef(el);
			}
		},
		placeHolderSizerRef: function placeHolderSizerRef(el) {
			this.placeHolderSizer = el;
		},
		sizerRef: function sizerRef(el) {
			this.sizer = el;
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.input;
		},
		focus: function focus() {
			this.input.focus();
		},
		blur: function blur() {
			this.input.blur();
		},
		select: function select() {
			this.input.select();
		},
		render: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});
	
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				React.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScaleUtils = exports.AxisUtils = exports.makeWidthFlexible = exports.Sunburst = exports.Sankey = exports.RadialChart = exports.Treemap = exports.ContinuousSizeLegend = exports.ContinuousColorLegend = exports.SearchableDiscreteColorLegend = exports.DiscreteColorLegend = exports.Voronoi = exports.HorizontalGridLines = exports.VerticalGridLines = exports.GridLines = exports.CircularGridLines = exports.YAxis = exports.XAxis = exports.XYPlot = exports.Crosshair = exports.Hint = exports.ArcSeries = exports.LineMarkSeries = exports.AreaSeries = exports.HeatmapSeries = exports.MarkSeries = exports.RectSeries = exports.PolygonSeries = exports.HorizontalRectSeries = exports.VerticalRectSeries = exports.HorizontalBarSeries = exports.VerticalBarSeries = exports.LineSeries = exports.AbstractSeries = undefined;
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(328);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _verticalBarSeries = __webpack_require__(807);
	
	var _verticalBarSeries2 = _interopRequireDefault(_verticalBarSeries);
	
	var _horizontalBarSeries = __webpack_require__(803);
	
	var _horizontalBarSeries2 = _interopRequireDefault(_horizontalBarSeries);
	
	var _verticalRectSeries = __webpack_require__(808);
	
	var _verticalRectSeries2 = _interopRequireDefault(_verticalRectSeries);
	
	var _horizontalRectSeries = __webpack_require__(804);
	
	var _horizontalRectSeries2 = _interopRequireDefault(_horizontalRectSeries);
	
	var _polygonSeries = __webpack_require__(806);
	
	var _polygonSeries2 = _interopRequireDefault(_polygonSeries);
	
	var _rectSeries = __webpack_require__(213);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	var _markSeries = __webpack_require__(329);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	var _heatmapSeries = __webpack_require__(802);
	
	var _heatmapSeries2 = _interopRequireDefault(_heatmapSeries);
	
	var _areaSeries = __webpack_require__(801);
	
	var _areaSeries2 = _interopRequireDefault(_areaSeries);
	
	var _lineMarkSeries = __webpack_require__(805);
	
	var _lineMarkSeries2 = _interopRequireDefault(_lineMarkSeries);
	
	var _arcSeries = __webpack_require__(326);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _hint = __webpack_require__(799);
	
	var _hint2 = _interopRequireDefault(_hint);
	
	var _crosshair = __webpack_require__(798);
	
	var _crosshair2 = _interopRequireDefault(_crosshair);
	
	var _xyPlot = __webpack_require__(331);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _xAxis = __webpack_require__(795);
	
	var _xAxis2 = _interopRequireDefault(_xAxis);
	
	var _yAxis = __webpack_require__(796);
	
	var _yAxis2 = _interopRequireDefault(_yAxis);
	
	var _circularGridLines = __webpack_require__(797);
	
	var _circularGridLines2 = _interopRequireDefault(_circularGridLines);
	
	var _gridLines = __webpack_require__(212);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _verticalGridLines = __webpack_require__(809);
	
	var _verticalGridLines2 = _interopRequireDefault(_verticalGridLines);
	
	var _horizontalGridLines = __webpack_require__(800);
	
	var _horizontalGridLines2 = _interopRequireDefault(_horizontalGridLines);
	
	var _voronoi = __webpack_require__(330);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _discreteColorLegend = __webpack_require__(324);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	var _searchableDiscreteColorLegend = __webpack_require__(790);
	
	var _searchableDiscreteColorLegend2 = _interopRequireDefault(_searchableDiscreteColorLegend);
	
	var _continuousColorLegend = __webpack_require__(787);
	
	var _continuousColorLegend2 = _interopRequireDefault(_continuousColorLegend);
	
	var _continuousSizeLegend = __webpack_require__(788);
	
	var _continuousSizeLegend2 = _interopRequireDefault(_continuousSizeLegend);
	
	var _treemap = __webpack_require__(813);
	
	var _treemap2 = _interopRequireDefault(_treemap);
	
	var _radialChart = __webpack_require__(810);
	
	var _radialChart2 = _interopRequireDefault(_radialChart);
	
	var _sankey = __webpack_require__(811);
	
	var _sankey2 = _interopRequireDefault(_sankey);
	
	var _sunburst = __webpack_require__(812);
	
	var _sunburst2 = _interopRequireDefault(_sunburst);
	
	var _makeVisFlexible = __webpack_require__(791);
	
	var _makeVisFlexible2 = _interopRequireDefault(_makeVisFlexible);
	
	var _axisUtils = __webpack_require__(38);
	
	var _axisUtils2 = _interopRequireDefault(_axisUtils);
	
	var _scalesUtils = __webpack_require__(32);
	
	var _scalesUtils2 = _interopRequireDefault(_scalesUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AbstractSeries = _abstractSeries2.default; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.LineSeries = _lineSeries2.default;
	exports.VerticalBarSeries = _verticalBarSeries2.default;
	exports.HorizontalBarSeries = _horizontalBarSeries2.default;
	exports.VerticalRectSeries = _verticalRectSeries2.default;
	exports.HorizontalRectSeries = _horizontalRectSeries2.default;
	exports.PolygonSeries = _polygonSeries2.default;
	exports.RectSeries = _rectSeries2.default;
	exports.MarkSeries = _markSeries2.default;
	exports.HeatmapSeries = _heatmapSeries2.default;
	exports.AreaSeries = _areaSeries2.default;
	exports.LineMarkSeries = _lineMarkSeries2.default;
	exports.ArcSeries = _arcSeries2.default;
	exports.Hint = _hint2.default;
	exports.Crosshair = _crosshair2.default;
	exports.XYPlot = _xyPlot2.default;
	exports.XAxis = _xAxis2.default;
	exports.YAxis = _yAxis2.default;
	exports.CircularGridLines = _circularGridLines2.default;
	exports.GridLines = _gridLines2.default;
	exports.VerticalGridLines = _verticalGridLines2.default;
	exports.HorizontalGridLines = _horizontalGridLines2.default;
	exports.Voronoi = _voronoi2.default;
	exports.DiscreteColorLegend = _discreteColorLegend2.default;
	exports.SearchableDiscreteColorLegend = _searchableDiscreteColorLegend2.default;
	exports.ContinuousColorLegend = _continuousColorLegend2.default;
	exports.ContinuousSizeLegend = _continuousSizeLegend2.default;
	exports.Treemap = _treemap2.default;
	exports.RadialChart = _radialChart2.default;
	exports.Sankey = _sankey2.default;
	exports.Sunburst = _sunburst2.default;
	exports.makeWidthFlexible = _makeVisFlexible2.default;
	exports.AxisUtils = _axisUtils2.default;
	exports.ScaleUtils = _scalesUtils2.default;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  height: _react2.default.PropTypes.number,
	  endColor: _react2.default.PropTypes.string,
	  endTitle: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
	  midColor: _react2.default.PropTypes.string,
	  midTitle: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]),
	  startColor: _react2.default.PropTypes.string,
	  startTitle: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
	  width: _react2.default.PropTypes.number
	};
	
	var defaultProps = {
	  className: '',
	  startColor: _theme.CONTINUOUS_COLOR_RANGE[0],
	  endColor: _theme.CONTINUOUS_COLOR_RANGE[1]
	};
	
	function ContinuousColorLegend(_ref) {
	  var startColor = _ref.startColor,
	      midColor = _ref.midColor,
	      endColor = _ref.endColor,
	      startTitle = _ref.startTitle,
	      midTitle = _ref.midTitle,
	      endTitle = _ref.endTitle,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var colors = [startColor];
	  if (midColor) {
	    colors.push(midColor);
	  }
	  colors.push(endColor);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-color-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement('div', {
	      className: 'rv-gradient',
	      style: { background: 'linear-gradient(to right, ' + colors.join(',') + ')' } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      ),
	      midTitle ? _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__center' },
	        midTitle
	      ) : null
	    )
	  );
	}
	
	ContinuousColorLegend.displayName = 'ContinuousColorLegend';
	ContinuousColorLegend.propTypes = propTypes;
	ContinuousColorLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousColorLegend;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  circlesTotal: _react2.default.PropTypes.number,
	  endSize: _react2.default.PropTypes.number,
	  endTitle: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
	  height: _react2.default.PropTypes.number,
	  startSize: _react2.default.PropTypes.number,
	  startTitle: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
	  width: _react2.default.PropTypes.number
	}; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  circlesTotal: 10,
	  className: '',
	  endSize: 20,
	  startSize: 2
	};
	
	function ContinuousSizeLegend(_ref) {
	  var startTitle = _ref.startTitle,
	      endTitle = _ref.endTitle,
	      startSize = _ref.startSize,
	      endSize = _ref.endSize,
	      circlesTotal = _ref.circlesTotal,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var circles = [];
	  var step = (endSize - startSize) / (circlesTotal - 1);
	
	  for (var i = 0; i < circlesTotal; i++) {
	    var size = step * i + startSize;
	    circles.push(_react2.default.createElement('div', { key: i, className: 'rv-bubble', style: {
	        width: size,
	        height: size,
	        borderRadius: size / 2
	      } }));
	    // Add the separator in order to justify the content (otherwise the tags
	    // will be stacked together without any margins around).
	    circles.push(' ');
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-size-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-bubbles', style: { height: endSize } },
	      circles,
	      _react2.default.createElement('div', { className: 'rv-spacer' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      )
	    )
	  );
	}
	
	ContinuousSizeLegend.displayName = 'ContinuousSizeLegend';
	ContinuousSizeLegend.propTypes = propTypes;
	ContinuousSizeLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousSizeLegend;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  title: _react2.default.PropTypes.string.isRequired,
	  color: _react2.default.PropTypes.string.isRequired,
	  disabled: _react2.default.PropTypes.bool,
	  onClick: _react2.default.PropTypes.func,
	  orientation: _react2.default.PropTypes.oneOf(['vertical', 'horizontal']).isRequired
	}; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  disabled: false
	};
	
	function DiscreteColorLegendItem(_ref) {
	  var onClick = _ref.onClick,
	      title = _ref.title,
	      color = _ref.color,
	      disabled = _ref.disabled,
	      orientation = _ref.orientation;
	
	  var className = 'rv-discrete-color-legend-item ' + orientation;
	  if (disabled) {
	    className += ' disabled';
	  }
	  if (onClick) {
	    className += ' clickable';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: className, onClick: onClick },
	    _react2.default.createElement('span', {
	      className: 'rv-discrete-color-legend-item__color',
	      style: disabled ? null : { background: color } }),
	    _react2.default.createElement(
	      'span',
	      { className: 'rv-discrete-color-legend-item__title' },
	      title
	    )
	  );
	}
	
	DiscreteColorLegendItem.propTypes = propTypes;
	DiscreteColorLegendItem.defaultProps = defaultProps;
	DiscreteColorLegendItem.displayName = 'DiscreteColorLegendItem';
	
	exports.default = DiscreteColorLegendItem;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _discreteColorLegend = __webpack_require__(324);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _discreteColorLegend2.default.propTypes, {
	  searchText: _react2.default.PropTypes.string,
	  onSearchChange: _react2.default.PropTypes.func,
	  searchPlaceholder: _react2.default.PropTypes.string,
	  searchFn: _react2.default.PropTypes.func
	});
	
	var defaultProps = {
	  className: '',
	  searchText: '',
	  searchFn: function searchFn(items, s) {
	    return items.filter(function (item) {
	      return String(item.title || item).toLowerCase().indexOf(s) !== -1;
	    });
	  }
	};
	
	function SearchableDiscreteColorLegend(props) {
	  var items = props.items,
	      onItemClick = props.onItemClick,
	      searchFn = props.searchFn,
	      onSearchChange = props.onSearchChange,
	      searchText = props.searchText,
	      searchPlaceholder = props.searchPlaceholder,
	      width = props.width,
	      height = props.height,
	      className = props.className;
	
	  var onChange = onSearchChange ? function (_ref) {
	    var value = _ref.target.value;
	    return onSearchChange(value);
	  } : null;
	  var filteredItems = searchFn(items, searchText);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-search-wrapper ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'form',
	      { className: 'rv-search-wrapper__form' },
	      _react2.default.createElement('input', {
	        type: 'search',
	        placeholder: searchPlaceholder,
	        className: 'rv-search-wrapper__form__input',
	        value: searchText,
	        onChange: onChange })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-search-wrapper__contents' },
	      _react2.default.createElement(_discreteColorLegend2.default, {
	        items: filteredItems,
	        onItemClick: onItemClick })
	    )
	  );
	}
	
	SearchableDiscreteColorLegend.propTypes = propTypes;
	SearchableDiscreteColorLegend.defaultProps = defaultProps;
	SearchableDiscreteColorLegend.displayName = 'SearchableDiscreteColorLegend';
	
	exports.default = SearchableDiscreteColorLegend;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = makeVisFlexible;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _window = __webpack_require__(609);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _reactUtils = __webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var CONTAINER_REF = 'container';
	
	// As a performance enhancement, we want to only listen once
	var resizeSubscribers = [];
	var DEBOUNCE_DURATION = 100;
	var timeoutId = null;
	
	/**
	 * Calls each subscriber, debounced to the
	 */
	function debounceEmitResize() {
	  _window2.default.clearTimeout(timeoutId);
	  timeoutId = _window2.default.setTimeout(emitResize, DEBOUNCE_DURATION);
	}
	
	/**
	 * Calls each subscriber once syncronously.
	 */
	function emitResize() {
	  resizeSubscribers.forEach(function (cb) {
	    return cb();
	  });
	}
	
	/**
	 * Add the given callback to the list of subscribers to be caled when the
	 * window resizes. Returns a function that, when called, removes the given
	 * callback from the list of subscribers. This function is also resposible for
	 * adding and removing the resize listener on `window`.
	 *
	 * @param {Function} cb - Subscriber callback function
	 * @returns {Function} Unsubscribe function
	 */
	function subscribeToDebouncedResize(cb) {
	  resizeSubscribers.push(cb);
	
	  // if we go from zero to one Flexible components instances, add the listener
	  if (resizeSubscribers.length === 1) {
	    _window2.default.addEventListener('resize', debounceEmitResize);
	  }
	  return function unsubscribe() {
	    removeSubscriber(cb);
	
	    // if we have no Flexible components, remove the listener
	    if (resizeSubscribers.length === 0) {
	      _window2.default.clearTimeout(timeoutId);
	      _window2.default.removeEventListener('resize', debounceEmitResize);
	    }
	  };
	}
	
	/**
	 * Helper for removing the given callback from the list of subscribers.
	 *
	 * @param {Function} cb - Subscriber callback function
	 */
	function removeSubscriber(cb) {
	  var index = resizeSubscribers.indexOf(cb);
	  if (index > -1) {
	    resizeSubscribers.splice(index, 1);
	  }
	}
	
	/**
	 * Add the ability to stretch the visualization on window resize.
	 * @param {*} Component React class for the child component.
	 * @returns {*} Flexible component.
	 */
	function makeVisFlexible(Component) {
	
	  var ResultClass = function (_React$Component) {
	    _inherits(ResultClass, _React$Component);
	
	    _createClass(ResultClass, null, [{
	      key: 'propTypes',
	      get: function get() {
	        var _Component$propTypes = Component.propTypes,
	            width = _Component$propTypes.width,
	            otherPropTypes = _objectWithoutProperties(_Component$propTypes, ['width']); // eslint-disable-line no-unused-vars
	
	
	        return otherPropTypes;
	      }
	    }]);
	
	    function ResultClass(props) {
	      _classCallCheck(this, ResultClass);
	
	      var _this = _possibleConstructorReturn(this, (ResultClass.__proto__ || Object.getPrototypeOf(ResultClass)).call(this, props));
	
	      _this.state = {
	        width: 0
	      };
	      _this._onResize = _this._onResize.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Get the width of the container and assign the width.
	     * @private
	     */
	
	
	    _createClass(ResultClass, [{
	      key: '_onResize',
	      value: function _onResize() {
	        var containerElement = (0, _reactUtils.getDOMNode)(this.refs[CONTAINER_REF]);
	        var offsetWidth = containerElement.offsetWidth;
	        if (this.state.width !== offsetWidth) {
	          this.setState({
	            width: offsetWidth
	          });
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._onResize();
	        this.cancelSubscription = subscribeToDebouncedResize(this._onResize);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps() {
	        this._onResize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.cancelSubscription();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var width = this.state.width;
	
	        var props = _extends({}, this.props, { animation: width === 0 ? null : this.props.animation });
	
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: CONTAINER_REF },
	          _react2.default.createElement(Component, _extends({
	            width: width
	          }, props))
	        );
	      }
	    }]);
	
	    return ResultClass;
	  }(_react2.default.Component);
	
	  ResultClass.displayName = 'Flexible' + Component.displayName;
	
	  return ResultClass;
	}

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  orientation: _react2.default.PropTypes.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired
	};
	
	function AxisLine(_ref) {
	  var orientation = _ref.orientation,
	      width = _ref.width,
	      height = _ref.height;
	
	  var lineProps = void 0;
	  if (orientation === LEFT) {
	    lineProps = {
	      x1: width,
	      x2: width,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === RIGHT) {
	    lineProps = {
	      x1: 0,
	      x2: 0,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === TOP) {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: height,
	      y2: height
	    };
	  } else {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: 0,
	      y2: 0
	    };
	  }
	  return _react2.default.createElement('line', _extends({}, lineProps, { className: 'rv-xy-plot__axis__line' }));
	}
	
	AxisLine.displayName = 'AxisLine';
	AxisLine.propTypes = propTypes;
	
	exports.default = AxisLine;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  orientation: _react2.default.PropTypes.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired
	};
	
	function _getTickFormatFn(scale, tickTotal, tickFormat) {
	  return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function (v) {
	    return v;
	  } : tickFormat;
	}
	
	var AxisTicks = function (_React$Component) {
	  _inherits(AxisTicks, _React$Component);
	
	  function AxisTicks() {
	    _classCallCheck(this, AxisTicks);
	
	    return _possibleConstructorReturn(this, (AxisTicks.__proto__ || Object.getPrototypeOf(AxisTicks)).apply(this, arguments));
	  }
	
	  _createClass(AxisTicks, [{
	    key: '_isAxisVertical',
	
	
	    /**
	     * Gets if the axis is vertical.
	     * @returns {boolean} True if vertical.
	     * @private
	     */
	    value: function _isAxisVertical() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === RIGHT;
	    }
	
	    /**
	     * Check if axis ticks should be mirrored (for the right and top positions.
	     * @returns {boolean} True if mirrored.
	     * @private
	     */
	
	  }, {
	    key: '_areTicksWrapped',
	    value: function _areTicksWrapped() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === TOP;
	    }
	  }, {
	    key: '_getTickContainerPropsGetterFn',
	    value: function _getTickContainerPropsGetterFn() {
	      if (this._isAxisVertical()) {
	        return function (pos) {
	          return { transform: 'translate(0, ' + pos + ')' };
	        };
	      }
	      return function (pos) {
	        return { transform: 'translate(' + pos + ', 0)' };
	      };
	    }
	
	    /**
	     * Get the props of the tick line.
	     * @returns {Object} Props.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLineProps',
	    value: function _getTickLineProps() {
	      var _ref;
	
	      var _props = this.props,
	          tickSize = _props.tickSize,
	          _props$tickSizeOuter = _props.tickSizeOuter,
	          tickSizeOuter = _props$tickSizeOuter === undefined ? tickSize : _props$tickSizeOuter,
	          _props$tickSizeInner = _props.tickSizeInner,
	          tickSizeInner = _props$tickSizeInner === undefined ? tickSize : _props$tickSizeInner;
	
	      var isVertical = this._isAxisVertical();
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	      return _ref = {}, _defineProperty(_ref, tickXAttr + '1', 0), _defineProperty(_ref, tickXAttr + '2', 0), _defineProperty(_ref, tickYAttr + '1', -wrap * tickSizeInner), _defineProperty(_ref, tickYAttr + '2', wrap * tickSizeOuter), _ref;
	    }
	
	    /**
	     * Get attributes for the label of the tick.
	     * @returns {Object} Object with properties.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLabelProps',
	    value: function _getTickLabelProps() {
	      var _props2 = this.props,
	          orientation = _props2.orientation,
	          tickLabelAngle = _props2.tickLabelAngle,
	          tickSize = _props2.tickSize,
	          _props2$tickSizeOuter = _props2.tickSizeOuter,
	          tickSizeOuter = _props2$tickSizeOuter === undefined ? tickSize : _props2$tickSizeOuter,
	          _props2$tickPadding = _props2.tickPadding,
	          tickPadding = _props2$tickPadding === undefined ? tickSize : _props2$tickPadding;
	
	      // Assign the text orientation inside the label of the tick mark.
	
	      var textAnchor = void 0;
	      if (orientation === LEFT || orientation === BOTTOM && tickLabelAngle) {
	        textAnchor = 'end';
	      } else if (orientation === RIGHT || orientation === TOP && tickLabelAngle) {
	        textAnchor = 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      // The label's position is translated to the given padding and then the
	      // label is rotated to the given angle.
	      var isVertical = this._isAxisVertical();
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	
	      var labelOffset = wrap * (tickSizeOuter + tickPadding);
	      var transform = (isVertical ? 'translate(' + labelOffset + ', 0)' : 'translate(0, ' + labelOffset + ')') + (tickLabelAngle ? ' rotate(' + tickLabelAngle + ')' : '');
	
	      // Set the vertical offset of the label according to the position of
	      // the axis.
	      var dy = orientation === TOP || tickLabelAngle ? '0' : orientation === BOTTOM ? '0.72em' : '0.32em';
	
	      return {
	        textAnchor: textAnchor,
	        dy: dy,
	        transform: transform
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          attr = _props3.attr,
	          orientation = _props3.orientation,
	          width = _props3.width,
	          height = _props3.height,
	          tickFormat = _props3.tickFormat,
	          tickTotal = _props3.tickTotal,
	          tickValues = _props3.tickValues;
	
	
	      var x = orientation === LEFT ? width : 0;
	      var y = orientation === TOP ? height : 0;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(this.props, attr);
	
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	      var tickFormatFn = _getTickFormatFn(scale, tickTotal, tickFormat);
	
	      var translateFn = this._getTickContainerPropsGetterFn();
	      var pathProps = this._getTickLineProps();
	      var textProps = this._getTickLabelProps();
	
	      var ticks = values.map(function (v, i) {
	        var pos = scale(v);
	        var text = tickFormatFn(v);
	
	        return _react2.default.createElement(
	          'g',
	          _extends({ key: i }, translateFn(pos, 0), { className: 'rv-xy-plot__axis__tick' }),
	          _react2.default.createElement('line', _extends({}, pathProps, { className: 'rv-xy-plot__axis__tick__line' })),
	          _react2.default.createElement(
	            'text',
	            _extends({}, textProps, { className: 'rv-xy-plot__axis__tick__text' }),
	            text
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + x + ', ' + y + ')',
	          className: 'rv-xy-plot__axis__ticks' },
	        ticks
	      );
	    }
	  }]);
	
	  return AxisTicks;
	}(_react2.default.Component);
	
	AxisTicks.displayName = 'AxisTicks';
	AxisTicks.propTypes = propTypes;
	AxisTicks.requiresSVG = true;
	
	exports.default = AxisTicks;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Assuming that 16px = 1em
	var ADJUSTMENT_FOR_TEXT_SIZE = 16;
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	/**
	 * Compute transformations, keyed by orientation
	 * @param {number} width - width of axis
	 * @param {number} height - height of axis
	 * @returns {Object} Object of transformations, keyed by orientation
	 */
	
	var transformation = function transformation(width, height) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, LEFT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE,
	    y: 0,
	    rotation: -90,
	    textAnchor: 'end'
	  }), _defineProperty(_ref, RIGHT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
	    y: height,
	    rotation: -90,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, TOP, {
	    x: 0,
	    y: ADJUSTMENT_FOR_TEXT_SIZE,
	    rotation: 0,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, BOTTOM, {
	    x: width,
	    y: -6,
	    rotation: 0,
	    textAnchor: 'end'
	  }), _ref;
	};
	
	var propTypes = {
	  width: _react2.default.PropTypes.number.isRequired,
	  height: _react2.default.PropTypes.number.isRequired,
	  orientation: _react2.default.PropTypes.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
	  title: _react2.default.PropTypes.string.isRequired
	};
	
	function AxisTitle(_ref2) {
	  var orientation = _ref2.orientation,
	      width = _ref2.width,
	      height = _ref2.height,
	      title = _ref2.title;
	
	  var outerGroupTranslateX = orientation === LEFT ? width : 0;
	  var outerGroupTranslateY = orientation === TOP ? height : 0;
	  var outerGroupTransform = 'translate(' + outerGroupTranslateX + ', ' + outerGroupTranslateY + ')';
	  var _transformation$orien = transformation(width, height)[orientation],
	      x = _transformation$orien.x,
	      y = _transformation$orien.y,
	      rotation = _transformation$orien.rotation,
	      textAnchor = _transformation$orien.textAnchor;
	
	  var innerGroupTransform = 'translate(' + x + ', ' + y + ') rotate(' + rotation + ')';
	
	  return _react2.default.createElement(
	    'g',
	    { transform: outerGroupTransform, className: 'rv-xy-plot__axis__title' },
	    _react2.default.createElement(
	      'g',
	      { style: { textAnchor: textAnchor }, transform: innerGroupTransform },
	      _react2.default.createElement(
	        'text',
	        null,
	        title
	      )
	    )
	  );
	}
	
	AxisTitle.displayName = 'AxisTitle';
	AxisTitle.propTypes = propTypes;
	
	exports.default = AxisTitle;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	var _axis = __webpack_require__(325);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _react2.default.PropTypes.oneOf([TOP, BOTTOM])
	});
	
	var defaultProps = {
	  orientation: BOTTOM,
	  attr: 'x'
	};
	
	function XAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = propTypes;
	XAxis.defaultProps = defaultProps;
	XAxis.requiresSVG = true;
	
	exports.default = XAxis;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	var _axis = __webpack_require__(325);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _react2.default.PropTypes.oneOf([LEFT, RIGHT])
	});
	
	var defaultProps = {
	  orientation: LEFT,
	  attr: 'y'
	};
	
	function YAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = propTypes;
	YAxis.defaultProps = defaultProps;
	YAxis.requiresSVG = true;
	
	exports.default = YAxis;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(32);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  centerX: _react.PropTypes.number,
	  centerY: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  top: _react.PropTypes.number,
	  left: _react.PropTypes.number,
	
	  tickValues: _react.PropTypes.array,
	  tickTotal: _react.PropTypes.number,
	
	  animation: _animation.AnimationPropType,
	  // generally supplied by xyplot
	  marginTop: _react.PropTypes.number,
	  marginBottom: _react.PropTypes.number,
	  marginLeft: _react.PropTypes.number,
	  marginRight: _react.PropTypes.number,
	  innerWidth: _react.PropTypes.number,
	  innerHeight: _react.PropTypes.number
	};
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var CircularGridLines = function (_PureRenderComponent) {
	  _inherits(CircularGridLines, _PureRenderComponent);
	
	  function CircularGridLines() {
	    _classCallCheck(this, CircularGridLines);
	
	    return _possibleConstructorReturn(this, (CircularGridLines.__proto__ || Object.getPrototypeOf(CircularGridLines)).apply(this, arguments));
	  }
	
	  _createClass(CircularGridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(Math.min(innerWidth, innerHeight))
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          animation = _props2.animation,
	          centerX = _props2.centerX,
	          centerY = _props2.centerY;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(CircularGridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop;
	
	
	      var xScale = (0, _scalesUtils.getAttributeScale)(props, 'x');
	      var yScale = (0, _scalesUtils.getAttributeScale)(props, 'y');
	      var values = (0, _axisUtils.getTickValues)(xScale, tickTotal, tickValues);
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + (xScale(centerX) + marginLeft) + ',' + (yScale(centerY) + marginTop) + ')',
	          className: 'rv-xy-plot__circular-grid-lines' },
	        values.map(function (value, index) {
	          return _react2.default.createElement('circle', _extends({ cx: 0, cy: 0, r: xScale(value) }, {
	            key: index,
	            className: 'rv-xy-plot__circular-grid-lines__line' }));
	        })
	      );
	    }
	  }]);
	
	  return CircularGridLines;
	}(_pureRenderComponent2.default);
	
	CircularGridLines.displayName = 'CircularGridLines';
	CircularGridLines.propTypes = propTypes;
	CircularGridLines.defaultProps = {
	  centerX: 0,
	  centerY: 0
	};
	CircularGridLines.requiresSVG = true;
	
	exports.default = CircularGridLines;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Format title by detault.
	 * @param {Array} values List of values.
	 * @returns {*} Formatted value or undefined.
	 */
	function defaultTitleFormat(values) {
	  var value = getFirstNonEmptyValue(values);
	  if (value) {
	    return {
	      title: 'x',
	      value: value.x
	    };
	  }
	}
	
	/**
	 * Format items by default.
	 * @param {Array} values Array of values.
	 * @returns {*} Formatted list of items.
	 */
	function defaultItemsFormat(values) {
	  return values.map(function (v, i) {
	    if (v) {
	      return { value: v.y, title: i };
	    }
	  });
	}
	
	/**
	 * Get the first non-empty item from an array.
	 * @param {Array} values Array of values.
	 * @returns {*} First non-empty value or undefined.
	 */
	function getFirstNonEmptyValue(values) {
	  return (values || []).find(function (v) {
	    return Boolean(v);
	  });
	}
	
	var Crosshair = function (_PureRenderComponent) {
	  _inherits(Crosshair, _PureRenderComponent);
	
	  function Crosshair() {
	    _classCallCheck(this, Crosshair);
	
	    return _possibleConstructorReturn(this, (Crosshair.__proto__ || Object.getPrototypeOf(Crosshair)).apply(this, arguments));
	  }
	
	  _createClass(Crosshair, [{
	    key: '_renderCrosshairTitle',
	
	
	    /**
	     * Render crosshair title.
	     * @returns {*} Container with the crosshair title.
	     * @private
	     */
	    value: function _renderCrosshairTitle() {
	      var _props = this.props,
	          values = _props.values,
	          titleFormat = _props.titleFormat;
	
	      var titleItem = titleFormat(values);
	      if (!titleItem) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'rv-crosshair__title', key: 'title' },
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__title' },
	          titleItem.title
	        ),
	        ': ',
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__value' },
	          titleItem.value
	        )
	      );
	    }
	
	    /**
	     * Render crosshair items (title + value for each series).
	     * @returns {*} Array of React classes with the crosshair values.
	     * @private
	     */
	
	  }, {
	    key: '_renderCrosshairItems',
	    value: function _renderCrosshairItems() {
	      var _props2 = this.props,
	          values = _props2.values,
	          itemsFormat = _props2.itemsFormat;
	
	      var items = itemsFormat(values);
	      if (!items) {
	        return null;
	      }
	      return items.filter(function (i) {
	        return i;
	      }).map(function renderValue(item, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'rv-crosshair__item', key: 'item' + i },
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__title' },
	            item.title
	          ),
	          ': ',
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__value' },
	            item.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          values = _props3.values,
	          marginTop = _props3.marginTop,
	          marginLeft = _props3.marginLeft,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight;
	
	      var value = getFirstNonEmptyValue(values);
	      if (!value) {
	        return null;
	      }
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x');
	      var innerLeft = x(value);
	
	      var _props$orientation = this.props.orientation,
	          orientation = _props$orientation === undefined ? innerLeft > innerWidth / 2 ? 'left' : 'right' : _props$orientation;
	
	      var left = marginLeft + innerLeft;
	      var top = marginTop;
	      var innerClassName = 'rv-crosshair__inner rv-crosshair__inner--' + orientation;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-crosshair',
	          style: { left: left + 'px', top: top + 'px' } },
	        _react2.default.createElement('div', {
	          className: 'rv-crosshair__line',
	          style: { height: innerHeight + 'px' } }),
	        _react2.default.createElement(
	          'div',
	          { className: innerClassName },
	          children ? children : _react2.default.createElement(
	            'div',
	            { className: 'rv-crosshair__inner__content' },
	            _react2.default.createElement(
	              'div',
	              null,
	              this._renderCrosshairTitle(),
	              this._renderCrosshairItems()
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        values: _react2.default.PropTypes.array,
	        series: _react2.default.PropTypes.object,
	        innerWidth: _react2.default.PropTypes.number,
	        innerHeight: _react2.default.PropTypes.number,
	        marginLeft: _react2.default.PropTypes.number,
	        marginTop: _react2.default.PropTypes.number,
	        orientation: _react2.default.PropTypes.oneOf(['left', 'right']),
	        itemsFormat: _react2.default.PropTypes.func,
	        titleFormat: _react2.default.PropTypes.func
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        titleFormat: defaultTitleFormat,
	        itemsFormat: defaultItemsFormat
	      };
	    }
	  }]);
	
	  return Crosshair;
	}(_pureRenderComponent2.default);
	
	Crosshair.displayName = 'Crosshair';
	
	exports.default = Crosshair;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderComponent = __webpack_require__(79);
	
	var _pureRenderComponent2 = _interopRequireDefault(_pureRenderComponent);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/*
	 * Hint provides two options for placement of hint:
	 * a) around a data point in one of four quadrants (imagine the point bisected
	 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
	 *    point).
	 * b) **New** pin to an edge of chart/plot area and position along that edge
	 *    using data point's other dimension value.
	 *
	 * To support these two options, deprecate one Hint props (orientation) with two
	 * new Hint align prop object (horizontal, vertical) with following values:
	 *
	 *   horizontal: auto, left, right, leftEdge, rightEdge
	 *   vertical: auto, bottom, top, bottomEdge, topEdge
	 *
	 * Thus, the following ALIGN constants are the values for horizontal
	 * and vertical
	 */
	var ALIGN = {
	  AUTO: 'auto',
	  LEFT: 'left',
	  RIGHT: 'right',
	  LEFT_EDGE: 'leftEdge',
	  RIGHT_EDGE: 'rightEdge',
	  BOTTOM: 'bottom',
	  TOP: 'top',
	  BOTTOM_EDGE: 'bottomEdge',
	  TOP_EDGE: 'topEdge'
	};
	
	/**
	 * For backwards support, retain the ORIENTATION prop constants
	 */
	var ORIENTATION = {
	  BOTTOM_LEFT: 'bottomleft',
	  BOTTOM_RIGHT: 'bottomright',
	  TOP_LEFT: 'topleft',
	  TOP_RIGHT: 'topright'
	};
	
	/**
	 * Default format function for the value.
	 * @param {Object} value Value.
	 * @returns {Array} title-value pairs.
	 */
	function defaultFormat(value) {
	  return Object.keys(value).map(function getProp(key) {
	    return { title: key, value: value[key] };
	  });
	}
	
	var Hint = function (_PureRenderComponent) {
	  _inherits(Hint, _PureRenderComponent);
	
	  function Hint() {
	    _classCallCheck(this, Hint);
	
	    return _possibleConstructorReturn(this, (Hint.__proto__ || Object.getPrototypeOf(Hint)).apply(this, arguments));
	  }
	
	  _createClass(Hint, [{
	    key: '_getCSSRight',
	
	
	    /**
	     * Get the right coordinate of the hint.
	     * When x undefined or null, edge case, pin right.
	     * @param {number} x X.
	     * @returns {{right: *}} Mixin.
	     * @private
	     */
	    value: function _getCSSRight(x) {
	      if (x === undefined || x === null) {
	        return {
	          right: 0
	        };
	      }
	
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          marginRight = _props.marginRight;
	
	      return {
	        right: marginRight + innerWidth - x
	      };
	    }
	
	    /**
	     * Get the left coordinate of the hint.
	     * When x undefined or null, edge case, pin left.
	     * @param {number} x X.
	     * @returns {{left: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSLeft',
	    value: function _getCSSLeft(x) {
	      if (x === undefined || x === null) {
	        return {
	          left: 0
	        };
	      }
	
	      var marginLeft = this.props.marginLeft;
	
	      return {
	        left: marginLeft + x
	      };
	    }
	
	    /**
	     * Get the bottom coordinate of the hint.
	     * When y undefined or null, edge case, pin bottom.
	     * @param {number} y Y.
	     * @returns {{bottom: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSBottom',
	    value: function _getCSSBottom(y) {
	      if (y === undefined || y === null) {
	        return {
	          bottom: 0
	        };
	      }
	
	      var _props2 = this.props,
	          innerHeight = _props2.innerHeight,
	          marginBottom = _props2.marginBottom;
	
	      return {
	        bottom: marginBottom + innerHeight - y
	      };
	    }
	
	    /**
	     * Get the top coordinate of the hint.
	     * When y undefined or null, edge case, pin top.
	     * @param {number} y Y.
	     * @returns {{top: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSTop',
	    value: function _getCSSTop(y) {
	      if (y === undefined || y === null) {
	        return {
	          top: 0
	        };
	      }
	
	      var marginTop = this.props.marginTop;
	
	      return {
	        top: marginTop + y
	      };
	    }
	  }, {
	    key: '_mapOrientationToAlign',
	    value: function _mapOrientationToAlign(orientation) {
	      // TODO: print warning that this feature is deprecated and support will be
	      // removed in next major release.
	      switch (orientation) {
	        case ORIENTATION.BOTTOM_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.BOTTOM_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.TOP_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.TOP
	          };
	        case ORIENTATION.TOP_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.TOP
	          };
	        default:
	          // fall back to horizontalAlign, verticalAlign that are either
	          // provided or defaulted to AUTO.  So, don't change things
	          break;
	      }
	    }
	
	    /**
	     * Obtain align object with horizontal and vertical settings
	     * but convert any AUTO values to the non-auto ALIGN depending on the
	     * values of x and y.
	     * @param {number} x X value.
	     * @param {number} y Y value.
	     * @returns {Object} Align object w/ horizontal, vertical prop strings.
	     * @private
	     */
	
	  }, {
	    key: '_getAlign',
	    value: function _getAlign(x, y) {
	      var _props3 = this.props,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight,
	          orientation = _props3.orientation,
	          _props3$align = _props3.align,
	          horizontal = _props3$align.horizontal,
	          vertical = _props3$align.vertical;
	
	      var align = orientation ? this._mapOrientationToAlign(orientation) : { horizontal: horizontal, vertical: vertical };
	      if (horizontal === ALIGN.AUTO) {
	        align.horizontal = x > innerWidth / 2 ? ALIGN.LEFT : ALIGN.RIGHT;
	      }
	      if (vertical === ALIGN.AUTO) {
	        align.vertical = y > innerHeight / 2 ? ALIGN.TOP : ALIGN.BOTTOM;
	      }
	      return align;
	    }
	
	    /**
	     * Get a CSS mixin for a proper positioning of the element.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @param {number} x X position.
	     * @param {number} y Y position.
	     * @returns {Object} Object, that may contain `left` or `right, `top` or
	     * `bottom` properties.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignStyle',
	    value: function _getAlignStyle(align, x, y) {
	      return _extends({}, this._getXCSS(align.horizontal, x), this._getYCSS(align.vertical, y));
	    }
	  }, {
	    key: '_getYCSS',
	    value: function _getYCSS(verticalAlign, y) {
	      // obtain yCSS
	      switch (verticalAlign) {
	        case ALIGN.TOP_EDGE:
	          // this pins x to top edge
	          return this._getCSSTop(null);
	        case ALIGN.BOTTOM_EDGE:
	          // this pins x to bottom edge
	          return this._getCSSBottom(null);
	        case ALIGN.BOTTOM:
	          // this places hint text to the bottom of center, so set its top edge
	          return this._getCSSTop(y);
	        case ALIGN.TOP:
	        default:
	          // this places hint text to the top of center, so set its bottom edge
	          // default case should not be possible but if it happens set to BOTTOM
	          return this._getCSSBottom(y);
	      }
	    }
	  }, {
	    key: '_getXCSS',
	    value: function _getXCSS(horizontal, x) {
	      // obtain xCSS
	      switch (horizontal) {
	        case ALIGN.LEFT_EDGE:
	          // this pins x to left edge
	          return this._getCSSLeft(null);
	        case ALIGN.RIGHT_EDGE:
	          // this pins x to left edge
	          return this._getCSSRight(null);
	        case ALIGN.LEFT:
	          // this places hint text to the left of center, so set its right edge
	          return this._getCSSRight(x);
	        case ALIGN.RIGHT:
	        default:
	          // this places hint text to the right of center, so set its left edge
	          // default case should not be possible but if it happens set to RIGHT
	          return this._getCSSLeft(x);
	      }
	    }
	
	    /**
	     * Get the class names from align values.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @returns {string} Class names.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignClassNames',
	    value: function _getAlignClassNames(align) {
	      var orientation = this.props.orientation;
	
	      var orientationClass = orientation ? 'rv-hint--orientation-' + orientation : '';
	      return orientationClass + ' rv-hint--horizontalAlign-' + align.horizontal + '\n     rv-hint--verticalAlign-' + align.vertical;
	    }
	
	    /**
	     * Get the position for the hint and the appropriate class name.
	     * @returns {{style: Object, className: string}} Style and className for the
	     * hint.
	     * @private
	     */
	
	  }, {
	    key: '_getPositionInfo',
	    value: function _getPositionInfo() {
	      var _props4 = this.props,
	          value = _props4.value,
	          getAlignStyle = _props4.getAlignStyle;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x')(value);
	      var y = (0, _scalesUtils.getAttributeFunctor)(this.props, 'y')(value);
	
	      var align = this._getAlign(x, y);
	
	      return {
	        style: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
	        className: this._getAlignClassNames(align)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          value = _props5.value,
	          format = _props5.format,
	          children = _props5.children;
	
	      var _getPositionInfo2 = this._getPositionInfo(),
	          style = _getPositionInfo2.style,
	          className = _getPositionInfo2.className;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-hint ' + className,
	          style: _extends({}, style, {
	            position: 'absolute'
	          }) },
	        children ? children : _react2.default.createElement(
	          'div',
	          { className: 'rv-hint__content' },
	          format(value).map(function (formattedProp, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'rv-hint' + i },
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__title' },
	                formattedProp.title
	              ),
	              ': ',
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__value' },
	                formattedProp.value
	              )
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        marginTop: _react2.default.PropTypes.number,
	        marginLeft: _react2.default.PropTypes.number,
	        innerWidth: _react2.default.PropTypes.number,
	        innerHeight: _react2.default.PropTypes.number,
	        scales: _react2.default.PropTypes.object,
	        value: _react2.default.PropTypes.object,
	        format: _react2.default.PropTypes.func,
	        align: _react2.default.PropTypes.shape({
	          horizontal: _react2.default.PropTypes.oneOf([ALIGN.AUTO, ALIGN.LEFT, ALIGN.RIGHT, ALIGN.LEFT_EDGE, ALIGN.RIGHT_EDGE]),
	          vertical: _react2.default.PropTypes.oneOf([ALIGN.AUTO, ALIGN.BOTTOM, ALIGN.TOP, ALIGN.BOTTOM_EDGE, ALIGN.TOP_EDGE])
	        }),
	        getAlignStyle: _react2.default.PropTypes.func,
	        orientation: _react2.default.PropTypes.oneOf([ORIENTATION.BOTTOM_LEFT, ORIENTATION.BOTTOM_RIGHT, ORIENTATION.TOP_LEFT, ORIENTATION.TOP_RIGHT])
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        format: defaultFormat,
	        align: {
	          horizontal: ALIGN.AUTO,
	          vertical: ALIGN.AUTO
	        }
	      };
	    }
	  }]);
	
	  return Hint;
	}(_pureRenderComponent2.default);
	
	Hint.displayName = 'Hint';
	Hint.ORIENTATION = ORIENTATION;
	Hint.ALIGN = ALIGN;
	
	exports.default = Hint;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(38);
	
	var _gridLines = __webpack_require__(212);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _react2.default.PropTypes.oneOf([HORIZONTAL])
	});
	
	var defaultProps = {
	  direction: HORIZONTAL,
	  attr: 'y'
	};
	
	function HorizontalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	HorizontalGridLines.displayName = 'HorizontalGridLines';
	HorizontalGridLines.propTypes = propTypes;
	HorizontalGridLines.defaultProps = defaultProps;
	HorizontalGridLines.requiresSVG = true;
	
	exports.default = HorizontalGridLines;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(143);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(48);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var AreaSeries = function (_AbstractSeries) {
	  _inherits(AreaSeries, _AbstractSeries);
	
	  function AreaSeries() {
	    _classCallCheck(this, AreaSeries);
	
	    return _possibleConstructorReturn(this, (AreaSeries.__proto__ || Object.getPrototypeOf(AreaSeries)).apply(this, arguments));
	  }
	
	  _createClass(AreaSeries, [{
	    key: '_renderArea',
	    value: function _renderArea(data, x, y0, y, curve) {
	      var area = d3Shape.area();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          area = area.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          area = area.curve(curve);
	        }
	      }
	      area = area.x(x).y0(y0).y1(y);
	      return area(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          curve = _props.curve,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(AreaSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var y0 = this._getAttr0Functor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var fill = this._getAttributeValue('fill') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var d = this._renderArea(data, x, y0, y, curve);
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        style: {
	          opacity: opacity,
	          stroke: stroke,
	          fill: fill
	        } });
	    }
	  }]);
	
	  return AreaSeries;
	}(_abstractSeries2.default);
	
	AreaSeries.displayName = 'AreaSeries';
	
	exports.default = AreaSeries;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--heatmap';
	
	var HeatmapSeries = function (_AbstractSeries) {
	  _inherits(HeatmapSeries, _AbstractSeries);
	
	  function HeatmapSeries() {
	    _classCallCheck(this, HeatmapSeries);
	
	    return _possibleConstructorReturn(this, (HeatmapSeries.__proto__ || Object.getPrototypeOf(HeatmapSeries)).apply(this, arguments));
	  }
	
	  _createClass(HeatmapSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(HeatmapSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var xDistance = this._getScaleDistance('x');
	      var yDistance = this._getScaleDistance('y');
	      return _react2.default.createElement(
	        'g',
	        {
	          className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var attrs = {
	            style: {
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d),
	              opacity: opacityFunctor && opacityFunctor(d)
	            },
	            x: xFunctor(d) - xDistance / 2,
	            y: yFunctor(d) - yDistance / 2,
	            width: xDistance,
	            height: yDistance,
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            }
	          };
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x' || attr === 'y';
	      return { isDomainAdjustmentNeeded: isDomainAdjustmentNeeded };
	    }
	  }]);
	
	  return HeatmapSeries;
	}(_abstractSeries2.default);
	
	HeatmapSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	HeatmapSeries.displayName = 'HeatmapSeries';
	
	exports.default = HeatmapSeries;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(327);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeries = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeries, _AbstractSeries);
	
	  function HorizontalBarSeries() {
	    _classCallCheck(this, HorizontalBarSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeries.__proto__ || Object.getPrototypeOf(HorizontalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalBarSeries;
	}(_abstractSeries2.default);
	
	HorizontalBarSeries.displayName = 'HorizontalBarSeries';
	
	exports.default = HorizontalBarSeries;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(213);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeries = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeries, _AbstractSeries);
	
	  function HorizontalRectSeries() {
	    _classCallCheck(this, HorizontalRectSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeries.__proto__ || Object.getPrototypeOf(HorizontalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalRectSeries;
	}(_abstractSeries2.default);
	
	HorizontalRectSeries.displayName = 'HorizontalRectSeries';
	
	exports.default = HorizontalRectSeries;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(328);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _markSeries = __webpack_require__(329);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineMarkSeries = function (_AbstractSeries) {
	  _inherits(LineMarkSeries, _AbstractSeries);
	
	  function LineMarkSeries() {
	    _classCallCheck(this, LineMarkSeries);
	
	    return _possibleConstructorReturn(this, (LineMarkSeries.__proto__ || Object.getPrototypeOf(LineMarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'g',
	        { className: 'rv-xy-plot__series rv-xy-plot__series--linemark' },
	        _react2.default.createElement(_lineSeries2.default, this.props),
	        _react2.default.createElement(_markSeries2.default, this.props)
	      );
	    }
	  }], [{
	    key: 'defaultProps',
	    get: function get() {
	      return _lineSeries2.default.defaultProps;
	    }
	  }]);
	
	  return LineMarkSeries;
	}(_abstractSeries2.default);
	
	LineMarkSeries.displayName = 'LineMarkSeries';
	
	exports.default = LineMarkSeries;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(52);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--polygon';
	var DEFAULT_COLOR = '#12939A';
	
	var generatePath = function generatePath(data, xFunctor, yFunctor) {
	  return data.reduce(function (res, row, i) {
	    return res + ' ' + (i ? 'L' : 'M') + xFunctor(row) + ' ' + yFunctor(row);
	  }, '') + ' Z';
	};
	
	var PolygonSeries = function (_AbstractSeries) {
	  _inherits(PolygonSeries, _AbstractSeries);
	
	  function PolygonSeries() {
	    _classCallCheck(this, PolygonSeries);
	
	    return _possibleConstructorReturn(this, (PolygonSeries.__proto__ || Object.getPrototypeOf(PolygonSeries)).apply(this, arguments));
	  }
	
	  _createClass(PolygonSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          color = _props.color,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(PolygonSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement('path', {
	        className: predefinedClassName + ' ' + className,
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        fill: color || DEFAULT_COLOR,
	        style: style,
	        d: generatePath(data, xFunctor, yFunctor),
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        ref: 'container'
	      });
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes);
	    }
	  }]);
	
	  return PolygonSeries;
	}(_abstractSeries2.default);
	
	PolygonSeries.displayName = 'PolygonSeries';
	
	exports.default = PolygonSeries;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(327);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalBarSeries = function (_AbstractSeries) {
	  _inherits(VerticalBarSeries, _AbstractSeries);
	
	  function VerticalBarSeries() {
	    _classCallCheck(this, VerticalBarSeries);
	
	    return _possibleConstructorReturn(this, (VerticalBarSeries.__proto__ || Object.getPrototypeOf(VerticalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalBarSeries;
	}(_abstractSeries2.default);
	
	VerticalBarSeries.displayName = 'VerticalBarSeries';
	
	exports.default = VerticalBarSeries;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(22);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(213);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalRectSeries = function (_AbstractSeries) {
	  _inherits(VerticalRectSeries, _AbstractSeries);
	
	  function VerticalRectSeries() {
	    _classCallCheck(this, VerticalRectSeries);
	
	    return _possibleConstructorReturn(this, (VerticalRectSeries.__proto__ || Object.getPrototypeOf(VerticalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalRectSeries;
	}(_abstractSeries2.default);
	
	VerticalRectSeries.displayName = 'VerticalRectSeries';
	
	exports.default = VerticalRectSeries;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridLines = __webpack_require__(212);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _axisUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _react2.default.PropTypes.oneOf([VERTICAL])
	});
	
	var defaultProps = {
	  direction: VERTICAL,
	  attr: 'x'
	};
	
	function VerticalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	VerticalGridLines.displayName = 'VerticalGridLines';
	VerticalGridLines.propTypes = propTypes;
	VerticalGridLines.defaultProps = defaultProps;
	VerticalGridLines.requiresSVG = true;
	
	exports.default = VerticalGridLines;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(143);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _chartUtils = __webpack_require__(332);
	
	var _theme = __webpack_require__(48);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NOOP = function NOOP(d) {
	  return d;
	};
	
	var ATTRIBUTES = ['angle', 'radius', 'innerRadius', 'color', 'opacity', 'fill', 'stroke'];
	
	var ANIMATED_PROPS = ['angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius', 'colorDomain', 'colorRange', 'color', 'opacityDomain', 'opacityRange', 'opacity', 'fillDomain', 'fillRange', 'fill', 'strokeDomain', 'strokeRange', 'stroke', 'data'];
	
	var DEFAULT_MARGINS = {
	  left: 10,
	  right: 10,
	  top: 10,
	  bottom: 10
	};
	
	/**
	 * Walk through the data and assign color property to the data points if it
	 * doesn't exist.
	 * @param {Array} data Array of data.
	 * @returns {Array} New array of data points.
	 */
	function assignColorsToData(data) {
	  return data.map(function (d, color) {
	    return _extends({ color: color }, d);
	  });
	}
	
	var RadialChart = function (_React$Component) {
	  _inherits(RadialChart, _React$Component);
	
	  _createClass(RadialChart, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _react.PropTypes.string,
	        height: _react.PropTypes.number.isRequired,
	        margin: _chartUtils.MarginPropType,
	        onSectionMouseOver: _react.PropTypes.func,
	        onSectionMouseOut: _react.PropTypes.func,
	        onSectionClick: _react.PropTypes.func,
	        showLabels: _react.PropTypes.bool,
	        width: _react.PropTypes.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: ''
	      };
	    }
	  }]);
	
	  function RadialChart(props) {
	    _classCallCheck(this, RadialChart);
	
	    var _this = _possibleConstructorReturn(this, (RadialChart.__proto__ || Object.getPrototypeOf(RadialChart)).call(this, props));
	
	    var data = assignColorsToData(props.data);
	    var scaleProps = _this._getAllScaleProps(props, data);
	    var arc = _this._getArcFromProps(scaleProps);
	    _this.state = { scaleProps: scaleProps, data: data, arc: arc };
	    return _this;
	  }
	
	  _createClass(RadialChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextData = assignColorsToData(nextProps.data);
	      var nextScaleProps = this._getAllScaleProps(nextProps, nextData);
	      this.setState({
	        scaleProps: this._getAllScaleProps(nextProps, nextData),
	        data: nextData,
	        arc: this._getArcFromProps(nextScaleProps)
	      });
	    }
	
	    /**
	     * Triggers a callback on a section if the callback is set.
	     * @param {function} handler Callback function.
	     * @param {Object} d Data point of the arc.
	     * @param {Object} event Event.
	     * @private
	     */
	
	  }, {
	    key: '_sectionHandler',
	    value: function _sectionHandler() {
	      var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NOOP;
	      var d = arguments[1];
	      var event = arguments[2];
	      var arc = this.state.arc;
	
	      var _arc$centroid = arc.centroid(d),
	          _arc$centroid2 = _slicedToArray(_arc$centroid, 2),
	          x = _arc$centroid2[0],
	          y = _arc$centroid2[1];
	
	      handler(d.data, { event: event, x: x, y: y });
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)(props, DEFAULT_MARGINS),
	          innerWidth = _getInnerDimensions.innerWidth,
	          innerHeight = _getInnerDimensions.innerHeight;
	
	      var radius = Math.min(innerWidth / 2, innerHeight / 2);
	      return {
	        radiusRange: [0, radius],
	        _radiusValue: radius,
	        opacityType: _theme.OPACITY_TYPE,
	        _opacityValue: _theme.DEFAULT_OPACITY,
	        colorRange: _theme.DISCRETE_COLOR_RANGE,
	        colorType: 'category'
	      };
	    }
	
	    /**
	     * Get the map of scales from the props.
	     * @param {Object} props Props.
	     * @param {Array} data Array of all data.
	     * @returns {Object} Map of scales.
	     * @private
	     */
	
	  }, {
	    key: '_getAllScaleProps',
	    value: function _getAllScaleProps(props, data) {
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), data, ATTRIBUTES);
	
	      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps, {
	        _allData: [],
	        _adjustBy: [],
	        _adjustWhat: []
	      });
	    }
	
	    /**
	     * Get attribute functor.
	     * @param {string} attr Attribute name.
	     * @returns {*} Functor.
	     * @protected
	     */
	
	  }, {
	    key: '_getAttributeFunctor',
	    value: function _getAttributeFunctor(attr) {
	      return (0, _scalesUtils.getAttributeFunctor)(this.state.scaleProps, attr);
	    }
	
	    /**
	     * Extract the arc function from the props.
	     * @param {Object} scaleProps Scale props.
	     * @returns {function} Arc function, null if radius is missing.
	     * @private
	     */
	
	  }, {
	    key: '_getArcFromProps',
	    value: function _getArcFromProps(scaleProps) {
	      var radiusFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'radius');
	      var innerRadiusFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'innerRadius');
	      if (!radiusFunctor) {
	        return null;
	      }
	      return (0, _d3Shape.arc)().outerRadius(radiusFunctor).innerRadius(innerRadiusFunctor);
	    }
	
	    /**
	     * Generate the svg pie slices to be rendered
	     * @param {Array} pieData - the d3 generate information for drawing slices
	     * @param {Func} arc - the arc generator
	     * @returns {function} the react content functor
	     * @private
	     */
	
	  }, {
	    key: '_renderPieSlice',
	    value: function _renderPieSlice(pieData, arc) {
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      return function (d, i) {
	        return _react2.default.createElement('path', {
	          className: 'rv-radial-chart__series--pie__slice',
	          d: arc(pieData[i]),
	          style: {
	            opacity: opacityFunctor && opacityFunctor(d),
	            stroke: strokeFunctor && strokeFunctor(d),
	            fill: fillFunctor && fillFunctor(d)
	          },
	          key: i
	        });
	      };
	    }
	
	    /**
	     * Generate the svg labels to be rendered.
	     * @param {Array} pieData - the d3 generate information for drawing slices
	     * @returns {function} the react content functor
	     * @private
	     */
	
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel(pieData) {
	      var radiusFunctor = (0, _scalesUtils.getAttributeFunctor)(this.state.scaleProps, 'radius');
	      return function (d, i) {
	        // reject the label if its not affixed to the section
	        var canRenderMainLabel = d.label && typeof d.label === 'string';
	        var canRenderSubLabel = d.subLabel && typeof d.subLabel === 'string';
	        if (!canRenderMainLabel && !canRenderSubLabel) {
	          return;
	        }
	        // this equation finds the center of the pie wedge and place the label there
	        // there is a quarter circle correction, due to where d3 places it's coord system
	        var angle = (pieData[i].startAngle + pieData[i].endAngle) / 2 - Math.PI / 2;
	        // we then translate a g to just outside the location of the wedge
	        var xTrans = 1.1 * radiusFunctor(d) * Math.cos(angle);
	        var yTrans = 1.1 * radiusFunctor(d) * Math.sin(angle);
	        // finally we select which way we want the text to be oriented
	        // if its on the left half of the circle, the it should be right aligned
	        // and vice versa for the right half
	        var textAnchor = angle > 0.5 * Math.PI && angle < 1.5 * Math.PI ? 'end' : 'start';
	        return _react2.default.createElement(
	          'g',
	          {
	            className: 'rv-radial-chart__series--pie-label-inner-wrapper',
	            transform: 'translate(' + xTrans + ',' + yTrans + ')', key: i + '-text-wrapper' },
	          canRenderMainLabel && _react2.default.createElement(
	            'text',
	            {
	              className: 'rv-radial-chart__series--pie-label-primary',
	              x: '0',
	              y: '0',
	              fontSize: '12',
	              textAnchor: textAnchor
	            },
	            d.label
	          ),
	          canRenderSubLabel && _react2.default.createElement(
	            'text',
	            {
	              className: 'rv-radial-chart__series--pie-label-secondary',
	              x: '0',
	              y: '15',
	              fontSize: '10',
	              textAnchor: textAnchor
	            },
	            d.subLabel
	          )
	        );
	      };
	    }
	
	    /**
	     * Generate invisible svg overlays for applying listeners to
	     * @param {Array} pieData - the d3 generate information for drawing slices
	     * @param {Func} arc - the arc generator
	     * @returns {function} the react content functor
	     * @private
	     */
	
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay(pieData, arc) {
	      var _this2 = this;
	
	      var _props = this.props,
	          onSectionMouseOver = _props.onSectionMouseOver,
	          onSectionMouseOut = _props.onSectionMouseOut,
	          onSectionClick = _props.onSectionClick;
	
	
	      return function (d, i) {
	        return _react2.default.createElement('path', {
	          className: 'rv-radial-chart__series--pie__slice-overlay',
	          d: arc(pieData[i]),
	          style: { opacity: 0 },
	          onMouseEnter: function onMouseEnter(e) {
	            return _this2._sectionHandler(onSectionMouseOver, pieData[i], e);
	          },
	          onMouseLeave: function onMouseLeave(e) {
	            return _this2._sectionHandler(onSectionMouseOut, pieData[i], e);
	          },
	          onClick: function onClick(e) {
	            return _this2._sectionHandler(onSectionClick, pieData[i], e);
	          },
	          key: i + '-listeners'
	        });
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          animation = _props2.animation,
	          className = _props2.className,
	          height = _props2.height,
	          showLabels = _props2.showLabels,
	          width = _props2.width;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
	          _react2.default.createElement(RadialChart, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _state = this.state,
	          data = _state.data,
	          arc = _state.arc;
	
	      if (!data || !arc) {
	        return null;
	      }
	
	      var pie = (0, _d3Shape.pie)().sort(null).value(function (d) {
	        return d.angle;
	      });
	      var pieData = pie(data);
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          },
	          className: 'rv-radial-chart ' + className },
	        _react2.default.createElement(
	          'svg',
	          {
	            width: width,
	            height: height,
	            className: 'rv-radial-chart__svg' },
	          _react2.default.createElement(
	            'g',
	            {
	              className: 'rv-radial-chart__series--pie',
	              transform: 'translate(' + width / 2 + ',' + height / 2 + ')',
	              ref: 'container' },
	            _react2.default.createElement(
	              'g',
	              { className: 'rv-radial-chart__series--pie-slices-wrapper' },
	              data.map(this._renderPieSlice(pieData, arc))
	            ),
	            _react2.default.createElement(
	              'g',
	              { className: 'rv-radial-chart__series--pie-labels-wrapper' },
	              showLabels && data.map(this._renderLabel(pieData))
	            ),
	            _react2.default.createElement(
	              'g',
	              { className: 'rv-radial-chart__series--pie-overlays-wrapper' },
	              data.map(this._renderOverlay(pieData, arc))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RadialChart;
	}(_react2.default.Component);
	
	RadialChart.displayName = 'RadialChart';
	
	exports.default = RadialChart;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3SankeyAlign = __webpack_require__(587);
	
	var _voronoi = __webpack_require__(330);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	var DEFAULT_LINK_COLOR = _theme.DISCRETE_COLOR_RANGE[1];
	var DEFAULT_LINK_OPACITY = 0.7;
	var DEFAULT_NODE_COLOR = _theme.DISCRETE_COLOR_RANGE[0];
	var DEFAULT_NODE_OPACITY = 1;
	
	var Sankey = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey() {
	    _classCallCheck(this, Sankey);
	
	    return _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).apply(this, arguments));
	  }
	
	  _createClass(Sankey, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          align = _props.align,
	          className = _props.className,
	          hasVoronoi = _props.hasVoronoi,
	          height = _props.height,
	          layout = _props.layout,
	          links = _props.links,
	          margin = _props.margin,
	          nodePadding = _props.nodePadding,
	          nodes = _props.nodes,
	          nodeWidth = _props.nodeWidth,
	          onBlur = _props.onBlur,
	          _onClick = _props.onClick,
	          onHover = _props.onHover,
	          width = _props.width;
	
	
	      var sankeyInstance = (0, _d3SankeyAlign.sankey)().size([width, height]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodes).links(links).align(align).layout(layout);
	
	      var nWidth = sankeyInstance.nodeWidth();
	      var path = sankeyInstance.link();
	
	      return _react2.default.createElement(
	        'svg',
	        { height: height + margin, width: width + margin, className: 'rv-sankey ' + className },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(' + margin / 2 + ', ' + margin / 2 + ')' },
	          links.map(function (link, i) {
	            return _react2.default.createElement('path', {
	              d: path(link),
	              className: 'rv-sankey__link',
	              opacity: Number.isFinite(link.opacity) ? link.opacity : DEFAULT_LINK_OPACITY,
	              stroke: link.color || DEFAULT_LINK_COLOR,
	              strokeWidth: Math.max(1, link.dy),
	              fill: 'none',
	              key: link.id || link.key || 'link-' + i });
	          }),
	          nodes.map(function (node, i) {
	            return _react2.default.createElement(
	              'g',
	              {
	                transform: 'translate(' + node.x + ', ' + node.y + ')',
	                className: 'rv-sankey__node',
	                opacity: Number.isFinite(node.opacity) ? node.opacity : DEFAULT_NODE_OPACITY,
	                key: node.id || node.key || 'node-' + i },
	              _react2.default.createElement('rect', {
	                onClick: function onClick() {
	                  return _onClick(node);
	                },
	                onMouseOver: function onMouseOver() {
	                  return onHover(node);
	                },
	                onMouseOut: function onMouseOut() {
	                  return onBlur(node);
	                },
	                fill: node.color || DEFAULT_NODE_COLOR,
	                height: node.dy,
	                width: nWidth })
	            );
	          }),
	          hasVoronoi && _react2.default.createElement(_voronoi2.default, {
	            className: 'rv-sankey__voronoi',
	            extent: [[-margin, -margin], [width + margin, height + margin]],
	            nodes: nodes,
	            onBlur: onBlur,
	            onClick: _onClick,
	            onHover: onHover,
	            x: function x(d) {
	              return d.x + d.dx / 2;
	            },
	            y: function y(d) {
	              return d.y + d.dy / 2;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component);
	
	Sankey.defaultProps = {
	  align: 'justify',
	  className: '',
	  hasVoronoi: false,
	  layout: 50,
	  margin: 20,
	  nodePadding: 10,
	  nodeWidth: 10,
	  onBlur: NOOP,
	  onClick: NOOP,
	  onHover: NOOP
	};
	Sankey.propTypes = {
	  align: _react.PropTypes.oneOf(['justify', 'left', 'right', 'center']),
	  className: _react.PropTypes.string,
	  hasVoronoi: _react.PropTypes.bool,
	  height: _react.PropTypes.number.isRequired,
	  layout: _react.PropTypes.number,
	  links: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    source: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object]).isRequired,
	    target: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object]).isRequired
	  })).isRequired,
	  margin: _react.PropTypes.number,
	  nodePadding: _react.PropTypes.number,
	  nodes: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	  nodeWidth: _react.PropTypes.number,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onHover: _react.PropTypes.func,
	  width: _react.PropTypes.number.isRequired
	};
	exports.default = Sankey;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Hierarchy = __webpack_require__(275);
	
	var _d3Scale = __webpack_require__(337);
	
	var _animation = __webpack_require__(19);
	
	var _arcSeries = __webpack_require__(326);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _xyPlot = __webpack_require__(331);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Find the max radius value from the nodes to be rendered after they have been
	 * transformed into an array
	 * @param {Array} data - the tree data after it has been broken into a iterable
	 * it is an array of objects!
	 * @returns {number} the maximum value in coordinates for the radial variable
	 */
	function getRadialDomain(data) {
	  return data.reduce(function (res, row) {
	    return Math.max(row.radius, res);
	  }, 0);
	}
	
	/**
	 * Create the list of nodes to render.
	 * @param {Object} props
	   props.data {Object} - tree structured data (each node has a name anc an array of children)
	   props.height {number} - the height of the graphic to be rendered
	   props.hideRootNode {boolean} - whether or not to hide the root node
	   props.width {number} - the width of the graphic to be rendered
	 * @returns {Array} Array of nodes.
	 */
	function getNodesToRender(_ref) {
	  var data = _ref.data,
	      height = _ref.height,
	      hideRootNode = _ref.hideRootNode,
	      width = _ref.width;
	
	  var partitionFunction = (0, _d3Hierarchy.partition)();
	  var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(function (d) {
	    return d.size;
	  });
	  var radius = Math.min(width, height) / 2 - 10;
	  var x = (0, _d3Scale.scaleLinear)().range([0, 2 * Math.PI]);
	  var y = (0, _d3Scale.scaleSqrt)().range([0, radius]);
	
	  return partitionFunction(structuredInput).descendants().reduce(function (res, cell, index) {
	    if (hideRootNode && index === 0) {
	      return res;
	    }
	
	    return res.concat([_extends({
	      angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
	      angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
	      radius0: Math.max(0, y(cell.y0)),
	      radius: Math.max(0, y(cell.y1)),
	      depth: cell.depth,
	      parent: cell.parent
	    }, cell.data)]);
	  }, []);
	}
	
	var Sunburst = function (_React$Component) {
	  _inherits(Sunburst, _React$Component);
	
	  function Sunburst() {
	    _classCallCheck(this, Sunburst);
	
	    return _possibleConstructorReturn(this, (Sunburst.__proto__ || Object.getPrototypeOf(Sunburst)).apply(this, arguments));
	  }
	
	  _createClass(Sunburst, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          width = _props.width,
	          colorType = _props.colorType;
	
	      var mappedData = getNodesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width });
	      var radialDomain = getRadialDomain(mappedData);
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          className: className,
	          xDomain: [-radialDomain, radialDomain],
	          yDomain: [-radialDomain, radialDomain] },
	        _react2.default.createElement(_arcSeries2.default, _extends({
	          colorType: colorType
	        }, this.props, {
	          animation: animation,
	          radiusDomain: [0, radialDomain],
	          // need to present a stripped down version for interpolation
	          data: animation ? mappedData.map(function (row) {
	            return _extends({}, row, { parent: null, children: null });
	          }) : mappedData,
	          _data: animation ? mappedData : null
	        }))
	      );
	    }
	  }]);
	
	  return Sunburst;
	}(_react2.default.Component);
	
	Sunburst.displayName = 'Sunburst';
	Sunburst.PropTypes = {
	  animation: _animation.AnimationPropType,
	  className: _react.PropTypes.string,
	  colorType: _react.PropTypes.string,
	  data: _react.PropTypes.object.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  hideRootNode: _react.PropTypes.bool,
	  onValueClick: _react.PropTypes.func,
	  onValueMouseOver: _react.PropTypes.func,
	  onValueMouseOut: _react.PropTypes.func,
	  width: _react.PropTypes.number.isRequired
	};
	Sunburst.defaultProps = {
	  className: '',
	  colorType: 'literal',
	  hideRootNode: false
	};
	
	exports.default = Sunburst;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Hierarchy = __webpack_require__(275);
	
	var _theme = __webpack_require__(48);
	
	var _animation = __webpack_require__(19);
	
	var _scalesUtils = __webpack_require__(32);
	
	var _treemapLeaf = __webpack_require__(814);
	
	var _treemapLeaf2 = _interopRequireDefault(_treemapLeaf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TREEMAP_TILE_MODES = {
	  squarify: _d3Hierarchy.treemapSquarify,
	  resquarify: _d3Hierarchy.treemapResquarify,
	  slice: _d3Hierarchy.treemapSlice,
	  dice: _d3Hierarchy.treemapDice,
	  slicedice: _d3Hierarchy.treemapSliceDice,
	  binary: _d3Hierarchy.treemapBinary
	};
	
	var TREEMAP_LAYOUT_MODES = ['circlePack', 'partition', 'partition-pivot'];
	
	var NOOP = function NOOP(d) {
	  return d;
	};
	
	var ATTRIBUTES = ['opacity', 'color'];
	
	/**
	 * Get the map of scale functions from the given props.
	 * @param {Object} props Props for the component.
	 * @returns {Object} Map of scale functions.
	 * @private
	 */
	function _getScaleFns(props) {
	  var data = props.data;
	
	  var allData = data.children || [];
	
	  // Adding _allData property to the object to reuse the existing
	  // getAttributeFunctor function.
	  var compatibleProps = _extends({}, props, (0, _scalesUtils.getMissingScaleProps)(props, allData, ATTRIBUTES), {
	    _allData: allData
	  });
	  return {
	    opacity: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'opacity'),
	    color: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'color')
	  };
	}
	
	var Treemap = function (_React$Component) {
	  _inherits(Treemap, _React$Component);
	
	  _createClass(Treemap, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _react.PropTypes.string,
	        data: _react.PropTypes.object.isRequired,
	        height: _react.PropTypes.number.isRequired,
	        mode: _react.PropTypes.oneOf(Object.keys(TREEMAP_TILE_MODES).concat(TREEMAP_LAYOUT_MODES)),
	        onLeafClick: _react.PropTypes.func,
	        onLeafMouseOver: _react.PropTypes.func,
	        onLeafMouseOut: _react.PropTypes.func,
	        useCirclePacking: _react.PropTypes.bool,
	        padding: _react.PropTypes.number.isRequired,
	        width: _react.PropTypes.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: '',
	        colorRange: _theme.CONTINUOUS_COLOR_RANGE,
	        _colorValue: _theme.DEFAULT_COLOR,
	        data: {
	          children: []
	        },
	        mode: 'squarify',
	        onLeafClick: NOOP,
	        onLeafMouseOver: NOOP,
	        onLeafMouseOut: NOOP,
	        opacityType: _theme.OPACITY_TYPE,
	        _opacityValue: _theme.DEFAULT_OPACITY,
	        padding: 1
	      };
	    }
	  }]);
	
	  function Treemap(props) {
	    _classCallCheck(this, Treemap);
	
	    var _this = _possibleConstructorReturn(this, (Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call(this, props));
	
	    _this.state = { scales: _getScaleFns(props) };
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({ scales: _getScaleFns(props) });
	    }
	
	    /**
	     * Create the list of nodes to render.
	     * @returns {Array} Array of nodes.
	     * @private
	     */
	
	  }, {
	    key: '_getNodesToRender',
	    value: function _getNodesToRender() {
	      var _props = this.props,
	          data = _props.data,
	          height = _props.height,
	          width = _props.width,
	          mode = _props.mode,
	          padding = _props.padding;
	
	      if (data && (mode === 'partition' || mode === 'partition-pivot')) {
	        var partitionFunction = (0, _d3Hierarchy.partition)().size([width, height]).padding(padding);
	        var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(function (d) {
	          return d.size;
	        });
	        var mappedNodes = partitionFunction(structuredInput).descendants();
	        if (mode === 'partition-pivot') {
	          return mappedNodes.map(function (node) {
	            return _extends({}, node, {
	              x0: node.y0,
	              x1: node.y1,
	              y0: node.x0,
	              y1: node.x1
	            });
	          });
	        }
	        return mappedNodes;
	      }
	      if (data && mode === 'circlePack') {
	        var packingFunction = (0, _d3Hierarchy.pack)().size([width, height]).padding(padding);
	        var _structuredInput = (0, _d3Hierarchy.hierarchy)(data).sort(function (a, b) {
	          return a.size - b.size;
	        }).sum(function (d) {
	          return d.size;
	        });
	        return packingFunction(_structuredInput).descendants();
	      }
	      if (data) {
	        var tileFn = TREEMAP_TILE_MODES[mode];
	        var treemapingFunction = (0, _d3Hierarchy.treemap)(tileFn).tile(tileFn).size([width, height]).padding(padding);
	        var _structuredInput2 = (0, _d3Hierarchy.hierarchy)(data).sort(function (a, b) {
	          return a.size - b.size;
	        }).sum(function (d) {
	          return d.size;
	        });
	
	        return treemapingFunction(_structuredInput2).descendants();
	      }
	      return [];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          animation = _props2.animation,
	          className = _props2.className,
	          height = _props2.height,
	          mode = _props2.mode,
	          width = _props2.width;
	
	      var nodes = this._getNodesToRender();
	      var useCirclePacking = mode === 'circlePack';
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          } },
	        nodes.map(function (node, index) {
	          // throw out the rootest node
	          if (!useCirclePacking && !index) {
	            return null;
	          }
	
	          var nodeProps = _extends({
	            animation: animation,
	            node: node
	          }, _this2.props, {
	            x0: useCirclePacking ? node.x : node.x0,
	            x1: useCirclePacking ? node.x : node.x1,
	            y0: useCirclePacking ? node.y : node.y0,
	            y1: useCirclePacking ? node.y : node.y1,
	            r: useCirclePacking ? node.r : 1,
	            scales: _this2.state.scales
	          });
	          return _react2.default.createElement(_treemapLeaf2.default, _extends({}, nodeProps, { key: 'leaf-' + index }));
	        })
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react2.default.Component);
	
	Treemap.displayName = 'Treemap';
	
	exports.default = Treemap;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(19);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _scalesUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ANIMATED_PROPS = ['colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'x0', 'x1', 'y0', 'y1', 'r'];
	
	var TreemapLeaf = function (_React$Component) {
	  _inherits(TreemapLeaf, _React$Component);
	
	  function TreemapLeaf() {
	    _classCallCheck(this, TreemapLeaf);
	
	    return _possibleConstructorReturn(this, (TreemapLeaf.__proto__ || Object.getPrototypeOf(TreemapLeaf)).apply(this, arguments));
	  }
	
	  _createClass(TreemapLeaf, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          mode = _props.mode,
	          node = _props.node,
	          onLeafClick = _props.onLeafClick,
	          onLeafMouseOver = _props.onLeafMouseOver,
	          onLeafMouseOut = _props.onLeafMouseOut,
	          r = _props.r,
	          scales = _props.scales,
	          x0 = _props.x0,
	          x1 = _props.x1,
	          y0 = _props.y0,
	          y1 = _props.y1;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
	          _react2.default.createElement(TreemapLeaf, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var useCirclePacking = mode === 'circlePack';
	      var background = scales.color(node);
	      var opacity = scales.opacity(node);
	      var color = (0, _scalesUtils.getFontColorFromBackground)(background);
	      var title = node.data.title;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap__leaf ' + (useCirclePacking ? 'rv-treemap__leaf--circle' : ''),
	          onMouseEnter: function onMouseEnter(event) {
	            return onLeafMouseOver(node, event);
	          },
	          onMouseLeave: function onMouseLeave(event) {
	            return onLeafMouseOut(node, event);
	          },
	          onClick: function onClick(event) {
	            return onLeafClick(node, event);
	          },
	          style: {
	            top: useCirclePacking ? y0 - r : y0,
	            left: useCirclePacking ? x0 - r : x0,
	            width: useCirclePacking ? r * 2 : x1 - x0,
	            height: useCirclePacking ? r * 2 : y1 - y0,
	            background: background,
	            opacity: opacity,
	            color: color
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'rv-treemap__leaf__content' },
	          title
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        height: _react.PropTypes.number.isRequired,
	        mode: _react.PropTypes.string,
	        node: _react.PropTypes.object.isRequired,
	        onLeafClick: _react.PropTypes.func,
	        onLeafMouseOver: _react.PropTypes.func,
	        onLeafMouseOut: _react.PropTypes.func,
	        scales: _react.PropTypes.object.isRequired,
	        width: _react.PropTypes.number.isRequired,
	        r: _react.PropTypes.number.isRequired,
	        x0: _react.PropTypes.number.isRequired,
	        x1: _react.PropTypes.number.isRequired,
	        y0: _react.PropTypes.number.isRequired,
	        y1: _react.PropTypes.number.isRequired
	      };
	    }
	  }]);
	
	  return TreemapLeaf;
	}(_react2.default.Component);
	
	exports.default = TreemapLeaf;

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getObjectValueAccessor = getObjectValueAccessor;
	exports.getUniquePropertyValues = getUniquePropertyValues;
	exports.addValueToArray = addValueToArray;
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Get the value accessor function that gets a property from an object.
	 * @param {string} propertyName Property name.
	 * @returns {Function} Value accessor.
	 */
	function getObjectValueAccessor(propertyName) {
	  return function (obj) {
	    return obj[propertyName];
	  };
	}
	
	/**
	 * Get unique property values from an array.
	 * @param {Array} arr Array of data.
	 * @param {string} propertyName Prop name.
	 * @returns {Array} Array of unique values.
	 */
	function getUniquePropertyValues(arr, propertyName) {
	  var setOfValues = new Set(arr.map(getObjectValueAccessor(propertyName)));
	  return Array.from(setOfValues);
	}
	
	/**
	 * Add zero to the domain.
	 * @param {Array} arr Add zero to the domain.
	 * @param {Number} value Add zero to domain.
	 * @returns {Array} Adjusted domain.
	 */
	function addValueToArray(arr, value) {
	  var result = [].concat(arr);
	  if (result[0] > value) {
	    result[0] = value;
	  }
	  if (result[result.length - 1] < value) {
	    result[result.length - 1] = value;
	  }
	  return result;
	}

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.2. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(338)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(215);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(144);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(217);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(206);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(207);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(216);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(125);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(215);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(144);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(217);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(206);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(207);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(216);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(125);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(215);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(144);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(217);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(822);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(206);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(207);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(216);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(125);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 822 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(819);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(820);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(821);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(825);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(339);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(144);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(824);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(339);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(17);
	
	var focusNode = __webpack_require__(280);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventPropagators = __webpack_require__(107);
	var ExecutionEnvironment = __webpack_require__(21);
	var FallbackCompositionState = __webpack_require__(834);
	var SyntheticCompositionEvent = __webpack_require__(873);
	var SyntheticInputEvent = __webpack_require__(876);
	
	var keyOf = __webpack_require__(58);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(340);
	var ExecutionEnvironment = __webpack_require__(21);
	var ReactPerf = __webpack_require__(33);
	
	var camelizeStyleName = __webpack_require__(597);
	var dangerousStyleValue = __webpack_require__(882);
	var hyphenateStyleName = __webpack_require__(603);
	var memoizeStringOnly = __webpack_require__(607);
	var warning = __webpack_require__(6);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventPluginHub = __webpack_require__(106);
	var EventPropagators = __webpack_require__(107);
	var ExecutionEnvironment = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(49);
	var SyntheticEvent = __webpack_require__(54);
	
	var getEventTarget = __webpack_require__(231);
	var isEventSupported = __webpack_require__(233);
	var isTextInputElement = __webpack_require__(366);
	var keyOf = __webpack_require__(58);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 830 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(21);
	
	var createNodesFromMarkup = __webpack_require__(600);
	var emptyFunction = __webpack_require__(45);
	var getMarkupWrap = __webpack_require__(282);
	var invariant = __webpack_require__(3);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : void 0;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : void 0;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : void 0;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : void 0;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : void 0;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(58);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventPropagators = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(17);
	var SyntheticMouseEvent = __webpack_require__(151);
	
	var keyOf = __webpack_require__(58);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(81);
	
	var getTextContentAccessor = __webpack_require__(364);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactChildren = __webpack_require__(342);
	var ReactComponent = __webpack_require__(344);
	var ReactClass = __webpack_require__(343);
	var ReactDOMFactories = __webpack_require__(845);
	var ReactElement = __webpack_require__(39);
	var ReactElementValidator = __webpack_require__(348);
	var ReactPropTypes = __webpack_require__(357);
	var ReactVersion = __webpack_require__(359);
	
	var onlyChild = __webpack_require__(888);
	var warning = __webpack_require__(6);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(98);
	
	var instantiateReactComponent = __webpack_require__(365);
	var KeyEscapeUtils = __webpack_require__(221);
	var shouldUpdateReactComponent = __webpack_require__(235);
	var traverseAllChildren = __webpack_require__(236);
	var warning = __webpack_require__(6);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', KeyEscapeUtils.unescape(name)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, removedNodes, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactComponentEnvironment = __webpack_require__(223);
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactElement = __webpack_require__(39);
	var ReactErrorUtils = __webpack_require__(224);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(148);
	var ReactNodeTypes = __webpack_require__(355);
	var ReactPerf = __webpack_require__(33);
	var ReactPropTypeLocations = __webpack_require__(150);
	var ReactPropTypeLocationNames = __webpack_require__(149);
	var ReactReconciler = __webpack_require__(98);
	var ReactUpdateQueue = __webpack_require__(358);
	
	var emptyObject = __webpack_require__(102);
	var invariant = __webpack_require__(3);
	var shouldUpdateReactComponent = __webpack_require__(235);
	var warning = __webpack_require__(6);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	    this._nativeParent = null;
	    this._nativeContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} nativeParent
	   * @param {?object} nativeContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst = this._constructComponent(publicProps, publicContext);
	    var renderedElement;
	
	    // Support functional components
	    if (!shouldConstruct(Component) && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : invariant(false) : void 0;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (publicProps, publicContext) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(publicProps, publicContext);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(publicProps, publicContext);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (publicProps, publicContext) {
	    var Component = this._currentElement.type;
	    if (shouldConstruct(Component)) {
	      return new Component(publicProps, publicContext, ReactUpdateQueue);
	    } else {
	      return Component(publicProps, publicContext, ReactUpdateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedNodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, transaction, nativeParent, nativeContainerInfo, this._processChildContext(context));
	
	    return markup;
	  },
	
	  getNativeNode: function () {
	    return ReactReconciler.getNativeNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : void 0;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : void 0;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    var willReceive = false;
	    var nextContext;
	    var nextProps;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      inst.componentWillReceiveProps(nextProps, nextContext);
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldNativeNode = ReactReconciler.getNativeNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      this._renderedNodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, transaction, this._nativeParent, this._nativeContainerInfo, this._processChildContext(context));
	      this._replaceNodeWithMarkup(oldNativeNode, nextMarkup);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldNativeNode, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldNativeNode, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDefaultInjection = __webpack_require__(858);
	var ReactMount = __webpack_require__(352);
	var ReactPerf = __webpack_require__(33);
	var ReactReconciler = __webpack_require__(98);
	var ReactUpdates = __webpack_require__(49);
	var ReactVersion = __webpack_require__(359);
	
	var findDOMNode = __webpack_require__(883);
	var getNativeComponentFromComposite = __webpack_require__(363);
	var renderSubtreeIntoContainer = __webpack_require__(890);
	var warning = __webpack_require__(6);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getNativeComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(145);
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: DisabledInputUtils.getNativeProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var AutoFocusUtils = __webpack_require__(826);
	var CSSPropertyOperations = __webpack_require__(828);
	var DOMLazyTree = __webpack_require__(97);
	var DOMNamespaces = __webpack_require__(830);
	var DOMProperty = __webpack_require__(80);
	var DOMPropertyOperations = __webpack_require__(219);
	var EventConstants = __webpack_require__(53);
	var EventPluginHub = __webpack_require__(106);
	var EventPluginRegistry = __webpack_require__(146);
	var ReactBrowserEventEmitter = __webpack_require__(147);
	var ReactComponentBrowserEnvironment = __webpack_require__(345);
	var ReactDOMButton = __webpack_require__(840);
	var ReactDOMComponentFlags = __webpack_require__(346);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMInput = __webpack_require__(848);
	var ReactDOMOption = __webpack_require__(850);
	var ReactDOMSelect = __webpack_require__(347);
	var ReactDOMTextarea = __webpack_require__(853);
	var ReactMultiChild = __webpack_require__(864);
	var ReactPerf = __webpack_require__(33);
	
	var escapeTextContentForBrowser = __webpack_require__(152);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(233);
	var keyOf = __webpack_require__(58);
	var shallowEqual = __webpack_require__(180);
	var validateDOMNesting = __webpack_require__(237);
	var warning = __webpack_require__(6);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : invariant(false) : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._nativeContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  if (!doc) {
	    // Server rendering.
	    return;
	  }
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._nativeContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the native container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = nativeContainerInfo._idCounter++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, nativeParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, nativeParent);
	        props = ReactDOMInput.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, nativeParent);
	        props = ReactDOMOption.getNativeProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, nativeParent);
	        props = ReactDOMSelect.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, nativeParent);
	        props = ReactDOMTextarea.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (nativeParent != null) {
	      namespaceURI = nativeParent._namespaceURI;
	      parentTag = nativeParent._tag;
	    } else if (nativeContainerInfo._tag) {
	      namespaceURI = nativeContainerInfo._namespaceURI;
	      parentTag = nativeContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo._tag) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else {
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._nativeParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'button':
	      case 'input':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._nativeParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getNativeNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent.Mixin, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  receiveComponent: 'receiveComponent'
	});
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(237);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMDebugTool
	 */
	
	'use strict';
	
	var ReactDOMUnknownPropertyDevtool = __webpack_require__(855);
	
	var warning = __webpack_require__(6);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var ReactDOMDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  onCreateMarkupForProperty: function (name, value) {
	    emitEvent('onCreateMarkupForProperty', name, value);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    emitEvent('onSetValueForProperty', node, name, value);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    emitEvent('onDeleteValueForProperty', node, name);
	  }
	};
	
	ReactDOMDebugTool.addDevtool(ReactDOMUnknownPropertyDevtool);
	
	module.exports = ReactDOMDebugTool;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(17);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._nativeContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    var domID = nativeContainerInfo._idCounter++;
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getNativeNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(39);
	var ReactElementValidator = __webpack_require__(348);
	
	var mapObject = __webpack_require__(606);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 846 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(218);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactPerf = __webpack_require__(33);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DisabledInputUtils = __webpack_require__(145);
	var DOMPropertyOperations = __webpack_require__(219);
	var LinkedValueUtils = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(49);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `input` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined
	    }, DisabledInputUtils.getNativeProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValueDefaultValue = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = props.checked !== undefined || props.value !== undefined;
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	
	      var initialValue = inst._wrapperState.initialChecked || inst._wrapperState.initialValue;
	      var defaultValue = props.defaultChecked || props.defaultValue;
	      var controlled = props.checked !== undefined || props.value !== undefined;
	      var owner = inst._currentElement._owner;
	
	      if ((initialValue || !inst._wrapperState.controlled) && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && (defaultValue || !controlled) && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var ReactDOMDebugTool = __webpack_require__(843);
	
	module.exports = { debugTool: ReactDOMDebugTool };

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactChildren = __webpack_require__(342);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMSelect = __webpack_require__(347);
	
	var warning = __webpack_require__(6);
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, nativeParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (nativeParent != null) {
	      var selectParent = nativeParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._nativeParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getNativeProps: function (inst, props) {
	    var nativeProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	var getNodeForCharacterOffset = __webpack_require__(886);
	var getTextContentAccessor = __webpack_require__(364);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DOMChildrenOperations = __webpack_require__(218);
	var DOMLazyTree = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactPerf = __webpack_require__(33);
	
	var escapeTextContentForBrowser = __webpack_require__(152);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(237);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo != null) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = nativeContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getNativeNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getNativeNode: function () {
	    var nativeNode = this._commentNodes;
	    if (nativeNode) {
	      return nativeNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : invariant(false) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    nativeNode = [this._nativeNode, this._closingComment];
	    this._commentNodes = nativeNode;
	    return nativeNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	ReactPerf.measureMethods(ReactDOMTextComponent.prototype, 'ReactDOMTextComponent', {
	  mountComponent: 'mountComponent',
	  receiveComponent: 'receiveComponent'
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DisabledInputUtils = __webpack_require__(145);
	var DOMPropertyOperations = __webpack_require__(219);
	var LinkedValueUtils = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(49);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `textarea` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = _assign({}, DisabledInputUtils.getNativeProps(inst, props), {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : void 0;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : void 0;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._nativeParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._nativeParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._nativeParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._nativeParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._nativeParent;
	    instB = instB._nativeParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._nativeParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_nativeNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : invariant(false) : void 0;
	
	  return inst._nativeParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._nativeParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._nativeParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._nativeParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMUnknownPropertyDevtool
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var EventPluginRegistry = __webpack_require__(146);
	
	var warning = __webpack_require__(6);
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : void 0;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    process.env.NODE_ENV !== 'production' ? warning(registrationName == null, 'Unknown event handler property %s. Did you mean `%s`?', name, registrationName) : void 0;
	  };
	}
	
	var ReactDOMUnknownPropertyDevtool = {
	  onCreateMarkupForProperty: function (name, value) {
	    warnUnknownProperty(name);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    warnUnknownProperty(name);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    warnUnknownProperty(name);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyDevtool;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDebugTool
	 */
	
	'use strict';
	
	var ReactInvalidSetStateWarningDevTool = __webpack_require__(862);
	var warning = __webpack_require__(6);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var ReactDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  onBeginProcessingChildContext: function () {
	    emitEvent('onBeginProcessingChildContext');
	  },
	  onEndProcessingChildContext: function () {
	    emitEvent('onEndProcessingChildContext');
	  },
	  onSetState: function () {
	    emitEvent('onSetState');
	  },
	  onMountRootComponent: function (internalInstance) {
	    emitEvent('onMountRootComponent', internalInstance);
	  },
	  onMountComponent: function (internalInstance) {
	    emitEvent('onMountComponent', internalInstance);
	  },
	  onUpdateComponent: function (internalInstance) {
	    emitEvent('onUpdateComponent', internalInstance);
	  },
	  onUnmountComponent: function (internalInstance) {
	    emitEvent('onUnmountComponent', internalInstance);
	  }
	};
	
	ReactDebugTool.addDevtool(ReactInvalidSetStateWarningDevTool);
	
	module.exports = ReactDebugTool;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactUpdates = __webpack_require__(49);
	var Transaction = __webpack_require__(226);
	
	var emptyFunction = __webpack_require__(45);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(827);
	var ChangeEventPlugin = __webpack_require__(829);
	var DefaultEventPluginOrder = __webpack_require__(832);
	var EnterLeaveEventPlugin = __webpack_require__(833);
	var ExecutionEnvironment = __webpack_require__(21);
	var HTMLDOMPropertyConfig = __webpack_require__(835);
	var ReactComponentBrowserEnvironment = __webpack_require__(345);
	var ReactDOMComponent = __webpack_require__(841);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMEmptyComponent = __webpack_require__(844);
	var ReactDOMTreeTraversal = __webpack_require__(854);
	var ReactDOMTextComponent = __webpack_require__(852);
	var ReactDefaultBatchingStrategy = __webpack_require__(857);
	var ReactEventListener = __webpack_require__(860);
	var ReactInjection = __webpack_require__(861);
	var ReactReconcileTransaction = __webpack_require__(866);
	var SVGDOMPropertyConfig = __webpack_require__(868);
	var SelectEventPlugin = __webpack_require__(869);
	var SimpleEventPlugin = __webpack_require__(870);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(106);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventListener = __webpack_require__(279);
	var ExecutionEnvironment = __webpack_require__(21);
	var PooledClass = __webpack_require__(81);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(49);
	
	var getEventTarget = __webpack_require__(231);
	var getUnboundedScrollPosition = __webpack_require__(601);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._nativeParent) {
	    inst = inst._nativeParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var EventPluginHub = __webpack_require__(106);
	var EventPluginUtils = __webpack_require__(220);
	var ReactComponentEnvironment = __webpack_require__(223);
	var ReactClass = __webpack_require__(343);
	var ReactEmptyComponent = __webpack_require__(349);
	var ReactBrowserEventEmitter = __webpack_require__(147);
	var ReactNativeComponent = __webpack_require__(354);
	var ReactPerf = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(49);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInvalidSetStateWarningDevTool
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	if (false) {
	  var processingChildContext = false;
	
	  var warnInvalidSetState = function () {
	    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
	  };
	}
	
	var ReactInvalidSetStateWarningDevTool = {
	  onBeginProcessingChildContext: function () {
	    processingChildContext = true;
	  },
	  onEndProcessingChildContext: function () {
	    processingChildContext = false;
	  },
	  onSetState: function () {
	    warnInvalidSetState();
	  }
	};
	
	module.exports = ReactInvalidSetStateWarningDevTool;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(881);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(223);
	var ReactMultiChildUpdateTypes = __webpack_require__(353);
	
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactReconciler = __webpack_require__(98);
	var ReactChildReconciler = __webpack_require__(837);
	
	var flattenChildren = __webpack_require__(884);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getNativeNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, lastPlacedNode, nextIndex, transaction, context));
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getNativeNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, afterNode, index, transaction, context) {
	      var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(341);
	var PooledClass = __webpack_require__(81);
	var ReactBrowserEventEmitter = __webpack_require__(147);
	var ReactInputSelection = __webpack_require__(351);
	var Transaction = __webpack_require__(226);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(865);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 868 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventPropagators = __webpack_require__(107);
	var ExecutionEnvironment = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInputSelection = __webpack_require__(351);
	var SyntheticEvent = __webpack_require__(54);
	
	var getActiveElement = __webpack_require__(281);
	var isTextInputElement = __webpack_require__(366);
	var keyOf = __webpack_require__(58);
	var shallowEqual = __webpack_require__(180);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(53);
	var EventListener = __webpack_require__(279);
	var EventPropagators = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(17);
	var SyntheticAnimationEvent = __webpack_require__(871);
	var SyntheticClipboardEvent = __webpack_require__(872);
	var SyntheticEvent = __webpack_require__(54);
	var SyntheticFocusEvent = __webpack_require__(875);
	var SyntheticKeyboardEvent = __webpack_require__(877);
	var SyntheticMouseEvent = __webpack_require__(151);
	var SyntheticDragEvent = __webpack_require__(874);
	var SyntheticTouchEvent = __webpack_require__(878);
	var SyntheticTransitionEvent = __webpack_require__(879);
	var SyntheticUIEvent = __webpack_require__(108);
	var SyntheticWheelEvent = __webpack_require__(880);
	
	var emptyFunction = __webpack_require__(45);
	var getEventCharCode = __webpack_require__(229);
	var invariant = __webpack_require__(3);
	var keyOf = __webpack_require__(58);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(151);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(108);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(108);
	
	var getEventCharCode = __webpack_require__(229);
	var getEventKey = __webpack_require__(885);
	var getEventModifierState = __webpack_require__(230);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(108);
	
	var getEventModifierState = __webpack_require__(230);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(151);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 881 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(340);
	var warning = __webpack_require__(6);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      if (component) {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(63);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(225);
	
	var getNativeComponentFromComposite = __webpack_require__(363);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getNativeComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(221);
	var traverseAllChildren = __webpack_require__(236);
	var warning = __webpack_require__(6);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', KeyEscapeUtils.unescape(name)) : void 0;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(229);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 886 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(21);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(39);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(152);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(352);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 891 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client Version 3.0.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	var identity = function(x) {
	  return x;
	};
	
	var transform = function(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	};
	
	var bbox = function(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	};
	
	var reverse = function(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	};
	
	var feature = function(topology, o) {
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	};
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	var stitch = function(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	};
	
	var mesh = function(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	};
	
	function meshArcs(topology, object$$1, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object$$1, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object$$1, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object$$1);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	var merge = function(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	};
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	var bisect = function(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	};
	
	var neighbors = function(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	};
	
	var untransform = function(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	};
	
	var quantize = function(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	};
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 893 */
46
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/